// Generated from src/antlr-grammar/CypherCmdParser.g4 by ANTLR 4.13.0
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import { ATN, ATNDeserializer, DFA, FailedPredicateException, RecognitionException, NoViableAltException, Parser, ParserATNSimulator, ParserRuleContext, PredictionContextCache, Token } from 'antlr4';
export default class CypherCmdParser extends Parser {
    static PARAM = 1;
    static CLEAR = 2;
    static HISTORY = 3;
    static CONNECT = 4;
    static DISCONNECT = 5;
    static WELCOME = 6;
    static SYSINFO = 7;
    static STYLE = 8;
    static RESET = 9;
    static PLAY = 10;
    static ACCESSMODE = 11;
    static EXPLAIN = 12;
    static PROFILE = 13;
    static CYPHER = 14;
    static SPACE = 15;
    static SINGLE_LINE_COMMENT = 16;
    static MULTI_LINE_COMMENT = 17;
    static DECIMAL_DOUBLE = 18;
    static UNSIGNED_DECIMAL_INTEGER = 19;
    static UNSIGNED_HEX_INTEGER = 20;
    static UNSIGNED_OCTAL_INTEGER = 21;
    static STRING_LITERAL1 = 22;
    static STRING_LITERAL2 = 23;
    static ESCAPED_SYMBOLIC_NAME = 24;
    static ACCESS = 25;
    static ACTIVE = 26;
    static ADD = 27;
    static ADMIN = 28;
    static ADMINISTRATOR = 29;
    static ALIAS = 30;
    static ALIASES = 31;
    static ALL_SHORTEST_PATHS = 32;
    static ALL = 33;
    static ALLREDUCE = 34;
    static ALTER = 35;
    static AND = 36;
    static ANY = 37;
    static ARRAY = 38;
    static AS = 39;
    static ASC = 40;
    static ASCENDING = 41;
    static ASSIGN = 42;
    static AT = 43;
    static AUTH = 44;
    static BAR = 45;
    static BINDINGS = 46;
    static BOOL = 47;
    static BOOLEAN = 48;
    static BOOSTED = 49;
    static BOTH = 50;
    static BREAK = 51;
    static BUILT = 52;
    static BY = 53;
    static CALL = 54;
    static CASCADE = 55;
    static CASE = 56;
    static CHANGE = 57;
    static CIDR = 58;
    static COLLECT = 59;
    static COLON = 60;
    static COLONCOLON = 61;
    static COMMA = 62;
    static COMMAND = 63;
    static COMMANDS = 64;
    static COMPOSITE = 65;
    static CONCURRENT = 66;
    static CONSTRAINT = 67;
    static CONSTRAINTS = 68;
    static CONTAINS = 69;
    static COPY = 70;
    static CONTINUE = 71;
    static COUNT = 72;
    static CREATE = 73;
    static CSV = 74;
    static CURRENT = 75;
    static DATA = 76;
    static DATABASE = 77;
    static DATABASES = 78;
    static DATE = 79;
    static DATETIME = 80;
    static DBMS = 81;
    static DEALLOCATE = 82;
    static DEFAULT = 83;
    static DEFINED = 84;
    static DELETE = 85;
    static DENY = 86;
    static DESC = 87;
    static DESCENDING = 88;
    static DESTROY = 89;
    static DETACH = 90;
    static DIFFERENT = 91;
    static DOLLAR = 92;
    static DISTINCT = 93;
    static DIVIDE = 94;
    static DOT = 95;
    static DOTDOT = 96;
    static DOUBLEBAR = 97;
    static DRIVER = 98;
    static DROP = 99;
    static DRYRUN = 100;
    static DUMP = 101;
    static DURATION = 102;
    static EACH = 103;
    static EDGE = 104;
    static ENABLE = 105;
    static ELEMENT = 106;
    static ELEMENTS = 107;
    static ELSE = 108;
    static ENCRYPTED = 109;
    static END = 110;
    static ENDS = 111;
    static EQ = 112;
    static EXECUTABLE = 113;
    static EXECUTE = 114;
    static EXIST = 115;
    static EXISTENCE = 116;
    static EXISTS = 117;
    static ERROR = 118;
    static FAIL = 119;
    static FALSE = 120;
    static FIELDTERMINATOR = 121;
    static FILTER = 122;
    static FINISH = 123;
    static FLOAT = 124;
    static FLOAT64 = 125;
    static FLOAT32 = 126;
    static FOR = 127;
    static FOREACH = 128;
    static FROM = 129;
    static FULLTEXT = 130;
    static FUNCTION = 131;
    static FUNCTIONS = 132;
    static GE = 133;
    static GRANT = 134;
    static GRAPH = 135;
    static GRAPHS = 136;
    static GROUP = 137;
    static GROUPS = 138;
    static GT = 139;
    static HEADERS = 140;
    static HOME = 141;
    static ID = 142;
    static IF = 143;
    static IMPERSONATE = 144;
    static IMMUTABLE = 145;
    static IN = 146;
    static INDEX = 147;
    static INDEXES = 148;
    static INF = 149;
    static INFINITY = 150;
    static INSERT = 151;
    static INT = 152;
    static INT64 = 153;
    static INT32 = 154;
    static INT16 = 155;
    static INT8 = 156;
    static INTEGER = 157;
    static INTEGER64 = 158;
    static INTEGER32 = 159;
    static INTEGER16 = 160;
    static INTEGER8 = 161;
    static IS = 162;
    static JOIN = 163;
    static KEY = 164;
    static LABEL = 165;
    static LABELS = 166;
    static AMPERSAND = 167;
    static EXCLAMATION_MARK = 168;
    static LANGUAGE = 169;
    static LBRACKET = 170;
    static LCURLY = 171;
    static LE = 172;
    static LEADING = 173;
    static LET = 174;
    static LIMITROWS = 175;
    static LIST = 176;
    static LOAD = 177;
    static LOCAL = 178;
    static LOOKUP = 179;
    static LPAREN = 180;
    static LT = 181;
    static MANAGEMENT = 182;
    static MAP = 183;
    static MATCH = 184;
    static MERGE = 185;
    static MINUS = 186;
    static PERCENT = 187;
    static IMPLIES = 188;
    static INVALID_NEQ = 189;
    static NEQ = 190;
    static NAME = 191;
    static NAMES = 192;
    static NAN = 193;
    static NFC = 194;
    static NFD = 195;
    static NFKC = 196;
    static NFKD = 197;
    static NEW = 198;
    static NEXT = 199;
    static NODE = 200;
    static NODETACH = 201;
    static NODES = 202;
    static NONE = 203;
    static NORMALIZE = 204;
    static NORMALIZED = 205;
    static NOT = 206;
    static NOTHING = 207;
    static NOWAIT = 208;
    static NULL = 209;
    static OF = 210;
    static OFFSET = 211;
    static ON = 212;
    static ONLY = 213;
    static OPTIONAL = 214;
    static OPTIONS = 215;
    static OPTION = 216;
    static OR = 217;
    static ORDER = 218;
    static PASSWORD = 219;
    static PASSWORDS = 220;
    static PATH = 221;
    static PATHS = 222;
    static PLAINTEXT = 223;
    static PLUS = 224;
    static PLUSEQUAL = 225;
    static POINT = 226;
    static POPULATED = 227;
    static POW = 228;
    static PRIMARY = 229;
    static PRIMARIES = 230;
    static PRIVILEGE = 231;
    static PRIVILEGES = 232;
    static PROCEDURE = 233;
    static PROCEDURES = 234;
    static PROPERTIES = 235;
    static PROPERTY = 236;
    static PROVIDER = 237;
    static PROVIDERS = 238;
    static QUESTION = 239;
    static RANGE = 240;
    static RBRACKET = 241;
    static RCURLY = 242;
    static READ = 243;
    static REALLOCATE = 244;
    static REDUCE = 245;
    static RENAME = 246;
    static REGEQ = 247;
    static REL = 248;
    static RELATIONSHIP = 249;
    static RELATIONSHIPS = 250;
    static REMOVE = 251;
    static REPEATABLE = 252;
    static REPLACE = 253;
    static REPLICA = 254;
    static REPLICAS = 255;
    static REPORT = 256;
    static REQUIRE = 257;
    static REQUIRED = 258;
    static RESTRICT = 259;
    static RETRY = 260;
    static RETURN = 261;
    static REVOKE = 262;
    static ROLE = 263;
    static ROLES = 264;
    static ROW = 265;
    static ROWS = 266;
    static RPAREN = 267;
    static SCAN = 268;
    static SEC = 269;
    static SECOND = 270;
    static SECONDARY = 271;
    static SECONDARIES = 272;
    static SECONDS = 273;
    static SEEK = 274;
    static SEMICOLON = 275;
    static SERVER = 276;
    static SERVERS = 277;
    static SET = 278;
    static SETTING = 279;
    static SETTINGS = 280;
    static SHARD = 281;
    static SHARDS = 282;
    static SHORTEST_PATH = 283;
    static SHORTEST = 284;
    static SHOW = 285;
    static SIGNED = 286;
    static SINGLE = 287;
    static SKIPROWS = 288;
    static START = 289;
    static STARTS = 290;
    static STATUS = 291;
    static STOP = 292;
    static STRING = 293;
    static SUPPORTED = 294;
    static SUSPENDED = 295;
    static TARGET = 296;
    static TERMINATE = 297;
    static TEXT = 298;
    static THEN = 299;
    static TIME = 300;
    static TIMES = 301;
    static TIMESTAMP = 302;
    static TIMEZONE = 303;
    static TO = 304;
    static TOPOLOGY = 305;
    static TRAILING = 306;
    static TRANSACTION = 307;
    static TRANSACTIONS = 308;
    static TRAVERSE = 309;
    static TRIM = 310;
    static TRUE = 311;
    static TYPE = 312;
    static TYPED = 313;
    static TYPES = 314;
    static UNION = 315;
    static UNIQUE = 316;
    static UNIQUENESS = 317;
    static UNWIND = 318;
    static URL = 319;
    static USE = 320;
    static USER = 321;
    static USERS = 322;
    static USING = 323;
    static VALUE = 324;
    static VARCHAR = 325;
    static VECTOR = 326;
    static VERTEX = 327;
    static WAIT = 328;
    static WHEN = 329;
    static WHERE = 330;
    static WITH = 331;
    static WITHOUT = 332;
    static WRITE = 333;
    static XOR = 334;
    static YIELD = 335;
    static ZONE = 336;
    static ZONED = 337;
    static IDENTIFIER = 338;
    static EXTENDED_IDENTIFIER = 339;
    static ARROW_LINE = 340;
    static ARROW_LEFT_HEAD = 341;
    static ARROW_RIGHT_HEAD = 342;
    static ErrorChar = 343;
    static EOF = Token.EOF;
    static RULE_statementsOrCommands = 0;
    static RULE_statementOrCommand = 1;
    static RULE_consoleCommand = 2;
    static RULE_paramsCmd = 3;
    static RULE_paramsArgs = 4;
    static RULE_lambda = 5;
    static RULE_clearCmd = 6;
    static RULE_historyCmd = 7;
    static RULE_useCmd = 8;
    static RULE_serverCmd = 9;
    static RULE_serverArgs = 10;
    static RULE_connectCmd = 11;
    static RULE_disconnectCmd = 12;
    static RULE_sysInfoCmd = 13;
    static RULE_styleCmd = 14;
    static RULE_welcomeCmd = 15;
    static RULE_playCmd = 16;
    static RULE_accessModeArgs = 17;
    static RULE_accessModeCmd = 18;
    static RULE_listCompletionRule = 19;
    static RULE_useCompletionRule = 20;
    static RULE_serverCompletionRule = 21;
    static RULE_readCompletionRule = 22;
    static RULE_writeCompletionRule = 23;
    static RULE_unescapedSymbolicNameString = 24;
    static RULE_preparsedStatement = 25;
    static RULE_preparserKeyword = 26;
    static RULE_preparserOption = 27;
    static RULE_cypher = 28;
    static RULE_cypherOptions = 29;
    static RULE_cypherOption = 30;
    static RULE_cypherOptionValue = 31;
    static RULE_cypherOptionName = 32;
    static RULE_cypherVersion = 33;
    static RULE_statements = 34;
    static RULE_statement = 35;
    static RULE_nextStatement = 36;
    static RULE_regularQuery = 37;
    static RULE_union = 38;
    static RULE_when = 39;
    static RULE_whenBranch = 40;
    static RULE_elseBranch = 41;
    static RULE_singleQuery = 42;
    static RULE_clause = 43;
    static RULE_useClause = 44;
    static RULE_graphReference = 45;
    static RULE_finishClause = 46;
    static RULE_returnClause = 47;
    static RULE_returnBody = 48;
    static RULE_returnItem = 49;
    static RULE_returnItems = 50;
    static RULE_orderItem = 51;
    static RULE_ascToken = 52;
    static RULE_descToken = 53;
    static RULE_orderBy = 54;
    static RULE_skip = 55;
    static RULE_limit = 56;
    static RULE_whereClause = 57;
    static RULE_withClause = 58;
    static RULE_createClause = 59;
    static RULE_insertClause = 60;
    static RULE_setClause = 61;
    static RULE_setItem = 62;
    static RULE_removeClause = 63;
    static RULE_removeItem = 64;
    static RULE_deleteClause = 65;
    static RULE_matchClause = 66;
    static RULE_matchMode = 67;
    static RULE_hint = 68;
    static RULE_mergeClause = 69;
    static RULE_mergeAction = 70;
    static RULE_filterClause = 71;
    static RULE_unwindClause = 72;
    static RULE_letClause = 73;
    static RULE_letItem = 74;
    static RULE_callClause = 75;
    static RULE_procedureName = 76;
    static RULE_procedureArgument = 77;
    static RULE_procedureResultItem = 78;
    static RULE_loadCSVClause = 79;
    static RULE_foreachClause = 80;
    static RULE_subqueryClause = 81;
    static RULE_subqueryScope = 82;
    static RULE_subqueryInTransactionsParameters = 83;
    static RULE_subqueryInTransactionsBatchParameters = 84;
    static RULE_subqueryInTransactionsErrorParameters = 85;
    static RULE_subqueryInTransactionsRetryParameters = 86;
    static RULE_subqueryInTransactionsReportParameters = 87;
    static RULE_orderBySkipLimitClause = 88;
    static RULE_patternList = 89;
    static RULE_insertPatternList = 90;
    static RULE_pattern = 91;
    static RULE_insertPattern = 92;
    static RULE_quantifier = 93;
    static RULE_anonymousPattern = 94;
    static RULE_shortestPathPattern = 95;
    static RULE_patternElement = 96;
    static RULE_selector = 97;
    static RULE_nonNegativeIntegerSpecification = 98;
    static RULE_groupToken = 99;
    static RULE_pathToken = 100;
    static RULE_pathPatternNonEmpty = 101;
    static RULE_nodePattern = 102;
    static RULE_insertNodePattern = 103;
    static RULE_parenthesizedPath = 104;
    static RULE_nodeLabels = 105;
    static RULE_nodeLabelsIs = 106;
    static RULE_dynamicExpression = 107;
    static RULE_dynamicAnyAllExpression = 108;
    static RULE_dynamicLabelType = 109;
    static RULE_labelType = 110;
    static RULE_relType = 111;
    static RULE_labelOrRelType = 112;
    static RULE_properties = 113;
    static RULE_relationshipPattern = 114;
    static RULE_insertRelationshipPattern = 115;
    static RULE_leftArrow = 116;
    static RULE_arrowLine = 117;
    static RULE_rightArrow = 118;
    static RULE_pathLength = 119;
    static RULE_labelExpression = 120;
    static RULE_labelExpression4 = 121;
    static RULE_labelExpression3 = 122;
    static RULE_labelExpression2 = 123;
    static RULE_labelExpression1 = 124;
    static RULE_insertNodeLabelExpression = 125;
    static RULE_insertRelationshipLabelExpression = 126;
    static RULE_expression = 127;
    static RULE_expression11 = 128;
    static RULE_expression10 = 129;
    static RULE_expression9 = 130;
    static RULE_expression8 = 131;
    static RULE_expression7 = 132;
    static RULE_comparisonExpression6 = 133;
    static RULE_normalForm = 134;
    static RULE_expression6 = 135;
    static RULE_expression5 = 136;
    static RULE_expression4 = 137;
    static RULE_expression3 = 138;
    static RULE_expression2 = 139;
    static RULE_postFix = 140;
    static RULE_property = 141;
    static RULE_dynamicProperty = 142;
    static RULE_propertyExpression = 143;
    static RULE_dynamicPropertyExpression = 144;
    static RULE_expression1 = 145;
    static RULE_literal = 146;
    static RULE_caseExpression = 147;
    static RULE_caseAlternative = 148;
    static RULE_extendedCaseExpression = 149;
    static RULE_extendedCaseAlternative = 150;
    static RULE_extendedWhen = 151;
    static RULE_listComprehension = 152;
    static RULE_patternComprehension = 153;
    static RULE_reduceExpression = 154;
    static RULE_allReduceExpression = 155;
    static RULE_listItemsPredicate = 156;
    static RULE_normalizeFunction = 157;
    static RULE_vectorFunction = 158;
    static RULE_trimFunction = 159;
    static RULE_patternExpression = 160;
    static RULE_shortestPathExpression = 161;
    static RULE_parenthesizedExpression = 162;
    static RULE_mapProjection = 163;
    static RULE_mapProjectionElement = 164;
    static RULE_countStar = 165;
    static RULE_existsExpression = 166;
    static RULE_countExpression = 167;
    static RULE_collectExpression = 168;
    static RULE_numberLiteral = 169;
    static RULE_signedIntegerLiteral = 170;
    static RULE_listLiteral = 171;
    static RULE_propertyKeyName = 172;
    static RULE_parameter = 173;
    static RULE_parameterName = 174;
    static RULE_functionInvocation = 175;
    static RULE_functionArgument = 176;
    static RULE_functionName = 177;
    static RULE_namespace = 178;
    static RULE_variable = 179;
    static RULE_nonEmptyNameList = 180;
    static RULE_type = 181;
    static RULE_typePart = 182;
    static RULE_typeName = 183;
    static RULE_typeNullability = 184;
    static RULE_typeListSuffix = 185;
    static RULE_vectorCoordinateType = 186;
    static RULE_command = 187;
    static RULE_createCommand = 188;
    static RULE_alterCommand = 189;
    static RULE_dropCommand = 190;
    static RULE_showCommand = 191;
    static RULE_showCommandYield = 192;
    static RULE_yieldItem = 193;
    static RULE_yieldSkip = 194;
    static RULE_yieldLimit = 195;
    static RULE_yieldClause = 196;
    static RULE_commandOptions = 197;
    static RULE_terminateCommand = 198;
    static RULE_composableCommandClauses = 199;
    static RULE_composableShowCommandClauses = 200;
    static RULE_showIndexCommand = 201;
    static RULE_showIndexType = 202;
    static RULE_showIndexesEnd = 203;
    static RULE_showConstraintCommand = 204;
    static RULE_showConstraintEntity = 205;
    static RULE_constraintExistType = 206;
    static RULE_showConstraintsEnd = 207;
    static RULE_showProcedures = 208;
    static RULE_showFunctions = 209;
    static RULE_functionToken = 210;
    static RULE_executableBy = 211;
    static RULE_showFunctionsType = 212;
    static RULE_showTransactions = 213;
    static RULE_terminateTransactions = 214;
    static RULE_showSettings = 215;
    static RULE_settingToken = 216;
    static RULE_namesAndClauses = 217;
    static RULE_stringsOrExpression = 218;
    static RULE_commandNodePattern = 219;
    static RULE_commandRelPattern = 220;
    static RULE_createConstraint = 221;
    static RULE_constraintType = 222;
    static RULE_dropConstraint = 223;
    static RULE_createIndex = 224;
    static RULE_createIndex_ = 225;
    static RULE_createFulltextIndex = 226;
    static RULE_fulltextNodePattern = 227;
    static RULE_fulltextRelPattern = 228;
    static RULE_createLookupIndex = 229;
    static RULE_lookupIndexNodePattern = 230;
    static RULE_lookupIndexRelPattern = 231;
    static RULE_dropIndex = 232;
    static RULE_propertyList = 233;
    static RULE_enclosedPropertyList = 234;
    static RULE_alterCurrentGraphType = 235;
    static RULE_graphTypeSpecification = 236;
    static RULE_graphTypeDropSpecification = 237;
    static RULE_graphTypeSpecificationBody = 238;
    static RULE_graphTypeDropSpecificationBody = 239;
    static RULE_graphTypeElement = 240;
    static RULE_graphTypeDropElement = 241;
    static RULE_nodeTypeInlineConstraintList = 242;
    static RULE_edgeTypeInlineConstraintList = 243;
    static RULE_implies = 244;
    static RULE_nodeTypeSpecification = 245;
    static RULE_impliedLabelSet = 246;
    static RULE_identifyingLabel = 247;
    static RULE_nodeTypeReference = 248;
    static RULE_nodeTypeAliasReference = 249;
    static RULE_nodeTypeInSituReference = 250;
    static RULE_edgeTypeSpecification = 251;
    static RULE_arcTypePointingRight = 252;
    static RULE_identifyingRelationship = 253;
    static RULE_edgeTypeReference = 254;
    static RULE_edgeTypeAliasReference = 255;
    static RULE_edgeTypeInSituReference = 256;
    static RULE_propertyTypeList = 257;
    static RULE_propertyType = 258;
    static RULE_propertyTypeInlineConstraint = 259;
    static RULE_typed = 260;
    static RULE_constraintSpecification = 261;
    static RULE_renameCommand = 262;
    static RULE_grantCommand = 263;
    static RULE_denyCommand = 264;
    static RULE_revokeCommand = 265;
    static RULE_userNames = 266;
    static RULE_roleNames = 267;
    static RULE_roleToken = 268;
    static RULE_enableServerCommand = 269;
    static RULE_alterServer = 270;
    static RULE_renameServer = 271;
    static RULE_dropServer = 272;
    static RULE_showServers = 273;
    static RULE_allocationCommand = 274;
    static RULE_deallocateDatabaseFromServers = 275;
    static RULE_reallocateDatabases = 276;
    static RULE_createRole = 277;
    static RULE_dropRole = 278;
    static RULE_renameRole = 279;
    static RULE_showRoles = 280;
    static RULE_grantRole = 281;
    static RULE_revokeRole = 282;
    static RULE_createUser = 283;
    static RULE_dropUser = 284;
    static RULE_renameUser = 285;
    static RULE_alterCurrentUser = 286;
    static RULE_alterUser = 287;
    static RULE_removeNamedProvider = 288;
    static RULE_password = 289;
    static RULE_passwordOnly = 290;
    static RULE_passwordExpression = 291;
    static RULE_passwordChangeRequired = 292;
    static RULE_userStatus = 293;
    static RULE_homeDatabase = 294;
    static RULE_setAuthClause = 295;
    static RULE_userAuthAttribute = 296;
    static RULE_showUsers = 297;
    static RULE_showCurrentUser = 298;
    static RULE_showSupportedPrivileges = 299;
    static RULE_showPrivileges = 300;
    static RULE_showRolePrivileges = 301;
    static RULE_showUserPrivileges = 302;
    static RULE_privilegeAsCommand = 303;
    static RULE_privilegeToken = 304;
    static RULE_privilege = 305;
    static RULE_allPrivilege = 306;
    static RULE_allPrivilegeType = 307;
    static RULE_allPrivilegeTarget = 308;
    static RULE_createPrivilege = 309;
    static RULE_createPrivilegeForDatabase = 310;
    static RULE_createNodePrivilegeToken = 311;
    static RULE_createRelPrivilegeToken = 312;
    static RULE_createPropertyPrivilegeToken = 313;
    static RULE_actionForDBMS = 314;
    static RULE_dropPrivilege = 315;
    static RULE_loadPrivilege = 316;
    static RULE_showPrivilege = 317;
    static RULE_setPrivilege = 318;
    static RULE_passwordToken = 319;
    static RULE_removePrivilege = 320;
    static RULE_writePrivilege = 321;
    static RULE_databasePrivilege = 322;
    static RULE_dbmsPrivilege = 323;
    static RULE_dbmsPrivilegeExecute = 324;
    static RULE_adminToken = 325;
    static RULE_procedureToken = 326;
    static RULE_indexToken = 327;
    static RULE_constraintToken = 328;
    static RULE_transactionToken = 329;
    static RULE_userQualifier = 330;
    static RULE_executeFunctionQualifier = 331;
    static RULE_executeProcedureQualifier = 332;
    static RULE_settingQualifier = 333;
    static RULE_globs = 334;
    static RULE_glob = 335;
    static RULE_globRecursive = 336;
    static RULE_globPart = 337;
    static RULE_qualifiedGraphPrivileges = 338;
    static RULE_labelsResource = 339;
    static RULE_propertiesResource = 340;
    static RULE_nonEmptyStringList = 341;
    static RULE_graphQualifier = 342;
    static RULE_graphQualifierToken = 343;
    static RULE_relToken = 344;
    static RULE_elementToken = 345;
    static RULE_nodeToken = 346;
    static RULE_databaseScope = 347;
    static RULE_graphScope = 348;
    static RULE_createCompositeDatabase = 349;
    static RULE_createDatabase = 350;
    static RULE_shards = 351;
    static RULE_graphShard = 352;
    static RULE_propertyShard = 353;
    static RULE_topology = 354;
    static RULE_primaryTopology = 355;
    static RULE_primaryToken = 356;
    static RULE_secondaryTopology = 357;
    static RULE_secondaryToken = 358;
    static RULE_defaultLanguageSpecification = 359;
    static RULE_dropDatabase = 360;
    static RULE_aliasAction = 361;
    static RULE_alterDatabase = 362;
    static RULE_alterDatabaseAccess = 363;
    static RULE_alterDatabaseTopology = 364;
    static RULE_alterDatabaseOption = 365;
    static RULE_startDatabase = 366;
    static RULE_stopDatabase = 367;
    static RULE_waitClause = 368;
    static RULE_secondsToken = 369;
    static RULE_showDatabase = 370;
    static RULE_aliasName = 371;
    static RULE_aliasTargetName = 372;
    static RULE_databaseName = 373;
    static RULE_createAlias = 374;
    static RULE_dropAlias = 375;
    static RULE_alterAlias = 376;
    static RULE_alterAliasTarget = 377;
    static RULE_alterAliasUser = 378;
    static RULE_alterAliasPassword = 379;
    static RULE_alterAliasDriver = 380;
    static RULE_alterAliasProperties = 381;
    static RULE_showAliases = 382;
    static RULE_symbolicNameOrStringParameter = 383;
    static RULE_commandNameExpression = 384;
    static RULE_symbolicNameOrStringParameterList = 385;
    static RULE_symbolicAliasNameList = 386;
    static RULE_symbolicAliasNameOrParameter = 387;
    static RULE_symbolicAliasName = 388;
    static RULE_stringListLiteral = 389;
    static RULE_stringList = 390;
    static RULE_stringLiteral = 391;
    static RULE_stringOrParameterExpression = 392;
    static RULE_stringOrParameter = 393;
    static RULE_uIntOrIntParameter = 394;
    static RULE_mapOrParameter = 395;
    static RULE_map = 396;
    static RULE_symbolicVariableNameString = 397;
    static RULE_escapedSymbolicVariableNameString = 398;
    static RULE_unescapedSymbolicVariableNameString = 399;
    static RULE_symbolicNameString = 400;
    static RULE_escapedSymbolicNameString = 401;
    static RULE_unescapedSymbolicNameString_ = 402;
    static RULE_endOfFile = 403;
    static literalNames = [null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, "'|'",
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        "':'", "'::'",
        "','", null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        "'$'", null,
        "'/'", "'.'",
        "'..'", "'||'",
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        "'='", null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, "'>='",
        null, null,
        null, null,
        null, "'>'",
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, "'&'",
        "'!'", null,
        "'['", "'{'",
        "'<='", null,
        null, null,
        null, null,
        null, null,
        "'('", "'<'",
        null, null,
        null, null,
        "'-'", "'%'",
        null, "'!='",
        "'<>'", null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        "'+'", "'+='",
        null, null,
        "'^'", null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, "'?'",
        null, "']'",
        "'}'", null,
        null, null,
        null, "'=~'",
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, "')'",
        null, null,
        null, null,
        null, null,
        null, "';'",
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, null,
        null, "'*'"];
    static symbolicNames = [null, "PARAM",
        "CLEAR", "HISTORY",
        "CONNECT",
        "DISCONNECT",
        "WELCOME",
        "SYSINFO",
        "STYLE", "RESET",
        "PLAY", "ACCESSMODE",
        "EXPLAIN",
        "PROFILE",
        "CYPHER", "SPACE",
        "SINGLE_LINE_COMMENT",
        "MULTI_LINE_COMMENT",
        "DECIMAL_DOUBLE",
        "UNSIGNED_DECIMAL_INTEGER",
        "UNSIGNED_HEX_INTEGER",
        "UNSIGNED_OCTAL_INTEGER",
        "STRING_LITERAL1",
        "STRING_LITERAL2",
        "ESCAPED_SYMBOLIC_NAME",
        "ACCESS", "ACTIVE",
        "ADD", "ADMIN",
        "ADMINISTRATOR",
        "ALIAS", "ALIASES",
        "ALL_SHORTEST_PATHS",
        "ALL", "ALLREDUCE",
        "ALTER", "AND",
        "ANY", "ARRAY",
        "AS", "ASC",
        "ASCENDING",
        "ASSIGN", "AT",
        "AUTH", "BAR",
        "BINDINGS",
        "BOOL", "BOOLEAN",
        "BOOSTED",
        "BOTH", "BREAK",
        "BUILT", "BY",
        "CALL", "CASCADE",
        "CASE", "CHANGE",
        "CIDR", "COLLECT",
        "COLON", "COLONCOLON",
        "COMMA", "COMMAND",
        "COMMANDS",
        "COMPOSITE",
        "CONCURRENT",
        "CONSTRAINT",
        "CONSTRAINTS",
        "CONTAINS",
        "COPY", "CONTINUE",
        "COUNT", "CREATE",
        "CSV", "CURRENT",
        "DATA", "DATABASE",
        "DATABASES",
        "DATE", "DATETIME",
        "DBMS", "DEALLOCATE",
        "DEFAULT",
        "DEFINED",
        "DELETE", "DENY",
        "DESC", "DESCENDING",
        "DESTROY",
        "DETACH", "DIFFERENT",
        "DOLLAR", "DISTINCT",
        "DIVIDE", "DOT",
        "DOTDOT", "DOUBLEBAR",
        "DRIVER", "DROP",
        "DRYRUN", "DUMP",
        "DURATION",
        "EACH", "EDGE",
        "ENABLE", "ELEMENT",
        "ELEMENTS",
        "ELSE", "ENCRYPTED",
        "END", "ENDS",
        "EQ", "EXECUTABLE",
        "EXECUTE",
        "EXIST", "EXISTENCE",
        "EXISTS", "ERROR",
        "FAIL", "FALSE",
        "FIELDTERMINATOR",
        "FILTER", "FINISH",
        "FLOAT", "FLOAT64",
        "FLOAT32",
        "FOR", "FOREACH",
        "FROM", "FULLTEXT",
        "FUNCTION",
        "FUNCTIONS",
        "GE", "GRANT",
        "GRAPH", "GRAPHS",
        "GROUP", "GROUPS",
        "GT", "HEADERS",
        "HOME", "ID",
        "IF", "IMPERSONATE",
        "IMMUTABLE",
        "IN", "INDEX",
        "INDEXES",
        "INF", "INFINITY",
        "INSERT", "INT",
        "INT64", "INT32",
        "INT16", "INT8",
        "INTEGER",
        "INTEGER64",
        "INTEGER32",
        "INTEGER16",
        "INTEGER8",
        "IS", "JOIN",
        "KEY", "LABEL",
        "LABELS", "AMPERSAND",
        "EXCLAMATION_MARK",
        "LANGUAGE",
        "LBRACKET",
        "LCURLY", "LE",
        "LEADING",
        "LET", "LIMITROWS",
        "LIST", "LOAD",
        "LOCAL", "LOOKUP",
        "LPAREN", "LT",
        "MANAGEMENT",
        "MAP", "MATCH",
        "MERGE", "MINUS",
        "PERCENT",
        "IMPLIES",
        "INVALID_NEQ",
        "NEQ", "NAME",
        "NAMES", "NAN",
        "NFC", "NFD",
        "NFKC", "NFKD",
        "NEW", "NEXT",
        "NODE", "NODETACH",
        "NODES", "NONE",
        "NORMALIZE",
        "NORMALIZED",
        "NOT", "NOTHING",
        "NOWAIT", "NULL",
        "OF", "OFFSET",
        "ON", "ONLY",
        "OPTIONAL",
        "OPTIONS",
        "OPTION", "OR",
        "ORDER", "PASSWORD",
        "PASSWORDS",
        "PATH", "PATHS",
        "PLAINTEXT",
        "PLUS", "PLUSEQUAL",
        "POINT", "POPULATED",
        "POW", "PRIMARY",
        "PRIMARIES",
        "PRIVILEGE",
        "PRIVILEGES",
        "PROCEDURE",
        "PROCEDURES",
        "PROPERTIES",
        "PROPERTY",
        "PROVIDER",
        "PROVIDERS",
        "QUESTION",
        "RANGE", "RBRACKET",
        "RCURLY", "READ",
        "REALLOCATE",
        "REDUCE", "RENAME",
        "REGEQ", "REL",
        "RELATIONSHIP",
        "RELATIONSHIPS",
        "REMOVE", "REPEATABLE",
        "REPLACE",
        "REPLICA",
        "REPLICAS",
        "REPORT", "REQUIRE",
        "REQUIRED",
        "RESTRICT",
        "RETRY", "RETURN",
        "REVOKE", "ROLE",
        "ROLES", "ROW",
        "ROWS", "RPAREN",
        "SCAN", "SEC",
        "SECOND", "SECONDARY",
        "SECONDARIES",
        "SECONDS",
        "SEEK", "SEMICOLON",
        "SERVER", "SERVERS",
        "SET", "SETTING",
        "SETTINGS",
        "SHARD", "SHARDS",
        "SHORTEST_PATH",
        "SHORTEST",
        "SHOW", "SIGNED",
        "SINGLE", "SKIPROWS",
        "START", "STARTS",
        "STATUS", "STOP",
        "STRING", "SUPPORTED",
        "SUSPENDED",
        "TARGET", "TERMINATE",
        "TEXT", "THEN",
        "TIME", "TIMES",
        "TIMESTAMP",
        "TIMEZONE",
        "TO", "TOPOLOGY",
        "TRAILING",
        "TRANSACTION",
        "TRANSACTIONS",
        "TRAVERSE",
        "TRIM", "TRUE",
        "TYPE", "TYPED",
        "TYPES", "UNION",
        "UNIQUE", "UNIQUENESS",
        "UNWIND", "URL",
        "USE", "USER",
        "USERS", "USING",
        "VALUE", "VARCHAR",
        "VECTOR", "VERTEX",
        "WAIT", "WHEN",
        "WHERE", "WITH",
        "WITHOUT",
        "WRITE", "XOR",
        "YIELD", "ZONE",
        "ZONED", "IDENTIFIER",
        "EXTENDED_IDENTIFIER",
        "ARROW_LINE",
        "ARROW_LEFT_HEAD",
        "ARROW_RIGHT_HEAD",
        "ErrorChar"];
    // tslint:disable:no-trailing-whitespace
    static ruleNames = [
        "statementsOrCommands", "statementOrCommand", "consoleCommand", "paramsCmd",
        "paramsArgs", "lambda", "clearCmd", "historyCmd", "useCmd", "serverCmd",
        "serverArgs", "connectCmd", "disconnectCmd", "sysInfoCmd", "styleCmd",
        "welcomeCmd", "playCmd", "accessModeArgs", "accessModeCmd", "listCompletionRule",
        "useCompletionRule", "serverCompletionRule", "readCompletionRule", "writeCompletionRule",
        "unescapedSymbolicNameString", "preparsedStatement", "preparserKeyword",
        "preparserOption", "cypher", "cypherOptions", "cypherOption", "cypherOptionValue",
        "cypherOptionName", "cypherVersion", "statements", "statement", "nextStatement",
        "regularQuery", "union", "when", "whenBranch", "elseBranch", "singleQuery",
        "clause", "useClause", "graphReference", "finishClause", "returnClause",
        "returnBody", "returnItem", "returnItems", "orderItem", "ascToken", "descToken",
        "orderBy", "skip", "limit", "whereClause", "withClause", "createClause",
        "insertClause", "setClause", "setItem", "removeClause", "removeItem",
        "deleteClause", "matchClause", "matchMode", "hint", "mergeClause", "mergeAction",
        "filterClause", "unwindClause", "letClause", "letItem", "callClause",
        "procedureName", "procedureArgument", "procedureResultItem", "loadCSVClause",
        "foreachClause", "subqueryClause", "subqueryScope", "subqueryInTransactionsParameters",
        "subqueryInTransactionsBatchParameters", "subqueryInTransactionsErrorParameters",
        "subqueryInTransactionsRetryParameters", "subqueryInTransactionsReportParameters",
        "orderBySkipLimitClause", "patternList", "insertPatternList", "pattern",
        "insertPattern", "quantifier", "anonymousPattern", "shortestPathPattern",
        "patternElement", "selector", "nonNegativeIntegerSpecification", "groupToken",
        "pathToken", "pathPatternNonEmpty", "nodePattern", "insertNodePattern",
        "parenthesizedPath", "nodeLabels", "nodeLabelsIs", "dynamicExpression",
        "dynamicAnyAllExpression", "dynamicLabelType", "labelType", "relType",
        "labelOrRelType", "properties", "relationshipPattern", "insertRelationshipPattern",
        "leftArrow", "arrowLine", "rightArrow", "pathLength", "labelExpression",
        "labelExpression4", "labelExpression3", "labelExpression2", "labelExpression1",
        "insertNodeLabelExpression", "insertRelationshipLabelExpression", "expression",
        "expression11", "expression10", "expression9", "expression8", "expression7",
        "comparisonExpression6", "normalForm", "expression6", "expression5", "expression4",
        "expression3", "expression2", "postFix", "property", "dynamicProperty",
        "propertyExpression", "dynamicPropertyExpression", "expression1", "literal",
        "caseExpression", "caseAlternative", "extendedCaseExpression", "extendedCaseAlternative",
        "extendedWhen", "listComprehension", "patternComprehension", "reduceExpression",
        "allReduceExpression", "listItemsPredicate", "normalizeFunction", "vectorFunction",
        "trimFunction", "patternExpression", "shortestPathExpression", "parenthesizedExpression",
        "mapProjection", "mapProjectionElement", "countStar", "existsExpression",
        "countExpression", "collectExpression", "numberLiteral", "signedIntegerLiteral",
        "listLiteral", "propertyKeyName", "parameter", "parameterName", "functionInvocation",
        "functionArgument", "functionName", "namespace", "variable", "nonEmptyNameList",
        "type", "typePart", "typeName", "typeNullability", "typeListSuffix", "vectorCoordinateType",
        "command", "createCommand", "alterCommand", "dropCommand", "showCommand",
        "showCommandYield", "yieldItem", "yieldSkip", "yieldLimit", "yieldClause",
        "commandOptions", "terminateCommand", "composableCommandClauses", "composableShowCommandClauses",
        "showIndexCommand", "showIndexType", "showIndexesEnd", "showConstraintCommand",
        "showConstraintEntity", "constraintExistType", "showConstraintsEnd", "showProcedures",
        "showFunctions", "functionToken", "executableBy", "showFunctionsType",
        "showTransactions", "terminateTransactions", "showSettings", "settingToken",
        "namesAndClauses", "stringsOrExpression", "commandNodePattern", "commandRelPattern",
        "createConstraint", "constraintType", "dropConstraint", "createIndex",
        "createIndex_", "createFulltextIndex", "fulltextNodePattern", "fulltextRelPattern",
        "createLookupIndex", "lookupIndexNodePattern", "lookupIndexRelPattern",
        "dropIndex", "propertyList", "enclosedPropertyList", "alterCurrentGraphType",
        "graphTypeSpecification", "graphTypeDropSpecification", "graphTypeSpecificationBody",
        "graphTypeDropSpecificationBody", "graphTypeElement", "graphTypeDropElement",
        "nodeTypeInlineConstraintList", "edgeTypeInlineConstraintList", "implies",
        "nodeTypeSpecification", "impliedLabelSet", "identifyingLabel", "nodeTypeReference",
        "nodeTypeAliasReference", "nodeTypeInSituReference", "edgeTypeSpecification",
        "arcTypePointingRight", "identifyingRelationship", "edgeTypeReference",
        "edgeTypeAliasReference", "edgeTypeInSituReference", "propertyTypeList",
        "propertyType", "propertyTypeInlineConstraint", "typed", "constraintSpecification",
        "renameCommand", "grantCommand", "denyCommand", "revokeCommand", "userNames",
        "roleNames", "roleToken", "enableServerCommand", "alterServer", "renameServer",
        "dropServer", "showServers", "allocationCommand", "deallocateDatabaseFromServers",
        "reallocateDatabases", "createRole", "dropRole", "renameRole", "showRoles",
        "grantRole", "revokeRole", "createUser", "dropUser", "renameUser", "alterCurrentUser",
        "alterUser", "removeNamedProvider", "password", "passwordOnly", "passwordExpression",
        "passwordChangeRequired", "userStatus", "homeDatabase", "setAuthClause",
        "userAuthAttribute", "showUsers", "showCurrentUser", "showSupportedPrivileges",
        "showPrivileges", "showRolePrivileges", "showUserPrivileges", "privilegeAsCommand",
        "privilegeToken", "privilege", "allPrivilege", "allPrivilegeType", "allPrivilegeTarget",
        "createPrivilege", "createPrivilegeForDatabase", "createNodePrivilegeToken",
        "createRelPrivilegeToken", "createPropertyPrivilegeToken", "actionForDBMS",
        "dropPrivilege", "loadPrivilege", "showPrivilege", "setPrivilege", "passwordToken",
        "removePrivilege", "writePrivilege", "databasePrivilege", "dbmsPrivilege",
        "dbmsPrivilegeExecute", "adminToken", "procedureToken", "indexToken",
        "constraintToken", "transactionToken", "userQualifier", "executeFunctionQualifier",
        "executeProcedureQualifier", "settingQualifier", "globs", "glob", "globRecursive",
        "globPart", "qualifiedGraphPrivileges", "labelsResource", "propertiesResource",
        "nonEmptyStringList", "graphQualifier", "graphQualifierToken", "relToken",
        "elementToken", "nodeToken", "databaseScope", "graphScope", "createCompositeDatabase",
        "createDatabase", "shards", "graphShard", "propertyShard", "topology",
        "primaryTopology", "primaryToken", "secondaryTopology", "secondaryToken",
        "defaultLanguageSpecification", "dropDatabase", "aliasAction", "alterDatabase",
        "alterDatabaseAccess", "alterDatabaseTopology", "alterDatabaseOption",
        "startDatabase", "stopDatabase", "waitClause", "secondsToken", "showDatabase",
        "aliasName", "aliasTargetName", "databaseName", "createAlias", "dropAlias",
        "alterAlias", "alterAliasTarget", "alterAliasUser", "alterAliasPassword",
        "alterAliasDriver", "alterAliasProperties", "showAliases", "symbolicNameOrStringParameter",
        "commandNameExpression", "symbolicNameOrStringParameterList", "symbolicAliasNameList",
        "symbolicAliasNameOrParameter", "symbolicAliasName", "stringListLiteral",
        "stringList", "stringLiteral", "stringOrParameterExpression", "stringOrParameter",
        "uIntOrIntParameter", "mapOrParameter", "map", "symbolicVariableNameString",
        "escapedSymbolicVariableNameString", "unescapedSymbolicVariableNameString",
        "symbolicNameString", "escapedSymbolicNameString", "unescapedSymbolicNameString_",
        "endOfFile",
    ];
    get grammarFileName() { return "CypherCmdParser.g4"; }
    get literalNames() { return CypherCmdParser.literalNames; }
    get symbolicNames() { return CypherCmdParser.symbolicNames; }
    get ruleNames() { return CypherCmdParser.ruleNames; }
    get serializedATN() { return CypherCmdParser._serializedATN; }
    createFailedPredicateException(predicate, message) {
        return new FailedPredicateException(this, predicate, message);
    }
    constructor(input) {
        super(input);
        this._interp = new ParserATNSimulator(this, CypherCmdParser._ATN, CypherCmdParser.DecisionsToDFA, new PredictionContextCache());
    }
    // @RuleVersion(0)
    statementsOrCommands() {
        let localctx = new StatementsOrCommandsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 0, CypherCmdParser.RULE_statementsOrCommands);
        let _la;
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 808;
                this.statementOrCommand();
                this.state = 813;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 0, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 809;
                                this.match(CypherCmdParser.SEMICOLON);
                                this.state = 810;
                                this.statementOrCommand();
                            }
                        }
                    }
                    this.state = 815;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 0, this._ctx);
                }
                this.state = 817;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 275) {
                    {
                        this.state = 816;
                        this.match(CypherCmdParser.SEMICOLON);
                    }
                }
                this.state = 819;
                this.match(CypherCmdParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    statementOrCommand() {
        let localctx = new StatementOrCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 2, CypherCmdParser.RULE_statementOrCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 823;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 12:
                    case 13:
                    case 14:
                    case 35:
                    case 54:
                    case 73:
                    case 82:
                    case 85:
                    case 86:
                    case 90:
                    case 99:
                    case 100:
                    case 105:
                    case 122:
                    case 123:
                    case 128:
                    case 134:
                    case 151:
                    case 171:
                    case 174:
                    case 175:
                    case 177:
                    case 184:
                    case 185:
                    case 201:
                    case 211:
                    case 214:
                    case 218:
                    case 244:
                    case 246:
                    case 251:
                    case 261:
                    case 262:
                    case 278:
                    case 285:
                    case 288:
                    case 289:
                    case 292:
                    case 297:
                    case 318:
                    case 320:
                    case 329:
                    case 331:
                        {
                            this.state = 821;
                            this.preparsedStatement();
                        }
                        break;
                    case 60:
                        {
                            this.state = 822;
                            this.consoleCommand();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    consoleCommand() {
        let localctx = new ConsoleCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 4, CypherCmdParser.RULE_consoleCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 825;
                this.match(CypherCmdParser.COLON);
                this.state = 838;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 2:
                        {
                            this.state = 826;
                            this.clearCmd();
                        }
                        break;
                    case 3:
                        {
                            this.state = 827;
                            this.historyCmd();
                        }
                        break;
                    case 320:
                        {
                            this.state = 828;
                            this.useCmd();
                        }
                        break;
                    case 1:
                        {
                            this.state = 829;
                            this.paramsCmd();
                        }
                        break;
                    case 276:
                        {
                            this.state = 830;
                            this.serverCmd();
                        }
                        break;
                    case 4:
                        {
                            this.state = 831;
                            this.connectCmd();
                        }
                        break;
                    case 5:
                        {
                            this.state = 832;
                            this.disconnectCmd();
                        }
                        break;
                    case 6:
                        {
                            this.state = 833;
                            this.welcomeCmd();
                        }
                        break;
                    case 7:
                        {
                            this.state = 834;
                            this.sysInfoCmd();
                        }
                        break;
                    case 8:
                        {
                            this.state = 835;
                            this.styleCmd();
                        }
                        break;
                    case 10:
                        {
                            this.state = 836;
                            this.playCmd();
                        }
                        break;
                    case 11:
                        {
                            this.state = 837;
                            this.accessModeCmd();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    paramsCmd() {
        let localctx = new ParamsCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 6, CypherCmdParser.RULE_paramsCmd);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 840;
                this.match(CypherCmdParser.PARAM);
                this.state = 842;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4280840446) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194655) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 262143) !== 0)) {
                    {
                        this.state = 841;
                        this.paramsArgs();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    paramsArgs() {
        let localctx = new ParamsArgsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 8, CypherCmdParser.RULE_paramsArgs);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 848;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 5, this._ctx)) {
                    case 1:
                        {
                            this.state = 844;
                            this.match(CypherCmdParser.CLEAR);
                        }
                        break;
                    case 2:
                        {
                            this.state = 845;
                            this.listCompletionRule();
                        }
                        break;
                    case 3:
                        {
                            this.state = 846;
                            this.map();
                        }
                        break;
                    case 4:
                        {
                            this.state = 847;
                            this.lambda();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lambda() {
        let localctx = new LambdaContext(this, this._ctx, this.state);
        this.enterRule(localctx, 10, CypherCmdParser.RULE_lambda);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 850;
                this.parameterName("ANY");
                this.state = 851;
                this.match(CypherCmdParser.EQ);
                this.state = 852;
                this.match(CypherCmdParser.GT);
                this.state = 853;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    clearCmd() {
        let localctx = new ClearCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 12, CypherCmdParser.RULE_clearCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 855;
                this.match(CypherCmdParser.CLEAR);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    historyCmd() {
        let localctx = new HistoryCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 14, CypherCmdParser.RULE_historyCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 857;
                this.match(CypherCmdParser.HISTORY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    useCmd() {
        let localctx = new UseCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 16, CypherCmdParser.RULE_useCmd);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 859;
                this.useCompletionRule();
                this.state = 861;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 860;
                        this.symbolicAliasName();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    serverCmd() {
        let localctx = new ServerCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 18, CypherCmdParser.RULE_serverCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 863;
                this.serverCompletionRule();
                this.state = 864;
                this.serverArgs();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    serverArgs() {
        let localctx = new ServerArgsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 20, CypherCmdParser.RULE_serverArgs);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 866;
                _la = this._input.LA(1);
                if (!(_la === 4 || _la === 5)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    connectCmd() {
        let localctx = new ConnectCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 22, CypherCmdParser.RULE_connectCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 868;
                this.match(CypherCmdParser.CONNECT);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    disconnectCmd() {
        let localctx = new DisconnectCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 24, CypherCmdParser.RULE_disconnectCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 870;
                this.match(CypherCmdParser.DISCONNECT);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    sysInfoCmd() {
        let localctx = new SysInfoCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 26, CypherCmdParser.RULE_sysInfoCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 872;
                this.match(CypherCmdParser.SYSINFO);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    styleCmd() {
        let localctx = new StyleCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 28, CypherCmdParser.RULE_styleCmd);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 874;
                this.match(CypherCmdParser.STYLE);
                this.state = 876;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 9) {
                    {
                        this.state = 875;
                        this.match(CypherCmdParser.RESET);
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    welcomeCmd() {
        let localctx = new WelcomeCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 30, CypherCmdParser.RULE_welcomeCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 878;
                this.match(CypherCmdParser.WELCOME);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    playCmd() {
        let localctx = new PlayCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 32, CypherCmdParser.RULE_playCmd);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 880;
                this.match(CypherCmdParser.PLAY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    accessModeArgs() {
        let localctx = new AccessModeArgsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 34, CypherCmdParser.RULE_accessModeArgs);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 884;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 243:
                        {
                            this.state = 882;
                            this.readCompletionRule();
                        }
                        break;
                    case 333:
                        {
                            this.state = 883;
                            this.writeCompletionRule();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    accessModeCmd() {
        let localctx = new AccessModeCmdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 36, CypherCmdParser.RULE_accessModeCmd);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 886;
                this.match(CypherCmdParser.ACCESSMODE);
                this.state = 888;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 243 || _la === 333) {
                    {
                        this.state = 887;
                        this.accessModeArgs();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    listCompletionRule() {
        let localctx = new ListCompletionRuleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 38, CypherCmdParser.RULE_listCompletionRule);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 890;
                this.match(CypherCmdParser.LIST);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    useCompletionRule() {
        let localctx = new UseCompletionRuleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 40, CypherCmdParser.RULE_useCompletionRule);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 892;
                this.match(CypherCmdParser.USE);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    serverCompletionRule() {
        let localctx = new ServerCompletionRuleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 42, CypherCmdParser.RULE_serverCompletionRule);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 894;
                this.match(CypherCmdParser.SERVER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    readCompletionRule() {
        let localctx = new ReadCompletionRuleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 44, CypherCmdParser.RULE_readCompletionRule);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 896;
                this.match(CypherCmdParser.READ);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    writeCompletionRule() {
        let localctx = new WriteCompletionRuleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 46, CypherCmdParser.RULE_writeCompletionRule);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 898;
                this.match(CypherCmdParser.WRITE);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    unescapedSymbolicNameString() {
        let localctx = new UnescapedSymbolicNameStringContext(this, this._ctx, this.state);
        this.enterRule(localctx, 48, CypherCmdParser.RULE_unescapedSymbolicNameString);
        try {
            this.state = 909;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 10, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 900;
                        this.preparserKeyword();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 901;
                        this.match(CypherCmdParser.HISTORY);
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 902;
                        this.match(CypherCmdParser.CLEAR);
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 903;
                        this.match(CypherCmdParser.PARAM);
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 904;
                        this.match(CypherCmdParser.CONNECT);
                    }
                    break;
                case 6:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 905;
                        this.match(CypherCmdParser.DISCONNECT);
                    }
                    break;
                case 7:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 906;
                        this.match(CypherCmdParser.WELCOME);
                    }
                    break;
                case 8:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 907;
                        this.match(CypherCmdParser.SYSINFO);
                    }
                    break;
                case 9:
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 908;
                        this.unescapedSymbolicNameString_();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    preparsedStatement() {
        let localctx = new PreparsedStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 50, CypherCmdParser.RULE_preparsedStatement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 914;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 28672) !== 0)) {
                    {
                        {
                            this.state = 911;
                            this.preparserOption();
                        }
                    }
                    this.state = 916;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 917;
                this.statement();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    preparserKeyword() {
        let localctx = new PreparserKeywordContext(this, this._ctx, this.state);
        this.enterRule(localctx, 52, CypherCmdParser.RULE_preparserKeyword);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 919;
                _la = this._input.LA(1);
                if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & 28672) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    preparserOption() {
        let localctx = new PreparserOptionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 54, CypherCmdParser.RULE_preparserOption);
        try {
            this.state = 924;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 12:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 921;
                        this.match(CypherCmdParser.EXPLAIN);
                    }
                    break;
                case 13:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 922;
                        this.match(CypherCmdParser.PROFILE);
                    }
                    break;
                case 14:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 923;
                        this.cypherOptions();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    cypher() {
        let localctx = new CypherContext(this, this._ctx, this.state);
        this.enterRule(localctx, 56, CypherCmdParser.RULE_cypher);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 926;
                this.match(CypherCmdParser.CYPHER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    cypherOptions() {
        let localctx = new CypherOptionsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 58, CypherCmdParser.RULE_cypherOptions);
        let _la;
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 928;
                this.cypher();
                this.state = 930;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 18 || _la === 19 || _la === 95 || _la === 339) {
                    {
                        this.state = 929;
                        this.cypherVersion();
                    }
                }
                this.state = 935;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 14, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 932;
                                this.cypherOption();
                            }
                        }
                    }
                    this.state = 937;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 14, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    cypherOption() {
        let localctx = new CypherOptionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 60, CypherCmdParser.RULE_cypherOption);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 938;
                this.cypherOptionName();
                this.state = 939;
                this.match(CypherCmdParser.EQ);
                this.state = 940;
                this.cypherOptionValue();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    cypherOptionValue() {
        let localctx = new CypherOptionValueContext(this, this._ctx, this.state);
        this.enterRule(localctx, 62, CypherCmdParser.RULE_cypherOptionValue);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 944;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 942;
                            this.unescapedSymbolicNameString();
                        }
                        break;
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 186:
                        {
                            this.state = 943;
                            this.numberLiteral();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    cypherOptionName() {
        let localctx = new CypherOptionNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 64, CypherCmdParser.RULE_cypherOptionName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 946;
                this.unescapedSymbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    cypherVersion() {
        let localctx = new CypherVersionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 66, CypherCmdParser.RULE_cypherVersion);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 949;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 948;
                            _la = this._input.LA(1);
                            if (!(_la === 18 || _la === 19 || _la === 95 || _la === 339)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        }
                    }
                    this.state = 951;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 18 || _la === 19 || _la === 95 || _la === 339);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    statements() {
        let localctx = new StatementsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 68, CypherCmdParser.RULE_statements);
        let _la;
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 953;
                this.statement();
                this.state = 958;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 17, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 954;
                                this.match(CypherCmdParser.SEMICOLON);
                                this.state = 955;
                                this.statement();
                            }
                        }
                    }
                    this.state = 960;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 17, this._ctx);
                }
                this.state = 962;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 275) {
                    {
                        this.state = 961;
                        this.match(CypherCmdParser.SEMICOLON);
                    }
                }
                this.state = 964;
                this.match(CypherCmdParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    statement() {
        let localctx = new StatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 70, CypherCmdParser.RULE_statement);
        try {
            this.state = 968;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 19, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 966;
                        this.command();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 967;
                        this.nextStatement();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nextStatement() {
        let localctx = new NextStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 72, CypherCmdParser.RULE_nextStatement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 970;
                this.regularQuery();
                this.state = 975;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 199) {
                    {
                        {
                            this.state = 971;
                            this.match(CypherCmdParser.NEXT);
                            this.state = 972;
                            this.regularQuery();
                        }
                    }
                    this.state = 977;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    regularQuery() {
        let localctx = new RegularQueryContext(this, this._ctx, this.state);
        this.enterRule(localctx, 74, CypherCmdParser.RULE_regularQuery);
        try {
            this.state = 980;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 54:
                case 73:
                case 85:
                case 90:
                case 122:
                case 123:
                case 128:
                case 151:
                case 171:
                case 174:
                case 175:
                case 177:
                case 184:
                case 185:
                case 201:
                case 211:
                case 214:
                case 218:
                case 251:
                case 261:
                case 278:
                case 288:
                case 318:
                case 320:
                case 331:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 978;
                        this.union();
                    }
                    break;
                case 329:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 979;
                        this.when();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    union() {
        let localctx = new UnionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 76, CypherCmdParser.RULE_union);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 982;
                this.singleQuery();
                this.state = 990;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 315) {
                    {
                        {
                            this.state = 983;
                            this.match(CypherCmdParser.UNION);
                            this.state = 985;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 33 || _la === 93) {
                                {
                                    this.state = 984;
                                    _la = this._input.LA(1);
                                    if (!(_la === 33 || _la === 93)) {
                                        this._errHandler.recoverInline(this);
                                    }
                                    else {
                                        this._errHandler.reportMatch(this);
                                        this.consume();
                                    }
                                }
                            }
                            this.state = 987;
                            this.singleQuery();
                        }
                    }
                    this.state = 992;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    when() {
        let localctx = new WhenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 78, CypherCmdParser.RULE_when);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 994;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 993;
                            this.whenBranch();
                        }
                    }
                    this.state = 996;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 329);
                this.state = 999;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 108) {
                    {
                        this.state = 998;
                        this.elseBranch();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    whenBranch() {
        let localctx = new WhenBranchContext(this, this._ctx, this.state);
        this.enterRule(localctx, 80, CypherCmdParser.RULE_whenBranch);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1001;
                this.match(CypherCmdParser.WHEN);
                this.state = 1002;
                this.expression();
                this.state = 1003;
                this.match(CypherCmdParser.THEN);
                this.state = 1004;
                this.singleQuery();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    elseBranch() {
        let localctx = new ElseBranchContext(this, this._ctx, this.state);
        this.enterRule(localctx, 82, CypherCmdParser.RULE_elseBranch);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1006;
                this.match(CypherCmdParser.ELSE);
                this.state = 1007;
                this.singleQuery();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    singleQuery() {
        let localctx = new SingleQueryContext(this, this._ctx, this.state);
        this.enterRule(localctx, 84, CypherCmdParser.RULE_singleQuery);
        let _la;
        try {
            this.state = 1021;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 28, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1010;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        do {
                            {
                                {
                                    this.state = 1009;
                                    this.clause();
                                }
                            }
                            this.state = 1012;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        } while (((((_la - 54)) & ~0x1F) === 0 && ((1 << (_la - 54)) & 2148007937) !== 0) || _la === 90 || ((((_la - 122)) & ~0x1F) === 0 && ((1 << (_la - 122)) & 536870979) !== 0) || ((((_la - 174)) & ~0x1F) === 0 && ((1 << (_la - 174)) & 134220811) !== 0) || ((((_la - 211)) & ~0x1F) === 0 && ((1 << (_la - 211)) & 137) !== 0) || ((((_la - 251)) & ~0x1F) === 0 && ((1 << (_la - 251)) & 134218753) !== 0) || _la === 288 || _la === 318 || _la === 320 || _la === 331);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1015;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 320) {
                            {
                                this.state = 1014;
                                this.useClause();
                            }
                        }
                        this.state = 1017;
                        this.match(CypherCmdParser.LCURLY);
                        this.state = 1018;
                        this.nextStatement();
                        this.state = 1019;
                        this.match(CypherCmdParser.RCURLY);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    clause() {
        let localctx = new ClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 86, CypherCmdParser.RULE_clause);
        try {
            this.state = 1042;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 29, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1023;
                        this.useClause();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1024;
                        this.finishClause();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1025;
                        this.returnClause();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1026;
                        this.createClause();
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 1027;
                        this.insertClause();
                    }
                    break;
                case 6:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 1028;
                        this.deleteClause();
                    }
                    break;
                case 7:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 1029;
                        this.setClause();
                    }
                    break;
                case 8:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 1030;
                        this.removeClause();
                    }
                    break;
                case 9:
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 1031;
                        this.matchClause();
                    }
                    break;
                case 10:
                    this.enterOuterAlt(localctx, 10);
                    {
                        this.state = 1032;
                        this.mergeClause();
                    }
                    break;
                case 11:
                    this.enterOuterAlt(localctx, 11);
                    {
                        this.state = 1033;
                        this.withClause();
                    }
                    break;
                case 12:
                    this.enterOuterAlt(localctx, 12);
                    {
                        this.state = 1034;
                        this.filterClause();
                    }
                    break;
                case 13:
                    this.enterOuterAlt(localctx, 13);
                    {
                        this.state = 1035;
                        this.unwindClause();
                    }
                    break;
                case 14:
                    this.enterOuterAlt(localctx, 14);
                    {
                        this.state = 1036;
                        this.letClause();
                    }
                    break;
                case 15:
                    this.enterOuterAlt(localctx, 15);
                    {
                        this.state = 1037;
                        this.callClause();
                    }
                    break;
                case 16:
                    this.enterOuterAlt(localctx, 16);
                    {
                        this.state = 1038;
                        this.subqueryClause();
                    }
                    break;
                case 17:
                    this.enterOuterAlt(localctx, 17);
                    {
                        this.state = 1039;
                        this.loadCSVClause();
                    }
                    break;
                case 18:
                    this.enterOuterAlt(localctx, 18);
                    {
                        this.state = 1040;
                        this.foreachClause();
                    }
                    break;
                case 19:
                    this.enterOuterAlt(localctx, 19);
                    {
                        this.state = 1041;
                        this.orderBySkipLimitClause();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    useClause() {
        let localctx = new UseClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 88, CypherCmdParser.RULE_useClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1044;
                this.match(CypherCmdParser.USE);
                this.state = 1046;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 30, this._ctx)) {
                    case 1:
                        {
                            this.state = 1045;
                            this.match(CypherCmdParser.GRAPH);
                        }
                        break;
                }
                this.state = 1048;
                this.graphReference();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphReference() {
        let localctx = new GraphReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 90, CypherCmdParser.RULE_graphReference);
        try {
            this.state = 1056;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 31, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1050;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1051;
                        this.graphReference();
                        this.state = 1052;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1054;
                        this.functionInvocation();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1055;
                        this.symbolicAliasName();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    finishClause() {
        let localctx = new FinishClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 92, CypherCmdParser.RULE_finishClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1058;
                this.match(CypherCmdParser.FINISH);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    returnClause() {
        let localctx = new ReturnClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 94, CypherCmdParser.RULE_returnClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1060;
                this.match(CypherCmdParser.RETURN);
                this.state = 1061;
                this.returnBody();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    returnBody() {
        let localctx = new ReturnBodyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 96, CypherCmdParser.RULE_returnBody);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1064;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 32, this._ctx)) {
                    case 1:
                        {
                            this.state = 1063;
                            _la = this._input.LA(1);
                            if (!(_la === 33 || _la === 93)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        }
                        break;
                }
                this.state = 1066;
                this.returnItems();
                this.state = 1068;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 33, this._ctx)) {
                    case 1:
                        {
                            this.state = 1067;
                            this.orderBy();
                        }
                        break;
                }
                this.state = 1071;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 34, this._ctx)) {
                    case 1:
                        {
                            this.state = 1070;
                            this.skip();
                        }
                        break;
                }
                this.state = 1074;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 35, this._ctx)) {
                    case 1:
                        {
                            this.state = 1073;
                            this.limit();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    returnItem() {
        let localctx = new ReturnItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 98, CypherCmdParser.RULE_returnItem);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1076;
                this.expression();
                this.state = 1079;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 1077;
                        this.match(CypherCmdParser.AS);
                        this.state = 1078;
                        this.variable();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    returnItems() {
        let localctx = new ReturnItemsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 100, CypherCmdParser.RULE_returnItems);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1083;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 301:
                        {
                            this.state = 1081;
                            this.match(CypherCmdParser.TIMES);
                        }
                        break;
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 170:
                    case 171:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 180:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 186:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 224:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 1082;
                            this.returnItem();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 1089;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1085;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1086;
                            this.returnItem();
                        }
                    }
                    this.state = 1091;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderItem() {
        let localctx = new OrderItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 102, CypherCmdParser.RULE_orderItem);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1092;
                this.expression();
                this.state = 1095;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 40:
                    case 41:
                        {
                            this.state = 1093;
                            this.ascToken();
                        }
                        break;
                    case 87:
                    case 88:
                        {
                            this.state = 1094;
                            this.descToken();
                        }
                        break;
                    case -1:
                    case 54:
                    case 62:
                    case 73:
                    case 85:
                    case 90:
                    case 108:
                    case 122:
                    case 123:
                    case 128:
                    case 151:
                    case 174:
                    case 175:
                    case 177:
                    case 184:
                    case 185:
                    case 199:
                    case 201:
                    case 211:
                    case 214:
                    case 218:
                    case 242:
                    case 251:
                    case 261:
                    case 267:
                    case 275:
                    case 278:
                    case 285:
                    case 288:
                    case 297:
                    case 315:
                    case 318:
                    case 320:
                    case 329:
                    case 330:
                    case 331:
                        break;
                    default:
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ascToken() {
        let localctx = new AscTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 104, CypherCmdParser.RULE_ascToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1097;
                _la = this._input.LA(1);
                if (!(_la === 40 || _la === 41)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    descToken() {
        let localctx = new DescTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 106, CypherCmdParser.RULE_descToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1099;
                _la = this._input.LA(1);
                if (!(_la === 87 || _la === 88)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderBy() {
        let localctx = new OrderByContext(this, this._ctx, this.state);
        this.enterRule(localctx, 108, CypherCmdParser.RULE_orderBy);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1101;
                this.match(CypherCmdParser.ORDER);
                this.state = 1102;
                this.match(CypherCmdParser.BY);
                this.state = 1103;
                this.orderItem();
                this.state = 1108;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1104;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1105;
                            this.orderItem();
                        }
                    }
                    this.state = 1110;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    skip() {
        let localctx = new SkipContext(this, this._ctx, this.state);
        this.enterRule(localctx, 110, CypherCmdParser.RULE_skip);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1111;
                _la = this._input.LA(1);
                if (!(_la === 211 || _la === 288)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1112;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    limit() {
        let localctx = new LimitContext(this, this._ctx, this.state);
        this.enterRule(localctx, 112, CypherCmdParser.RULE_limit);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1114;
                this.match(CypherCmdParser.LIMITROWS);
                this.state = 1115;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    whereClause() {
        let localctx = new WhereClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 114, CypherCmdParser.RULE_whereClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1117;
                this.match(CypherCmdParser.WHERE);
                this.state = 1118;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    withClause() {
        let localctx = new WithClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 116, CypherCmdParser.RULE_withClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1120;
                this.match(CypherCmdParser.WITH);
                this.state = 1121;
                this.returnBody();
                this.state = 1123;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330) {
                    {
                        this.state = 1122;
                        this.whereClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createClause() {
        let localctx = new CreateClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 118, CypherCmdParser.RULE_createClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1125;
                this.match(CypherCmdParser.CREATE);
                this.state = 1126;
                this.patternList();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertClause() {
        let localctx = new InsertClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 120, CypherCmdParser.RULE_insertClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1128;
                this.match(CypherCmdParser.INSERT);
                this.state = 1129;
                this.insertPatternList();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    setClause() {
        let localctx = new SetClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 122, CypherCmdParser.RULE_setClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1131;
                this.match(CypherCmdParser.SET);
                this.state = 1132;
                this.setItem();
                this.state = 1137;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1133;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1134;
                            this.setItem();
                        }
                    }
                    this.state = 1139;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    setItem() {
        let localctx = new SetItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 124, CypherCmdParser.RULE_setItem);
        try {
            this.state = 1162;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 43, this._ctx)) {
                case 1:
                    localctx = new SetPropContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1140;
                        this.propertyExpression();
                        this.state = 1141;
                        this.match(CypherCmdParser.EQ);
                        this.state = 1142;
                        this.expression();
                    }
                    break;
                case 2:
                    localctx = new SetDynamicPropContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1144;
                        this.dynamicPropertyExpression();
                        this.state = 1145;
                        this.match(CypherCmdParser.EQ);
                        this.state = 1146;
                        this.expression();
                    }
                    break;
                case 3:
                    localctx = new SetPropsContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1148;
                        this.variable();
                        this.state = 1149;
                        this.match(CypherCmdParser.EQ);
                        this.state = 1150;
                        this.expression();
                    }
                    break;
                case 4:
                    localctx = new AddPropContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1152;
                        this.variable();
                        this.state = 1153;
                        this.match(CypherCmdParser.PLUSEQUAL);
                        this.state = 1154;
                        this.expression();
                    }
                    break;
                case 5:
                    localctx = new SetLabelsContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 1156;
                        this.variable();
                        this.state = 1157;
                        this.nodeLabels();
                    }
                    break;
                case 6:
                    localctx = new SetLabelsIsContext(this, localctx);
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 1159;
                        this.variable();
                        this.state = 1160;
                        this.nodeLabelsIs();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    removeClause() {
        let localctx = new RemoveClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 126, CypherCmdParser.RULE_removeClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1164;
                this.match(CypherCmdParser.REMOVE);
                this.state = 1165;
                this.removeItem();
                this.state = 1170;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1166;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1167;
                            this.removeItem();
                        }
                    }
                    this.state = 1172;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    removeItem() {
        let localctx = new RemoveItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 128, CypherCmdParser.RULE_removeItem);
        try {
            this.state = 1181;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 45, this._ctx)) {
                case 1:
                    localctx = new RemovePropContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1173;
                        this.propertyExpression();
                    }
                    break;
                case 2:
                    localctx = new RemoveDynamicPropContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1174;
                        this.dynamicPropertyExpression();
                    }
                    break;
                case 3:
                    localctx = new RemoveLabelsContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1175;
                        this.variable();
                        this.state = 1176;
                        this.nodeLabels();
                    }
                    break;
                case 4:
                    localctx = new RemoveLabelsIsContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1178;
                        this.variable();
                        this.state = 1179;
                        this.nodeLabelsIs();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    deleteClause() {
        let localctx = new DeleteClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 130, CypherCmdParser.RULE_deleteClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1184;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 90 || _la === 201) {
                    {
                        this.state = 1183;
                        _la = this._input.LA(1);
                        if (!(_la === 90 || _la === 201)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 1186;
                this.match(CypherCmdParser.DELETE);
                this.state = 1187;
                this.expression();
                this.state = 1192;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1188;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1189;
                            this.expression();
                        }
                    }
                    this.state = 1194;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    matchClause() {
        let localctx = new MatchClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 132, CypherCmdParser.RULE_matchClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1196;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 214) {
                    {
                        this.state = 1195;
                        this.match(CypherCmdParser.OPTIONAL);
                    }
                }
                this.state = 1198;
                this.match(CypherCmdParser.MATCH);
                this.state = 1200;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 49, this._ctx)) {
                    case 1:
                        {
                            this.state = 1199;
                            this.matchMode();
                        }
                        break;
                }
                this.state = 1202;
                this.patternList();
                this.state = 1206;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 323) {
                    {
                        {
                            this.state = 1203;
                            this.hint();
                        }
                    }
                    this.state = 1208;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 1210;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330) {
                    {
                        this.state = 1209;
                        this.whereClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    matchMode() {
        let localctx = new MatchModeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 134, CypherCmdParser.RULE_matchMode);
        try {
            this.state = 1228;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 252:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1212;
                        this.match(CypherCmdParser.REPEATABLE);
                        this.state = 1218;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 106:
                                {
                                    this.state = 1213;
                                    this.match(CypherCmdParser.ELEMENT);
                                    this.state = 1215;
                                    this._errHandler.sync(this);
                                    switch (this._interp.adaptivePredict(this._input, 52, this._ctx)) {
                                        case 1:
                                            {
                                                this.state = 1214;
                                                this.match(CypherCmdParser.BINDINGS);
                                            }
                                            break;
                                    }
                                }
                                break;
                            case 107:
                                {
                                    this.state = 1217;
                                    this.match(CypherCmdParser.ELEMENTS);
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                case 91:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1220;
                        this.match(CypherCmdParser.DIFFERENT);
                        this.state = 1226;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 249:
                                {
                                    this.state = 1221;
                                    this.match(CypherCmdParser.RELATIONSHIP);
                                    this.state = 1223;
                                    this._errHandler.sync(this);
                                    switch (this._interp.adaptivePredict(this._input, 54, this._ctx)) {
                                        case 1:
                                            {
                                                this.state = 1222;
                                                this.match(CypherCmdParser.BINDINGS);
                                            }
                                            break;
                                    }
                                }
                                break;
                            case 250:
                                {
                                    this.state = 1225;
                                    this.match(CypherCmdParser.RELATIONSHIPS);
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    hint() {
        let localctx = new HintContext(this, this._ctx, this.state);
        this.enterRule(localctx, 136, CypherCmdParser.RULE_hint);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1230;
                this.match(CypherCmdParser.USING);
                this.state = 1256;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 147:
                    case 226:
                    case 240:
                    case 298:
                        {
                            {
                                this.state = 1238;
                                this._errHandler.sync(this);
                                switch (this._input.LA(1)) {
                                    case 147:
                                        {
                                            this.state = 1231;
                                            this.match(CypherCmdParser.INDEX);
                                        }
                                        break;
                                    case 298:
                                        {
                                            this.state = 1232;
                                            this.match(CypherCmdParser.TEXT);
                                            this.state = 1233;
                                            this.match(CypherCmdParser.INDEX);
                                        }
                                        break;
                                    case 240:
                                        {
                                            this.state = 1234;
                                            this.match(CypherCmdParser.RANGE);
                                            this.state = 1235;
                                            this.match(CypherCmdParser.INDEX);
                                        }
                                        break;
                                    case 226:
                                        {
                                            this.state = 1236;
                                            this.match(CypherCmdParser.POINT);
                                            this.state = 1237;
                                            this.match(CypherCmdParser.INDEX);
                                        }
                                        break;
                                    default:
                                        throw new NoViableAltException(this);
                                }
                                this.state = 1241;
                                this._errHandler.sync(this);
                                switch (this._interp.adaptivePredict(this._input, 58, this._ctx)) {
                                    case 1:
                                        {
                                            this.state = 1240;
                                            this.match(CypherCmdParser.SEEK);
                                        }
                                        break;
                                }
                                this.state = 1243;
                                this.variable();
                                this.state = 1244;
                                this.labelOrRelType();
                                this.state = 1245;
                                this.match(CypherCmdParser.LPAREN);
                                this.state = 1246;
                                this.nonEmptyNameList();
                                this.state = 1247;
                                this.match(CypherCmdParser.RPAREN);
                            }
                        }
                        break;
                    case 163:
                        {
                            this.state = 1249;
                            this.match(CypherCmdParser.JOIN);
                            this.state = 1250;
                            this.match(CypherCmdParser.ON);
                            this.state = 1251;
                            this.nonEmptyNameList();
                        }
                        break;
                    case 268:
                        {
                            this.state = 1252;
                            this.match(CypherCmdParser.SCAN);
                            this.state = 1253;
                            this.variable();
                            this.state = 1254;
                            this.labelOrRelType();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    mergeClause() {
        let localctx = new MergeClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 138, CypherCmdParser.RULE_mergeClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1258;
                this.match(CypherCmdParser.MERGE);
                this.state = 1259;
                this.pattern();
                this.state = 1263;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 212) {
                    {
                        {
                            this.state = 1260;
                            this.mergeAction();
                        }
                    }
                    this.state = 1265;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    mergeAction() {
        let localctx = new MergeActionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 140, CypherCmdParser.RULE_mergeAction);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1266;
                this.match(CypherCmdParser.ON);
                this.state = 1267;
                _la = this._input.LA(1);
                if (!(_la === 73 || _la === 184)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1268;
                this.setClause();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    filterClause() {
        let localctx = new FilterClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 142, CypherCmdParser.RULE_filterClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1270;
                this.match(CypherCmdParser.FILTER);
                this.state = 1272;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 61, this._ctx)) {
                    case 1:
                        {
                            this.state = 1271;
                            this.match(CypherCmdParser.WHERE);
                        }
                        break;
                }
                this.state = 1274;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    unwindClause() {
        let localctx = new UnwindClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 144, CypherCmdParser.RULE_unwindClause);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1276;
                this.match(CypherCmdParser.UNWIND);
                this.state = 1277;
                this.expression();
                this.state = 1278;
                this.match(CypherCmdParser.AS);
                this.state = 1279;
                this.variable();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    letClause() {
        let localctx = new LetClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 146, CypherCmdParser.RULE_letClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1281;
                this.match(CypherCmdParser.LET);
                this.state = 1282;
                this.letItem();
                this.state = 1287;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1283;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1284;
                            this.letItem();
                        }
                    }
                    this.state = 1289;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    letItem() {
        let localctx = new LetItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 148, CypherCmdParser.RULE_letItem);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1290;
                this.variable();
                this.state = 1291;
                this.match(CypherCmdParser.EQ);
                this.state = 1292;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    callClause() {
        let localctx = new CallClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 150, CypherCmdParser.RULE_callClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1295;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 214) {
                    {
                        this.state = 1294;
                        this.match(CypherCmdParser.OPTIONAL);
                    }
                }
                this.state = 1297;
                this.match(CypherCmdParser.CALL);
                this.state = 1298;
                this.procedureName();
                this.state = 1311;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 180) {
                    {
                        this.state = 1299;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1308;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294734078) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 1073741823) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3858234271) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 2147483647) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                            {
                                this.state = 1300;
                                this.procedureArgument();
                                this.state = 1305;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                                while (_la === 62) {
                                    {
                                        {
                                            this.state = 1301;
                                            this.match(CypherCmdParser.COMMA);
                                            this.state = 1302;
                                            this.procedureArgument();
                                        }
                                    }
                                    this.state = 1307;
                                    this._errHandler.sync(this);
                                    _la = this._input.LA(1);
                                }
                            }
                        }
                        this.state = 1310;
                        this.match(CypherCmdParser.RPAREN);
                    }
                }
                this.state = 1328;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 335) {
                    {
                        this.state = 1313;
                        this.match(CypherCmdParser.YIELD);
                        this.state = 1326;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 301:
                                {
                                    this.state = 1314;
                                    this.match(CypherCmdParser.TIMES);
                                }
                                break;
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 12:
                            case 13:
                            case 14:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 46:
                            case 47:
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 63:
                            case 64:
                            case 65:
                            case 66:
                            case 67:
                            case 68:
                            case 69:
                            case 70:
                            case 71:
                            case 72:
                            case 73:
                            case 74:
                            case 75:
                            case 76:
                            case 77:
                            case 78:
                            case 79:
                            case 80:
                            case 81:
                            case 82:
                            case 83:
                            case 84:
                            case 85:
                            case 86:
                            case 87:
                            case 88:
                            case 89:
                            case 90:
                            case 91:
                            case 93:
                            case 98:
                            case 99:
                            case 100:
                            case 101:
                            case 102:
                            case 103:
                            case 104:
                            case 105:
                            case 106:
                            case 107:
                            case 108:
                            case 109:
                            case 110:
                            case 111:
                            case 113:
                            case 114:
                            case 115:
                            case 116:
                            case 117:
                            case 118:
                            case 119:
                            case 120:
                            case 121:
                            case 122:
                            case 123:
                            case 124:
                            case 125:
                            case 126:
                            case 127:
                            case 128:
                            case 129:
                            case 130:
                            case 131:
                            case 132:
                            case 134:
                            case 135:
                            case 136:
                            case 137:
                            case 138:
                            case 140:
                            case 141:
                            case 142:
                            case 143:
                            case 144:
                            case 145:
                            case 146:
                            case 147:
                            case 148:
                            case 149:
                            case 150:
                            case 151:
                            case 152:
                            case 153:
                            case 154:
                            case 155:
                            case 156:
                            case 157:
                            case 158:
                            case 159:
                            case 160:
                            case 161:
                            case 162:
                            case 163:
                            case 164:
                            case 165:
                            case 166:
                            case 169:
                            case 173:
                            case 174:
                            case 175:
                            case 176:
                            case 177:
                            case 178:
                            case 179:
                            case 182:
                            case 183:
                            case 184:
                            case 185:
                            case 188:
                            case 191:
                            case 192:
                            case 193:
                            case 194:
                            case 195:
                            case 196:
                            case 197:
                            case 198:
                            case 199:
                            case 200:
                            case 201:
                            case 202:
                            case 203:
                            case 204:
                            case 205:
                            case 206:
                            case 207:
                            case 208:
                            case 209:
                            case 210:
                            case 211:
                            case 212:
                            case 213:
                            case 214:
                            case 215:
                            case 216:
                            case 217:
                            case 218:
                            case 219:
                            case 220:
                            case 221:
                            case 222:
                            case 223:
                            case 226:
                            case 227:
                            case 229:
                            case 230:
                            case 231:
                            case 232:
                            case 233:
                            case 234:
                            case 235:
                            case 236:
                            case 237:
                            case 238:
                            case 240:
                            case 243:
                            case 244:
                            case 245:
                            case 246:
                            case 248:
                            case 249:
                            case 250:
                            case 251:
                            case 252:
                            case 253:
                            case 254:
                            case 255:
                            case 256:
                            case 257:
                            case 258:
                            case 259:
                            case 260:
                            case 261:
                            case 262:
                            case 263:
                            case 264:
                            case 265:
                            case 266:
                            case 268:
                            case 269:
                            case 270:
                            case 271:
                            case 272:
                            case 273:
                            case 274:
                            case 276:
                            case 277:
                            case 278:
                            case 279:
                            case 280:
                            case 281:
                            case 282:
                            case 283:
                            case 284:
                            case 285:
                            case 286:
                            case 287:
                            case 288:
                            case 289:
                            case 290:
                            case 291:
                            case 292:
                            case 293:
                            case 294:
                            case 295:
                            case 296:
                            case 297:
                            case 298:
                            case 299:
                            case 300:
                            case 302:
                            case 303:
                            case 304:
                            case 305:
                            case 306:
                            case 307:
                            case 308:
                            case 309:
                            case 310:
                            case 311:
                            case 312:
                            case 313:
                            case 314:
                            case 315:
                            case 316:
                            case 317:
                            case 318:
                            case 319:
                            case 320:
                            case 321:
                            case 322:
                            case 323:
                            case 324:
                            case 325:
                            case 326:
                            case 327:
                            case 328:
                            case 329:
                            case 330:
                            case 331:
                            case 332:
                            case 333:
                            case 334:
                            case 335:
                            case 336:
                            case 337:
                            case 338:
                                {
                                    this.state = 1315;
                                    this.procedureResultItem();
                                    this.state = 1320;
                                    this._errHandler.sync(this);
                                    _la = this._input.LA(1);
                                    while (_la === 62) {
                                        {
                                            {
                                                this.state = 1316;
                                                this.match(CypherCmdParser.COMMA);
                                                this.state = 1317;
                                                this.procedureResultItem();
                                            }
                                        }
                                        this.state = 1322;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                    }
                                    this.state = 1324;
                                    this._errHandler.sync(this);
                                    _la = this._input.LA(1);
                                    if (_la === 330) {
                                        {
                                            this.state = 1323;
                                            this.whereClause();
                                        }
                                    }
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    procedureName() {
        let localctx = new ProcedureNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 152, CypherCmdParser.RULE_procedureName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1330;
                this.namespace();
                this.state = 1331;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    procedureArgument() {
        let localctx = new ProcedureArgumentContext(this, this._ctx, this.state);
        this.enterRule(localctx, 154, CypherCmdParser.RULE_procedureArgument);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1333;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    procedureResultItem() {
        let localctx = new ProcedureResultItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 156, CypherCmdParser.RULE_procedureResultItem);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1335;
                localctx._yieldItemName = this.variable();
                this.state = 1338;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 1336;
                        this.match(CypherCmdParser.AS);
                        this.state = 1337;
                        localctx._yieldItemAlias = this.variable();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    loadCSVClause() {
        let localctx = new LoadCSVClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 158, CypherCmdParser.RULE_loadCSVClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1340;
                this.match(CypherCmdParser.LOAD);
                this.state = 1341;
                this.match(CypherCmdParser.CSV);
                this.state = 1344;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 331) {
                    {
                        this.state = 1342;
                        this.match(CypherCmdParser.WITH);
                        this.state = 1343;
                        this.match(CypherCmdParser.HEADERS);
                    }
                }
                this.state = 1346;
                this.match(CypherCmdParser.FROM);
                this.state = 1347;
                this.expression();
                this.state = 1348;
                this.match(CypherCmdParser.AS);
                this.state = 1349;
                this.variable();
                this.state = 1352;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 121) {
                    {
                        this.state = 1350;
                        this.match(CypherCmdParser.FIELDTERMINATOR);
                        this.state = 1351;
                        this.stringLiteral();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    foreachClause() {
        let localctx = new ForeachClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 160, CypherCmdParser.RULE_foreachClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1354;
                this.match(CypherCmdParser.FOREACH);
                this.state = 1355;
                this.match(CypherCmdParser.LPAREN);
                this.state = 1356;
                this.variable();
                this.state = 1357;
                this.match(CypherCmdParser.IN);
                this.state = 1358;
                this.expression();
                this.state = 1359;
                this.match(CypherCmdParser.BAR);
                this.state = 1361;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 1360;
                            this.clause();
                        }
                    }
                    this.state = 1363;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (((((_la - 54)) & ~0x1F) === 0 && ((1 << (_la - 54)) & 2148007937) !== 0) || _la === 90 || ((((_la - 122)) & ~0x1F) === 0 && ((1 << (_la - 122)) & 536870979) !== 0) || ((((_la - 174)) & ~0x1F) === 0 && ((1 << (_la - 174)) & 134220811) !== 0) || ((((_la - 211)) & ~0x1F) === 0 && ((1 << (_la - 211)) & 137) !== 0) || ((((_la - 251)) & ~0x1F) === 0 && ((1 << (_la - 251)) & 134218753) !== 0) || _la === 288 || _la === 318 || _la === 320 || _la === 331);
                this.state = 1365;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryClause() {
        let localctx = new SubqueryClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 162, CypherCmdParser.RULE_subqueryClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1368;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 214) {
                    {
                        this.state = 1367;
                        this.match(CypherCmdParser.OPTIONAL);
                    }
                }
                this.state = 1370;
                this.match(CypherCmdParser.CALL);
                this.state = 1372;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 180) {
                    {
                        this.state = 1371;
                        this.subqueryScope();
                    }
                }
                this.state = 1374;
                this.match(CypherCmdParser.LCURLY);
                this.state = 1375;
                this.nextStatement();
                this.state = 1376;
                this.match(CypherCmdParser.RCURLY);
                this.state = 1378;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 146) {
                    {
                        this.state = 1377;
                        this.subqueryInTransactionsParameters();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryScope() {
        let localctx = new SubqueryScopeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 164, CypherCmdParser.RULE_subqueryScope);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1380;
                this.match(CypherCmdParser.LPAREN);
                this.state = 1390;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 301:
                        {
                            this.state = 1381;
                            this.match(CypherCmdParser.TIMES);
                        }
                        break;
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 1382;
                            this.variable();
                            this.state = 1387;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            while (_la === 62) {
                                {
                                    {
                                        this.state = 1383;
                                        this.match(CypherCmdParser.COMMA);
                                        this.state = 1384;
                                        this.variable();
                                    }
                                }
                                this.state = 1389;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                            }
                        }
                        break;
                    case 267:
                        break;
                    default:
                        break;
                }
                this.state = 1392;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryInTransactionsParameters() {
        let localctx = new SubqueryInTransactionsParametersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 166, CypherCmdParser.RULE_subqueryInTransactionsParameters);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1394;
                this.match(CypherCmdParser.IN);
                this.state = 1399;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 81, this._ctx)) {
                    case 1:
                        {
                            this.state = 1396;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 80, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 1395;
                                        this.expression();
                                    }
                                    break;
                            }
                            this.state = 1398;
                            this.match(CypherCmdParser.CONCURRENT);
                        }
                        break;
                }
                this.state = 1401;
                this.match(CypherCmdParser.TRANSACTIONS);
                this.state = 1407;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 210 || _la === 212 || _la === 256) {
                    {
                        this.state = 1405;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 210:
                                {
                                    this.state = 1402;
                                    this.subqueryInTransactionsBatchParameters();
                                }
                                break;
                            case 212:
                                {
                                    this.state = 1403;
                                    this.subqueryInTransactionsErrorParameters();
                                }
                                break;
                            case 256:
                                {
                                    this.state = 1404;
                                    this.subqueryInTransactionsReportParameters();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    this.state = 1409;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryInTransactionsBatchParameters() {
        let localctx = new SubqueryInTransactionsBatchParametersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 168, CypherCmdParser.RULE_subqueryInTransactionsBatchParameters);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1410;
                this.match(CypherCmdParser.OF);
                this.state = 1411;
                this.expression();
                this.state = 1412;
                _la = this._input.LA(1);
                if (!(_la === 265 || _la === 266)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryInTransactionsErrorParameters() {
        let localctx = new SubqueryInTransactionsErrorParametersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 170, CypherCmdParser.RULE_subqueryInTransactionsErrorParameters);
        let _la;
        try {
            this.state = 1427;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 86, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1414;
                        this.match(CypherCmdParser.ON);
                        this.state = 1415;
                        this.match(CypherCmdParser.ERROR);
                        this.state = 1416;
                        this.match(CypherCmdParser.RETRY);
                        this.state = 1418;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 84, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1417;
                                    this.subqueryInTransactionsRetryParameters();
                                }
                                break;
                        }
                        this.state = 1422;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 299) {
                            {
                                this.state = 1420;
                                this.match(CypherCmdParser.THEN);
                                this.state = 1421;
                                _la = this._input.LA(1);
                                if (!(_la === 51 || _la === 71 || _la === 119)) {
                                    this._errHandler.recoverInline(this);
                                }
                                else {
                                    this._errHandler.reportMatch(this);
                                    this.consume();
                                }
                            }
                        }
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1424;
                        this.match(CypherCmdParser.ON);
                        this.state = 1425;
                        this.match(CypherCmdParser.ERROR);
                        this.state = 1426;
                        _la = this._input.LA(1);
                        if (!(_la === 51 || _la === 71 || _la === 119)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryInTransactionsRetryParameters() {
        let localctx = new SubqueryInTransactionsRetryParametersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 172, CypherCmdParser.RULE_subqueryInTransactionsRetryParameters);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1430;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 87, this._ctx)) {
                    case 1:
                        {
                            this.state = 1429;
                            this.match(CypherCmdParser.FOR);
                        }
                        break;
                }
                this.state = 1432;
                this.expression();
                this.state = 1433;
                this.secondsToken();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    subqueryInTransactionsReportParameters() {
        let localctx = new SubqueryInTransactionsReportParametersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 174, CypherCmdParser.RULE_subqueryInTransactionsReportParameters);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1435;
                this.match(CypherCmdParser.REPORT);
                this.state = 1436;
                this.match(CypherCmdParser.STATUS);
                this.state = 1437;
                this.match(CypherCmdParser.AS);
                this.state = 1438;
                this.variable();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderBySkipLimitClause() {
        let localctx = new OrderBySkipLimitClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 176, CypherCmdParser.RULE_orderBySkipLimitClause);
        try {
            this.state = 1452;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 218:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1440;
                        this.orderBy();
                        this.state = 1442;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 88, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1441;
                                    this.skip();
                                }
                                break;
                        }
                        this.state = 1445;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 89, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1444;
                                    this.limit();
                                }
                                break;
                        }
                    }
                    break;
                case 211:
                case 288:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1447;
                        this.skip();
                        this.state = 1449;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 90, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1448;
                                    this.limit();
                                }
                                break;
                        }
                    }
                    break;
                case 175:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1451;
                        this.limit();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    patternList() {
        let localctx = new PatternListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 178, CypherCmdParser.RULE_patternList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1454;
                this.pattern();
                this.state = 1459;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1455;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1456;
                            this.pattern();
                        }
                    }
                    this.state = 1461;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertPatternList() {
        let localctx = new InsertPatternListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 180, CypherCmdParser.RULE_insertPatternList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1462;
                this.insertPattern();
                this.state = 1467;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 1463;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 1464;
                            this.insertPattern();
                        }
                    }
                    this.state = 1469;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    pattern() {
        let localctx = new PatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 182, CypherCmdParser.RULE_pattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1473;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 94, this._ctx)) {
                    case 1:
                        {
                            this.state = 1470;
                            this.variable();
                            this.state = 1471;
                            this.match(CypherCmdParser.EQ);
                        }
                        break;
                }
                this.state = 1476;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 33 || _la === 37 || _la === 284) {
                    {
                        this.state = 1475;
                        this.selector();
                    }
                }
                this.state = 1478;
                this.anonymousPattern();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertPattern() {
        let localctx = new InsertPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 184, CypherCmdParser.RULE_insertPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1483;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 1480;
                        this.symbolicNameString();
                        this.state = 1481;
                        this.match(CypherCmdParser.EQ);
                    }
                }
                this.state = 1485;
                this.insertNodePattern();
                this.state = 1491;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 181 || _la === 186 || _la === 340 || _la === 341) {
                    {
                        {
                            this.state = 1486;
                            this.insertRelationshipPattern();
                            this.state = 1487;
                            this.insertNodePattern();
                        }
                    }
                    this.state = 1493;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    quantifier() {
        let localctx = new QuantifierContext(this, this._ctx, this.state);
        this.enterRule(localctx, 186, CypherCmdParser.RULE_quantifier);
        let _la;
        try {
            this.state = 1508;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 100, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1494;
                        this.match(CypherCmdParser.LCURLY);
                        this.state = 1495;
                        this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                        this.state = 1496;
                        this.match(CypherCmdParser.RCURLY);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1497;
                        this.match(CypherCmdParser.LCURLY);
                        this.state = 1499;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 19) {
                            {
                                this.state = 1498;
                                localctx._from_ = this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                            }
                        }
                        this.state = 1501;
                        this.match(CypherCmdParser.COMMA);
                        this.state = 1503;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 19) {
                            {
                                this.state = 1502;
                                localctx._to = this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                            }
                        }
                        this.state = 1505;
                        this.match(CypherCmdParser.RCURLY);
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1506;
                        this.match(CypherCmdParser.PLUS);
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1507;
                        this.match(CypherCmdParser.TIMES);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    anonymousPattern() {
        let localctx = new AnonymousPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 188, CypherCmdParser.RULE_anonymousPattern);
        try {
            this.state = 1512;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 32:
                case 283:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1510;
                        this.shortestPathPattern();
                    }
                    break;
                case 180:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1511;
                        this.patternElement();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    shortestPathPattern() {
        let localctx = new ShortestPathPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 190, CypherCmdParser.RULE_shortestPathPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1514;
                _la = this._input.LA(1);
                if (!(_la === 32 || _la === 283)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1515;
                this.match(CypherCmdParser.LPAREN);
                this.state = 1516;
                this.patternElement();
                this.state = 1517;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    patternElement() {
        let localctx = new PatternElementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 192, CypherCmdParser.RULE_patternElement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1532;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        this.state = 1532;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 104, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1519;
                                    this.nodePattern();
                                    this.state = 1528;
                                    this._errHandler.sync(this);
                                    _la = this._input.LA(1);
                                    while (_la === 181 || _la === 186 || _la === 340 || _la === 341) {
                                        {
                                            {
                                                this.state = 1520;
                                                this.relationshipPattern();
                                                this.state = 1522;
                                                this._errHandler.sync(this);
                                                _la = this._input.LA(1);
                                                if (_la === 171 || _la === 224 || _la === 301) {
                                                    {
                                                        this.state = 1521;
                                                        this.quantifier();
                                                    }
                                                }
                                                this.state = 1524;
                                                this.nodePattern();
                                            }
                                        }
                                        this.state = 1530;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                    }
                                }
                                break;
                            case 2:
                                {
                                    this.state = 1531;
                                    this.parenthesizedPath();
                                }
                                break;
                        }
                    }
                    this.state = 1534;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 180);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    selector() {
        let localctx = new SelectorContext(this, this._ctx, this.state);
        this.enterRule(localctx, 194, CypherCmdParser.RULE_selector);
        let _la;
        try {
            this.state = 1570;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 114, this._ctx)) {
                case 1:
                    localctx = new AnyShortestPathContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1536;
                        this.match(CypherCmdParser.ANY);
                        this.state = 1537;
                        this.match(CypherCmdParser.SHORTEST);
                        this.state = 1539;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 221 || _la === 222) {
                            {
                                this.state = 1538;
                                this.pathToken();
                            }
                        }
                    }
                    break;
                case 2:
                    localctx = new AllShortestPathContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1541;
                        this.match(CypherCmdParser.ALL);
                        this.state = 1542;
                        this.match(CypherCmdParser.SHORTEST);
                        this.state = 1544;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 221 || _la === 222) {
                            {
                                this.state = 1543;
                                this.pathToken();
                            }
                        }
                    }
                    break;
                case 3:
                    localctx = new AnyPathContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1546;
                        this.match(CypherCmdParser.ANY);
                        this.state = 1548;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 19 || _la === 92) {
                            {
                                this.state = 1547;
                                this.nonNegativeIntegerSpecification();
                            }
                        }
                        this.state = 1551;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 221 || _la === 222) {
                            {
                                this.state = 1550;
                                this.pathToken();
                            }
                        }
                    }
                    break;
                case 4:
                    localctx = new AllPathContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1553;
                        this.match(CypherCmdParser.ALL);
                        this.state = 1555;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 221 || _la === 222) {
                            {
                                this.state = 1554;
                                this.pathToken();
                            }
                        }
                    }
                    break;
                case 5:
                    localctx = new ShortestGroupContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 1557;
                        this.match(CypherCmdParser.SHORTEST);
                        this.state = 1559;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 19 || _la === 92) {
                            {
                                this.state = 1558;
                                this.nonNegativeIntegerSpecification();
                            }
                        }
                        this.state = 1562;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 221 || _la === 222) {
                            {
                                this.state = 1561;
                                this.pathToken();
                            }
                        }
                        this.state = 1564;
                        this.groupToken();
                    }
                    break;
                case 6:
                    localctx = new AnyShortestPathContext(this, localctx);
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 1565;
                        this.match(CypherCmdParser.SHORTEST);
                        this.state = 1566;
                        this.nonNegativeIntegerSpecification();
                        this.state = 1568;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 221 || _la === 222) {
                            {
                                this.state = 1567;
                                this.pathToken();
                            }
                        }
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nonNegativeIntegerSpecification() {
        let localctx = new NonNegativeIntegerSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 196, CypherCmdParser.RULE_nonNegativeIntegerSpecification);
        try {
            this.state = 1574;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 19:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1572;
                        this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1573;
                        this.parameter("INTEGER");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    groupToken() {
        let localctx = new GroupTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 198, CypherCmdParser.RULE_groupToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1576;
                _la = this._input.LA(1);
                if (!(_la === 137 || _la === 138)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    pathToken() {
        let localctx = new PathTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 200, CypherCmdParser.RULE_pathToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1578;
                _la = this._input.LA(1);
                if (!(_la === 221 || _la === 222)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    pathPatternNonEmpty() {
        let localctx = new PathPatternNonEmptyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 202, CypherCmdParser.RULE_pathPatternNonEmpty);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1580;
                this.nodePattern();
                this.state = 1584;
                this._errHandler.sync(this);
                _alt = 1;
                do {
                    switch (_alt) {
                        case 1:
                            {
                                {
                                    this.state = 1581;
                                    this.relationshipPattern();
                                    this.state = 1582;
                                    this.nodePattern();
                                }
                            }
                            break;
                        default:
                            throw new NoViableAltException(this);
                    }
                    this.state = 1586;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 116, this._ctx);
                } while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodePattern() {
        let localctx = new NodePatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 204, CypherCmdParser.RULE_nodePattern);
        let _la;
        try {
            this.state = 1608;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 121, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1588;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1589;
                        this.match(CypherCmdParser.WHERE);
                        this.state = 1590;
                        this.expression();
                        this.state = 1591;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1593;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1595;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 117, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1594;
                                    this.variable();
                                }
                                break;
                        }
                        this.state = 1598;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 60 || _la === 162) {
                            {
                                this.state = 1597;
                                this.labelExpression();
                            }
                        }
                        this.state = 1601;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 92 || _la === 171) {
                            {
                                this.state = 1600;
                                this.properties();
                            }
                        }
                        this.state = 1605;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 330) {
                            {
                                this.state = 1603;
                                this.match(CypherCmdParser.WHERE);
                                this.state = 1604;
                                this.expression();
                            }
                        }
                        this.state = 1607;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertNodePattern() {
        let localctx = new InsertNodePatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 206, CypherCmdParser.RULE_insertNodePattern);
        let _la;
        try {
            this.state = 1626;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 125, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1610;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1611;
                        this.match(CypherCmdParser.WHERE);
                        this.state = 1612;
                        this.expression();
                        this.state = 1613;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1615;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1617;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 122, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1616;
                                    this.variable();
                                }
                                break;
                        }
                        this.state = 1620;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 60 || _la === 162) {
                            {
                                this.state = 1619;
                                this.insertNodeLabelExpression();
                            }
                        }
                        this.state = 1623;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 171) {
                            {
                                this.state = 1622;
                                this.map();
                            }
                        }
                        this.state = 1625;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    parenthesizedPath() {
        let localctx = new ParenthesizedPathContext(this, this._ctx, this.state);
        this.enterRule(localctx, 208, CypherCmdParser.RULE_parenthesizedPath);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1628;
                this.match(CypherCmdParser.LPAREN);
                this.state = 1629;
                this.pattern();
                this.state = 1632;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330) {
                    {
                        this.state = 1630;
                        this.match(CypherCmdParser.WHERE);
                        this.state = 1631;
                        this.expression();
                    }
                }
                this.state = 1634;
                this.match(CypherCmdParser.RPAREN);
                this.state = 1636;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 171 || _la === 224 || _la === 301) {
                    {
                        this.state = 1635;
                        this.quantifier();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeLabels() {
        let localctx = new NodeLabelsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 210, CypherCmdParser.RULE_nodeLabels);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1640;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        this.state = 1640;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 128, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1638;
                                    this.labelType();
                                }
                                break;
                            case 2:
                                {
                                    this.state = 1639;
                                    this.dynamicLabelType();
                                }
                                break;
                        }
                    }
                    this.state = 1642;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 60);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeLabelsIs() {
        let localctx = new NodeLabelsIsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 212, CypherCmdParser.RULE_nodeLabelsIs);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1644;
                this.match(CypherCmdParser.IS);
                this.state = 1647;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 1645;
                            this.symbolicNameString();
                        }
                        break;
                    case 92:
                        {
                            this.state = 1646;
                            this.dynamicExpression();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 1653;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 60) {
                    {
                        this.state = 1651;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 131, this._ctx)) {
                            case 1:
                                {
                                    this.state = 1649;
                                    this.labelType();
                                }
                                break;
                            case 2:
                                {
                                    this.state = 1650;
                                    this.dynamicLabelType();
                                }
                                break;
                        }
                    }
                    this.state = 1655;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dynamicExpression() {
        let localctx = new DynamicExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 214, CypherCmdParser.RULE_dynamicExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1656;
                this.match(CypherCmdParser.DOLLAR);
                this.state = 1657;
                this.match(CypherCmdParser.LPAREN);
                this.state = 1658;
                this.expression();
                this.state = 1659;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dynamicAnyAllExpression() {
        let localctx = new DynamicAnyAllExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 216, CypherCmdParser.RULE_dynamicAnyAllExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1661;
                this.match(CypherCmdParser.DOLLAR);
                this.state = 1663;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 33 || _la === 37) {
                    {
                        this.state = 1662;
                        _la = this._input.LA(1);
                        if (!(_la === 33 || _la === 37)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 1665;
                this.match(CypherCmdParser.LPAREN);
                this.state = 1666;
                this.expression();
                this.state = 1667;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dynamicLabelType() {
        let localctx = new DynamicLabelTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 218, CypherCmdParser.RULE_dynamicLabelType);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1669;
                this.match(CypherCmdParser.COLON);
                this.state = 1670;
                this.dynamicExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelType() {
        let localctx = new LabelTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 220, CypherCmdParser.RULE_labelType);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1672;
                this.match(CypherCmdParser.COLON);
                this.state = 1673;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    relType() {
        let localctx = new RelTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 222, CypherCmdParser.RULE_relType);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1675;
                this.match(CypherCmdParser.COLON);
                this.state = 1676;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelOrRelType() {
        let localctx = new LabelOrRelTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 224, CypherCmdParser.RULE_labelOrRelType);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1678;
                this.match(CypherCmdParser.COLON);
                this.state = 1679;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    properties() {
        let localctx = new PropertiesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 226, CypherCmdParser.RULE_properties);
        try {
            this.state = 1683;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 171:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1681;
                        this.map();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1682;
                        this.parameter("ANY");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    relationshipPattern() {
        let localctx = new RelationshipPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 228, CypherCmdParser.RULE_relationshipPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1686;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 181 || _la === 341) {
                    {
                        this.state = 1685;
                        this.leftArrow();
                    }
                }
                this.state = 1688;
                this.arrowLine();
                this.state = 1712;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 141, this._ctx)) {
                    case 1:
                        {
                            this.state = 1689;
                            this.match(CypherCmdParser.LBRACKET);
                            this.state = 1690;
                            this.match(CypherCmdParser.WHERE);
                            this.state = 1691;
                            this.expression();
                            this.state = 1692;
                            this.match(CypherCmdParser.RBRACKET);
                        }
                        break;
                    case 2:
                        {
                            this.state = 1694;
                            this.match(CypherCmdParser.LBRACKET);
                            this.state = 1696;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 136, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 1695;
                                        this.variable();
                                    }
                                    break;
                            }
                            this.state = 1699;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 60 || _la === 162) {
                                {
                                    this.state = 1698;
                                    this.labelExpression();
                                }
                            }
                            this.state = 1702;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 301) {
                                {
                                    this.state = 1701;
                                    this.pathLength();
                                }
                            }
                            this.state = 1705;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 92 || _la === 171) {
                                {
                                    this.state = 1704;
                                    this.properties();
                                }
                            }
                            this.state = 1709;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330) {
                                {
                                    this.state = 1707;
                                    this.match(CypherCmdParser.WHERE);
                                    this.state = 1708;
                                    this.expression();
                                }
                            }
                            this.state = 1711;
                            this.match(CypherCmdParser.RBRACKET);
                        }
                        break;
                }
                this.state = 1714;
                this.arrowLine();
                this.state = 1716;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 139 || _la === 342) {
                    {
                        this.state = 1715;
                        this.rightArrow();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertRelationshipPattern() {
        let localctx = new InsertRelationshipPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 230, CypherCmdParser.RULE_insertRelationshipPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1719;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 181 || _la === 341) {
                    {
                        this.state = 1718;
                        this.leftArrow();
                    }
                }
                this.state = 1721;
                this.arrowLine();
                this.state = 1737;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 146, this._ctx)) {
                    case 1:
                        {
                            this.state = 1722;
                            this.match(CypherCmdParser.LBRACKET);
                            this.state = 1723;
                            this.match(CypherCmdParser.WHERE);
                            this.state = 1724;
                            this.expression();
                            this.state = 1725;
                            this.match(CypherCmdParser.RBRACKET);
                        }
                        break;
                    case 2:
                        {
                            this.state = 1727;
                            this.match(CypherCmdParser.LBRACKET);
                            this.state = 1729;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 144, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 1728;
                                        this.variable();
                                    }
                                    break;
                            }
                            this.state = 1731;
                            this.insertRelationshipLabelExpression();
                            this.state = 1733;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 171) {
                                {
                                    this.state = 1732;
                                    this.map();
                                }
                            }
                            this.state = 1735;
                            this.match(CypherCmdParser.RBRACKET);
                        }
                        break;
                }
                this.state = 1739;
                this.arrowLine();
                this.state = 1741;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 139 || _la === 342) {
                    {
                        this.state = 1740;
                        this.rightArrow();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    leftArrow() {
        let localctx = new LeftArrowContext(this, this._ctx, this.state);
        this.enterRule(localctx, 232, CypherCmdParser.RULE_leftArrow);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1743;
                _la = this._input.LA(1);
                if (!(_la === 181 || _la === 341)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    arrowLine() {
        let localctx = new ArrowLineContext(this, this._ctx, this.state);
        this.enterRule(localctx, 234, CypherCmdParser.RULE_arrowLine);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1745;
                _la = this._input.LA(1);
                if (!(_la === 186 || _la === 340)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    rightArrow() {
        let localctx = new RightArrowContext(this, this._ctx, this.state);
        this.enterRule(localctx, 236, CypherCmdParser.RULE_rightArrow);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1747;
                _la = this._input.LA(1);
                if (!(_la === 139 || _la === 342)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    pathLength() {
        let localctx = new PathLengthContext(this, this._ctx, this.state);
        this.enterRule(localctx, 238, CypherCmdParser.RULE_pathLength);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1749;
                this.match(CypherCmdParser.TIMES);
                this.state = 1758;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 150, this._ctx)) {
                    case 1:
                        {
                            this.state = 1751;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 19) {
                                {
                                    this.state = 1750;
                                    localctx._from_ = this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                                }
                            }
                            this.state = 1753;
                            this.match(CypherCmdParser.DOTDOT);
                            this.state = 1755;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 19) {
                                {
                                    this.state = 1754;
                                    localctx._to = this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                                }
                            }
                        }
                        break;
                    case 2:
                        {
                            this.state = 1757;
                            localctx._single = this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelExpression() {
        let localctx = new LabelExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 240, CypherCmdParser.RULE_labelExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1760;
                _la = this._input.LA(1);
                if (!(_la === 60 || _la === 162)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1761;
                this.labelExpression4();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelExpression4() {
        let localctx = new LabelExpression4Context(this, this._ctx, this.state);
        this.enterRule(localctx, 242, CypherCmdParser.RULE_labelExpression4);
        let _la;
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1763;
                this.labelExpression3();
                this.state = 1771;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 152, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 1764;
                                this.match(CypherCmdParser.BAR);
                                this.state = 1766;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                                if (_la === 60) {
                                    {
                                        this.state = 1765;
                                        this.match(CypherCmdParser.COLON);
                                    }
                                }
                                this.state = 1768;
                                this.labelExpression3();
                            }
                        }
                    }
                    this.state = 1773;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 152, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelExpression3() {
        let localctx = new LabelExpression3Context(this, this._ctx, this.state);
        this.enterRule(localctx, 244, CypherCmdParser.RULE_labelExpression3);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1774;
                this.labelExpression2();
                this.state = 1779;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 60 || _la === 167) {
                    {
                        {
                            this.state = 1775;
                            _la = this._input.LA(1);
                            if (!(_la === 60 || _la === 167)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 1776;
                            this.labelExpression2();
                        }
                    }
                    this.state = 1781;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelExpression2() {
        let localctx = new LabelExpression2Context(this, this._ctx, this.state);
        this.enterRule(localctx, 246, CypherCmdParser.RULE_labelExpression2);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1785;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 168) {
                    {
                        {
                            this.state = 1782;
                            this.match(CypherCmdParser.EXCLAMATION_MARK);
                        }
                    }
                    this.state = 1787;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 1788;
                this.labelExpression1();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelExpression1() {
        let localctx = new LabelExpression1Context(this, this._ctx, this.state);
        this.enterRule(localctx, 248, CypherCmdParser.RULE_labelExpression1);
        try {
            this.state = 1797;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 180:
                    localctx = new ParenthesizedLabelExpressionContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1790;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 1791;
                        this.labelExpression4();
                        this.state = 1792;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
                case 187:
                    localctx = new AnyLabelContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1794;
                        this.match(CypherCmdParser.PERCENT);
                    }
                    break;
                case 92:
                    localctx = new DynamicLabelContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1795;
                        this.dynamicAnyAllExpression();
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    localctx = new LabelNameContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1796;
                        this.symbolicNameString();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertNodeLabelExpression() {
        let localctx = new InsertNodeLabelExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 250, CypherCmdParser.RULE_insertNodeLabelExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1799;
                _la = this._input.LA(1);
                if (!(_la === 60 || _la === 162)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1800;
                this.symbolicNameString();
                this.state = 1805;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 60 || _la === 167) {
                    {
                        {
                            this.state = 1801;
                            _la = this._input.LA(1);
                            if (!(_la === 60 || _la === 167)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 1802;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 1807;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    insertRelationshipLabelExpression() {
        let localctx = new InsertRelationshipLabelExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 252, CypherCmdParser.RULE_insertRelationshipLabelExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1808;
                _la = this._input.LA(1);
                if (!(_la === 60 || _la === 162)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1809;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression() {
        let localctx = new ExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 254, CypherCmdParser.RULE_expression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1811;
                this.expression11();
                this.state = 1816;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 217) {
                    {
                        {
                            this.state = 1812;
                            this.match(CypherCmdParser.OR);
                            this.state = 1813;
                            this.expression11();
                        }
                    }
                    this.state = 1818;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression11() {
        let localctx = new Expression11Context(this, this._ctx, this.state);
        this.enterRule(localctx, 256, CypherCmdParser.RULE_expression11);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1819;
                this.expression10();
                this.state = 1824;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 334) {
                    {
                        {
                            this.state = 1820;
                            this.match(CypherCmdParser.XOR);
                            this.state = 1821;
                            this.expression10();
                        }
                    }
                    this.state = 1826;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression10() {
        let localctx = new Expression10Context(this, this._ctx, this.state);
        this.enterRule(localctx, 258, CypherCmdParser.RULE_expression10);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1827;
                this.expression9();
                this.state = 1832;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 36) {
                    {
                        {
                            this.state = 1828;
                            this.match(CypherCmdParser.AND);
                            this.state = 1829;
                            this.expression9();
                        }
                    }
                    this.state = 1834;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression9() {
        let localctx = new Expression9Context(this, this._ctx, this.state);
        this.enterRule(localctx, 260, CypherCmdParser.RULE_expression9);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1838;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 160, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 1835;
                                this.match(CypherCmdParser.NOT);
                            }
                        }
                    }
                    this.state = 1840;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 160, this._ctx);
                }
                this.state = 1841;
                this.expression8();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression8() {
        let localctx = new Expression8Context(this, this._ctx, this.state);
        this.enterRule(localctx, 262, CypherCmdParser.RULE_expression8);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1843;
                this.expression7();
                this.state = 1848;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (((((_la - 112)) & ~0x1F) === 0 && ((1 << (_la - 112)) & 136314881) !== 0) || ((((_la - 172)) & ~0x1F) === 0 && ((1 << (_la - 172)) & 393729) !== 0)) {
                    {
                        {
                            this.state = 1844;
                            _la = this._input.LA(1);
                            if (!(((((_la - 112)) & ~0x1F) === 0 && ((1 << (_la - 112)) & 136314881) !== 0) || ((((_la - 172)) & ~0x1F) === 0 && ((1 << (_la - 172)) & 393729) !== 0))) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 1845;
                            this.expression7();
                        }
                    }
                    this.state = 1850;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression7() {
        let localctx = new Expression7Context(this, this._ctx, this.state);
        this.enterRule(localctx, 264, CypherCmdParser.RULE_expression7);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1851;
                this.expression6();
                this.state = 1853;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (((((_la - 60)) & ~0x1F) === 0 && ((1 << (_la - 60)) & 515) !== 0) || _la === 111 || _la === 146 || _la === 162 || _la === 247 || _la === 290) {
                    {
                        this.state = 1852;
                        this.comparisonExpression6();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    comparisonExpression6() {
        let localctx = new ComparisonExpression6Context(this, this._ctx, this.state);
        this.enterRule(localctx, 266, CypherCmdParser.RULE_comparisonExpression6);
        let _la;
        try {
            this.state = 1888;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 169, this._ctx)) {
                case 1:
                    localctx = new StringAndListComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1862;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 247:
                                {
                                    this.state = 1855;
                                    this.match(CypherCmdParser.REGEQ);
                                }
                                break;
                            case 290:
                                {
                                    this.state = 1856;
                                    this.match(CypherCmdParser.STARTS);
                                    this.state = 1857;
                                    this.match(CypherCmdParser.WITH);
                                }
                                break;
                            case 111:
                                {
                                    this.state = 1858;
                                    this.match(CypherCmdParser.ENDS);
                                    this.state = 1859;
                                    this.match(CypherCmdParser.WITH);
                                }
                                break;
                            case 69:
                                {
                                    this.state = 1860;
                                    this.match(CypherCmdParser.CONTAINS);
                                }
                                break;
                            case 146:
                                {
                                    this.state = 1861;
                                    this.match(CypherCmdParser.IN);
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                        this.state = 1864;
                        this.expression6();
                    }
                    break;
                case 2:
                    localctx = new NullComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1865;
                        this.match(CypherCmdParser.IS);
                        this.state = 1867;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 206) {
                            {
                                this.state = 1866;
                                this.match(CypherCmdParser.NOT);
                            }
                        }
                        this.state = 1869;
                        this.match(CypherCmdParser.NULL);
                    }
                    break;
                case 3:
                    localctx = new TypeComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1876;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 162:
                                {
                                    this.state = 1870;
                                    this.match(CypherCmdParser.IS);
                                    this.state = 1872;
                                    this._errHandler.sync(this);
                                    _la = this._input.LA(1);
                                    if (_la === 206) {
                                        {
                                            this.state = 1871;
                                            this.match(CypherCmdParser.NOT);
                                        }
                                    }
                                    this.state = 1874;
                                    _la = this._input.LA(1);
                                    if (!(_la === 61 || _la === 313)) {
                                        this._errHandler.recoverInline(this);
                                    }
                                    else {
                                        this._errHandler.reportMatch(this);
                                        this.consume();
                                    }
                                }
                                break;
                            case 61:
                                {
                                    this.state = 1875;
                                    this.match(CypherCmdParser.COLONCOLON);
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                        this.state = 1878;
                        this.type_();
                    }
                    break;
                case 4:
                    localctx = new NormalFormComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1879;
                        this.match(CypherCmdParser.IS);
                        this.state = 1881;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 206) {
                            {
                                this.state = 1880;
                                this.match(CypherCmdParser.NOT);
                            }
                        }
                        this.state = 1884;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 15) !== 0)) {
                            {
                                this.state = 1883;
                                this.normalForm();
                            }
                        }
                        this.state = 1886;
                        this.match(CypherCmdParser.NORMALIZED);
                    }
                    break;
                case 5:
                    localctx = new LabelComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 1887;
                        this.labelExpression();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    normalForm() {
        let localctx = new NormalFormContext(this, this._ctx, this.state);
        this.enterRule(localctx, 268, CypherCmdParser.RULE_normalForm);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1890;
                _la = this._input.LA(1);
                if (!(((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 15) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression6() {
        let localctx = new Expression6Context(this, this._ctx, this.state);
        this.enterRule(localctx, 270, CypherCmdParser.RULE_expression6);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1892;
                this.expression5();
                this.state = 1897;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 97 || _la === 186 || _la === 224) {
                    {
                        {
                            this.state = 1893;
                            _la = this._input.LA(1);
                            if (!(_la === 97 || _la === 186 || _la === 224)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 1894;
                            this.expression5();
                        }
                    }
                    this.state = 1899;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression5() {
        let localctx = new Expression5Context(this, this._ctx, this.state);
        this.enterRule(localctx, 272, CypherCmdParser.RULE_expression5);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1900;
                this.expression4();
                this.state = 1905;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 94 || _la === 187 || _la === 301) {
                    {
                        {
                            this.state = 1901;
                            _la = this._input.LA(1);
                            if (!(_la === 94 || _la === 187 || _la === 301)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 1902;
                            this.expression4();
                        }
                    }
                    this.state = 1907;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression4() {
        let localctx = new Expression4Context(this, this._ctx, this.state);
        this.enterRule(localctx, 274, CypherCmdParser.RULE_expression4);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1908;
                this.expression3();
                this.state = 1913;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 228) {
                    {
                        {
                            this.state = 1909;
                            this.match(CypherCmdParser.POW);
                            this.state = 1910;
                            this.expression3();
                        }
                    }
                    this.state = 1915;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression3() {
        let localctx = new Expression3Context(this, this._ctx, this.state);
        this.enterRule(localctx, 276, CypherCmdParser.RULE_expression3);
        let _la;
        try {
            this.state = 1919;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 173, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1916;
                        this.expression2();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1917;
                        _la = this._input.LA(1);
                        if (!(_la === 186 || _la === 224)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 1918;
                        this.expression2();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression2() {
        let localctx = new Expression2Context(this, this._ctx, this.state);
        this.enterRule(localctx, 278, CypherCmdParser.RULE_expression2);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1921;
                this.expression1();
                this.state = 1925;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 95 || _la === 170) {
                    {
                        {
                            this.state = 1922;
                            this.postFix();
                        }
                    }
                    this.state = 1927;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    postFix() {
        let localctx = new PostFixContext(this, this._ctx, this.state);
        this.enterRule(localctx, 280, CypherCmdParser.RULE_postFix);
        let _la;
        try {
            this.state = 1942;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 177, this._ctx)) {
                case 1:
                    localctx = new PropertyPostfixContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1928;
                        this.property();
                    }
                    break;
                case 2:
                    localctx = new IndexPostfixContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1929;
                        this.match(CypherCmdParser.LBRACKET);
                        this.state = 1930;
                        this.expression();
                        this.state = 1931;
                        this.match(CypherCmdParser.RBRACKET);
                    }
                    break;
                case 3:
                    localctx = new RangePostfixContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1933;
                        this.match(CypherCmdParser.LBRACKET);
                        this.state = 1935;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294734078) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 1073741823) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3858234271) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 2147483647) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                            {
                                this.state = 1934;
                                localctx._fromExp = this.expression();
                            }
                        }
                        this.state = 1937;
                        this.match(CypherCmdParser.DOTDOT);
                        this.state = 1939;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294734078) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 1073741823) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3858234271) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 2147483647) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                            {
                                this.state = 1938;
                                localctx._toExp = this.expression();
                            }
                        }
                        this.state = 1941;
                        this.match(CypherCmdParser.RBRACKET);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    property() {
        let localctx = new PropertyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 282, CypherCmdParser.RULE_property);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1944;
                this.match(CypherCmdParser.DOT);
                this.state = 1945;
                this.propertyKeyName();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dynamicProperty() {
        let localctx = new DynamicPropertyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 284, CypherCmdParser.RULE_dynamicProperty);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1947;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 1948;
                this.expression();
                this.state = 1949;
                this.match(CypherCmdParser.RBRACKET);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyExpression() {
        let localctx = new PropertyExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 286, CypherCmdParser.RULE_propertyExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1951;
                this.expression1();
                this.state = 1953;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 1952;
                            this.property();
                        }
                    }
                    this.state = 1955;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 95);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dynamicPropertyExpression() {
        let localctx = new DynamicPropertyExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 288, CypherCmdParser.RULE_dynamicPropertyExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1957;
                this.expression1();
                this.state = 1958;
                this.dynamicProperty();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression1() {
        let localctx = new Expression1Context(this, this._ctx, this.state);
        this.enterRule(localctx, 290, CypherCmdParser.RULE_expression1);
        try {
            this.state = 1983;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 179, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1960;
                        this.literal();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1961;
                        this.parameter("ANY");
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1962;
                        this.caseExpression();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1963;
                        this.extendedCaseExpression();
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 1964;
                        this.countStar();
                    }
                    break;
                case 6:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 1965;
                        this.existsExpression();
                    }
                    break;
                case 7:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 1966;
                        this.countExpression();
                    }
                    break;
                case 8:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 1967;
                        this.collectExpression();
                    }
                    break;
                case 9:
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 1968;
                        this.mapProjection();
                    }
                    break;
                case 10:
                    this.enterOuterAlt(localctx, 10);
                    {
                        this.state = 1969;
                        this.listComprehension();
                    }
                    break;
                case 11:
                    this.enterOuterAlt(localctx, 11);
                    {
                        this.state = 1970;
                        this.listLiteral();
                    }
                    break;
                case 12:
                    this.enterOuterAlt(localctx, 12);
                    {
                        this.state = 1971;
                        this.patternComprehension();
                    }
                    break;
                case 13:
                    this.enterOuterAlt(localctx, 13);
                    {
                        this.state = 1972;
                        this.reduceExpression();
                    }
                    break;
                case 14:
                    this.enterOuterAlt(localctx, 14);
                    {
                        this.state = 1973;
                        this.allReduceExpression();
                    }
                    break;
                case 15:
                    this.enterOuterAlt(localctx, 15);
                    {
                        this.state = 1974;
                        this.listItemsPredicate();
                    }
                    break;
                case 16:
                    this.enterOuterAlt(localctx, 16);
                    {
                        this.state = 1975;
                        this.normalizeFunction();
                    }
                    break;
                case 17:
                    this.enterOuterAlt(localctx, 17);
                    {
                        this.state = 1976;
                        this.vectorFunction();
                    }
                    break;
                case 18:
                    this.enterOuterAlt(localctx, 18);
                    {
                        this.state = 1977;
                        this.trimFunction();
                    }
                    break;
                case 19:
                    this.enterOuterAlt(localctx, 19);
                    {
                        this.state = 1978;
                        this.patternExpression();
                    }
                    break;
                case 20:
                    this.enterOuterAlt(localctx, 20);
                    {
                        this.state = 1979;
                        this.shortestPathExpression();
                    }
                    break;
                case 21:
                    this.enterOuterAlt(localctx, 21);
                    {
                        this.state = 1980;
                        this.parenthesizedExpression();
                    }
                    break;
                case 22:
                    this.enterOuterAlt(localctx, 22);
                    {
                        this.state = 1981;
                        this.functionInvocation();
                    }
                    break;
                case 23:
                    this.enterOuterAlt(localctx, 23);
                    {
                        this.state = 1982;
                        this.variable();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    literal() {
        let localctx = new LiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 292, CypherCmdParser.RULE_literal);
        try {
            this.state = 1994;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 18:
                case 19:
                case 20:
                case 21:
                case 186:
                    localctx = new NummericLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 1985;
                        this.numberLiteral();
                    }
                    break;
                case 22:
                case 23:
                    localctx = new StringsLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 1986;
                        this.stringLiteral();
                    }
                    break;
                case 171:
                    localctx = new OtherLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 1987;
                        this.map();
                    }
                    break;
                case 311:
                    localctx = new BooleanLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 1988;
                        this.match(CypherCmdParser.TRUE);
                    }
                    break;
                case 120:
                    localctx = new BooleanLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 1989;
                        this.match(CypherCmdParser.FALSE);
                    }
                    break;
                case 149:
                    localctx = new KeywordLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 1990;
                        this.match(CypherCmdParser.INF);
                    }
                    break;
                case 150:
                    localctx = new KeywordLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 1991;
                        this.match(CypherCmdParser.INFINITY);
                    }
                    break;
                case 193:
                    localctx = new KeywordLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 1992;
                        this.match(CypherCmdParser.NAN);
                    }
                    break;
                case 209:
                    localctx = new KeywordLiteralContext(this, localctx);
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 1993;
                        this.match(CypherCmdParser.NULL);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseExpression() {
        let localctx = new CaseExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 294, CypherCmdParser.RULE_caseExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1996;
                this.match(CypherCmdParser.CASE);
                this.state = 1998;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 1997;
                            this.caseAlternative();
                        }
                    }
                    this.state = 2000;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 329);
                this.state = 2004;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 108) {
                    {
                        this.state = 2002;
                        this.match(CypherCmdParser.ELSE);
                        this.state = 2003;
                        this.expression();
                    }
                }
                this.state = 2006;
                this.match(CypherCmdParser.END);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseAlternative() {
        let localctx = new CaseAlternativeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 296, CypherCmdParser.RULE_caseAlternative);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2008;
                this.match(CypherCmdParser.WHEN);
                this.state = 2009;
                this.expression();
                this.state = 2010;
                this.match(CypherCmdParser.THEN);
                this.state = 2011;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    extendedCaseExpression() {
        let localctx = new ExtendedCaseExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 298, CypherCmdParser.RULE_extendedCaseExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2013;
                this.match(CypherCmdParser.CASE);
                this.state = 2014;
                this.expression();
                this.state = 2016;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 2015;
                            this.extendedCaseAlternative();
                        }
                    }
                    this.state = 2018;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 329);
                this.state = 2022;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 108) {
                    {
                        this.state = 2020;
                        this.match(CypherCmdParser.ELSE);
                        this.state = 2021;
                        localctx._elseExp = this.expression();
                    }
                }
                this.state = 2024;
                this.match(CypherCmdParser.END);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    extendedCaseAlternative() {
        let localctx = new ExtendedCaseAlternativeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 300, CypherCmdParser.RULE_extendedCaseAlternative);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2026;
                this.match(CypherCmdParser.WHEN);
                this.state = 2027;
                this.extendedWhen();
                this.state = 2032;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 2028;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 2029;
                            this.extendedWhen();
                        }
                    }
                    this.state = 2034;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 2035;
                this.match(CypherCmdParser.THEN);
                this.state = 2036;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    extendedWhen() {
        let localctx = new ExtendedWhenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 302, CypherCmdParser.RULE_extendedWhen);
        let _la;
        try {
            this.state = 2042;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 186, this._ctx)) {
                case 1:
                    localctx = new WhenSimpleComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2038;
                        _la = this._input.LA(1);
                        if (!(((((_la - 112)) & ~0x1F) === 0 && ((1 << (_la - 112)) & 136314881) !== 0) || ((((_la - 172)) & ~0x1F) === 0 && ((1 << (_la - 172)) & 393729) !== 0))) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 2039;
                        this.expression7();
                    }
                    break;
                case 2:
                    localctx = new WhenAdvancedComparisonContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2040;
                        this.comparisonExpression6();
                    }
                    break;
                case 3:
                    localctx = new WhenEqualsContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2041;
                        this.expression();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    listComprehension() {
        let localctx = new ListComprehensionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 304, CypherCmdParser.RULE_listComprehension);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2044;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2045;
                this.variable();
                this.state = 2046;
                this.match(CypherCmdParser.IN);
                this.state = 2047;
                this.expression();
                this.state = 2058;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 189, this._ctx)) {
                    case 1:
                        {
                            this.state = 2050;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330) {
                                {
                                    this.state = 2048;
                                    this.match(CypherCmdParser.WHERE);
                                    this.state = 2049;
                                    localctx._whereExp = this.expression();
                                }
                            }
                            this.state = 2052;
                            this.match(CypherCmdParser.BAR);
                            this.state = 2053;
                            localctx._barExp = this.expression();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2056;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330) {
                                {
                                    this.state = 2054;
                                    this.match(CypherCmdParser.WHERE);
                                    this.state = 2055;
                                    localctx._whereExp = this.expression();
                                }
                            }
                        }
                        break;
                }
                this.state = 2060;
                this.match(CypherCmdParser.RBRACKET);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    patternComprehension() {
        let localctx = new PatternComprehensionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 306, CypherCmdParser.RULE_patternComprehension);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2062;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2066;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 2063;
                        this.variable();
                        this.state = 2064;
                        this.match(CypherCmdParser.EQ);
                    }
                }
                this.state = 2068;
                this.pathPatternNonEmpty();
                this.state = 2071;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330) {
                    {
                        this.state = 2069;
                        this.match(CypherCmdParser.WHERE);
                        this.state = 2070;
                        localctx._whereExp = this.expression();
                    }
                }
                this.state = 2073;
                this.match(CypherCmdParser.BAR);
                this.state = 2074;
                localctx._barExp = this.expression();
                this.state = 2075;
                this.match(CypherCmdParser.RBRACKET);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    reduceExpression() {
        let localctx = new ReduceExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 308, CypherCmdParser.RULE_reduceExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2077;
                this.match(CypherCmdParser.REDUCE);
                this.state = 2078;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2079;
                this.variable();
                this.state = 2080;
                this.match(CypherCmdParser.EQ);
                this.state = 2081;
                this.expression();
                this.state = 2082;
                this.match(CypherCmdParser.COMMA);
                this.state = 2083;
                this.variable();
                this.state = 2084;
                this.match(CypherCmdParser.IN);
                this.state = 2085;
                this.expression();
                this.state = 2086;
                this.match(CypherCmdParser.BAR);
                this.state = 2087;
                this.expression();
                this.state = 2088;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    allReduceExpression() {
        let localctx = new AllReduceExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 310, CypherCmdParser.RULE_allReduceExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2090;
                this.match(CypherCmdParser.ALLREDUCE);
                this.state = 2091;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2092;
                this.variable();
                this.state = 2093;
                this.match(CypherCmdParser.EQ);
                this.state = 2094;
                this.expression();
                this.state = 2095;
                this.match(CypherCmdParser.COMMA);
                this.state = 2096;
                this.expression();
                this.state = 2097;
                this.match(CypherCmdParser.COMMA);
                this.state = 2098;
                this.expression();
                this.state = 2099;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    listItemsPredicate() {
        let localctx = new ListItemsPredicateContext(this, this._ctx, this.state);
        this.enterRule(localctx, 312, CypherCmdParser.RULE_listItemsPredicate);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2101;
                _la = this._input.LA(1);
                if (!(_la === 33 || _la === 37 || _la === 203 || _la === 287)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 2102;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2103;
                this.variable();
                this.state = 2104;
                this.match(CypherCmdParser.IN);
                this.state = 2105;
                localctx._inExp = this.expression();
                this.state = 2108;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330) {
                    {
                        this.state = 2106;
                        this.match(CypherCmdParser.WHERE);
                        this.state = 2107;
                        localctx._whereExp = this.expression();
                    }
                }
                this.state = 2110;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    normalizeFunction() {
        let localctx = new NormalizeFunctionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 314, CypherCmdParser.RULE_normalizeFunction);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2112;
                this.match(CypherCmdParser.NORMALIZE);
                this.state = 2113;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2114;
                this.expression();
                this.state = 2117;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 62) {
                    {
                        this.state = 2115;
                        this.match(CypherCmdParser.COMMA);
                        this.state = 2116;
                        this.normalForm();
                    }
                }
                this.state = 2119;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    vectorFunction() {
        let localctx = new VectorFunctionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 316, CypherCmdParser.RULE_vectorFunction);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2121;
                this.match(CypherCmdParser.VECTOR);
                this.state = 2122;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2123;
                localctx._vectorValue = this.expression();
                this.state = 2124;
                this.match(CypherCmdParser.COMMA);
                this.state = 2125;
                localctx._dimension = this.expression();
                this.state = 2126;
                this.match(CypherCmdParser.COMMA);
                this.state = 2127;
                this.vectorCoordinateType();
                this.state = 2128;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    trimFunction() {
        let localctx = new TrimFunctionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 318, CypherCmdParser.RULE_trimFunction);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2130;
                this.match(CypherCmdParser.TRIM);
                this.state = 2131;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2139;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 196, this._ctx)) {
                    case 1:
                        {
                            this.state = 2133;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 194, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 2132;
                                        _la = this._input.LA(1);
                                        if (!(_la === 50 || _la === 173 || _la === 306)) {
                                            this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                    }
                                    break;
                            }
                            this.state = 2136;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 195, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 2135;
                                        localctx._trimCharacterString = this.expression();
                                    }
                                    break;
                            }
                            this.state = 2138;
                            this.match(CypherCmdParser.FROM);
                        }
                        break;
                }
                this.state = 2141;
                localctx._trimSource = this.expression();
                this.state = 2142;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    patternExpression() {
        let localctx = new PatternExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 320, CypherCmdParser.RULE_patternExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2144;
                this.pathPatternNonEmpty();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    shortestPathExpression() {
        let localctx = new ShortestPathExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 322, CypherCmdParser.RULE_shortestPathExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2146;
                this.shortestPathPattern();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    parenthesizedExpression() {
        let localctx = new ParenthesizedExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 324, CypherCmdParser.RULE_parenthesizedExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2148;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2149;
                this.expression();
                this.state = 2150;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    mapProjection() {
        let localctx = new MapProjectionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 326, CypherCmdParser.RULE_mapProjection);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2152;
                this.variable();
                this.state = 2153;
                this.match(CypherCmdParser.LCURLY);
                this.state = 2162;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 2952790015) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 2154;
                        this.mapProjectionElement();
                        this.state = 2159;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 62) {
                            {
                                {
                                    this.state = 2155;
                                    this.match(CypherCmdParser.COMMA);
                                    this.state = 2156;
                                    this.mapProjectionElement();
                                }
                            }
                            this.state = 2161;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 2164;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    mapProjectionElement() {
        let localctx = new MapProjectionElementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 328, CypherCmdParser.RULE_mapProjectionElement);
        try {
            this.state = 2174;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 199, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2166;
                        this.propertyKeyName();
                        this.state = 2167;
                        this.match(CypherCmdParser.COLON);
                        this.state = 2168;
                        this.expression();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2170;
                        this.property();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2171;
                        this.variable();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 2172;
                        this.match(CypherCmdParser.DOT);
                        this.state = 2173;
                        this.match(CypherCmdParser.TIMES);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    countStar() {
        let localctx = new CountStarContext(this, this._ctx, this.state);
        this.enterRule(localctx, 330, CypherCmdParser.RULE_countStar);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2176;
                this.match(CypherCmdParser.COUNT);
                this.state = 2177;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2178;
                this.match(CypherCmdParser.TIMES);
                this.state = 2179;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    existsExpression() {
        let localctx = new ExistsExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 332, CypherCmdParser.RULE_existsExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2181;
                this.match(CypherCmdParser.EXISTS);
                this.state = 2182;
                this.match(CypherCmdParser.LCURLY);
                this.state = 2191;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 202, this._ctx)) {
                    case 1:
                        {
                            this.state = 2183;
                            this.nextStatement();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2185;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 200, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 2184;
                                        this.matchMode();
                                    }
                                    break;
                            }
                            this.state = 2187;
                            this.patternList();
                            this.state = 2189;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330) {
                                {
                                    this.state = 2188;
                                    this.whereClause();
                                }
                            }
                        }
                        break;
                }
                this.state = 2193;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    countExpression() {
        let localctx = new CountExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 334, CypherCmdParser.RULE_countExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2195;
                this.match(CypherCmdParser.COUNT);
                this.state = 2196;
                this.match(CypherCmdParser.LCURLY);
                this.state = 2205;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 205, this._ctx)) {
                    case 1:
                        {
                            this.state = 2197;
                            this.nextStatement();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2199;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 203, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 2198;
                                        this.matchMode();
                                    }
                                    break;
                            }
                            this.state = 2201;
                            this.patternList();
                            this.state = 2203;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330) {
                                {
                                    this.state = 2202;
                                    this.whereClause();
                                }
                            }
                        }
                        break;
                }
                this.state = 2207;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    collectExpression() {
        let localctx = new CollectExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 336, CypherCmdParser.RULE_collectExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2209;
                this.match(CypherCmdParser.COLLECT);
                this.state = 2210;
                this.match(CypherCmdParser.LCURLY);
                this.state = 2211;
                this.nextStatement();
                this.state = 2212;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    numberLiteral() {
        let localctx = new NumberLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 338, CypherCmdParser.RULE_numberLiteral);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2215;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 186) {
                    {
                        this.state = 2214;
                        this.match(CypherCmdParser.MINUS);
                    }
                }
                this.state = 2217;
                _la = this._input.LA(1);
                if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & 3932160) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    signedIntegerLiteral() {
        let localctx = new SignedIntegerLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 340, CypherCmdParser.RULE_signedIntegerLiteral);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2220;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 186) {
                    {
                        this.state = 2219;
                        this.match(CypherCmdParser.MINUS);
                    }
                }
                this.state = 2222;
                this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    listLiteral() {
        let localctx = new ListLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 342, CypherCmdParser.RULE_listLiteral);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2224;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2233;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294734078) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 1073741823) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3858234271) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 2147483647) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 2225;
                        this.expression();
                        this.state = 2230;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 62) {
                            {
                                {
                                    this.state = 2226;
                                    this.match(CypherCmdParser.COMMA);
                                    this.state = 2227;
                                    this.expression();
                                }
                            }
                            this.state = 2232;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 2235;
                this.match(CypherCmdParser.RBRACKET);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyKeyName() {
        let localctx = new PropertyKeyNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 344, CypherCmdParser.RULE_propertyKeyName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2237;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    parameter(paramType) {
        let localctx = new ParameterContext(this, this._ctx, this.state, paramType);
        this.enterRule(localctx, 346, CypherCmdParser.RULE_parameter);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2239;
                this.match(CypherCmdParser.DOLLAR);
                this.state = 2240;
                this.parameterName(paramType);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    parameterName(paramType) {
        let localctx = new ParameterNameContext(this, this._ctx, this.state, paramType);
        this.enterRule(localctx, 348, CypherCmdParser.RULE_parameterName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2246;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 2242;
                            this.symbolicNameString();
                        }
                        break;
                    case 19:
                        {
                            this.state = 2243;
                            this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                        }
                        break;
                    case 21:
                        {
                            this.state = 2244;
                            this.match(CypherCmdParser.UNSIGNED_OCTAL_INTEGER);
                        }
                        break;
                    case 339:
                        {
                            this.state = 2245;
                            this.match(CypherCmdParser.EXTENDED_IDENTIFIER);
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionInvocation() {
        let localctx = new FunctionInvocationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 350, CypherCmdParser.RULE_functionInvocation);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2248;
                this.functionName();
                this.state = 2249;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2251;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 211, this._ctx)) {
                    case 1:
                        {
                            this.state = 2250;
                            _la = this._input.LA(1);
                            if (!(_la === 33 || _la === 93)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        }
                        break;
                }
                this.state = 2261;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4294734078) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 1073741823) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3858234271) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 2147483647) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 2253;
                        this.functionArgument();
                        this.state = 2258;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 62) {
                            {
                                {
                                    this.state = 2254;
                                    this.match(CypherCmdParser.COMMA);
                                    this.state = 2255;
                                    this.functionArgument();
                                }
                            }
                            this.state = 2260;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 2263;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionArgument() {
        let localctx = new FunctionArgumentContext(this, this._ctx, this.state);
        this.enterRule(localctx, 352, CypherCmdParser.RULE_functionArgument);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2265;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionName() {
        let localctx = new FunctionNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 354, CypherCmdParser.RULE_functionName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2267;
                this.namespace();
                this.state = 2268;
                this.symbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    namespace() {
        let localctx = new NamespaceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 356, CypherCmdParser.RULE_namespace);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2275;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 214, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 2270;
                                this.symbolicNameString();
                                this.state = 2271;
                                this.match(CypherCmdParser.DOT);
                            }
                        }
                    }
                    this.state = 2277;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 214, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    variable() {
        let localctx = new VariableContext(this, this._ctx, this.state);
        this.enterRule(localctx, 358, CypherCmdParser.RULE_variable);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2278;
                this.symbolicVariableNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nonEmptyNameList() {
        let localctx = new NonEmptyNameListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 360, CypherCmdParser.RULE_nonEmptyNameList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2280;
                this.symbolicNameString();
                this.state = 2285;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 2281;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 2282;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 2287;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    type_() {
        let localctx = new TypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 362, CypherCmdParser.RULE_type);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2288;
                this.typePart();
                this.state = 2293;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 216, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 2289;
                                this.match(CypherCmdParser.BAR);
                                this.state = 2290;
                                this.typePart();
                            }
                        }
                    }
                    this.state = 2295;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 216, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    typePart() {
        let localctx = new TypePartContext(this, this._ctx, this.state);
        this.enterRule(localctx, 364, CypherCmdParser.RULE_typePart);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2296;
                this.typeName();
                this.state = 2298;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 168 || _la === 206) {
                    {
                        this.state = 2297;
                        this.typeNullability();
                    }
                }
                this.state = 2303;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 38 || _la === 176) {
                    {
                        {
                            this.state = 2300;
                            this.typeListSuffix();
                        }
                    }
                    this.state = 2305;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    typeName() {
        let localctx = new TypeNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 366, CypherCmdParser.RULE_typeName);
        let _la;
        try {
            this.state = 2394;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 226, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2306;
                        this.match(CypherCmdParser.NOTHING);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2307;
                        this.match(CypherCmdParser.NULL);
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2308;
                        this.match(CypherCmdParser.BOOL);
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 2309;
                        this.match(CypherCmdParser.BOOLEAN);
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 2310;
                        this.match(CypherCmdParser.VARCHAR);
                    }
                    break;
                case 6:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 2311;
                        this.match(CypherCmdParser.STRING);
                    }
                    break;
                case 7:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 2312;
                        this.match(CypherCmdParser.INT);
                    }
                    break;
                case 8:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 2314;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 286) {
                            {
                                this.state = 2313;
                                this.match(CypherCmdParser.SIGNED);
                            }
                        }
                        this.state = 2316;
                        this.match(CypherCmdParser.INTEGER);
                    }
                    break;
                case 9:
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 2317;
                        this.match(CypherCmdParser.INTEGER64);
                    }
                    break;
                case 10:
                    this.enterOuterAlt(localctx, 10);
                    {
                        this.state = 2318;
                        this.match(CypherCmdParser.INT64);
                    }
                    break;
                case 11:
                    this.enterOuterAlt(localctx, 11);
                    {
                        this.state = 2319;
                        this.match(CypherCmdParser.FLOAT);
                    }
                    break;
                case 12:
                    this.enterOuterAlt(localctx, 12);
                    {
                        this.state = 2320;
                        this.match(CypherCmdParser.FLOAT64);
                    }
                    break;
                case 13:
                    this.enterOuterAlt(localctx, 13);
                    {
                        this.state = 2321;
                        this.match(CypherCmdParser.DATE);
                    }
                    break;
                case 14:
                    this.enterOuterAlt(localctx, 14);
                    {
                        this.state = 2322;
                        this.match(CypherCmdParser.LOCAL);
                        this.state = 2323;
                        _la = this._input.LA(1);
                        if (!(_la === 80 || _la === 300)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                    break;
                case 15:
                    this.enterOuterAlt(localctx, 15);
                    {
                        this.state = 2324;
                        this.match(CypherCmdParser.ZONED);
                        this.state = 2325;
                        _la = this._input.LA(1);
                        if (!(_la === 80 || _la === 300)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                    break;
                case 16:
                    this.enterOuterAlt(localctx, 16);
                    {
                        this.state = 2326;
                        this.match(CypherCmdParser.TIME);
                        this.state = 2327;
                        _la = this._input.LA(1);
                        if (!(_la === 331 || _la === 332)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 2331;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 303:
                                {
                                    this.state = 2328;
                                    this.match(CypherCmdParser.TIMEZONE);
                                }
                                break;
                            case 300:
                                {
                                    this.state = 2329;
                                    this.match(CypherCmdParser.TIME);
                                    this.state = 2330;
                                    this.match(CypherCmdParser.ZONE);
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                case 17:
                    this.enterOuterAlt(localctx, 17);
                    {
                        this.state = 2333;
                        this.match(CypherCmdParser.TIMESTAMP);
                        this.state = 2334;
                        _la = this._input.LA(1);
                        if (!(_la === 331 || _la === 332)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 2338;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 303:
                                {
                                    this.state = 2335;
                                    this.match(CypherCmdParser.TIMEZONE);
                                }
                                break;
                            case 300:
                                {
                                    this.state = 2336;
                                    this.match(CypherCmdParser.TIME);
                                    this.state = 2337;
                                    this.match(CypherCmdParser.ZONE);
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                case 18:
                    this.enterOuterAlt(localctx, 18);
                    {
                        this.state = 2340;
                        this.match(CypherCmdParser.DURATION);
                    }
                    break;
                case 19:
                    this.enterOuterAlt(localctx, 19);
                    {
                        this.state = 2341;
                        this.match(CypherCmdParser.POINT);
                    }
                    break;
                case 20:
                    this.enterOuterAlt(localctx, 20);
                    {
                        this.state = 2342;
                        this.match(CypherCmdParser.NODE);
                    }
                    break;
                case 21:
                    this.enterOuterAlt(localctx, 21);
                    {
                        this.state = 2343;
                        this.match(CypherCmdParser.VECTOR);
                        this.state = 2344;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 2345;
                        this.signedIntegerLiteral();
                        this.state = 2346;
                        this.match(CypherCmdParser.COMMA);
                        this.state = 2347;
                        this.vectorCoordinateType();
                        this.state = 2348;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
                case 22:
                    this.enterOuterAlt(localctx, 22);
                    {
                        this.state = 2350;
                        this.match(CypherCmdParser.VECTOR);
                        this.state = 2355;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 222, this._ctx)) {
                            case 1:
                                {
                                    this.state = 2351;
                                    this.match(CypherCmdParser.LT);
                                    this.state = 2352;
                                    this.vectorCoordinateType();
                                    this.state = 2353;
                                    this.match(CypherCmdParser.GT);
                                }
                                break;
                        }
                        this.state = 2361;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 180) {
                            {
                                this.state = 2357;
                                this.match(CypherCmdParser.LPAREN);
                                this.state = 2358;
                                this.signedIntegerLiteral();
                                this.state = 2359;
                                this.match(CypherCmdParser.RPAREN);
                            }
                        }
                    }
                    break;
                case 23:
                    this.enterOuterAlt(localctx, 23);
                    {
                        this.state = 2363;
                        this.match(CypherCmdParser.VERTEX);
                    }
                    break;
                case 24:
                    this.enterOuterAlt(localctx, 24);
                    {
                        this.state = 2364;
                        this.match(CypherCmdParser.RELATIONSHIP);
                    }
                    break;
                case 25:
                    this.enterOuterAlt(localctx, 25);
                    {
                        this.state = 2365;
                        this.match(CypherCmdParser.EDGE);
                    }
                    break;
                case 26:
                    this.enterOuterAlt(localctx, 26);
                    {
                        this.state = 2366;
                        this.match(CypherCmdParser.MAP);
                    }
                    break;
                case 27:
                    this.enterOuterAlt(localctx, 27);
                    {
                        this.state = 2367;
                        _la = this._input.LA(1);
                        if (!(_la === 38 || _la === 176)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 2368;
                        this.match(CypherCmdParser.LT);
                        this.state = 2369;
                        this.type_();
                        this.state = 2370;
                        this.match(CypherCmdParser.GT);
                    }
                    break;
                case 28:
                    this.enterOuterAlt(localctx, 28);
                    {
                        this.state = 2372;
                        this.match(CypherCmdParser.PATH);
                    }
                    break;
                case 29:
                    this.enterOuterAlt(localctx, 29);
                    {
                        this.state = 2373;
                        this.match(CypherCmdParser.PATHS);
                    }
                    break;
                case 30:
                    this.enterOuterAlt(localctx, 30);
                    {
                        this.state = 2374;
                        this.match(CypherCmdParser.PROPERTY);
                        this.state = 2375;
                        this.match(CypherCmdParser.VALUE);
                    }
                    break;
                case 31:
                    this.enterOuterAlt(localctx, 31);
                    {
                        this.state = 2376;
                        this.match(CypherCmdParser.ANY);
                        this.state = 2392;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 225, this._ctx)) {
                            case 1:
                                {
                                    this.state = 2377;
                                    this.match(CypherCmdParser.NODE);
                                }
                                break;
                            case 2:
                                {
                                    this.state = 2378;
                                    this.match(CypherCmdParser.VERTEX);
                                }
                                break;
                            case 3:
                                {
                                    this.state = 2379;
                                    this.match(CypherCmdParser.RELATIONSHIP);
                                }
                                break;
                            case 4:
                                {
                                    this.state = 2380;
                                    this.match(CypherCmdParser.EDGE);
                                }
                                break;
                            case 5:
                                {
                                    this.state = 2381;
                                    this.match(CypherCmdParser.MAP);
                                }
                                break;
                            case 6:
                                {
                                    this.state = 2382;
                                    this.match(CypherCmdParser.PROPERTY);
                                    this.state = 2383;
                                    this.match(CypherCmdParser.VALUE);
                                }
                                break;
                            case 7:
                                {
                                    this.state = 2385;
                                    this._errHandler.sync(this);
                                    _la = this._input.LA(1);
                                    if (_la === 324) {
                                        {
                                            this.state = 2384;
                                            this.match(CypherCmdParser.VALUE);
                                        }
                                    }
                                    this.state = 2387;
                                    this.match(CypherCmdParser.LT);
                                    this.state = 2388;
                                    this.type_();
                                    this.state = 2389;
                                    this.match(CypherCmdParser.GT);
                                }
                                break;
                            case 8:
                                {
                                    this.state = 2391;
                                    this.match(CypherCmdParser.VALUE);
                                }
                                break;
                        }
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    typeNullability() {
        let localctx = new TypeNullabilityContext(this, this._ctx, this.state);
        this.enterRule(localctx, 368, CypherCmdParser.RULE_typeNullability);
        try {
            this.state = 2399;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 206:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2396;
                        this.match(CypherCmdParser.NOT);
                        this.state = 2397;
                        this.match(CypherCmdParser.NULL);
                    }
                    break;
                case 168:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2398;
                        this.match(CypherCmdParser.EXCLAMATION_MARK);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    typeListSuffix() {
        let localctx = new TypeListSuffixContext(this, this._ctx, this.state);
        this.enterRule(localctx, 370, CypherCmdParser.RULE_typeListSuffix);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2401;
                _la = this._input.LA(1);
                if (!(_la === 38 || _la === 176)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 2403;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 168 || _la === 206) {
                    {
                        this.state = 2402;
                        this.typeNullability();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    vectorCoordinateType() {
        let localctx = new VectorCoordinateTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 372, CypherCmdParser.RULE_vectorCoordinateType);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2421;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 152:
                        {
                            this.state = 2405;
                            this.match(CypherCmdParser.INT);
                        }
                        break;
                    case 157:
                    case 286:
                        {
                            this.state = 2407;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 286) {
                                {
                                    this.state = 2406;
                                    this.match(CypherCmdParser.SIGNED);
                                }
                            }
                            this.state = 2409;
                            this.match(CypherCmdParser.INTEGER);
                        }
                        break;
                    case 158:
                        {
                            this.state = 2410;
                            this.match(CypherCmdParser.INTEGER64);
                        }
                        break;
                    case 159:
                        {
                            this.state = 2411;
                            this.match(CypherCmdParser.INTEGER32);
                        }
                        break;
                    case 160:
                        {
                            this.state = 2412;
                            this.match(CypherCmdParser.INTEGER16);
                        }
                        break;
                    case 161:
                        {
                            this.state = 2413;
                            this.match(CypherCmdParser.INTEGER8);
                        }
                        break;
                    case 153:
                        {
                            this.state = 2414;
                            this.match(CypherCmdParser.INT64);
                        }
                        break;
                    case 154:
                        {
                            this.state = 2415;
                            this.match(CypherCmdParser.INT32);
                        }
                        break;
                    case 155:
                        {
                            this.state = 2416;
                            this.match(CypherCmdParser.INT16);
                        }
                        break;
                    case 156:
                        {
                            this.state = 2417;
                            this.match(CypherCmdParser.INT8);
                        }
                        break;
                    case 124:
                        {
                            this.state = 2418;
                            this.match(CypherCmdParser.FLOAT);
                        }
                        break;
                    case 125:
                        {
                            this.state = 2419;
                            this.match(CypherCmdParser.FLOAT64);
                        }
                        break;
                    case 126:
                        {
                            this.state = 2420;
                            this.match(CypherCmdParser.FLOAT32);
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 2424;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 168 || _la === 206) {
                    {
                        this.state = 2423;
                        this.typeNullability();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    command() {
        let localctx = new CommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 374, CypherCmdParser.RULE_command);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2427;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 320) {
                    {
                        this.state = 2426;
                        this.useClause();
                    }
                }
                this.state = 2442;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 73:
                        {
                            this.state = 2429;
                            this.createCommand();
                        }
                        break;
                    case 99:
                        {
                            this.state = 2430;
                            this.dropCommand();
                        }
                        break;
                    case 35:
                        {
                            this.state = 2431;
                            this.alterCommand();
                        }
                        break;
                    case 246:
                        {
                            this.state = 2432;
                            this.renameCommand();
                        }
                        break;
                    case 86:
                        {
                            this.state = 2433;
                            this.denyCommand();
                        }
                        break;
                    case 262:
                        {
                            this.state = 2434;
                            this.revokeCommand();
                        }
                        break;
                    case 134:
                        {
                            this.state = 2435;
                            this.grantCommand();
                        }
                        break;
                    case 289:
                        {
                            this.state = 2436;
                            this.startDatabase();
                        }
                        break;
                    case 292:
                        {
                            this.state = 2437;
                            this.stopDatabase();
                        }
                        break;
                    case 105:
                        {
                            this.state = 2438;
                            this.enableServerCommand();
                        }
                        break;
                    case 82:
                    case 100:
                    case 244:
                        {
                            this.state = 2439;
                            this.allocationCommand();
                        }
                        break;
                    case 285:
                        {
                            this.state = 2440;
                            this.showCommand();
                        }
                        break;
                    case 297:
                        {
                            this.state = 2441;
                            this.terminateCommand();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createCommand() {
        let localctx = new CreateCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 376, CypherCmdParser.RULE_createCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2444;
                this.match(CypherCmdParser.CREATE);
                this.state = 2447;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 217) {
                    {
                        this.state = 2445;
                        this.match(CypherCmdParser.OR);
                        this.state = 2446;
                        this.match(CypherCmdParser.REPLACE);
                    }
                }
                this.state = 2456;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 30:
                        {
                            this.state = 2449;
                            this.createAlias();
                        }
                        break;
                    case 65:
                        {
                            this.state = 2450;
                            this.createCompositeDatabase();
                        }
                        break;
                    case 67:
                        {
                            this.state = 2451;
                            this.createConstraint();
                        }
                        break;
                    case 77:
                        {
                            this.state = 2452;
                            this.createDatabase();
                        }
                        break;
                    case 130:
                    case 147:
                    case 179:
                    case 226:
                    case 240:
                    case 298:
                    case 326:
                        {
                            this.state = 2453;
                            this.createIndex();
                        }
                        break;
                    case 145:
                    case 263:
                        {
                            this.state = 2454;
                            this.createRole();
                        }
                        break;
                    case 321:
                        {
                            this.state = 2455;
                            this.createUser();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterCommand() {
        let localctx = new AlterCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 378, CypherCmdParser.RULE_alterCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2458;
                this.match(CypherCmdParser.ALTER);
                this.state = 2465;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 236, this._ctx)) {
                    case 1:
                        {
                            this.state = 2459;
                            this.alterAlias();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2460;
                            this.alterCurrentUser();
                        }
                        break;
                    case 3:
                        {
                            this.state = 2461;
                            this.alterCurrentGraphType();
                        }
                        break;
                    case 4:
                        {
                            this.state = 2462;
                            this.alterDatabase();
                        }
                        break;
                    case 5:
                        {
                            this.state = 2463;
                            this.alterUser();
                        }
                        break;
                    case 6:
                        {
                            this.state = 2464;
                            this.alterServer();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropCommand() {
        let localctx = new DropCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 380, CypherCmdParser.RULE_dropCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2467;
                this.match(CypherCmdParser.DROP);
                this.state = 2475;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 30:
                        {
                            this.state = 2468;
                            this.dropAlias();
                        }
                        break;
                    case 67:
                        {
                            this.state = 2469;
                            this.dropConstraint();
                        }
                        break;
                    case 65:
                    case 77:
                        {
                            this.state = 2470;
                            this.dropDatabase();
                        }
                        break;
                    case 147:
                        {
                            this.state = 2471;
                            this.dropIndex();
                        }
                        break;
                    case 263:
                        {
                            this.state = 2472;
                            this.dropRole();
                        }
                        break;
                    case 276:
                        {
                            this.state = 2473;
                            this.dropServer();
                        }
                        break;
                    case 321:
                        {
                            this.state = 2474;
                            this.dropUser();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showCommand() {
        let localctx = new ShowCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 382, CypherCmdParser.RULE_showCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2477;
                this.match(CypherCmdParser.SHOW);
                this.state = 2494;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 238, this._ctx)) {
                    case 1:
                        {
                            this.state = 2478;
                            this.showAliases();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2479;
                            this.showConstraintCommand();
                        }
                        break;
                    case 3:
                        {
                            this.state = 2480;
                            this.showCurrentUser();
                        }
                        break;
                    case 4:
                        {
                            this.state = 2481;
                            this.showDatabase();
                        }
                        break;
                    case 5:
                        {
                            this.state = 2482;
                            this.showFunctions();
                        }
                        break;
                    case 6:
                        {
                            this.state = 2483;
                            this.showIndexCommand();
                        }
                        break;
                    case 7:
                        {
                            this.state = 2484;
                            this.showPrivileges();
                        }
                        break;
                    case 8:
                        {
                            this.state = 2485;
                            this.showProcedures();
                        }
                        break;
                    case 9:
                        {
                            this.state = 2486;
                            this.showRolePrivileges();
                        }
                        break;
                    case 10:
                        {
                            this.state = 2487;
                            this.showRoles();
                        }
                        break;
                    case 11:
                        {
                            this.state = 2488;
                            this.showServers();
                        }
                        break;
                    case 12:
                        {
                            this.state = 2489;
                            this.showSettings();
                        }
                        break;
                    case 13:
                        {
                            this.state = 2490;
                            this.showSupportedPrivileges();
                        }
                        break;
                    case 14:
                        {
                            this.state = 2491;
                            this.showTransactions();
                        }
                        break;
                    case 15:
                        {
                            this.state = 2492;
                            this.showUserPrivileges();
                        }
                        break;
                    case 16:
                        {
                            this.state = 2493;
                            this.showUsers();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showCommandYield() {
        let localctx = new ShowCommandYieldContext(this, this._ctx, this.state);
        this.enterRule(localctx, 384, CypherCmdParser.RULE_showCommandYield);
        let _la;
        try {
            this.state = 2501;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 335:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2496;
                        this.yieldClause();
                        this.state = 2498;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 261) {
                            {
                                this.state = 2497;
                                this.returnClause();
                            }
                        }
                    }
                    break;
                case 330:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2500;
                        this.whereClause();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    yieldItem() {
        let localctx = new YieldItemContext(this, this._ctx, this.state);
        this.enterRule(localctx, 386, CypherCmdParser.RULE_yieldItem);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2503;
                this.variable();
                this.state = 2506;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 2504;
                        this.match(CypherCmdParser.AS);
                        this.state = 2505;
                        this.variable();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    yieldSkip() {
        let localctx = new YieldSkipContext(this, this._ctx, this.state);
        this.enterRule(localctx, 388, CypherCmdParser.RULE_yieldSkip);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2508;
                _la = this._input.LA(1);
                if (!(_la === 211 || _la === 288)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 2509;
                this.signedIntegerLiteral();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    yieldLimit() {
        let localctx = new YieldLimitContext(this, this._ctx, this.state);
        this.enterRule(localctx, 390, CypherCmdParser.RULE_yieldLimit);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2511;
                this.match(CypherCmdParser.LIMITROWS);
                this.state = 2512;
                this.signedIntegerLiteral();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    yieldClause() {
        let localctx = new YieldClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 392, CypherCmdParser.RULE_yieldClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2514;
                this.match(CypherCmdParser.YIELD);
                this.state = 2524;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 301:
                        {
                            this.state = 2515;
                            this.match(CypherCmdParser.TIMES);
                        }
                        break;
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 2516;
                            this.yieldItem();
                            this.state = 2521;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            while (_la === 62) {
                                {
                                    {
                                        this.state = 2517;
                                        this.match(CypherCmdParser.COMMA);
                                        this.state = 2518;
                                        this.yieldItem();
                                    }
                                }
                                this.state = 2523;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                            }
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 2527;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 218) {
                    {
                        this.state = 2526;
                        this.orderBy();
                    }
                }
                this.state = 2530;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 211 || _la === 288) {
                    {
                        this.state = 2529;
                        this.yieldSkip();
                    }
                }
                this.state = 2533;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 175) {
                    {
                        this.state = 2532;
                        this.yieldLimit();
                    }
                }
                this.state = 2536;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330) {
                    {
                        this.state = 2535;
                        this.whereClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    commandOptions() {
        let localctx = new CommandOptionsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 394, CypherCmdParser.RULE_commandOptions);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2538;
                this.match(CypherCmdParser.OPTIONS);
                this.state = 2539;
                this.mapOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    terminateCommand() {
        let localctx = new TerminateCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 396, CypherCmdParser.RULE_terminateCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2541;
                this.match(CypherCmdParser.TERMINATE);
                this.state = 2542;
                this.terminateTransactions();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    composableCommandClauses() {
        let localctx = new ComposableCommandClausesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 398, CypherCmdParser.RULE_composableCommandClauses);
        try {
            this.state = 2546;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 297:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2544;
                        this.terminateCommand();
                    }
                    break;
                case 285:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2545;
                        this.composableShowCommandClauses();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    composableShowCommandClauses() {
        let localctx = new ComposableShowCommandClausesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 400, CypherCmdParser.RULE_composableShowCommandClauses);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2548;
                this.match(CypherCmdParser.SHOW);
                this.state = 2555;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 249, this._ctx)) {
                    case 1:
                        {
                            this.state = 2549;
                            this.showIndexCommand();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2550;
                            this.showConstraintCommand();
                        }
                        break;
                    case 3:
                        {
                            this.state = 2551;
                            this.showFunctions();
                        }
                        break;
                    case 4:
                        {
                            this.state = 2552;
                            this.showProcedures();
                        }
                        break;
                    case 5:
                        {
                            this.state = 2553;
                            this.showSettings();
                        }
                        break;
                    case 6:
                        {
                            this.state = 2554;
                            this.showTransactions();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showIndexCommand() {
        let localctx = new ShowIndexCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 402, CypherCmdParser.RULE_showIndexCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2558;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 33 || _la === 130 || _la === 179 || _la === 226 || _la === 240 || _la === 298 || _la === 326) {
                    {
                        this.state = 2557;
                        this.showIndexType();
                    }
                }
                this.state = 2560;
                this.showIndexesEnd();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showIndexType() {
        let localctx = new ShowIndexTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 404, CypherCmdParser.RULE_showIndexType);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2562;
                _la = this._input.LA(1);
                if (!(_la === 33 || _la === 130 || _la === 179 || _la === 226 || _la === 240 || _la === 298 || _la === 326)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showIndexesEnd() {
        let localctx = new ShowIndexesEndContext(this, this._ctx, this.state);
        this.enterRule(localctx, 406, CypherCmdParser.RULE_showIndexesEnd);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2564;
                this.indexToken();
                this.state = 2566;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 2565;
                        this.showCommandYield();
                    }
                }
                this.state = 2569;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 285 || _la === 297) {
                    {
                        this.state = 2568;
                        this.composableCommandClauses();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showConstraintCommand() {
        let localctx = new ShowConstraintCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 408, CypherCmdParser.RULE_showConstraintCommand);
        let _la;
        try {
            this.state = 2600;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 259, this._ctx)) {
                case 1:
                    localctx = new ShowConstraintAllContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2572;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 33) {
                            {
                                this.state = 2571;
                                this.match(CypherCmdParser.ALL);
                            }
                        }
                        this.state = 2574;
                        this.showConstraintsEnd();
                    }
                    break;
                case 2:
                    localctx = new ShowConstraintExistContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2576;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 200 || _la === 248 || _la === 249) {
                            {
                                this.state = 2575;
                                this.showConstraintEntity();
                            }
                        }
                        this.state = 2578;
                        this.constraintExistType();
                        this.state = 2579;
                        this.showConstraintsEnd();
                    }
                    break;
                case 3:
                    localctx = new ShowConstraintKeyContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2582;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 200 || _la === 248 || _la === 249) {
                            {
                                this.state = 2581;
                                this.showConstraintEntity();
                            }
                        }
                        this.state = 2584;
                        this.match(CypherCmdParser.KEY);
                        this.state = 2585;
                        this.showConstraintsEnd();
                    }
                    break;
                case 4:
                    localctx = new ShowConstraintPropTypeContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 2587;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 200 || _la === 248 || _la === 249) {
                            {
                                this.state = 2586;
                                this.showConstraintEntity();
                            }
                        }
                        this.state = 2589;
                        this.match(CypherCmdParser.PROPERTY);
                        this.state = 2590;
                        this.match(CypherCmdParser.TYPE);
                        this.state = 2591;
                        this.showConstraintsEnd();
                    }
                    break;
                case 5:
                    localctx = new ShowConstraintUniqueContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 2593;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 200 || _la === 248 || _la === 249) {
                            {
                                this.state = 2592;
                                this.showConstraintEntity();
                            }
                        }
                        this.state = 2596;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 236) {
                            {
                                this.state = 2595;
                                this.match(CypherCmdParser.PROPERTY);
                            }
                        }
                        this.state = 2598;
                        _la = this._input.LA(1);
                        if (!(_la === 316 || _la === 317)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 2599;
                        this.showConstraintsEnd();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showConstraintEntity() {
        let localctx = new ShowConstraintEntityContext(this, this._ctx, this.state);
        this.enterRule(localctx, 410, CypherCmdParser.RULE_showConstraintEntity);
        let _la;
        try {
            this.state = 2604;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 200:
                    localctx = new NodeEntityContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2602;
                        this.match(CypherCmdParser.NODE);
                    }
                    break;
                case 248:
                case 249:
                    localctx = new RelEntityContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2603;
                        _la = this._input.LA(1);
                        if (!(_la === 248 || _la === 249)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    constraintExistType() {
        let localctx = new ConstraintExistTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 412, CypherCmdParser.RULE_constraintExistType);
        try {
            this.state = 2612;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 261, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2606;
                        this.match(CypherCmdParser.EXISTENCE);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2607;
                        this.match(CypherCmdParser.EXIST);
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2608;
                        this.match(CypherCmdParser.PROPERTY);
                        this.state = 2609;
                        this.match(CypherCmdParser.EXISTENCE);
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 2610;
                        this.match(CypherCmdParser.PROPERTY);
                        this.state = 2611;
                        this.match(CypherCmdParser.EXIST);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showConstraintsEnd() {
        let localctx = new ShowConstraintsEndContext(this, this._ctx, this.state);
        this.enterRule(localctx, 414, CypherCmdParser.RULE_showConstraintsEnd);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2614;
                this.constraintToken();
                this.state = 2616;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 2615;
                        this.showCommandYield();
                    }
                }
                this.state = 2619;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 285 || _la === 297) {
                    {
                        this.state = 2618;
                        this.composableCommandClauses();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showProcedures() {
        let localctx = new ShowProceduresContext(this, this._ctx, this.state);
        this.enterRule(localctx, 416, CypherCmdParser.RULE_showProcedures);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2621;
                _la = this._input.LA(1);
                if (!(_la === 233 || _la === 234)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 2623;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 113) {
                    {
                        this.state = 2622;
                        this.executableBy();
                    }
                }
                this.state = 2626;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 2625;
                        this.showCommandYield();
                    }
                }
                this.state = 2629;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 285 || _la === 297) {
                    {
                        this.state = 2628;
                        this.composableCommandClauses();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showFunctions() {
        let localctx = new ShowFunctionsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 418, CypherCmdParser.RULE_showFunctions);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2632;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 33 || _la === 52 || _la === 321) {
                    {
                        this.state = 2631;
                        this.showFunctionsType();
                    }
                }
                this.state = 2634;
                this.functionToken();
                this.state = 2636;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 113) {
                    {
                        this.state = 2635;
                        this.executableBy();
                    }
                }
                this.state = 2639;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 2638;
                        this.showCommandYield();
                    }
                }
                this.state = 2642;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 285 || _la === 297) {
                    {
                        this.state = 2641;
                        this.composableCommandClauses();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionToken() {
        let localctx = new FunctionTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 420, CypherCmdParser.RULE_functionToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2644;
                _la = this._input.LA(1);
                if (!(_la === 131 || _la === 132)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    executableBy() {
        let localctx = new ExecutableByContext(this, this._ctx, this.state);
        this.enterRule(localctx, 422, CypherCmdParser.RULE_executableBy);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2646;
                this.match(CypherCmdParser.EXECUTABLE);
                this.state = 2653;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 53) {
                    {
                        this.state = 2647;
                        this.match(CypherCmdParser.BY);
                        this.state = 2651;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 271, this._ctx)) {
                            case 1:
                                {
                                    this.state = 2648;
                                    this.match(CypherCmdParser.CURRENT);
                                    this.state = 2649;
                                    this.match(CypherCmdParser.USER);
                                }
                                break;
                            case 2:
                                {
                                    this.state = 2650;
                                    this.symbolicNameString();
                                }
                                break;
                        }
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showFunctionsType() {
        let localctx = new ShowFunctionsTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 424, CypherCmdParser.RULE_showFunctionsType);
        try {
            this.state = 2660;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 33:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2655;
                        this.match(CypherCmdParser.ALL);
                    }
                    break;
                case 52:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2656;
                        this.match(CypherCmdParser.BUILT);
                        this.state = 2657;
                        this.match(CypherCmdParser.IN);
                    }
                    break;
                case 321:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2658;
                        this.match(CypherCmdParser.USER);
                        this.state = 2659;
                        this.match(CypherCmdParser.DEFINED);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showTransactions() {
        let localctx = new ShowTransactionsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 426, CypherCmdParser.RULE_showTransactions);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2662;
                this.transactionToken();
                this.state = 2663;
                this.namesAndClauses();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    terminateTransactions() {
        let localctx = new TerminateTransactionsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 428, CypherCmdParser.RULE_terminateTransactions);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2665;
                this.transactionToken();
                this.state = 2666;
                this.stringsOrExpression();
                this.state = 2668;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 2667;
                        this.showCommandYield();
                    }
                }
                this.state = 2671;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 285 || _la === 297) {
                    {
                        this.state = 2670;
                        this.composableCommandClauses();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showSettings() {
        let localctx = new ShowSettingsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 430, CypherCmdParser.RULE_showSettings);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2673;
                this.settingToken();
                this.state = 2674;
                this.namesAndClauses();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    settingToken() {
        let localctx = new SettingTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 432, CypherCmdParser.RULE_settingToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2676;
                _la = this._input.LA(1);
                if (!(_la === 279 || _la === 280)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    namesAndClauses() {
        let localctx = new NamesAndClausesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 434, CypherCmdParser.RULE_namesAndClauses);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2685;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 278, this._ctx)) {
                    case 1:
                        {
                            this.state = 2679;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330 || _la === 335) {
                                {
                                    this.state = 2678;
                                    this.showCommandYield();
                                }
                            }
                        }
                        break;
                    case 2:
                        {
                            this.state = 2681;
                            this.stringsOrExpression();
                            this.state = 2683;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 330 || _la === 335) {
                                {
                                    this.state = 2682;
                                    this.showCommandYield();
                                }
                            }
                        }
                        break;
                }
                this.state = 2688;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 285 || _la === 297) {
                    {
                        this.state = 2687;
                        this.composableCommandClauses();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringsOrExpression() {
        let localctx = new StringsOrExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 436, CypherCmdParser.RULE_stringsOrExpression);
        try {
            this.state = 2692;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 280, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2690;
                        this.stringList();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2691;
                        this.expression();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    commandNodePattern() {
        let localctx = new CommandNodePatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 438, CypherCmdParser.RULE_commandNodePattern);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2694;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2695;
                this.variable();
                this.state = 2696;
                this.labelType();
                this.state = 2697;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    commandRelPattern() {
        let localctx = new CommandRelPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 440, CypherCmdParser.RULE_commandRelPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2699;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2700;
                this.match(CypherCmdParser.RPAREN);
                this.state = 2702;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 181 || _la === 341) {
                    {
                        this.state = 2701;
                        this.leftArrow();
                    }
                }
                this.state = 2704;
                this.arrowLine();
                this.state = 2705;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2706;
                this.variable();
                this.state = 2707;
                this.relType();
                this.state = 2708;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 2709;
                this.arrowLine();
                this.state = 2711;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 139 || _la === 342) {
                    {
                        this.state = 2710;
                        this.rightArrow();
                    }
                }
                this.state = 2713;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2714;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createConstraint() {
        let localctx = new CreateConstraintContext(this, this._ctx, this.state);
        this.enterRule(localctx, 442, CypherCmdParser.RULE_createConstraint);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2716;
                this.match(CypherCmdParser.CONSTRAINT);
                this.state = 2718;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 283, this._ctx)) {
                    case 1:
                        {
                            this.state = 2717;
                            this.symbolicNameOrStringParameter();
                        }
                        break;
                }
                this.state = 2723;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 2720;
                        this.match(CypherCmdParser.IF);
                        this.state = 2721;
                        this.match(CypherCmdParser.NOT);
                        this.state = 2722;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 2725;
                this.match(CypherCmdParser.FOR);
                this.state = 2728;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 285, this._ctx)) {
                    case 1:
                        {
                            this.state = 2726;
                            this.commandNodePattern();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2727;
                            this.commandRelPattern();
                        }
                        break;
                }
                this.state = 2730;
                this.constraintType();
                this.state = 2732;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 2731;
                        this.commandOptions();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    constraintType() {
        let localctx = new ConstraintTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 444, CypherCmdParser.RULE_constraintType);
        let _la;
        try {
            this.state = 2765;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 290, this._ctx)) {
                case 1:
                    localctx = new ConstraintTypedContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2734;
                        this.match(CypherCmdParser.REQUIRE);
                        this.state = 2735;
                        this.propertyList();
                        this.state = 2739;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 61:
                                {
                                    this.state = 2736;
                                    this.match(CypherCmdParser.COLONCOLON);
                                }
                                break;
                            case 162:
                                {
                                    this.state = 2737;
                                    this.match(CypherCmdParser.IS);
                                    this.state = 2738;
                                    _la = this._input.LA(1);
                                    if (!(_la === 61 || _la === 313)) {
                                        this._errHandler.recoverInline(this);
                                    }
                                    else {
                                        this._errHandler.reportMatch(this);
                                        this.consume();
                                    }
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                        this.state = 2741;
                        this.type_();
                    }
                    break;
                case 2:
                    localctx = new ConstraintIsUniqueContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2743;
                        this.match(CypherCmdParser.REQUIRE);
                        this.state = 2744;
                        this.propertyList();
                        this.state = 2745;
                        this.match(CypherCmdParser.IS);
                        this.state = 2747;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 200 || _la === 248 || _la === 249) {
                            {
                                this.state = 2746;
                                _la = this._input.LA(1);
                                if (!(_la === 200 || _la === 248 || _la === 249)) {
                                    this._errHandler.recoverInline(this);
                                }
                                else {
                                    this._errHandler.reportMatch(this);
                                    this.consume();
                                }
                            }
                        }
                        this.state = 2749;
                        this.match(CypherCmdParser.UNIQUE);
                    }
                    break;
                case 3:
                    localctx = new ConstraintKeyContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2751;
                        this.match(CypherCmdParser.REQUIRE);
                        this.state = 2752;
                        this.propertyList();
                        this.state = 2753;
                        this.match(CypherCmdParser.IS);
                        this.state = 2755;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 200 || _la === 248 || _la === 249) {
                            {
                                this.state = 2754;
                                _la = this._input.LA(1);
                                if (!(_la === 200 || _la === 248 || _la === 249)) {
                                    this._errHandler.recoverInline(this);
                                }
                                else {
                                    this._errHandler.reportMatch(this);
                                    this.consume();
                                }
                            }
                        }
                        this.state = 2757;
                        this.match(CypherCmdParser.KEY);
                    }
                    break;
                case 4:
                    localctx = new ConstraintIsNotNullContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 2759;
                        this.match(CypherCmdParser.REQUIRE);
                        this.state = 2760;
                        this.propertyList();
                        this.state = 2761;
                        this.match(CypherCmdParser.IS);
                        this.state = 2762;
                        this.match(CypherCmdParser.NOT);
                        this.state = 2763;
                        this.match(CypherCmdParser.NULL);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropConstraint() {
        let localctx = new DropConstraintContext(this, this._ctx, this.state);
        this.enterRule(localctx, 446, CypherCmdParser.RULE_dropConstraint);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2767;
                this.match(CypherCmdParser.CONSTRAINT);
                this.state = 2768;
                this.symbolicNameOrStringParameter();
                this.state = 2771;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 2769;
                        this.match(CypherCmdParser.IF);
                        this.state = 2770;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createIndex() {
        let localctx = new CreateIndexContext(this, this._ctx, this.state);
        this.enterRule(localctx, 448, CypherCmdParser.RULE_createIndex);
        try {
            this.state = 2793;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 240:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2773;
                        this.match(CypherCmdParser.RANGE);
                        this.state = 2774;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2775;
                        this.createIndex_();
                    }
                    break;
                case 298:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2776;
                        this.match(CypherCmdParser.TEXT);
                        this.state = 2777;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2778;
                        this.createIndex_();
                    }
                    break;
                case 226:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2779;
                        this.match(CypherCmdParser.POINT);
                        this.state = 2780;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2781;
                        this.createIndex_();
                    }
                    break;
                case 326:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 2782;
                        this.match(CypherCmdParser.VECTOR);
                        this.state = 2783;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2784;
                        this.createIndex_();
                    }
                    break;
                case 179:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 2785;
                        this.match(CypherCmdParser.LOOKUP);
                        this.state = 2786;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2787;
                        this.createLookupIndex();
                    }
                    break;
                case 130:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 2788;
                        this.match(CypherCmdParser.FULLTEXT);
                        this.state = 2789;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2790;
                        this.createFulltextIndex();
                    }
                    break;
                case 147:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 2791;
                        this.match(CypherCmdParser.INDEX);
                        this.state = 2792;
                        this.createIndex_();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createIndex_() {
        let localctx = new CreateIndex_Context(this, this._ctx, this.state);
        this.enterRule(localctx, 450, CypherCmdParser.RULE_createIndex_);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2796;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 293, this._ctx)) {
                    case 1:
                        {
                            this.state = 2795;
                            this.symbolicNameOrStringParameter();
                        }
                        break;
                }
                this.state = 2801;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 2798;
                        this.match(CypherCmdParser.IF);
                        this.state = 2799;
                        this.match(CypherCmdParser.NOT);
                        this.state = 2800;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 2803;
                this.match(CypherCmdParser.FOR);
                this.state = 2806;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 295, this._ctx)) {
                    case 1:
                        {
                            this.state = 2804;
                            this.commandNodePattern();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2805;
                            this.commandRelPattern();
                        }
                        break;
                }
                this.state = 2808;
                this.match(CypherCmdParser.ON);
                this.state = 2809;
                this.propertyList();
                this.state = 2811;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 2810;
                        this.commandOptions();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createFulltextIndex() {
        let localctx = new CreateFulltextIndexContext(this, this._ctx, this.state);
        this.enterRule(localctx, 452, CypherCmdParser.RULE_createFulltextIndex);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2814;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 297, this._ctx)) {
                    case 1:
                        {
                            this.state = 2813;
                            this.symbolicNameOrStringParameter();
                        }
                        break;
                }
                this.state = 2819;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 2816;
                        this.match(CypherCmdParser.IF);
                        this.state = 2817;
                        this.match(CypherCmdParser.NOT);
                        this.state = 2818;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 2821;
                this.match(CypherCmdParser.FOR);
                this.state = 2824;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 299, this._ctx)) {
                    case 1:
                        {
                            this.state = 2822;
                            this.fulltextNodePattern();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2823;
                            this.fulltextRelPattern();
                        }
                        break;
                }
                this.state = 2826;
                this.match(CypherCmdParser.ON);
                this.state = 2827;
                this.match(CypherCmdParser.EACH);
                this.state = 2828;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2829;
                this.enclosedPropertyList();
                this.state = 2830;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 2832;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 2831;
                        this.commandOptions();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    fulltextNodePattern() {
        let localctx = new FulltextNodePatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 454, CypherCmdParser.RULE_fulltextNodePattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2834;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2835;
                this.variable();
                this.state = 2836;
                this.match(CypherCmdParser.COLON);
                this.state = 2837;
                this.symbolicNameString();
                this.state = 2842;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 45) {
                    {
                        {
                            this.state = 2838;
                            this.match(CypherCmdParser.BAR);
                            this.state = 2839;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 2844;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 2845;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    fulltextRelPattern() {
        let localctx = new FulltextRelPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 456, CypherCmdParser.RULE_fulltextRelPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2847;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2848;
                this.match(CypherCmdParser.RPAREN);
                this.state = 2850;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 181 || _la === 341) {
                    {
                        this.state = 2849;
                        this.leftArrow();
                    }
                }
                this.state = 2852;
                this.arrowLine();
                this.state = 2853;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2854;
                this.variable();
                this.state = 2855;
                this.match(CypherCmdParser.COLON);
                this.state = 2856;
                this.symbolicNameString();
                this.state = 2861;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 45) {
                    {
                        {
                            this.state = 2857;
                            this.match(CypherCmdParser.BAR);
                            this.state = 2858;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 2863;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 2864;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 2865;
                this.arrowLine();
                this.state = 2867;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 139 || _la === 342) {
                    {
                        this.state = 2866;
                        this.rightArrow();
                    }
                }
                this.state = 2869;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2870;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createLookupIndex() {
        let localctx = new CreateLookupIndexContext(this, this._ctx, this.state);
        this.enterRule(localctx, 458, CypherCmdParser.RULE_createLookupIndex);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2873;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 305, this._ctx)) {
                    case 1:
                        {
                            this.state = 2872;
                            this.symbolicNameOrStringParameter();
                        }
                        break;
                }
                this.state = 2878;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 2875;
                        this.match(CypherCmdParser.IF);
                        this.state = 2876;
                        this.match(CypherCmdParser.NOT);
                        this.state = 2877;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 2880;
                this.match(CypherCmdParser.FOR);
                this.state = 2883;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 307, this._ctx)) {
                    case 1:
                        {
                            this.state = 2881;
                            this.lookupIndexNodePattern();
                        }
                        break;
                    case 2:
                        {
                            this.state = 2882;
                            this.lookupIndexRelPattern();
                        }
                        break;
                }
                this.state = 2885;
                this.symbolicNameString();
                this.state = 2886;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2887;
                this.variable();
                this.state = 2888;
                this.match(CypherCmdParser.RPAREN);
                this.state = 2890;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 2889;
                        this.commandOptions();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lookupIndexNodePattern() {
        let localctx = new LookupIndexNodePatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 460, CypherCmdParser.RULE_lookupIndexNodePattern);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2892;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2893;
                this.variable();
                this.state = 2894;
                this.match(CypherCmdParser.RPAREN);
                this.state = 2895;
                this.match(CypherCmdParser.ON);
                this.state = 2896;
                this.match(CypherCmdParser.EACH);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lookupIndexRelPattern() {
        let localctx = new LookupIndexRelPatternContext(this, this._ctx, this.state);
        this.enterRule(localctx, 462, CypherCmdParser.RULE_lookupIndexRelPattern);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2898;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2899;
                this.match(CypherCmdParser.RPAREN);
                this.state = 2901;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 181 || _la === 341) {
                    {
                        this.state = 2900;
                        this.leftArrow();
                    }
                }
                this.state = 2903;
                this.arrowLine();
                this.state = 2904;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 2905;
                this.variable();
                this.state = 2906;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 2907;
                this.arrowLine();
                this.state = 2909;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 139 || _la === 342) {
                    {
                        this.state = 2908;
                        this.rightArrow();
                    }
                }
                this.state = 2911;
                this.match(CypherCmdParser.LPAREN);
                this.state = 2912;
                this.match(CypherCmdParser.RPAREN);
                this.state = 2913;
                this.match(CypherCmdParser.ON);
                this.state = 2915;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 311, this._ctx)) {
                    case 1:
                        {
                            this.state = 2914;
                            this.match(CypherCmdParser.EACH);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropIndex() {
        let localctx = new DropIndexContext(this, this._ctx, this.state);
        this.enterRule(localctx, 464, CypherCmdParser.RULE_dropIndex);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2917;
                this.match(CypherCmdParser.INDEX);
                this.state = 2918;
                this.symbolicNameOrStringParameter();
                this.state = 2921;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 2919;
                        this.match(CypherCmdParser.IF);
                        this.state = 2920;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyList() {
        let localctx = new PropertyListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 466, CypherCmdParser.RULE_propertyList);
        try {
            this.state = 2930;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2923;
                        this.variable();
                        this.state = 2924;
                        this.property();
                    }
                    break;
                case 180:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2926;
                        this.match(CypherCmdParser.LPAREN);
                        this.state = 2927;
                        this.enclosedPropertyList();
                        this.state = 2928;
                        this.match(CypherCmdParser.RPAREN);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    enclosedPropertyList() {
        let localctx = new EnclosedPropertyListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 468, CypherCmdParser.RULE_enclosedPropertyList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2932;
                this.variable();
                this.state = 2933;
                this.property();
                this.state = 2940;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 2934;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 2935;
                            this.variable();
                            this.state = 2936;
                            this.property();
                        }
                    }
                    this.state = 2942;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterCurrentGraphType() {
        let localctx = new AlterCurrentGraphTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 470, CypherCmdParser.RULE_alterCurrentGraphType);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2943;
                this.match(CypherCmdParser.CURRENT);
                this.state = 2944;
                this.match(CypherCmdParser.GRAPH);
                this.state = 2945;
                this.match(CypherCmdParser.TYPE);
                this.state = 2950;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 27:
                    case 35:
                    case 278:
                        {
                            this.state = 2946;
                            _la = this._input.LA(1);
                            if (!(_la === 27 || _la === 35 || _la === 278)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 2947;
                            this.graphTypeSpecification();
                        }
                        break;
                    case 99:
                        {
                            this.state = 2948;
                            this.match(CypherCmdParser.DROP);
                            this.state = 2949;
                            this.graphTypeDropSpecification();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphTypeSpecification() {
        let localctx = new GraphTypeSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 472, CypherCmdParser.RULE_graphTypeSpecification);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2952;
                this.match(CypherCmdParser.LCURLY);
                this.state = 2954;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 67 || _la === 180) {
                    {
                        this.state = 2953;
                        this.graphTypeSpecificationBody();
                    }
                }
                this.state = 2956;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphTypeDropSpecification() {
        let localctx = new GraphTypeDropSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 474, CypherCmdParser.RULE_graphTypeDropSpecification);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2958;
                this.match(CypherCmdParser.LCURLY);
                this.state = 2960;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 67 || _la === 180) {
                    {
                        this.state = 2959;
                        this.graphTypeDropSpecificationBody();
                    }
                }
                this.state = 2962;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphTypeSpecificationBody() {
        let localctx = new GraphTypeSpecificationBodyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 476, CypherCmdParser.RULE_graphTypeSpecificationBody);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2964;
                this.graphTypeElement();
                this.state = 2969;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 2965;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 2966;
                            this.graphTypeElement();
                        }
                    }
                    this.state = 2971;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphTypeDropSpecificationBody() {
        let localctx = new GraphTypeDropSpecificationBodyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 478, CypherCmdParser.RULE_graphTypeDropSpecificationBody);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2972;
                this.graphTypeDropElement();
                this.state = 2977;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 2973;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 2974;
                            this.graphTypeDropElement();
                        }
                    }
                    this.state = 2979;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphTypeElement() {
        let localctx = new GraphTypeElementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 480, CypherCmdParser.RULE_graphTypeElement);
        try {
            this.state = 2983;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 320, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2980;
                        this.edgeTypeSpecification();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2981;
                        this.nodeTypeSpecification();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2982;
                        this.constraintSpecification();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphTypeDropElement() {
        let localctx = new GraphTypeDropElementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 482, CypherCmdParser.RULE_graphTypeDropElement);
        try {
            this.state = 2989;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 321, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 2985;
                        this.edgeTypeSpecification();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 2986;
                        this.nodeTypeSpecification();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 2987;
                        this.match(CypherCmdParser.CONSTRAINT);
                        this.state = 2988;
                        this.symbolicNameString();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeTypeInlineConstraintList() {
        let localctx = new NodeTypeInlineConstraintListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 484, CypherCmdParser.RULE_nodeTypeInlineConstraintList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 2995;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 2991;
                            this.constraintType();
                            this.state = 2993;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 215) {
                                {
                                    this.state = 2992;
                                    this.commandOptions();
                                }
                            }
                        }
                    }
                    this.state = 2997;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 257);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    edgeTypeInlineConstraintList() {
        let localctx = new EdgeTypeInlineConstraintListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 486, CypherCmdParser.RULE_edgeTypeInlineConstraintList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3003;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 2999;
                            this.constraintType();
                            this.state = 3001;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 215) {
                                {
                                    this.state = 3000;
                                    this.commandOptions();
                                }
                            }
                        }
                    }
                    this.state = 3005;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 257);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    implies() {
        let localctx = new ImpliesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 488, CypherCmdParser.RULE_implies);
        try {
            this.state = 3010;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 112:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3007;
                        this.match(CypherCmdParser.EQ);
                        this.state = 3008;
                        this.rightArrow();
                    }
                    break;
                case 188:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3009;
                        this.match(CypherCmdParser.IMPLIES);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeTypeSpecification() {
        let localctx = new NodeTypeSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 490, CypherCmdParser.RULE_nodeTypeSpecification);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3012;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3014;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 3013;
                        this.variable();
                    }
                }
                this.state = 3016;
                this.identifyingLabel();
                this.state = 3018;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 60) {
                    {
                        this.state = 3017;
                        this.impliedLabelSet();
                    }
                }
                this.state = 3021;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 171) {
                    {
                        this.state = 3020;
                        this.propertyTypeList();
                    }
                }
                this.state = 3023;
                this.match(CypherCmdParser.RPAREN);
                this.state = 3025;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 257) {
                    {
                        this.state = 3024;
                        this.nodeTypeInlineConstraintList();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    impliedLabelSet() {
        let localctx = new ImpliedLabelSetContext(this, this._ctx, this.state);
        this.enterRule(localctx, 492, CypherCmdParser.RULE_impliedLabelSet);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3027;
                this.labelType();
                this.state = 3032;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 167) {
                    {
                        {
                            this.state = 3028;
                            this.match(CypherCmdParser.AMPERSAND);
                            this.state = 3029;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 3034;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    identifyingLabel() {
        let localctx = new IdentifyingLabelContext(this, this._ctx, this.state);
        this.enterRule(localctx, 494, CypherCmdParser.RULE_identifyingLabel);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3035;
                this.labelType();
                this.state = 3036;
                this.implies();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeTypeReference() {
        let localctx = new NodeTypeReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 496, CypherCmdParser.RULE_nodeTypeReference);
        try {
            this.state = 3040;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 332, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3038;
                        this.nodeTypeAliasReference();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3039;
                        this.nodeTypeInSituReference();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeTypeAliasReference() {
        let localctx = new NodeTypeAliasReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 498, CypherCmdParser.RULE_nodeTypeAliasReference);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3042;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3043;
                this.variable();
                this.state = 3044;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeTypeInSituReference() {
        let localctx = new NodeTypeInSituReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 500, CypherCmdParser.RULE_nodeTypeInSituReference);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3046;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3054;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2684346367) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 3048;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                            {
                                this.state = 3047;
                                this.variable();
                            }
                        }
                        this.state = 3050;
                        this.labelType();
                        this.state = 3052;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 112 || _la === 188) {
                            {
                                this.state = 3051;
                                this.implies();
                            }
                        }
                    }
                }
                this.state = 3056;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    edgeTypeSpecification() {
        let localctx = new EdgeTypeSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 502, CypherCmdParser.RULE_edgeTypeSpecification);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3058;
                this.nodeTypeReference();
                this.state = 3059;
                this.arcTypePointingRight();
                this.state = 3060;
                this.nodeTypeReference();
                this.state = 3062;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 257) {
                    {
                        this.state = 3061;
                        this.edgeTypeInlineConstraintList();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    arcTypePointingRight() {
        let localctx = new ArcTypePointingRightContext(this, this._ctx, this.state);
        this.enterRule(localctx, 504, CypherCmdParser.RULE_arcTypePointingRight);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3064;
                this.arrowLine();
                this.state = 3065;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 3067;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 3066;
                        this.variable();
                    }
                }
                this.state = 3069;
                this.identifyingRelationship();
                this.state = 3071;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 171) {
                    {
                        this.state = 3070;
                        this.propertyTypeList();
                    }
                }
                this.state = 3073;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 3074;
                this.arrowLine();
                this.state = 3075;
                this.rightArrow();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    identifyingRelationship() {
        let localctx = new IdentifyingRelationshipContext(this, this._ctx, this.state);
        this.enterRule(localctx, 506, CypherCmdParser.RULE_identifyingRelationship);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3077;
                this.relType();
                this.state = 3078;
                this.implies();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    edgeTypeReference() {
        let localctx = new EdgeTypeReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 508, CypherCmdParser.RULE_edgeTypeReference);
        try {
            this.state = 3082;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 339, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3080;
                        this.edgeTypeAliasReference();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3081;
                        this.edgeTypeInSituReference();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    edgeTypeAliasReference() {
        let localctx = new EdgeTypeAliasReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 510, CypherCmdParser.RULE_edgeTypeAliasReference);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3084;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3085;
                this.match(CypherCmdParser.RPAREN);
                this.state = 3086;
                this.arrowLine();
                this.state = 3087;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 3088;
                this.variable();
                this.state = 3089;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 3090;
                this.arrowLine();
                this.state = 3091;
                this.rightArrow();
                this.state = 3092;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3093;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    edgeTypeInSituReference() {
        let localctx = new EdgeTypeInSituReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 512, CypherCmdParser.RULE_edgeTypeInSituReference);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3095;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3096;
                this.match(CypherCmdParser.RPAREN);
                this.state = 3097;
                this.arrowLine();
                this.state = 3098;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 3100;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 3099;
                        this.variable();
                    }
                }
                this.state = 3102;
                this.relType();
                this.state = 3104;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 112 || _la === 188) {
                    {
                        this.state = 3103;
                        this.implies();
                    }
                }
                this.state = 3106;
                this.match(CypherCmdParser.RBRACKET);
                this.state = 3107;
                this.arrowLine();
                this.state = 3108;
                this.rightArrow();
                this.state = 3109;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3110;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyTypeList() {
        let localctx = new PropertyTypeListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 514, CypherCmdParser.RULE_propertyTypeList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3112;
                this.match(CypherCmdParser.LCURLY);
                this.state = 3121;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 3113;
                        this.propertyType();
                        this.state = 3118;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 62) {
                            {
                                {
                                    this.state = 3114;
                                    this.match(CypherCmdParser.COMMA);
                                    this.state = 3115;
                                    this.propertyType();
                                }
                            }
                            this.state = 3120;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 3123;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyType() {
        let localctx = new PropertyTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 516, CypherCmdParser.RULE_propertyType);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3125;
                this.propertyKeyName();
                this.state = 3127;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 61 || _la === 313) {
                    {
                        this.state = 3126;
                        this.typed();
                    }
                }
                this.state = 3129;
                this.type_();
                this.state = 3131;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 162) {
                    {
                        this.state = 3130;
                        this.propertyTypeInlineConstraint();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyTypeInlineConstraint() {
        let localctx = new PropertyTypeInlineConstraintContext(this, this._ctx, this.state);
        this.enterRule(localctx, 518, CypherCmdParser.RULE_propertyTypeInlineConstraint);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3133;
                this.match(CypherCmdParser.IS);
                this.state = 3135;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 200 || _la === 248 || _la === 249) {
                    {
                        this.state = 3134;
                        _la = this._input.LA(1);
                        if (!(_la === 200 || _la === 248 || _la === 249)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3137;
                _la = this._input.LA(1);
                if (!(_la === 164 || _la === 316)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    typed() {
        let localctx = new TypedContext(this, this._ctx, this.state);
        this.enterRule(localctx, 520, CypherCmdParser.RULE_typed);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3139;
                _la = this._input.LA(1);
                if (!(_la === 61 || _la === 313)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    constraintSpecification() {
        let localctx = new ConstraintSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 522, CypherCmdParser.RULE_constraintSpecification);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3141;
                this.match(CypherCmdParser.CONSTRAINT);
                this.state = 3143;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 347, this._ctx)) {
                    case 1:
                        {
                            this.state = 3142;
                            this.symbolicNameString();
                        }
                        break;
                }
                this.state = 3145;
                this.match(CypherCmdParser.FOR);
                this.state = 3148;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 348, this._ctx)) {
                    case 1:
                        {
                            this.state = 3146;
                            this.nodeTypeReference();
                        }
                        break;
                    case 2:
                        {
                            this.state = 3147;
                            this.edgeTypeReference();
                        }
                        break;
                }
                this.state = 3150;
                this.constraintType();
                this.state = 3152;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 3151;
                        this.commandOptions();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    renameCommand() {
        let localctx = new RenameCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 524, CypherCmdParser.RULE_renameCommand);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3154;
                this.match(CypherCmdParser.RENAME);
                this.state = 3158;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 263:
                        {
                            this.state = 3155;
                            this.renameRole();
                        }
                        break;
                    case 276:
                        {
                            this.state = 3156;
                            this.renameServer();
                        }
                        break;
                    case 321:
                        {
                            this.state = 3157;
                            this.renameUser();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    grantCommand() {
        let localctx = new GrantCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 526, CypherCmdParser.RULE_grantCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3160;
                this.match(CypherCmdParser.GRANT);
                this.state = 3171;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 352, this._ctx)) {
                    case 1:
                        {
                            this.state = 3162;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 145) {
                                {
                                    this.state = 3161;
                                    this.match(CypherCmdParser.IMMUTABLE);
                                }
                            }
                            this.state = 3164;
                            this.privilege();
                            this.state = 3165;
                            this.match(CypherCmdParser.TO);
                            this.state = 3166;
                            this.roleNames();
                        }
                        break;
                    case 2:
                        {
                            this.state = 3168;
                            this.roleToken();
                            this.state = 3169;
                            this.grantRole();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    denyCommand() {
        let localctx = new DenyCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 528, CypherCmdParser.RULE_denyCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3173;
                this.match(CypherCmdParser.DENY);
                this.state = 3175;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 145) {
                    {
                        this.state = 3174;
                        this.match(CypherCmdParser.IMMUTABLE);
                    }
                }
                this.state = 3177;
                this.privilege();
                this.state = 3178;
                this.match(CypherCmdParser.TO);
                this.state = 3179;
                this.roleNames();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    revokeCommand() {
        let localctx = new RevokeCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 530, CypherCmdParser.RULE_revokeCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3181;
                this.match(CypherCmdParser.REVOKE);
                this.state = 3195;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 356, this._ctx)) {
                    case 1:
                        {
                            this.state = 3183;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 86 || _la === 134) {
                                {
                                    this.state = 3182;
                                    _la = this._input.LA(1);
                                    if (!(_la === 86 || _la === 134)) {
                                        this._errHandler.recoverInline(this);
                                    }
                                    else {
                                        this._errHandler.reportMatch(this);
                                        this.consume();
                                    }
                                }
                            }
                            this.state = 3186;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 145) {
                                {
                                    this.state = 3185;
                                    this.match(CypherCmdParser.IMMUTABLE);
                                }
                            }
                            this.state = 3188;
                            this.privilege();
                            this.state = 3189;
                            this.match(CypherCmdParser.FROM);
                            this.state = 3190;
                            this.roleNames();
                        }
                        break;
                    case 2:
                        {
                            this.state = 3192;
                            this.roleToken();
                            this.state = 3193;
                            this.revokeRole();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    userNames() {
        let localctx = new UserNamesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 532, CypherCmdParser.RULE_userNames);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3197;
                this.symbolicNameOrStringParameterList();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    roleNames() {
        let localctx = new RoleNamesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 534, CypherCmdParser.RULE_roleNames);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3199;
                this.symbolicNameOrStringParameterList();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    roleToken() {
        let localctx = new RoleTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 536, CypherCmdParser.RULE_roleToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3201;
                _la = this._input.LA(1);
                if (!(_la === 263 || _la === 264)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    enableServerCommand() {
        let localctx = new EnableServerCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 538, CypherCmdParser.RULE_enableServerCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3203;
                this.match(CypherCmdParser.ENABLE);
                this.state = 3204;
                this.match(CypherCmdParser.SERVER);
                this.state = 3205;
                this.stringOrParameter();
                this.state = 3207;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 3206;
                        this.commandOptions();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterServer() {
        let localctx = new AlterServerContext(this, this._ctx, this.state);
        this.enterRule(localctx, 540, CypherCmdParser.RULE_alterServer);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3209;
                this.match(CypherCmdParser.SERVER);
                this.state = 3210;
                this.stringOrParameter();
                this.state = 3211;
                this.match(CypherCmdParser.SET);
                this.state = 3212;
                this.commandOptions();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    renameServer() {
        let localctx = new RenameServerContext(this, this._ctx, this.state);
        this.enterRule(localctx, 542, CypherCmdParser.RULE_renameServer);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3214;
                this.match(CypherCmdParser.SERVER);
                this.state = 3215;
                this.stringOrParameter();
                this.state = 3216;
                this.match(CypherCmdParser.TO);
                this.state = 3217;
                this.stringOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropServer() {
        let localctx = new DropServerContext(this, this._ctx, this.state);
        this.enterRule(localctx, 544, CypherCmdParser.RULE_dropServer);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3219;
                this.match(CypherCmdParser.SERVER);
                this.state = 3220;
                this.stringOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showServers() {
        let localctx = new ShowServersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 546, CypherCmdParser.RULE_showServers);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3222;
                _la = this._input.LA(1);
                if (!(_la === 276 || _la === 277)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 3224;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3223;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    allocationCommand() {
        let localctx = new AllocationCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 548, CypherCmdParser.RULE_allocationCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3227;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 100) {
                    {
                        this.state = 3226;
                        this.match(CypherCmdParser.DRYRUN);
                    }
                }
                this.state = 3231;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 82:
                        {
                            this.state = 3229;
                            this.deallocateDatabaseFromServers();
                        }
                        break;
                    case 244:
                        {
                            this.state = 3230;
                            this.reallocateDatabases();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    deallocateDatabaseFromServers() {
        let localctx = new DeallocateDatabaseFromServersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 550, CypherCmdParser.RULE_deallocateDatabaseFromServers);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3233;
                this.match(CypherCmdParser.DEALLOCATE);
                this.state = 3234;
                _la = this._input.LA(1);
                if (!(_la === 77 || _la === 78)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 3235;
                this.match(CypherCmdParser.FROM);
                this.state = 3236;
                _la = this._input.LA(1);
                if (!(_la === 276 || _la === 277)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 3237;
                this.stringOrParameter();
                this.state = 3242;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 3238;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 3239;
                            this.stringOrParameter();
                        }
                    }
                    this.state = 3244;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    reallocateDatabases() {
        let localctx = new ReallocateDatabasesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 552, CypherCmdParser.RULE_reallocateDatabases);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3245;
                this.match(CypherCmdParser.REALLOCATE);
                this.state = 3246;
                _la = this._input.LA(1);
                if (!(_la === 77 || _la === 78)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createRole() {
        let localctx = new CreateRoleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 554, CypherCmdParser.RULE_createRole);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3249;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 145) {
                    {
                        this.state = 3248;
                        this.match(CypherCmdParser.IMMUTABLE);
                    }
                }
                this.state = 3251;
                this.match(CypherCmdParser.ROLE);
                this.state = 3252;
                this.commandNameExpression();
                this.state = 3256;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3253;
                        this.match(CypherCmdParser.IF);
                        this.state = 3254;
                        this.match(CypherCmdParser.NOT);
                        this.state = 3255;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3262;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 3258;
                        this.match(CypherCmdParser.AS);
                        this.state = 3259;
                        this.match(CypherCmdParser.COPY);
                        this.state = 3260;
                        this.match(CypherCmdParser.OF);
                        this.state = 3261;
                        this.commandNameExpression();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropRole() {
        let localctx = new DropRoleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 556, CypherCmdParser.RULE_dropRole);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3264;
                this.match(CypherCmdParser.ROLE);
                this.state = 3265;
                this.commandNameExpression();
                this.state = 3268;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3266;
                        this.match(CypherCmdParser.IF);
                        this.state = 3267;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    renameRole() {
        let localctx = new RenameRoleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 558, CypherCmdParser.RULE_renameRole);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3270;
                this.match(CypherCmdParser.ROLE);
                this.state = 3271;
                this.commandNameExpression();
                this.state = 3274;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3272;
                        this.match(CypherCmdParser.IF);
                        this.state = 3273;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3276;
                this.match(CypherCmdParser.TO);
                this.state = 3277;
                this.commandNameExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showRoles() {
        let localctx = new ShowRolesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 560, CypherCmdParser.RULE_showRoles);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3280;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 33 || _la === 227) {
                    {
                        this.state = 3279;
                        _la = this._input.LA(1);
                        if (!(_la === 33 || _la === 227)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3282;
                this.roleToken();
                this.state = 3285;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 331) {
                    {
                        this.state = 3283;
                        this.match(CypherCmdParser.WITH);
                        this.state = 3284;
                        _la = this._input.LA(1);
                        if (!(_la === 321 || _la === 322)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3288;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3287;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    grantRole() {
        let localctx = new GrantRoleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 562, CypherCmdParser.RULE_grantRole);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3290;
                this.roleNames();
                this.state = 3291;
                this.match(CypherCmdParser.TO);
                this.state = 3292;
                this.userNames();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    revokeRole() {
        let localctx = new RevokeRoleContext(this, this._ctx, this.state);
        this.enterRule(localctx, 564, CypherCmdParser.RULE_revokeRole);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3294;
                this.roleNames();
                this.state = 3295;
                this.match(CypherCmdParser.FROM);
                this.state = 3296;
                this.userNames();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createUser() {
        let localctx = new CreateUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 566, CypherCmdParser.RULE_createUser);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3298;
                this.match(CypherCmdParser.USER);
                this.state = 3299;
                this.commandNameExpression();
                this.state = 3303;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3300;
                        this.match(CypherCmdParser.IF);
                        this.state = 3301;
                        this.match(CypherCmdParser.NOT);
                        this.state = 3302;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3314;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 3305;
                            this.match(CypherCmdParser.SET);
                            this.state = 3312;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 371, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 3306;
                                        this.password();
                                    }
                                    break;
                                case 2:
                                    {
                                        this.state = 3307;
                                        this.match(CypherCmdParser.PASSWORD);
                                        this.state = 3308;
                                        this.passwordChangeRequired();
                                    }
                                    break;
                                case 3:
                                    {
                                        this.state = 3309;
                                        this.userStatus();
                                    }
                                    break;
                                case 4:
                                    {
                                        this.state = 3310;
                                        this.homeDatabase();
                                    }
                                    break;
                                case 5:
                                    {
                                        this.state = 3311;
                                        this.setAuthClause();
                                    }
                                    break;
                            }
                        }
                    }
                    this.state = 3316;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 278);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropUser() {
        let localctx = new DropUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 568, CypherCmdParser.RULE_dropUser);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3318;
                this.match(CypherCmdParser.USER);
                this.state = 3319;
                this.commandNameExpression();
                this.state = 3322;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3320;
                        this.match(CypherCmdParser.IF);
                        this.state = 3321;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    renameUser() {
        let localctx = new RenameUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 570, CypherCmdParser.RULE_renameUser);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3324;
                this.match(CypherCmdParser.USER);
                this.state = 3325;
                this.commandNameExpression();
                this.state = 3328;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3326;
                        this.match(CypherCmdParser.IF);
                        this.state = 3327;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3330;
                this.match(CypherCmdParser.TO);
                this.state = 3331;
                this.commandNameExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterCurrentUser() {
        let localctx = new AlterCurrentUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 572, CypherCmdParser.RULE_alterCurrentUser);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3333;
                this.match(CypherCmdParser.CURRENT);
                this.state = 3334;
                this.match(CypherCmdParser.USER);
                this.state = 3335;
                this.match(CypherCmdParser.SET);
                this.state = 3336;
                this.match(CypherCmdParser.PASSWORD);
                this.state = 3337;
                this.match(CypherCmdParser.FROM);
                this.state = 3338;
                this.passwordExpression();
                this.state = 3339;
                this.match(CypherCmdParser.TO);
                this.state = 3340;
                this.passwordExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterUser() {
        let localctx = new AlterUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 574, CypherCmdParser.RULE_alterUser);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3342;
                this.match(CypherCmdParser.USER);
                this.state = 3343;
                this.commandNameExpression();
                this.state = 3346;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3344;
                        this.match(CypherCmdParser.IF);
                        this.state = 3345;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3361;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 251) {
                    {
                        {
                            this.state = 3348;
                            this.match(CypherCmdParser.REMOVE);
                            this.state = 3357;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 141:
                                    {
                                        this.state = 3349;
                                        this.match(CypherCmdParser.HOME);
                                        this.state = 3350;
                                        this.match(CypherCmdParser.DATABASE);
                                    }
                                    break;
                                case 33:
                                    {
                                        this.state = 3351;
                                        this.match(CypherCmdParser.ALL);
                                        this.state = 3352;
                                        this.match(CypherCmdParser.AUTH);
                                        this.state = 3354;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 237 || _la === 238) {
                                            {
                                                this.state = 3353;
                                                _la = this._input.LA(1);
                                                if (!(_la === 237 || _la === 238)) {
                                                    this._errHandler.recoverInline(this);
                                                }
                                                else {
                                                    this._errHandler.reportMatch(this);
                                                    this.consume();
                                                }
                                            }
                                        }
                                    }
                                    break;
                                case 44:
                                    {
                                        this.state = 3356;
                                        this.removeNamedProvider();
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                        }
                    }
                    this.state = 3363;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 3375;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 278) {
                    {
                        {
                            this.state = 3364;
                            this.match(CypherCmdParser.SET);
                            this.state = 3371;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 379, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 3365;
                                        this.password();
                                    }
                                    break;
                                case 2:
                                    {
                                        this.state = 3366;
                                        this.match(CypherCmdParser.PASSWORD);
                                        this.state = 3367;
                                        this.passwordChangeRequired();
                                    }
                                    break;
                                case 3:
                                    {
                                        this.state = 3368;
                                        this.userStatus();
                                    }
                                    break;
                                case 4:
                                    {
                                        this.state = 3369;
                                        this.homeDatabase();
                                    }
                                    break;
                                case 5:
                                    {
                                        this.state = 3370;
                                        this.setAuthClause();
                                    }
                                    break;
                            }
                        }
                    }
                    this.state = 3377;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    removeNamedProvider() {
        let localctx = new RemoveNamedProviderContext(this, this._ctx, this.state);
        this.enterRule(localctx, 576, CypherCmdParser.RULE_removeNamedProvider);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3378;
                this.match(CypherCmdParser.AUTH);
                this.state = 3380;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 237 || _la === 238) {
                    {
                        this.state = 3379;
                        _la = this._input.LA(1);
                        if (!(_la === 237 || _la === 238)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3385;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 22:
                    case 23:
                        {
                            this.state = 3382;
                            this.stringLiteral();
                        }
                        break;
                    case 170:
                        {
                            this.state = 3383;
                            this.stringListLiteral();
                        }
                        break;
                    case 92:
                        {
                            this.state = 3384;
                            this.parameter("ANY");
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    password() {
        let localctx = new PasswordContext(this, this._ctx, this.state);
        this.enterRule(localctx, 578, CypherCmdParser.RULE_password);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3388;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 109 || _la === 223) {
                    {
                        this.state = 3387;
                        _la = this._input.LA(1);
                        if (!(_la === 109 || _la === 223)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3390;
                this.match(CypherCmdParser.PASSWORD);
                this.state = 3391;
                this.passwordExpression();
                this.state = 3393;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 57) {
                    {
                        this.state = 3392;
                        this.passwordChangeRequired();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    passwordOnly() {
        let localctx = new PasswordOnlyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 580, CypherCmdParser.RULE_passwordOnly);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3396;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 109 || _la === 223) {
                    {
                        this.state = 3395;
                        _la = this._input.LA(1);
                        if (!(_la === 109 || _la === 223)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3398;
                this.match(CypherCmdParser.PASSWORD);
                this.state = 3399;
                this.passwordExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    passwordExpression() {
        let localctx = new PasswordExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 582, CypherCmdParser.RULE_passwordExpression);
        try {
            this.state = 3403;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 22:
                case 23:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3401;
                        this.stringLiteral();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3402;
                        this.parameter("STRING");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    passwordChangeRequired() {
        let localctx = new PasswordChangeRequiredContext(this, this._ctx, this.state);
        this.enterRule(localctx, 584, CypherCmdParser.RULE_passwordChangeRequired);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3405;
                this.match(CypherCmdParser.CHANGE);
                this.state = 3407;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 206) {
                    {
                        this.state = 3406;
                        this.match(CypherCmdParser.NOT);
                    }
                }
                this.state = 3409;
                this.match(CypherCmdParser.REQUIRED);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    userStatus() {
        let localctx = new UserStatusContext(this, this._ctx, this.state);
        this.enterRule(localctx, 586, CypherCmdParser.RULE_userStatus);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3411;
                this.match(CypherCmdParser.STATUS);
                this.state = 3412;
                _la = this._input.LA(1);
                if (!(_la === 26 || _la === 295)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    homeDatabase() {
        let localctx = new HomeDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 588, CypherCmdParser.RULE_homeDatabase);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3414;
                this.match(CypherCmdParser.HOME);
                this.state = 3415;
                this.match(CypherCmdParser.DATABASE);
                this.state = 3416;
                this.symbolicAliasNameOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    setAuthClause() {
        let localctx = new SetAuthClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 590, CypherCmdParser.RULE_setAuthClause);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3418;
                this.match(CypherCmdParser.AUTH);
                this.state = 3420;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 237) {
                    {
                        this.state = 3419;
                        this.match(CypherCmdParser.PROVIDER);
                    }
                }
                this.state = 3422;
                this.stringLiteral();
                this.state = 3423;
                this.match(CypherCmdParser.LCURLY);
                this.state = 3426;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 3424;
                            this.match(CypherCmdParser.SET);
                            {
                                this.state = 3425;
                                this.userAuthAttribute();
                            }
                        }
                    }
                    this.state = 3428;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 278);
                this.state = 3430;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    userAuthAttribute() {
        let localctx = new UserAuthAttributeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 592, CypherCmdParser.RULE_userAuthAttribute);
        try {
            this.state = 3437;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 390, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3432;
                        this.match(CypherCmdParser.ID);
                        this.state = 3433;
                        this.stringOrParameterExpression();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3434;
                        this.passwordOnly();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3435;
                        this.match(CypherCmdParser.PASSWORD);
                        this.state = 3436;
                        this.passwordChangeRequired();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showUsers() {
        let localctx = new ShowUsersContext(this, this._ctx, this.state);
        this.enterRule(localctx, 594, CypherCmdParser.RULE_showUsers);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3439;
                _la = this._input.LA(1);
                if (!(_la === 321 || _la === 322)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 3442;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 331) {
                    {
                        this.state = 3440;
                        this.match(CypherCmdParser.WITH);
                        this.state = 3441;
                        this.match(CypherCmdParser.AUTH);
                    }
                }
                this.state = 3445;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3444;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showCurrentUser() {
        let localctx = new ShowCurrentUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 596, CypherCmdParser.RULE_showCurrentUser);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3447;
                this.match(CypherCmdParser.CURRENT);
                this.state = 3448;
                this.match(CypherCmdParser.USER);
                this.state = 3450;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3449;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showSupportedPrivileges() {
        let localctx = new ShowSupportedPrivilegesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 598, CypherCmdParser.RULE_showSupportedPrivileges);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3452;
                this.match(CypherCmdParser.SUPPORTED);
                this.state = 3453;
                this.privilegeToken();
                this.state = 3455;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3454;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showPrivileges() {
        let localctx = new ShowPrivilegesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 600, CypherCmdParser.RULE_showPrivileges);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3458;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 33) {
                    {
                        this.state = 3457;
                        this.match(CypherCmdParser.ALL);
                    }
                }
                this.state = 3460;
                this.privilegeToken();
                this.state = 3462;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 3461;
                        this.privilegeAsCommand();
                    }
                }
                this.state = 3465;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3464;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showRolePrivileges() {
        let localctx = new ShowRolePrivilegesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 602, CypherCmdParser.RULE_showRolePrivileges);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3467;
                _la = this._input.LA(1);
                if (!(_la === 263 || _la === 264)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 3468;
                this.roleNames();
                this.state = 3469;
                this.privilegeToken();
                this.state = 3471;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 3470;
                        this.privilegeAsCommand();
                    }
                }
                this.state = 3474;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3473;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showUserPrivileges() {
        let localctx = new ShowUserPrivilegesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 604, CypherCmdParser.RULE_showUserPrivileges);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3476;
                _la = this._input.LA(1);
                if (!(_la === 321 || _la === 322)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 3478;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 400, this._ctx)) {
                    case 1:
                        {
                            this.state = 3477;
                            this.userNames();
                        }
                        break;
                }
                this.state = 3480;
                this.privilegeToken();
                this.state = 3482;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 39) {
                    {
                        this.state = 3481;
                        this.privilegeAsCommand();
                    }
                }
                this.state = 3485;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 3484;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    privilegeAsCommand() {
        let localctx = new PrivilegeAsCommandContext(this, this._ctx, this.state);
        this.enterRule(localctx, 606, CypherCmdParser.RULE_privilegeAsCommand);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3487;
                this.match(CypherCmdParser.AS);
                this.state = 3489;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 262) {
                    {
                        this.state = 3488;
                        this.match(CypherCmdParser.REVOKE);
                    }
                }
                this.state = 3491;
                _la = this._input.LA(1);
                if (!(_la === 63 || _la === 64)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    privilegeToken() {
        let localctx = new PrivilegeTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 608, CypherCmdParser.RULE_privilegeToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3493;
                _la = this._input.LA(1);
                if (!(_la === 231 || _la === 232)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    privilege() {
        let localctx = new PrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 610, CypherCmdParser.RULE_privilege);
        try {
            this.state = 3506;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 33:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3495;
                        this.allPrivilege();
                    }
                    break;
                case 73:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3496;
                        this.createPrivilege();
                    }
                    break;
                case 25:
                case 67:
                case 68:
                case 147:
                case 148:
                case 191:
                case 289:
                case 292:
                case 297:
                case 307:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3497;
                        this.databasePrivilege();
                    }
                    break;
                case 30:
                case 35:
                case 42:
                case 65:
                case 77:
                case 114:
                case 144:
                case 231:
                case 246:
                case 263:
                case 276:
                case 321:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 3498;
                        this.dbmsPrivilege();
                    }
                    break;
                case 99:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 3499;
                        this.dropPrivilege();
                    }
                    break;
                case 177:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 3500;
                        this.loadPrivilege();
                    }
                    break;
                case 85:
                case 184:
                case 185:
                case 243:
                case 309:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 3501;
                        this.qualifiedGraphPrivileges();
                    }
                    break;
                case 251:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 3502;
                        this.removePrivilege();
                    }
                    break;
                case 278:
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 3503;
                        this.setPrivilege();
                    }
                    break;
                case 285:
                    this.enterOuterAlt(localctx, 10);
                    {
                        this.state = 3504;
                        this.showPrivilege();
                    }
                    break;
                case 333:
                    this.enterOuterAlt(localctx, 11);
                    {
                        this.state = 3505;
                        this.writePrivilege();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    allPrivilege() {
        let localctx = new AllPrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 612, CypherCmdParser.RULE_allPrivilege);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3508;
                this.match(CypherCmdParser.ALL);
                this.state = 3510;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 77 || _la === 81 || _la === 135 || _la === 232) {
                    {
                        this.state = 3509;
                        this.allPrivilegeType();
                    }
                }
                this.state = 3512;
                this.match(CypherCmdParser.ON);
                this.state = 3513;
                this.allPrivilegeTarget();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    allPrivilegeType() {
        let localctx = new AllPrivilegeTypeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 614, CypherCmdParser.RULE_allPrivilegeType);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3516;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 77 || _la === 81 || _la === 135) {
                    {
                        this.state = 3515;
                        _la = this._input.LA(1);
                        if (!(_la === 77 || _la === 81 || _la === 135)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 3518;
                this.match(CypherCmdParser.PRIVILEGES);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    allPrivilegeTarget() {
        let localctx = new AllPrivilegeTargetContext(this, this._ctx, this.state);
        this.enterRule(localctx, 616, CypherCmdParser.RULE_allPrivilegeTarget);
        let _la;
        try {
            this.state = 3533;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 141:
                    localctx = new DefaultTargetContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3520;
                        this.match(CypherCmdParser.HOME);
                        this.state = 3521;
                        _la = this._input.LA(1);
                        if (!(_la === 77 || _la === 135)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                    break;
                case 77:
                case 78:
                    localctx = new DatabaseVariableTargetContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3522;
                        _la = this._input.LA(1);
                        if (!(_la === 77 || _la === 78)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 3525;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 301:
                                {
                                    this.state = 3523;
                                    this.match(CypherCmdParser.TIMES);
                                }
                                break;
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 12:
                            case 13:
                            case 14:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 46:
                            case 47:
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 63:
                            case 64:
                            case 65:
                            case 66:
                            case 67:
                            case 68:
                            case 69:
                            case 70:
                            case 71:
                            case 72:
                            case 73:
                            case 74:
                            case 75:
                            case 76:
                            case 77:
                            case 78:
                            case 79:
                            case 80:
                            case 81:
                            case 82:
                            case 83:
                            case 84:
                            case 85:
                            case 86:
                            case 87:
                            case 88:
                            case 89:
                            case 90:
                            case 91:
                            case 92:
                            case 93:
                            case 98:
                            case 99:
                            case 100:
                            case 101:
                            case 102:
                            case 103:
                            case 104:
                            case 105:
                            case 106:
                            case 107:
                            case 108:
                            case 109:
                            case 110:
                            case 111:
                            case 113:
                            case 114:
                            case 115:
                            case 116:
                            case 117:
                            case 118:
                            case 119:
                            case 120:
                            case 121:
                            case 122:
                            case 123:
                            case 124:
                            case 125:
                            case 126:
                            case 127:
                            case 128:
                            case 129:
                            case 130:
                            case 131:
                            case 132:
                            case 134:
                            case 135:
                            case 136:
                            case 137:
                            case 138:
                            case 140:
                            case 141:
                            case 142:
                            case 143:
                            case 144:
                            case 145:
                            case 146:
                            case 147:
                            case 148:
                            case 149:
                            case 150:
                            case 151:
                            case 152:
                            case 153:
                            case 154:
                            case 155:
                            case 156:
                            case 157:
                            case 158:
                            case 159:
                            case 160:
                            case 161:
                            case 162:
                            case 163:
                            case 164:
                            case 165:
                            case 166:
                            case 169:
                            case 173:
                            case 174:
                            case 175:
                            case 176:
                            case 177:
                            case 178:
                            case 179:
                            case 182:
                            case 183:
                            case 184:
                            case 185:
                            case 188:
                            case 191:
                            case 192:
                            case 193:
                            case 194:
                            case 195:
                            case 196:
                            case 197:
                            case 198:
                            case 199:
                            case 200:
                            case 201:
                            case 202:
                            case 203:
                            case 204:
                            case 205:
                            case 206:
                            case 207:
                            case 208:
                            case 209:
                            case 210:
                            case 211:
                            case 212:
                            case 213:
                            case 214:
                            case 215:
                            case 216:
                            case 217:
                            case 218:
                            case 219:
                            case 220:
                            case 221:
                            case 222:
                            case 223:
                            case 226:
                            case 227:
                            case 229:
                            case 230:
                            case 231:
                            case 232:
                            case 233:
                            case 234:
                            case 235:
                            case 236:
                            case 237:
                            case 238:
                            case 240:
                            case 243:
                            case 244:
                            case 245:
                            case 246:
                            case 248:
                            case 249:
                            case 250:
                            case 251:
                            case 252:
                            case 253:
                            case 254:
                            case 255:
                            case 256:
                            case 257:
                            case 258:
                            case 259:
                            case 260:
                            case 261:
                            case 262:
                            case 263:
                            case 264:
                            case 265:
                            case 266:
                            case 268:
                            case 269:
                            case 270:
                            case 271:
                            case 272:
                            case 273:
                            case 274:
                            case 276:
                            case 277:
                            case 278:
                            case 279:
                            case 280:
                            case 281:
                            case 282:
                            case 283:
                            case 284:
                            case 285:
                            case 286:
                            case 287:
                            case 288:
                            case 289:
                            case 290:
                            case 291:
                            case 292:
                            case 293:
                            case 294:
                            case 295:
                            case 296:
                            case 297:
                            case 298:
                            case 299:
                            case 300:
                            case 302:
                            case 303:
                            case 304:
                            case 305:
                            case 306:
                            case 307:
                            case 308:
                            case 309:
                            case 310:
                            case 311:
                            case 312:
                            case 313:
                            case 314:
                            case 315:
                            case 316:
                            case 317:
                            case 318:
                            case 319:
                            case 320:
                            case 321:
                            case 322:
                            case 323:
                            case 324:
                            case 325:
                            case 326:
                            case 327:
                            case 328:
                            case 329:
                            case 330:
                            case 331:
                            case 332:
                            case 333:
                            case 334:
                            case 335:
                            case 336:
                            case 337:
                            case 338:
                                {
                                    this.state = 3524;
                                    this.symbolicAliasNameList();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                case 135:
                case 136:
                    localctx = new GraphVariableTargetContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3527;
                        _la = this._input.LA(1);
                        if (!(_la === 135 || _la === 136)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 3530;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 301:
                                {
                                    this.state = 3528;
                                    this.match(CypherCmdParser.TIMES);
                                }
                                break;
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 12:
                            case 13:
                            case 14:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 46:
                            case 47:
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 63:
                            case 64:
                            case 65:
                            case 66:
                            case 67:
                            case 68:
                            case 69:
                            case 70:
                            case 71:
                            case 72:
                            case 73:
                            case 74:
                            case 75:
                            case 76:
                            case 77:
                            case 78:
                            case 79:
                            case 80:
                            case 81:
                            case 82:
                            case 83:
                            case 84:
                            case 85:
                            case 86:
                            case 87:
                            case 88:
                            case 89:
                            case 90:
                            case 91:
                            case 92:
                            case 93:
                            case 98:
                            case 99:
                            case 100:
                            case 101:
                            case 102:
                            case 103:
                            case 104:
                            case 105:
                            case 106:
                            case 107:
                            case 108:
                            case 109:
                            case 110:
                            case 111:
                            case 113:
                            case 114:
                            case 115:
                            case 116:
                            case 117:
                            case 118:
                            case 119:
                            case 120:
                            case 121:
                            case 122:
                            case 123:
                            case 124:
                            case 125:
                            case 126:
                            case 127:
                            case 128:
                            case 129:
                            case 130:
                            case 131:
                            case 132:
                            case 134:
                            case 135:
                            case 136:
                            case 137:
                            case 138:
                            case 140:
                            case 141:
                            case 142:
                            case 143:
                            case 144:
                            case 145:
                            case 146:
                            case 147:
                            case 148:
                            case 149:
                            case 150:
                            case 151:
                            case 152:
                            case 153:
                            case 154:
                            case 155:
                            case 156:
                            case 157:
                            case 158:
                            case 159:
                            case 160:
                            case 161:
                            case 162:
                            case 163:
                            case 164:
                            case 165:
                            case 166:
                            case 169:
                            case 173:
                            case 174:
                            case 175:
                            case 176:
                            case 177:
                            case 178:
                            case 179:
                            case 182:
                            case 183:
                            case 184:
                            case 185:
                            case 188:
                            case 191:
                            case 192:
                            case 193:
                            case 194:
                            case 195:
                            case 196:
                            case 197:
                            case 198:
                            case 199:
                            case 200:
                            case 201:
                            case 202:
                            case 203:
                            case 204:
                            case 205:
                            case 206:
                            case 207:
                            case 208:
                            case 209:
                            case 210:
                            case 211:
                            case 212:
                            case 213:
                            case 214:
                            case 215:
                            case 216:
                            case 217:
                            case 218:
                            case 219:
                            case 220:
                            case 221:
                            case 222:
                            case 223:
                            case 226:
                            case 227:
                            case 229:
                            case 230:
                            case 231:
                            case 232:
                            case 233:
                            case 234:
                            case 235:
                            case 236:
                            case 237:
                            case 238:
                            case 240:
                            case 243:
                            case 244:
                            case 245:
                            case 246:
                            case 248:
                            case 249:
                            case 250:
                            case 251:
                            case 252:
                            case 253:
                            case 254:
                            case 255:
                            case 256:
                            case 257:
                            case 258:
                            case 259:
                            case 260:
                            case 261:
                            case 262:
                            case 263:
                            case 264:
                            case 265:
                            case 266:
                            case 268:
                            case 269:
                            case 270:
                            case 271:
                            case 272:
                            case 273:
                            case 274:
                            case 276:
                            case 277:
                            case 278:
                            case 279:
                            case 280:
                            case 281:
                            case 282:
                            case 283:
                            case 284:
                            case 285:
                            case 286:
                            case 287:
                            case 288:
                            case 289:
                            case 290:
                            case 291:
                            case 292:
                            case 293:
                            case 294:
                            case 295:
                            case 296:
                            case 297:
                            case 298:
                            case 299:
                            case 300:
                            case 302:
                            case 303:
                            case 304:
                            case 305:
                            case 306:
                            case 307:
                            case 308:
                            case 309:
                            case 310:
                            case 311:
                            case 312:
                            case 313:
                            case 314:
                            case 315:
                            case 316:
                            case 317:
                            case 318:
                            case 319:
                            case 320:
                            case 321:
                            case 322:
                            case 323:
                            case 324:
                            case 325:
                            case 326:
                            case 327:
                            case 328:
                            case 329:
                            case 330:
                            case 331:
                            case 332:
                            case 333:
                            case 334:
                            case 335:
                            case 336:
                            case 337:
                            case 338:
                                {
                                    this.state = 3529;
                                    this.symbolicAliasNameList();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                case 81:
                    localctx = new DBMSTargetContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 3532;
                        this.match(CypherCmdParser.DBMS);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createPrivilege() {
        let localctx = new CreatePrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 618, CypherCmdParser.RULE_createPrivilege);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3535;
                this.match(CypherCmdParser.CREATE);
                this.state = 3548;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 67:
                    case 68:
                    case 147:
                    case 148:
                    case 198:
                        {
                            this.state = 3536;
                            this.createPrivilegeForDatabase();
                            this.state = 3537;
                            this.match(CypherCmdParser.ON);
                            this.state = 3538;
                            this.databaseScope();
                        }
                        break;
                    case 30:
                    case 65:
                    case 77:
                    case 263:
                    case 321:
                        {
                            this.state = 3540;
                            this.actionForDBMS();
                            this.state = 3541;
                            this.match(CypherCmdParser.ON);
                            this.state = 3542;
                            this.match(CypherCmdParser.DBMS);
                        }
                        break;
                    case 212:
                        {
                            this.state = 3544;
                            this.match(CypherCmdParser.ON);
                            this.state = 3545;
                            this.graphScope();
                            this.state = 3546;
                            this.graphQualifier();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createPrivilegeForDatabase() {
        let localctx = new CreatePrivilegeForDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 620, CypherCmdParser.RULE_createPrivilegeForDatabase);
        try {
            this.state = 3555;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 411, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3550;
                        this.indexToken();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3551;
                        this.constraintToken();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3552;
                        this.createNodePrivilegeToken();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 3553;
                        this.createRelPrivilegeToken();
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 3554;
                        this.createPropertyPrivilegeToken();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createNodePrivilegeToken() {
        let localctx = new CreateNodePrivilegeTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 622, CypherCmdParser.RULE_createNodePrivilegeToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3557;
                this.match(CypherCmdParser.NEW);
                this.state = 3559;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 200) {
                    {
                        this.state = 3558;
                        this.match(CypherCmdParser.NODE);
                    }
                }
                this.state = 3561;
                _la = this._input.LA(1);
                if (!(_la === 165 || _la === 166)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createRelPrivilegeToken() {
        let localctx = new CreateRelPrivilegeTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 624, CypherCmdParser.RULE_createRelPrivilegeToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3563;
                this.match(CypherCmdParser.NEW);
                this.state = 3565;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 249) {
                    {
                        this.state = 3564;
                        this.match(CypherCmdParser.RELATIONSHIP);
                    }
                }
                this.state = 3567;
                _la = this._input.LA(1);
                if (!(_la === 312 || _la === 314)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createPropertyPrivilegeToken() {
        let localctx = new CreatePropertyPrivilegeTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 626, CypherCmdParser.RULE_createPropertyPrivilegeToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3569;
                this.match(CypherCmdParser.NEW);
                this.state = 3571;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 236) {
                    {
                        this.state = 3570;
                        this.match(CypherCmdParser.PROPERTY);
                    }
                }
                this.state = 3573;
                _la = this._input.LA(1);
                if (!(_la === 191 || _la === 192)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    actionForDBMS() {
        let localctx = new ActionForDBMSContext(this, this._ctx, this.state);
        this.enterRule(localctx, 628, CypherCmdParser.RULE_actionForDBMS);
        let _la;
        try {
            this.state = 3582;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 30:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3575;
                        this.match(CypherCmdParser.ALIAS);
                    }
                    break;
                case 65:
                case 77:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3577;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 65) {
                            {
                                this.state = 3576;
                                this.match(CypherCmdParser.COMPOSITE);
                            }
                        }
                        this.state = 3579;
                        this.match(CypherCmdParser.DATABASE);
                    }
                    break;
                case 263:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3580;
                        this.match(CypherCmdParser.ROLE);
                    }
                    break;
                case 321:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 3581;
                        this.match(CypherCmdParser.USER);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropPrivilege() {
        let localctx = new DropPrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 630, CypherCmdParser.RULE_dropPrivilege);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3584;
                this.match(CypherCmdParser.DROP);
                this.state = 3596;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 67:
                    case 68:
                    case 147:
                    case 148:
                        {
                            this.state = 3587;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 147:
                                case 148:
                                    {
                                        this.state = 3585;
                                        this.indexToken();
                                    }
                                    break;
                                case 67:
                                case 68:
                                    {
                                        this.state = 3586;
                                        this.constraintToken();
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3589;
                            this.match(CypherCmdParser.ON);
                            this.state = 3590;
                            this.databaseScope();
                        }
                        break;
                    case 30:
                    case 65:
                    case 77:
                    case 263:
                    case 321:
                        {
                            this.state = 3592;
                            this.actionForDBMS();
                            this.state = 3593;
                            this.match(CypherCmdParser.ON);
                            this.state = 3594;
                            this.match(CypherCmdParser.DBMS);
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    loadPrivilege() {
        let localctx = new LoadPrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 632, CypherCmdParser.RULE_loadPrivilege);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3598;
                this.match(CypherCmdParser.LOAD);
                this.state = 3599;
                this.match(CypherCmdParser.ON);
                this.state = 3604;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 58:
                    case 319:
                        {
                            this.state = 3600;
                            _la = this._input.LA(1);
                            if (!(_la === 58 || _la === 319)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 3601;
                            this.stringOrParameter();
                        }
                        break;
                    case 33:
                        {
                            this.state = 3602;
                            this.match(CypherCmdParser.ALL);
                            this.state = 3603;
                            this.match(CypherCmdParser.DATA);
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showPrivilege() {
        let localctx = new ShowPrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 634, CypherCmdParser.RULE_showPrivilege);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3606;
                this.match(CypherCmdParser.SHOW);
                this.state = 3631;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 67:
                    case 68:
                    case 147:
                    case 148:
                    case 307:
                    case 308:
                        {
                            this.state = 3613;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 147:
                                case 148:
                                    {
                                        this.state = 3607;
                                        this.indexToken();
                                    }
                                    break;
                                case 67:
                                case 68:
                                    {
                                        this.state = 3608;
                                        this.constraintToken();
                                    }
                                    break;
                                case 307:
                                case 308:
                                    {
                                        this.state = 3609;
                                        this.transactionToken();
                                        this.state = 3611;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 180) {
                                            {
                                                this.state = 3610;
                                                this.userQualifier();
                                            }
                                        }
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3615;
                            this.match(CypherCmdParser.ON);
                            this.state = 3616;
                            this.databaseScope();
                        }
                        break;
                    case 30:
                    case 231:
                    case 263:
                    case 276:
                    case 277:
                    case 279:
                    case 280:
                    case 321:
                        {
                            this.state = 3627;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 30:
                                    {
                                        this.state = 3618;
                                        this.match(CypherCmdParser.ALIAS);
                                    }
                                    break;
                                case 231:
                                    {
                                        this.state = 3619;
                                        this.match(CypherCmdParser.PRIVILEGE);
                                    }
                                    break;
                                case 263:
                                    {
                                        this.state = 3620;
                                        this.match(CypherCmdParser.ROLE);
                                    }
                                    break;
                                case 276:
                                    {
                                        this.state = 3621;
                                        this.match(CypherCmdParser.SERVER);
                                    }
                                    break;
                                case 277:
                                    {
                                        this.state = 3622;
                                        this.match(CypherCmdParser.SERVERS);
                                    }
                                    break;
                                case 279:
                                case 280:
                                    {
                                        this.state = 3623;
                                        this.settingToken();
                                        this.state = 3624;
                                        this.settingQualifier();
                                    }
                                    break;
                                case 321:
                                    {
                                        this.state = 3626;
                                        this.match(CypherCmdParser.USER);
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3629;
                            this.match(CypherCmdParser.ON);
                            this.state = 3630;
                            this.match(CypherCmdParser.DBMS);
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    setPrivilege() {
        let localctx = new SetPrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 636, CypherCmdParser.RULE_setPrivilege);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3633;
                this.match(CypherCmdParser.SET);
                this.state = 3663;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 44:
                    case 77:
                    case 219:
                    case 220:
                    case 321:
                        {
                            this.state = 3648;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 219:
                                case 220:
                                    {
                                        this.state = 3634;
                                        this.passwordToken();
                                    }
                                    break;
                                case 321:
                                    {
                                        this.state = 3635;
                                        this.match(CypherCmdParser.USER);
                                        this.state = 3639;
                                        this._errHandler.sync(this);
                                        switch (this._input.LA(1)) {
                                            case 291:
                                                {
                                                    this.state = 3636;
                                                    this.match(CypherCmdParser.STATUS);
                                                }
                                                break;
                                            case 141:
                                                {
                                                    this.state = 3637;
                                                    this.match(CypherCmdParser.HOME);
                                                    this.state = 3638;
                                                    this.match(CypherCmdParser.DATABASE);
                                                }
                                                break;
                                            default:
                                                throw new NoViableAltException(this);
                                        }
                                    }
                                    break;
                                case 77:
                                    {
                                        this.state = 3641;
                                        this.match(CypherCmdParser.DATABASE);
                                        this.state = 3645;
                                        this._errHandler.sync(this);
                                        switch (this._input.LA(1)) {
                                            case 25:
                                                {
                                                    this.state = 3642;
                                                    this.match(CypherCmdParser.ACCESS);
                                                }
                                                break;
                                            case 83:
                                                {
                                                    this.state = 3643;
                                                    this.match(CypherCmdParser.DEFAULT);
                                                    this.state = 3644;
                                                    this.match(CypherCmdParser.LANGUAGE);
                                                }
                                                break;
                                            default:
                                                throw new NoViableAltException(this);
                                        }
                                    }
                                    break;
                                case 44:
                                    {
                                        this.state = 3647;
                                        this.match(CypherCmdParser.AUTH);
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3650;
                            this.match(CypherCmdParser.ON);
                            this.state = 3651;
                            this.match(CypherCmdParser.DBMS);
                        }
                        break;
                    case 165:
                        {
                            this.state = 3652;
                            this.match(CypherCmdParser.LABEL);
                            this.state = 3653;
                            this.labelsResource();
                            this.state = 3654;
                            this.match(CypherCmdParser.ON);
                            this.state = 3655;
                            this.graphScope();
                        }
                        break;
                    case 236:
                        {
                            this.state = 3657;
                            this.match(CypherCmdParser.PROPERTY);
                            this.state = 3658;
                            this.propertiesResource();
                            this.state = 3659;
                            this.match(CypherCmdParser.ON);
                            this.state = 3660;
                            this.graphScope();
                            this.state = 3661;
                            this.graphQualifier();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    passwordToken() {
        let localctx = new PasswordTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 638, CypherCmdParser.RULE_passwordToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3665;
                _la = this._input.LA(1);
                if (!(_la === 219 || _la === 220)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    removePrivilege() {
        let localctx = new RemovePrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 640, CypherCmdParser.RULE_removePrivilege);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3667;
                this.match(CypherCmdParser.REMOVE);
                this.state = 3676;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 231:
                    case 263:
                        {
                            this.state = 3668;
                            _la = this._input.LA(1);
                            if (!(_la === 231 || _la === 263)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 3669;
                            this.match(CypherCmdParser.ON);
                            this.state = 3670;
                            this.match(CypherCmdParser.DBMS);
                        }
                        break;
                    case 165:
                        {
                            this.state = 3671;
                            this.match(CypherCmdParser.LABEL);
                            this.state = 3672;
                            this.labelsResource();
                            this.state = 3673;
                            this.match(CypherCmdParser.ON);
                            this.state = 3674;
                            this.graphScope();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    writePrivilege() {
        let localctx = new WritePrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 642, CypherCmdParser.RULE_writePrivilege);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3678;
                this.match(CypherCmdParser.WRITE);
                this.state = 3679;
                this.match(CypherCmdParser.ON);
                this.state = 3680;
                this.graphScope();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    databasePrivilege() {
        let localctx = new DatabasePrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 644, CypherCmdParser.RULE_databasePrivilege);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3704;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 25:
                        {
                            this.state = 3682;
                            this.match(CypherCmdParser.ACCESS);
                        }
                        break;
                    case 289:
                        {
                            this.state = 3683;
                            this.match(CypherCmdParser.START);
                        }
                        break;
                    case 292:
                        {
                            this.state = 3684;
                            this.match(CypherCmdParser.STOP);
                        }
                        break;
                    case 67:
                    case 68:
                    case 147:
                    case 148:
                    case 191:
                        {
                            this.state = 3688;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 147:
                                case 148:
                                    {
                                        this.state = 3685;
                                        this.indexToken();
                                    }
                                    break;
                                case 67:
                                case 68:
                                    {
                                        this.state = 3686;
                                        this.constraintToken();
                                    }
                                    break;
                                case 191:
                                    {
                                        this.state = 3687;
                                        this.match(CypherCmdParser.NAME);
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3691;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 182) {
                                {
                                    this.state = 3690;
                                    this.match(CypherCmdParser.MANAGEMENT);
                                }
                            }
                        }
                        break;
                    case 297:
                    case 307:
                        {
                            this.state = 3699;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 307:
                                    {
                                        this.state = 3693;
                                        this.match(CypherCmdParser.TRANSACTION);
                                        this.state = 3695;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 182) {
                                            {
                                                this.state = 3694;
                                                this.match(CypherCmdParser.MANAGEMENT);
                                            }
                                        }
                                    }
                                    break;
                                case 297:
                                    {
                                        this.state = 3697;
                                        this.match(CypherCmdParser.TERMINATE);
                                        this.state = 3698;
                                        this.transactionToken();
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3702;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 180) {
                                {
                                    this.state = 3701;
                                    this.userQualifier();
                                }
                            }
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 3706;
                this.match(CypherCmdParser.ON);
                this.state = 3707;
                this.databaseScope();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dbmsPrivilege() {
        let localctx = new DbmsPrivilegeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 646, CypherCmdParser.RULE_dbmsPrivilege);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3739;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 35:
                        {
                            this.state = 3709;
                            this.match(CypherCmdParser.ALTER);
                            this.state = 3716;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 30:
                                    {
                                        this.state = 3710;
                                        this.match(CypherCmdParser.ALIAS);
                                    }
                                    break;
                                case 65:
                                case 77:
                                    {
                                        this.state = 3712;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 65) {
                                            {
                                                this.state = 3711;
                                                this.match(CypherCmdParser.COMPOSITE);
                                            }
                                        }
                                        this.state = 3714;
                                        this.match(CypherCmdParser.DATABASE);
                                    }
                                    break;
                                case 321:
                                    {
                                        this.state = 3715;
                                        this.match(CypherCmdParser.USER);
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                        }
                        break;
                    case 42:
                        {
                            this.state = 3718;
                            this.match(CypherCmdParser.ASSIGN);
                            this.state = 3719;
                            _la = this._input.LA(1);
                            if (!(_la === 231 || _la === 263)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        }
                        break;
                    case 30:
                    case 65:
                    case 77:
                    case 231:
                    case 263:
                    case 276:
                    case 321:
                        {
                            this.state = 3729;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 30:
                                    {
                                        this.state = 3720;
                                        this.match(CypherCmdParser.ALIAS);
                                    }
                                    break;
                                case 65:
                                case 77:
                                    {
                                        this.state = 3722;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 65) {
                                            {
                                                this.state = 3721;
                                                this.match(CypherCmdParser.COMPOSITE);
                                            }
                                        }
                                        this.state = 3724;
                                        this.match(CypherCmdParser.DATABASE);
                                    }
                                    break;
                                case 231:
                                    {
                                        this.state = 3725;
                                        this.match(CypherCmdParser.PRIVILEGE);
                                    }
                                    break;
                                case 263:
                                    {
                                        this.state = 3726;
                                        this.match(CypherCmdParser.ROLE);
                                    }
                                    break;
                                case 276:
                                    {
                                        this.state = 3727;
                                        this.match(CypherCmdParser.SERVER);
                                    }
                                    break;
                                case 321:
                                    {
                                        this.state = 3728;
                                        this.match(CypherCmdParser.USER);
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                            this.state = 3731;
                            this.match(CypherCmdParser.MANAGEMENT);
                        }
                        break;
                    case 114:
                        {
                            this.state = 3732;
                            this.dbmsPrivilegeExecute();
                        }
                        break;
                    case 246:
                        {
                            this.state = 3733;
                            this.match(CypherCmdParser.RENAME);
                            this.state = 3734;
                            _la = this._input.LA(1);
                            if (!(_la === 263 || _la === 321)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        }
                        break;
                    case 144:
                        {
                            this.state = 3735;
                            this.match(CypherCmdParser.IMPERSONATE);
                            this.state = 3737;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 180) {
                                {
                                    this.state = 3736;
                                    this.userQualifier();
                                }
                            }
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 3741;
                this.match(CypherCmdParser.ON);
                this.state = 3742;
                this.match(CypherCmdParser.DBMS);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dbmsPrivilegeExecute() {
        let localctx = new DbmsPrivilegeExecuteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 648, CypherCmdParser.RULE_dbmsPrivilegeExecute);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3744;
                this.match(CypherCmdParser.EXECUTE);
                this.state = 3765;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 28:
                    case 29:
                        {
                            this.state = 3745;
                            this.adminToken();
                            this.state = 3746;
                            this.match(CypherCmdParser.PROCEDURES);
                        }
                        break;
                    case 49:
                    case 131:
                    case 132:
                    case 233:
                    case 234:
                    case 321:
                        {
                            this.state = 3749;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 49) {
                                {
                                    this.state = 3748;
                                    this.match(CypherCmdParser.BOOSTED);
                                }
                            }
                            this.state = 3763;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 233:
                                case 234:
                                    {
                                        this.state = 3751;
                                        this.procedureToken();
                                        this.state = 3752;
                                        this.executeProcedureQualifier();
                                    }
                                    break;
                                case 131:
                                case 132:
                                case 321:
                                    {
                                        this.state = 3758;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 321) {
                                            {
                                                this.state = 3754;
                                                this.match(CypherCmdParser.USER);
                                                this.state = 3756;
                                                this._errHandler.sync(this);
                                                _la = this._input.LA(1);
                                                if (_la === 84) {
                                                    {
                                                        this.state = 3755;
                                                        this.match(CypherCmdParser.DEFINED);
                                                    }
                                                }
                                            }
                                        }
                                        this.state = 3760;
                                        this.functionToken();
                                        this.state = 3761;
                                        this.executeFunctionQualifier();
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    adminToken() {
        let localctx = new AdminTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 650, CypherCmdParser.RULE_adminToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3767;
                _la = this._input.LA(1);
                if (!(_la === 28 || _la === 29)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    procedureToken() {
        let localctx = new ProcedureTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 652, CypherCmdParser.RULE_procedureToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3769;
                _la = this._input.LA(1);
                if (!(_la === 233 || _la === 234)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    indexToken() {
        let localctx = new IndexTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 654, CypherCmdParser.RULE_indexToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3771;
                _la = this._input.LA(1);
                if (!(_la === 147 || _la === 148)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    constraintToken() {
        let localctx = new ConstraintTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 656, CypherCmdParser.RULE_constraintToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3773;
                _la = this._input.LA(1);
                if (!(_la === 67 || _la === 68)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    transactionToken() {
        let localctx = new TransactionTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 658, CypherCmdParser.RULE_transactionToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3775;
                _la = this._input.LA(1);
                if (!(_la === 307 || _la === 308)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    userQualifier() {
        let localctx = new UserQualifierContext(this, this._ctx, this.state);
        this.enterRule(localctx, 660, CypherCmdParser.RULE_userQualifier);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3777;
                this.match(CypherCmdParser.LPAREN);
                this.state = 3780;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 301:
                        {
                            this.state = 3778;
                            this.match(CypherCmdParser.TIMES);
                        }
                        break;
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 3779;
                            this.userNames();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 3782;
                this.match(CypherCmdParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    executeFunctionQualifier() {
        let localctx = new ExecuteFunctionQualifierContext(this, this._ctx, this.state);
        this.enterRule(localctx, 662, CypherCmdParser.RULE_executeFunctionQualifier);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3784;
                this.globs();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    executeProcedureQualifier() {
        let localctx = new ExecuteProcedureQualifierContext(this, this._ctx, this.state);
        this.enterRule(localctx, 664, CypherCmdParser.RULE_executeProcedureQualifier);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3786;
                this.globs();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    settingQualifier() {
        let localctx = new SettingQualifierContext(this, this._ctx, this.state);
        this.enterRule(localctx, 666, CypherCmdParser.RULE_settingQualifier);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3788;
                this.globs();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    globs() {
        let localctx = new GlobsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 668, CypherCmdParser.RULE_globs);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3790;
                this.glob();
                this.state = 3795;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 3791;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 3792;
                            this.glob();
                        }
                    }
                    this.state = 3797;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    glob() {
        let localctx = new GlobContext(this, this._ctx, this.state);
        this.enterRule(localctx, 670, CypherCmdParser.RULE_glob);
        try {
            this.state = 3803;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 24:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3798;
                        this.escapedSymbolicNameString();
                        this.state = 3800;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 448, this._ctx)) {
                            case 1:
                                {
                                    this.state = 3799;
                                    this.globRecursive();
                                }
                                break;
                        }
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 95:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 239:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 301:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3802;
                        this.globRecursive();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    globRecursive() {
        let localctx = new GlobRecursiveContext(this, this._ctx, this.state);
        this.enterRule(localctx, 672, CypherCmdParser.RULE_globRecursive);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3805;
                this.globPart();
                this.state = 3807;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 450, this._ctx)) {
                    case 1:
                        {
                            this.state = 3806;
                            this.globRecursive();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    globPart() {
        let localctx = new GlobPartContext(this, this._ctx, this.state);
        this.enterRule(localctx, 674, CypherCmdParser.RULE_globPart);
        let _la;
        try {
            this.state = 3816;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 95:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3809;
                        this.match(CypherCmdParser.DOT);
                        this.state = 3811;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 24) {
                            {
                                this.state = 3810;
                                this.escapedSymbolicNameString();
                            }
                        }
                    }
                    break;
                case 239:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3813;
                        this.match(CypherCmdParser.QUESTION);
                    }
                    break;
                case 301:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3814;
                        this.match(CypherCmdParser.TIMES);
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 3815;
                        this.unescapedSymbolicNameString();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    qualifiedGraphPrivileges() {
        let localctx = new QualifiedGraphPrivilegesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 676, CypherCmdParser.RULE_qualifiedGraphPrivileges);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3822;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 309:
                        {
                            this.state = 3818;
                            this.match(CypherCmdParser.TRAVERSE);
                        }
                        break;
                    case 85:
                        {
                            this.state = 3819;
                            this.match(CypherCmdParser.DELETE);
                        }
                        break;
                    case 184:
                    case 185:
                    case 243:
                        {
                            this.state = 3820;
                            _la = this._input.LA(1);
                            if (!(_la === 184 || _la === 185 || _la === 243)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 3821;
                            this.propertiesResource();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 3824;
                this.match(CypherCmdParser.ON);
                this.state = 3825;
                this.graphScope();
                this.state = 3826;
                this.graphQualifier();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    labelsResource() {
        let localctx = new LabelsResourceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 678, CypherCmdParser.RULE_labelsResource);
        try {
            this.state = 3830;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 301:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3828;
                        this.match(CypherCmdParser.TIMES);
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3829;
                        this.nonEmptyStringList();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertiesResource() {
        let localctx = new PropertiesResourceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 680, CypherCmdParser.RULE_propertiesResource);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3832;
                this.match(CypherCmdParser.LCURLY);
                this.state = 3835;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 301:
                        {
                            this.state = 3833;
                            this.match(CypherCmdParser.TIMES);
                        }
                        break;
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 12:
                    case 13:
                    case 14:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 78:
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 93:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                    case 130:
                    case 131:
                    case 132:
                    case 134:
                    case 135:
                    case 136:
                    case 137:
                    case 138:
                    case 140:
                    case 141:
                    case 142:
                    case 143:
                    case 144:
                    case 145:
                    case 146:
                    case 147:
                    case 148:
                    case 149:
                    case 150:
                    case 151:
                    case 152:
                    case 153:
                    case 154:
                    case 155:
                    case 156:
                    case 157:
                    case 158:
                    case 159:
                    case 160:
                    case 161:
                    case 162:
                    case 163:
                    case 164:
                    case 165:
                    case 166:
                    case 169:
                    case 173:
                    case 174:
                    case 175:
                    case 176:
                    case 177:
                    case 178:
                    case 179:
                    case 182:
                    case 183:
                    case 184:
                    case 185:
                    case 188:
                    case 191:
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 196:
                    case 197:
                    case 198:
                    case 199:
                    case 200:
                    case 201:
                    case 202:
                    case 203:
                    case 204:
                    case 205:
                    case 206:
                    case 207:
                    case 208:
                    case 209:
                    case 210:
                    case 211:
                    case 212:
                    case 213:
                    case 214:
                    case 215:
                    case 216:
                    case 217:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 226:
                    case 227:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 240:
                    case 243:
                    case 244:
                    case 245:
                    case 246:
                    case 248:
                    case 249:
                    case 250:
                    case 251:
                    case 252:
                    case 253:
                    case 254:
                    case 255:
                    case 256:
                    case 257:
                    case 258:
                    case 259:
                    case 260:
                    case 261:
                    case 262:
                    case 263:
                    case 264:
                    case 265:
                    case 266:
                    case 268:
                    case 269:
                    case 270:
                    case 271:
                    case 272:
                    case 273:
                    case 274:
                    case 276:
                    case 277:
                    case 278:
                    case 279:
                    case 280:
                    case 281:
                    case 282:
                    case 283:
                    case 284:
                    case 285:
                    case 286:
                    case 287:
                    case 288:
                    case 289:
                    case 290:
                    case 291:
                    case 292:
                    case 293:
                    case 294:
                    case 295:
                    case 296:
                    case 297:
                    case 298:
                    case 299:
                    case 300:
                    case 302:
                    case 303:
                    case 304:
                    case 305:
                    case 306:
                    case 307:
                    case 308:
                    case 309:
                    case 310:
                    case 311:
                    case 312:
                    case 313:
                    case 314:
                    case 315:
                    case 316:
                    case 317:
                    case 318:
                    case 319:
                    case 320:
                    case 321:
                    case 322:
                    case 323:
                    case 324:
                    case 325:
                    case 326:
                    case 327:
                    case 328:
                    case 329:
                    case 330:
                    case 331:
                    case 332:
                    case 333:
                    case 334:
                    case 335:
                    case 336:
                    case 337:
                    case 338:
                        {
                            this.state = 3834;
                            this.nonEmptyStringList();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 3837;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nonEmptyStringList() {
        let localctx = new NonEmptyStringListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 682, CypherCmdParser.RULE_nonEmptyStringList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3839;
                this.symbolicNameString();
                this.state = 3844;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 3840;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 3841;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 3846;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphQualifier() {
        let localctx = new GraphQualifierContext(this, this._ctx, this.state);
        this.enterRule(localctx, 684, CypherCmdParser.RULE_graphQualifier);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3928;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 106:
                    case 107:
                    case 200:
                    case 202:
                    case 249:
                    case 250:
                        {
                            this.state = 3847;
                            this.graphQualifierToken();
                            this.state = 3850;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case 301:
                                    {
                                        this.state = 3848;
                                        this.match(CypherCmdParser.TIMES);
                                    }
                                    break;
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 12:
                                case 13:
                                case 14:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 93:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 169:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 188:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 226:
                                case 227:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 240:
                                case 243:
                                case 244:
                                case 245:
                                case 246:
                                case 248:
                                case 249:
                                case 250:
                                case 251:
                                case 252:
                                case 253:
                                case 254:
                                case 255:
                                case 256:
                                case 257:
                                case 258:
                                case 259:
                                case 260:
                                case 261:
                                case 262:
                                case 263:
                                case 264:
                                case 265:
                                case 266:
                                case 268:
                                case 269:
                                case 270:
                                case 271:
                                case 272:
                                case 273:
                                case 274:
                                case 276:
                                case 277:
                                case 278:
                                case 279:
                                case 280:
                                case 281:
                                case 282:
                                case 283:
                                case 284:
                                case 285:
                                case 286:
                                case 287:
                                case 288:
                                case 289:
                                case 290:
                                case 291:
                                case 292:
                                case 293:
                                case 294:
                                case 295:
                                case 296:
                                case 297:
                                case 298:
                                case 299:
                                case 300:
                                case 302:
                                case 303:
                                case 304:
                                case 305:
                                case 306:
                                case 307:
                                case 308:
                                case 309:
                                case 310:
                                case 311:
                                case 312:
                                case 313:
                                case 314:
                                case 315:
                                case 316:
                                case 317:
                                case 318:
                                case 319:
                                case 320:
                                case 321:
                                case 322:
                                case 323:
                                case 324:
                                case 325:
                                case 326:
                                case 327:
                                case 328:
                                case 329:
                                case 330:
                                case 331:
                                case 332:
                                case 333:
                                case 334:
                                case 335:
                                case 336:
                                case 337:
                                case 338:
                                    {
                                        this.state = 3849;
                                        this.nonEmptyStringList();
                                    }
                                    break;
                                default:
                                    throw new NoViableAltException(this);
                            }
                        }
                        break;
                    case 127:
                        {
                            this.state = 3852;
                            this.match(CypherCmdParser.FOR);
                            this.state = 3926;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 471, this._ctx)) {
                                case 1:
                                    {
                                        this.state = 3853;
                                        this.match(CypherCmdParser.LPAREN);
                                        this.state = 3855;
                                        this._errHandler.sync(this);
                                        switch (this._interp.adaptivePredict(this._input, 458, this._ctx)) {
                                            case 1:
                                                {
                                                    this.state = 3854;
                                                    this.variable();
                                                }
                                                break;
                                        }
                                        this.state = 3866;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 60) {
                                            {
                                                this.state = 3857;
                                                this.match(CypherCmdParser.COLON);
                                                this.state = 3858;
                                                this.symbolicNameString();
                                                this.state = 3863;
                                                this._errHandler.sync(this);
                                                _la = this._input.LA(1);
                                                while (_la === 45) {
                                                    {
                                                        {
                                                            this.state = 3859;
                                                            this.match(CypherCmdParser.BAR);
                                                            this.state = 3860;
                                                            this.symbolicNameString();
                                                        }
                                                    }
                                                    this.state = 3865;
                                                    this._errHandler.sync(this);
                                                    _la = this._input.LA(1);
                                                }
                                            }
                                        }
                                        this.state = 3878;
                                        this._errHandler.sync(this);
                                        switch (this._input.LA(1)) {
                                            case 267:
                                                {
                                                    this.state = 3868;
                                                    this.match(CypherCmdParser.RPAREN);
                                                    this.state = 3869;
                                                    this.match(CypherCmdParser.WHERE);
                                                    this.state = 3870;
                                                    this.expression();
                                                }
                                                break;
                                            case 171:
                                            case 330:
                                                {
                                                    this.state = 3874;
                                                    this._errHandler.sync(this);
                                                    switch (this._input.LA(1)) {
                                                        case 330:
                                                            {
                                                                this.state = 3871;
                                                                this.match(CypherCmdParser.WHERE);
                                                                this.state = 3872;
                                                                this.expression();
                                                            }
                                                            break;
                                                        case 171:
                                                            {
                                                                this.state = 3873;
                                                                this.map();
                                                            }
                                                            break;
                                                        default:
                                                            throw new NoViableAltException(this);
                                                    }
                                                    this.state = 3876;
                                                    this.match(CypherCmdParser.RPAREN);
                                                }
                                                break;
                                            default:
                                                throw new NoViableAltException(this);
                                        }
                                    }
                                    break;
                                case 2:
                                    {
                                        this.state = 3880;
                                        this.match(CypherCmdParser.LPAREN);
                                        this.state = 3881;
                                        this.match(CypherCmdParser.RPAREN);
                                        this.state = 3883;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 181 || _la === 341) {
                                            {
                                                this.state = 3882;
                                                this.leftArrow();
                                            }
                                        }
                                        this.state = 3885;
                                        this.arrowLine();
                                        this.state = 3886;
                                        this.match(CypherCmdParser.LBRACKET);
                                        this.state = 3888;
                                        this._errHandler.sync(this);
                                        switch (this._interp.adaptivePredict(this._input, 464, this._ctx)) {
                                            case 1:
                                                {
                                                    this.state = 3887;
                                                    this.variable();
                                                }
                                                break;
                                        }
                                        this.state = 3899;
                                        this._errHandler.sync(this);
                                        _la = this._input.LA(1);
                                        if (_la === 60) {
                                            {
                                                this.state = 3890;
                                                this.match(CypherCmdParser.COLON);
                                                this.state = 3891;
                                                this.symbolicNameString();
                                                this.state = 3896;
                                                this._errHandler.sync(this);
                                                _la = this._input.LA(1);
                                                while (_la === 45) {
                                                    {
                                                        {
                                                            this.state = 3892;
                                                            this.match(CypherCmdParser.BAR);
                                                            this.state = 3893;
                                                            this.symbolicNameString();
                                                        }
                                                    }
                                                    this.state = 3898;
                                                    this._errHandler.sync(this);
                                                    _la = this._input.LA(1);
                                                }
                                            }
                                        }
                                        this.state = 3924;
                                        this._errHandler.sync(this);
                                        switch (this._input.LA(1)) {
                                            case 241:
                                                {
                                                    this.state = 3901;
                                                    this.match(CypherCmdParser.RBRACKET);
                                                    this.state = 3902;
                                                    this.arrowLine();
                                                    this.state = 3904;
                                                    this._errHandler.sync(this);
                                                    _la = this._input.LA(1);
                                                    if (_la === 139 || _la === 342) {
                                                        {
                                                            this.state = 3903;
                                                            this.rightArrow();
                                                        }
                                                    }
                                                    this.state = 3906;
                                                    this.match(CypherCmdParser.LPAREN);
                                                    this.state = 3907;
                                                    this.match(CypherCmdParser.RPAREN);
                                                    this.state = 3908;
                                                    this.match(CypherCmdParser.WHERE);
                                                    this.state = 3909;
                                                    this.expression();
                                                }
                                                break;
                                            case 171:
                                            case 330:
                                                {
                                                    this.state = 3914;
                                                    this._errHandler.sync(this);
                                                    switch (this._input.LA(1)) {
                                                        case 330:
                                                            {
                                                                this.state = 3911;
                                                                this.match(CypherCmdParser.WHERE);
                                                                this.state = 3912;
                                                                this.expression();
                                                            }
                                                            break;
                                                        case 171:
                                                            {
                                                                this.state = 3913;
                                                                this.map();
                                                            }
                                                            break;
                                                        default:
                                                            throw new NoViableAltException(this);
                                                    }
                                                    this.state = 3916;
                                                    this.match(CypherCmdParser.RBRACKET);
                                                    this.state = 3917;
                                                    this.arrowLine();
                                                    this.state = 3919;
                                                    this._errHandler.sync(this);
                                                    _la = this._input.LA(1);
                                                    if (_la === 139 || _la === 342) {
                                                        {
                                                            this.state = 3918;
                                                            this.rightArrow();
                                                        }
                                                    }
                                                    this.state = 3921;
                                                    this.match(CypherCmdParser.LPAREN);
                                                    this.state = 3922;
                                                    this.match(CypherCmdParser.RPAREN);
                                                }
                                                break;
                                            default:
                                                throw new NoViableAltException(this);
                                        }
                                    }
                                    break;
                            }
                        }
                        break;
                    case 129:
                    case 304:
                        break;
                    default:
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphQualifierToken() {
        let localctx = new GraphQualifierTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 686, CypherCmdParser.RULE_graphQualifierToken);
        try {
            this.state = 3933;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 249:
                case 250:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3930;
                        this.relToken();
                    }
                    break;
                case 200:
                case 202:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3931;
                        this.nodeToken();
                    }
                    break;
                case 106:
                case 107:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 3932;
                        this.elementToken();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    relToken() {
        let localctx = new RelTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 688, CypherCmdParser.RULE_relToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3935;
                _la = this._input.LA(1);
                if (!(_la === 249 || _la === 250)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    elementToken() {
        let localctx = new ElementTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 690, CypherCmdParser.RULE_elementToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3937;
                _la = this._input.LA(1);
                if (!(_la === 106 || _la === 107)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nodeToken() {
        let localctx = new NodeTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 692, CypherCmdParser.RULE_nodeToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3939;
                _la = this._input.LA(1);
                if (!(_la === 200 || _la === 202)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    databaseScope() {
        let localctx = new DatabaseScopeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 694, CypherCmdParser.RULE_databaseScope);
        let _la;
        try {
            this.state = 3948;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 141:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3941;
                        this.match(CypherCmdParser.HOME);
                        this.state = 3942;
                        this.match(CypherCmdParser.DATABASE);
                    }
                    break;
                case 77:
                case 78:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3943;
                        _la = this._input.LA(1);
                        if (!(_la === 77 || _la === 78)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 3946;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 301:
                                {
                                    this.state = 3944;
                                    this.match(CypherCmdParser.TIMES);
                                }
                                break;
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 12:
                            case 13:
                            case 14:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 46:
                            case 47:
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 63:
                            case 64:
                            case 65:
                            case 66:
                            case 67:
                            case 68:
                            case 69:
                            case 70:
                            case 71:
                            case 72:
                            case 73:
                            case 74:
                            case 75:
                            case 76:
                            case 77:
                            case 78:
                            case 79:
                            case 80:
                            case 81:
                            case 82:
                            case 83:
                            case 84:
                            case 85:
                            case 86:
                            case 87:
                            case 88:
                            case 89:
                            case 90:
                            case 91:
                            case 92:
                            case 93:
                            case 98:
                            case 99:
                            case 100:
                            case 101:
                            case 102:
                            case 103:
                            case 104:
                            case 105:
                            case 106:
                            case 107:
                            case 108:
                            case 109:
                            case 110:
                            case 111:
                            case 113:
                            case 114:
                            case 115:
                            case 116:
                            case 117:
                            case 118:
                            case 119:
                            case 120:
                            case 121:
                            case 122:
                            case 123:
                            case 124:
                            case 125:
                            case 126:
                            case 127:
                            case 128:
                            case 129:
                            case 130:
                            case 131:
                            case 132:
                            case 134:
                            case 135:
                            case 136:
                            case 137:
                            case 138:
                            case 140:
                            case 141:
                            case 142:
                            case 143:
                            case 144:
                            case 145:
                            case 146:
                            case 147:
                            case 148:
                            case 149:
                            case 150:
                            case 151:
                            case 152:
                            case 153:
                            case 154:
                            case 155:
                            case 156:
                            case 157:
                            case 158:
                            case 159:
                            case 160:
                            case 161:
                            case 162:
                            case 163:
                            case 164:
                            case 165:
                            case 166:
                            case 169:
                            case 173:
                            case 174:
                            case 175:
                            case 176:
                            case 177:
                            case 178:
                            case 179:
                            case 182:
                            case 183:
                            case 184:
                            case 185:
                            case 188:
                            case 191:
                            case 192:
                            case 193:
                            case 194:
                            case 195:
                            case 196:
                            case 197:
                            case 198:
                            case 199:
                            case 200:
                            case 201:
                            case 202:
                            case 203:
                            case 204:
                            case 205:
                            case 206:
                            case 207:
                            case 208:
                            case 209:
                            case 210:
                            case 211:
                            case 212:
                            case 213:
                            case 214:
                            case 215:
                            case 216:
                            case 217:
                            case 218:
                            case 219:
                            case 220:
                            case 221:
                            case 222:
                            case 223:
                            case 226:
                            case 227:
                            case 229:
                            case 230:
                            case 231:
                            case 232:
                            case 233:
                            case 234:
                            case 235:
                            case 236:
                            case 237:
                            case 238:
                            case 240:
                            case 243:
                            case 244:
                            case 245:
                            case 246:
                            case 248:
                            case 249:
                            case 250:
                            case 251:
                            case 252:
                            case 253:
                            case 254:
                            case 255:
                            case 256:
                            case 257:
                            case 258:
                            case 259:
                            case 260:
                            case 261:
                            case 262:
                            case 263:
                            case 264:
                            case 265:
                            case 266:
                            case 268:
                            case 269:
                            case 270:
                            case 271:
                            case 272:
                            case 273:
                            case 274:
                            case 276:
                            case 277:
                            case 278:
                            case 279:
                            case 280:
                            case 281:
                            case 282:
                            case 283:
                            case 284:
                            case 285:
                            case 286:
                            case 287:
                            case 288:
                            case 289:
                            case 290:
                            case 291:
                            case 292:
                            case 293:
                            case 294:
                            case 295:
                            case 296:
                            case 297:
                            case 298:
                            case 299:
                            case 300:
                            case 302:
                            case 303:
                            case 304:
                            case 305:
                            case 306:
                            case 307:
                            case 308:
                            case 309:
                            case 310:
                            case 311:
                            case 312:
                            case 313:
                            case 314:
                            case 315:
                            case 316:
                            case 317:
                            case 318:
                            case 319:
                            case 320:
                            case 321:
                            case 322:
                            case 323:
                            case 324:
                            case 325:
                            case 326:
                            case 327:
                            case 328:
                            case 329:
                            case 330:
                            case 331:
                            case 332:
                            case 333:
                            case 334:
                            case 335:
                            case 336:
                            case 337:
                            case 338:
                                {
                                    this.state = 3945;
                                    this.symbolicAliasNameList();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphScope() {
        let localctx = new GraphScopeContext(this, this._ctx, this.state);
        this.enterRule(localctx, 696, CypherCmdParser.RULE_graphScope);
        let _la;
        try {
            this.state = 3957;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 141:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 3950;
                        this.match(CypherCmdParser.HOME);
                        this.state = 3951;
                        this.match(CypherCmdParser.GRAPH);
                    }
                    break;
                case 135:
                case 136:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 3952;
                        _la = this._input.LA(1);
                        if (!(_la === 135 || _la === 136)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 3955;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 301:
                                {
                                    this.state = 3953;
                                    this.match(CypherCmdParser.TIMES);
                                }
                                break;
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 12:
                            case 13:
                            case 14:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 46:
                            case 47:
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 63:
                            case 64:
                            case 65:
                            case 66:
                            case 67:
                            case 68:
                            case 69:
                            case 70:
                            case 71:
                            case 72:
                            case 73:
                            case 74:
                            case 75:
                            case 76:
                            case 77:
                            case 78:
                            case 79:
                            case 80:
                            case 81:
                            case 82:
                            case 83:
                            case 84:
                            case 85:
                            case 86:
                            case 87:
                            case 88:
                            case 89:
                            case 90:
                            case 91:
                            case 92:
                            case 93:
                            case 98:
                            case 99:
                            case 100:
                            case 101:
                            case 102:
                            case 103:
                            case 104:
                            case 105:
                            case 106:
                            case 107:
                            case 108:
                            case 109:
                            case 110:
                            case 111:
                            case 113:
                            case 114:
                            case 115:
                            case 116:
                            case 117:
                            case 118:
                            case 119:
                            case 120:
                            case 121:
                            case 122:
                            case 123:
                            case 124:
                            case 125:
                            case 126:
                            case 127:
                            case 128:
                            case 129:
                            case 130:
                            case 131:
                            case 132:
                            case 134:
                            case 135:
                            case 136:
                            case 137:
                            case 138:
                            case 140:
                            case 141:
                            case 142:
                            case 143:
                            case 144:
                            case 145:
                            case 146:
                            case 147:
                            case 148:
                            case 149:
                            case 150:
                            case 151:
                            case 152:
                            case 153:
                            case 154:
                            case 155:
                            case 156:
                            case 157:
                            case 158:
                            case 159:
                            case 160:
                            case 161:
                            case 162:
                            case 163:
                            case 164:
                            case 165:
                            case 166:
                            case 169:
                            case 173:
                            case 174:
                            case 175:
                            case 176:
                            case 177:
                            case 178:
                            case 179:
                            case 182:
                            case 183:
                            case 184:
                            case 185:
                            case 188:
                            case 191:
                            case 192:
                            case 193:
                            case 194:
                            case 195:
                            case 196:
                            case 197:
                            case 198:
                            case 199:
                            case 200:
                            case 201:
                            case 202:
                            case 203:
                            case 204:
                            case 205:
                            case 206:
                            case 207:
                            case 208:
                            case 209:
                            case 210:
                            case 211:
                            case 212:
                            case 213:
                            case 214:
                            case 215:
                            case 216:
                            case 217:
                            case 218:
                            case 219:
                            case 220:
                            case 221:
                            case 222:
                            case 223:
                            case 226:
                            case 227:
                            case 229:
                            case 230:
                            case 231:
                            case 232:
                            case 233:
                            case 234:
                            case 235:
                            case 236:
                            case 237:
                            case 238:
                            case 240:
                            case 243:
                            case 244:
                            case 245:
                            case 246:
                            case 248:
                            case 249:
                            case 250:
                            case 251:
                            case 252:
                            case 253:
                            case 254:
                            case 255:
                            case 256:
                            case 257:
                            case 258:
                            case 259:
                            case 260:
                            case 261:
                            case 262:
                            case 263:
                            case 264:
                            case 265:
                            case 266:
                            case 268:
                            case 269:
                            case 270:
                            case 271:
                            case 272:
                            case 273:
                            case 274:
                            case 276:
                            case 277:
                            case 278:
                            case 279:
                            case 280:
                            case 281:
                            case 282:
                            case 283:
                            case 284:
                            case 285:
                            case 286:
                            case 287:
                            case 288:
                            case 289:
                            case 290:
                            case 291:
                            case 292:
                            case 293:
                            case 294:
                            case 295:
                            case 296:
                            case 297:
                            case 298:
                            case 299:
                            case 300:
                            case 302:
                            case 303:
                            case 304:
                            case 305:
                            case 306:
                            case 307:
                            case 308:
                            case 309:
                            case 310:
                            case 311:
                            case 312:
                            case 313:
                            case 314:
                            case 315:
                            case 316:
                            case 317:
                            case 318:
                            case 319:
                            case 320:
                            case 321:
                            case 322:
                            case 323:
                            case 324:
                            case 325:
                            case 326:
                            case 327:
                            case 328:
                            case 329:
                            case 330:
                            case 331:
                            case 332:
                            case 333:
                            case 334:
                            case 335:
                            case 336:
                            case 337:
                            case 338:
                                {
                                    this.state = 3954;
                                    this.symbolicAliasNameList();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createCompositeDatabase() {
        let localctx = new CreateCompositeDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 698, CypherCmdParser.RULE_createCompositeDatabase);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3959;
                this.match(CypherCmdParser.COMPOSITE);
                this.state = 3960;
                this.match(CypherCmdParser.DATABASE);
                this.state = 3961;
                this.databaseName();
                this.state = 3965;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3962;
                        this.match(CypherCmdParser.IF);
                        this.state = 3963;
                        this.match(CypherCmdParser.NOT);
                        this.state = 3964;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3971;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 83 || _la === 278) {
                    {
                        this.state = 3968;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 278) {
                            {
                                this.state = 3967;
                                this.match(CypherCmdParser.SET);
                            }
                        }
                        this.state = 3970;
                        this.defaultLanguageSpecification();
                    }
                }
                this.state = 3974;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 3973;
                        this.commandOptions();
                    }
                }
                this.state = 3977;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 208 || _la === 328) {
                    {
                        this.state = 3976;
                        this.waitClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createDatabase() {
        let localctx = new CreateDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 700, CypherCmdParser.RULE_createDatabase);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 3979;
                this.match(CypherCmdParser.DATABASE);
                this.state = 3980;
                this.databaseName();
                this.state = 3984;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 3981;
                        this.match(CypherCmdParser.IF);
                        this.state = 3982;
                        this.match(CypherCmdParser.NOT);
                        this.state = 3983;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 3990;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 485, this._ctx)) {
                    case 1:
                        {
                            this.state = 3987;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 278) {
                                {
                                    this.state = 3986;
                                    this.match(CypherCmdParser.SET);
                                }
                            }
                            this.state = 3989;
                            this.defaultLanguageSpecification();
                        }
                        break;
                }
                this.state = 3994;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 486, this._ctx)) {
                    case 1:
                        {
                            this.state = 3992;
                            this.topology();
                        }
                        break;
                    case 2:
                        {
                            this.state = 3993;
                            this.shards();
                        }
                        break;
                }
                this.state = 3997;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 215) {
                    {
                        this.state = 3996;
                        this.commandOptions();
                    }
                }
                this.state = 4000;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 208 || _la === 328) {
                    {
                        this.state = 3999;
                        this.waitClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    shards() {
        let localctx = new ShardsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 702, CypherCmdParser.RULE_shards);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4006;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 490, this._ctx)) {
                    case 1:
                        {
                            this.state = 4003;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            if (_la === 278) {
                                {
                                    this.state = 4002;
                                    this.match(CypherCmdParser.SET);
                                }
                            }
                            this.state = 4005;
                            this.graphShard();
                        }
                        break;
                }
                this.state = 4009;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 278) {
                    {
                        this.state = 4008;
                        this.match(CypherCmdParser.SET);
                    }
                }
                this.state = 4011;
                this.propertyShard();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    graphShard() {
        let localctx = new GraphShardContext(this, this._ctx, this.state);
        this.enterRule(localctx, 704, CypherCmdParser.RULE_graphShard);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4013;
                this.match(CypherCmdParser.GRAPH);
                this.state = 4014;
                this.match(CypherCmdParser.SHARD);
                this.state = 4015;
                this.match(CypherCmdParser.LCURLY);
                this.state = 4017;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 278 || _la === 305) {
                    {
                        this.state = 4016;
                        this.topology();
                    }
                }
                this.state = 4019;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    propertyShard() {
        let localctx = new PropertyShardContext(this, this._ctx, this.state);
        this.enterRule(localctx, 706, CypherCmdParser.RULE_propertyShard);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4021;
                this.match(CypherCmdParser.PROPERTY);
                this.state = 4022;
                _la = this._input.LA(1);
                if (!(_la === 281 || _la === 282)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 4023;
                this.match(CypherCmdParser.LCURLY);
                this.state = 4024;
                this.match(CypherCmdParser.COUNT);
                this.state = 4025;
                this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                this.state = 4033;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 278 || _la === 305) {
                    {
                        this.state = 4027;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 278) {
                            {
                                this.state = 4026;
                                this.match(CypherCmdParser.SET);
                            }
                        }
                        this.state = 4029;
                        this.match(CypherCmdParser.TOPOLOGY);
                        this.state = 4030;
                        this.uIntOrIntParameter();
                        this.state = 4031;
                        _la = this._input.LA(1);
                        if (!(_la === 254 || _la === 255)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                }
                this.state = 4035;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    topology() {
        let localctx = new TopologyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 708, CypherCmdParser.RULE_topology);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4038;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 278) {
                    {
                        this.state = 4037;
                        this.match(CypherCmdParser.SET);
                    }
                }
                this.state = 4040;
                this.match(CypherCmdParser.TOPOLOGY);
                this.state = 4043;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        this.state = 4043;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 496, this._ctx)) {
                            case 1:
                                {
                                    this.state = 4041;
                                    this.primaryTopology();
                                }
                                break;
                            case 2:
                                {
                                    this.state = 4042;
                                    this.secondaryTopology();
                                }
                                break;
                        }
                    }
                    this.state = 4045;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 19 || _la === 92);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    primaryTopology() {
        let localctx = new PrimaryTopologyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 710, CypherCmdParser.RULE_primaryTopology);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4047;
                this.uIntOrIntParameter();
                this.state = 4048;
                this.primaryToken();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    primaryToken() {
        let localctx = new PrimaryTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 712, CypherCmdParser.RULE_primaryToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4050;
                _la = this._input.LA(1);
                if (!(_la === 229 || _la === 230)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    secondaryTopology() {
        let localctx = new SecondaryTopologyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 714, CypherCmdParser.RULE_secondaryTopology);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4052;
                this.uIntOrIntParameter();
                this.state = 4053;
                this.secondaryToken();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    secondaryToken() {
        let localctx = new SecondaryTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 716, CypherCmdParser.RULE_secondaryToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4055;
                _la = this._input.LA(1);
                if (!(_la === 271 || _la === 272)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    defaultLanguageSpecification() {
        let localctx = new DefaultLanguageSpecificationContext(this, this._ctx, this.state);
        this.enterRule(localctx, 718, CypherCmdParser.RULE_defaultLanguageSpecification);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4057;
                this.match(CypherCmdParser.DEFAULT);
                this.state = 4058;
                this.match(CypherCmdParser.LANGUAGE);
                this.state = 4059;
                this.match(CypherCmdParser.CYPHER);
                this.state = 4060;
                this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropDatabase() {
        let localctx = new DropDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 720, CypherCmdParser.RULE_dropDatabase);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4063;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 65) {
                    {
                        this.state = 4062;
                        this.match(CypherCmdParser.COMPOSITE);
                    }
                }
                this.state = 4065;
                this.match(CypherCmdParser.DATABASE);
                this.state = 4066;
                this.symbolicAliasNameOrParameter();
                this.state = 4069;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 4067;
                        this.match(CypherCmdParser.IF);
                        this.state = 4068;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 4072;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 55 || _la === 259) {
                    {
                        this.state = 4071;
                        this.aliasAction();
                    }
                }
                this.state = 4076;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 89 || _la === 101) {
                    {
                        this.state = 4074;
                        _la = this._input.LA(1);
                        if (!(_la === 89 || _la === 101)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 4075;
                        this.match(CypherCmdParser.DATA);
                    }
                }
                this.state = 4079;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 208 || _la === 328) {
                    {
                        this.state = 4078;
                        this.waitClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    aliasAction() {
        let localctx = new AliasActionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 722, CypherCmdParser.RULE_aliasAction);
        let _la;
        try {
            this.state = 4084;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 259:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4081;
                        this.match(CypherCmdParser.RESTRICT);
                    }
                    break;
                case 55:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4082;
                        this.match(CypherCmdParser.CASCADE);
                        this.state = 4083;
                        _la = this._input.LA(1);
                        if (!(_la === 30 || _la === 31)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterDatabase() {
        let localctx = new AlterDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 724, CypherCmdParser.RULE_alterDatabase);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4086;
                this.match(CypherCmdParser.DATABASE);
                this.state = 4087;
                this.symbolicAliasNameOrParameter();
                this.state = 4090;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 4088;
                        this.match(CypherCmdParser.IF);
                        this.state = 4089;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 4110;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 278:
                        {
                            this.state = 4099;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            do {
                                {
                                    {
                                        this.state = 4092;
                                        this.match(CypherCmdParser.SET);
                                        this.state = 4097;
                                        this._errHandler.sync(this);
                                        switch (this._input.LA(1)) {
                                            case 25:
                                                {
                                                    this.state = 4093;
                                                    this.alterDatabaseAccess();
                                                }
                                                break;
                                            case 305:
                                                {
                                                    this.state = 4094;
                                                    this.alterDatabaseTopology();
                                                }
                                                break;
                                            case 216:
                                                {
                                                    this.state = 4095;
                                                    this.alterDatabaseOption();
                                                }
                                                break;
                                            case 83:
                                                {
                                                    this.state = 4096;
                                                    this.defaultLanguageSpecification();
                                                }
                                                break;
                                            default:
                                                throw new NoViableAltException(this);
                                        }
                                    }
                                }
                                this.state = 4101;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                            } while (_la === 278);
                        }
                        break;
                    case 251:
                        {
                            this.state = 4106;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            do {
                                {
                                    {
                                        this.state = 4103;
                                        this.match(CypherCmdParser.REMOVE);
                                        this.state = 4104;
                                        this.match(CypherCmdParser.OPTION);
                                        this.state = 4105;
                                        this.symbolicNameString();
                                    }
                                }
                                this.state = 4108;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                            } while (_la === 251);
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this.state = 4113;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 208 || _la === 328) {
                    {
                        this.state = 4112;
                        this.waitClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterDatabaseAccess() {
        let localctx = new AlterDatabaseAccessContext(this, this._ctx, this.state);
        this.enterRule(localctx, 726, CypherCmdParser.RULE_alterDatabaseAccess);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4115;
                this.match(CypherCmdParser.ACCESS);
                this.state = 4116;
                this.match(CypherCmdParser.READ);
                this.state = 4117;
                _la = this._input.LA(1);
                if (!(_la === 213 || _la === 333)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterDatabaseTopology() {
        let localctx = new AlterDatabaseTopologyContext(this, this._ctx, this.state);
        this.enterRule(localctx, 728, CypherCmdParser.RULE_alterDatabaseTopology);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4119;
                this.match(CypherCmdParser.TOPOLOGY);
                this.state = 4122;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        this.state = 4122;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 510, this._ctx)) {
                            case 1:
                                {
                                    this.state = 4120;
                                    this.primaryTopology();
                                }
                                break;
                            case 2:
                                {
                                    this.state = 4121;
                                    this.secondaryTopology();
                                }
                                break;
                        }
                    }
                    this.state = 4124;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 19 || _la === 92);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterDatabaseOption() {
        let localctx = new AlterDatabaseOptionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 730, CypherCmdParser.RULE_alterDatabaseOption);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4126;
                this.match(CypherCmdParser.OPTION);
                this.state = 4127;
                this.symbolicNameString();
                this.state = 4128;
                this.expression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    startDatabase() {
        let localctx = new StartDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 732, CypherCmdParser.RULE_startDatabase);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4130;
                this.match(CypherCmdParser.START);
                this.state = 4131;
                this.match(CypherCmdParser.DATABASE);
                this.state = 4132;
                this.symbolicAliasNameOrParameter();
                this.state = 4134;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 208 || _la === 328) {
                    {
                        this.state = 4133;
                        this.waitClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stopDatabase() {
        let localctx = new StopDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 734, CypherCmdParser.RULE_stopDatabase);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4136;
                this.match(CypherCmdParser.STOP);
                this.state = 4137;
                this.match(CypherCmdParser.DATABASE);
                this.state = 4138;
                this.symbolicAliasNameOrParameter();
                this.state = 4140;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 208 || _la === 328) {
                    {
                        this.state = 4139;
                        this.waitClause();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    waitClause() {
        let localctx = new WaitClauseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 736, CypherCmdParser.RULE_waitClause);
        let _la;
        try {
            this.state = 4150;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 328:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4142;
                        this.match(CypherCmdParser.WAIT);
                        this.state = 4147;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 19) {
                            {
                                this.state = 4143;
                                this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                                this.state = 4145;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                                if (((((_la - 269)) & ~0x1F) === 0 && ((1 << (_la - 269)) & 19) !== 0)) {
                                    {
                                        this.state = 4144;
                                        this.secondsToken();
                                    }
                                }
                            }
                        }
                    }
                    break;
                case 208:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4149;
                        this.match(CypherCmdParser.NOWAIT);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    secondsToken() {
        let localctx = new SecondsTokenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 738, CypherCmdParser.RULE_secondsToken);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4152;
                _la = this._input.LA(1);
                if (!(((((_la - 269)) & ~0x1F) === 0 && ((1 << (_la - 269)) & 19) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showDatabase() {
        let localctx = new ShowDatabaseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 740, CypherCmdParser.RULE_showDatabase);
        let _la;
        try {
            this.state = 4166;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 83:
                case 141:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4154;
                        _la = this._input.LA(1);
                        if (!(_la === 83 || _la === 141)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 4155;
                        this.match(CypherCmdParser.DATABASE);
                        this.state = 4157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 330 || _la === 335) {
                            {
                                this.state = 4156;
                                this.showCommandYield();
                            }
                        }
                    }
                    break;
                case 77:
                case 78:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4159;
                        _la = this._input.LA(1);
                        if (!(_la === 77 || _la === 78)) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 4161;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 518, this._ctx)) {
                            case 1:
                                {
                                    this.state = 4160;
                                    this.symbolicAliasNameOrParameter();
                                }
                                break;
                        }
                        this.state = 4164;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 330 || _la === 335) {
                            {
                                this.state = 4163;
                                this.showCommandYield();
                            }
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    aliasName() {
        let localctx = new AliasNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 742, CypherCmdParser.RULE_aliasName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4168;
                this.symbolicAliasNameOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    aliasTargetName() {
        let localctx = new AliasTargetNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 744, CypherCmdParser.RULE_aliasTargetName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4170;
                this.symbolicAliasNameOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    databaseName() {
        let localctx = new DatabaseNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 746, CypherCmdParser.RULE_databaseName);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4172;
                this.symbolicNameOrStringParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    createAlias() {
        let localctx = new CreateAliasContext(this, this._ctx, this.state);
        this.enterRule(localctx, 748, CypherCmdParser.RULE_createAlias);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4174;
                this.match(CypherCmdParser.ALIAS);
                this.state = 4175;
                this.aliasName();
                this.state = 4179;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 4176;
                        this.match(CypherCmdParser.IF);
                        this.state = 4177;
                        this.match(CypherCmdParser.NOT);
                        this.state = 4178;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 4181;
                this.match(CypherCmdParser.FOR);
                this.state = 4182;
                this.match(CypherCmdParser.DATABASE);
                this.state = 4183;
                this.aliasTargetName();
                this.state = 4197;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 43) {
                    {
                        this.state = 4184;
                        this.match(CypherCmdParser.AT);
                        this.state = 4185;
                        this.stringOrParameter();
                        this.state = 4186;
                        this.match(CypherCmdParser.USER);
                        this.state = 4187;
                        this.commandNameExpression();
                        this.state = 4188;
                        this.match(CypherCmdParser.PASSWORD);
                        this.state = 4189;
                        this.passwordExpression();
                        this.state = 4192;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 98) {
                            {
                                this.state = 4190;
                                this.match(CypherCmdParser.DRIVER);
                                this.state = 4191;
                                this.mapOrParameter();
                            }
                        }
                        this.state = 4195;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (_la === 83) {
                            {
                                this.state = 4194;
                                this.defaultLanguageSpecification();
                            }
                        }
                    }
                }
                this.state = 4201;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 235) {
                    {
                        this.state = 4199;
                        this.match(CypherCmdParser.PROPERTIES);
                        this.state = 4200;
                        this.mapOrParameter();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dropAlias() {
        let localctx = new DropAliasContext(this, this._ctx, this.state);
        this.enterRule(localctx, 750, CypherCmdParser.RULE_dropAlias);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4203;
                this.match(CypherCmdParser.ALIAS);
                this.state = 4204;
                this.aliasName();
                this.state = 4207;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 4205;
                        this.match(CypherCmdParser.IF);
                        this.state = 4206;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 4209;
                this.match(CypherCmdParser.FOR);
                this.state = 4210;
                this.match(CypherCmdParser.DATABASE);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterAlias() {
        let localctx = new AlterAliasContext(this, this._ctx, this.state);
        this.enterRule(localctx, 752, CypherCmdParser.RULE_alterAlias);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4212;
                this.match(CypherCmdParser.ALIAS);
                this.state = 4213;
                this.aliasName();
                this.state = 4216;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 143) {
                    {
                        this.state = 4214;
                        this.match(CypherCmdParser.IF);
                        this.state = 4215;
                        this.match(CypherCmdParser.EXISTS);
                    }
                }
                this.state = 4218;
                this.match(CypherCmdParser.SET);
                this.state = 4219;
                this.match(CypherCmdParser.DATABASE);
                this.state = 4226;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        this.state = 4226;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 296:
                                {
                                    this.state = 4220;
                                    this.alterAliasTarget();
                                }
                                break;
                            case 321:
                                {
                                    this.state = 4221;
                                    this.alterAliasUser();
                                }
                                break;
                            case 219:
                                {
                                    this.state = 4222;
                                    this.alterAliasPassword();
                                }
                                break;
                            case 98:
                                {
                                    this.state = 4223;
                                    this.alterAliasDriver();
                                }
                                break;
                            case 235:
                                {
                                    this.state = 4224;
                                    this.alterAliasProperties();
                                }
                                break;
                            case 83:
                                {
                                    this.state = 4225;
                                    this.defaultLanguageSpecification();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    this.state = 4228;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 83 || _la === 98 || _la === 219 || _la === 235 || _la === 296 || _la === 321);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterAliasTarget() {
        let localctx = new AlterAliasTargetContext(this, this._ctx, this.state);
        this.enterRule(localctx, 754, CypherCmdParser.RULE_alterAliasTarget);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4230;
                this.match(CypherCmdParser.TARGET);
                this.state = 4231;
                this.aliasTargetName();
                this.state = 4234;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 43) {
                    {
                        this.state = 4232;
                        this.match(CypherCmdParser.AT);
                        this.state = 4233;
                        this.stringOrParameter();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterAliasUser() {
        let localctx = new AlterAliasUserContext(this, this._ctx, this.state);
        this.enterRule(localctx, 756, CypherCmdParser.RULE_alterAliasUser);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4236;
                this.match(CypherCmdParser.USER);
                this.state = 4237;
                this.commandNameExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterAliasPassword() {
        let localctx = new AlterAliasPasswordContext(this, this._ctx, this.state);
        this.enterRule(localctx, 758, CypherCmdParser.RULE_alterAliasPassword);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4239;
                this.match(CypherCmdParser.PASSWORD);
                this.state = 4240;
                this.passwordExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterAliasDriver() {
        let localctx = new AlterAliasDriverContext(this, this._ctx, this.state);
        this.enterRule(localctx, 760, CypherCmdParser.RULE_alterAliasDriver);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4242;
                this.match(CypherCmdParser.DRIVER);
                this.state = 4243;
                this.mapOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    alterAliasProperties() {
        let localctx = new AlterAliasPropertiesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 762, CypherCmdParser.RULE_alterAliasProperties);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4245;
                this.match(CypherCmdParser.PROPERTIES);
                this.state = 4246;
                this.mapOrParameter();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    showAliases() {
        let localctx = new ShowAliasesContext(this, this._ctx, this.state);
        this.enterRule(localctx, 764, CypherCmdParser.RULE_showAliases);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4248;
                _la = this._input.LA(1);
                if (!(_la === 30 || _la === 31)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 4250;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 531, this._ctx)) {
                    case 1:
                        {
                            this.state = 4249;
                            this.aliasName();
                        }
                        break;
                }
                this.state = 4252;
                this.match(CypherCmdParser.FOR);
                this.state = 4253;
                _la = this._input.LA(1);
                if (!(_la === 77 || _la === 78)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 4255;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 330 || _la === 335) {
                    {
                        this.state = 4254;
                        this.showCommandYield();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicNameOrStringParameter() {
        let localctx = new SymbolicNameOrStringParameterContext(this, this._ctx, this.state);
        this.enterRule(localctx, 766, CypherCmdParser.RULE_symbolicNameOrStringParameter);
        try {
            this.state = 4259;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4257;
                        this.symbolicNameString();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4258;
                        this.parameter("STRING");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    commandNameExpression() {
        let localctx = new CommandNameExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 768, CypherCmdParser.RULE_commandNameExpression);
        try {
            this.state = 4263;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4261;
                        this.symbolicNameString();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4262;
                        this.parameter("STRING");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicNameOrStringParameterList() {
        let localctx = new SymbolicNameOrStringParameterListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 770, CypherCmdParser.RULE_symbolicNameOrStringParameterList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4265;
                this.commandNameExpression();
                this.state = 4270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 4266;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 4267;
                            this.commandNameExpression();
                        }
                    }
                    this.state = 4272;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicAliasNameList() {
        let localctx = new SymbolicAliasNameListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 772, CypherCmdParser.RULE_symbolicAliasNameList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4273;
                this.symbolicAliasNameOrParameter();
                this.state = 4278;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 62) {
                    {
                        {
                            this.state = 4274;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 4275;
                            this.symbolicAliasNameOrParameter();
                        }
                    }
                    this.state = 4280;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicAliasNameOrParameter() {
        let localctx = new SymbolicAliasNameOrParameterContext(this, this._ctx, this.state);
        this.enterRule(localctx, 774, CypherCmdParser.RULE_symbolicAliasNameOrParameter);
        try {
            this.state = 4283;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4281;
                        this.symbolicAliasName();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4282;
                        this.parameter("STRING");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicAliasName() {
        let localctx = new SymbolicAliasNameContext(this, this._ctx, this.state);
        this.enterRule(localctx, 776, CypherCmdParser.RULE_symbolicAliasName);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4285;
                this.symbolicNameString();
                this.state = 4290;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 95) {
                    {
                        {
                            this.state = 4286;
                            this.match(CypherCmdParser.DOT);
                            this.state = 4287;
                            this.symbolicNameString();
                        }
                    }
                    this.state = 4292;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringListLiteral() {
        let localctx = new StringListLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 778, CypherCmdParser.RULE_stringListLiteral);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4293;
                this.match(CypherCmdParser.LBRACKET);
                this.state = 4302;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 22 || _la === 23) {
                    {
                        this.state = 4294;
                        this.stringLiteral();
                        this.state = 4299;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 62) {
                            {
                                {
                                    this.state = 4295;
                                    this.match(CypherCmdParser.COMMA);
                                    this.state = 4296;
                                    this.stringLiteral();
                                }
                            }
                            this.state = 4301;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 4304;
                this.match(CypherCmdParser.RBRACKET);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringList() {
        let localctx = new StringListContext(this, this._ctx, this.state);
        this.enterRule(localctx, 780, CypherCmdParser.RULE_stringList);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4306;
                this.stringLiteral();
                this.state = 4309;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 4307;
                            this.match(CypherCmdParser.COMMA);
                            this.state = 4308;
                            this.stringLiteral();
                        }
                    }
                    this.state = 4311;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while (_la === 62);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringLiteral() {
        let localctx = new StringLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 782, CypherCmdParser.RULE_stringLiteral);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4313;
                _la = this._input.LA(1);
                if (!(_la === 22 || _la === 23)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringOrParameterExpression() {
        let localctx = new StringOrParameterExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 784, CypherCmdParser.RULE_stringOrParameterExpression);
        try {
            this.state = 4317;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 22:
                case 23:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4315;
                        this.stringLiteral();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4316;
                        this.parameter("STRING");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringOrParameter() {
        let localctx = new StringOrParameterContext(this, this._ctx, this.state);
        this.enterRule(localctx, 786, CypherCmdParser.RULE_stringOrParameter);
        try {
            this.state = 4321;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 22:
                case 23:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4319;
                        this.stringLiteral();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4320;
                        this.parameter("STRING");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    uIntOrIntParameter() {
        let localctx = new UIntOrIntParameterContext(this, this._ctx, this.state);
        this.enterRule(localctx, 788, CypherCmdParser.RULE_uIntOrIntParameter);
        try {
            this.state = 4325;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 19:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4323;
                        this.match(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4324;
                        this.parameter("INTEGER");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    mapOrParameter() {
        let localctx = new MapOrParameterContext(this, this._ctx, this.state);
        this.enterRule(localctx, 790, CypherCmdParser.RULE_mapOrParameter);
        try {
            this.state = 4329;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 171:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4327;
                        this.map();
                    }
                    break;
                case 92:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4328;
                        this.parameter("MAP");
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    map() {
        let localctx = new MapContext(this, this._ctx, this.state);
        this.enterRule(localctx, 792, CypherCmdParser.RULE_map);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4331;
                this.match(CypherCmdParser.LCURLY);
                this.state = 4345;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4278219006) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0)) {
                    {
                        this.state = 4332;
                        this.propertyKeyName();
                        this.state = 4333;
                        this.match(CypherCmdParser.COLON);
                        this.state = 4334;
                        this.expression();
                        this.state = 4342;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 62) {
                            {
                                {
                                    this.state = 4335;
                                    this.match(CypherCmdParser.COMMA);
                                    this.state = 4336;
                                    this.propertyKeyName();
                                    this.state = 4337;
                                    this.match(CypherCmdParser.COLON);
                                    this.state = 4338;
                                    this.expression();
                                }
                            }
                            this.state = 4344;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 4347;
                this.match(CypherCmdParser.RCURLY);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicVariableNameString() {
        let localctx = new SymbolicVariableNameStringContext(this, this._ctx, this.state);
        this.enterRule(localctx, 794, CypherCmdParser.RULE_symbolicVariableNameString);
        try {
            this.state = 4351;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 24:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4349;
                        this.escapedSymbolicVariableNameString();
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4350;
                        this.unescapedSymbolicVariableNameString();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    escapedSymbolicVariableNameString() {
        let localctx = new EscapedSymbolicVariableNameStringContext(this, this._ctx, this.state);
        this.enterRule(localctx, 796, CypherCmdParser.RULE_escapedSymbolicVariableNameString);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4353;
                this.escapedSymbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    unescapedSymbolicVariableNameString() {
        let localctx = new UnescapedSymbolicVariableNameStringContext(this, this._ctx, this.state);
        this.enterRule(localctx, 798, CypherCmdParser.RULE_unescapedSymbolicVariableNameString);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4355;
                this.unescapedSymbolicNameString();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    symbolicNameString() {
        let localctx = new SymbolicNameStringContext(this, this._ctx, this.state);
        this.enterRule(localctx, 800, CypherCmdParser.RULE_symbolicNameString);
        try {
            this.state = 4359;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 24:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 4357;
                        this.escapedSymbolicNameString();
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 12:
                case 13:
                case 14:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 93:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 169:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 182:
                case 183:
                case 184:
                case 185:
                case 188:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 226:
                case 227:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 240:
                case 243:
                case 244:
                case 245:
                case 246:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                case 256:
                case 257:
                case 258:
                case 259:
                case 260:
                case 261:
                case 262:
                case 263:
                case 264:
                case 265:
                case 266:
                case 268:
                case 269:
                case 270:
                case 271:
                case 272:
                case 273:
                case 274:
                case 276:
                case 277:
                case 278:
                case 279:
                case 280:
                case 281:
                case 282:
                case 283:
                case 284:
                case 285:
                case 286:
                case 287:
                case 288:
                case 289:
                case 290:
                case 291:
                case 292:
                case 293:
                case 294:
                case 295:
                case 296:
                case 297:
                case 298:
                case 299:
                case 300:
                case 302:
                case 303:
                case 304:
                case 305:
                case 306:
                case 307:
                case 308:
                case 309:
                case 310:
                case 311:
                case 312:
                case 313:
                case 314:
                case 315:
                case 316:
                case 317:
                case 318:
                case 319:
                case 320:
                case 321:
                case 322:
                case 323:
                case 324:
                case 325:
                case 326:
                case 327:
                case 328:
                case 329:
                case 330:
                case 331:
                case 332:
                case 333:
                case 334:
                case 335:
                case 336:
                case 337:
                case 338:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 4358;
                        this.unescapedSymbolicNameString();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    escapedSymbolicNameString() {
        let localctx = new EscapedSymbolicNameStringContext(this, this._ctx, this.state);
        this.enterRule(localctx, 802, CypherCmdParser.RULE_escapedSymbolicNameString);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4361;
                this.match(CypherCmdParser.ESCAPED_SYMBOLIC_NAME);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    unescapedSymbolicNameString_() {
        let localctx = new UnescapedSymbolicNameString_Context(this, this._ctx, this.state);
        this.enterRule(localctx, 804, CypherCmdParser.RULE_unescapedSymbolicNameString_);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4363;
                _la = this._input.LA(1);
                if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & 4261429248) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2415910911) !== 0) || ((((_la - 64)) & ~0x1F) === 0 && ((1 << (_la - 64)) & 805306367) !== 0) || ((((_la - 98)) & ~0x1F) === 0 && ((1 << (_la - 98)) & 4294950911) !== 0) || ((((_la - 130)) & ~0x1F) === 0 && ((1 << (_la - 130)) & 4294966775) !== 0) || ((((_la - 162)) & ~0x1F) === 0 && ((1 << (_la - 162)) & 3841194143) !== 0) || ((((_la - 194)) & ~0x1F) === 0 && ((1 << (_la - 194)) & 1073741823) !== 0) || ((((_la - 226)) & ~0x1F) === 0 && ((1 << (_la - 226)) & 4292763643) !== 0) || ((((_la - 258)) & ~0x1F) === 0 && ((1 << (_la - 258)) & 4294835711) !== 0) || ((((_la - 290)) & ~0x1F) === 0 && ((1 << (_la - 290)) & 4294965247) !== 0) || ((((_la - 322)) & ~0x1F) === 0 && ((1 << (_la - 322)) & 131071) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    endOfFile() {
        let localctx = new EndOfFileContext(this, this._ctx, this.state);
        this.enterRule(localctx, 806, CypherCmdParser.RULE_endOfFile);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 4365;
                this.match(CypherCmdParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    static _serializedATN = [4, 1, 343, 4368, 2, 0, 7, 0,
        2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9,
        2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2,
        17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7, 20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24,
        7, 24, 2, 25, 7, 25, 2, 26, 7, 26, 2, 27, 7, 27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7,
        31, 2, 32, 7, 32, 2, 33, 7, 33, 2, 34, 7, 34, 2, 35, 7, 35, 2, 36, 7, 36, 2, 37, 7, 37, 2, 38, 7, 38,
        2, 39, 7, 39, 2, 40, 7, 40, 2, 41, 7, 41, 2, 42, 7, 42, 2, 43, 7, 43, 2, 44, 7, 44, 2, 45, 7, 45, 2,
        46, 7, 46, 2, 47, 7, 47, 2, 48, 7, 48, 2, 49, 7, 49, 2, 50, 7, 50, 2, 51, 7, 51, 2, 52, 7, 52, 2, 53,
        7, 53, 2, 54, 7, 54, 2, 55, 7, 55, 2, 56, 7, 56, 2, 57, 7, 57, 2, 58, 7, 58, 2, 59, 7, 59, 2, 60, 7,
        60, 2, 61, 7, 61, 2, 62, 7, 62, 2, 63, 7, 63, 2, 64, 7, 64, 2, 65, 7, 65, 2, 66, 7, 66, 2, 67, 7, 67,
        2, 68, 7, 68, 2, 69, 7, 69, 2, 70, 7, 70, 2, 71, 7, 71, 2, 72, 7, 72, 2, 73, 7, 73, 2, 74, 7, 74, 2,
        75, 7, 75, 2, 76, 7, 76, 2, 77, 7, 77, 2, 78, 7, 78, 2, 79, 7, 79, 2, 80, 7, 80, 2, 81, 7, 81, 2, 82,
        7, 82, 2, 83, 7, 83, 2, 84, 7, 84, 2, 85, 7, 85, 2, 86, 7, 86, 2, 87, 7, 87, 2, 88, 7, 88, 2, 89, 7,
        89, 2, 90, 7, 90, 2, 91, 7, 91, 2, 92, 7, 92, 2, 93, 7, 93, 2, 94, 7, 94, 2, 95, 7, 95, 2, 96, 7, 96,
        2, 97, 7, 97, 2, 98, 7, 98, 2, 99, 7, 99, 2, 100, 7, 100, 2, 101, 7, 101, 2, 102, 7, 102, 2, 103,
        7, 103, 2, 104, 7, 104, 2, 105, 7, 105, 2, 106, 7, 106, 2, 107, 7, 107, 2, 108, 7, 108, 2, 109,
        7, 109, 2, 110, 7, 110, 2, 111, 7, 111, 2, 112, 7, 112, 2, 113, 7, 113, 2, 114, 7, 114, 2, 115,
        7, 115, 2, 116, 7, 116, 2, 117, 7, 117, 2, 118, 7, 118, 2, 119, 7, 119, 2, 120, 7, 120, 2, 121,
        7, 121, 2, 122, 7, 122, 2, 123, 7, 123, 2, 124, 7, 124, 2, 125, 7, 125, 2, 126, 7, 126, 2, 127,
        7, 127, 2, 128, 7, 128, 2, 129, 7, 129, 2, 130, 7, 130, 2, 131, 7, 131, 2, 132, 7, 132, 2, 133,
        7, 133, 2, 134, 7, 134, 2, 135, 7, 135, 2, 136, 7, 136, 2, 137, 7, 137, 2, 138, 7, 138, 2, 139,
        7, 139, 2, 140, 7, 140, 2, 141, 7, 141, 2, 142, 7, 142, 2, 143, 7, 143, 2, 144, 7, 144, 2, 145,
        7, 145, 2, 146, 7, 146, 2, 147, 7, 147, 2, 148, 7, 148, 2, 149, 7, 149, 2, 150, 7, 150, 2, 151,
        7, 151, 2, 152, 7, 152, 2, 153, 7, 153, 2, 154, 7, 154, 2, 155, 7, 155, 2, 156, 7, 156, 2, 157,
        7, 157, 2, 158, 7, 158, 2, 159, 7, 159, 2, 160, 7, 160, 2, 161, 7, 161, 2, 162, 7, 162, 2, 163,
        7, 163, 2, 164, 7, 164, 2, 165, 7, 165, 2, 166, 7, 166, 2, 167, 7, 167, 2, 168, 7, 168, 2, 169,
        7, 169, 2, 170, 7, 170, 2, 171, 7, 171, 2, 172, 7, 172, 2, 173, 7, 173, 2, 174, 7, 174, 2, 175,
        7, 175, 2, 176, 7, 176, 2, 177, 7, 177, 2, 178, 7, 178, 2, 179, 7, 179, 2, 180, 7, 180, 2, 181,
        7, 181, 2, 182, 7, 182, 2, 183, 7, 183, 2, 184, 7, 184, 2, 185, 7, 185, 2, 186, 7, 186, 2, 187,
        7, 187, 2, 188, 7, 188, 2, 189, 7, 189, 2, 190, 7, 190, 2, 191, 7, 191, 2, 192, 7, 192, 2, 193,
        7, 193, 2, 194, 7, 194, 2, 195, 7, 195, 2, 196, 7, 196, 2, 197, 7, 197, 2, 198, 7, 198, 2, 199,
        7, 199, 2, 200, 7, 200, 2, 201, 7, 201, 2, 202, 7, 202, 2, 203, 7, 203, 2, 204, 7, 204, 2, 205,
        7, 205, 2, 206, 7, 206, 2, 207, 7, 207, 2, 208, 7, 208, 2, 209, 7, 209, 2, 210, 7, 210, 2, 211,
        7, 211, 2, 212, 7, 212, 2, 213, 7, 213, 2, 214, 7, 214, 2, 215, 7, 215, 2, 216, 7, 216, 2, 217,
        7, 217, 2, 218, 7, 218, 2, 219, 7, 219, 2, 220, 7, 220, 2, 221, 7, 221, 2, 222, 7, 222, 2, 223,
        7, 223, 2, 224, 7, 224, 2, 225, 7, 225, 2, 226, 7, 226, 2, 227, 7, 227, 2, 228, 7, 228, 2, 229,
        7, 229, 2, 230, 7, 230, 2, 231, 7, 231, 2, 232, 7, 232, 2, 233, 7, 233, 2, 234, 7, 234, 2, 235,
        7, 235, 2, 236, 7, 236, 2, 237, 7, 237, 2, 238, 7, 238, 2, 239, 7, 239, 2, 240, 7, 240, 2, 241,
        7, 241, 2, 242, 7, 242, 2, 243, 7, 243, 2, 244, 7, 244, 2, 245, 7, 245, 2, 246, 7, 246, 2, 247,
        7, 247, 2, 248, 7, 248, 2, 249, 7, 249, 2, 250, 7, 250, 2, 251, 7, 251, 2, 252, 7, 252, 2, 253,
        7, 253, 2, 254, 7, 254, 2, 255, 7, 255, 2, 256, 7, 256, 2, 257, 7, 257, 2, 258, 7, 258, 2, 259,
        7, 259, 2, 260, 7, 260, 2, 261, 7, 261, 2, 262, 7, 262, 2, 263, 7, 263, 2, 264, 7, 264, 2, 265,
        7, 265, 2, 266, 7, 266, 2, 267, 7, 267, 2, 268, 7, 268, 2, 269, 7, 269, 2, 270, 7, 270, 2, 271,
        7, 271, 2, 272, 7, 272, 2, 273, 7, 273, 2, 274, 7, 274, 2, 275, 7, 275, 2, 276, 7, 276, 2, 277,
        7, 277, 2, 278, 7, 278, 2, 279, 7, 279, 2, 280, 7, 280, 2, 281, 7, 281, 2, 282, 7, 282, 2, 283,
        7, 283, 2, 284, 7, 284, 2, 285, 7, 285, 2, 286, 7, 286, 2, 287, 7, 287, 2, 288, 7, 288, 2, 289,
        7, 289, 2, 290, 7, 290, 2, 291, 7, 291, 2, 292, 7, 292, 2, 293, 7, 293, 2, 294, 7, 294, 2, 295,
        7, 295, 2, 296, 7, 296, 2, 297, 7, 297, 2, 298, 7, 298, 2, 299, 7, 299, 2, 300, 7, 300, 2, 301,
        7, 301, 2, 302, 7, 302, 2, 303, 7, 303, 2, 304, 7, 304, 2, 305, 7, 305, 2, 306, 7, 306, 2, 307,
        7, 307, 2, 308, 7, 308, 2, 309, 7, 309, 2, 310, 7, 310, 2, 311, 7, 311, 2, 312, 7, 312, 2, 313,
        7, 313, 2, 314, 7, 314, 2, 315, 7, 315, 2, 316, 7, 316, 2, 317, 7, 317, 2, 318, 7, 318, 2, 319,
        7, 319, 2, 320, 7, 320, 2, 321, 7, 321, 2, 322, 7, 322, 2, 323, 7, 323, 2, 324, 7, 324, 2, 325,
        7, 325, 2, 326, 7, 326, 2, 327, 7, 327, 2, 328, 7, 328, 2, 329, 7, 329, 2, 330, 7, 330, 2, 331,
        7, 331, 2, 332, 7, 332, 2, 333, 7, 333, 2, 334, 7, 334, 2, 335, 7, 335, 2, 336, 7, 336, 2, 337,
        7, 337, 2, 338, 7, 338, 2, 339, 7, 339, 2, 340, 7, 340, 2, 341, 7, 341, 2, 342, 7, 342, 2, 343,
        7, 343, 2, 344, 7, 344, 2, 345, 7, 345, 2, 346, 7, 346, 2, 347, 7, 347, 2, 348, 7, 348, 2, 349,
        7, 349, 2, 350, 7, 350, 2, 351, 7, 351, 2, 352, 7, 352, 2, 353, 7, 353, 2, 354, 7, 354, 2, 355,
        7, 355, 2, 356, 7, 356, 2, 357, 7, 357, 2, 358, 7, 358, 2, 359, 7, 359, 2, 360, 7, 360, 2, 361,
        7, 361, 2, 362, 7, 362, 2, 363, 7, 363, 2, 364, 7, 364, 2, 365, 7, 365, 2, 366, 7, 366, 2, 367,
        7, 367, 2, 368, 7, 368, 2, 369, 7, 369, 2, 370, 7, 370, 2, 371, 7, 371, 2, 372, 7, 372, 2, 373,
        7, 373, 2, 374, 7, 374, 2, 375, 7, 375, 2, 376, 7, 376, 2, 377, 7, 377, 2, 378, 7, 378, 2, 379,
        7, 379, 2, 380, 7, 380, 2, 381, 7, 381, 2, 382, 7, 382, 2, 383, 7, 383, 2, 384, 7, 384, 2, 385,
        7, 385, 2, 386, 7, 386, 2, 387, 7, 387, 2, 388, 7, 388, 2, 389, 7, 389, 2, 390, 7, 390, 2, 391,
        7, 391, 2, 392, 7, 392, 2, 393, 7, 393, 2, 394, 7, 394, 2, 395, 7, 395, 2, 396, 7, 396, 2, 397,
        7, 397, 2, 398, 7, 398, 2, 399, 7, 399, 2, 400, 7, 400, 2, 401, 7, 401, 2, 402, 7, 402, 2, 403,
        7, 403, 1, 0, 1, 0, 1, 0, 5, 0, 812, 8, 0, 10, 0, 12, 0, 815, 9, 0, 1, 0, 3, 0, 818, 8, 0, 1, 0, 1, 0,
        1, 1, 1, 1, 3, 1, 824, 8, 1, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2,
        3, 2, 839, 8, 2, 1, 3, 1, 3, 3, 3, 843, 8, 3, 1, 4, 1, 4, 1, 4, 1, 4, 3, 4, 849, 8, 4, 1, 5, 1, 5, 1, 5,
        1, 5, 1, 5, 1, 6, 1, 6, 1, 7, 1, 7, 1, 8, 1, 8, 3, 8, 862, 8, 8, 1, 9, 1, 9, 1, 9, 1, 10, 1, 10, 1, 11,
        1, 11, 1, 12, 1, 12, 1, 13, 1, 13, 1, 14, 1, 14, 3, 14, 877, 8, 14, 1, 15, 1, 15, 1, 16, 1, 16, 1,
        17, 1, 17, 3, 17, 885, 8, 17, 1, 18, 1, 18, 3, 18, 889, 8, 18, 1, 19, 1, 19, 1, 20, 1, 20, 1, 21,
        1, 21, 1, 22, 1, 22, 1, 23, 1, 23, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 3,
        24, 910, 8, 24, 1, 25, 5, 25, 913, 8, 25, 10, 25, 12, 25, 916, 9, 25, 1, 25, 1, 25, 1, 26, 1, 26,
        1, 27, 1, 27, 1, 27, 3, 27, 925, 8, 27, 1, 28, 1, 28, 1, 29, 1, 29, 3, 29, 931, 8, 29, 1, 29, 5, 29,
        934, 8, 29, 10, 29, 12, 29, 937, 9, 29, 1, 30, 1, 30, 1, 30, 1, 30, 1, 31, 1, 31, 3, 31, 945, 8,
        31, 1, 32, 1, 32, 1, 33, 4, 33, 950, 8, 33, 11, 33, 12, 33, 951, 1, 34, 1, 34, 1, 34, 5, 34, 957,
        8, 34, 10, 34, 12, 34, 960, 9, 34, 1, 34, 3, 34, 963, 8, 34, 1, 34, 1, 34, 1, 35, 1, 35, 3, 35, 969,
        8, 35, 1, 36, 1, 36, 1, 36, 5, 36, 974, 8, 36, 10, 36, 12, 36, 977, 9, 36, 1, 37, 1, 37, 3, 37, 981,
        8, 37, 1, 38, 1, 38, 1, 38, 3, 38, 986, 8, 38, 1, 38, 5, 38, 989, 8, 38, 10, 38, 12, 38, 992, 9,
        38, 1, 39, 4, 39, 995, 8, 39, 11, 39, 12, 39, 996, 1, 39, 3, 39, 1000, 8, 39, 1, 40, 1, 40, 1, 40,
        1, 40, 1, 40, 1, 41, 1, 41, 1, 41, 1, 42, 4, 42, 1011, 8, 42, 11, 42, 12, 42, 1012, 1, 42, 3, 42,
        1016, 8, 42, 1, 42, 1, 42, 1, 42, 1, 42, 3, 42, 1022, 8, 42, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1,
        43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 3, 43,
        1043, 8, 43, 1, 44, 1, 44, 3, 44, 1047, 8, 44, 1, 44, 1, 44, 1, 45, 1, 45, 1, 45, 1, 45, 1, 45, 1,
        45, 3, 45, 1057, 8, 45, 1, 46, 1, 46, 1, 47, 1, 47, 1, 47, 1, 48, 3, 48, 1065, 8, 48, 1, 48, 1, 48,
        3, 48, 1069, 8, 48, 1, 48, 3, 48, 1072, 8, 48, 1, 48, 3, 48, 1075, 8, 48, 1, 49, 1, 49, 1, 49, 3,
        49, 1080, 8, 49, 1, 50, 1, 50, 3, 50, 1084, 8, 50, 1, 50, 1, 50, 5, 50, 1088, 8, 50, 10, 50, 12,
        50, 1091, 9, 50, 1, 51, 1, 51, 1, 51, 3, 51, 1096, 8, 51, 1, 52, 1, 52, 1, 53, 1, 53, 1, 54, 1, 54,
        1, 54, 1, 54, 1, 54, 5, 54, 1107, 8, 54, 10, 54, 12, 54, 1110, 9, 54, 1, 55, 1, 55, 1, 55, 1, 56,
        1, 56, 1, 56, 1, 57, 1, 57, 1, 57, 1, 58, 1, 58, 1, 58, 3, 58, 1124, 8, 58, 1, 59, 1, 59, 1, 59, 1,
        60, 1, 60, 1, 60, 1, 61, 1, 61, 1, 61, 1, 61, 5, 61, 1136, 8, 61, 10, 61, 12, 61, 1139, 9, 61, 1,
        62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62,
        1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 3, 62, 1163, 8, 62, 1, 63, 1, 63, 1, 63, 1, 63, 5,
        63, 1169, 8, 63, 10, 63, 12, 63, 1172, 9, 63, 1, 64, 1, 64, 1, 64, 1, 64, 1, 64, 1, 64, 1, 64, 1,
        64, 3, 64, 1182, 8, 64, 1, 65, 3, 65, 1185, 8, 65, 1, 65, 1, 65, 1, 65, 1, 65, 5, 65, 1191, 8, 65,
        10, 65, 12, 65, 1194, 9, 65, 1, 66, 3, 66, 1197, 8, 66, 1, 66, 1, 66, 3, 66, 1201, 8, 66, 1, 66,
        1, 66, 5, 66, 1205, 8, 66, 10, 66, 12, 66, 1208, 9, 66, 1, 66, 3, 66, 1211, 8, 66, 1, 67, 1, 67,
        1, 67, 3, 67, 1216, 8, 67, 1, 67, 3, 67, 1219, 8, 67, 1, 67, 1, 67, 1, 67, 3, 67, 1224, 8, 67, 1,
        67, 3, 67, 1227, 8, 67, 3, 67, 1229, 8, 67, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68,
        3, 68, 1239, 8, 68, 1, 68, 3, 68, 1242, 8, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1,
        68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 3, 68, 1257, 8, 68, 1, 69, 1, 69, 1, 69, 5, 69, 1262, 8, 69,
        10, 69, 12, 69, 1265, 9, 69, 1, 70, 1, 70, 1, 70, 1, 70, 1, 71, 1, 71, 3, 71, 1273, 8, 71, 1, 71,
        1, 71, 1, 72, 1, 72, 1, 72, 1, 72, 1, 72, 1, 73, 1, 73, 1, 73, 1, 73, 5, 73, 1286, 8, 73, 10, 73,
        12, 73, 1289, 9, 73, 1, 74, 1, 74, 1, 74, 1, 74, 1, 75, 3, 75, 1296, 8, 75, 1, 75, 1, 75, 1, 75,
        1, 75, 1, 75, 1, 75, 5, 75, 1304, 8, 75, 10, 75, 12, 75, 1307, 9, 75, 3, 75, 1309, 8, 75, 1, 75,
        3, 75, 1312, 8, 75, 1, 75, 1, 75, 1, 75, 1, 75, 1, 75, 5, 75, 1319, 8, 75, 10, 75, 12, 75, 1322,
        9, 75, 1, 75, 3, 75, 1325, 8, 75, 3, 75, 1327, 8, 75, 3, 75, 1329, 8, 75, 1, 76, 1, 76, 1, 76, 1,
        77, 1, 77, 1, 78, 1, 78, 1, 78, 3, 78, 1339, 8, 78, 1, 79, 1, 79, 1, 79, 1, 79, 3, 79, 1345, 8, 79,
        1, 79, 1, 79, 1, 79, 1, 79, 1, 79, 1, 79, 3, 79, 1353, 8, 79, 1, 80, 1, 80, 1, 80, 1, 80, 1, 80, 1,
        80, 1, 80, 4, 80, 1362, 8, 80, 11, 80, 12, 80, 1363, 1, 80, 1, 80, 1, 81, 3, 81, 1369, 8, 81, 1,
        81, 1, 81, 3, 81, 1373, 8, 81, 1, 81, 1, 81, 1, 81, 1, 81, 3, 81, 1379, 8, 81, 1, 82, 1, 82, 1, 82,
        1, 82, 1, 82, 5, 82, 1386, 8, 82, 10, 82, 12, 82, 1389, 9, 82, 3, 82, 1391, 8, 82, 1, 82, 1, 82,
        1, 83, 1, 83, 3, 83, 1397, 8, 83, 1, 83, 3, 83, 1400, 8, 83, 1, 83, 1, 83, 1, 83, 1, 83, 5, 83, 1406,
        8, 83, 10, 83, 12, 83, 1409, 9, 83, 1, 84, 1, 84, 1, 84, 1, 84, 1, 85, 1, 85, 1, 85, 1, 85, 3, 85,
        1419, 8, 85, 1, 85, 1, 85, 3, 85, 1423, 8, 85, 1, 85, 1, 85, 1, 85, 3, 85, 1428, 8, 85, 1, 86, 3,
        86, 1431, 8, 86, 1, 86, 1, 86, 1, 86, 1, 87, 1, 87, 1, 87, 1, 87, 1, 87, 1, 88, 1, 88, 3, 88, 1443,
        8, 88, 1, 88, 3, 88, 1446, 8, 88, 1, 88, 1, 88, 3, 88, 1450, 8, 88, 1, 88, 3, 88, 1453, 8, 88, 1,
        89, 1, 89, 1, 89, 5, 89, 1458, 8, 89, 10, 89, 12, 89, 1461, 9, 89, 1, 90, 1, 90, 1, 90, 5, 90, 1466,
        8, 90, 10, 90, 12, 90, 1469, 9, 90, 1, 91, 1, 91, 1, 91, 3, 91, 1474, 8, 91, 1, 91, 3, 91, 1477,
        8, 91, 1, 91, 1, 91, 1, 92, 1, 92, 1, 92, 3, 92, 1484, 8, 92, 1, 92, 1, 92, 1, 92, 1, 92, 5, 92, 1490,
        8, 92, 10, 92, 12, 92, 1493, 9, 92, 1, 93, 1, 93, 1, 93, 1, 93, 1, 93, 3, 93, 1500, 8, 93, 1, 93,
        1, 93, 3, 93, 1504, 8, 93, 1, 93, 1, 93, 1, 93, 3, 93, 1509, 8, 93, 1, 94, 1, 94, 3, 94, 1513, 8,
        94, 1, 95, 1, 95, 1, 95, 1, 95, 1, 95, 1, 96, 1, 96, 1, 96, 3, 96, 1523, 8, 96, 1, 96, 1, 96, 5, 96,
        1527, 8, 96, 10, 96, 12, 96, 1530, 9, 96, 1, 96, 4, 96, 1533, 8, 96, 11, 96, 12, 96, 1534, 1,
        97, 1, 97, 1, 97, 3, 97, 1540, 8, 97, 1, 97, 1, 97, 1, 97, 3, 97, 1545, 8, 97, 1, 97, 1, 97, 3, 97,
        1549, 8, 97, 1, 97, 3, 97, 1552, 8, 97, 1, 97, 1, 97, 3, 97, 1556, 8, 97, 1, 97, 1, 97, 3, 97, 1560,
        8, 97, 1, 97, 3, 97, 1563, 8, 97, 1, 97, 1, 97, 1, 97, 1, 97, 3, 97, 1569, 8, 97, 3, 97, 1571, 8,
        97, 1, 98, 1, 98, 3, 98, 1575, 8, 98, 1, 99, 1, 99, 1, 100, 1, 100, 1, 101, 1, 101, 1, 101, 1, 101,
        4, 101, 1585, 8, 101, 11, 101, 12, 101, 1586, 1, 102, 1, 102, 1, 102, 1, 102, 1, 102, 1, 102,
        1, 102, 3, 102, 1596, 8, 102, 1, 102, 3, 102, 1599, 8, 102, 1, 102, 3, 102, 1602, 8, 102, 1,
        102, 1, 102, 3, 102, 1606, 8, 102, 1, 102, 3, 102, 1609, 8, 102, 1, 103, 1, 103, 1, 103, 1, 103,
        1, 103, 1, 103, 1, 103, 3, 103, 1618, 8, 103, 1, 103, 3, 103, 1621, 8, 103, 1, 103, 3, 103, 1624,
        8, 103, 1, 103, 3, 103, 1627, 8, 103, 1, 104, 1, 104, 1, 104, 1, 104, 3, 104, 1633, 8, 104, 1,
        104, 1, 104, 3, 104, 1637, 8, 104, 1, 105, 1, 105, 4, 105, 1641, 8, 105, 11, 105, 12, 105, 1642,
        1, 106, 1, 106, 1, 106, 3, 106, 1648, 8, 106, 1, 106, 1, 106, 5, 106, 1652, 8, 106, 10, 106,
        12, 106, 1655, 9, 106, 1, 107, 1, 107, 1, 107, 1, 107, 1, 107, 1, 108, 1, 108, 3, 108, 1664,
        8, 108, 1, 108, 1, 108, 1, 108, 1, 108, 1, 109, 1, 109, 1, 109, 1, 110, 1, 110, 1, 110, 1, 111,
        1, 111, 1, 111, 1, 112, 1, 112, 1, 112, 1, 113, 1, 113, 3, 113, 1684, 8, 113, 1, 114, 3, 114,
        1687, 8, 114, 1, 114, 1, 114, 1, 114, 1, 114, 1, 114, 1, 114, 1, 114, 1, 114, 3, 114, 1697, 8,
        114, 1, 114, 3, 114, 1700, 8, 114, 1, 114, 3, 114, 1703, 8, 114, 1, 114, 3, 114, 1706, 8, 114,
        1, 114, 1, 114, 3, 114, 1710, 8, 114, 1, 114, 3, 114, 1713, 8, 114, 1, 114, 1, 114, 3, 114, 1717,
        8, 114, 1, 115, 3, 115, 1720, 8, 115, 1, 115, 1, 115, 1, 115, 1, 115, 1, 115, 1, 115, 1, 115,
        1, 115, 3, 115, 1730, 8, 115, 1, 115, 1, 115, 3, 115, 1734, 8, 115, 1, 115, 1, 115, 3, 115, 1738,
        8, 115, 1, 115, 1, 115, 3, 115, 1742, 8, 115, 1, 116, 1, 116, 1, 117, 1, 117, 1, 118, 1, 118,
        1, 119, 1, 119, 3, 119, 1752, 8, 119, 1, 119, 1, 119, 3, 119, 1756, 8, 119, 1, 119, 3, 119, 1759,
        8, 119, 1, 120, 1, 120, 1, 120, 1, 121, 1, 121, 1, 121, 3, 121, 1767, 8, 121, 1, 121, 5, 121,
        1770, 8, 121, 10, 121, 12, 121, 1773, 9, 121, 1, 122, 1, 122, 1, 122, 5, 122, 1778, 8, 122,
        10, 122, 12, 122, 1781, 9, 122, 1, 123, 5, 123, 1784, 8, 123, 10, 123, 12, 123, 1787, 9, 123,
        1, 123, 1, 123, 1, 124, 1, 124, 1, 124, 1, 124, 1, 124, 1, 124, 1, 124, 3, 124, 1798, 8, 124,
        1, 125, 1, 125, 1, 125, 1, 125, 5, 125, 1804, 8, 125, 10, 125, 12, 125, 1807, 9, 125, 1, 126,
        1, 126, 1, 126, 1, 127, 1, 127, 1, 127, 5, 127, 1815, 8, 127, 10, 127, 12, 127, 1818, 9, 127,
        1, 128, 1, 128, 1, 128, 5, 128, 1823, 8, 128, 10, 128, 12, 128, 1826, 9, 128, 1, 129, 1, 129,
        1, 129, 5, 129, 1831, 8, 129, 10, 129, 12, 129, 1834, 9, 129, 1, 130, 5, 130, 1837, 8, 130,
        10, 130, 12, 130, 1840, 9, 130, 1, 130, 1, 130, 1, 131, 1, 131, 1, 131, 5, 131, 1847, 8, 131,
        10, 131, 12, 131, 1850, 9, 131, 1, 132, 1, 132, 3, 132, 1854, 8, 132, 1, 133, 1, 133, 1, 133,
        1, 133, 1, 133, 1, 133, 1, 133, 3, 133, 1863, 8, 133, 1, 133, 1, 133, 1, 133, 3, 133, 1868, 8,
        133, 1, 133, 1, 133, 1, 133, 3, 133, 1873, 8, 133, 1, 133, 1, 133, 3, 133, 1877, 8, 133, 1, 133,
        1, 133, 1, 133, 3, 133, 1882, 8, 133, 1, 133, 3, 133, 1885, 8, 133, 1, 133, 1, 133, 3, 133, 1889,
        8, 133, 1, 134, 1, 134, 1, 135, 1, 135, 1, 135, 5, 135, 1896, 8, 135, 10, 135, 12, 135, 1899,
        9, 135, 1, 136, 1, 136, 1, 136, 5, 136, 1904, 8, 136, 10, 136, 12, 136, 1907, 9, 136, 1, 137,
        1, 137, 1, 137, 5, 137, 1912, 8, 137, 10, 137, 12, 137, 1915, 9, 137, 1, 138, 1, 138, 1, 138,
        3, 138, 1920, 8, 138, 1, 139, 1, 139, 5, 139, 1924, 8, 139, 10, 139, 12, 139, 1927, 9, 139,
        1, 140, 1, 140, 1, 140, 1, 140, 1, 140, 1, 140, 1, 140, 3, 140, 1936, 8, 140, 1, 140, 1, 140,
        3, 140, 1940, 8, 140, 1, 140, 3, 140, 1943, 8, 140, 1, 141, 1, 141, 1, 141, 1, 142, 1, 142, 1,
        142, 1, 142, 1, 143, 1, 143, 4, 143, 1954, 8, 143, 11, 143, 12, 143, 1955, 1, 144, 1, 144, 1,
        144, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1,
        145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 1, 145, 3,
        145, 1984, 8, 145, 1, 146, 1, 146, 1, 146, 1, 146, 1, 146, 1, 146, 1, 146, 1, 146, 1, 146, 3,
        146, 1995, 8, 146, 1, 147, 1, 147, 4, 147, 1999, 8, 147, 11, 147, 12, 147, 2000, 1, 147, 1,
        147, 3, 147, 2005, 8, 147, 1, 147, 1, 147, 1, 148, 1, 148, 1, 148, 1, 148, 1, 148, 1, 149, 1,
        149, 1, 149, 4, 149, 2017, 8, 149, 11, 149, 12, 149, 2018, 1, 149, 1, 149, 3, 149, 2023, 8,
        149, 1, 149, 1, 149, 1, 150, 1, 150, 1, 150, 1, 150, 5, 150, 2031, 8, 150, 10, 150, 12, 150,
        2034, 9, 150, 1, 150, 1, 150, 1, 150, 1, 151, 1, 151, 1, 151, 1, 151, 3, 151, 2043, 8, 151, 1,
        152, 1, 152, 1, 152, 1, 152, 1, 152, 1, 152, 3, 152, 2051, 8, 152, 1, 152, 1, 152, 1, 152, 1,
        152, 3, 152, 2057, 8, 152, 3, 152, 2059, 8, 152, 1, 152, 1, 152, 1, 153, 1, 153, 1, 153, 1, 153,
        3, 153, 2067, 8, 153, 1, 153, 1, 153, 1, 153, 3, 153, 2072, 8, 153, 1, 153, 1, 153, 1, 153, 1,
        153, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1, 154, 1,
        154, 1, 154, 1, 155, 1, 155, 1, 155, 1, 155, 1, 155, 1, 155, 1, 155, 1, 155, 1, 155, 1, 155, 1,
        155, 1, 156, 1, 156, 1, 156, 1, 156, 1, 156, 1, 156, 1, 156, 3, 156, 2109, 8, 156, 1, 156, 1,
        156, 1, 157, 1, 157, 1, 157, 1, 157, 1, 157, 3, 157, 2118, 8, 157, 1, 157, 1, 157, 1, 158, 1,
        158, 1, 158, 1, 158, 1, 158, 1, 158, 1, 158, 1, 158, 1, 158, 1, 159, 1, 159, 1, 159, 3, 159, 2134,
        8, 159, 1, 159, 3, 159, 2137, 8, 159, 1, 159, 3, 159, 2140, 8, 159, 1, 159, 1, 159, 1, 159, 1,
        160, 1, 160, 1, 161, 1, 161, 1, 162, 1, 162, 1, 162, 1, 162, 1, 163, 1, 163, 1, 163, 1, 163, 1,
        163, 5, 163, 2158, 8, 163, 10, 163, 12, 163, 2161, 9, 163, 3, 163, 2163, 8, 163, 1, 163, 1,
        163, 1, 164, 1, 164, 1, 164, 1, 164, 1, 164, 1, 164, 1, 164, 1, 164, 3, 164, 2175, 8, 164, 1,
        165, 1, 165, 1, 165, 1, 165, 1, 165, 1, 166, 1, 166, 1, 166, 1, 166, 3, 166, 2186, 8, 166, 1,
        166, 1, 166, 3, 166, 2190, 8, 166, 3, 166, 2192, 8, 166, 1, 166, 1, 166, 1, 167, 1, 167, 1, 167,
        1, 167, 3, 167, 2200, 8, 167, 1, 167, 1, 167, 3, 167, 2204, 8, 167, 3, 167, 2206, 8, 167, 1,
        167, 1, 167, 1, 168, 1, 168, 1, 168, 1, 168, 1, 168, 1, 169, 3, 169, 2216, 8, 169, 1, 169, 1,
        169, 1, 170, 3, 170, 2221, 8, 170, 1, 170, 1, 170, 1, 171, 1, 171, 1, 171, 1, 171, 5, 171, 2229,
        8, 171, 10, 171, 12, 171, 2232, 9, 171, 3, 171, 2234, 8, 171, 1, 171, 1, 171, 1, 172, 1, 172,
        1, 173, 1, 173, 1, 173, 1, 174, 1, 174, 1, 174, 1, 174, 3, 174, 2247, 8, 174, 1, 175, 1, 175,
        1, 175, 3, 175, 2252, 8, 175, 1, 175, 1, 175, 1, 175, 5, 175, 2257, 8, 175, 10, 175, 12, 175,
        2260, 9, 175, 3, 175, 2262, 8, 175, 1, 175, 1, 175, 1, 176, 1, 176, 1, 177, 1, 177, 1, 177, 1,
        178, 1, 178, 1, 178, 5, 178, 2274, 8, 178, 10, 178, 12, 178, 2277, 9, 178, 1, 179, 1, 179, 1,
        180, 1, 180, 1, 180, 5, 180, 2284, 8, 180, 10, 180, 12, 180, 2287, 9, 180, 1, 181, 1, 181, 1,
        181, 5, 181, 2292, 8, 181, 10, 181, 12, 181, 2295, 9, 181, 1, 182, 1, 182, 3, 182, 2299, 8,
        182, 1, 182, 5, 182, 2302, 8, 182, 10, 182, 12, 182, 2305, 9, 182, 1, 183, 1, 183, 1, 183, 1,
        183, 1, 183, 1, 183, 1, 183, 1, 183, 3, 183, 2315, 8, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1,
        183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 3, 183, 2332,
        8, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 3, 183, 2339, 8, 183, 1, 183, 1, 183, 1, 183,
        1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183,
        3, 183, 2356, 8, 183, 1, 183, 1, 183, 1, 183, 1, 183, 3, 183, 2362, 8, 183, 1, 183, 1, 183, 1,
        183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1,
        183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 1, 183, 3, 183, 2386, 8, 183, 1, 183, 1,
        183, 1, 183, 1, 183, 1, 183, 3, 183, 2393, 8, 183, 3, 183, 2395, 8, 183, 1, 184, 1, 184, 1, 184,
        3, 184, 2400, 8, 184, 1, 185, 1, 185, 3, 185, 2404, 8, 185, 1, 186, 1, 186, 3, 186, 2408, 8,
        186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1, 186, 1,
        186, 3, 186, 2422, 8, 186, 1, 186, 3, 186, 2425, 8, 186, 1, 187, 3, 187, 2428, 8, 187, 1, 187,
        1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187, 1, 187,
        3, 187, 2443, 8, 187, 1, 188, 1, 188, 1, 188, 3, 188, 2448, 8, 188, 1, 188, 1, 188, 1, 188, 1,
        188, 1, 188, 1, 188, 1, 188, 3, 188, 2457, 8, 188, 1, 189, 1, 189, 1, 189, 1, 189, 1, 189, 1,
        189, 1, 189, 3, 189, 2466, 8, 189, 1, 190, 1, 190, 1, 190, 1, 190, 1, 190, 1, 190, 1, 190, 1,
        190, 3, 190, 2476, 8, 190, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1,
        191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 1, 191, 3, 191, 2495, 8, 191, 1,
        192, 1, 192, 3, 192, 2499, 8, 192, 1, 192, 3, 192, 2502, 8, 192, 1, 193, 1, 193, 1, 193, 3, 193,
        2507, 8, 193, 1, 194, 1, 194, 1, 194, 1, 195, 1, 195, 1, 195, 1, 196, 1, 196, 1, 196, 1, 196,
        1, 196, 5, 196, 2520, 8, 196, 10, 196, 12, 196, 2523, 9, 196, 3, 196, 2525, 8, 196, 1, 196,
        3, 196, 2528, 8, 196, 1, 196, 3, 196, 2531, 8, 196, 1, 196, 3, 196, 2534, 8, 196, 1, 196, 3,
        196, 2537, 8, 196, 1, 197, 1, 197, 1, 197, 1, 198, 1, 198, 1, 198, 1, 199, 1, 199, 3, 199, 2547,
        8, 199, 1, 200, 1, 200, 1, 200, 1, 200, 1, 200, 1, 200, 1, 200, 3, 200, 2556, 8, 200, 1, 201,
        3, 201, 2559, 8, 201, 1, 201, 1, 201, 1, 202, 1, 202, 1, 203, 1, 203, 3, 203, 2567, 8, 203, 1,
        203, 3, 203, 2570, 8, 203, 1, 204, 3, 204, 2573, 8, 204, 1, 204, 1, 204, 3, 204, 2577, 8, 204,
        1, 204, 1, 204, 1, 204, 1, 204, 3, 204, 2583, 8, 204, 1, 204, 1, 204, 1, 204, 3, 204, 2588, 8,
        204, 1, 204, 1, 204, 1, 204, 1, 204, 3, 204, 2594, 8, 204, 1, 204, 3, 204, 2597, 8, 204, 1, 204,
        1, 204, 3, 204, 2601, 8, 204, 1, 205, 1, 205, 3, 205, 2605, 8, 205, 1, 206, 1, 206, 1, 206, 1,
        206, 1, 206, 1, 206, 3, 206, 2613, 8, 206, 1, 207, 1, 207, 3, 207, 2617, 8, 207, 1, 207, 3, 207,
        2620, 8, 207, 1, 208, 1, 208, 3, 208, 2624, 8, 208, 1, 208, 3, 208, 2627, 8, 208, 1, 208, 3,
        208, 2630, 8, 208, 1, 209, 3, 209, 2633, 8, 209, 1, 209, 1, 209, 3, 209, 2637, 8, 209, 1, 209,
        3, 209, 2640, 8, 209, 1, 209, 3, 209, 2643, 8, 209, 1, 210, 1, 210, 1, 211, 1, 211, 1, 211, 1,
        211, 1, 211, 3, 211, 2652, 8, 211, 3, 211, 2654, 8, 211, 1, 212, 1, 212, 1, 212, 1, 212, 1, 212,
        3, 212, 2661, 8, 212, 1, 213, 1, 213, 1, 213, 1, 214, 1, 214, 1, 214, 3, 214, 2669, 8, 214, 1,
        214, 3, 214, 2672, 8, 214, 1, 215, 1, 215, 1, 215, 1, 216, 1, 216, 1, 217, 3, 217, 2680, 8, 217,
        1, 217, 1, 217, 3, 217, 2684, 8, 217, 3, 217, 2686, 8, 217, 1, 217, 3, 217, 2689, 8, 217, 1,
        218, 1, 218, 3, 218, 2693, 8, 218, 1, 219, 1, 219, 1, 219, 1, 219, 1, 219, 1, 220, 1, 220, 1,
        220, 3, 220, 2703, 8, 220, 1, 220, 1, 220, 1, 220, 1, 220, 1, 220, 1, 220, 1, 220, 3, 220, 2712,
        8, 220, 1, 220, 1, 220, 1, 220, 1, 221, 1, 221, 3, 221, 2719, 8, 221, 1, 221, 1, 221, 1, 221,
        3, 221, 2724, 8, 221, 1, 221, 1, 221, 1, 221, 3, 221, 2729, 8, 221, 1, 221, 1, 221, 3, 221, 2733,
        8, 221, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222, 3, 222, 2740, 8, 222, 1, 222, 1, 222, 1, 222,
        1, 222, 1, 222, 1, 222, 3, 222, 2748, 8, 222, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222,
        3, 222, 2756, 8, 222, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222, 1, 222, 3, 222,
        2766, 8, 222, 1, 223, 1, 223, 1, 223, 1, 223, 3, 223, 2772, 8, 223, 1, 224, 1, 224, 1, 224, 1,
        224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1, 224, 1,
        224, 1, 224, 1, 224, 1, 224, 1, 224, 3, 224, 2794, 8, 224, 1, 225, 3, 225, 2797, 8, 225, 1, 225,
        1, 225, 1, 225, 3, 225, 2802, 8, 225, 1, 225, 1, 225, 1, 225, 3, 225, 2807, 8, 225, 1, 225, 1,
        225, 1, 225, 3, 225, 2812, 8, 225, 1, 226, 3, 226, 2815, 8, 226, 1, 226, 1, 226, 1, 226, 3, 226,
        2820, 8, 226, 1, 226, 1, 226, 1, 226, 3, 226, 2825, 8, 226, 1, 226, 1, 226, 1, 226, 1, 226, 1,
        226, 1, 226, 3, 226, 2833, 8, 226, 1, 227, 1, 227, 1, 227, 1, 227, 1, 227, 1, 227, 5, 227, 2841,
        8, 227, 10, 227, 12, 227, 2844, 9, 227, 1, 227, 1, 227, 1, 228, 1, 228, 1, 228, 3, 228, 2851,
        8, 228, 1, 228, 1, 228, 1, 228, 1, 228, 1, 228, 1, 228, 1, 228, 5, 228, 2860, 8, 228, 10, 228,
        12, 228, 2863, 9, 228, 1, 228, 1, 228, 1, 228, 3, 228, 2868, 8, 228, 1, 228, 1, 228, 1, 228,
        1, 229, 3, 229, 2874, 8, 229, 1, 229, 1, 229, 1, 229, 3, 229, 2879, 8, 229, 1, 229, 1, 229, 1,
        229, 3, 229, 2884, 8, 229, 1, 229, 1, 229, 1, 229, 1, 229, 1, 229, 3, 229, 2891, 8, 229, 1, 230,
        1, 230, 1, 230, 1, 230, 1, 230, 1, 230, 1, 231, 1, 231, 1, 231, 3, 231, 2902, 8, 231, 1, 231,
        1, 231, 1, 231, 1, 231, 1, 231, 1, 231, 3, 231, 2910, 8, 231, 1, 231, 1, 231, 1, 231, 1, 231,
        3, 231, 2916, 8, 231, 1, 232, 1, 232, 1, 232, 1, 232, 3, 232, 2922, 8, 232, 1, 233, 1, 233, 1,
        233, 1, 233, 1, 233, 1, 233, 1, 233, 3, 233, 2931, 8, 233, 1, 234, 1, 234, 1, 234, 1, 234, 1,
        234, 1, 234, 5, 234, 2939, 8, 234, 10, 234, 12, 234, 2942, 9, 234, 1, 235, 1, 235, 1, 235, 1,
        235, 1, 235, 1, 235, 1, 235, 3, 235, 2951, 8, 235, 1, 236, 1, 236, 3, 236, 2955, 8, 236, 1, 236,
        1, 236, 1, 237, 1, 237, 3, 237, 2961, 8, 237, 1, 237, 1, 237, 1, 238, 1, 238, 1, 238, 5, 238,
        2968, 8, 238, 10, 238, 12, 238, 2971, 9, 238, 1, 239, 1, 239, 1, 239, 5, 239, 2976, 8, 239,
        10, 239, 12, 239, 2979, 9, 239, 1, 240, 1, 240, 1, 240, 3, 240, 2984, 8, 240, 1, 241, 1, 241,
        1, 241, 1, 241, 3, 241, 2990, 8, 241, 1, 242, 1, 242, 3, 242, 2994, 8, 242, 4, 242, 2996, 8,
        242, 11, 242, 12, 242, 2997, 1, 243, 1, 243, 3, 243, 3002, 8, 243, 4, 243, 3004, 8, 243, 11,
        243, 12, 243, 3005, 1, 244, 1, 244, 1, 244, 3, 244, 3011, 8, 244, 1, 245, 1, 245, 3, 245, 3015,
        8, 245, 1, 245, 1, 245, 3, 245, 3019, 8, 245, 1, 245, 3, 245, 3022, 8, 245, 1, 245, 1, 245, 3,
        245, 3026, 8, 245, 1, 246, 1, 246, 1, 246, 5, 246, 3031, 8, 246, 10, 246, 12, 246, 3034, 9,
        246, 1, 247, 1, 247, 1, 247, 1, 248, 1, 248, 3, 248, 3041, 8, 248, 1, 249, 1, 249, 1, 249, 1,
        249, 1, 250, 1, 250, 3, 250, 3049, 8, 250, 1, 250, 1, 250, 3, 250, 3053, 8, 250, 3, 250, 3055,
        8, 250, 1, 250, 1, 250, 1, 251, 1, 251, 1, 251, 1, 251, 3, 251, 3063, 8, 251, 1, 252, 1, 252,
        1, 252, 3, 252, 3068, 8, 252, 1, 252, 1, 252, 3, 252, 3072, 8, 252, 1, 252, 1, 252, 1, 252, 1,
        252, 1, 253, 1, 253, 1, 253, 1, 254, 1, 254, 3, 254, 3083, 8, 254, 1, 255, 1, 255, 1, 255, 1,
        255, 1, 255, 1, 255, 1, 255, 1, 255, 1, 255, 1, 255, 1, 255, 1, 256, 1, 256, 1, 256, 1, 256, 1,
        256, 3, 256, 3101, 8, 256, 1, 256, 1, 256, 3, 256, 3105, 8, 256, 1, 256, 1, 256, 1, 256, 1, 256,
        1, 256, 1, 256, 1, 257, 1, 257, 1, 257, 1, 257, 5, 257, 3117, 8, 257, 10, 257, 12, 257, 3120,
        9, 257, 3, 257, 3122, 8, 257, 1, 257, 1, 257, 1, 258, 1, 258, 3, 258, 3128, 8, 258, 1, 258, 1,
        258, 3, 258, 3132, 8, 258, 1, 259, 1, 259, 3, 259, 3136, 8, 259, 1, 259, 1, 259, 1, 260, 1, 260,
        1, 261, 1, 261, 3, 261, 3144, 8, 261, 1, 261, 1, 261, 1, 261, 3, 261, 3149, 8, 261, 1, 261, 1,
        261, 3, 261, 3153, 8, 261, 1, 262, 1, 262, 1, 262, 1, 262, 3, 262, 3159, 8, 262, 1, 263, 1, 263,
        3, 263, 3163, 8, 263, 1, 263, 1, 263, 1, 263, 1, 263, 1, 263, 1, 263, 1, 263, 3, 263, 3172, 8,
        263, 1, 264, 1, 264, 3, 264, 3176, 8, 264, 1, 264, 1, 264, 1, 264, 1, 264, 1, 265, 1, 265, 3,
        265, 3184, 8, 265, 1, 265, 3, 265, 3187, 8, 265, 1, 265, 1, 265, 1, 265, 1, 265, 1, 265, 1, 265,
        1, 265, 3, 265, 3196, 8, 265, 1, 266, 1, 266, 1, 267, 1, 267, 1, 268, 1, 268, 1, 269, 1, 269,
        1, 269, 1, 269, 3, 269, 3208, 8, 269, 1, 270, 1, 270, 1, 270, 1, 270, 1, 270, 1, 271, 1, 271,
        1, 271, 1, 271, 1, 271, 1, 272, 1, 272, 1, 272, 1, 273, 1, 273, 3, 273, 3225, 8, 273, 1, 274,
        3, 274, 3228, 8, 274, 1, 274, 1, 274, 3, 274, 3232, 8, 274, 1, 275, 1, 275, 1, 275, 1, 275, 1,
        275, 1, 275, 1, 275, 5, 275, 3241, 8, 275, 10, 275, 12, 275, 3244, 9, 275, 1, 276, 1, 276, 1,
        276, 1, 277, 3, 277, 3250, 8, 277, 1, 277, 1, 277, 1, 277, 1, 277, 1, 277, 3, 277, 3257, 8, 277,
        1, 277, 1, 277, 1, 277, 1, 277, 3, 277, 3263, 8, 277, 1, 278, 1, 278, 1, 278, 1, 278, 3, 278,
        3269, 8, 278, 1, 279, 1, 279, 1, 279, 1, 279, 3, 279, 3275, 8, 279, 1, 279, 1, 279, 1, 279, 1,
        280, 3, 280, 3281, 8, 280, 1, 280, 1, 280, 1, 280, 3, 280, 3286, 8, 280, 1, 280, 3, 280, 3289,
        8, 280, 1, 281, 1, 281, 1, 281, 1, 281, 1, 282, 1, 282, 1, 282, 1, 282, 1, 283, 1, 283, 1, 283,
        1, 283, 1, 283, 3, 283, 3304, 8, 283, 1, 283, 1, 283, 1, 283, 1, 283, 1, 283, 1, 283, 1, 283,
        3, 283, 3313, 8, 283, 4, 283, 3315, 8, 283, 11, 283, 12, 283, 3316, 1, 284, 1, 284, 1, 284,
        1, 284, 3, 284, 3323, 8, 284, 1, 285, 1, 285, 1, 285, 1, 285, 3, 285, 3329, 8, 285, 1, 285, 1,
        285, 1, 285, 1, 286, 1, 286, 1, 286, 1, 286, 1, 286, 1, 286, 1, 286, 1, 286, 1, 286, 1, 287, 1,
        287, 1, 287, 1, 287, 3, 287, 3347, 8, 287, 1, 287, 1, 287, 1, 287, 1, 287, 1, 287, 1, 287, 3,
        287, 3355, 8, 287, 1, 287, 3, 287, 3358, 8, 287, 5, 287, 3360, 8, 287, 10, 287, 12, 287, 3363,
        9, 287, 1, 287, 1, 287, 1, 287, 1, 287, 1, 287, 1, 287, 1, 287, 3, 287, 3372, 8, 287, 5, 287,
        3374, 8, 287, 10, 287, 12, 287, 3377, 9, 287, 1, 288, 1, 288, 3, 288, 3381, 8, 288, 1, 288,
        1, 288, 1, 288, 3, 288, 3386, 8, 288, 1, 289, 3, 289, 3389, 8, 289, 1, 289, 1, 289, 1, 289, 3,
        289, 3394, 8, 289, 1, 290, 3, 290, 3397, 8, 290, 1, 290, 1, 290, 1, 290, 1, 291, 1, 291, 3, 291,
        3404, 8, 291, 1, 292, 1, 292, 3, 292, 3408, 8, 292, 1, 292, 1, 292, 1, 293, 1, 293, 1, 293, 1,
        294, 1, 294, 1, 294, 1, 294, 1, 295, 1, 295, 3, 295, 3421, 8, 295, 1, 295, 1, 295, 1, 295, 1,
        295, 4, 295, 3427, 8, 295, 11, 295, 12, 295, 3428, 1, 295, 1, 295, 1, 296, 1, 296, 1, 296, 1,
        296, 1, 296, 3, 296, 3438, 8, 296, 1, 297, 1, 297, 1, 297, 3, 297, 3443, 8, 297, 1, 297, 3, 297,
        3446, 8, 297, 1, 298, 1, 298, 1, 298, 3, 298, 3451, 8, 298, 1, 299, 1, 299, 1, 299, 3, 299, 3456,
        8, 299, 1, 300, 3, 300, 3459, 8, 300, 1, 300, 1, 300, 3, 300, 3463, 8, 300, 1, 300, 3, 300, 3466,
        8, 300, 1, 301, 1, 301, 1, 301, 1, 301, 3, 301, 3472, 8, 301, 1, 301, 3, 301, 3475, 8, 301, 1,
        302, 1, 302, 3, 302, 3479, 8, 302, 1, 302, 1, 302, 3, 302, 3483, 8, 302, 1, 302, 3, 302, 3486,
        8, 302, 1, 303, 1, 303, 3, 303, 3490, 8, 303, 1, 303, 1, 303, 1, 304, 1, 304, 1, 305, 1, 305,
        1, 305, 1, 305, 1, 305, 1, 305, 1, 305, 1, 305, 1, 305, 1, 305, 1, 305, 3, 305, 3507, 8, 305,
        1, 306, 1, 306, 3, 306, 3511, 8, 306, 1, 306, 1, 306, 1, 306, 1, 307, 3, 307, 3517, 8, 307, 1,
        307, 1, 307, 1, 308, 1, 308, 1, 308, 1, 308, 1, 308, 3, 308, 3526, 8, 308, 1, 308, 1, 308, 1,
        308, 3, 308, 3531, 8, 308, 1, 308, 3, 308, 3534, 8, 308, 1, 309, 1, 309, 1, 309, 1, 309, 1, 309,
        1, 309, 1, 309, 1, 309, 1, 309, 1, 309, 1, 309, 1, 309, 1, 309, 3, 309, 3549, 8, 309, 1, 310,
        1, 310, 1, 310, 1, 310, 1, 310, 3, 310, 3556, 8, 310, 1, 311, 1, 311, 3, 311, 3560, 8, 311, 1,
        311, 1, 311, 1, 312, 1, 312, 3, 312, 3566, 8, 312, 1, 312, 1, 312, 1, 313, 1, 313, 3, 313, 3572,
        8, 313, 1, 313, 1, 313, 1, 314, 1, 314, 3, 314, 3578, 8, 314, 1, 314, 1, 314, 1, 314, 3, 314,
        3583, 8, 314, 1, 315, 1, 315, 1, 315, 3, 315, 3588, 8, 315, 1, 315, 1, 315, 1, 315, 1, 315, 1,
        315, 1, 315, 1, 315, 3, 315, 3597, 8, 315, 1, 316, 1, 316, 1, 316, 1, 316, 1, 316, 1, 316, 3,
        316, 3605, 8, 316, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 3, 317, 3612, 8, 317, 3, 317, 3614,
        8, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317, 1, 317,
        1, 317, 3, 317, 3628, 8, 317, 1, 317, 1, 317, 3, 317, 3632, 8, 317, 1, 318, 1, 318, 1, 318, 1,
        318, 1, 318, 1, 318, 3, 318, 3640, 8, 318, 1, 318, 1, 318, 1, 318, 1, 318, 3, 318, 3646, 8, 318,
        1, 318, 3, 318, 3649, 8, 318, 1, 318, 1, 318, 1, 318, 1, 318, 1, 318, 1, 318, 1, 318, 1, 318,
        1, 318, 1, 318, 1, 318, 1, 318, 1, 318, 3, 318, 3664, 8, 318, 1, 319, 1, 319, 1, 320, 1, 320,
        1, 320, 1, 320, 1, 320, 1, 320, 1, 320, 1, 320, 1, 320, 3, 320, 3677, 8, 320, 1, 321, 1, 321,
        1, 321, 1, 321, 1, 322, 1, 322, 1, 322, 1, 322, 1, 322, 1, 322, 3, 322, 3689, 8, 322, 1, 322,
        3, 322, 3692, 8, 322, 1, 322, 1, 322, 3, 322, 3696, 8, 322, 1, 322, 1, 322, 3, 322, 3700, 8,
        322, 1, 322, 3, 322, 3703, 8, 322, 3, 322, 3705, 8, 322, 1, 322, 1, 322, 1, 322, 1, 323, 1, 323,
        1, 323, 3, 323, 3713, 8, 323, 1, 323, 1, 323, 3, 323, 3717, 8, 323, 1, 323, 1, 323, 1, 323, 1,
        323, 3, 323, 3723, 8, 323, 1, 323, 1, 323, 1, 323, 1, 323, 1, 323, 3, 323, 3730, 8, 323, 1, 323,
        1, 323, 1, 323, 1, 323, 1, 323, 1, 323, 3, 323, 3738, 8, 323, 3, 323, 3740, 8, 323, 1, 323, 1,
        323, 1, 323, 1, 324, 1, 324, 1, 324, 1, 324, 1, 324, 3, 324, 3750, 8, 324, 1, 324, 1, 324, 1,
        324, 1, 324, 1, 324, 3, 324, 3757, 8, 324, 3, 324, 3759, 8, 324, 1, 324, 1, 324, 1, 324, 3, 324,
        3764, 8, 324, 3, 324, 3766, 8, 324, 1, 325, 1, 325, 1, 326, 1, 326, 1, 327, 1, 327, 1, 328, 1,
        328, 1, 329, 1, 329, 1, 330, 1, 330, 1, 330, 3, 330, 3781, 8, 330, 1, 330, 1, 330, 1, 331, 1,
        331, 1, 332, 1, 332, 1, 333, 1, 333, 1, 334, 1, 334, 1, 334, 5, 334, 3794, 8, 334, 10, 334, 12,
        334, 3797, 9, 334, 1, 335, 1, 335, 3, 335, 3801, 8, 335, 1, 335, 3, 335, 3804, 8, 335, 1, 336,
        1, 336, 3, 336, 3808, 8, 336, 1, 337, 1, 337, 3, 337, 3812, 8, 337, 1, 337, 1, 337, 1, 337, 3,
        337, 3817, 8, 337, 1, 338, 1, 338, 1, 338, 1, 338, 3, 338, 3823, 8, 338, 1, 338, 1, 338, 1, 338,
        1, 338, 1, 339, 1, 339, 3, 339, 3831, 8, 339, 1, 340, 1, 340, 1, 340, 3, 340, 3836, 8, 340, 1,
        340, 1, 340, 1, 341, 1, 341, 1, 341, 5, 341, 3843, 8, 341, 10, 341, 12, 341, 3846, 9, 341, 1,
        342, 1, 342, 1, 342, 3, 342, 3851, 8, 342, 1, 342, 1, 342, 1, 342, 3, 342, 3856, 8, 342, 1, 342,
        1, 342, 1, 342, 1, 342, 5, 342, 3862, 8, 342, 10, 342, 12, 342, 3865, 9, 342, 3, 342, 3867,
        8, 342, 1, 342, 1, 342, 1, 342, 1, 342, 1, 342, 1, 342, 3, 342, 3875, 8, 342, 1, 342, 1, 342,
        3, 342, 3879, 8, 342, 1, 342, 1, 342, 1, 342, 3, 342, 3884, 8, 342, 1, 342, 1, 342, 1, 342, 3,
        342, 3889, 8, 342, 1, 342, 1, 342, 1, 342, 1, 342, 5, 342, 3895, 8, 342, 10, 342, 12, 342, 3898,
        9, 342, 3, 342, 3900, 8, 342, 1, 342, 1, 342, 1, 342, 3, 342, 3905, 8, 342, 1, 342, 1, 342, 1,
        342, 1, 342, 1, 342, 1, 342, 1, 342, 1, 342, 3, 342, 3915, 8, 342, 1, 342, 1, 342, 1, 342, 3,
        342, 3920, 8, 342, 1, 342, 1, 342, 1, 342, 3, 342, 3925, 8, 342, 3, 342, 3927, 8, 342, 3, 342,
        3929, 8, 342, 1, 343, 1, 343, 1, 343, 3, 343, 3934, 8, 343, 1, 344, 1, 344, 1, 345, 1, 345, 1,
        346, 1, 346, 1, 347, 1, 347, 1, 347, 1, 347, 1, 347, 3, 347, 3947, 8, 347, 3, 347, 3949, 8, 347,
        1, 348, 1, 348, 1, 348, 1, 348, 1, 348, 3, 348, 3956, 8, 348, 3, 348, 3958, 8, 348, 1, 349, 1,
        349, 1, 349, 1, 349, 1, 349, 1, 349, 3, 349, 3966, 8, 349, 1, 349, 3, 349, 3969, 8, 349, 1, 349,
        3, 349, 3972, 8, 349, 1, 349, 3, 349, 3975, 8, 349, 1, 349, 3, 349, 3978, 8, 349, 1, 350, 1,
        350, 1, 350, 1, 350, 1, 350, 3, 350, 3985, 8, 350, 1, 350, 3, 350, 3988, 8, 350, 1, 350, 3, 350,
        3991, 8, 350, 1, 350, 1, 350, 3, 350, 3995, 8, 350, 1, 350, 3, 350, 3998, 8, 350, 1, 350, 3,
        350, 4001, 8, 350, 1, 351, 3, 351, 4004, 8, 351, 1, 351, 3, 351, 4007, 8, 351, 1, 351, 3, 351,
        4010, 8, 351, 1, 351, 1, 351, 1, 352, 1, 352, 1, 352, 1, 352, 3, 352, 4018, 8, 352, 1, 352, 1,
        352, 1, 353, 1, 353, 1, 353, 1, 353, 1, 353, 1, 353, 3, 353, 4028, 8, 353, 1, 353, 1, 353, 1,
        353, 1, 353, 3, 353, 4034, 8, 353, 1, 353, 1, 353, 1, 354, 3, 354, 4039, 8, 354, 1, 354, 1, 354,
        1, 354, 4, 354, 4044, 8, 354, 11, 354, 12, 354, 4045, 1, 355, 1, 355, 1, 355, 1, 356, 1, 356,
        1, 357, 1, 357, 1, 357, 1, 358, 1, 358, 1, 359, 1, 359, 1, 359, 1, 359, 1, 359, 1, 360, 3, 360,
        4064, 8, 360, 1, 360, 1, 360, 1, 360, 1, 360, 3, 360, 4070, 8, 360, 1, 360, 3, 360, 4073, 8,
        360, 1, 360, 1, 360, 3, 360, 4077, 8, 360, 1, 360, 3, 360, 4080, 8, 360, 1, 361, 1, 361, 1, 361,
        3, 361, 4085, 8, 361, 1, 362, 1, 362, 1, 362, 1, 362, 3, 362, 4091, 8, 362, 1, 362, 1, 362, 1,
        362, 1, 362, 1, 362, 3, 362, 4098, 8, 362, 4, 362, 4100, 8, 362, 11, 362, 12, 362, 4101, 1,
        362, 1, 362, 1, 362, 4, 362, 4107, 8, 362, 11, 362, 12, 362, 4108, 3, 362, 4111, 8, 362, 1,
        362, 3, 362, 4114, 8, 362, 1, 363, 1, 363, 1, 363, 1, 363, 1, 364, 1, 364, 1, 364, 4, 364, 4123,
        8, 364, 11, 364, 12, 364, 4124, 1, 365, 1, 365, 1, 365, 1, 365, 1, 366, 1, 366, 1, 366, 1, 366,
        3, 366, 4135, 8, 366, 1, 367, 1, 367, 1, 367, 1, 367, 3, 367, 4141, 8, 367, 1, 368, 1, 368, 1,
        368, 3, 368, 4146, 8, 368, 3, 368, 4148, 8, 368, 1, 368, 3, 368, 4151, 8, 368, 1, 369, 1, 369,
        1, 370, 1, 370, 1, 370, 3, 370, 4158, 8, 370, 1, 370, 1, 370, 3, 370, 4162, 8, 370, 1, 370, 3,
        370, 4165, 8, 370, 3, 370, 4167, 8, 370, 1, 371, 1, 371, 1, 372, 1, 372, 1, 373, 1, 373, 1, 374,
        1, 374, 1, 374, 1, 374, 1, 374, 3, 374, 4180, 8, 374, 1, 374, 1, 374, 1, 374, 1, 374, 1, 374,
        1, 374, 1, 374, 1, 374, 1, 374, 1, 374, 1, 374, 3, 374, 4193, 8, 374, 1, 374, 3, 374, 4196, 8,
        374, 3, 374, 4198, 8, 374, 1, 374, 1, 374, 3, 374, 4202, 8, 374, 1, 375, 1, 375, 1, 375, 1, 375,
        3, 375, 4208, 8, 375, 1, 375, 1, 375, 1, 375, 1, 376, 1, 376, 1, 376, 1, 376, 3, 376, 4217, 8,
        376, 1, 376, 1, 376, 1, 376, 1, 376, 1, 376, 1, 376, 1, 376, 1, 376, 4, 376, 4227, 8, 376, 11,
        376, 12, 376, 4228, 1, 377, 1, 377, 1, 377, 1, 377, 3, 377, 4235, 8, 377, 1, 378, 1, 378, 1,
        378, 1, 379, 1, 379, 1, 379, 1, 380, 1, 380, 1, 380, 1, 381, 1, 381, 1, 381, 1, 382, 1, 382, 3,
        382, 4251, 8, 382, 1, 382, 1, 382, 1, 382, 3, 382, 4256, 8, 382, 1, 383, 1, 383, 3, 383, 4260,
        8, 383, 1, 384, 1, 384, 3, 384, 4264, 8, 384, 1, 385, 1, 385, 1, 385, 5, 385, 4269, 8, 385, 10,
        385, 12, 385, 4272, 9, 385, 1, 386, 1, 386, 1, 386, 5, 386, 4277, 8, 386, 10, 386, 12, 386,
        4280, 9, 386, 1, 387, 1, 387, 3, 387, 4284, 8, 387, 1, 388, 1, 388, 1, 388, 5, 388, 4289, 8,
        388, 10, 388, 12, 388, 4292, 9, 388, 1, 389, 1, 389, 1, 389, 1, 389, 5, 389, 4298, 8, 389, 10,
        389, 12, 389, 4301, 9, 389, 3, 389, 4303, 8, 389, 1, 389, 1, 389, 1, 390, 1, 390, 1, 390, 4,
        390, 4310, 8, 390, 11, 390, 12, 390, 4311, 1, 391, 1, 391, 1, 392, 1, 392, 3, 392, 4318, 8,
        392, 1, 393, 1, 393, 3, 393, 4322, 8, 393, 1, 394, 1, 394, 3, 394, 4326, 8, 394, 1, 395, 1, 395,
        3, 395, 4330, 8, 395, 1, 396, 1, 396, 1, 396, 1, 396, 1, 396, 1, 396, 1, 396, 1, 396, 1, 396,
        5, 396, 4341, 8, 396, 10, 396, 12, 396, 4344, 9, 396, 3, 396, 4346, 8, 396, 1, 396, 1, 396,
        1, 397, 1, 397, 3, 397, 4352, 8, 397, 1, 398, 1, 398, 1, 399, 1, 399, 1, 400, 1, 400, 3, 400,
        4360, 8, 400, 1, 401, 1, 401, 1, 402, 1, 402, 1, 403, 1, 403, 1, 403, 0, 0, 404, 0, 2, 4, 6, 8,
        10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56,
        58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102,
        104, 106, 108, 110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 136, 138,
        140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162, 164, 166, 168, 170, 172, 174,
        176, 178, 180, 182, 184, 186, 188, 190, 192, 194, 196, 198, 200, 202, 204, 206, 208, 210,
        212, 214, 216, 218, 220, 222, 224, 226, 228, 230, 232, 234, 236, 238, 240, 242, 244, 246,
        248, 250, 252, 254, 256, 258, 260, 262, 264, 266, 268, 270, 272, 274, 276, 278, 280, 282,
        284, 286, 288, 290, 292, 294, 296, 298, 300, 302, 304, 306, 308, 310, 312, 314, 316, 318,
        320, 322, 324, 326, 328, 330, 332, 334, 336, 338, 340, 342, 344, 346, 348, 350, 352, 354,
        356, 358, 360, 362, 364, 366, 368, 370, 372, 374, 376, 378, 380, 382, 384, 386, 388, 390,
        392, 394, 396, 398, 400, 402, 404, 406, 408, 410, 412, 414, 416, 418, 420, 422, 424, 426,
        428, 430, 432, 434, 436, 438, 440, 442, 444, 446, 448, 450, 452, 454, 456, 458, 460, 462,
        464, 466, 468, 470, 472, 474, 476, 478, 480, 482, 484, 486, 488, 490, 492, 494, 496, 498,
        500, 502, 504, 506, 508, 510, 512, 514, 516, 518, 520, 522, 524, 526, 528, 530, 532, 534,
        536, 538, 540, 542, 544, 546, 548, 550, 552, 554, 556, 558, 560, 562, 564, 566, 568, 570,
        572, 574, 576, 578, 580, 582, 584, 586, 588, 590, 592, 594, 596, 598, 600, 602, 604, 606,
        608, 610, 612, 614, 616, 618, 620, 622, 624, 626, 628, 630, 632, 634, 636, 638, 640, 642,
        644, 646, 648, 650, 652, 654, 656, 658, 660, 662, 664, 666, 668, 670, 672, 674, 676, 678,
        680, 682, 684, 686, 688, 690, 692, 694, 696, 698, 700, 702, 704, 706, 708, 710, 712, 714,
        716, 718, 720, 722, 724, 726, 728, 730, 732, 734, 736, 738, 740, 742, 744, 746, 748, 750,
        752, 754, 756, 758, 760, 762, 764, 766, 768, 770, 772, 774, 776, 778, 780, 782, 784, 786,
        788, 790, 792, 794, 796, 798, 800, 802, 804, 806, 0, 81, 1, 0, 4, 5, 1, 0, 12, 14, 3, 0, 18, 19,
        95, 95, 339, 339, 2, 0, 33, 33, 93, 93, 1, 0, 40, 41, 1, 0, 87, 88, 2, 0, 211, 211, 288, 288, 2,
        0, 90, 90, 201, 201, 2, 0, 73, 73, 184, 184, 1, 0, 265, 266, 3, 0, 51, 51, 71, 71, 119, 119, 2,
        0, 32, 32, 283, 283, 1, 0, 137, 138, 1, 0, 221, 222, 2, 0, 33, 33, 37, 37, 2, 0, 181, 181, 341,
        341, 2, 0, 186, 186, 340, 340, 2, 0, 139, 139, 342, 342, 2, 0, 60, 60, 162, 162, 2, 0, 60, 60,
        167, 167, 6, 0, 112, 112, 133, 133, 139, 139, 172, 172, 181, 181, 189, 190, 2, 0, 61, 61, 313,
        313, 1, 0, 194, 197, 3, 0, 97, 97, 186, 186, 224, 224, 3, 0, 94, 94, 187, 187, 301, 301, 2, 0,
        186, 186, 224, 224, 4, 0, 33, 33, 37, 37, 203, 203, 287, 287, 3, 0, 50, 50, 173, 173, 306, 306,
        1, 0, 18, 21, 2, 0, 80, 80, 300, 300, 1, 0, 331, 332, 2, 0, 38, 38, 176, 176, 7, 0, 33, 33, 130,
        130, 179, 179, 226, 226, 240, 240, 298, 298, 326, 326, 1, 0, 316, 317, 1, 0, 248, 249, 1, 0,
        233, 234, 1, 0, 131, 132, 1, 0, 279, 280, 2, 0, 200, 200, 248, 249, 3, 0, 27, 27, 35, 35, 278,
        278, 2, 0, 164, 164, 316, 316, 2, 0, 86, 86, 134, 134, 1, 0, 263, 264, 1, 0, 276, 277, 1, 0, 77,
        78, 2, 0, 33, 33, 227, 227, 1, 0, 321, 322, 1, 0, 237, 238, 2, 0, 109, 109, 223, 223, 2, 0, 26,
        26, 295, 295, 1, 0, 63, 64, 1, 0, 231, 232, 3, 0, 77, 77, 81, 81, 135, 135, 2, 0, 77, 77, 135,
        135, 1, 0, 135, 136, 1, 0, 165, 166, 2, 0, 312, 312, 314, 314, 1, 0, 191, 192, 2, 0, 58, 58, 319,
        319, 1, 0, 219, 220, 2, 0, 231, 231, 263, 263, 2, 0, 263, 263, 321, 321, 1, 0, 28, 29, 1, 0, 147,
        148, 1, 0, 67, 68, 1, 0, 307, 308, 2, 0, 184, 185, 243, 243, 1, 0, 249, 250, 1, 0, 106, 107, 2,
        0, 200, 200, 202, 202, 1, 0, 281, 282, 1, 0, 254, 255, 1, 0, 229, 230, 1, 0, 271, 272, 2, 0, 89,
        89, 101, 101, 1, 0, 30, 31, 2, 0, 213, 213, 333, 333, 2, 0, 269, 270, 273, 273, 2, 0, 83, 83,
        141, 141, 1, 0, 22, 23, 22, 0, 14, 14, 25, 44, 46, 59, 63, 91, 93, 93, 98, 111, 113, 132, 134,
        138, 140, 166, 169, 169, 173, 179, 182, 185, 188, 188, 191, 223, 226, 227, 229, 238, 240,
        240, 243, 246, 248, 266, 268, 274, 276, 300, 302, 338, 4780, 0, 808, 1, 0, 0, 0, 2, 823, 1,
        0, 0, 0, 4, 825, 1, 0, 0, 0, 6, 840, 1, 0, 0, 0, 8, 848, 1, 0, 0, 0, 10, 850, 1, 0, 0, 0, 12, 855, 1,
        0, 0, 0, 14, 857, 1, 0, 0, 0, 16, 859, 1, 0, 0, 0, 18, 863, 1, 0, 0, 0, 20, 866, 1, 0, 0, 0, 22, 868,
        1, 0, 0, 0, 24, 870, 1, 0, 0, 0, 26, 872, 1, 0, 0, 0, 28, 874, 1, 0, 0, 0, 30, 878, 1, 0, 0, 0, 32,
        880, 1, 0, 0, 0, 34, 884, 1, 0, 0, 0, 36, 886, 1, 0, 0, 0, 38, 890, 1, 0, 0, 0, 40, 892, 1, 0, 0, 0,
        42, 894, 1, 0, 0, 0, 44, 896, 1, 0, 0, 0, 46, 898, 1, 0, 0, 0, 48, 909, 1, 0, 0, 0, 50, 914, 1, 0,
        0, 0, 52, 919, 1, 0, 0, 0, 54, 924, 1, 0, 0, 0, 56, 926, 1, 0, 0, 0, 58, 928, 1, 0, 0, 0, 60, 938,
        1, 0, 0, 0, 62, 944, 1, 0, 0, 0, 64, 946, 1, 0, 0, 0, 66, 949, 1, 0, 0, 0, 68, 953, 1, 0, 0, 0, 70,
        968, 1, 0, 0, 0, 72, 970, 1, 0, 0, 0, 74, 980, 1, 0, 0, 0, 76, 982, 1, 0, 0, 0, 78, 994, 1, 0, 0, 0,
        80, 1001, 1, 0, 0, 0, 82, 1006, 1, 0, 0, 0, 84, 1021, 1, 0, 0, 0, 86, 1042, 1, 0, 0, 0, 88, 1044,
        1, 0, 0, 0, 90, 1056, 1, 0, 0, 0, 92, 1058, 1, 0, 0, 0, 94, 1060, 1, 0, 0, 0, 96, 1064, 1, 0, 0, 0,
        98, 1076, 1, 0, 0, 0, 100, 1083, 1, 0, 0, 0, 102, 1092, 1, 0, 0, 0, 104, 1097, 1, 0, 0, 0, 106,
        1099, 1, 0, 0, 0, 108, 1101, 1, 0, 0, 0, 110, 1111, 1, 0, 0, 0, 112, 1114, 1, 0, 0, 0, 114, 1117,
        1, 0, 0, 0, 116, 1120, 1, 0, 0, 0, 118, 1125, 1, 0, 0, 0, 120, 1128, 1, 0, 0, 0, 122, 1131, 1, 0,
        0, 0, 124, 1162, 1, 0, 0, 0, 126, 1164, 1, 0, 0, 0, 128, 1181, 1, 0, 0, 0, 130, 1184, 1, 0, 0, 0,
        132, 1196, 1, 0, 0, 0, 134, 1228, 1, 0, 0, 0, 136, 1230, 1, 0, 0, 0, 138, 1258, 1, 0, 0, 0, 140,
        1266, 1, 0, 0, 0, 142, 1270, 1, 0, 0, 0, 144, 1276, 1, 0, 0, 0, 146, 1281, 1, 0, 0, 0, 148, 1290,
        1, 0, 0, 0, 150, 1295, 1, 0, 0, 0, 152, 1330, 1, 0, 0, 0, 154, 1333, 1, 0, 0, 0, 156, 1335, 1, 0,
        0, 0, 158, 1340, 1, 0, 0, 0, 160, 1354, 1, 0, 0, 0, 162, 1368, 1, 0, 0, 0, 164, 1380, 1, 0, 0, 0,
        166, 1394, 1, 0, 0, 0, 168, 1410, 1, 0, 0, 0, 170, 1427, 1, 0, 0, 0, 172, 1430, 1, 0, 0, 0, 174,
        1435, 1, 0, 0, 0, 176, 1452, 1, 0, 0, 0, 178, 1454, 1, 0, 0, 0, 180, 1462, 1, 0, 0, 0, 182, 1473,
        1, 0, 0, 0, 184, 1483, 1, 0, 0, 0, 186, 1508, 1, 0, 0, 0, 188, 1512, 1, 0, 0, 0, 190, 1514, 1, 0,
        0, 0, 192, 1532, 1, 0, 0, 0, 194, 1570, 1, 0, 0, 0, 196, 1574, 1, 0, 0, 0, 198, 1576, 1, 0, 0, 0,
        200, 1578, 1, 0, 0, 0, 202, 1580, 1, 0, 0, 0, 204, 1608, 1, 0, 0, 0, 206, 1626, 1, 0, 0, 0, 208,
        1628, 1, 0, 0, 0, 210, 1640, 1, 0, 0, 0, 212, 1644, 1, 0, 0, 0, 214, 1656, 1, 0, 0, 0, 216, 1661,
        1, 0, 0, 0, 218, 1669, 1, 0, 0, 0, 220, 1672, 1, 0, 0, 0, 222, 1675, 1, 0, 0, 0, 224, 1678, 1, 0,
        0, 0, 226, 1683, 1, 0, 0, 0, 228, 1686, 1, 0, 0, 0, 230, 1719, 1, 0, 0, 0, 232, 1743, 1, 0, 0, 0,
        234, 1745, 1, 0, 0, 0, 236, 1747, 1, 0, 0, 0, 238, 1749, 1, 0, 0, 0, 240, 1760, 1, 0, 0, 0, 242,
        1763, 1, 0, 0, 0, 244, 1774, 1, 0, 0, 0, 246, 1785, 1, 0, 0, 0, 248, 1797, 1, 0, 0, 0, 250, 1799,
        1, 0, 0, 0, 252, 1808, 1, 0, 0, 0, 254, 1811, 1, 0, 0, 0, 256, 1819, 1, 0, 0, 0, 258, 1827, 1, 0,
        0, 0, 260, 1838, 1, 0, 0, 0, 262, 1843, 1, 0, 0, 0, 264, 1851, 1, 0, 0, 0, 266, 1888, 1, 0, 0, 0,
        268, 1890, 1, 0, 0, 0, 270, 1892, 1, 0, 0, 0, 272, 1900, 1, 0, 0, 0, 274, 1908, 1, 0, 0, 0, 276,
        1919, 1, 0, 0, 0, 278, 1921, 1, 0, 0, 0, 280, 1942, 1, 0, 0, 0, 282, 1944, 1, 0, 0, 0, 284, 1947,
        1, 0, 0, 0, 286, 1951, 1, 0, 0, 0, 288, 1957, 1, 0, 0, 0, 290, 1983, 1, 0, 0, 0, 292, 1994, 1, 0,
        0, 0, 294, 1996, 1, 0, 0, 0, 296, 2008, 1, 0, 0, 0, 298, 2013, 1, 0, 0, 0, 300, 2026, 1, 0, 0, 0,
        302, 2042, 1, 0, 0, 0, 304, 2044, 1, 0, 0, 0, 306, 2062, 1, 0, 0, 0, 308, 2077, 1, 0, 0, 0, 310,
        2090, 1, 0, 0, 0, 312, 2101, 1, 0, 0, 0, 314, 2112, 1, 0, 0, 0, 316, 2121, 1, 0, 0, 0, 318, 2130,
        1, 0, 0, 0, 320, 2144, 1, 0, 0, 0, 322, 2146, 1, 0, 0, 0, 324, 2148, 1, 0, 0, 0, 326, 2152, 1, 0,
        0, 0, 328, 2174, 1, 0, 0, 0, 330, 2176, 1, 0, 0, 0, 332, 2181, 1, 0, 0, 0, 334, 2195, 1, 0, 0, 0,
        336, 2209, 1, 0, 0, 0, 338, 2215, 1, 0, 0, 0, 340, 2220, 1, 0, 0, 0, 342, 2224, 1, 0, 0, 0, 344,
        2237, 1, 0, 0, 0, 346, 2239, 1, 0, 0, 0, 348, 2246, 1, 0, 0, 0, 350, 2248, 1, 0, 0, 0, 352, 2265,
        1, 0, 0, 0, 354, 2267, 1, 0, 0, 0, 356, 2275, 1, 0, 0, 0, 358, 2278, 1, 0, 0, 0, 360, 2280, 1, 0,
        0, 0, 362, 2288, 1, 0, 0, 0, 364, 2296, 1, 0, 0, 0, 366, 2394, 1, 0, 0, 0, 368, 2399, 1, 0, 0, 0,
        370, 2401, 1, 0, 0, 0, 372, 2421, 1, 0, 0, 0, 374, 2427, 1, 0, 0, 0, 376, 2444, 1, 0, 0, 0, 378,
        2458, 1, 0, 0, 0, 380, 2467, 1, 0, 0, 0, 382, 2477, 1, 0, 0, 0, 384, 2501, 1, 0, 0, 0, 386, 2503,
        1, 0, 0, 0, 388, 2508, 1, 0, 0, 0, 390, 2511, 1, 0, 0, 0, 392, 2514, 1, 0, 0, 0, 394, 2538, 1, 0,
        0, 0, 396, 2541, 1, 0, 0, 0, 398, 2546, 1, 0, 0, 0, 400, 2548, 1, 0, 0, 0, 402, 2558, 1, 0, 0, 0,
        404, 2562, 1, 0, 0, 0, 406, 2564, 1, 0, 0, 0, 408, 2600, 1, 0, 0, 0, 410, 2604, 1, 0, 0, 0, 412,
        2612, 1, 0, 0, 0, 414, 2614, 1, 0, 0, 0, 416, 2621, 1, 0, 0, 0, 418, 2632, 1, 0, 0, 0, 420, 2644,
        1, 0, 0, 0, 422, 2646, 1, 0, 0, 0, 424, 2660, 1, 0, 0, 0, 426, 2662, 1, 0, 0, 0, 428, 2665, 1, 0,
        0, 0, 430, 2673, 1, 0, 0, 0, 432, 2676, 1, 0, 0, 0, 434, 2685, 1, 0, 0, 0, 436, 2692, 1, 0, 0, 0,
        438, 2694, 1, 0, 0, 0, 440, 2699, 1, 0, 0, 0, 442, 2716, 1, 0, 0, 0, 444, 2765, 1, 0, 0, 0, 446,
        2767, 1, 0, 0, 0, 448, 2793, 1, 0, 0, 0, 450, 2796, 1, 0, 0, 0, 452, 2814, 1, 0, 0, 0, 454, 2834,
        1, 0, 0, 0, 456, 2847, 1, 0, 0, 0, 458, 2873, 1, 0, 0, 0, 460, 2892, 1, 0, 0, 0, 462, 2898, 1, 0,
        0, 0, 464, 2917, 1, 0, 0, 0, 466, 2930, 1, 0, 0, 0, 468, 2932, 1, 0, 0, 0, 470, 2943, 1, 0, 0, 0,
        472, 2952, 1, 0, 0, 0, 474, 2958, 1, 0, 0, 0, 476, 2964, 1, 0, 0, 0, 478, 2972, 1, 0, 0, 0, 480,
        2983, 1, 0, 0, 0, 482, 2989, 1, 0, 0, 0, 484, 2995, 1, 0, 0, 0, 486, 3003, 1, 0, 0, 0, 488, 3010,
        1, 0, 0, 0, 490, 3012, 1, 0, 0, 0, 492, 3027, 1, 0, 0, 0, 494, 3035, 1, 0, 0, 0, 496, 3040, 1, 0,
        0, 0, 498, 3042, 1, 0, 0, 0, 500, 3046, 1, 0, 0, 0, 502, 3058, 1, 0, 0, 0, 504, 3064, 1, 0, 0, 0,
        506, 3077, 1, 0, 0, 0, 508, 3082, 1, 0, 0, 0, 510, 3084, 1, 0, 0, 0, 512, 3095, 1, 0, 0, 0, 514,
        3112, 1, 0, 0, 0, 516, 3125, 1, 0, 0, 0, 518, 3133, 1, 0, 0, 0, 520, 3139, 1, 0, 0, 0, 522, 3141,
        1, 0, 0, 0, 524, 3154, 1, 0, 0, 0, 526, 3160, 1, 0, 0, 0, 528, 3173, 1, 0, 0, 0, 530, 3181, 1, 0,
        0, 0, 532, 3197, 1, 0, 0, 0, 534, 3199, 1, 0, 0, 0, 536, 3201, 1, 0, 0, 0, 538, 3203, 1, 0, 0, 0,
        540, 3209, 1, 0, 0, 0, 542, 3214, 1, 0, 0, 0, 544, 3219, 1, 0, 0, 0, 546, 3222, 1, 0, 0, 0, 548,
        3227, 1, 0, 0, 0, 550, 3233, 1, 0, 0, 0, 552, 3245, 1, 0, 0, 0, 554, 3249, 1, 0, 0, 0, 556, 3264,
        1, 0, 0, 0, 558, 3270, 1, 0, 0, 0, 560, 3280, 1, 0, 0, 0, 562, 3290, 1, 0, 0, 0, 564, 3294, 1, 0,
        0, 0, 566, 3298, 1, 0, 0, 0, 568, 3318, 1, 0, 0, 0, 570, 3324, 1, 0, 0, 0, 572, 3333, 1, 0, 0, 0,
        574, 3342, 1, 0, 0, 0, 576, 3378, 1, 0, 0, 0, 578, 3388, 1, 0, 0, 0, 580, 3396, 1, 0, 0, 0, 582,
        3403, 1, 0, 0, 0, 584, 3405, 1, 0, 0, 0, 586, 3411, 1, 0, 0, 0, 588, 3414, 1, 0, 0, 0, 590, 3418,
        1, 0, 0, 0, 592, 3437, 1, 0, 0, 0, 594, 3439, 1, 0, 0, 0, 596, 3447, 1, 0, 0, 0, 598, 3452, 1, 0,
        0, 0, 600, 3458, 1, 0, 0, 0, 602, 3467, 1, 0, 0, 0, 604, 3476, 1, 0, 0, 0, 606, 3487, 1, 0, 0, 0,
        608, 3493, 1, 0, 0, 0, 610, 3506, 1, 0, 0, 0, 612, 3508, 1, 0, 0, 0, 614, 3516, 1, 0, 0, 0, 616,
        3533, 1, 0, 0, 0, 618, 3535, 1, 0, 0, 0, 620, 3555, 1, 0, 0, 0, 622, 3557, 1, 0, 0, 0, 624, 3563,
        1, 0, 0, 0, 626, 3569, 1, 0, 0, 0, 628, 3582, 1, 0, 0, 0, 630, 3584, 1, 0, 0, 0, 632, 3598, 1, 0,
        0, 0, 634, 3606, 1, 0, 0, 0, 636, 3633, 1, 0, 0, 0, 638, 3665, 1, 0, 0, 0, 640, 3667, 1, 0, 0, 0,
        642, 3678, 1, 0, 0, 0, 644, 3704, 1, 0, 0, 0, 646, 3739, 1, 0, 0, 0, 648, 3744, 1, 0, 0, 0, 650,
        3767, 1, 0, 0, 0, 652, 3769, 1, 0, 0, 0, 654, 3771, 1, 0, 0, 0, 656, 3773, 1, 0, 0, 0, 658, 3775,
        1, 0, 0, 0, 660, 3777, 1, 0, 0, 0, 662, 3784, 1, 0, 0, 0, 664, 3786, 1, 0, 0, 0, 666, 3788, 1, 0,
        0, 0, 668, 3790, 1, 0, 0, 0, 670, 3803, 1, 0, 0, 0, 672, 3805, 1, 0, 0, 0, 674, 3816, 1, 0, 0, 0,
        676, 3822, 1, 0, 0, 0, 678, 3830, 1, 0, 0, 0, 680, 3832, 1, 0, 0, 0, 682, 3839, 1, 0, 0, 0, 684,
        3928, 1, 0, 0, 0, 686, 3933, 1, 0, 0, 0, 688, 3935, 1, 0, 0, 0, 690, 3937, 1, 0, 0, 0, 692, 3939,
        1, 0, 0, 0, 694, 3948, 1, 0, 0, 0, 696, 3957, 1, 0, 0, 0, 698, 3959, 1, 0, 0, 0, 700, 3979, 1, 0,
        0, 0, 702, 4006, 1, 0, 0, 0, 704, 4013, 1, 0, 0, 0, 706, 4021, 1, 0, 0, 0, 708, 4038, 1, 0, 0, 0,
        710, 4047, 1, 0, 0, 0, 712, 4050, 1, 0, 0, 0, 714, 4052, 1, 0, 0, 0, 716, 4055, 1, 0, 0, 0, 718,
        4057, 1, 0, 0, 0, 720, 4063, 1, 0, 0, 0, 722, 4084, 1, 0, 0, 0, 724, 4086, 1, 0, 0, 0, 726, 4115,
        1, 0, 0, 0, 728, 4119, 1, 0, 0, 0, 730, 4126, 1, 0, 0, 0, 732, 4130, 1, 0, 0, 0, 734, 4136, 1, 0,
        0, 0, 736, 4150, 1, 0, 0, 0, 738, 4152, 1, 0, 0, 0, 740, 4166, 1, 0, 0, 0, 742, 4168, 1, 0, 0, 0,
        744, 4170, 1, 0, 0, 0, 746, 4172, 1, 0, 0, 0, 748, 4174, 1, 0, 0, 0, 750, 4203, 1, 0, 0, 0, 752,
        4212, 1, 0, 0, 0, 754, 4230, 1, 0, 0, 0, 756, 4236, 1, 0, 0, 0, 758, 4239, 1, 0, 0, 0, 760, 4242,
        1, 0, 0, 0, 762, 4245, 1, 0, 0, 0, 764, 4248, 1, 0, 0, 0, 766, 4259, 1, 0, 0, 0, 768, 4263, 1, 0,
        0, 0, 770, 4265, 1, 0, 0, 0, 772, 4273, 1, 0, 0, 0, 774, 4283, 1, 0, 0, 0, 776, 4285, 1, 0, 0, 0,
        778, 4293, 1, 0, 0, 0, 780, 4306, 1, 0, 0, 0, 782, 4313, 1, 0, 0, 0, 784, 4317, 1, 0, 0, 0, 786,
        4321, 1, 0, 0, 0, 788, 4325, 1, 0, 0, 0, 790, 4329, 1, 0, 0, 0, 792, 4331, 1, 0, 0, 0, 794, 4351,
        1, 0, 0, 0, 796, 4353, 1, 0, 0, 0, 798, 4355, 1, 0, 0, 0, 800, 4359, 1, 0, 0, 0, 802, 4361, 1, 0,
        0, 0, 804, 4363, 1, 0, 0, 0, 806, 4365, 1, 0, 0, 0, 808, 813, 3, 2, 1, 0, 809, 810, 5, 275, 0, 0,
        810, 812, 3, 2, 1, 0, 811, 809, 1, 0, 0, 0, 812, 815, 1, 0, 0, 0, 813, 811, 1, 0, 0, 0, 813, 814,
        1, 0, 0, 0, 814, 817, 1, 0, 0, 0, 815, 813, 1, 0, 0, 0, 816, 818, 5, 275, 0, 0, 817, 816, 1, 0, 0,
        0, 817, 818, 1, 0, 0, 0, 818, 819, 1, 0, 0, 0, 819, 820, 5, 0, 0, 1, 820, 1, 1, 0, 0, 0, 821, 824,
        3, 50, 25, 0, 822, 824, 3, 4, 2, 0, 823, 821, 1, 0, 0, 0, 823, 822, 1, 0, 0, 0, 824, 3, 1, 0, 0, 0,
        825, 838, 5, 60, 0, 0, 826, 839, 3, 12, 6, 0, 827, 839, 3, 14, 7, 0, 828, 839, 3, 16, 8, 0, 829,
        839, 3, 6, 3, 0, 830, 839, 3, 18, 9, 0, 831, 839, 3, 22, 11, 0, 832, 839, 3, 24, 12, 0, 833, 839,
        3, 30, 15, 0, 834, 839, 3, 26, 13, 0, 835, 839, 3, 28, 14, 0, 836, 839, 3, 32, 16, 0, 837, 839,
        3, 36, 18, 0, 838, 826, 1, 0, 0, 0, 838, 827, 1, 0, 0, 0, 838, 828, 1, 0, 0, 0, 838, 829, 1, 0, 0,
        0, 838, 830, 1, 0, 0, 0, 838, 831, 1, 0, 0, 0, 838, 832, 1, 0, 0, 0, 838, 833, 1, 0, 0, 0, 838, 834,
        1, 0, 0, 0, 838, 835, 1, 0, 0, 0, 838, 836, 1, 0, 0, 0, 838, 837, 1, 0, 0, 0, 839, 5, 1, 0, 0, 0, 840,
        842, 5, 1, 0, 0, 841, 843, 3, 8, 4, 0, 842, 841, 1, 0, 0, 0, 842, 843, 1, 0, 0, 0, 843, 7, 1, 0, 0,
        0, 844, 849, 5, 2, 0, 0, 845, 849, 3, 38, 19, 0, 846, 849, 3, 792, 396, 0, 847, 849, 3, 10, 5,
        0, 848, 844, 1, 0, 0, 0, 848, 845, 1, 0, 0, 0, 848, 846, 1, 0, 0, 0, 848, 847, 1, 0, 0, 0, 849, 9,
        1, 0, 0, 0, 850, 851, 3, 348, 174, 0, 851, 852, 5, 112, 0, 0, 852, 853, 5, 139, 0, 0, 853, 854,
        3, 254, 127, 0, 854, 11, 1, 0, 0, 0, 855, 856, 5, 2, 0, 0, 856, 13, 1, 0, 0, 0, 857, 858, 5, 3, 0,
        0, 858, 15, 1, 0, 0, 0, 859, 861, 3, 40, 20, 0, 860, 862, 3, 776, 388, 0, 861, 860, 1, 0, 0, 0,
        861, 862, 1, 0, 0, 0, 862, 17, 1, 0, 0, 0, 863, 864, 3, 42, 21, 0, 864, 865, 3, 20, 10, 0, 865,
        19, 1, 0, 0, 0, 866, 867, 7, 0, 0, 0, 867, 21, 1, 0, 0, 0, 868, 869, 5, 4, 0, 0, 869, 23, 1, 0, 0,
        0, 870, 871, 5, 5, 0, 0, 871, 25, 1, 0, 0, 0, 872, 873, 5, 7, 0, 0, 873, 27, 1, 0, 0, 0, 874, 876,
        5, 8, 0, 0, 875, 877, 5, 9, 0, 0, 876, 875, 1, 0, 0, 0, 876, 877, 1, 0, 0, 0, 877, 29, 1, 0, 0, 0,
        878, 879, 5, 6, 0, 0, 879, 31, 1, 0, 0, 0, 880, 881, 5, 10, 0, 0, 881, 33, 1, 0, 0, 0, 882, 885,
        3, 44, 22, 0, 883, 885, 3, 46, 23, 0, 884, 882, 1, 0, 0, 0, 884, 883, 1, 0, 0, 0, 885, 35, 1, 0,
        0, 0, 886, 888, 5, 11, 0, 0, 887, 889, 3, 34, 17, 0, 888, 887, 1, 0, 0, 0, 888, 889, 1, 0, 0, 0,
        889, 37, 1, 0, 0, 0, 890, 891, 5, 176, 0, 0, 891, 39, 1, 0, 0, 0, 892, 893, 5, 320, 0, 0, 893, 41,
        1, 0, 0, 0, 894, 895, 5, 276, 0, 0, 895, 43, 1, 0, 0, 0, 896, 897, 5, 243, 0, 0, 897, 45, 1, 0, 0,
        0, 898, 899, 5, 333, 0, 0, 899, 47, 1, 0, 0, 0, 900, 910, 3, 52, 26, 0, 901, 910, 5, 3, 0, 0, 902,
        910, 5, 2, 0, 0, 903, 910, 5, 1, 0, 0, 904, 910, 5, 4, 0, 0, 905, 910, 5, 5, 0, 0, 906, 910, 5, 6,
        0, 0, 907, 910, 5, 7, 0, 0, 908, 910, 3, 804, 402, 0, 909, 900, 1, 0, 0, 0, 909, 901, 1, 0, 0, 0,
        909, 902, 1, 0, 0, 0, 909, 903, 1, 0, 0, 0, 909, 904, 1, 0, 0, 0, 909, 905, 1, 0, 0, 0, 909, 906,
        1, 0, 0, 0, 909, 907, 1, 0, 0, 0, 909, 908, 1, 0, 0, 0, 910, 49, 1, 0, 0, 0, 911, 913, 3, 54, 27,
        0, 912, 911, 1, 0, 0, 0, 913, 916, 1, 0, 0, 0, 914, 912, 1, 0, 0, 0, 914, 915, 1, 0, 0, 0, 915, 917,
        1, 0, 0, 0, 916, 914, 1, 0, 0, 0, 917, 918, 3, 70, 35, 0, 918, 51, 1, 0, 0, 0, 919, 920, 7, 1, 0,
        0, 920, 53, 1, 0, 0, 0, 921, 925, 5, 12, 0, 0, 922, 925, 5, 13, 0, 0, 923, 925, 3, 58, 29, 0, 924,
        921, 1, 0, 0, 0, 924, 922, 1, 0, 0, 0, 924, 923, 1, 0, 0, 0, 925, 55, 1, 0, 0, 0, 926, 927, 5, 14,
        0, 0, 927, 57, 1, 0, 0, 0, 928, 930, 3, 56, 28, 0, 929, 931, 3, 66, 33, 0, 930, 929, 1, 0, 0, 0,
        930, 931, 1, 0, 0, 0, 931, 935, 1, 0, 0, 0, 932, 934, 3, 60, 30, 0, 933, 932, 1, 0, 0, 0, 934, 937,
        1, 0, 0, 0, 935, 933, 1, 0, 0, 0, 935, 936, 1, 0, 0, 0, 936, 59, 1, 0, 0, 0, 937, 935, 1, 0, 0, 0,
        938, 939, 3, 64, 32, 0, 939, 940, 5, 112, 0, 0, 940, 941, 3, 62, 31, 0, 941, 61, 1, 0, 0, 0, 942,
        945, 3, 48, 24, 0, 943, 945, 3, 338, 169, 0, 944, 942, 1, 0, 0, 0, 944, 943, 1, 0, 0, 0, 945, 63,
        1, 0, 0, 0, 946, 947, 3, 48, 24, 0, 947, 65, 1, 0, 0, 0, 948, 950, 7, 2, 0, 0, 949, 948, 1, 0, 0,
        0, 950, 951, 1, 0, 0, 0, 951, 949, 1, 0, 0, 0, 951, 952, 1, 0, 0, 0, 952, 67, 1, 0, 0, 0, 953, 958,
        3, 70, 35, 0, 954, 955, 5, 275, 0, 0, 955, 957, 3, 70, 35, 0, 956, 954, 1, 0, 0, 0, 957, 960, 1,
        0, 0, 0, 958, 956, 1, 0, 0, 0, 958, 959, 1, 0, 0, 0, 959, 962, 1, 0, 0, 0, 960, 958, 1, 0, 0, 0, 961,
        963, 5, 275, 0, 0, 962, 961, 1, 0, 0, 0, 962, 963, 1, 0, 0, 0, 963, 964, 1, 0, 0, 0, 964, 965, 5,
        0, 0, 1, 965, 69, 1, 0, 0, 0, 966, 969, 3, 374, 187, 0, 967, 969, 3, 72, 36, 0, 968, 966, 1, 0,
        0, 0, 968, 967, 1, 0, 0, 0, 969, 71, 1, 0, 0, 0, 970, 975, 3, 74, 37, 0, 971, 972, 5, 199, 0, 0,
        972, 974, 3, 74, 37, 0, 973, 971, 1, 0, 0, 0, 974, 977, 1, 0, 0, 0, 975, 973, 1, 0, 0, 0, 975, 976,
        1, 0, 0, 0, 976, 73, 1, 0, 0, 0, 977, 975, 1, 0, 0, 0, 978, 981, 3, 76, 38, 0, 979, 981, 3, 78, 39,
        0, 980, 978, 1, 0, 0, 0, 980, 979, 1, 0, 0, 0, 981, 75, 1, 0, 0, 0, 982, 990, 3, 84, 42, 0, 983,
        985, 5, 315, 0, 0, 984, 986, 7, 3, 0, 0, 985, 984, 1, 0, 0, 0, 985, 986, 1, 0, 0, 0, 986, 987, 1,
        0, 0, 0, 987, 989, 3, 84, 42, 0, 988, 983, 1, 0, 0, 0, 989, 992, 1, 0, 0, 0, 990, 988, 1, 0, 0, 0,
        990, 991, 1, 0, 0, 0, 991, 77, 1, 0, 0, 0, 992, 990, 1, 0, 0, 0, 993, 995, 3, 80, 40, 0, 994, 993,
        1, 0, 0, 0, 995, 996, 1, 0, 0, 0, 996, 994, 1, 0, 0, 0, 996, 997, 1, 0, 0, 0, 997, 999, 1, 0, 0, 0,
        998, 1000, 3, 82, 41, 0, 999, 998, 1, 0, 0, 0, 999, 1000, 1, 0, 0, 0, 1000, 79, 1, 0, 0, 0, 1001,
        1002, 5, 329, 0, 0, 1002, 1003, 3, 254, 127, 0, 1003, 1004, 5, 299, 0, 0, 1004, 1005, 3, 84,
        42, 0, 1005, 81, 1, 0, 0, 0, 1006, 1007, 5, 108, 0, 0, 1007, 1008, 3, 84, 42, 0, 1008, 83, 1,
        0, 0, 0, 1009, 1011, 3, 86, 43, 0, 1010, 1009, 1, 0, 0, 0, 1011, 1012, 1, 0, 0, 0, 1012, 1010,
        1, 0, 0, 0, 1012, 1013, 1, 0, 0, 0, 1013, 1022, 1, 0, 0, 0, 1014, 1016, 3, 88, 44, 0, 1015, 1014,
        1, 0, 0, 0, 1015, 1016, 1, 0, 0, 0, 1016, 1017, 1, 0, 0, 0, 1017, 1018, 5, 171, 0, 0, 1018, 1019,
        3, 72, 36, 0, 1019, 1020, 5, 242, 0, 0, 1020, 1022, 1, 0, 0, 0, 1021, 1010, 1, 0, 0, 0, 1021,
        1015, 1, 0, 0, 0, 1022, 85, 1, 0, 0, 0, 1023, 1043, 3, 88, 44, 0, 1024, 1043, 3, 92, 46, 0, 1025,
        1043, 3, 94, 47, 0, 1026, 1043, 3, 118, 59, 0, 1027, 1043, 3, 120, 60, 0, 1028, 1043, 3, 130,
        65, 0, 1029, 1043, 3, 122, 61, 0, 1030, 1043, 3, 126, 63, 0, 1031, 1043, 3, 132, 66, 0, 1032,
        1043, 3, 138, 69, 0, 1033, 1043, 3, 116, 58, 0, 1034, 1043, 3, 142, 71, 0, 1035, 1043, 3, 144,
        72, 0, 1036, 1043, 3, 146, 73, 0, 1037, 1043, 3, 150, 75, 0, 1038, 1043, 3, 162, 81, 0, 1039,
        1043, 3, 158, 79, 0, 1040, 1043, 3, 160, 80, 0, 1041, 1043, 3, 176, 88, 0, 1042, 1023, 1, 0,
        0, 0, 1042, 1024, 1, 0, 0, 0, 1042, 1025, 1, 0, 0, 0, 1042, 1026, 1, 0, 0, 0, 1042, 1027, 1, 0,
        0, 0, 1042, 1028, 1, 0, 0, 0, 1042, 1029, 1, 0, 0, 0, 1042, 1030, 1, 0, 0, 0, 1042, 1031, 1, 0,
        0, 0, 1042, 1032, 1, 0, 0, 0, 1042, 1033, 1, 0, 0, 0, 1042, 1034, 1, 0, 0, 0, 1042, 1035, 1, 0,
        0, 0, 1042, 1036, 1, 0, 0, 0, 1042, 1037, 1, 0, 0, 0, 1042, 1038, 1, 0, 0, 0, 1042, 1039, 1, 0,
        0, 0, 1042, 1040, 1, 0, 0, 0, 1042, 1041, 1, 0, 0, 0, 1043, 87, 1, 0, 0, 0, 1044, 1046, 5, 320,
        0, 0, 1045, 1047, 5, 135, 0, 0, 1046, 1045, 1, 0, 0, 0, 1046, 1047, 1, 0, 0, 0, 1047, 1048, 1,
        0, 0, 0, 1048, 1049, 3, 90, 45, 0, 1049, 89, 1, 0, 0, 0, 1050, 1051, 5, 180, 0, 0, 1051, 1052,
        3, 90, 45, 0, 1052, 1053, 5, 267, 0, 0, 1053, 1057, 1, 0, 0, 0, 1054, 1057, 3, 350, 175, 0, 1055,
        1057, 3, 776, 388, 0, 1056, 1050, 1, 0, 0, 0, 1056, 1054, 1, 0, 0, 0, 1056, 1055, 1, 0, 0, 0,
        1057, 91, 1, 0, 0, 0, 1058, 1059, 5, 123, 0, 0, 1059, 93, 1, 0, 0, 0, 1060, 1061, 5, 261, 0, 0,
        1061, 1062, 3, 96, 48, 0, 1062, 95, 1, 0, 0, 0, 1063, 1065, 7, 3, 0, 0, 1064, 1063, 1, 0, 0, 0,
        1064, 1065, 1, 0, 0, 0, 1065, 1066, 1, 0, 0, 0, 1066, 1068, 3, 100, 50, 0, 1067, 1069, 3, 108,
        54, 0, 1068, 1067, 1, 0, 0, 0, 1068, 1069, 1, 0, 0, 0, 1069, 1071, 1, 0, 0, 0, 1070, 1072, 3,
        110, 55, 0, 1071, 1070, 1, 0, 0, 0, 1071, 1072, 1, 0, 0, 0, 1072, 1074, 1, 0, 0, 0, 1073, 1075,
        3, 112, 56, 0, 1074, 1073, 1, 0, 0, 0, 1074, 1075, 1, 0, 0, 0, 1075, 97, 1, 0, 0, 0, 1076, 1079,
        3, 254, 127, 0, 1077, 1078, 5, 39, 0, 0, 1078, 1080, 3, 358, 179, 0, 1079, 1077, 1, 0, 0, 0,
        1079, 1080, 1, 0, 0, 0, 1080, 99, 1, 0, 0, 0, 1081, 1084, 5, 301, 0, 0, 1082, 1084, 3, 98, 49,
        0, 1083, 1081, 1, 0, 0, 0, 1083, 1082, 1, 0, 0, 0, 1084, 1089, 1, 0, 0, 0, 1085, 1086, 5, 62,
        0, 0, 1086, 1088, 3, 98, 49, 0, 1087, 1085, 1, 0, 0, 0, 1088, 1091, 1, 0, 0, 0, 1089, 1087, 1,
        0, 0, 0, 1089, 1090, 1, 0, 0, 0, 1090, 101, 1, 0, 0, 0, 1091, 1089, 1, 0, 0, 0, 1092, 1095, 3,
        254, 127, 0, 1093, 1096, 3, 104, 52, 0, 1094, 1096, 3, 106, 53, 0, 1095, 1093, 1, 0, 0, 0, 1095,
        1094, 1, 0, 0, 0, 1095, 1096, 1, 0, 0, 0, 1096, 103, 1, 0, 0, 0, 1097, 1098, 7, 4, 0, 0, 1098,
        105, 1, 0, 0, 0, 1099, 1100, 7, 5, 0, 0, 1100, 107, 1, 0, 0, 0, 1101, 1102, 5, 218, 0, 0, 1102,
        1103, 5, 53, 0, 0, 1103, 1108, 3, 102, 51, 0, 1104, 1105, 5, 62, 0, 0, 1105, 1107, 3, 102, 51,
        0, 1106, 1104, 1, 0, 0, 0, 1107, 1110, 1, 0, 0, 0, 1108, 1106, 1, 0, 0, 0, 1108, 1109, 1, 0, 0,
        0, 1109, 109, 1, 0, 0, 0, 1110, 1108, 1, 0, 0, 0, 1111, 1112, 7, 6, 0, 0, 1112, 1113, 3, 254,
        127, 0, 1113, 111, 1, 0, 0, 0, 1114, 1115, 5, 175, 0, 0, 1115, 1116, 3, 254, 127, 0, 1116, 113,
        1, 0, 0, 0, 1117, 1118, 5, 330, 0, 0, 1118, 1119, 3, 254, 127, 0, 1119, 115, 1, 0, 0, 0, 1120,
        1121, 5, 331, 0, 0, 1121, 1123, 3, 96, 48, 0, 1122, 1124, 3, 114, 57, 0, 1123, 1122, 1, 0, 0,
        0, 1123, 1124, 1, 0, 0, 0, 1124, 117, 1, 0, 0, 0, 1125, 1126, 5, 73, 0, 0, 1126, 1127, 3, 178,
        89, 0, 1127, 119, 1, 0, 0, 0, 1128, 1129, 5, 151, 0, 0, 1129, 1130, 3, 180, 90, 0, 1130, 121,
        1, 0, 0, 0, 1131, 1132, 5, 278, 0, 0, 1132, 1137, 3, 124, 62, 0, 1133, 1134, 5, 62, 0, 0, 1134,
        1136, 3, 124, 62, 0, 1135, 1133, 1, 0, 0, 0, 1136, 1139, 1, 0, 0, 0, 1137, 1135, 1, 0, 0, 0, 1137,
        1138, 1, 0, 0, 0, 1138, 123, 1, 0, 0, 0, 1139, 1137, 1, 0, 0, 0, 1140, 1141, 3, 286, 143, 0, 1141,
        1142, 5, 112, 0, 0, 1142, 1143, 3, 254, 127, 0, 1143, 1163, 1, 0, 0, 0, 1144, 1145, 3, 288,
        144, 0, 1145, 1146, 5, 112, 0, 0, 1146, 1147, 3, 254, 127, 0, 1147, 1163, 1, 0, 0, 0, 1148,
        1149, 3, 358, 179, 0, 1149, 1150, 5, 112, 0, 0, 1150, 1151, 3, 254, 127, 0, 1151, 1163, 1,
        0, 0, 0, 1152, 1153, 3, 358, 179, 0, 1153, 1154, 5, 225, 0, 0, 1154, 1155, 3, 254, 127, 0, 1155,
        1163, 1, 0, 0, 0, 1156, 1157, 3, 358, 179, 0, 1157, 1158, 3, 210, 105, 0, 1158, 1163, 1, 0,
        0, 0, 1159, 1160, 3, 358, 179, 0, 1160, 1161, 3, 212, 106, 0, 1161, 1163, 1, 0, 0, 0, 1162,
        1140, 1, 0, 0, 0, 1162, 1144, 1, 0, 0, 0, 1162, 1148, 1, 0, 0, 0, 1162, 1152, 1, 0, 0, 0, 1162,
        1156, 1, 0, 0, 0, 1162, 1159, 1, 0, 0, 0, 1163, 125, 1, 0, 0, 0, 1164, 1165, 5, 251, 0, 0, 1165,
        1170, 3, 128, 64, 0, 1166, 1167, 5, 62, 0, 0, 1167, 1169, 3, 128, 64, 0, 1168, 1166, 1, 0, 0,
        0, 1169, 1172, 1, 0, 0, 0, 1170, 1168, 1, 0, 0, 0, 1170, 1171, 1, 0, 0, 0, 1171, 127, 1, 0, 0,
        0, 1172, 1170, 1, 0, 0, 0, 1173, 1182, 3, 286, 143, 0, 1174, 1182, 3, 288, 144, 0, 1175, 1176,
        3, 358, 179, 0, 1176, 1177, 3, 210, 105, 0, 1177, 1182, 1, 0, 0, 0, 1178, 1179, 3, 358, 179,
        0, 1179, 1180, 3, 212, 106, 0, 1180, 1182, 1, 0, 0, 0, 1181, 1173, 1, 0, 0, 0, 1181, 1174, 1,
        0, 0, 0, 1181, 1175, 1, 0, 0, 0, 1181, 1178, 1, 0, 0, 0, 1182, 129, 1, 0, 0, 0, 1183, 1185, 7,
        7, 0, 0, 1184, 1183, 1, 0, 0, 0, 1184, 1185, 1, 0, 0, 0, 1185, 1186, 1, 0, 0, 0, 1186, 1187, 5,
        85, 0, 0, 1187, 1192, 3, 254, 127, 0, 1188, 1189, 5, 62, 0, 0, 1189, 1191, 3, 254, 127, 0, 1190,
        1188, 1, 0, 0, 0, 1191, 1194, 1, 0, 0, 0, 1192, 1190, 1, 0, 0, 0, 1192, 1193, 1, 0, 0, 0, 1193,
        131, 1, 0, 0, 0, 1194, 1192, 1, 0, 0, 0, 1195, 1197, 5, 214, 0, 0, 1196, 1195, 1, 0, 0, 0, 1196,
        1197, 1, 0, 0, 0, 1197, 1198, 1, 0, 0, 0, 1198, 1200, 5, 184, 0, 0, 1199, 1201, 3, 134, 67, 0,
        1200, 1199, 1, 0, 0, 0, 1200, 1201, 1, 0, 0, 0, 1201, 1202, 1, 0, 0, 0, 1202, 1206, 3, 178, 89,
        0, 1203, 1205, 3, 136, 68, 0, 1204, 1203, 1, 0, 0, 0, 1205, 1208, 1, 0, 0, 0, 1206, 1204, 1,
        0, 0, 0, 1206, 1207, 1, 0, 0, 0, 1207, 1210, 1, 0, 0, 0, 1208, 1206, 1, 0, 0, 0, 1209, 1211, 3,
        114, 57, 0, 1210, 1209, 1, 0, 0, 0, 1210, 1211, 1, 0, 0, 0, 1211, 133, 1, 0, 0, 0, 1212, 1218,
        5, 252, 0, 0, 1213, 1215, 5, 106, 0, 0, 1214, 1216, 5, 46, 0, 0, 1215, 1214, 1, 0, 0, 0, 1215,
        1216, 1, 0, 0, 0, 1216, 1219, 1, 0, 0, 0, 1217, 1219, 5, 107, 0, 0, 1218, 1213, 1, 0, 0, 0, 1218,
        1217, 1, 0, 0, 0, 1219, 1229, 1, 0, 0, 0, 1220, 1226, 5, 91, 0, 0, 1221, 1223, 5, 249, 0, 0, 1222,
        1224, 5, 46, 0, 0, 1223, 1222, 1, 0, 0, 0, 1223, 1224, 1, 0, 0, 0, 1224, 1227, 1, 0, 0, 0, 1225,
        1227, 5, 250, 0, 0, 1226, 1221, 1, 0, 0, 0, 1226, 1225, 1, 0, 0, 0, 1227, 1229, 1, 0, 0, 0, 1228,
        1212, 1, 0, 0, 0, 1228, 1220, 1, 0, 0, 0, 1229, 135, 1, 0, 0, 0, 1230, 1256, 5, 323, 0, 0, 1231,
        1239, 5, 147, 0, 0, 1232, 1233, 5, 298, 0, 0, 1233, 1239, 5, 147, 0, 0, 1234, 1235, 5, 240,
        0, 0, 1235, 1239, 5, 147, 0, 0, 1236, 1237, 5, 226, 0, 0, 1237, 1239, 5, 147, 0, 0, 1238, 1231,
        1, 0, 0, 0, 1238, 1232, 1, 0, 0, 0, 1238, 1234, 1, 0, 0, 0, 1238, 1236, 1, 0, 0, 0, 1239, 1241,
        1, 0, 0, 0, 1240, 1242, 5, 274, 0, 0, 1241, 1240, 1, 0, 0, 0, 1241, 1242, 1, 0, 0, 0, 1242, 1243,
        1, 0, 0, 0, 1243, 1244, 3, 358, 179, 0, 1244, 1245, 3, 224, 112, 0, 1245, 1246, 5, 180, 0, 0,
        1246, 1247, 3, 360, 180, 0, 1247, 1248, 5, 267, 0, 0, 1248, 1257, 1, 0, 0, 0, 1249, 1250, 5,
        163, 0, 0, 1250, 1251, 5, 212, 0, 0, 1251, 1257, 3, 360, 180, 0, 1252, 1253, 5, 268, 0, 0, 1253,
        1254, 3, 358, 179, 0, 1254, 1255, 3, 224, 112, 0, 1255, 1257, 1, 0, 0, 0, 1256, 1238, 1, 0,
        0, 0, 1256, 1249, 1, 0, 0, 0, 1256, 1252, 1, 0, 0, 0, 1257, 137, 1, 0, 0, 0, 1258, 1259, 5, 185,
        0, 0, 1259, 1263, 3, 182, 91, 0, 1260, 1262, 3, 140, 70, 0, 1261, 1260, 1, 0, 0, 0, 1262, 1265,
        1, 0, 0, 0, 1263, 1261, 1, 0, 0, 0, 1263, 1264, 1, 0, 0, 0, 1264, 139, 1, 0, 0, 0, 1265, 1263,
        1, 0, 0, 0, 1266, 1267, 5, 212, 0, 0, 1267, 1268, 7, 8, 0, 0, 1268, 1269, 3, 122, 61, 0, 1269,
        141, 1, 0, 0, 0, 1270, 1272, 5, 122, 0, 0, 1271, 1273, 5, 330, 0, 0, 1272, 1271, 1, 0, 0, 0, 1272,
        1273, 1, 0, 0, 0, 1273, 1274, 1, 0, 0, 0, 1274, 1275, 3, 254, 127, 0, 1275, 143, 1, 0, 0, 0, 1276,
        1277, 5, 318, 0, 0, 1277, 1278, 3, 254, 127, 0, 1278, 1279, 5, 39, 0, 0, 1279, 1280, 3, 358,
        179, 0, 1280, 145, 1, 0, 0, 0, 1281, 1282, 5, 174, 0, 0, 1282, 1287, 3, 148, 74, 0, 1283, 1284,
        5, 62, 0, 0, 1284, 1286, 3, 148, 74, 0, 1285, 1283, 1, 0, 0, 0, 1286, 1289, 1, 0, 0, 0, 1287,
        1285, 1, 0, 0, 0, 1287, 1288, 1, 0, 0, 0, 1288, 147, 1, 0, 0, 0, 1289, 1287, 1, 0, 0, 0, 1290,
        1291, 3, 358, 179, 0, 1291, 1292, 5, 112, 0, 0, 1292, 1293, 3, 254, 127, 0, 1293, 149, 1, 0,
        0, 0, 1294, 1296, 5, 214, 0, 0, 1295, 1294, 1, 0, 0, 0, 1295, 1296, 1, 0, 0, 0, 1296, 1297, 1,
        0, 0, 0, 1297, 1298, 5, 54, 0, 0, 1298, 1311, 3, 152, 76, 0, 1299, 1308, 5, 180, 0, 0, 1300,
        1305, 3, 154, 77, 0, 1301, 1302, 5, 62, 0, 0, 1302, 1304, 3, 154, 77, 0, 1303, 1301, 1, 0, 0,
        0, 1304, 1307, 1, 0, 0, 0, 1305, 1303, 1, 0, 0, 0, 1305, 1306, 1, 0, 0, 0, 1306, 1309, 1, 0, 0,
        0, 1307, 1305, 1, 0, 0, 0, 1308, 1300, 1, 0, 0, 0, 1308, 1309, 1, 0, 0, 0, 1309, 1310, 1, 0, 0,
        0, 1310, 1312, 5, 267, 0, 0, 1311, 1299, 1, 0, 0, 0, 1311, 1312, 1, 0, 0, 0, 1312, 1328, 1, 0,
        0, 0, 1313, 1326, 5, 335, 0, 0, 1314, 1327, 5, 301, 0, 0, 1315, 1320, 3, 156, 78, 0, 1316, 1317,
        5, 62, 0, 0, 1317, 1319, 3, 156, 78, 0, 1318, 1316, 1, 0, 0, 0, 1319, 1322, 1, 0, 0, 0, 1320,
        1318, 1, 0, 0, 0, 1320, 1321, 1, 0, 0, 0, 1321, 1324, 1, 0, 0, 0, 1322, 1320, 1, 0, 0, 0, 1323,
        1325, 3, 114, 57, 0, 1324, 1323, 1, 0, 0, 0, 1324, 1325, 1, 0, 0, 0, 1325, 1327, 1, 0, 0, 0, 1326,
        1314, 1, 0, 0, 0, 1326, 1315, 1, 0, 0, 0, 1327, 1329, 1, 0, 0, 0, 1328, 1313, 1, 0, 0, 0, 1328,
        1329, 1, 0, 0, 0, 1329, 151, 1, 0, 0, 0, 1330, 1331, 3, 356, 178, 0, 1331, 1332, 3, 800, 400,
        0, 1332, 153, 1, 0, 0, 0, 1333, 1334, 3, 254, 127, 0, 1334, 155, 1, 0, 0, 0, 1335, 1338, 3, 358,
        179, 0, 1336, 1337, 5, 39, 0, 0, 1337, 1339, 3, 358, 179, 0, 1338, 1336, 1, 0, 0, 0, 1338, 1339,
        1, 0, 0, 0, 1339, 157, 1, 0, 0, 0, 1340, 1341, 5, 177, 0, 0, 1341, 1344, 5, 74, 0, 0, 1342, 1343,
        5, 331, 0, 0, 1343, 1345, 5, 140, 0, 0, 1344, 1342, 1, 0, 0, 0, 1344, 1345, 1, 0, 0, 0, 1345,
        1346, 1, 0, 0, 0, 1346, 1347, 5, 129, 0, 0, 1347, 1348, 3, 254, 127, 0, 1348, 1349, 5, 39, 0,
        0, 1349, 1352, 3, 358, 179, 0, 1350, 1351, 5, 121, 0, 0, 1351, 1353, 3, 782, 391, 0, 1352,
        1350, 1, 0, 0, 0, 1352, 1353, 1, 0, 0, 0, 1353, 159, 1, 0, 0, 0, 1354, 1355, 5, 128, 0, 0, 1355,
        1356, 5, 180, 0, 0, 1356, 1357, 3, 358, 179, 0, 1357, 1358, 5, 146, 0, 0, 1358, 1359, 3, 254,
        127, 0, 1359, 1361, 5, 45, 0, 0, 1360, 1362, 3, 86, 43, 0, 1361, 1360, 1, 0, 0, 0, 1362, 1363,
        1, 0, 0, 0, 1363, 1361, 1, 0, 0, 0, 1363, 1364, 1, 0, 0, 0, 1364, 1365, 1, 0, 0, 0, 1365, 1366,
        5, 267, 0, 0, 1366, 161, 1, 0, 0, 0, 1367, 1369, 5, 214, 0, 0, 1368, 1367, 1, 0, 0, 0, 1368, 1369,
        1, 0, 0, 0, 1369, 1370, 1, 0, 0, 0, 1370, 1372, 5, 54, 0, 0, 1371, 1373, 3, 164, 82, 0, 1372,
        1371, 1, 0, 0, 0, 1372, 1373, 1, 0, 0, 0, 1373, 1374, 1, 0, 0, 0, 1374, 1375, 5, 171, 0, 0, 1375,
        1376, 3, 72, 36, 0, 1376, 1378, 5, 242, 0, 0, 1377, 1379, 3, 166, 83, 0, 1378, 1377, 1, 0, 0,
        0, 1378, 1379, 1, 0, 0, 0, 1379, 163, 1, 0, 0, 0, 1380, 1390, 5, 180, 0, 0, 1381, 1391, 5, 301,
        0, 0, 1382, 1387, 3, 358, 179, 0, 1383, 1384, 5, 62, 0, 0, 1384, 1386, 3, 358, 179, 0, 1385,
        1383, 1, 0, 0, 0, 1386, 1389, 1, 0, 0, 0, 1387, 1385, 1, 0, 0, 0, 1387, 1388, 1, 0, 0, 0, 1388,
        1391, 1, 0, 0, 0, 1389, 1387, 1, 0, 0, 0, 1390, 1381, 1, 0, 0, 0, 1390, 1382, 1, 0, 0, 0, 1390,
        1391, 1, 0, 0, 0, 1391, 1392, 1, 0, 0, 0, 1392, 1393, 5, 267, 0, 0, 1393, 165, 1, 0, 0, 0, 1394,
        1399, 5, 146, 0, 0, 1395, 1397, 3, 254, 127, 0, 1396, 1395, 1, 0, 0, 0, 1396, 1397, 1, 0, 0,
        0, 1397, 1398, 1, 0, 0, 0, 1398, 1400, 5, 66, 0, 0, 1399, 1396, 1, 0, 0, 0, 1399, 1400, 1, 0,
        0, 0, 1400, 1401, 1, 0, 0, 0, 1401, 1407, 5, 308, 0, 0, 1402, 1406, 3, 168, 84, 0, 1403, 1406,
        3, 170, 85, 0, 1404, 1406, 3, 174, 87, 0, 1405, 1402, 1, 0, 0, 0, 1405, 1403, 1, 0, 0, 0, 1405,
        1404, 1, 0, 0, 0, 1406, 1409, 1, 0, 0, 0, 1407, 1405, 1, 0, 0, 0, 1407, 1408, 1, 0, 0, 0, 1408,
        167, 1, 0, 0, 0, 1409, 1407, 1, 0, 0, 0, 1410, 1411, 5, 210, 0, 0, 1411, 1412, 3, 254, 127, 0,
        1412, 1413, 7, 9, 0, 0, 1413, 169, 1, 0, 0, 0, 1414, 1415, 5, 212, 0, 0, 1415, 1416, 5, 118,
        0, 0, 1416, 1418, 5, 260, 0, 0, 1417, 1419, 3, 172, 86, 0, 1418, 1417, 1, 0, 0, 0, 1418, 1419,
        1, 0, 0, 0, 1419, 1422, 1, 0, 0, 0, 1420, 1421, 5, 299, 0, 0, 1421, 1423, 7, 10, 0, 0, 1422, 1420,
        1, 0, 0, 0, 1422, 1423, 1, 0, 0, 0, 1423, 1428, 1, 0, 0, 0, 1424, 1425, 5, 212, 0, 0, 1425, 1426,
        5, 118, 0, 0, 1426, 1428, 7, 10, 0, 0, 1427, 1414, 1, 0, 0, 0, 1427, 1424, 1, 0, 0, 0, 1428, 171,
        1, 0, 0, 0, 1429, 1431, 5, 127, 0, 0, 1430, 1429, 1, 0, 0, 0, 1430, 1431, 1, 0, 0, 0, 1431, 1432,
        1, 0, 0, 0, 1432, 1433, 3, 254, 127, 0, 1433, 1434, 3, 738, 369, 0, 1434, 173, 1, 0, 0, 0, 1435,
        1436, 5, 256, 0, 0, 1436, 1437, 5, 291, 0, 0, 1437, 1438, 5, 39, 0, 0, 1438, 1439, 3, 358, 179,
        0, 1439, 175, 1, 0, 0, 0, 1440, 1442, 3, 108, 54, 0, 1441, 1443, 3, 110, 55, 0, 1442, 1441,
        1, 0, 0, 0, 1442, 1443, 1, 0, 0, 0, 1443, 1445, 1, 0, 0, 0, 1444, 1446, 3, 112, 56, 0, 1445, 1444,
        1, 0, 0, 0, 1445, 1446, 1, 0, 0, 0, 1446, 1453, 1, 0, 0, 0, 1447, 1449, 3, 110, 55, 0, 1448, 1450,
        3, 112, 56, 0, 1449, 1448, 1, 0, 0, 0, 1449, 1450, 1, 0, 0, 0, 1450, 1453, 1, 0, 0, 0, 1451, 1453,
        3, 112, 56, 0, 1452, 1440, 1, 0, 0, 0, 1452, 1447, 1, 0, 0, 0, 1452, 1451, 1, 0, 0, 0, 1453, 177,
        1, 0, 0, 0, 1454, 1459, 3, 182, 91, 0, 1455, 1456, 5, 62, 0, 0, 1456, 1458, 3, 182, 91, 0, 1457,
        1455, 1, 0, 0, 0, 1458, 1461, 1, 0, 0, 0, 1459, 1457, 1, 0, 0, 0, 1459, 1460, 1, 0, 0, 0, 1460,
        179, 1, 0, 0, 0, 1461, 1459, 1, 0, 0, 0, 1462, 1467, 3, 184, 92, 0, 1463, 1464, 5, 62, 0, 0, 1464,
        1466, 3, 184, 92, 0, 1465, 1463, 1, 0, 0, 0, 1466, 1469, 1, 0, 0, 0, 1467, 1465, 1, 0, 0, 0, 1467,
        1468, 1, 0, 0, 0, 1468, 181, 1, 0, 0, 0, 1469, 1467, 1, 0, 0, 0, 1470, 1471, 3, 358, 179, 0, 1471,
        1472, 5, 112, 0, 0, 1472, 1474, 1, 0, 0, 0, 1473, 1470, 1, 0, 0, 0, 1473, 1474, 1, 0, 0, 0, 1474,
        1476, 1, 0, 0, 0, 1475, 1477, 3, 194, 97, 0, 1476, 1475, 1, 0, 0, 0, 1476, 1477, 1, 0, 0, 0, 1477,
        1478, 1, 0, 0, 0, 1478, 1479, 3, 188, 94, 0, 1479, 183, 1, 0, 0, 0, 1480, 1481, 3, 800, 400,
        0, 1481, 1482, 5, 112, 0, 0, 1482, 1484, 1, 0, 0, 0, 1483, 1480, 1, 0, 0, 0, 1483, 1484, 1, 0,
        0, 0, 1484, 1485, 1, 0, 0, 0, 1485, 1491, 3, 206, 103, 0, 1486, 1487, 3, 230, 115, 0, 1487,
        1488, 3, 206, 103, 0, 1488, 1490, 1, 0, 0, 0, 1489, 1486, 1, 0, 0, 0, 1490, 1493, 1, 0, 0, 0,
        1491, 1489, 1, 0, 0, 0, 1491, 1492, 1, 0, 0, 0, 1492, 185, 1, 0, 0, 0, 1493, 1491, 1, 0, 0, 0,
        1494, 1495, 5, 171, 0, 0, 1495, 1496, 5, 19, 0, 0, 1496, 1509, 5, 242, 0, 0, 1497, 1499, 5,
        171, 0, 0, 1498, 1500, 5, 19, 0, 0, 1499, 1498, 1, 0, 0, 0, 1499, 1500, 1, 0, 0, 0, 1500, 1501,
        1, 0, 0, 0, 1501, 1503, 5, 62, 0, 0, 1502, 1504, 5, 19, 0, 0, 1503, 1502, 1, 0, 0, 0, 1503, 1504,
        1, 0, 0, 0, 1504, 1505, 1, 0, 0, 0, 1505, 1509, 5, 242, 0, 0, 1506, 1509, 5, 224, 0, 0, 1507,
        1509, 5, 301, 0, 0, 1508, 1494, 1, 0, 0, 0, 1508, 1497, 1, 0, 0, 0, 1508, 1506, 1, 0, 0, 0, 1508,
        1507, 1, 0, 0, 0, 1509, 187, 1, 0, 0, 0, 1510, 1513, 3, 190, 95, 0, 1511, 1513, 3, 192, 96, 0,
        1512, 1510, 1, 0, 0, 0, 1512, 1511, 1, 0, 0, 0, 1513, 189, 1, 0, 0, 0, 1514, 1515, 7, 11, 0, 0,
        1515, 1516, 5, 180, 0, 0, 1516, 1517, 3, 192, 96, 0, 1517, 1518, 5, 267, 0, 0, 1518, 191, 1,
        0, 0, 0, 1519, 1528, 3, 204, 102, 0, 1520, 1522, 3, 228, 114, 0, 1521, 1523, 3, 186, 93, 0,
        1522, 1521, 1, 0, 0, 0, 1522, 1523, 1, 0, 0, 0, 1523, 1524, 1, 0, 0, 0, 1524, 1525, 3, 204, 102,
        0, 1525, 1527, 1, 0, 0, 0, 1526, 1520, 1, 0, 0, 0, 1527, 1530, 1, 0, 0, 0, 1528, 1526, 1, 0, 0,
        0, 1528, 1529, 1, 0, 0, 0, 1529, 1533, 1, 0, 0, 0, 1530, 1528, 1, 0, 0, 0, 1531, 1533, 3, 208,
        104, 0, 1532, 1519, 1, 0, 0, 0, 1532, 1531, 1, 0, 0, 0, 1533, 1534, 1, 0, 0, 0, 1534, 1532, 1,
        0, 0, 0, 1534, 1535, 1, 0, 0, 0, 1535, 193, 1, 0, 0, 0, 1536, 1537, 5, 37, 0, 0, 1537, 1539, 5,
        284, 0, 0, 1538, 1540, 3, 200, 100, 0, 1539, 1538, 1, 0, 0, 0, 1539, 1540, 1, 0, 0, 0, 1540,
        1571, 1, 0, 0, 0, 1541, 1542, 5, 33, 0, 0, 1542, 1544, 5, 284, 0, 0, 1543, 1545, 3, 200, 100,
        0, 1544, 1543, 1, 0, 0, 0, 1544, 1545, 1, 0, 0, 0, 1545, 1571, 1, 0, 0, 0, 1546, 1548, 5, 37,
        0, 0, 1547, 1549, 3, 196, 98, 0, 1548, 1547, 1, 0, 0, 0, 1548, 1549, 1, 0, 0, 0, 1549, 1551,
        1, 0, 0, 0, 1550, 1552, 3, 200, 100, 0, 1551, 1550, 1, 0, 0, 0, 1551, 1552, 1, 0, 0, 0, 1552,
        1571, 1, 0, 0, 0, 1553, 1555, 5, 33, 0, 0, 1554, 1556, 3, 200, 100, 0, 1555, 1554, 1, 0, 0, 0,
        1555, 1556, 1, 0, 0, 0, 1556, 1571, 1, 0, 0, 0, 1557, 1559, 5, 284, 0, 0, 1558, 1560, 3, 196,
        98, 0, 1559, 1558, 1, 0, 0, 0, 1559, 1560, 1, 0, 0, 0, 1560, 1562, 1, 0, 0, 0, 1561, 1563, 3,
        200, 100, 0, 1562, 1561, 1, 0, 0, 0, 1562, 1563, 1, 0, 0, 0, 1563, 1564, 1, 0, 0, 0, 1564, 1571,
        3, 198, 99, 0, 1565, 1566, 5, 284, 0, 0, 1566, 1568, 3, 196, 98, 0, 1567, 1569, 3, 200, 100,
        0, 1568, 1567, 1, 0, 0, 0, 1568, 1569, 1, 0, 0, 0, 1569, 1571, 1, 0, 0, 0, 1570, 1536, 1, 0, 0,
        0, 1570, 1541, 1, 0, 0, 0, 1570, 1546, 1, 0, 0, 0, 1570, 1553, 1, 0, 0, 0, 1570, 1557, 1, 0, 0,
        0, 1570, 1565, 1, 0, 0, 0, 1571, 195, 1, 0, 0, 0, 1572, 1575, 5, 19, 0, 0, 1573, 1575, 3, 346,
        173, 0, 1574, 1572, 1, 0, 0, 0, 1574, 1573, 1, 0, 0, 0, 1575, 197, 1, 0, 0, 0, 1576, 1577, 7,
        12, 0, 0, 1577, 199, 1, 0, 0, 0, 1578, 1579, 7, 13, 0, 0, 1579, 201, 1, 0, 0, 0, 1580, 1584, 3,
        204, 102, 0, 1581, 1582, 3, 228, 114, 0, 1582, 1583, 3, 204, 102, 0, 1583, 1585, 1, 0, 0, 0,
        1584, 1581, 1, 0, 0, 0, 1585, 1586, 1, 0, 0, 0, 1586, 1584, 1, 0, 0, 0, 1586, 1587, 1, 0, 0, 0,
        1587, 203, 1, 0, 0, 0, 1588, 1589, 5, 180, 0, 0, 1589, 1590, 5, 330, 0, 0, 1590, 1591, 3, 254,
        127, 0, 1591, 1592, 5, 267, 0, 0, 1592, 1609, 1, 0, 0, 0, 1593, 1595, 5, 180, 0, 0, 1594, 1596,
        3, 358, 179, 0, 1595, 1594, 1, 0, 0, 0, 1595, 1596, 1, 0, 0, 0, 1596, 1598, 1, 0, 0, 0, 1597,
        1599, 3, 240, 120, 0, 1598, 1597, 1, 0, 0, 0, 1598, 1599, 1, 0, 0, 0, 1599, 1601, 1, 0, 0, 0,
        1600, 1602, 3, 226, 113, 0, 1601, 1600, 1, 0, 0, 0, 1601, 1602, 1, 0, 0, 0, 1602, 1605, 1, 0,
        0, 0, 1603, 1604, 5, 330, 0, 0, 1604, 1606, 3, 254, 127, 0, 1605, 1603, 1, 0, 0, 0, 1605, 1606,
        1, 0, 0, 0, 1606, 1607, 1, 0, 0, 0, 1607, 1609, 5, 267, 0, 0, 1608, 1588, 1, 0, 0, 0, 1608, 1593,
        1, 0, 0, 0, 1609, 205, 1, 0, 0, 0, 1610, 1611, 5, 180, 0, 0, 1611, 1612, 5, 330, 0, 0, 1612, 1613,
        3, 254, 127, 0, 1613, 1614, 5, 267, 0, 0, 1614, 1627, 1, 0, 0, 0, 1615, 1617, 5, 180, 0, 0, 1616,
        1618, 3, 358, 179, 0, 1617, 1616, 1, 0, 0, 0, 1617, 1618, 1, 0, 0, 0, 1618, 1620, 1, 0, 0, 0,
        1619, 1621, 3, 250, 125, 0, 1620, 1619, 1, 0, 0, 0, 1620, 1621, 1, 0, 0, 0, 1621, 1623, 1, 0,
        0, 0, 1622, 1624, 3, 792, 396, 0, 1623, 1622, 1, 0, 0, 0, 1623, 1624, 1, 0, 0, 0, 1624, 1625,
        1, 0, 0, 0, 1625, 1627, 5, 267, 0, 0, 1626, 1610, 1, 0, 0, 0, 1626, 1615, 1, 0, 0, 0, 1627, 207,
        1, 0, 0, 0, 1628, 1629, 5, 180, 0, 0, 1629, 1632, 3, 182, 91, 0, 1630, 1631, 5, 330, 0, 0, 1631,
        1633, 3, 254, 127, 0, 1632, 1630, 1, 0, 0, 0, 1632, 1633, 1, 0, 0, 0, 1633, 1634, 1, 0, 0, 0,
        1634, 1636, 5, 267, 0, 0, 1635, 1637, 3, 186, 93, 0, 1636, 1635, 1, 0, 0, 0, 1636, 1637, 1,
        0, 0, 0, 1637, 209, 1, 0, 0, 0, 1638, 1641, 3, 220, 110, 0, 1639, 1641, 3, 218, 109, 0, 1640,
        1638, 1, 0, 0, 0, 1640, 1639, 1, 0, 0, 0, 1641, 1642, 1, 0, 0, 0, 1642, 1640, 1, 0, 0, 0, 1642,
        1643, 1, 0, 0, 0, 1643, 211, 1, 0, 0, 0, 1644, 1647, 5, 162, 0, 0, 1645, 1648, 3, 800, 400, 0,
        1646, 1648, 3, 214, 107, 0, 1647, 1645, 1, 0, 0, 0, 1647, 1646, 1, 0, 0, 0, 1648, 1653, 1, 0,
        0, 0, 1649, 1652, 3, 220, 110, 0, 1650, 1652, 3, 218, 109, 0, 1651, 1649, 1, 0, 0, 0, 1651,
        1650, 1, 0, 0, 0, 1652, 1655, 1, 0, 0, 0, 1653, 1651, 1, 0, 0, 0, 1653, 1654, 1, 0, 0, 0, 1654,
        213, 1, 0, 0, 0, 1655, 1653, 1, 0, 0, 0, 1656, 1657, 5, 92, 0, 0, 1657, 1658, 5, 180, 0, 0, 1658,
        1659, 3, 254, 127, 0, 1659, 1660, 5, 267, 0, 0, 1660, 215, 1, 0, 0, 0, 1661, 1663, 5, 92, 0,
        0, 1662, 1664, 7, 14, 0, 0, 1663, 1662, 1, 0, 0, 0, 1663, 1664, 1, 0, 0, 0, 1664, 1665, 1, 0,
        0, 0, 1665, 1666, 5, 180, 0, 0, 1666, 1667, 3, 254, 127, 0, 1667, 1668, 5, 267, 0, 0, 1668,
        217, 1, 0, 0, 0, 1669, 1670, 5, 60, 0, 0, 1670, 1671, 3, 214, 107, 0, 1671, 219, 1, 0, 0, 0, 1672,
        1673, 5, 60, 0, 0, 1673, 1674, 3, 800, 400, 0, 1674, 221, 1, 0, 0, 0, 1675, 1676, 5, 60, 0, 0,
        1676, 1677, 3, 800, 400, 0, 1677, 223, 1, 0, 0, 0, 1678, 1679, 5, 60, 0, 0, 1679, 1680, 3, 800,
        400, 0, 1680, 225, 1, 0, 0, 0, 1681, 1684, 3, 792, 396, 0, 1682, 1684, 3, 346, 173, 0, 1683,
        1681, 1, 0, 0, 0, 1683, 1682, 1, 0, 0, 0, 1684, 227, 1, 0, 0, 0, 1685, 1687, 3, 232, 116, 0, 1686,
        1685, 1, 0, 0, 0, 1686, 1687, 1, 0, 0, 0, 1687, 1688, 1, 0, 0, 0, 1688, 1712, 3, 234, 117, 0,
        1689, 1690, 5, 170, 0, 0, 1690, 1691, 5, 330, 0, 0, 1691, 1692, 3, 254, 127, 0, 1692, 1693,
        5, 241, 0, 0, 1693, 1713, 1, 0, 0, 0, 1694, 1696, 5, 170, 0, 0, 1695, 1697, 3, 358, 179, 0, 1696,
        1695, 1, 0, 0, 0, 1696, 1697, 1, 0, 0, 0, 1697, 1699, 1, 0, 0, 0, 1698, 1700, 3, 240, 120, 0,
        1699, 1698, 1, 0, 0, 0, 1699, 1700, 1, 0, 0, 0, 1700, 1702, 1, 0, 0, 0, 1701, 1703, 3, 238, 119,
        0, 1702, 1701, 1, 0, 0, 0, 1702, 1703, 1, 0, 0, 0, 1703, 1705, 1, 0, 0, 0, 1704, 1706, 3, 226,
        113, 0, 1705, 1704, 1, 0, 0, 0, 1705, 1706, 1, 0, 0, 0, 1706, 1709, 1, 0, 0, 0, 1707, 1708, 5,
        330, 0, 0, 1708, 1710, 3, 254, 127, 0, 1709, 1707, 1, 0, 0, 0, 1709, 1710, 1, 0, 0, 0, 1710,
        1711, 1, 0, 0, 0, 1711, 1713, 5, 241, 0, 0, 1712, 1689, 1, 0, 0, 0, 1712, 1694, 1, 0, 0, 0, 1712,
        1713, 1, 0, 0, 0, 1713, 1714, 1, 0, 0, 0, 1714, 1716, 3, 234, 117, 0, 1715, 1717, 3, 236, 118,
        0, 1716, 1715, 1, 0, 0, 0, 1716, 1717, 1, 0, 0, 0, 1717, 229, 1, 0, 0, 0, 1718, 1720, 3, 232,
        116, 0, 1719, 1718, 1, 0, 0, 0, 1719, 1720, 1, 0, 0, 0, 1720, 1721, 1, 0, 0, 0, 1721, 1737, 3,
        234, 117, 0, 1722, 1723, 5, 170, 0, 0, 1723, 1724, 5, 330, 0, 0, 1724, 1725, 3, 254, 127, 0,
        1725, 1726, 5, 241, 0, 0, 1726, 1738, 1, 0, 0, 0, 1727, 1729, 5, 170, 0, 0, 1728, 1730, 3, 358,
        179, 0, 1729, 1728, 1, 0, 0, 0, 1729, 1730, 1, 0, 0, 0, 1730, 1731, 1, 0, 0, 0, 1731, 1733, 3,
        252, 126, 0, 1732, 1734, 3, 792, 396, 0, 1733, 1732, 1, 0, 0, 0, 1733, 1734, 1, 0, 0, 0, 1734,
        1735, 1, 0, 0, 0, 1735, 1736, 5, 241, 0, 0, 1736, 1738, 1, 0, 0, 0, 1737, 1722, 1, 0, 0, 0, 1737,
        1727, 1, 0, 0, 0, 1738, 1739, 1, 0, 0, 0, 1739, 1741, 3, 234, 117, 0, 1740, 1742, 3, 236, 118,
        0, 1741, 1740, 1, 0, 0, 0, 1741, 1742, 1, 0, 0, 0, 1742, 231, 1, 0, 0, 0, 1743, 1744, 7, 15, 0,
        0, 1744, 233, 1, 0, 0, 0, 1745, 1746, 7, 16, 0, 0, 1746, 235, 1, 0, 0, 0, 1747, 1748, 7, 17, 0,
        0, 1748, 237, 1, 0, 0, 0, 1749, 1758, 5, 301, 0, 0, 1750, 1752, 5, 19, 0, 0, 1751, 1750, 1, 0,
        0, 0, 1751, 1752, 1, 0, 0, 0, 1752, 1753, 1, 0, 0, 0, 1753, 1755, 5, 96, 0, 0, 1754, 1756, 5,
        19, 0, 0, 1755, 1754, 1, 0, 0, 0, 1755, 1756, 1, 0, 0, 0, 1756, 1759, 1, 0, 0, 0, 1757, 1759,
        5, 19, 0, 0, 1758, 1751, 1, 0, 0, 0, 1758, 1757, 1, 0, 0, 0, 1758, 1759, 1, 0, 0, 0, 1759, 239,
        1, 0, 0, 0, 1760, 1761, 7, 18, 0, 0, 1761, 1762, 3, 242, 121, 0, 1762, 241, 1, 0, 0, 0, 1763,
        1771, 3, 244, 122, 0, 1764, 1766, 5, 45, 0, 0, 1765, 1767, 5, 60, 0, 0, 1766, 1765, 1, 0, 0,
        0, 1766, 1767, 1, 0, 0, 0, 1767, 1768, 1, 0, 0, 0, 1768, 1770, 3, 244, 122, 0, 1769, 1764, 1,
        0, 0, 0, 1770, 1773, 1, 0, 0, 0, 1771, 1769, 1, 0, 0, 0, 1771, 1772, 1, 0, 0, 0, 1772, 243, 1,
        0, 0, 0, 1773, 1771, 1, 0, 0, 0, 1774, 1779, 3, 246, 123, 0, 1775, 1776, 7, 19, 0, 0, 1776, 1778,
        3, 246, 123, 0, 1777, 1775, 1, 0, 0, 0, 1778, 1781, 1, 0, 0, 0, 1779, 1777, 1, 0, 0, 0, 1779,
        1780, 1, 0, 0, 0, 1780, 245, 1, 0, 0, 0, 1781, 1779, 1, 0, 0, 0, 1782, 1784, 5, 168, 0, 0, 1783,
        1782, 1, 0, 0, 0, 1784, 1787, 1, 0, 0, 0, 1785, 1783, 1, 0, 0, 0, 1785, 1786, 1, 0, 0, 0, 1786,
        1788, 1, 0, 0, 0, 1787, 1785, 1, 0, 0, 0, 1788, 1789, 3, 248, 124, 0, 1789, 247, 1, 0, 0, 0, 1790,
        1791, 5, 180, 0, 0, 1791, 1792, 3, 242, 121, 0, 1792, 1793, 5, 267, 0, 0, 1793, 1798, 1, 0,
        0, 0, 1794, 1798, 5, 187, 0, 0, 1795, 1798, 3, 216, 108, 0, 1796, 1798, 3, 800, 400, 0, 1797,
        1790, 1, 0, 0, 0, 1797, 1794, 1, 0, 0, 0, 1797, 1795, 1, 0, 0, 0, 1797, 1796, 1, 0, 0, 0, 1798,
        249, 1, 0, 0, 0, 1799, 1800, 7, 18, 0, 0, 1800, 1805, 3, 800, 400, 0, 1801, 1802, 7, 19, 0, 0,
        1802, 1804, 3, 800, 400, 0, 1803, 1801, 1, 0, 0, 0, 1804, 1807, 1, 0, 0, 0, 1805, 1803, 1, 0,
        0, 0, 1805, 1806, 1, 0, 0, 0, 1806, 251, 1, 0, 0, 0, 1807, 1805, 1, 0, 0, 0, 1808, 1809, 7, 18,
        0, 0, 1809, 1810, 3, 800, 400, 0, 1810, 253, 1, 0, 0, 0, 1811, 1816, 3, 256, 128, 0, 1812, 1813,
        5, 217, 0, 0, 1813, 1815, 3, 256, 128, 0, 1814, 1812, 1, 0, 0, 0, 1815, 1818, 1, 0, 0, 0, 1816,
        1814, 1, 0, 0, 0, 1816, 1817, 1, 0, 0, 0, 1817, 255, 1, 0, 0, 0, 1818, 1816, 1, 0, 0, 0, 1819,
        1824, 3, 258, 129, 0, 1820, 1821, 5, 334, 0, 0, 1821, 1823, 3, 258, 129, 0, 1822, 1820, 1,
        0, 0, 0, 1823, 1826, 1, 0, 0, 0, 1824, 1822, 1, 0, 0, 0, 1824, 1825, 1, 0, 0, 0, 1825, 257, 1,
        0, 0, 0, 1826, 1824, 1, 0, 0, 0, 1827, 1832, 3, 260, 130, 0, 1828, 1829, 5, 36, 0, 0, 1829, 1831,
        3, 260, 130, 0, 1830, 1828, 1, 0, 0, 0, 1831, 1834, 1, 0, 0, 0, 1832, 1830, 1, 0, 0, 0, 1832,
        1833, 1, 0, 0, 0, 1833, 259, 1, 0, 0, 0, 1834, 1832, 1, 0, 0, 0, 1835, 1837, 5, 206, 0, 0, 1836,
        1835, 1, 0, 0, 0, 1837, 1840, 1, 0, 0, 0, 1838, 1836, 1, 0, 0, 0, 1838, 1839, 1, 0, 0, 0, 1839,
        1841, 1, 0, 0, 0, 1840, 1838, 1, 0, 0, 0, 1841, 1842, 3, 262, 131, 0, 1842, 261, 1, 0, 0, 0, 1843,
        1848, 3, 264, 132, 0, 1844, 1845, 7, 20, 0, 0, 1845, 1847, 3, 264, 132, 0, 1846, 1844, 1, 0,
        0, 0, 1847, 1850, 1, 0, 0, 0, 1848, 1846, 1, 0, 0, 0, 1848, 1849, 1, 0, 0, 0, 1849, 263, 1, 0,
        0, 0, 1850, 1848, 1, 0, 0, 0, 1851, 1853, 3, 270, 135, 0, 1852, 1854, 3, 266, 133, 0, 1853,
        1852, 1, 0, 0, 0, 1853, 1854, 1, 0, 0, 0, 1854, 265, 1, 0, 0, 0, 1855, 1863, 5, 247, 0, 0, 1856,
        1857, 5, 290, 0, 0, 1857, 1863, 5, 331, 0, 0, 1858, 1859, 5, 111, 0, 0, 1859, 1863, 5, 331,
        0, 0, 1860, 1863, 5, 69, 0, 0, 1861, 1863, 5, 146, 0, 0, 1862, 1855, 1, 0, 0, 0, 1862, 1856,
        1, 0, 0, 0, 1862, 1858, 1, 0, 0, 0, 1862, 1860, 1, 0, 0, 0, 1862, 1861, 1, 0, 0, 0, 1863, 1864,
        1, 0, 0, 0, 1864, 1889, 3, 270, 135, 0, 1865, 1867, 5, 162, 0, 0, 1866, 1868, 5, 206, 0, 0, 1867,
        1866, 1, 0, 0, 0, 1867, 1868, 1, 0, 0, 0, 1868, 1869, 1, 0, 0, 0, 1869, 1889, 5, 209, 0, 0, 1870,
        1872, 5, 162, 0, 0, 1871, 1873, 5, 206, 0, 0, 1872, 1871, 1, 0, 0, 0, 1872, 1873, 1, 0, 0, 0,
        1873, 1874, 1, 0, 0, 0, 1874, 1877, 7, 21, 0, 0, 1875, 1877, 5, 61, 0, 0, 1876, 1870, 1, 0, 0,
        0, 1876, 1875, 1, 0, 0, 0, 1877, 1878, 1, 0, 0, 0, 1878, 1889, 3, 362, 181, 0, 1879, 1881, 5,
        162, 0, 0, 1880, 1882, 5, 206, 0, 0, 1881, 1880, 1, 0, 0, 0, 1881, 1882, 1, 0, 0, 0, 1882, 1884,
        1, 0, 0, 0, 1883, 1885, 3, 268, 134, 0, 1884, 1883, 1, 0, 0, 0, 1884, 1885, 1, 0, 0, 0, 1885,
        1886, 1, 0, 0, 0, 1886, 1889, 5, 205, 0, 0, 1887, 1889, 3, 240, 120, 0, 1888, 1862, 1, 0, 0,
        0, 1888, 1865, 1, 0, 0, 0, 1888, 1876, 1, 0, 0, 0, 1888, 1879, 1, 0, 0, 0, 1888, 1887, 1, 0, 0,
        0, 1889, 267, 1, 0, 0, 0, 1890, 1891, 7, 22, 0, 0, 1891, 269, 1, 0, 0, 0, 1892, 1897, 3, 272,
        136, 0, 1893, 1894, 7, 23, 0, 0, 1894, 1896, 3, 272, 136, 0, 1895, 1893, 1, 0, 0, 0, 1896, 1899,
        1, 0, 0, 0, 1897, 1895, 1, 0, 0, 0, 1897, 1898, 1, 0, 0, 0, 1898, 271, 1, 0, 0, 0, 1899, 1897,
        1, 0, 0, 0, 1900, 1905, 3, 274, 137, 0, 1901, 1902, 7, 24, 0, 0, 1902, 1904, 3, 274, 137, 0,
        1903, 1901, 1, 0, 0, 0, 1904, 1907, 1, 0, 0, 0, 1905, 1903, 1, 0, 0, 0, 1905, 1906, 1, 0, 0, 0,
        1906, 273, 1, 0, 0, 0, 1907, 1905, 1, 0, 0, 0, 1908, 1913, 3, 276, 138, 0, 1909, 1910, 5, 228,
        0, 0, 1910, 1912, 3, 276, 138, 0, 1911, 1909, 1, 0, 0, 0, 1912, 1915, 1, 0, 0, 0, 1913, 1911,
        1, 0, 0, 0, 1913, 1914, 1, 0, 0, 0, 1914, 275, 1, 0, 0, 0, 1915, 1913, 1, 0, 0, 0, 1916, 1920,
        3, 278, 139, 0, 1917, 1918, 7, 25, 0, 0, 1918, 1920, 3, 278, 139, 0, 1919, 1916, 1, 0, 0, 0,
        1919, 1917, 1, 0, 0, 0, 1920, 277, 1, 0, 0, 0, 1921, 1925, 3, 290, 145, 0, 1922, 1924, 3, 280,
        140, 0, 1923, 1922, 1, 0, 0, 0, 1924, 1927, 1, 0, 0, 0, 1925, 1923, 1, 0, 0, 0, 1925, 1926, 1,
        0, 0, 0, 1926, 279, 1, 0, 0, 0, 1927, 1925, 1, 0, 0, 0, 1928, 1943, 3, 282, 141, 0, 1929, 1930,
        5, 170, 0, 0, 1930, 1931, 3, 254, 127, 0, 1931, 1932, 5, 241, 0, 0, 1932, 1943, 1, 0, 0, 0, 1933,
        1935, 5, 170, 0, 0, 1934, 1936, 3, 254, 127, 0, 1935, 1934, 1, 0, 0, 0, 1935, 1936, 1, 0, 0,
        0, 1936, 1937, 1, 0, 0, 0, 1937, 1939, 5, 96, 0, 0, 1938, 1940, 3, 254, 127, 0, 1939, 1938,
        1, 0, 0, 0, 1939, 1940, 1, 0, 0, 0, 1940, 1941, 1, 0, 0, 0, 1941, 1943, 5, 241, 0, 0, 1942, 1928,
        1, 0, 0, 0, 1942, 1929, 1, 0, 0, 0, 1942, 1933, 1, 0, 0, 0, 1943, 281, 1, 0, 0, 0, 1944, 1945,
        5, 95, 0, 0, 1945, 1946, 3, 344, 172, 0, 1946, 283, 1, 0, 0, 0, 1947, 1948, 5, 170, 0, 0, 1948,
        1949, 3, 254, 127, 0, 1949, 1950, 5, 241, 0, 0, 1950, 285, 1, 0, 0, 0, 1951, 1953, 3, 290, 145,
        0, 1952, 1954, 3, 282, 141, 0, 1953, 1952, 1, 0, 0, 0, 1954, 1955, 1, 0, 0, 0, 1955, 1953, 1,
        0, 0, 0, 1955, 1956, 1, 0, 0, 0, 1956, 287, 1, 0, 0, 0, 1957, 1958, 3, 290, 145, 0, 1958, 1959,
        3, 284, 142, 0, 1959, 289, 1, 0, 0, 0, 1960, 1984, 3, 292, 146, 0, 1961, 1984, 3, 346, 173,
        0, 1962, 1984, 3, 294, 147, 0, 1963, 1984, 3, 298, 149, 0, 1964, 1984, 3, 330, 165, 0, 1965,
        1984, 3, 332, 166, 0, 1966, 1984, 3, 334, 167, 0, 1967, 1984, 3, 336, 168, 0, 1968, 1984,
        3, 326, 163, 0, 1969, 1984, 3, 304, 152, 0, 1970, 1984, 3, 342, 171, 0, 1971, 1984, 3, 306,
        153, 0, 1972, 1984, 3, 308, 154, 0, 1973, 1984, 3, 310, 155, 0, 1974, 1984, 3, 312, 156, 0,
        1975, 1984, 3, 314, 157, 0, 1976, 1984, 3, 316, 158, 0, 1977, 1984, 3, 318, 159, 0, 1978,
        1984, 3, 320, 160, 0, 1979, 1984, 3, 322, 161, 0, 1980, 1984, 3, 324, 162, 0, 1981, 1984,
        3, 350, 175, 0, 1982, 1984, 3, 358, 179, 0, 1983, 1960, 1, 0, 0, 0, 1983, 1961, 1, 0, 0, 0, 1983,
        1962, 1, 0, 0, 0, 1983, 1963, 1, 0, 0, 0, 1983, 1964, 1, 0, 0, 0, 1983, 1965, 1, 0, 0, 0, 1983,
        1966, 1, 0, 0, 0, 1983, 1967, 1, 0, 0, 0, 1983, 1968, 1, 0, 0, 0, 1983, 1969, 1, 0, 0, 0, 1983,
        1970, 1, 0, 0, 0, 1983, 1971, 1, 0, 0, 0, 1983, 1972, 1, 0, 0, 0, 1983, 1973, 1, 0, 0, 0, 1983,
        1974, 1, 0, 0, 0, 1983, 1975, 1, 0, 0, 0, 1983, 1976, 1, 0, 0, 0, 1983, 1977, 1, 0, 0, 0, 1983,
        1978, 1, 0, 0, 0, 1983, 1979, 1, 0, 0, 0, 1983, 1980, 1, 0, 0, 0, 1983, 1981, 1, 0, 0, 0, 1983,
        1982, 1, 0, 0, 0, 1984, 291, 1, 0, 0, 0, 1985, 1995, 3, 338, 169, 0, 1986, 1995, 3, 782, 391,
        0, 1987, 1995, 3, 792, 396, 0, 1988, 1995, 5, 311, 0, 0, 1989, 1995, 5, 120, 0, 0, 1990, 1995,
        5, 149, 0, 0, 1991, 1995, 5, 150, 0, 0, 1992, 1995, 5, 193, 0, 0, 1993, 1995, 5, 209, 0, 0, 1994,
        1985, 1, 0, 0, 0, 1994, 1986, 1, 0, 0, 0, 1994, 1987, 1, 0, 0, 0, 1994, 1988, 1, 0, 0, 0, 1994,
        1989, 1, 0, 0, 0, 1994, 1990, 1, 0, 0, 0, 1994, 1991, 1, 0, 0, 0, 1994, 1992, 1, 0, 0, 0, 1994,
        1993, 1, 0, 0, 0, 1995, 293, 1, 0, 0, 0, 1996, 1998, 5, 56, 0, 0, 1997, 1999, 3, 296, 148, 0,
        1998, 1997, 1, 0, 0, 0, 1999, 2000, 1, 0, 0, 0, 2000, 1998, 1, 0, 0, 0, 2000, 2001, 1, 0, 0, 0,
        2001, 2004, 1, 0, 0, 0, 2002, 2003, 5, 108, 0, 0, 2003, 2005, 3, 254, 127, 0, 2004, 2002, 1,
        0, 0, 0, 2004, 2005, 1, 0, 0, 0, 2005, 2006, 1, 0, 0, 0, 2006, 2007, 5, 110, 0, 0, 2007, 295,
        1, 0, 0, 0, 2008, 2009, 5, 329, 0, 0, 2009, 2010, 3, 254, 127, 0, 2010, 2011, 5, 299, 0, 0, 2011,
        2012, 3, 254, 127, 0, 2012, 297, 1, 0, 0, 0, 2013, 2014, 5, 56, 0, 0, 2014, 2016, 3, 254, 127,
        0, 2015, 2017, 3, 300, 150, 0, 2016, 2015, 1, 0, 0, 0, 2017, 2018, 1, 0, 0, 0, 2018, 2016, 1,
        0, 0, 0, 2018, 2019, 1, 0, 0, 0, 2019, 2022, 1, 0, 0, 0, 2020, 2021, 5, 108, 0, 0, 2021, 2023,
        3, 254, 127, 0, 2022, 2020, 1, 0, 0, 0, 2022, 2023, 1, 0, 0, 0, 2023, 2024, 1, 0, 0, 0, 2024,
        2025, 5, 110, 0, 0, 2025, 299, 1, 0, 0, 0, 2026, 2027, 5, 329, 0, 0, 2027, 2032, 3, 302, 151,
        0, 2028, 2029, 5, 62, 0, 0, 2029, 2031, 3, 302, 151, 0, 2030, 2028, 1, 0, 0, 0, 2031, 2034,
        1, 0, 0, 0, 2032, 2030, 1, 0, 0, 0, 2032, 2033, 1, 0, 0, 0, 2033, 2035, 1, 0, 0, 0, 2034, 2032,
        1, 0, 0, 0, 2035, 2036, 5, 299, 0, 0, 2036, 2037, 3, 254, 127, 0, 2037, 301, 1, 0, 0, 0, 2038,
        2039, 7, 20, 0, 0, 2039, 2043, 3, 264, 132, 0, 2040, 2043, 3, 266, 133, 0, 2041, 2043, 3, 254,
        127, 0, 2042, 2038, 1, 0, 0, 0, 2042, 2040, 1, 0, 0, 0, 2042, 2041, 1, 0, 0, 0, 2043, 303, 1,
        0, 0, 0, 2044, 2045, 5, 170, 0, 0, 2045, 2046, 3, 358, 179, 0, 2046, 2047, 5, 146, 0, 0, 2047,
        2058, 3, 254, 127, 0, 2048, 2049, 5, 330, 0, 0, 2049, 2051, 3, 254, 127, 0, 2050, 2048, 1,
        0, 0, 0, 2050, 2051, 1, 0, 0, 0, 2051, 2052, 1, 0, 0, 0, 2052, 2053, 5, 45, 0, 0, 2053, 2059,
        3, 254, 127, 0, 2054, 2055, 5, 330, 0, 0, 2055, 2057, 3, 254, 127, 0, 2056, 2054, 1, 0, 0, 0,
        2056, 2057, 1, 0, 0, 0, 2057, 2059, 1, 0, 0, 0, 2058, 2050, 1, 0, 0, 0, 2058, 2056, 1, 0, 0, 0,
        2059, 2060, 1, 0, 0, 0, 2060, 2061, 5, 241, 0, 0, 2061, 305, 1, 0, 0, 0, 2062, 2066, 5, 170,
        0, 0, 2063, 2064, 3, 358, 179, 0, 2064, 2065, 5, 112, 0, 0, 2065, 2067, 1, 0, 0, 0, 2066, 2063,
        1, 0, 0, 0, 2066, 2067, 1, 0, 0, 0, 2067, 2068, 1, 0, 0, 0, 2068, 2071, 3, 202, 101, 0, 2069,
        2070, 5, 330, 0, 0, 2070, 2072, 3, 254, 127, 0, 2071, 2069, 1, 0, 0, 0, 2071, 2072, 1, 0, 0,
        0, 2072, 2073, 1, 0, 0, 0, 2073, 2074, 5, 45, 0, 0, 2074, 2075, 3, 254, 127, 0, 2075, 2076,
        5, 241, 0, 0, 2076, 307, 1, 0, 0, 0, 2077, 2078, 5, 245, 0, 0, 2078, 2079, 5, 180, 0, 0, 2079,
        2080, 3, 358, 179, 0, 2080, 2081, 5, 112, 0, 0, 2081, 2082, 3, 254, 127, 0, 2082, 2083, 5,
        62, 0, 0, 2083, 2084, 3, 358, 179, 0, 2084, 2085, 5, 146, 0, 0, 2085, 2086, 3, 254, 127, 0,
        2086, 2087, 5, 45, 0, 0, 2087, 2088, 3, 254, 127, 0, 2088, 2089, 5, 267, 0, 0, 2089, 309, 1,
        0, 0, 0, 2090, 2091, 5, 34, 0, 0, 2091, 2092, 5, 180, 0, 0, 2092, 2093, 3, 358, 179, 0, 2093,
        2094, 5, 112, 0, 0, 2094, 2095, 3, 254, 127, 0, 2095, 2096, 5, 62, 0, 0, 2096, 2097, 3, 254,
        127, 0, 2097, 2098, 5, 62, 0, 0, 2098, 2099, 3, 254, 127, 0, 2099, 2100, 5, 267, 0, 0, 2100,
        311, 1, 0, 0, 0, 2101, 2102, 7, 26, 0, 0, 2102, 2103, 5, 180, 0, 0, 2103, 2104, 3, 358, 179,
        0, 2104, 2105, 5, 146, 0, 0, 2105, 2108, 3, 254, 127, 0, 2106, 2107, 5, 330, 0, 0, 2107, 2109,
        3, 254, 127, 0, 2108, 2106, 1, 0, 0, 0, 2108, 2109, 1, 0, 0, 0, 2109, 2110, 1, 0, 0, 0, 2110,
        2111, 5, 267, 0, 0, 2111, 313, 1, 0, 0, 0, 2112, 2113, 5, 204, 0, 0, 2113, 2114, 5, 180, 0, 0,
        2114, 2117, 3, 254, 127, 0, 2115, 2116, 5, 62, 0, 0, 2116, 2118, 3, 268, 134, 0, 2117, 2115,
        1, 0, 0, 0, 2117, 2118, 1, 0, 0, 0, 2118, 2119, 1, 0, 0, 0, 2119, 2120, 5, 267, 0, 0, 2120, 315,
        1, 0, 0, 0, 2121, 2122, 5, 326, 0, 0, 2122, 2123, 5, 180, 0, 0, 2123, 2124, 3, 254, 127, 0, 2124,
        2125, 5, 62, 0, 0, 2125, 2126, 3, 254, 127, 0, 2126, 2127, 5, 62, 0, 0, 2127, 2128, 3, 372,
        186, 0, 2128, 2129, 5, 267, 0, 0, 2129, 317, 1, 0, 0, 0, 2130, 2131, 5, 310, 0, 0, 2131, 2139,
        5, 180, 0, 0, 2132, 2134, 7, 27, 0, 0, 2133, 2132, 1, 0, 0, 0, 2133, 2134, 1, 0, 0, 0, 2134, 2136,
        1, 0, 0, 0, 2135, 2137, 3, 254, 127, 0, 2136, 2135, 1, 0, 0, 0, 2136, 2137, 1, 0, 0, 0, 2137,
        2138, 1, 0, 0, 0, 2138, 2140, 5, 129, 0, 0, 2139, 2133, 1, 0, 0, 0, 2139, 2140, 1, 0, 0, 0, 2140,
        2141, 1, 0, 0, 0, 2141, 2142, 3, 254, 127, 0, 2142, 2143, 5, 267, 0, 0, 2143, 319, 1, 0, 0, 0,
        2144, 2145, 3, 202, 101, 0, 2145, 321, 1, 0, 0, 0, 2146, 2147, 3, 190, 95, 0, 2147, 323, 1,
        0, 0, 0, 2148, 2149, 5, 180, 0, 0, 2149, 2150, 3, 254, 127, 0, 2150, 2151, 5, 267, 0, 0, 2151,
        325, 1, 0, 0, 0, 2152, 2153, 3, 358, 179, 0, 2153, 2162, 5, 171, 0, 0, 2154, 2159, 3, 328, 164,
        0, 2155, 2156, 5, 62, 0, 0, 2156, 2158, 3, 328, 164, 0, 2157, 2155, 1, 0, 0, 0, 2158, 2161,
        1, 0, 0, 0, 2159, 2157, 1, 0, 0, 0, 2159, 2160, 1, 0, 0, 0, 2160, 2163, 1, 0, 0, 0, 2161, 2159,
        1, 0, 0, 0, 2162, 2154, 1, 0, 0, 0, 2162, 2163, 1, 0, 0, 0, 2163, 2164, 1, 0, 0, 0, 2164, 2165,
        5, 242, 0, 0, 2165, 327, 1, 0, 0, 0, 2166, 2167, 3, 344, 172, 0, 2167, 2168, 5, 60, 0, 0, 2168,
        2169, 3, 254, 127, 0, 2169, 2175, 1, 0, 0, 0, 2170, 2175, 3, 282, 141, 0, 2171, 2175, 3, 358,
        179, 0, 2172, 2173, 5, 95, 0, 0, 2173, 2175, 5, 301, 0, 0, 2174, 2166, 1, 0, 0, 0, 2174, 2170,
        1, 0, 0, 0, 2174, 2171, 1, 0, 0, 0, 2174, 2172, 1, 0, 0, 0, 2175, 329, 1, 0, 0, 0, 2176, 2177,
        5, 72, 0, 0, 2177, 2178, 5, 180, 0, 0, 2178, 2179, 5, 301, 0, 0, 2179, 2180, 5, 267, 0, 0, 2180,
        331, 1, 0, 0, 0, 2181, 2182, 5, 117, 0, 0, 2182, 2191, 5, 171, 0, 0, 2183, 2192, 3, 72, 36, 0,
        2184, 2186, 3, 134, 67, 0, 2185, 2184, 1, 0, 0, 0, 2185, 2186, 1, 0, 0, 0, 2186, 2187, 1, 0,
        0, 0, 2187, 2189, 3, 178, 89, 0, 2188, 2190, 3, 114, 57, 0, 2189, 2188, 1, 0, 0, 0, 2189, 2190,
        1, 0, 0, 0, 2190, 2192, 1, 0, 0, 0, 2191, 2183, 1, 0, 0, 0, 2191, 2185, 1, 0, 0, 0, 2192, 2193,
        1, 0, 0, 0, 2193, 2194, 5, 242, 0, 0, 2194, 333, 1, 0, 0, 0, 2195, 2196, 5, 72, 0, 0, 2196, 2205,
        5, 171, 0, 0, 2197, 2206, 3, 72, 36, 0, 2198, 2200, 3, 134, 67, 0, 2199, 2198, 1, 0, 0, 0, 2199,
        2200, 1, 0, 0, 0, 2200, 2201, 1, 0, 0, 0, 2201, 2203, 3, 178, 89, 0, 2202, 2204, 3, 114, 57,
        0, 2203, 2202, 1, 0, 0, 0, 2203, 2204, 1, 0, 0, 0, 2204, 2206, 1, 0, 0, 0, 2205, 2197, 1, 0, 0,
        0, 2205, 2199, 1, 0, 0, 0, 2206, 2207, 1, 0, 0, 0, 2207, 2208, 5, 242, 0, 0, 2208, 335, 1, 0,
        0, 0, 2209, 2210, 5, 59, 0, 0, 2210, 2211, 5, 171, 0, 0, 2211, 2212, 3, 72, 36, 0, 2212, 2213,
        5, 242, 0, 0, 2213, 337, 1, 0, 0, 0, 2214, 2216, 5, 186, 0, 0, 2215, 2214, 1, 0, 0, 0, 2215, 2216,
        1, 0, 0, 0, 2216, 2217, 1, 0, 0, 0, 2217, 2218, 7, 28, 0, 0, 2218, 339, 1, 0, 0, 0, 2219, 2221,
        5, 186, 0, 0, 2220, 2219, 1, 0, 0, 0, 2220, 2221, 1, 0, 0, 0, 2221, 2222, 1, 0, 0, 0, 2222, 2223,
        5, 19, 0, 0, 2223, 341, 1, 0, 0, 0, 2224, 2233, 5, 170, 0, 0, 2225, 2230, 3, 254, 127, 0, 2226,
        2227, 5, 62, 0, 0, 2227, 2229, 3, 254, 127, 0, 2228, 2226, 1, 0, 0, 0, 2229, 2232, 1, 0, 0, 0,
        2230, 2228, 1, 0, 0, 0, 2230, 2231, 1, 0, 0, 0, 2231, 2234, 1, 0, 0, 0, 2232, 2230, 1, 0, 0, 0,
        2233, 2225, 1, 0, 0, 0, 2233, 2234, 1, 0, 0, 0, 2234, 2235, 1, 0, 0, 0, 2235, 2236, 5, 241, 0,
        0, 2236, 343, 1, 0, 0, 0, 2237, 2238, 3, 800, 400, 0, 2238, 345, 1, 0, 0, 0, 2239, 2240, 5, 92,
        0, 0, 2240, 2241, 3, 348, 174, 0, 2241, 347, 1, 0, 0, 0, 2242, 2247, 3, 800, 400, 0, 2243, 2247,
        5, 19, 0, 0, 2244, 2247, 5, 21, 0, 0, 2245, 2247, 5, 339, 0, 0, 2246, 2242, 1, 0, 0, 0, 2246,
        2243, 1, 0, 0, 0, 2246, 2244, 1, 0, 0, 0, 2246, 2245, 1, 0, 0, 0, 2247, 349, 1, 0, 0, 0, 2248,
        2249, 3, 354, 177, 0, 2249, 2251, 5, 180, 0, 0, 2250, 2252, 7, 3, 0, 0, 2251, 2250, 1, 0, 0,
        0, 2251, 2252, 1, 0, 0, 0, 2252, 2261, 1, 0, 0, 0, 2253, 2258, 3, 352, 176, 0, 2254, 2255, 5,
        62, 0, 0, 2255, 2257, 3, 352, 176, 0, 2256, 2254, 1, 0, 0, 0, 2257, 2260, 1, 0, 0, 0, 2258, 2256,
        1, 0, 0, 0, 2258, 2259, 1, 0, 0, 0, 2259, 2262, 1, 0, 0, 0, 2260, 2258, 1, 0, 0, 0, 2261, 2253,
        1, 0, 0, 0, 2261, 2262, 1, 0, 0, 0, 2262, 2263, 1, 0, 0, 0, 2263, 2264, 5, 267, 0, 0, 2264, 351,
        1, 0, 0, 0, 2265, 2266, 3, 254, 127, 0, 2266, 353, 1, 0, 0, 0, 2267, 2268, 3, 356, 178, 0, 2268,
        2269, 3, 800, 400, 0, 2269, 355, 1, 0, 0, 0, 2270, 2271, 3, 800, 400, 0, 2271, 2272, 5, 95,
        0, 0, 2272, 2274, 1, 0, 0, 0, 2273, 2270, 1, 0, 0, 0, 2274, 2277, 1, 0, 0, 0, 2275, 2273, 1, 0,
        0, 0, 2275, 2276, 1, 0, 0, 0, 2276, 357, 1, 0, 0, 0, 2277, 2275, 1, 0, 0, 0, 2278, 2279, 3, 794,
        397, 0, 2279, 359, 1, 0, 0, 0, 2280, 2285, 3, 800, 400, 0, 2281, 2282, 5, 62, 0, 0, 2282, 2284,
        3, 800, 400, 0, 2283, 2281, 1, 0, 0, 0, 2284, 2287, 1, 0, 0, 0, 2285, 2283, 1, 0, 0, 0, 2285,
        2286, 1, 0, 0, 0, 2286, 361, 1, 0, 0, 0, 2287, 2285, 1, 0, 0, 0, 2288, 2293, 3, 364, 182, 0, 2289,
        2290, 5, 45, 0, 0, 2290, 2292, 3, 364, 182, 0, 2291, 2289, 1, 0, 0, 0, 2292, 2295, 1, 0, 0, 0,
        2293, 2291, 1, 0, 0, 0, 2293, 2294, 1, 0, 0, 0, 2294, 363, 1, 0, 0, 0, 2295, 2293, 1, 0, 0, 0,
        2296, 2298, 3, 366, 183, 0, 2297, 2299, 3, 368, 184, 0, 2298, 2297, 1, 0, 0, 0, 2298, 2299,
        1, 0, 0, 0, 2299, 2303, 1, 0, 0, 0, 2300, 2302, 3, 370, 185, 0, 2301, 2300, 1, 0, 0, 0, 2302,
        2305, 1, 0, 0, 0, 2303, 2301, 1, 0, 0, 0, 2303, 2304, 1, 0, 0, 0, 2304, 365, 1, 0, 0, 0, 2305,
        2303, 1, 0, 0, 0, 2306, 2395, 5, 207, 0, 0, 2307, 2395, 5, 209, 0, 0, 2308, 2395, 5, 47, 0, 0,
        2309, 2395, 5, 48, 0, 0, 2310, 2395, 5, 325, 0, 0, 2311, 2395, 5, 293, 0, 0, 2312, 2395, 5,
        152, 0, 0, 2313, 2315, 5, 286, 0, 0, 2314, 2313, 1, 0, 0, 0, 2314, 2315, 1, 0, 0, 0, 2315, 2316,
        1, 0, 0, 0, 2316, 2395, 5, 157, 0, 0, 2317, 2395, 5, 158, 0, 0, 2318, 2395, 5, 153, 0, 0, 2319,
        2395, 5, 124, 0, 0, 2320, 2395, 5, 125, 0, 0, 2321, 2395, 5, 79, 0, 0, 2322, 2323, 5, 178, 0,
        0, 2323, 2395, 7, 29, 0, 0, 2324, 2325, 5, 337, 0, 0, 2325, 2395, 7, 29, 0, 0, 2326, 2327, 5,
        300, 0, 0, 2327, 2331, 7, 30, 0, 0, 2328, 2332, 5, 303, 0, 0, 2329, 2330, 5, 300, 0, 0, 2330,
        2332, 5, 336, 0, 0, 2331, 2328, 1, 0, 0, 0, 2331, 2329, 1, 0, 0, 0, 2332, 2395, 1, 0, 0, 0, 2333,
        2334, 5, 302, 0, 0, 2334, 2338, 7, 30, 0, 0, 2335, 2339, 5, 303, 0, 0, 2336, 2337, 5, 300, 0,
        0, 2337, 2339, 5, 336, 0, 0, 2338, 2335, 1, 0, 0, 0, 2338, 2336, 1, 0, 0, 0, 2339, 2395, 1, 0,
        0, 0, 2340, 2395, 5, 102, 0, 0, 2341, 2395, 5, 226, 0, 0, 2342, 2395, 5, 200, 0, 0, 2343, 2344,
        5, 326, 0, 0, 2344, 2345, 5, 180, 0, 0, 2345, 2346, 3, 340, 170, 0, 2346, 2347, 5, 62, 0, 0,
        2347, 2348, 3, 372, 186, 0, 2348, 2349, 5, 267, 0, 0, 2349, 2395, 1, 0, 0, 0, 2350, 2355, 5,
        326, 0, 0, 2351, 2352, 5, 181, 0, 0, 2352, 2353, 3, 372, 186, 0, 2353, 2354, 5, 139, 0, 0, 2354,
        2356, 1, 0, 0, 0, 2355, 2351, 1, 0, 0, 0, 2355, 2356, 1, 0, 0, 0, 2356, 2361, 1, 0, 0, 0, 2357,
        2358, 5, 180, 0, 0, 2358, 2359, 3, 340, 170, 0, 2359, 2360, 5, 267, 0, 0, 2360, 2362, 1, 0,
        0, 0, 2361, 2357, 1, 0, 0, 0, 2361, 2362, 1, 0, 0, 0, 2362, 2395, 1, 0, 0, 0, 2363, 2395, 5, 327,
        0, 0, 2364, 2395, 5, 249, 0, 0, 2365, 2395, 5, 104, 0, 0, 2366, 2395, 5, 183, 0, 0, 2367, 2368,
        7, 31, 0, 0, 2368, 2369, 5, 181, 0, 0, 2369, 2370, 3, 362, 181, 0, 2370, 2371, 5, 139, 0, 0,
        2371, 2395, 1, 0, 0, 0, 2372, 2395, 5, 221, 0, 0, 2373, 2395, 5, 222, 0, 0, 2374, 2375, 5, 236,
        0, 0, 2375, 2395, 5, 324, 0, 0, 2376, 2392, 5, 37, 0, 0, 2377, 2393, 5, 200, 0, 0, 2378, 2393,
        5, 327, 0, 0, 2379, 2393, 5, 249, 0, 0, 2380, 2393, 5, 104, 0, 0, 2381, 2393, 5, 183, 0, 0, 2382,
        2383, 5, 236, 0, 0, 2383, 2393, 5, 324, 0, 0, 2384, 2386, 5, 324, 0, 0, 2385, 2384, 1, 0, 0,
        0, 2385, 2386, 1, 0, 0, 0, 2386, 2387, 1, 0, 0, 0, 2387, 2388, 5, 181, 0, 0, 2388, 2389, 3, 362,
        181, 0, 2389, 2390, 5, 139, 0, 0, 2390, 2393, 1, 0, 0, 0, 2391, 2393, 5, 324, 0, 0, 2392, 2377,
        1, 0, 0, 0, 2392, 2378, 1, 0, 0, 0, 2392, 2379, 1, 0, 0, 0, 2392, 2380, 1, 0, 0, 0, 2392, 2381,
        1, 0, 0, 0, 2392, 2382, 1, 0, 0, 0, 2392, 2385, 1, 0, 0, 0, 2392, 2391, 1, 0, 0, 0, 2392, 2393,
        1, 0, 0, 0, 2393, 2395, 1, 0, 0, 0, 2394, 2306, 1, 0, 0, 0, 2394, 2307, 1, 0, 0, 0, 2394, 2308,
        1, 0, 0, 0, 2394, 2309, 1, 0, 0, 0, 2394, 2310, 1, 0, 0, 0, 2394, 2311, 1, 0, 0, 0, 2394, 2312,
        1, 0, 0, 0, 2394, 2314, 1, 0, 0, 0, 2394, 2317, 1, 0, 0, 0, 2394, 2318, 1, 0, 0, 0, 2394, 2319,
        1, 0, 0, 0, 2394, 2320, 1, 0, 0, 0, 2394, 2321, 1, 0, 0, 0, 2394, 2322, 1, 0, 0, 0, 2394, 2324,
        1, 0, 0, 0, 2394, 2326, 1, 0, 0, 0, 2394, 2333, 1, 0, 0, 0, 2394, 2340, 1, 0, 0, 0, 2394, 2341,
        1, 0, 0, 0, 2394, 2342, 1, 0, 0, 0, 2394, 2343, 1, 0, 0, 0, 2394, 2350, 1, 0, 0, 0, 2394, 2363,
        1, 0, 0, 0, 2394, 2364, 1, 0, 0, 0, 2394, 2365, 1, 0, 0, 0, 2394, 2366, 1, 0, 0, 0, 2394, 2367,
        1, 0, 0, 0, 2394, 2372, 1, 0, 0, 0, 2394, 2373, 1, 0, 0, 0, 2394, 2374, 1, 0, 0, 0, 2394, 2376,
        1, 0, 0, 0, 2395, 367, 1, 0, 0, 0, 2396, 2397, 5, 206, 0, 0, 2397, 2400, 5, 209, 0, 0, 2398, 2400,
        5, 168, 0, 0, 2399, 2396, 1, 0, 0, 0, 2399, 2398, 1, 0, 0, 0, 2400, 369, 1, 0, 0, 0, 2401, 2403,
        7, 31, 0, 0, 2402, 2404, 3, 368, 184, 0, 2403, 2402, 1, 0, 0, 0, 2403, 2404, 1, 0, 0, 0, 2404,
        371, 1, 0, 0, 0, 2405, 2422, 5, 152, 0, 0, 2406, 2408, 5, 286, 0, 0, 2407, 2406, 1, 0, 0, 0, 2407,
        2408, 1, 0, 0, 0, 2408, 2409, 1, 0, 0, 0, 2409, 2422, 5, 157, 0, 0, 2410, 2422, 5, 158, 0, 0,
        2411, 2422, 5, 159, 0, 0, 2412, 2422, 5, 160, 0, 0, 2413, 2422, 5, 161, 0, 0, 2414, 2422, 5,
        153, 0, 0, 2415, 2422, 5, 154, 0, 0, 2416, 2422, 5, 155, 0, 0, 2417, 2422, 5, 156, 0, 0, 2418,
        2422, 5, 124, 0, 0, 2419, 2422, 5, 125, 0, 0, 2420, 2422, 5, 126, 0, 0, 2421, 2405, 1, 0, 0,
        0, 2421, 2407, 1, 0, 0, 0, 2421, 2410, 1, 0, 0, 0, 2421, 2411, 1, 0, 0, 0, 2421, 2412, 1, 0, 0,
        0, 2421, 2413, 1, 0, 0, 0, 2421, 2414, 1, 0, 0, 0, 2421, 2415, 1, 0, 0, 0, 2421, 2416, 1, 0, 0,
        0, 2421, 2417, 1, 0, 0, 0, 2421, 2418, 1, 0, 0, 0, 2421, 2419, 1, 0, 0, 0, 2421, 2420, 1, 0, 0,
        0, 2422, 2424, 1, 0, 0, 0, 2423, 2425, 3, 368, 184, 0, 2424, 2423, 1, 0, 0, 0, 2424, 2425, 1,
        0, 0, 0, 2425, 373, 1, 0, 0, 0, 2426, 2428, 3, 88, 44, 0, 2427, 2426, 1, 0, 0, 0, 2427, 2428,
        1, 0, 0, 0, 2428, 2442, 1, 0, 0, 0, 2429, 2443, 3, 376, 188, 0, 2430, 2443, 3, 380, 190, 0, 2431,
        2443, 3, 378, 189, 0, 2432, 2443, 3, 524, 262, 0, 2433, 2443, 3, 528, 264, 0, 2434, 2443,
        3, 530, 265, 0, 2435, 2443, 3, 526, 263, 0, 2436, 2443, 3, 732, 366, 0, 2437, 2443, 3, 734,
        367, 0, 2438, 2443, 3, 538, 269, 0, 2439, 2443, 3, 548, 274, 0, 2440, 2443, 3, 382, 191, 0,
        2441, 2443, 3, 396, 198, 0, 2442, 2429, 1, 0, 0, 0, 2442, 2430, 1, 0, 0, 0, 2442, 2431, 1, 0,
        0, 0, 2442, 2432, 1, 0, 0, 0, 2442, 2433, 1, 0, 0, 0, 2442, 2434, 1, 0, 0, 0, 2442, 2435, 1, 0,
        0, 0, 2442, 2436, 1, 0, 0, 0, 2442, 2437, 1, 0, 0, 0, 2442, 2438, 1, 0, 0, 0, 2442, 2439, 1, 0,
        0, 0, 2442, 2440, 1, 0, 0, 0, 2442, 2441, 1, 0, 0, 0, 2443, 375, 1, 0, 0, 0, 2444, 2447, 5, 73,
        0, 0, 2445, 2446, 5, 217, 0, 0, 2446, 2448, 5, 253, 0, 0, 2447, 2445, 1, 0, 0, 0, 2447, 2448,
        1, 0, 0, 0, 2448, 2456, 1, 0, 0, 0, 2449, 2457, 3, 748, 374, 0, 2450, 2457, 3, 698, 349, 0, 2451,
        2457, 3, 442, 221, 0, 2452, 2457, 3, 700, 350, 0, 2453, 2457, 3, 448, 224, 0, 2454, 2457,
        3, 554, 277, 0, 2455, 2457, 3, 566, 283, 0, 2456, 2449, 1, 0, 0, 0, 2456, 2450, 1, 0, 0, 0, 2456,
        2451, 1, 0, 0, 0, 2456, 2452, 1, 0, 0, 0, 2456, 2453, 1, 0, 0, 0, 2456, 2454, 1, 0, 0, 0, 2456,
        2455, 1, 0, 0, 0, 2457, 377, 1, 0, 0, 0, 2458, 2465, 5, 35, 0, 0, 2459, 2466, 3, 752, 376, 0,
        2460, 2466, 3, 572, 286, 0, 2461, 2466, 3, 470, 235, 0, 2462, 2466, 3, 724, 362, 0, 2463,
        2466, 3, 574, 287, 0, 2464, 2466, 3, 540, 270, 0, 2465, 2459, 1, 0, 0, 0, 2465, 2460, 1, 0,
        0, 0, 2465, 2461, 1, 0, 0, 0, 2465, 2462, 1, 0, 0, 0, 2465, 2463, 1, 0, 0, 0, 2465, 2464, 1, 0,
        0, 0, 2466, 379, 1, 0, 0, 0, 2467, 2475, 5, 99, 0, 0, 2468, 2476, 3, 750, 375, 0, 2469, 2476,
        3, 446, 223, 0, 2470, 2476, 3, 720, 360, 0, 2471, 2476, 3, 464, 232, 0, 2472, 2476, 3, 556,
        278, 0, 2473, 2476, 3, 544, 272, 0, 2474, 2476, 3, 568, 284, 0, 2475, 2468, 1, 0, 0, 0, 2475,
        2469, 1, 0, 0, 0, 2475, 2470, 1, 0, 0, 0, 2475, 2471, 1, 0, 0, 0, 2475, 2472, 1, 0, 0, 0, 2475,
        2473, 1, 0, 0, 0, 2475, 2474, 1, 0, 0, 0, 2476, 381, 1, 0, 0, 0, 2477, 2494, 5, 285, 0, 0, 2478,
        2495, 3, 764, 382, 0, 2479, 2495, 3, 408, 204, 0, 2480, 2495, 3, 596, 298, 0, 2481, 2495,
        3, 740, 370, 0, 2482, 2495, 3, 418, 209, 0, 2483, 2495, 3, 402, 201, 0, 2484, 2495, 3, 600,
        300, 0, 2485, 2495, 3, 416, 208, 0, 2486, 2495, 3, 602, 301, 0, 2487, 2495, 3, 560, 280, 0,
        2488, 2495, 3, 546, 273, 0, 2489, 2495, 3, 430, 215, 0, 2490, 2495, 3, 598, 299, 0, 2491,
        2495, 3, 426, 213, 0, 2492, 2495, 3, 604, 302, 0, 2493, 2495, 3, 594, 297, 0, 2494, 2478,
        1, 0, 0, 0, 2494, 2479, 1, 0, 0, 0, 2494, 2480, 1, 0, 0, 0, 2494, 2481, 1, 0, 0, 0, 2494, 2482,
        1, 0, 0, 0, 2494, 2483, 1, 0, 0, 0, 2494, 2484, 1, 0, 0, 0, 2494, 2485, 1, 0, 0, 0, 2494, 2486,
        1, 0, 0, 0, 2494, 2487, 1, 0, 0, 0, 2494, 2488, 1, 0, 0, 0, 2494, 2489, 1, 0, 0, 0, 2494, 2490,
        1, 0, 0, 0, 2494, 2491, 1, 0, 0, 0, 2494, 2492, 1, 0, 0, 0, 2494, 2493, 1, 0, 0, 0, 2495, 383,
        1, 0, 0, 0, 2496, 2498, 3, 392, 196, 0, 2497, 2499, 3, 94, 47, 0, 2498, 2497, 1, 0, 0, 0, 2498,
        2499, 1, 0, 0, 0, 2499, 2502, 1, 0, 0, 0, 2500, 2502, 3, 114, 57, 0, 2501, 2496, 1, 0, 0, 0, 2501,
        2500, 1, 0, 0, 0, 2502, 385, 1, 0, 0, 0, 2503, 2506, 3, 358, 179, 0, 2504, 2505, 5, 39, 0, 0,
        2505, 2507, 3, 358, 179, 0, 2506, 2504, 1, 0, 0, 0, 2506, 2507, 1, 0, 0, 0, 2507, 387, 1, 0,
        0, 0, 2508, 2509, 7, 6, 0, 0, 2509, 2510, 3, 340, 170, 0, 2510, 389, 1, 0, 0, 0, 2511, 2512,
        5, 175, 0, 0, 2512, 2513, 3, 340, 170, 0, 2513, 391, 1, 0, 0, 0, 2514, 2524, 5, 335, 0, 0, 2515,
        2525, 5, 301, 0, 0, 2516, 2521, 3, 386, 193, 0, 2517, 2518, 5, 62, 0, 0, 2518, 2520, 3, 386,
        193, 0, 2519, 2517, 1, 0, 0, 0, 2520, 2523, 1, 0, 0, 0, 2521, 2519, 1, 0, 0, 0, 2521, 2522, 1,
        0, 0, 0, 2522, 2525, 1, 0, 0, 0, 2523, 2521, 1, 0, 0, 0, 2524, 2515, 1, 0, 0, 0, 2524, 2516, 1,
        0, 0, 0, 2525, 2527, 1, 0, 0, 0, 2526, 2528, 3, 108, 54, 0, 2527, 2526, 1, 0, 0, 0, 2527, 2528,
        1, 0, 0, 0, 2528, 2530, 1, 0, 0, 0, 2529, 2531, 3, 388, 194, 0, 2530, 2529, 1, 0, 0, 0, 2530,
        2531, 1, 0, 0, 0, 2531, 2533, 1, 0, 0, 0, 2532, 2534, 3, 390, 195, 0, 2533, 2532, 1, 0, 0, 0,
        2533, 2534, 1, 0, 0, 0, 2534, 2536, 1, 0, 0, 0, 2535, 2537, 3, 114, 57, 0, 2536, 2535, 1, 0,
        0, 0, 2536, 2537, 1, 0, 0, 0, 2537, 393, 1, 0, 0, 0, 2538, 2539, 5, 215, 0, 0, 2539, 2540, 3,
        790, 395, 0, 2540, 395, 1, 0, 0, 0, 2541, 2542, 5, 297, 0, 0, 2542, 2543, 3, 428, 214, 0, 2543,
        397, 1, 0, 0, 0, 2544, 2547, 3, 396, 198, 0, 2545, 2547, 3, 400, 200, 0, 2546, 2544, 1, 0, 0,
        0, 2546, 2545, 1, 0, 0, 0, 2547, 399, 1, 0, 0, 0, 2548, 2555, 5, 285, 0, 0, 2549, 2556, 3, 402,
        201, 0, 2550, 2556, 3, 408, 204, 0, 2551, 2556, 3, 418, 209, 0, 2552, 2556, 3, 416, 208, 0,
        2553, 2556, 3, 430, 215, 0, 2554, 2556, 3, 426, 213, 0, 2555, 2549, 1, 0, 0, 0, 2555, 2550,
        1, 0, 0, 0, 2555, 2551, 1, 0, 0, 0, 2555, 2552, 1, 0, 0, 0, 2555, 2553, 1, 0, 0, 0, 2555, 2554,
        1, 0, 0, 0, 2556, 401, 1, 0, 0, 0, 2557, 2559, 3, 404, 202, 0, 2558, 2557, 1, 0, 0, 0, 2558, 2559,
        1, 0, 0, 0, 2559, 2560, 1, 0, 0, 0, 2560, 2561, 3, 406, 203, 0, 2561, 403, 1, 0, 0, 0, 2562, 2563,
        7, 32, 0, 0, 2563, 405, 1, 0, 0, 0, 2564, 2566, 3, 654, 327, 0, 2565, 2567, 3, 384, 192, 0, 2566,
        2565, 1, 0, 0, 0, 2566, 2567, 1, 0, 0, 0, 2567, 2569, 1, 0, 0, 0, 2568, 2570, 3, 398, 199, 0,
        2569, 2568, 1, 0, 0, 0, 2569, 2570, 1, 0, 0, 0, 2570, 407, 1, 0, 0, 0, 2571, 2573, 5, 33, 0, 0,
        2572, 2571, 1, 0, 0, 0, 2572, 2573, 1, 0, 0, 0, 2573, 2574, 1, 0, 0, 0, 2574, 2601, 3, 414, 207,
        0, 2575, 2577, 3, 410, 205, 0, 2576, 2575, 1, 0, 0, 0, 2576, 2577, 1, 0, 0, 0, 2577, 2578, 1,
        0, 0, 0, 2578, 2579, 3, 412, 206, 0, 2579, 2580, 3, 414, 207, 0, 2580, 2601, 1, 0, 0, 0, 2581,
        2583, 3, 410, 205, 0, 2582, 2581, 1, 0, 0, 0, 2582, 2583, 1, 0, 0, 0, 2583, 2584, 1, 0, 0, 0,
        2584, 2585, 5, 164, 0, 0, 2585, 2601, 3, 414, 207, 0, 2586, 2588, 3, 410, 205, 0, 2587, 2586,
        1, 0, 0, 0, 2587, 2588, 1, 0, 0, 0, 2588, 2589, 1, 0, 0, 0, 2589, 2590, 5, 236, 0, 0, 2590, 2591,
        5, 312, 0, 0, 2591, 2601, 3, 414, 207, 0, 2592, 2594, 3, 410, 205, 0, 2593, 2592, 1, 0, 0, 0,
        2593, 2594, 1, 0, 0, 0, 2594, 2596, 1, 0, 0, 0, 2595, 2597, 5, 236, 0, 0, 2596, 2595, 1, 0, 0,
        0, 2596, 2597, 1, 0, 0, 0, 2597, 2598, 1, 0, 0, 0, 2598, 2599, 7, 33, 0, 0, 2599, 2601, 3, 414,
        207, 0, 2600, 2572, 1, 0, 0, 0, 2600, 2576, 1, 0, 0, 0, 2600, 2582, 1, 0, 0, 0, 2600, 2587, 1,
        0, 0, 0, 2600, 2593, 1, 0, 0, 0, 2601, 409, 1, 0, 0, 0, 2602, 2605, 5, 200, 0, 0, 2603, 2605,
        7, 34, 0, 0, 2604, 2602, 1, 0, 0, 0, 2604, 2603, 1, 0, 0, 0, 2605, 411, 1, 0, 0, 0, 2606, 2613,
        5, 116, 0, 0, 2607, 2613, 5, 115, 0, 0, 2608, 2609, 5, 236, 0, 0, 2609, 2613, 5, 116, 0, 0, 2610,
        2611, 5, 236, 0, 0, 2611, 2613, 5, 115, 0, 0, 2612, 2606, 1, 0, 0, 0, 2612, 2607, 1, 0, 0, 0,
        2612, 2608, 1, 0, 0, 0, 2612, 2610, 1, 0, 0, 0, 2613, 413, 1, 0, 0, 0, 2614, 2616, 3, 656, 328,
        0, 2615, 2617, 3, 384, 192, 0, 2616, 2615, 1, 0, 0, 0, 2616, 2617, 1, 0, 0, 0, 2617, 2619, 1,
        0, 0, 0, 2618, 2620, 3, 398, 199, 0, 2619, 2618, 1, 0, 0, 0, 2619, 2620, 1, 0, 0, 0, 2620, 415,
        1, 0, 0, 0, 2621, 2623, 7, 35, 0, 0, 2622, 2624, 3, 422, 211, 0, 2623, 2622, 1, 0, 0, 0, 2623,
        2624, 1, 0, 0, 0, 2624, 2626, 1, 0, 0, 0, 2625, 2627, 3, 384, 192, 0, 2626, 2625, 1, 0, 0, 0,
        2626, 2627, 1, 0, 0, 0, 2627, 2629, 1, 0, 0, 0, 2628, 2630, 3, 398, 199, 0, 2629, 2628, 1, 0,
        0, 0, 2629, 2630, 1, 0, 0, 0, 2630, 417, 1, 0, 0, 0, 2631, 2633, 3, 424, 212, 0, 2632, 2631,
        1, 0, 0, 0, 2632, 2633, 1, 0, 0, 0, 2633, 2634, 1, 0, 0, 0, 2634, 2636, 3, 420, 210, 0, 2635,
        2637, 3, 422, 211, 0, 2636, 2635, 1, 0, 0, 0, 2636, 2637, 1, 0, 0, 0, 2637, 2639, 1, 0, 0, 0,
        2638, 2640, 3, 384, 192, 0, 2639, 2638, 1, 0, 0, 0, 2639, 2640, 1, 0, 0, 0, 2640, 2642, 1, 0,
        0, 0, 2641, 2643, 3, 398, 199, 0, 2642, 2641, 1, 0, 0, 0, 2642, 2643, 1, 0, 0, 0, 2643, 419,
        1, 0, 0, 0, 2644, 2645, 7, 36, 0, 0, 2645, 421, 1, 0, 0, 0, 2646, 2653, 5, 113, 0, 0, 2647, 2651,
        5, 53, 0, 0, 2648, 2649, 5, 75, 0, 0, 2649, 2652, 5, 321, 0, 0, 2650, 2652, 3, 800, 400, 0, 2651,
        2648, 1, 0, 0, 0, 2651, 2650, 1, 0, 0, 0, 2652, 2654, 1, 0, 0, 0, 2653, 2647, 1, 0, 0, 0, 2653,
        2654, 1, 0, 0, 0, 2654, 423, 1, 0, 0, 0, 2655, 2661, 5, 33, 0, 0, 2656, 2657, 5, 52, 0, 0, 2657,
        2661, 5, 146, 0, 0, 2658, 2659, 5, 321, 0, 0, 2659, 2661, 5, 84, 0, 0, 2660, 2655, 1, 0, 0, 0,
        2660, 2656, 1, 0, 0, 0, 2660, 2658, 1, 0, 0, 0, 2661, 425, 1, 0, 0, 0, 2662, 2663, 3, 658, 329,
        0, 2663, 2664, 3, 434, 217, 0, 2664, 427, 1, 0, 0, 0, 2665, 2666, 3, 658, 329, 0, 2666, 2668,
        3, 436, 218, 0, 2667, 2669, 3, 384, 192, 0, 2668, 2667, 1, 0, 0, 0, 2668, 2669, 1, 0, 0, 0, 2669,
        2671, 1, 0, 0, 0, 2670, 2672, 3, 398, 199, 0, 2671, 2670, 1, 0, 0, 0, 2671, 2672, 1, 0, 0, 0,
        2672, 429, 1, 0, 0, 0, 2673, 2674, 3, 432, 216, 0, 2674, 2675, 3, 434, 217, 0, 2675, 431, 1,
        0, 0, 0, 2676, 2677, 7, 37, 0, 0, 2677, 433, 1, 0, 0, 0, 2678, 2680, 3, 384, 192, 0, 2679, 2678,
        1, 0, 0, 0, 2679, 2680, 1, 0, 0, 0, 2680, 2686, 1, 0, 0, 0, 2681, 2683, 3, 436, 218, 0, 2682,
        2684, 3, 384, 192, 0, 2683, 2682, 1, 0, 0, 0, 2683, 2684, 1, 0, 0, 0, 2684, 2686, 1, 0, 0, 0,
        2685, 2679, 1, 0, 0, 0, 2685, 2681, 1, 0, 0, 0, 2686, 2688, 1, 0, 0, 0, 2687, 2689, 3, 398, 199,
        0, 2688, 2687, 1, 0, 0, 0, 2688, 2689, 1, 0, 0, 0, 2689, 435, 1, 0, 0, 0, 2690, 2693, 3, 780,
        390, 0, 2691, 2693, 3, 254, 127, 0, 2692, 2690, 1, 0, 0, 0, 2692, 2691, 1, 0, 0, 0, 2693, 437,
        1, 0, 0, 0, 2694, 2695, 5, 180, 0, 0, 2695, 2696, 3, 358, 179, 0, 2696, 2697, 3, 220, 110, 0,
        2697, 2698, 5, 267, 0, 0, 2698, 439, 1, 0, 0, 0, 2699, 2700, 5, 180, 0, 0, 2700, 2702, 5, 267,
        0, 0, 2701, 2703, 3, 232, 116, 0, 2702, 2701, 1, 0, 0, 0, 2702, 2703, 1, 0, 0, 0, 2703, 2704,
        1, 0, 0, 0, 2704, 2705, 3, 234, 117, 0, 2705, 2706, 5, 170, 0, 0, 2706, 2707, 3, 358, 179, 0,
        2707, 2708, 3, 222, 111, 0, 2708, 2709, 5, 241, 0, 0, 2709, 2711, 3, 234, 117, 0, 2710, 2712,
        3, 236, 118, 0, 2711, 2710, 1, 0, 0, 0, 2711, 2712, 1, 0, 0, 0, 2712, 2713, 1, 0, 0, 0, 2713,
        2714, 5, 180, 0, 0, 2714, 2715, 5, 267, 0, 0, 2715, 441, 1, 0, 0, 0, 2716, 2718, 5, 67, 0, 0,
        2717, 2719, 3, 766, 383, 0, 2718, 2717, 1, 0, 0, 0, 2718, 2719, 1, 0, 0, 0, 2719, 2723, 1, 0,
        0, 0, 2720, 2721, 5, 143, 0, 0, 2721, 2722, 5, 206, 0, 0, 2722, 2724, 5, 117, 0, 0, 2723, 2720,
        1, 0, 0, 0, 2723, 2724, 1, 0, 0, 0, 2724, 2725, 1, 0, 0, 0, 2725, 2728, 5, 127, 0, 0, 2726, 2729,
        3, 438, 219, 0, 2727, 2729, 3, 440, 220, 0, 2728, 2726, 1, 0, 0, 0, 2728, 2727, 1, 0, 0, 0, 2729,
        2730, 1, 0, 0, 0, 2730, 2732, 3, 444, 222, 0, 2731, 2733, 3, 394, 197, 0, 2732, 2731, 1, 0,
        0, 0, 2732, 2733, 1, 0, 0, 0, 2733, 443, 1, 0, 0, 0, 2734, 2735, 5, 257, 0, 0, 2735, 2739, 3,
        466, 233, 0, 2736, 2740, 5, 61, 0, 0, 2737, 2738, 5, 162, 0, 0, 2738, 2740, 7, 21, 0, 0, 2739,
        2736, 1, 0, 0, 0, 2739, 2737, 1, 0, 0, 0, 2740, 2741, 1, 0, 0, 0, 2741, 2742, 3, 362, 181, 0,
        2742, 2766, 1, 0, 0, 0, 2743, 2744, 5, 257, 0, 0, 2744, 2745, 3, 466, 233, 0, 2745, 2747, 5,
        162, 0, 0, 2746, 2748, 7, 38, 0, 0, 2747, 2746, 1, 0, 0, 0, 2747, 2748, 1, 0, 0, 0, 2748, 2749,
        1, 0, 0, 0, 2749, 2750, 5, 316, 0, 0, 2750, 2766, 1, 0, 0, 0, 2751, 2752, 5, 257, 0, 0, 2752,
        2753, 3, 466, 233, 0, 2753, 2755, 5, 162, 0, 0, 2754, 2756, 7, 38, 0, 0, 2755, 2754, 1, 0, 0,
        0, 2755, 2756, 1, 0, 0, 0, 2756, 2757, 1, 0, 0, 0, 2757, 2758, 5, 164, 0, 0, 2758, 2766, 1, 0,
        0, 0, 2759, 2760, 5, 257, 0, 0, 2760, 2761, 3, 466, 233, 0, 2761, 2762, 5, 162, 0, 0, 2762,
        2763, 5, 206, 0, 0, 2763, 2764, 5, 209, 0, 0, 2764, 2766, 1, 0, 0, 0, 2765, 2734, 1, 0, 0, 0,
        2765, 2743, 1, 0, 0, 0, 2765, 2751, 1, 0, 0, 0, 2765, 2759, 1, 0, 0, 0, 2766, 445, 1, 0, 0, 0,
        2767, 2768, 5, 67, 0, 0, 2768, 2771, 3, 766, 383, 0, 2769, 2770, 5, 143, 0, 0, 2770, 2772,
        5, 117, 0, 0, 2771, 2769, 1, 0, 0, 0, 2771, 2772, 1, 0, 0, 0, 2772, 447, 1, 0, 0, 0, 2773, 2774,
        5, 240, 0, 0, 2774, 2775, 5, 147, 0, 0, 2775, 2794, 3, 450, 225, 0, 2776, 2777, 5, 298, 0, 0,
        2777, 2778, 5, 147, 0, 0, 2778, 2794, 3, 450, 225, 0, 2779, 2780, 5, 226, 0, 0, 2780, 2781,
        5, 147, 0, 0, 2781, 2794, 3, 450, 225, 0, 2782, 2783, 5, 326, 0, 0, 2783, 2784, 5, 147, 0, 0,
        2784, 2794, 3, 450, 225, 0, 2785, 2786, 5, 179, 0, 0, 2786, 2787, 5, 147, 0, 0, 2787, 2794,
        3, 458, 229, 0, 2788, 2789, 5, 130, 0, 0, 2789, 2790, 5, 147, 0, 0, 2790, 2794, 3, 452, 226,
        0, 2791, 2792, 5, 147, 0, 0, 2792, 2794, 3, 450, 225, 0, 2793, 2773, 1, 0, 0, 0, 2793, 2776,
        1, 0, 0, 0, 2793, 2779, 1, 0, 0, 0, 2793, 2782, 1, 0, 0, 0, 2793, 2785, 1, 0, 0, 0, 2793, 2788,
        1, 0, 0, 0, 2793, 2791, 1, 0, 0, 0, 2794, 449, 1, 0, 0, 0, 2795, 2797, 3, 766, 383, 0, 2796, 2795,
        1, 0, 0, 0, 2796, 2797, 1, 0, 0, 0, 2797, 2801, 1, 0, 0, 0, 2798, 2799, 5, 143, 0, 0, 2799, 2800,
        5, 206, 0, 0, 2800, 2802, 5, 117, 0, 0, 2801, 2798, 1, 0, 0, 0, 2801, 2802, 1, 0, 0, 0, 2802,
        2803, 1, 0, 0, 0, 2803, 2806, 5, 127, 0, 0, 2804, 2807, 3, 438, 219, 0, 2805, 2807, 3, 440,
        220, 0, 2806, 2804, 1, 0, 0, 0, 2806, 2805, 1, 0, 0, 0, 2807, 2808, 1, 0, 0, 0, 2808, 2809, 5,
        212, 0, 0, 2809, 2811, 3, 466, 233, 0, 2810, 2812, 3, 394, 197, 0, 2811, 2810, 1, 0, 0, 0, 2811,
        2812, 1, 0, 0, 0, 2812, 451, 1, 0, 0, 0, 2813, 2815, 3, 766, 383, 0, 2814, 2813, 1, 0, 0, 0, 2814,
        2815, 1, 0, 0, 0, 2815, 2819, 1, 0, 0, 0, 2816, 2817, 5, 143, 0, 0, 2817, 2818, 5, 206, 0, 0,
        2818, 2820, 5, 117, 0, 0, 2819, 2816, 1, 0, 0, 0, 2819, 2820, 1, 0, 0, 0, 2820, 2821, 1, 0, 0,
        0, 2821, 2824, 5, 127, 0, 0, 2822, 2825, 3, 454, 227, 0, 2823, 2825, 3, 456, 228, 0, 2824,
        2822, 1, 0, 0, 0, 2824, 2823, 1, 0, 0, 0, 2825, 2826, 1, 0, 0, 0, 2826, 2827, 5, 212, 0, 0, 2827,
        2828, 5, 103, 0, 0, 2828, 2829, 5, 170, 0, 0, 2829, 2830, 3, 468, 234, 0, 2830, 2832, 5, 241,
        0, 0, 2831, 2833, 3, 394, 197, 0, 2832, 2831, 1, 0, 0, 0, 2832, 2833, 1, 0, 0, 0, 2833, 453,
        1, 0, 0, 0, 2834, 2835, 5, 180, 0, 0, 2835, 2836, 3, 358, 179, 0, 2836, 2837, 5, 60, 0, 0, 2837,
        2842, 3, 800, 400, 0, 2838, 2839, 5, 45, 0, 0, 2839, 2841, 3, 800, 400, 0, 2840, 2838, 1, 0,
        0, 0, 2841, 2844, 1, 0, 0, 0, 2842, 2840, 1, 0, 0, 0, 2842, 2843, 1, 0, 0, 0, 2843, 2845, 1, 0,
        0, 0, 2844, 2842, 1, 0, 0, 0, 2845, 2846, 5, 267, 0, 0, 2846, 455, 1, 0, 0, 0, 2847, 2848, 5,
        180, 0, 0, 2848, 2850, 5, 267, 0, 0, 2849, 2851, 3, 232, 116, 0, 2850, 2849, 1, 0, 0, 0, 2850,
        2851, 1, 0, 0, 0, 2851, 2852, 1, 0, 0, 0, 2852, 2853, 3, 234, 117, 0, 2853, 2854, 5, 170, 0,
        0, 2854, 2855, 3, 358, 179, 0, 2855, 2856, 5, 60, 0, 0, 2856, 2861, 3, 800, 400, 0, 2857, 2858,
        5, 45, 0, 0, 2858, 2860, 3, 800, 400, 0, 2859, 2857, 1, 0, 0, 0, 2860, 2863, 1, 0, 0, 0, 2861,
        2859, 1, 0, 0, 0, 2861, 2862, 1, 0, 0, 0, 2862, 2864, 1, 0, 0, 0, 2863, 2861, 1, 0, 0, 0, 2864,
        2865, 5, 241, 0, 0, 2865, 2867, 3, 234, 117, 0, 2866, 2868, 3, 236, 118, 0, 2867, 2866, 1,
        0, 0, 0, 2867, 2868, 1, 0, 0, 0, 2868, 2869, 1, 0, 0, 0, 2869, 2870, 5, 180, 0, 0, 2870, 2871,
        5, 267, 0, 0, 2871, 457, 1, 0, 0, 0, 2872, 2874, 3, 766, 383, 0, 2873, 2872, 1, 0, 0, 0, 2873,
        2874, 1, 0, 0, 0, 2874, 2878, 1, 0, 0, 0, 2875, 2876, 5, 143, 0, 0, 2876, 2877, 5, 206, 0, 0,
        2877, 2879, 5, 117, 0, 0, 2878, 2875, 1, 0, 0, 0, 2878, 2879, 1, 0, 0, 0, 2879, 2880, 1, 0, 0,
        0, 2880, 2883, 5, 127, 0, 0, 2881, 2884, 3, 460, 230, 0, 2882, 2884, 3, 462, 231, 0, 2883,
        2881, 1, 0, 0, 0, 2883, 2882, 1, 0, 0, 0, 2884, 2885, 1, 0, 0, 0, 2885, 2886, 3, 800, 400, 0,
        2886, 2887, 5, 180, 0, 0, 2887, 2888, 3, 358, 179, 0, 2888, 2890, 5, 267, 0, 0, 2889, 2891,
        3, 394, 197, 0, 2890, 2889, 1, 0, 0, 0, 2890, 2891, 1, 0, 0, 0, 2891, 459, 1, 0, 0, 0, 2892, 2893,
        5, 180, 0, 0, 2893, 2894, 3, 358, 179, 0, 2894, 2895, 5, 267, 0, 0, 2895, 2896, 5, 212, 0, 0,
        2896, 2897, 5, 103, 0, 0, 2897, 461, 1, 0, 0, 0, 2898, 2899, 5, 180, 0, 0, 2899, 2901, 5, 267,
        0, 0, 2900, 2902, 3, 232, 116, 0, 2901, 2900, 1, 0, 0, 0, 2901, 2902, 1, 0, 0, 0, 2902, 2903,
        1, 0, 0, 0, 2903, 2904, 3, 234, 117, 0, 2904, 2905, 5, 170, 0, 0, 2905, 2906, 3, 358, 179, 0,
        2906, 2907, 5, 241, 0, 0, 2907, 2909, 3, 234, 117, 0, 2908, 2910, 3, 236, 118, 0, 2909, 2908,
        1, 0, 0, 0, 2909, 2910, 1, 0, 0, 0, 2910, 2911, 1, 0, 0, 0, 2911, 2912, 5, 180, 0, 0, 2912, 2913,
        5, 267, 0, 0, 2913, 2915, 5, 212, 0, 0, 2914, 2916, 5, 103, 0, 0, 2915, 2914, 1, 0, 0, 0, 2915,
        2916, 1, 0, 0, 0, 2916, 463, 1, 0, 0, 0, 2917, 2918, 5, 147, 0, 0, 2918, 2921, 3, 766, 383, 0,
        2919, 2920, 5, 143, 0, 0, 2920, 2922, 5, 117, 0, 0, 2921, 2919, 1, 0, 0, 0, 2921, 2922, 1, 0,
        0, 0, 2922, 465, 1, 0, 0, 0, 2923, 2924, 3, 358, 179, 0, 2924, 2925, 3, 282, 141, 0, 2925, 2931,
        1, 0, 0, 0, 2926, 2927, 5, 180, 0, 0, 2927, 2928, 3, 468, 234, 0, 2928, 2929, 5, 267, 0, 0, 2929,
        2931, 1, 0, 0, 0, 2930, 2923, 1, 0, 0, 0, 2930, 2926, 1, 0, 0, 0, 2931, 467, 1, 0, 0, 0, 2932,
        2933, 3, 358, 179, 0, 2933, 2940, 3, 282, 141, 0, 2934, 2935, 5, 62, 0, 0, 2935, 2936, 3, 358,
        179, 0, 2936, 2937, 3, 282, 141, 0, 2937, 2939, 1, 0, 0, 0, 2938, 2934, 1, 0, 0, 0, 2939, 2942,
        1, 0, 0, 0, 2940, 2938, 1, 0, 0, 0, 2940, 2941, 1, 0, 0, 0, 2941, 469, 1, 0, 0, 0, 2942, 2940,
        1, 0, 0, 0, 2943, 2944, 5, 75, 0, 0, 2944, 2945, 5, 135, 0, 0, 2945, 2950, 5, 312, 0, 0, 2946,
        2947, 7, 39, 0, 0, 2947, 2951, 3, 472, 236, 0, 2948, 2949, 5, 99, 0, 0, 2949, 2951, 3, 474,
        237, 0, 2950, 2946, 1, 0, 0, 0, 2950, 2948, 1, 0, 0, 0, 2951, 471, 1, 0, 0, 0, 2952, 2954, 5,
        171, 0, 0, 2953, 2955, 3, 476, 238, 0, 2954, 2953, 1, 0, 0, 0, 2954, 2955, 1, 0, 0, 0, 2955,
        2956, 1, 0, 0, 0, 2956, 2957, 5, 242, 0, 0, 2957, 473, 1, 0, 0, 0, 2958, 2960, 5, 171, 0, 0, 2959,
        2961, 3, 478, 239, 0, 2960, 2959, 1, 0, 0, 0, 2960, 2961, 1, 0, 0, 0, 2961, 2962, 1, 0, 0, 0,
        2962, 2963, 5, 242, 0, 0, 2963, 475, 1, 0, 0, 0, 2964, 2969, 3, 480, 240, 0, 2965, 2966, 5,
        62, 0, 0, 2966, 2968, 3, 480, 240, 0, 2967, 2965, 1, 0, 0, 0, 2968, 2971, 1, 0, 0, 0, 2969, 2967,
        1, 0, 0, 0, 2969, 2970, 1, 0, 0, 0, 2970, 477, 1, 0, 0, 0, 2971, 2969, 1, 0, 0, 0, 2972, 2977,
        3, 482, 241, 0, 2973, 2974, 5, 62, 0, 0, 2974, 2976, 3, 482, 241, 0, 2975, 2973, 1, 0, 0, 0,
        2976, 2979, 1, 0, 0, 0, 2977, 2975, 1, 0, 0, 0, 2977, 2978, 1, 0, 0, 0, 2978, 479, 1, 0, 0, 0,
        2979, 2977, 1, 0, 0, 0, 2980, 2984, 3, 502, 251, 0, 2981, 2984, 3, 490, 245, 0, 2982, 2984,
        3, 522, 261, 0, 2983, 2980, 1, 0, 0, 0, 2983, 2981, 1, 0, 0, 0, 2983, 2982, 1, 0, 0, 0, 2984,
        481, 1, 0, 0, 0, 2985, 2990, 3, 502, 251, 0, 2986, 2990, 3, 490, 245, 0, 2987, 2988, 5, 67,
        0, 0, 2988, 2990, 3, 800, 400, 0, 2989, 2985, 1, 0, 0, 0, 2989, 2986, 1, 0, 0, 0, 2989, 2987,
        1, 0, 0, 0, 2990, 483, 1, 0, 0, 0, 2991, 2993, 3, 444, 222, 0, 2992, 2994, 3, 394, 197, 0, 2993,
        2992, 1, 0, 0, 0, 2993, 2994, 1, 0, 0, 0, 2994, 2996, 1, 0, 0, 0, 2995, 2991, 1, 0, 0, 0, 2996,
        2997, 1, 0, 0, 0, 2997, 2995, 1, 0, 0, 0, 2997, 2998, 1, 0, 0, 0, 2998, 485, 1, 0, 0, 0, 2999,
        3001, 3, 444, 222, 0, 3000, 3002, 3, 394, 197, 0, 3001, 3000, 1, 0, 0, 0, 3001, 3002, 1, 0,
        0, 0, 3002, 3004, 1, 0, 0, 0, 3003, 2999, 1, 0, 0, 0, 3004, 3005, 1, 0, 0, 0, 3005, 3003, 1, 0,
        0, 0, 3005, 3006, 1, 0, 0, 0, 3006, 487, 1, 0, 0, 0, 3007, 3008, 5, 112, 0, 0, 3008, 3011, 3,
        236, 118, 0, 3009, 3011, 5, 188, 0, 0, 3010, 3007, 1, 0, 0, 0, 3010, 3009, 1, 0, 0, 0, 3011,
        489, 1, 0, 0, 0, 3012, 3014, 5, 180, 0, 0, 3013, 3015, 3, 358, 179, 0, 3014, 3013, 1, 0, 0, 0,
        3014, 3015, 1, 0, 0, 0, 3015, 3016, 1, 0, 0, 0, 3016, 3018, 3, 494, 247, 0, 3017, 3019, 3, 492,
        246, 0, 3018, 3017, 1, 0, 0, 0, 3018, 3019, 1, 0, 0, 0, 3019, 3021, 1, 0, 0, 0, 3020, 3022, 3,
        514, 257, 0, 3021, 3020, 1, 0, 0, 0, 3021, 3022, 1, 0, 0, 0, 3022, 3023, 1, 0, 0, 0, 3023, 3025,
        5, 267, 0, 0, 3024, 3026, 3, 484, 242, 0, 3025, 3024, 1, 0, 0, 0, 3025, 3026, 1, 0, 0, 0, 3026,
        491, 1, 0, 0, 0, 3027, 3032, 3, 220, 110, 0, 3028, 3029, 5, 167, 0, 0, 3029, 3031, 3, 800, 400,
        0, 3030, 3028, 1, 0, 0, 0, 3031, 3034, 1, 0, 0, 0, 3032, 3030, 1, 0, 0, 0, 3032, 3033, 1, 0, 0,
        0, 3033, 493, 1, 0, 0, 0, 3034, 3032, 1, 0, 0, 0, 3035, 3036, 3, 220, 110, 0, 3036, 3037, 3,
        488, 244, 0, 3037, 495, 1, 0, 0, 0, 3038, 3041, 3, 498, 249, 0, 3039, 3041, 3, 500, 250, 0,
        3040, 3038, 1, 0, 0, 0, 3040, 3039, 1, 0, 0, 0, 3041, 497, 1, 0, 0, 0, 3042, 3043, 5, 180, 0,
        0, 3043, 3044, 3, 358, 179, 0, 3044, 3045, 5, 267, 0, 0, 3045, 499, 1, 0, 0, 0, 3046, 3054,
        5, 180, 0, 0, 3047, 3049, 3, 358, 179, 0, 3048, 3047, 1, 0, 0, 0, 3048, 3049, 1, 0, 0, 0, 3049,
        3050, 1, 0, 0, 0, 3050, 3052, 3, 220, 110, 0, 3051, 3053, 3, 488, 244, 0, 3052, 3051, 1, 0,
        0, 0, 3052, 3053, 1, 0, 0, 0, 3053, 3055, 1, 0, 0, 0, 3054, 3048, 1, 0, 0, 0, 3054, 3055, 1, 0,
        0, 0, 3055, 3056, 1, 0, 0, 0, 3056, 3057, 5, 267, 0, 0, 3057, 501, 1, 0, 0, 0, 3058, 3059, 3,
        496, 248, 0, 3059, 3060, 3, 504, 252, 0, 3060, 3062, 3, 496, 248, 0, 3061, 3063, 3, 486, 243,
        0, 3062, 3061, 1, 0, 0, 0, 3062, 3063, 1, 0, 0, 0, 3063, 503, 1, 0, 0, 0, 3064, 3065, 3, 234,
        117, 0, 3065, 3067, 5, 170, 0, 0, 3066, 3068, 3, 358, 179, 0, 3067, 3066, 1, 0, 0, 0, 3067,
        3068, 1, 0, 0, 0, 3068, 3069, 1, 0, 0, 0, 3069, 3071, 3, 506, 253, 0, 3070, 3072, 3, 514, 257,
        0, 3071, 3070, 1, 0, 0, 0, 3071, 3072, 1, 0, 0, 0, 3072, 3073, 1, 0, 0, 0, 3073, 3074, 5, 241,
        0, 0, 3074, 3075, 3, 234, 117, 0, 3075, 3076, 3, 236, 118, 0, 3076, 505, 1, 0, 0, 0, 3077, 3078,
        3, 222, 111, 0, 3078, 3079, 3, 488, 244, 0, 3079, 507, 1, 0, 0, 0, 3080, 3083, 3, 510, 255,
        0, 3081, 3083, 3, 512, 256, 0, 3082, 3080, 1, 0, 0, 0, 3082, 3081, 1, 0, 0, 0, 3083, 509, 1,
        0, 0, 0, 3084, 3085, 5, 180, 0, 0, 3085, 3086, 5, 267, 0, 0, 3086, 3087, 3, 234, 117, 0, 3087,
        3088, 5, 170, 0, 0, 3088, 3089, 3, 358, 179, 0, 3089, 3090, 5, 241, 0, 0, 3090, 3091, 3, 234,
        117, 0, 3091, 3092, 3, 236, 118, 0, 3092, 3093, 5, 180, 0, 0, 3093, 3094, 5, 267, 0, 0, 3094,
        511, 1, 0, 0, 0, 3095, 3096, 5, 180, 0, 0, 3096, 3097, 5, 267, 0, 0, 3097, 3098, 3, 234, 117,
        0, 3098, 3100, 5, 170, 0, 0, 3099, 3101, 3, 358, 179, 0, 3100, 3099, 1, 0, 0, 0, 3100, 3101,
        1, 0, 0, 0, 3101, 3102, 1, 0, 0, 0, 3102, 3104, 3, 222, 111, 0, 3103, 3105, 3, 488, 244, 0, 3104,
        3103, 1, 0, 0, 0, 3104, 3105, 1, 0, 0, 0, 3105, 3106, 1, 0, 0, 0, 3106, 3107, 5, 241, 0, 0, 3107,
        3108, 3, 234, 117, 0, 3108, 3109, 3, 236, 118, 0, 3109, 3110, 5, 180, 0, 0, 3110, 3111, 5,
        267, 0, 0, 3111, 513, 1, 0, 0, 0, 3112, 3121, 5, 171, 0, 0, 3113, 3118, 3, 516, 258, 0, 3114,
        3115, 5, 62, 0, 0, 3115, 3117, 3, 516, 258, 0, 3116, 3114, 1, 0, 0, 0, 3117, 3120, 1, 0, 0, 0,
        3118, 3116, 1, 0, 0, 0, 3118, 3119, 1, 0, 0, 0, 3119, 3122, 1, 0, 0, 0, 3120, 3118, 1, 0, 0, 0,
        3121, 3113, 1, 0, 0, 0, 3121, 3122, 1, 0, 0, 0, 3122, 3123, 1, 0, 0, 0, 3123, 3124, 5, 242, 0,
        0, 3124, 515, 1, 0, 0, 0, 3125, 3127, 3, 344, 172, 0, 3126, 3128, 3, 520, 260, 0, 3127, 3126,
        1, 0, 0, 0, 3127, 3128, 1, 0, 0, 0, 3128, 3129, 1, 0, 0, 0, 3129, 3131, 3, 362, 181, 0, 3130,
        3132, 3, 518, 259, 0, 3131, 3130, 1, 0, 0, 0, 3131, 3132, 1, 0, 0, 0, 3132, 517, 1, 0, 0, 0, 3133,
        3135, 5, 162, 0, 0, 3134, 3136, 7, 38, 0, 0, 3135, 3134, 1, 0, 0, 0, 3135, 3136, 1, 0, 0, 0, 3136,
        3137, 1, 0, 0, 0, 3137, 3138, 7, 40, 0, 0, 3138, 519, 1, 0, 0, 0, 3139, 3140, 7, 21, 0, 0, 3140,
        521, 1, 0, 0, 0, 3141, 3143, 5, 67, 0, 0, 3142, 3144, 3, 800, 400, 0, 3143, 3142, 1, 0, 0, 0,
        3143, 3144, 1, 0, 0, 0, 3144, 3145, 1, 0, 0, 0, 3145, 3148, 5, 127, 0, 0, 3146, 3149, 3, 496,
        248, 0, 3147, 3149, 3, 508, 254, 0, 3148, 3146, 1, 0, 0, 0, 3148, 3147, 1, 0, 0, 0, 3149, 3150,
        1, 0, 0, 0, 3150, 3152, 3, 444, 222, 0, 3151, 3153, 3, 394, 197, 0, 3152, 3151, 1, 0, 0, 0, 3152,
        3153, 1, 0, 0, 0, 3153, 523, 1, 0, 0, 0, 3154, 3158, 5, 246, 0, 0, 3155, 3159, 3, 558, 279, 0,
        3156, 3159, 3, 542, 271, 0, 3157, 3159, 3, 570, 285, 0, 3158, 3155, 1, 0, 0, 0, 3158, 3156,
        1, 0, 0, 0, 3158, 3157, 1, 0, 0, 0, 3159, 525, 1, 0, 0, 0, 3160, 3171, 5, 134, 0, 0, 3161, 3163,
        5, 145, 0, 0, 3162, 3161, 1, 0, 0, 0, 3162, 3163, 1, 0, 0, 0, 3163, 3164, 1, 0, 0, 0, 3164, 3165,
        3, 610, 305, 0, 3165, 3166, 5, 304, 0, 0, 3166, 3167, 3, 534, 267, 0, 3167, 3172, 1, 0, 0, 0,
        3168, 3169, 3, 536, 268, 0, 3169, 3170, 3, 562, 281, 0, 3170, 3172, 1, 0, 0, 0, 3171, 3162,
        1, 0, 0, 0, 3171, 3168, 1, 0, 0, 0, 3172, 527, 1, 0, 0, 0, 3173, 3175, 5, 86, 0, 0, 3174, 3176,
        5, 145, 0, 0, 3175, 3174, 1, 0, 0, 0, 3175, 3176, 1, 0, 0, 0, 3176, 3177, 1, 0, 0, 0, 3177, 3178,
        3, 610, 305, 0, 3178, 3179, 5, 304, 0, 0, 3179, 3180, 3, 534, 267, 0, 3180, 529, 1, 0, 0, 0,
        3181, 3195, 5, 262, 0, 0, 3182, 3184, 7, 41, 0, 0, 3183, 3182, 1, 0, 0, 0, 3183, 3184, 1, 0,
        0, 0, 3184, 3186, 1, 0, 0, 0, 3185, 3187, 5, 145, 0, 0, 3186, 3185, 1, 0, 0, 0, 3186, 3187, 1,
        0, 0, 0, 3187, 3188, 1, 0, 0, 0, 3188, 3189, 3, 610, 305, 0, 3189, 3190, 5, 129, 0, 0, 3190,
        3191, 3, 534, 267, 0, 3191, 3196, 1, 0, 0, 0, 3192, 3193, 3, 536, 268, 0, 3193, 3194, 3, 564,
        282, 0, 3194, 3196, 1, 0, 0, 0, 3195, 3183, 1, 0, 0, 0, 3195, 3192, 1, 0, 0, 0, 3196, 531, 1,
        0, 0, 0, 3197, 3198, 3, 770, 385, 0, 3198, 533, 1, 0, 0, 0, 3199, 3200, 3, 770, 385, 0, 3200,
        535, 1, 0, 0, 0, 3201, 3202, 7, 42, 0, 0, 3202, 537, 1, 0, 0, 0, 3203, 3204, 5, 105, 0, 0, 3204,
        3205, 5, 276, 0, 0, 3205, 3207, 3, 786, 393, 0, 3206, 3208, 3, 394, 197, 0, 3207, 3206, 1,
        0, 0, 0, 3207, 3208, 1, 0, 0, 0, 3208, 539, 1, 0, 0, 0, 3209, 3210, 5, 276, 0, 0, 3210, 3211,
        3, 786, 393, 0, 3211, 3212, 5, 278, 0, 0, 3212, 3213, 3, 394, 197, 0, 3213, 541, 1, 0, 0, 0,
        3214, 3215, 5, 276, 0, 0, 3215, 3216, 3, 786, 393, 0, 3216, 3217, 5, 304, 0, 0, 3217, 3218,
        3, 786, 393, 0, 3218, 543, 1, 0, 0, 0, 3219, 3220, 5, 276, 0, 0, 3220, 3221, 3, 786, 393, 0,
        3221, 545, 1, 0, 0, 0, 3222, 3224, 7, 43, 0, 0, 3223, 3225, 3, 384, 192, 0, 3224, 3223, 1, 0,
        0, 0, 3224, 3225, 1, 0, 0, 0, 3225, 547, 1, 0, 0, 0, 3226, 3228, 5, 100, 0, 0, 3227, 3226, 1,
        0, 0, 0, 3227, 3228, 1, 0, 0, 0, 3228, 3231, 1, 0, 0, 0, 3229, 3232, 3, 550, 275, 0, 3230, 3232,
        3, 552, 276, 0, 3231, 3229, 1, 0, 0, 0, 3231, 3230, 1, 0, 0, 0, 3232, 549, 1, 0, 0, 0, 3233, 3234,
        5, 82, 0, 0, 3234, 3235, 7, 44, 0, 0, 3235, 3236, 5, 129, 0, 0, 3236, 3237, 7, 43, 0, 0, 3237,
        3242, 3, 786, 393, 0, 3238, 3239, 5, 62, 0, 0, 3239, 3241, 3, 786, 393, 0, 3240, 3238, 1, 0,
        0, 0, 3241, 3244, 1, 0, 0, 0, 3242, 3240, 1, 0, 0, 0, 3242, 3243, 1, 0, 0, 0, 3243, 551, 1, 0,
        0, 0, 3244, 3242, 1, 0, 0, 0, 3245, 3246, 5, 244, 0, 0, 3246, 3247, 7, 44, 0, 0, 3247, 553, 1,
        0, 0, 0, 3248, 3250, 5, 145, 0, 0, 3249, 3248, 1, 0, 0, 0, 3249, 3250, 1, 0, 0, 0, 3250, 3251,
        1, 0, 0, 0, 3251, 3252, 5, 263, 0, 0, 3252, 3256, 3, 768, 384, 0, 3253, 3254, 5, 143, 0, 0, 3254,
        3255, 5, 206, 0, 0, 3255, 3257, 5, 117, 0, 0, 3256, 3253, 1, 0, 0, 0, 3256, 3257, 1, 0, 0, 0,
        3257, 3262, 1, 0, 0, 0, 3258, 3259, 5, 39, 0, 0, 3259, 3260, 5, 70, 0, 0, 3260, 3261, 5, 210,
        0, 0, 3261, 3263, 3, 768, 384, 0, 3262, 3258, 1, 0, 0, 0, 3262, 3263, 1, 0, 0, 0, 3263, 555,
        1, 0, 0, 0, 3264, 3265, 5, 263, 0, 0, 3265, 3268, 3, 768, 384, 0, 3266, 3267, 5, 143, 0, 0, 3267,
        3269, 5, 117, 0, 0, 3268, 3266, 1, 0, 0, 0, 3268, 3269, 1, 0, 0, 0, 3269, 557, 1, 0, 0, 0, 3270,
        3271, 5, 263, 0, 0, 3271, 3274, 3, 768, 384, 0, 3272, 3273, 5, 143, 0, 0, 3273, 3275, 5, 117,
        0, 0, 3274, 3272, 1, 0, 0, 0, 3274, 3275, 1, 0, 0, 0, 3275, 3276, 1, 0, 0, 0, 3276, 3277, 5, 304,
        0, 0, 3277, 3278, 3, 768, 384, 0, 3278, 559, 1, 0, 0, 0, 3279, 3281, 7, 45, 0, 0, 3280, 3279,
        1, 0, 0, 0, 3280, 3281, 1, 0, 0, 0, 3281, 3282, 1, 0, 0, 0, 3282, 3285, 3, 536, 268, 0, 3283,
        3284, 5, 331, 0, 0, 3284, 3286, 7, 46, 0, 0, 3285, 3283, 1, 0, 0, 0, 3285, 3286, 1, 0, 0, 0, 3286,
        3288, 1, 0, 0, 0, 3287, 3289, 3, 384, 192, 0, 3288, 3287, 1, 0, 0, 0, 3288, 3289, 1, 0, 0, 0,
        3289, 561, 1, 0, 0, 0, 3290, 3291, 3, 534, 267, 0, 3291, 3292, 5, 304, 0, 0, 3292, 3293, 3,
        532, 266, 0, 3293, 563, 1, 0, 0, 0, 3294, 3295, 3, 534, 267, 0, 3295, 3296, 5, 129, 0, 0, 3296,
        3297, 3, 532, 266, 0, 3297, 565, 1, 0, 0, 0, 3298, 3299, 5, 321, 0, 0, 3299, 3303, 3, 768, 384,
        0, 3300, 3301, 5, 143, 0, 0, 3301, 3302, 5, 206, 0, 0, 3302, 3304, 5, 117, 0, 0, 3303, 3300,
        1, 0, 0, 0, 3303, 3304, 1, 0, 0, 0, 3304, 3314, 1, 0, 0, 0, 3305, 3312, 5, 278, 0, 0, 3306, 3313,
        3, 578, 289, 0, 3307, 3308, 5, 219, 0, 0, 3308, 3313, 3, 584, 292, 0, 3309, 3313, 3, 586, 293,
        0, 3310, 3313, 3, 588, 294, 0, 3311, 3313, 3, 590, 295, 0, 3312, 3306, 1, 0, 0, 0, 3312, 3307,
        1, 0, 0, 0, 3312, 3309, 1, 0, 0, 0, 3312, 3310, 1, 0, 0, 0, 3312, 3311, 1, 0, 0, 0, 3313, 3315,
        1, 0, 0, 0, 3314, 3305, 1, 0, 0, 0, 3315, 3316, 1, 0, 0, 0, 3316, 3314, 1, 0, 0, 0, 3316, 3317,
        1, 0, 0, 0, 3317, 567, 1, 0, 0, 0, 3318, 3319, 5, 321, 0, 0, 3319, 3322, 3, 768, 384, 0, 3320,
        3321, 5, 143, 0, 0, 3321, 3323, 5, 117, 0, 0, 3322, 3320, 1, 0, 0, 0, 3322, 3323, 1, 0, 0, 0,
        3323, 569, 1, 0, 0, 0, 3324, 3325, 5, 321, 0, 0, 3325, 3328, 3, 768, 384, 0, 3326, 3327, 5,
        143, 0, 0, 3327, 3329, 5, 117, 0, 0, 3328, 3326, 1, 0, 0, 0, 3328, 3329, 1, 0, 0, 0, 3329, 3330,
        1, 0, 0, 0, 3330, 3331, 5, 304, 0, 0, 3331, 3332, 3, 768, 384, 0, 3332, 571, 1, 0, 0, 0, 3333,
        3334, 5, 75, 0, 0, 3334, 3335, 5, 321, 0, 0, 3335, 3336, 5, 278, 0, 0, 3336, 3337, 5, 219, 0,
        0, 3337, 3338, 5, 129, 0, 0, 3338, 3339, 3, 582, 291, 0, 3339, 3340, 5, 304, 0, 0, 3340, 3341,
        3, 582, 291, 0, 3341, 573, 1, 0, 0, 0, 3342, 3343, 5, 321, 0, 0, 3343, 3346, 3, 768, 384, 0,
        3344, 3345, 5, 143, 0, 0, 3345, 3347, 5, 117, 0, 0, 3346, 3344, 1, 0, 0, 0, 3346, 3347, 1, 0,
        0, 0, 3347, 3361, 1, 0, 0, 0, 3348, 3357, 5, 251, 0, 0, 3349, 3350, 5, 141, 0, 0, 3350, 3358,
        5, 77, 0, 0, 3351, 3352, 5, 33, 0, 0, 3352, 3354, 5, 44, 0, 0, 3353, 3355, 7, 47, 0, 0, 3354,
        3353, 1, 0, 0, 0, 3354, 3355, 1, 0, 0, 0, 3355, 3358, 1, 0, 0, 0, 3356, 3358, 3, 576, 288, 0,
        3357, 3349, 1, 0, 0, 0, 3357, 3351, 1, 0, 0, 0, 3357, 3356, 1, 0, 0, 0, 3358, 3360, 1, 0, 0, 0,
        3359, 3348, 1, 0, 0, 0, 3360, 3363, 1, 0, 0, 0, 3361, 3359, 1, 0, 0, 0, 3361, 3362, 1, 0, 0, 0,
        3362, 3375, 1, 0, 0, 0, 3363, 3361, 1, 0, 0, 0, 3364, 3371, 5, 278, 0, 0, 3365, 3372, 3, 578,
        289, 0, 3366, 3367, 5, 219, 0, 0, 3367, 3372, 3, 584, 292, 0, 3368, 3372, 3, 586, 293, 0, 3369,
        3372, 3, 588, 294, 0, 3370, 3372, 3, 590, 295, 0, 3371, 3365, 1, 0, 0, 0, 3371, 3366, 1, 0,
        0, 0, 3371, 3368, 1, 0, 0, 0, 3371, 3369, 1, 0, 0, 0, 3371, 3370, 1, 0, 0, 0, 3372, 3374, 1, 0,
        0, 0, 3373, 3364, 1, 0, 0, 0, 3374, 3377, 1, 0, 0, 0, 3375, 3373, 1, 0, 0, 0, 3375, 3376, 1, 0,
        0, 0, 3376, 575, 1, 0, 0, 0, 3377, 3375, 1, 0, 0, 0, 3378, 3380, 5, 44, 0, 0, 3379, 3381, 7, 47,
        0, 0, 3380, 3379, 1, 0, 0, 0, 3380, 3381, 1, 0, 0, 0, 3381, 3385, 1, 0, 0, 0, 3382, 3386, 3, 782,
        391, 0, 3383, 3386, 3, 778, 389, 0, 3384, 3386, 3, 346, 173, 0, 3385, 3382, 1, 0, 0, 0, 3385,
        3383, 1, 0, 0, 0, 3385, 3384, 1, 0, 0, 0, 3386, 577, 1, 0, 0, 0, 3387, 3389, 7, 48, 0, 0, 3388,
        3387, 1, 0, 0, 0, 3388, 3389, 1, 0, 0, 0, 3389, 3390, 1, 0, 0, 0, 3390, 3391, 5, 219, 0, 0, 3391,
        3393, 3, 582, 291, 0, 3392, 3394, 3, 584, 292, 0, 3393, 3392, 1, 0, 0, 0, 3393, 3394, 1, 0,
        0, 0, 3394, 579, 1, 0, 0, 0, 3395, 3397, 7, 48, 0, 0, 3396, 3395, 1, 0, 0, 0, 3396, 3397, 1, 0,
        0, 0, 3397, 3398, 1, 0, 0, 0, 3398, 3399, 5, 219, 0, 0, 3399, 3400, 3, 582, 291, 0, 3400, 581,
        1, 0, 0, 0, 3401, 3404, 3, 782, 391, 0, 3402, 3404, 3, 346, 173, 0, 3403, 3401, 1, 0, 0, 0, 3403,
        3402, 1, 0, 0, 0, 3404, 583, 1, 0, 0, 0, 3405, 3407, 5, 57, 0, 0, 3406, 3408, 5, 206, 0, 0, 3407,
        3406, 1, 0, 0, 0, 3407, 3408, 1, 0, 0, 0, 3408, 3409, 1, 0, 0, 0, 3409, 3410, 5, 258, 0, 0, 3410,
        585, 1, 0, 0, 0, 3411, 3412, 5, 291, 0, 0, 3412, 3413, 7, 49, 0, 0, 3413, 587, 1, 0, 0, 0, 3414,
        3415, 5, 141, 0, 0, 3415, 3416, 5, 77, 0, 0, 3416, 3417, 3, 774, 387, 0, 3417, 589, 1, 0, 0,
        0, 3418, 3420, 5, 44, 0, 0, 3419, 3421, 5, 237, 0, 0, 3420, 3419, 1, 0, 0, 0, 3420, 3421, 1,
        0, 0, 0, 3421, 3422, 1, 0, 0, 0, 3422, 3423, 3, 782, 391, 0, 3423, 3426, 5, 171, 0, 0, 3424,
        3425, 5, 278, 0, 0, 3425, 3427, 3, 592, 296, 0, 3426, 3424, 1, 0, 0, 0, 3427, 3428, 1, 0, 0,
        0, 3428, 3426, 1, 0, 0, 0, 3428, 3429, 1, 0, 0, 0, 3429, 3430, 1, 0, 0, 0, 3430, 3431, 5, 242,
        0, 0, 3431, 591, 1, 0, 0, 0, 3432, 3433, 5, 142, 0, 0, 3433, 3438, 3, 784, 392, 0, 3434, 3438,
        3, 580, 290, 0, 3435, 3436, 5, 219, 0, 0, 3436, 3438, 3, 584, 292, 0, 3437, 3432, 1, 0, 0, 0,
        3437, 3434, 1, 0, 0, 0, 3437, 3435, 1, 0, 0, 0, 3438, 593, 1, 0, 0, 0, 3439, 3442, 7, 46, 0, 0,
        3440, 3441, 5, 331, 0, 0, 3441, 3443, 5, 44, 0, 0, 3442, 3440, 1, 0, 0, 0, 3442, 3443, 1, 0,
        0, 0, 3443, 3445, 1, 0, 0, 0, 3444, 3446, 3, 384, 192, 0, 3445, 3444, 1, 0, 0, 0, 3445, 3446,
        1, 0, 0, 0, 3446, 595, 1, 0, 0, 0, 3447, 3448, 5, 75, 0, 0, 3448, 3450, 5, 321, 0, 0, 3449, 3451,
        3, 384, 192, 0, 3450, 3449, 1, 0, 0, 0, 3450, 3451, 1, 0, 0, 0, 3451, 597, 1, 0, 0, 0, 3452, 3453,
        5, 294, 0, 0, 3453, 3455, 3, 608, 304, 0, 3454, 3456, 3, 384, 192, 0, 3455, 3454, 1, 0, 0, 0,
        3455, 3456, 1, 0, 0, 0, 3456, 599, 1, 0, 0, 0, 3457, 3459, 5, 33, 0, 0, 3458, 3457, 1, 0, 0, 0,
        3458, 3459, 1, 0, 0, 0, 3459, 3460, 1, 0, 0, 0, 3460, 3462, 3, 608, 304, 0, 3461, 3463, 3, 606,
        303, 0, 3462, 3461, 1, 0, 0, 0, 3462, 3463, 1, 0, 0, 0, 3463, 3465, 1, 0, 0, 0, 3464, 3466, 3,
        384, 192, 0, 3465, 3464, 1, 0, 0, 0, 3465, 3466, 1, 0, 0, 0, 3466, 601, 1, 0, 0, 0, 3467, 3468,
        7, 42, 0, 0, 3468, 3469, 3, 534, 267, 0, 3469, 3471, 3, 608, 304, 0, 3470, 3472, 3, 606, 303,
        0, 3471, 3470, 1, 0, 0, 0, 3471, 3472, 1, 0, 0, 0, 3472, 3474, 1, 0, 0, 0, 3473, 3475, 3, 384,
        192, 0, 3474, 3473, 1, 0, 0, 0, 3474, 3475, 1, 0, 0, 0, 3475, 603, 1, 0, 0, 0, 3476, 3478, 7,
        46, 0, 0, 3477, 3479, 3, 532, 266, 0, 3478, 3477, 1, 0, 0, 0, 3478, 3479, 1, 0, 0, 0, 3479, 3480,
        1, 0, 0, 0, 3480, 3482, 3, 608, 304, 0, 3481, 3483, 3, 606, 303, 0, 3482, 3481, 1, 0, 0, 0, 3482,
        3483, 1, 0, 0, 0, 3483, 3485, 1, 0, 0, 0, 3484, 3486, 3, 384, 192, 0, 3485, 3484, 1, 0, 0, 0,
        3485, 3486, 1, 0, 0, 0, 3486, 605, 1, 0, 0, 0, 3487, 3489, 5, 39, 0, 0, 3488, 3490, 5, 262, 0,
        0, 3489, 3488, 1, 0, 0, 0, 3489, 3490, 1, 0, 0, 0, 3490, 3491, 1, 0, 0, 0, 3491, 3492, 7, 50,
        0, 0, 3492, 607, 1, 0, 0, 0, 3493, 3494, 7, 51, 0, 0, 3494, 609, 1, 0, 0, 0, 3495, 3507, 3, 612,
        306, 0, 3496, 3507, 3, 618, 309, 0, 3497, 3507, 3, 644, 322, 0, 3498, 3507, 3, 646, 323, 0,
        3499, 3507, 3, 630, 315, 0, 3500, 3507, 3, 632, 316, 0, 3501, 3507, 3, 676, 338, 0, 3502,
        3507, 3, 640, 320, 0, 3503, 3507, 3, 636, 318, 0, 3504, 3507, 3, 634, 317, 0, 3505, 3507,
        3, 642, 321, 0, 3506, 3495, 1, 0, 0, 0, 3506, 3496, 1, 0, 0, 0, 3506, 3497, 1, 0, 0, 0, 3506,
        3498, 1, 0, 0, 0, 3506, 3499, 1, 0, 0, 0, 3506, 3500, 1, 0, 0, 0, 3506, 3501, 1, 0, 0, 0, 3506,
        3502, 1, 0, 0, 0, 3506, 3503, 1, 0, 0, 0, 3506, 3504, 1, 0, 0, 0, 3506, 3505, 1, 0, 0, 0, 3507,
        611, 1, 0, 0, 0, 3508, 3510, 5, 33, 0, 0, 3509, 3511, 3, 614, 307, 0, 3510, 3509, 1, 0, 0, 0,
        3510, 3511, 1, 0, 0, 0, 3511, 3512, 1, 0, 0, 0, 3512, 3513, 5, 212, 0, 0, 3513, 3514, 3, 616,
        308, 0, 3514, 613, 1, 0, 0, 0, 3515, 3517, 7, 52, 0, 0, 3516, 3515, 1, 0, 0, 0, 3516, 3517, 1,
        0, 0, 0, 3517, 3518, 1, 0, 0, 0, 3518, 3519, 5, 232, 0, 0, 3519, 615, 1, 0, 0, 0, 3520, 3521,
        5, 141, 0, 0, 3521, 3534, 7, 53, 0, 0, 3522, 3525, 7, 44, 0, 0, 3523, 3526, 5, 301, 0, 0, 3524,
        3526, 3, 772, 386, 0, 3525, 3523, 1, 0, 0, 0, 3525, 3524, 1, 0, 0, 0, 3526, 3534, 1, 0, 0, 0,
        3527, 3530, 7, 54, 0, 0, 3528, 3531, 5, 301, 0, 0, 3529, 3531, 3, 772, 386, 0, 3530, 3528,
        1, 0, 0, 0, 3530, 3529, 1, 0, 0, 0, 3531, 3534, 1, 0, 0, 0, 3532, 3534, 5, 81, 0, 0, 3533, 3520,
        1, 0, 0, 0, 3533, 3522, 1, 0, 0, 0, 3533, 3527, 1, 0, 0, 0, 3533, 3532, 1, 0, 0, 0, 3534, 617,
        1, 0, 0, 0, 3535, 3548, 5, 73, 0, 0, 3536, 3537, 3, 620, 310, 0, 3537, 3538, 5, 212, 0, 0, 3538,
        3539, 3, 694, 347, 0, 3539, 3549, 1, 0, 0, 0, 3540, 3541, 3, 628, 314, 0, 3541, 3542, 5, 212,
        0, 0, 3542, 3543, 5, 81, 0, 0, 3543, 3549, 1, 0, 0, 0, 3544, 3545, 5, 212, 0, 0, 3545, 3546,
        3, 696, 348, 0, 3546, 3547, 3, 684, 342, 0, 3547, 3549, 1, 0, 0, 0, 3548, 3536, 1, 0, 0, 0, 3548,
        3540, 1, 0, 0, 0, 3548, 3544, 1, 0, 0, 0, 3549, 619, 1, 0, 0, 0, 3550, 3556, 3, 654, 327, 0, 3551,
        3556, 3, 656, 328, 0, 3552, 3556, 3, 622, 311, 0, 3553, 3556, 3, 624, 312, 0, 3554, 3556,
        3, 626, 313, 0, 3555, 3550, 1, 0, 0, 0, 3555, 3551, 1, 0, 0, 0, 3555, 3552, 1, 0, 0, 0, 3555,
        3553, 1, 0, 0, 0, 3555, 3554, 1, 0, 0, 0, 3556, 621, 1, 0, 0, 0, 3557, 3559, 5, 198, 0, 0, 3558,
        3560, 5, 200, 0, 0, 3559, 3558, 1, 0, 0, 0, 3559, 3560, 1, 0, 0, 0, 3560, 3561, 1, 0, 0, 0, 3561,
        3562, 7, 55, 0, 0, 3562, 623, 1, 0, 0, 0, 3563, 3565, 5, 198, 0, 0, 3564, 3566, 5, 249, 0, 0,
        3565, 3564, 1, 0, 0, 0, 3565, 3566, 1, 0, 0, 0, 3566, 3567, 1, 0, 0, 0, 3567, 3568, 7, 56, 0,
        0, 3568, 625, 1, 0, 0, 0, 3569, 3571, 5, 198, 0, 0, 3570, 3572, 5, 236, 0, 0, 3571, 3570, 1,
        0, 0, 0, 3571, 3572, 1, 0, 0, 0, 3572, 3573, 1, 0, 0, 0, 3573, 3574, 7, 57, 0, 0, 3574, 627, 1,
        0, 0, 0, 3575, 3583, 5, 30, 0, 0, 3576, 3578, 5, 65, 0, 0, 3577, 3576, 1, 0, 0, 0, 3577, 3578,
        1, 0, 0, 0, 3578, 3579, 1, 0, 0, 0, 3579, 3583, 5, 77, 0, 0, 3580, 3583, 5, 263, 0, 0, 3581, 3583,
        5, 321, 0, 0, 3582, 3575, 1, 0, 0, 0, 3582, 3577, 1, 0, 0, 0, 3582, 3580, 1, 0, 0, 0, 3582, 3581,
        1, 0, 0, 0, 3583, 629, 1, 0, 0, 0, 3584, 3596, 5, 99, 0, 0, 3585, 3588, 3, 654, 327, 0, 3586,
        3588, 3, 656, 328, 0, 3587, 3585, 1, 0, 0, 0, 3587, 3586, 1, 0, 0, 0, 3588, 3589, 1, 0, 0, 0,
        3589, 3590, 5, 212, 0, 0, 3590, 3591, 3, 694, 347, 0, 3591, 3597, 1, 0, 0, 0, 3592, 3593, 3,
        628, 314, 0, 3593, 3594, 5, 212, 0, 0, 3594, 3595, 5, 81, 0, 0, 3595, 3597, 1, 0, 0, 0, 3596,
        3587, 1, 0, 0, 0, 3596, 3592, 1, 0, 0, 0, 3597, 631, 1, 0, 0, 0, 3598, 3599, 5, 177, 0, 0, 3599,
        3604, 5, 212, 0, 0, 3600, 3601, 7, 58, 0, 0, 3601, 3605, 3, 786, 393, 0, 3602, 3603, 5, 33,
        0, 0, 3603, 3605, 5, 76, 0, 0, 3604, 3600, 1, 0, 0, 0, 3604, 3602, 1, 0, 0, 0, 3605, 633, 1, 0,
        0, 0, 3606, 3631, 5, 285, 0, 0, 3607, 3614, 3, 654, 327, 0, 3608, 3614, 3, 656, 328, 0, 3609,
        3611, 3, 658, 329, 0, 3610, 3612, 3, 660, 330, 0, 3611, 3610, 1, 0, 0, 0, 3611, 3612, 1, 0,
        0, 0, 3612, 3614, 1, 0, 0, 0, 3613, 3607, 1, 0, 0, 0, 3613, 3608, 1, 0, 0, 0, 3613, 3609, 1, 0,
        0, 0, 3614, 3615, 1, 0, 0, 0, 3615, 3616, 5, 212, 0, 0, 3616, 3617, 3, 694, 347, 0, 3617, 3632,
        1, 0, 0, 0, 3618, 3628, 5, 30, 0, 0, 3619, 3628, 5, 231, 0, 0, 3620, 3628, 5, 263, 0, 0, 3621,
        3628, 5, 276, 0, 0, 3622, 3628, 5, 277, 0, 0, 3623, 3624, 3, 432, 216, 0, 3624, 3625, 3, 666,
        333, 0, 3625, 3628, 1, 0, 0, 0, 3626, 3628, 5, 321, 0, 0, 3627, 3618, 1, 0, 0, 0, 3627, 3619,
        1, 0, 0, 0, 3627, 3620, 1, 0, 0, 0, 3627, 3621, 1, 0, 0, 0, 3627, 3622, 1, 0, 0, 0, 3627, 3623,
        1, 0, 0, 0, 3627, 3626, 1, 0, 0, 0, 3628, 3629, 1, 0, 0, 0, 3629, 3630, 5, 212, 0, 0, 3630, 3632,
        5, 81, 0, 0, 3631, 3613, 1, 0, 0, 0, 3631, 3627, 1, 0, 0, 0, 3632, 635, 1, 0, 0, 0, 3633, 3663,
        5, 278, 0, 0, 3634, 3649, 3, 638, 319, 0, 3635, 3639, 5, 321, 0, 0, 3636, 3640, 5, 291, 0, 0,
        3637, 3638, 5, 141, 0, 0, 3638, 3640, 5, 77, 0, 0, 3639, 3636, 1, 0, 0, 0, 3639, 3637, 1, 0,
        0, 0, 3640, 3649, 1, 0, 0, 0, 3641, 3645, 5, 77, 0, 0, 3642, 3646, 5, 25, 0, 0, 3643, 3644, 5,
        83, 0, 0, 3644, 3646, 5, 169, 0, 0, 3645, 3642, 1, 0, 0, 0, 3645, 3643, 1, 0, 0, 0, 3646, 3649,
        1, 0, 0, 0, 3647, 3649, 5, 44, 0, 0, 3648, 3634, 1, 0, 0, 0, 3648, 3635, 1, 0, 0, 0, 3648, 3641,
        1, 0, 0, 0, 3648, 3647, 1, 0, 0, 0, 3649, 3650, 1, 0, 0, 0, 3650, 3651, 5, 212, 0, 0, 3651, 3664,
        5, 81, 0, 0, 3652, 3653, 5, 165, 0, 0, 3653, 3654, 3, 678, 339, 0, 3654, 3655, 5, 212, 0, 0,
        3655, 3656, 3, 696, 348, 0, 3656, 3664, 1, 0, 0, 0, 3657, 3658, 5, 236, 0, 0, 3658, 3659, 3,
        680, 340, 0, 3659, 3660, 5, 212, 0, 0, 3660, 3661, 3, 696, 348, 0, 3661, 3662, 3, 684, 342,
        0, 3662, 3664, 1, 0, 0, 0, 3663, 3648, 1, 0, 0, 0, 3663, 3652, 1, 0, 0, 0, 3663, 3657, 1, 0, 0,
        0, 3664, 637, 1, 0, 0, 0, 3665, 3666, 7, 59, 0, 0, 3666, 639, 1, 0, 0, 0, 3667, 3676, 5, 251,
        0, 0, 3668, 3669, 7, 60, 0, 0, 3669, 3670, 5, 212, 0, 0, 3670, 3677, 5, 81, 0, 0, 3671, 3672,
        5, 165, 0, 0, 3672, 3673, 3, 678, 339, 0, 3673, 3674, 5, 212, 0, 0, 3674, 3675, 3, 696, 348,
        0, 3675, 3677, 1, 0, 0, 0, 3676, 3668, 1, 0, 0, 0, 3676, 3671, 1, 0, 0, 0, 3677, 641, 1, 0, 0,
        0, 3678, 3679, 5, 333, 0, 0, 3679, 3680, 5, 212, 0, 0, 3680, 3681, 3, 696, 348, 0, 3681, 643,
        1, 0, 0, 0, 3682, 3705, 5, 25, 0, 0, 3683, 3705, 5, 289, 0, 0, 3684, 3705, 5, 292, 0, 0, 3685,
        3689, 3, 654, 327, 0, 3686, 3689, 3, 656, 328, 0, 3687, 3689, 5, 191, 0, 0, 3688, 3685, 1,
        0, 0, 0, 3688, 3686, 1, 0, 0, 0, 3688, 3687, 1, 0, 0, 0, 3689, 3691, 1, 0, 0, 0, 3690, 3692, 5,
        182, 0, 0, 3691, 3690, 1, 0, 0, 0, 3691, 3692, 1, 0, 0, 0, 3692, 3705, 1, 0, 0, 0, 3693, 3695,
        5, 307, 0, 0, 3694, 3696, 5, 182, 0, 0, 3695, 3694, 1, 0, 0, 0, 3695, 3696, 1, 0, 0, 0, 3696,
        3700, 1, 0, 0, 0, 3697, 3698, 5, 297, 0, 0, 3698, 3700, 3, 658, 329, 0, 3699, 3693, 1, 0, 0,
        0, 3699, 3697, 1, 0, 0, 0, 3700, 3702, 1, 0, 0, 0, 3701, 3703, 3, 660, 330, 0, 3702, 3701, 1,
        0, 0, 0, 3702, 3703, 1, 0, 0, 0, 3703, 3705, 1, 0, 0, 0, 3704, 3682, 1, 0, 0, 0, 3704, 3683, 1,
        0, 0, 0, 3704, 3684, 1, 0, 0, 0, 3704, 3688, 1, 0, 0, 0, 3704, 3699, 1, 0, 0, 0, 3705, 3706, 1,
        0, 0, 0, 3706, 3707, 5, 212, 0, 0, 3707, 3708, 3, 694, 347, 0, 3708, 645, 1, 0, 0, 0, 3709, 3716,
        5, 35, 0, 0, 3710, 3717, 5, 30, 0, 0, 3711, 3713, 5, 65, 0, 0, 3712, 3711, 1, 0, 0, 0, 3712, 3713,
        1, 0, 0, 0, 3713, 3714, 1, 0, 0, 0, 3714, 3717, 5, 77, 0, 0, 3715, 3717, 5, 321, 0, 0, 3716, 3710,
        1, 0, 0, 0, 3716, 3712, 1, 0, 0, 0, 3716, 3715, 1, 0, 0, 0, 3717, 3740, 1, 0, 0, 0, 3718, 3719,
        5, 42, 0, 0, 3719, 3740, 7, 60, 0, 0, 3720, 3730, 5, 30, 0, 0, 3721, 3723, 5, 65, 0, 0, 3722,
        3721, 1, 0, 0, 0, 3722, 3723, 1, 0, 0, 0, 3723, 3724, 1, 0, 0, 0, 3724, 3730, 5, 77, 0, 0, 3725,
        3730, 5, 231, 0, 0, 3726, 3730, 5, 263, 0, 0, 3727, 3730, 5, 276, 0, 0, 3728, 3730, 5, 321,
        0, 0, 3729, 3720, 1, 0, 0, 0, 3729, 3722, 1, 0, 0, 0, 3729, 3725, 1, 0, 0, 0, 3729, 3726, 1, 0,
        0, 0, 3729, 3727, 1, 0, 0, 0, 3729, 3728, 1, 0, 0, 0, 3730, 3731, 1, 0, 0, 0, 3731, 3740, 5, 182,
        0, 0, 3732, 3740, 3, 648, 324, 0, 3733, 3734, 5, 246, 0, 0, 3734, 3740, 7, 61, 0, 0, 3735, 3737,
        5, 144, 0, 0, 3736, 3738, 3, 660, 330, 0, 3737, 3736, 1, 0, 0, 0, 3737, 3738, 1, 0, 0, 0, 3738,
        3740, 1, 0, 0, 0, 3739, 3709, 1, 0, 0, 0, 3739, 3718, 1, 0, 0, 0, 3739, 3729, 1, 0, 0, 0, 3739,
        3732, 1, 0, 0, 0, 3739, 3733, 1, 0, 0, 0, 3739, 3735, 1, 0, 0, 0, 3740, 3741, 1, 0, 0, 0, 3741,
        3742, 5, 212, 0, 0, 3742, 3743, 5, 81, 0, 0, 3743, 647, 1, 0, 0, 0, 3744, 3765, 5, 114, 0, 0,
        3745, 3746, 3, 650, 325, 0, 3746, 3747, 5, 234, 0, 0, 3747, 3766, 1, 0, 0, 0, 3748, 3750, 5,
        49, 0, 0, 3749, 3748, 1, 0, 0, 0, 3749, 3750, 1, 0, 0, 0, 3750, 3763, 1, 0, 0, 0, 3751, 3752,
        3, 652, 326, 0, 3752, 3753, 3, 664, 332, 0, 3753, 3764, 1, 0, 0, 0, 3754, 3756, 5, 321, 0, 0,
        3755, 3757, 5, 84, 0, 0, 3756, 3755, 1, 0, 0, 0, 3756, 3757, 1, 0, 0, 0, 3757, 3759, 1, 0, 0,
        0, 3758, 3754, 1, 0, 0, 0, 3758, 3759, 1, 0, 0, 0, 3759, 3760, 1, 0, 0, 0, 3760, 3761, 3, 420,
        210, 0, 3761, 3762, 3, 662, 331, 0, 3762, 3764, 1, 0, 0, 0, 3763, 3751, 1, 0, 0, 0, 3763, 3758,
        1, 0, 0, 0, 3764, 3766, 1, 0, 0, 0, 3765, 3745, 1, 0, 0, 0, 3765, 3749, 1, 0, 0, 0, 3766, 649,
        1, 0, 0, 0, 3767, 3768, 7, 62, 0, 0, 3768, 651, 1, 0, 0, 0, 3769, 3770, 7, 35, 0, 0, 3770, 653,
        1, 0, 0, 0, 3771, 3772, 7, 63, 0, 0, 3772, 655, 1, 0, 0, 0, 3773, 3774, 7, 64, 0, 0, 3774, 657,
        1, 0, 0, 0, 3775, 3776, 7, 65, 0, 0, 3776, 659, 1, 0, 0, 0, 3777, 3780, 5, 180, 0, 0, 3778, 3781,
        5, 301, 0, 0, 3779, 3781, 3, 532, 266, 0, 3780, 3778, 1, 0, 0, 0, 3780, 3779, 1, 0, 0, 0, 3781,
        3782, 1, 0, 0, 0, 3782, 3783, 5, 267, 0, 0, 3783, 661, 1, 0, 0, 0, 3784, 3785, 3, 668, 334, 0,
        3785, 663, 1, 0, 0, 0, 3786, 3787, 3, 668, 334, 0, 3787, 665, 1, 0, 0, 0, 3788, 3789, 3, 668,
        334, 0, 3789, 667, 1, 0, 0, 0, 3790, 3795, 3, 670, 335, 0, 3791, 3792, 5, 62, 0, 0, 3792, 3794,
        3, 670, 335, 0, 3793, 3791, 1, 0, 0, 0, 3794, 3797, 1, 0, 0, 0, 3795, 3793, 1, 0, 0, 0, 3795,
        3796, 1, 0, 0, 0, 3796, 669, 1, 0, 0, 0, 3797, 3795, 1, 0, 0, 0, 3798, 3800, 3, 802, 401, 0, 3799,
        3801, 3, 672, 336, 0, 3800, 3799, 1, 0, 0, 0, 3800, 3801, 1, 0, 0, 0, 3801, 3804, 1, 0, 0, 0,
        3802, 3804, 3, 672, 336, 0, 3803, 3798, 1, 0, 0, 0, 3803, 3802, 1, 0, 0, 0, 3804, 671, 1, 0,
        0, 0, 3805, 3807, 3, 674, 337, 0, 3806, 3808, 3, 672, 336, 0, 3807, 3806, 1, 0, 0, 0, 3807,
        3808, 1, 0, 0, 0, 3808, 673, 1, 0, 0, 0, 3809, 3811, 5, 95, 0, 0, 3810, 3812, 3, 802, 401, 0,
        3811, 3810, 1, 0, 0, 0, 3811, 3812, 1, 0, 0, 0, 3812, 3817, 1, 0, 0, 0, 3813, 3817, 5, 239, 0,
        0, 3814, 3817, 5, 301, 0, 0, 3815, 3817, 3, 48, 24, 0, 3816, 3809, 1, 0, 0, 0, 3816, 3813, 1,
        0, 0, 0, 3816, 3814, 1, 0, 0, 0, 3816, 3815, 1, 0, 0, 0, 3817, 675, 1, 0, 0, 0, 3818, 3823, 5,
        309, 0, 0, 3819, 3823, 5, 85, 0, 0, 3820, 3821, 7, 66, 0, 0, 3821, 3823, 3, 680, 340, 0, 3822,
        3818, 1, 0, 0, 0, 3822, 3819, 1, 0, 0, 0, 3822, 3820, 1, 0, 0, 0, 3823, 3824, 1, 0, 0, 0, 3824,
        3825, 5, 212, 0, 0, 3825, 3826, 3, 696, 348, 0, 3826, 3827, 3, 684, 342, 0, 3827, 677, 1, 0,
        0, 0, 3828, 3831, 5, 301, 0, 0, 3829, 3831, 3, 682, 341, 0, 3830, 3828, 1, 0, 0, 0, 3830, 3829,
        1, 0, 0, 0, 3831, 679, 1, 0, 0, 0, 3832, 3835, 5, 171, 0, 0, 3833, 3836, 5, 301, 0, 0, 3834, 3836,
        3, 682, 341, 0, 3835, 3833, 1, 0, 0, 0, 3835, 3834, 1, 0, 0, 0, 3836, 3837, 1, 0, 0, 0, 3837,
        3838, 5, 242, 0, 0, 3838, 681, 1, 0, 0, 0, 3839, 3844, 3, 800, 400, 0, 3840, 3841, 5, 62, 0,
        0, 3841, 3843, 3, 800, 400, 0, 3842, 3840, 1, 0, 0, 0, 3843, 3846, 1, 0, 0, 0, 3844, 3842, 1,
        0, 0, 0, 3844, 3845, 1, 0, 0, 0, 3845, 683, 1, 0, 0, 0, 3846, 3844, 1, 0, 0, 0, 3847, 3850, 3,
        686, 343, 0, 3848, 3851, 5, 301, 0, 0, 3849, 3851, 3, 682, 341, 0, 3850, 3848, 1, 0, 0, 0, 3850,
        3849, 1, 0, 0, 0, 3851, 3929, 1, 0, 0, 0, 3852, 3926, 5, 127, 0, 0, 3853, 3855, 5, 180, 0, 0,
        3854, 3856, 3, 358, 179, 0, 3855, 3854, 1, 0, 0, 0, 3855, 3856, 1, 0, 0, 0, 3856, 3866, 1, 0,
        0, 0, 3857, 3858, 5, 60, 0, 0, 3858, 3863, 3, 800, 400, 0, 3859, 3860, 5, 45, 0, 0, 3860, 3862,
        3, 800, 400, 0, 3861, 3859, 1, 0, 0, 0, 3862, 3865, 1, 0, 0, 0, 3863, 3861, 1, 0, 0, 0, 3863,
        3864, 1, 0, 0, 0, 3864, 3867, 1, 0, 0, 0, 3865, 3863, 1, 0, 0, 0, 3866, 3857, 1, 0, 0, 0, 3866,
        3867, 1, 0, 0, 0, 3867, 3878, 1, 0, 0, 0, 3868, 3869, 5, 267, 0, 0, 3869, 3870, 5, 330, 0, 0,
        3870, 3879, 3, 254, 127, 0, 3871, 3872, 5, 330, 0, 0, 3872, 3875, 3, 254, 127, 0, 3873, 3875,
        3, 792, 396, 0, 3874, 3871, 1, 0, 0, 0, 3874, 3873, 1, 0, 0, 0, 3875, 3876, 1, 0, 0, 0, 3876,
        3877, 5, 267, 0, 0, 3877, 3879, 1, 0, 0, 0, 3878, 3868, 1, 0, 0, 0, 3878, 3874, 1, 0, 0, 0, 3879,
        3927, 1, 0, 0, 0, 3880, 3881, 5, 180, 0, 0, 3881, 3883, 5, 267, 0, 0, 3882, 3884, 3, 232, 116,
        0, 3883, 3882, 1, 0, 0, 0, 3883, 3884, 1, 0, 0, 0, 3884, 3885, 1, 0, 0, 0, 3885, 3886, 3, 234,
        117, 0, 3886, 3888, 5, 170, 0, 0, 3887, 3889, 3, 358, 179, 0, 3888, 3887, 1, 0, 0, 0, 3888,
        3889, 1, 0, 0, 0, 3889, 3899, 1, 0, 0, 0, 3890, 3891, 5, 60, 0, 0, 3891, 3896, 3, 800, 400, 0,
        3892, 3893, 5, 45, 0, 0, 3893, 3895, 3, 800, 400, 0, 3894, 3892, 1, 0, 0, 0, 3895, 3898, 1,
        0, 0, 0, 3896, 3894, 1, 0, 0, 0, 3896, 3897, 1, 0, 0, 0, 3897, 3900, 1, 0, 0, 0, 3898, 3896, 1,
        0, 0, 0, 3899, 3890, 1, 0, 0, 0, 3899, 3900, 1, 0, 0, 0, 3900, 3924, 1, 0, 0, 0, 3901, 3902, 5,
        241, 0, 0, 3902, 3904, 3, 234, 117, 0, 3903, 3905, 3, 236, 118, 0, 3904, 3903, 1, 0, 0, 0, 3904,
        3905, 1, 0, 0, 0, 3905, 3906, 1, 0, 0, 0, 3906, 3907, 5, 180, 0, 0, 3907, 3908, 5, 267, 0, 0,
        3908, 3909, 5, 330, 0, 0, 3909, 3910, 3, 254, 127, 0, 3910, 3925, 1, 0, 0, 0, 3911, 3912, 5,
        330, 0, 0, 3912, 3915, 3, 254, 127, 0, 3913, 3915, 3, 792, 396, 0, 3914, 3911, 1, 0, 0, 0, 3914,
        3913, 1, 0, 0, 0, 3915, 3916, 1, 0, 0, 0, 3916, 3917, 5, 241, 0, 0, 3917, 3919, 3, 234, 117,
        0, 3918, 3920, 3, 236, 118, 0, 3919, 3918, 1, 0, 0, 0, 3919, 3920, 1, 0, 0, 0, 3920, 3921, 1,
        0, 0, 0, 3921, 3922, 5, 180, 0, 0, 3922, 3923, 5, 267, 0, 0, 3923, 3925, 1, 0, 0, 0, 3924, 3901,
        1, 0, 0, 0, 3924, 3914, 1, 0, 0, 0, 3925, 3927, 1, 0, 0, 0, 3926, 3853, 1, 0, 0, 0, 3926, 3880,
        1, 0, 0, 0, 3927, 3929, 1, 0, 0, 0, 3928, 3847, 1, 0, 0, 0, 3928, 3852, 1, 0, 0, 0, 3928, 3929,
        1, 0, 0, 0, 3929, 685, 1, 0, 0, 0, 3930, 3934, 3, 688, 344, 0, 3931, 3934, 3, 692, 346, 0, 3932,
        3934, 3, 690, 345, 0, 3933, 3930, 1, 0, 0, 0, 3933, 3931, 1, 0, 0, 0, 3933, 3932, 1, 0, 0, 0,
        3934, 687, 1, 0, 0, 0, 3935, 3936, 7, 67, 0, 0, 3936, 689, 1, 0, 0, 0, 3937, 3938, 7, 68, 0, 0,
        3938, 691, 1, 0, 0, 0, 3939, 3940, 7, 69, 0, 0, 3940, 693, 1, 0, 0, 0, 3941, 3942, 5, 141, 0,
        0, 3942, 3949, 5, 77, 0, 0, 3943, 3946, 7, 44, 0, 0, 3944, 3947, 5, 301, 0, 0, 3945, 3947, 3,
        772, 386, 0, 3946, 3944, 1, 0, 0, 0, 3946, 3945, 1, 0, 0, 0, 3947, 3949, 1, 0, 0, 0, 3948, 3941,
        1, 0, 0, 0, 3948, 3943, 1, 0, 0, 0, 3949, 695, 1, 0, 0, 0, 3950, 3951, 5, 141, 0, 0, 3951, 3958,
        5, 135, 0, 0, 3952, 3955, 7, 54, 0, 0, 3953, 3956, 5, 301, 0, 0, 3954, 3956, 3, 772, 386, 0,
        3955, 3953, 1, 0, 0, 0, 3955, 3954, 1, 0, 0, 0, 3956, 3958, 1, 0, 0, 0, 3957, 3950, 1, 0, 0, 0,
        3957, 3952, 1, 0, 0, 0, 3958, 697, 1, 0, 0, 0, 3959, 3960, 5, 65, 0, 0, 3960, 3961, 5, 77, 0,
        0, 3961, 3965, 3, 746, 373, 0, 3962, 3963, 5, 143, 0, 0, 3963, 3964, 5, 206, 0, 0, 3964, 3966,
        5, 117, 0, 0, 3965, 3962, 1, 0, 0, 0, 3965, 3966, 1, 0, 0, 0, 3966, 3971, 1, 0, 0, 0, 3967, 3969,
        5, 278, 0, 0, 3968, 3967, 1, 0, 0, 0, 3968, 3969, 1, 0, 0, 0, 3969, 3970, 1, 0, 0, 0, 3970, 3972,
        3, 718, 359, 0, 3971, 3968, 1, 0, 0, 0, 3971, 3972, 1, 0, 0, 0, 3972, 3974, 1, 0, 0, 0, 3973,
        3975, 3, 394, 197, 0, 3974, 3973, 1, 0, 0, 0, 3974, 3975, 1, 0, 0, 0, 3975, 3977, 1, 0, 0, 0,
        3976, 3978, 3, 736, 368, 0, 3977, 3976, 1, 0, 0, 0, 3977, 3978, 1, 0, 0, 0, 3978, 699, 1, 0,
        0, 0, 3979, 3980, 5, 77, 0, 0, 3980, 3984, 3, 746, 373, 0, 3981, 3982, 5, 143, 0, 0, 3982, 3983,
        5, 206, 0, 0, 3983, 3985, 5, 117, 0, 0, 3984, 3981, 1, 0, 0, 0, 3984, 3985, 1, 0, 0, 0, 3985,
        3990, 1, 0, 0, 0, 3986, 3988, 5, 278, 0, 0, 3987, 3986, 1, 0, 0, 0, 3987, 3988, 1, 0, 0, 0, 3988,
        3989, 1, 0, 0, 0, 3989, 3991, 3, 718, 359, 0, 3990, 3987, 1, 0, 0, 0, 3990, 3991, 1, 0, 0, 0,
        3991, 3994, 1, 0, 0, 0, 3992, 3995, 3, 708, 354, 0, 3993, 3995, 3, 702, 351, 0, 3994, 3992,
        1, 0, 0, 0, 3994, 3993, 1, 0, 0, 0, 3994, 3995, 1, 0, 0, 0, 3995, 3997, 1, 0, 0, 0, 3996, 3998,
        3, 394, 197, 0, 3997, 3996, 1, 0, 0, 0, 3997, 3998, 1, 0, 0, 0, 3998, 4000, 1, 0, 0, 0, 3999,
        4001, 3, 736, 368, 0, 4000, 3999, 1, 0, 0, 0, 4000, 4001, 1, 0, 0, 0, 4001, 701, 1, 0, 0, 0, 4002,
        4004, 5, 278, 0, 0, 4003, 4002, 1, 0, 0, 0, 4003, 4004, 1, 0, 0, 0, 4004, 4005, 1, 0, 0, 0, 4005,
        4007, 3, 704, 352, 0, 4006, 4003, 1, 0, 0, 0, 4006, 4007, 1, 0, 0, 0, 4007, 4009, 1, 0, 0, 0,
        4008, 4010, 5, 278, 0, 0, 4009, 4008, 1, 0, 0, 0, 4009, 4010, 1, 0, 0, 0, 4010, 4011, 1, 0, 0,
        0, 4011, 4012, 3, 706, 353, 0, 4012, 703, 1, 0, 0, 0, 4013, 4014, 5, 135, 0, 0, 4014, 4015,
        5, 281, 0, 0, 4015, 4017, 5, 171, 0, 0, 4016, 4018, 3, 708, 354, 0, 4017, 4016, 1, 0, 0, 0, 4017,
        4018, 1, 0, 0, 0, 4018, 4019, 1, 0, 0, 0, 4019, 4020, 5, 242, 0, 0, 4020, 705, 1, 0, 0, 0, 4021,
        4022, 5, 236, 0, 0, 4022, 4023, 7, 70, 0, 0, 4023, 4024, 5, 171, 0, 0, 4024, 4025, 5, 72, 0,
        0, 4025, 4033, 5, 19, 0, 0, 4026, 4028, 5, 278, 0, 0, 4027, 4026, 1, 0, 0, 0, 4027, 4028, 1,
        0, 0, 0, 4028, 4029, 1, 0, 0, 0, 4029, 4030, 5, 305, 0, 0, 4030, 4031, 3, 788, 394, 0, 4031,
        4032, 7, 71, 0, 0, 4032, 4034, 1, 0, 0, 0, 4033, 4027, 1, 0, 0, 0, 4033, 4034, 1, 0, 0, 0, 4034,
        4035, 1, 0, 0, 0, 4035, 4036, 5, 242, 0, 0, 4036, 707, 1, 0, 0, 0, 4037, 4039, 5, 278, 0, 0, 4038,
        4037, 1, 0, 0, 0, 4038, 4039, 1, 0, 0, 0, 4039, 4040, 1, 0, 0, 0, 4040, 4043, 5, 305, 0, 0, 4041,
        4044, 3, 710, 355, 0, 4042, 4044, 3, 714, 357, 0, 4043, 4041, 1, 0, 0, 0, 4043, 4042, 1, 0,
        0, 0, 4044, 4045, 1, 0, 0, 0, 4045, 4043, 1, 0, 0, 0, 4045, 4046, 1, 0, 0, 0, 4046, 709, 1, 0,
        0, 0, 4047, 4048, 3, 788, 394, 0, 4048, 4049, 3, 712, 356, 0, 4049, 711, 1, 0, 0, 0, 4050, 4051,
        7, 72, 0, 0, 4051, 713, 1, 0, 0, 0, 4052, 4053, 3, 788, 394, 0, 4053, 4054, 3, 716, 358, 0, 4054,
        715, 1, 0, 0, 0, 4055, 4056, 7, 73, 0, 0, 4056, 717, 1, 0, 0, 0, 4057, 4058, 5, 83, 0, 0, 4058,
        4059, 5, 169, 0, 0, 4059, 4060, 5, 14, 0, 0, 4060, 4061, 5, 19, 0, 0, 4061, 719, 1, 0, 0, 0, 4062,
        4064, 5, 65, 0, 0, 4063, 4062, 1, 0, 0, 0, 4063, 4064, 1, 0, 0, 0, 4064, 4065, 1, 0, 0, 0, 4065,
        4066, 5, 77, 0, 0, 4066, 4069, 3, 774, 387, 0, 4067, 4068, 5, 143, 0, 0, 4068, 4070, 5, 117,
        0, 0, 4069, 4067, 1, 0, 0, 0, 4069, 4070, 1, 0, 0, 0, 4070, 4072, 1, 0, 0, 0, 4071, 4073, 3, 722,
        361, 0, 4072, 4071, 1, 0, 0, 0, 4072, 4073, 1, 0, 0, 0, 4073, 4076, 1, 0, 0, 0, 4074, 4075, 7,
        74, 0, 0, 4075, 4077, 5, 76, 0, 0, 4076, 4074, 1, 0, 0, 0, 4076, 4077, 1, 0, 0, 0, 4077, 4079,
        1, 0, 0, 0, 4078, 4080, 3, 736, 368, 0, 4079, 4078, 1, 0, 0, 0, 4079, 4080, 1, 0, 0, 0, 4080,
        721, 1, 0, 0, 0, 4081, 4085, 5, 259, 0, 0, 4082, 4083, 5, 55, 0, 0, 4083, 4085, 7, 75, 0, 0, 4084,
        4081, 1, 0, 0, 0, 4084, 4082, 1, 0, 0, 0, 4085, 723, 1, 0, 0, 0, 4086, 4087, 5, 77, 0, 0, 4087,
        4090, 3, 774, 387, 0, 4088, 4089, 5, 143, 0, 0, 4089, 4091, 5, 117, 0, 0, 4090, 4088, 1, 0,
        0, 0, 4090, 4091, 1, 0, 0, 0, 4091, 4110, 1, 0, 0, 0, 4092, 4097, 5, 278, 0, 0, 4093, 4098, 3,
        726, 363, 0, 4094, 4098, 3, 728, 364, 0, 4095, 4098, 3, 730, 365, 0, 4096, 4098, 3, 718, 359,
        0, 4097, 4093, 1, 0, 0, 0, 4097, 4094, 1, 0, 0, 0, 4097, 4095, 1, 0, 0, 0, 4097, 4096, 1, 0, 0,
        0, 4098, 4100, 1, 0, 0, 0, 4099, 4092, 1, 0, 0, 0, 4100, 4101, 1, 0, 0, 0, 4101, 4099, 1, 0, 0,
        0, 4101, 4102, 1, 0, 0, 0, 4102, 4111, 1, 0, 0, 0, 4103, 4104, 5, 251, 0, 0, 4104, 4105, 5, 216,
        0, 0, 4105, 4107, 3, 800, 400, 0, 4106, 4103, 1, 0, 0, 0, 4107, 4108, 1, 0, 0, 0, 4108, 4106,
        1, 0, 0, 0, 4108, 4109, 1, 0, 0, 0, 4109, 4111, 1, 0, 0, 0, 4110, 4099, 1, 0, 0, 0, 4110, 4106,
        1, 0, 0, 0, 4111, 4113, 1, 0, 0, 0, 4112, 4114, 3, 736, 368, 0, 4113, 4112, 1, 0, 0, 0, 4113,
        4114, 1, 0, 0, 0, 4114, 725, 1, 0, 0, 0, 4115, 4116, 5, 25, 0, 0, 4116, 4117, 5, 243, 0, 0, 4117,
        4118, 7, 76, 0, 0, 4118, 727, 1, 0, 0, 0, 4119, 4122, 5, 305, 0, 0, 4120, 4123, 3, 710, 355,
        0, 4121, 4123, 3, 714, 357, 0, 4122, 4120, 1, 0, 0, 0, 4122, 4121, 1, 0, 0, 0, 4123, 4124, 1,
        0, 0, 0, 4124, 4122, 1, 0, 0, 0, 4124, 4125, 1, 0, 0, 0, 4125, 729, 1, 0, 0, 0, 4126, 4127, 5,
        216, 0, 0, 4127, 4128, 3, 800, 400, 0, 4128, 4129, 3, 254, 127, 0, 4129, 731, 1, 0, 0, 0, 4130,
        4131, 5, 289, 0, 0, 4131, 4132, 5, 77, 0, 0, 4132, 4134, 3, 774, 387, 0, 4133, 4135, 3, 736,
        368, 0, 4134, 4133, 1, 0, 0, 0, 4134, 4135, 1, 0, 0, 0, 4135, 733, 1, 0, 0, 0, 4136, 4137, 5,
        292, 0, 0, 4137, 4138, 5, 77, 0, 0, 4138, 4140, 3, 774, 387, 0, 4139, 4141, 3, 736, 368, 0,
        4140, 4139, 1, 0, 0, 0, 4140, 4141, 1, 0, 0, 0, 4141, 735, 1, 0, 0, 0, 4142, 4147, 5, 328, 0,
        0, 4143, 4145, 5, 19, 0, 0, 4144, 4146, 3, 738, 369, 0, 4145, 4144, 1, 0, 0, 0, 4145, 4146,
        1, 0, 0, 0, 4146, 4148, 1, 0, 0, 0, 4147, 4143, 1, 0, 0, 0, 4147, 4148, 1, 0, 0, 0, 4148, 4151,
        1, 0, 0, 0, 4149, 4151, 5, 208, 0, 0, 4150, 4142, 1, 0, 0, 0, 4150, 4149, 1, 0, 0, 0, 4151, 737,
        1, 0, 0, 0, 4152, 4153, 7, 77, 0, 0, 4153, 739, 1, 0, 0, 0, 4154, 4155, 7, 78, 0, 0, 4155, 4157,
        5, 77, 0, 0, 4156, 4158, 3, 384, 192, 0, 4157, 4156, 1, 0, 0, 0, 4157, 4158, 1, 0, 0, 0, 4158,
        4167, 1, 0, 0, 0, 4159, 4161, 7, 44, 0, 0, 4160, 4162, 3, 774, 387, 0, 4161, 4160, 1, 0, 0, 0,
        4161, 4162, 1, 0, 0, 0, 4162, 4164, 1, 0, 0, 0, 4163, 4165, 3, 384, 192, 0, 4164, 4163, 1, 0,
        0, 0, 4164, 4165, 1, 0, 0, 0, 4165, 4167, 1, 0, 0, 0, 4166, 4154, 1, 0, 0, 0, 4166, 4159, 1, 0,
        0, 0, 4167, 741, 1, 0, 0, 0, 4168, 4169, 3, 774, 387, 0, 4169, 743, 1, 0, 0, 0, 4170, 4171, 3,
        774, 387, 0, 4171, 745, 1, 0, 0, 0, 4172, 4173, 3, 766, 383, 0, 4173, 747, 1, 0, 0, 0, 4174,
        4175, 5, 30, 0, 0, 4175, 4179, 3, 742, 371, 0, 4176, 4177, 5, 143, 0, 0, 4177, 4178, 5, 206,
        0, 0, 4178, 4180, 5, 117, 0, 0, 4179, 4176, 1, 0, 0, 0, 4179, 4180, 1, 0, 0, 0, 4180, 4181, 1,
        0, 0, 0, 4181, 4182, 5, 127, 0, 0, 4182, 4183, 5, 77, 0, 0, 4183, 4197, 3, 744, 372, 0, 4184,
        4185, 5, 43, 0, 0, 4185, 4186, 3, 786, 393, 0, 4186, 4187, 5, 321, 0, 0, 4187, 4188, 3, 768,
        384, 0, 4188, 4189, 5, 219, 0, 0, 4189, 4192, 3, 582, 291, 0, 4190, 4191, 5, 98, 0, 0, 4191,
        4193, 3, 790, 395, 0, 4192, 4190, 1, 0, 0, 0, 4192, 4193, 1, 0, 0, 0, 4193, 4195, 1, 0, 0, 0,
        4194, 4196, 3, 718, 359, 0, 4195, 4194, 1, 0, 0, 0, 4195, 4196, 1, 0, 0, 0, 4196, 4198, 1, 0,
        0, 0, 4197, 4184, 1, 0, 0, 0, 4197, 4198, 1, 0, 0, 0, 4198, 4201, 1, 0, 0, 0, 4199, 4200, 5, 235,
        0, 0, 4200, 4202, 3, 790, 395, 0, 4201, 4199, 1, 0, 0, 0, 4201, 4202, 1, 0, 0, 0, 4202, 749,
        1, 0, 0, 0, 4203, 4204, 5, 30, 0, 0, 4204, 4207, 3, 742, 371, 0, 4205, 4206, 5, 143, 0, 0, 4206,
        4208, 5, 117, 0, 0, 4207, 4205, 1, 0, 0, 0, 4207, 4208, 1, 0, 0, 0, 4208, 4209, 1, 0, 0, 0, 4209,
        4210, 5, 127, 0, 0, 4210, 4211, 5, 77, 0, 0, 4211, 751, 1, 0, 0, 0, 4212, 4213, 5, 30, 0, 0, 4213,
        4216, 3, 742, 371, 0, 4214, 4215, 5, 143, 0, 0, 4215, 4217, 5, 117, 0, 0, 4216, 4214, 1, 0,
        0, 0, 4216, 4217, 1, 0, 0, 0, 4217, 4218, 1, 0, 0, 0, 4218, 4219, 5, 278, 0, 0, 4219, 4226, 5,
        77, 0, 0, 4220, 4227, 3, 754, 377, 0, 4221, 4227, 3, 756, 378, 0, 4222, 4227, 3, 758, 379,
        0, 4223, 4227, 3, 760, 380, 0, 4224, 4227, 3, 762, 381, 0, 4225, 4227, 3, 718, 359, 0, 4226,
        4220, 1, 0, 0, 0, 4226, 4221, 1, 0, 0, 0, 4226, 4222, 1, 0, 0, 0, 4226, 4223, 1, 0, 0, 0, 4226,
        4224, 1, 0, 0, 0, 4226, 4225, 1, 0, 0, 0, 4227, 4228, 1, 0, 0, 0, 4228, 4226, 1, 0, 0, 0, 4228,
        4229, 1, 0, 0, 0, 4229, 753, 1, 0, 0, 0, 4230, 4231, 5, 296, 0, 0, 4231, 4234, 3, 744, 372, 0,
        4232, 4233, 5, 43, 0, 0, 4233, 4235, 3, 786, 393, 0, 4234, 4232, 1, 0, 0, 0, 4234, 4235, 1,
        0, 0, 0, 4235, 755, 1, 0, 0, 0, 4236, 4237, 5, 321, 0, 0, 4237, 4238, 3, 768, 384, 0, 4238, 757,
        1, 0, 0, 0, 4239, 4240, 5, 219, 0, 0, 4240, 4241, 3, 582, 291, 0, 4241, 759, 1, 0, 0, 0, 4242,
        4243, 5, 98, 0, 0, 4243, 4244, 3, 790, 395, 0, 4244, 761, 1, 0, 0, 0, 4245, 4246, 5, 235, 0,
        0, 4246, 4247, 3, 790, 395, 0, 4247, 763, 1, 0, 0, 0, 4248, 4250, 7, 75, 0, 0, 4249, 4251, 3,
        742, 371, 0, 4250, 4249, 1, 0, 0, 0, 4250, 4251, 1, 0, 0, 0, 4251, 4252, 1, 0, 0, 0, 4252, 4253,
        5, 127, 0, 0, 4253, 4255, 7, 44, 0, 0, 4254, 4256, 3, 384, 192, 0, 4255, 4254, 1, 0, 0, 0, 4255,
        4256, 1, 0, 0, 0, 4256, 765, 1, 0, 0, 0, 4257, 4260, 3, 800, 400, 0, 4258, 4260, 3, 346, 173,
        0, 4259, 4257, 1, 0, 0, 0, 4259, 4258, 1, 0, 0, 0, 4260, 767, 1, 0, 0, 0, 4261, 4264, 3, 800,
        400, 0, 4262, 4264, 3, 346, 173, 0, 4263, 4261, 1, 0, 0, 0, 4263, 4262, 1, 0, 0, 0, 4264, 769,
        1, 0, 0, 0, 4265, 4270, 3, 768, 384, 0, 4266, 4267, 5, 62, 0, 0, 4267, 4269, 3, 768, 384, 0,
        4268, 4266, 1, 0, 0, 0, 4269, 4272, 1, 0, 0, 0, 4270, 4268, 1, 0, 0, 0, 4270, 4271, 1, 0, 0, 0,
        4271, 771, 1, 0, 0, 0, 4272, 4270, 1, 0, 0, 0, 4273, 4278, 3, 774, 387, 0, 4274, 4275, 5, 62,
        0, 0, 4275, 4277, 3, 774, 387, 0, 4276, 4274, 1, 0, 0, 0, 4277, 4280, 1, 0, 0, 0, 4278, 4276,
        1, 0, 0, 0, 4278, 4279, 1, 0, 0, 0, 4279, 773, 1, 0, 0, 0, 4280, 4278, 1, 0, 0, 0, 4281, 4284,
        3, 776, 388, 0, 4282, 4284, 3, 346, 173, 0, 4283, 4281, 1, 0, 0, 0, 4283, 4282, 1, 0, 0, 0, 4284,
        775, 1, 0, 0, 0, 4285, 4290, 3, 800, 400, 0, 4286, 4287, 5, 95, 0, 0, 4287, 4289, 3, 800, 400,
        0, 4288, 4286, 1, 0, 0, 0, 4289, 4292, 1, 0, 0, 0, 4290, 4288, 1, 0, 0, 0, 4290, 4291, 1, 0, 0,
        0, 4291, 777, 1, 0, 0, 0, 4292, 4290, 1, 0, 0, 0, 4293, 4302, 5, 170, 0, 0, 4294, 4299, 3, 782,
        391, 0, 4295, 4296, 5, 62, 0, 0, 4296, 4298, 3, 782, 391, 0, 4297, 4295, 1, 0, 0, 0, 4298, 4301,
        1, 0, 0, 0, 4299, 4297, 1, 0, 0, 0, 4299, 4300, 1, 0, 0, 0, 4300, 4303, 1, 0, 0, 0, 4301, 4299,
        1, 0, 0, 0, 4302, 4294, 1, 0, 0, 0, 4302, 4303, 1, 0, 0, 0, 4303, 4304, 1, 0, 0, 0, 4304, 4305,
        5, 241, 0, 0, 4305, 779, 1, 0, 0, 0, 4306, 4309, 3, 782, 391, 0, 4307, 4308, 5, 62, 0, 0, 4308,
        4310, 3, 782, 391, 0, 4309, 4307, 1, 0, 0, 0, 4310, 4311, 1, 0, 0, 0, 4311, 4309, 1, 0, 0, 0,
        4311, 4312, 1, 0, 0, 0, 4312, 781, 1, 0, 0, 0, 4313, 4314, 7, 79, 0, 0, 4314, 783, 1, 0, 0, 0,
        4315, 4318, 3, 782, 391, 0, 4316, 4318, 3, 346, 173, 0, 4317, 4315, 1, 0, 0, 0, 4317, 4316,
        1, 0, 0, 0, 4318, 785, 1, 0, 0, 0, 4319, 4322, 3, 782, 391, 0, 4320, 4322, 3, 346, 173, 0, 4321,
        4319, 1, 0, 0, 0, 4321, 4320, 1, 0, 0, 0, 4322, 787, 1, 0, 0, 0, 4323, 4326, 5, 19, 0, 0, 4324,
        4326, 3, 346, 173, 0, 4325, 4323, 1, 0, 0, 0, 4325, 4324, 1, 0, 0, 0, 4326, 789, 1, 0, 0, 0, 4327,
        4330, 3, 792, 396, 0, 4328, 4330, 3, 346, 173, 0, 4329, 4327, 1, 0, 0, 0, 4329, 4328, 1, 0,
        0, 0, 4330, 791, 1, 0, 0, 0, 4331, 4345, 5, 171, 0, 0, 4332, 4333, 3, 344, 172, 0, 4333, 4334,
        5, 60, 0, 0, 4334, 4342, 3, 254, 127, 0, 4335, 4336, 5, 62, 0, 0, 4336, 4337, 3, 344, 172, 0,
        4337, 4338, 5, 60, 0, 0, 4338, 4339, 3, 254, 127, 0, 4339, 4341, 1, 0, 0, 0, 4340, 4335, 1,
        0, 0, 0, 4341, 4344, 1, 0, 0, 0, 4342, 4340, 1, 0, 0, 0, 4342, 4343, 1, 0, 0, 0, 4343, 4346, 1,
        0, 0, 0, 4344, 4342, 1, 0, 0, 0, 4345, 4332, 1, 0, 0, 0, 4345, 4346, 1, 0, 0, 0, 4346, 4347, 1,
        0, 0, 0, 4347, 4348, 5, 242, 0, 0, 4348, 793, 1, 0, 0, 0, 4349, 4352, 3, 796, 398, 0, 4350, 4352,
        3, 798, 399, 0, 4351, 4349, 1, 0, 0, 0, 4351, 4350, 1, 0, 0, 0, 4352, 795, 1, 0, 0, 0, 4353, 4354,
        3, 802, 401, 0, 4354, 797, 1, 0, 0, 0, 4355, 4356, 3, 48, 24, 0, 4356, 799, 1, 0, 0, 0, 4357,
        4360, 3, 802, 401, 0, 4358, 4360, 3, 48, 24, 0, 4359, 4357, 1, 0, 0, 0, 4359, 4358, 1, 0, 0,
        0, 4360, 801, 1, 0, 0, 0, 4361, 4362, 5, 24, 0, 0, 4362, 803, 1, 0, 0, 0, 4363, 4364, 7, 80, 0,
        0, 4364, 805, 1, 0, 0, 0, 4365, 4366, 5, 0, 0, 1, 4366, 807, 1, 0, 0, 0, 550, 813, 817, 823, 838,
        842, 848, 861, 876, 884, 888, 909, 914, 924, 930, 935, 944, 951, 958, 962, 968, 975, 980,
        985, 990, 996, 999, 1012, 1015, 1021, 1042, 1046, 1056, 1064, 1068, 1071, 1074, 1079,
        1083, 1089, 1095, 1108, 1123, 1137, 1162, 1170, 1181, 1184, 1192, 1196, 1200, 1206, 1210,
        1215, 1218, 1223, 1226, 1228, 1238, 1241, 1256, 1263, 1272, 1287, 1295, 1305, 1308, 1311,
        1320, 1324, 1326, 1328, 1338, 1344, 1352, 1363, 1368, 1372, 1378, 1387, 1390, 1396, 1399,
        1405, 1407, 1418, 1422, 1427, 1430, 1442, 1445, 1449, 1452, 1459, 1467, 1473, 1476, 1483,
        1491, 1499, 1503, 1508, 1512, 1522, 1528, 1532, 1534, 1539, 1544, 1548, 1551, 1555, 1559,
        1562, 1568, 1570, 1574, 1586, 1595, 1598, 1601, 1605, 1608, 1617, 1620, 1623, 1626, 1632,
        1636, 1640, 1642, 1647, 1651, 1653, 1663, 1683, 1686, 1696, 1699, 1702, 1705, 1709, 1712,
        1716, 1719, 1729, 1733, 1737, 1741, 1751, 1755, 1758, 1766, 1771, 1779, 1785, 1797, 1805,
        1816, 1824, 1832, 1838, 1848, 1853, 1862, 1867, 1872, 1876, 1881, 1884, 1888, 1897, 1905,
        1913, 1919, 1925, 1935, 1939, 1942, 1955, 1983, 1994, 2000, 2004, 2018, 2022, 2032, 2042,
        2050, 2056, 2058, 2066, 2071, 2108, 2117, 2133, 2136, 2139, 2159, 2162, 2174, 2185, 2189,
        2191, 2199, 2203, 2205, 2215, 2220, 2230, 2233, 2246, 2251, 2258, 2261, 2275, 2285, 2293,
        2298, 2303, 2314, 2331, 2338, 2355, 2361, 2385, 2392, 2394, 2399, 2403, 2407, 2421, 2424,
        2427, 2442, 2447, 2456, 2465, 2475, 2494, 2498, 2501, 2506, 2521, 2524, 2527, 2530, 2533,
        2536, 2546, 2555, 2558, 2566, 2569, 2572, 2576, 2582, 2587, 2593, 2596, 2600, 2604, 2612,
        2616, 2619, 2623, 2626, 2629, 2632, 2636, 2639, 2642, 2651, 2653, 2660, 2668, 2671, 2679,
        2683, 2685, 2688, 2692, 2702, 2711, 2718, 2723, 2728, 2732, 2739, 2747, 2755, 2765, 2771,
        2793, 2796, 2801, 2806, 2811, 2814, 2819, 2824, 2832, 2842, 2850, 2861, 2867, 2873, 2878,
        2883, 2890, 2901, 2909, 2915, 2921, 2930, 2940, 2950, 2954, 2960, 2969, 2977, 2983, 2989,
        2993, 2997, 3001, 3005, 3010, 3014, 3018, 3021, 3025, 3032, 3040, 3048, 3052, 3054, 3062,
        3067, 3071, 3082, 3100, 3104, 3118, 3121, 3127, 3131, 3135, 3143, 3148, 3152, 3158, 3162,
        3171, 3175, 3183, 3186, 3195, 3207, 3224, 3227, 3231, 3242, 3249, 3256, 3262, 3268, 3274,
        3280, 3285, 3288, 3303, 3312, 3316, 3322, 3328, 3346, 3354, 3357, 3361, 3371, 3375, 3380,
        3385, 3388, 3393, 3396, 3403, 3407, 3420, 3428, 3437, 3442, 3445, 3450, 3455, 3458, 3462,
        3465, 3471, 3474, 3478, 3482, 3485, 3489, 3506, 3510, 3516, 3525, 3530, 3533, 3548, 3555,
        3559, 3565, 3571, 3577, 3582, 3587, 3596, 3604, 3611, 3613, 3627, 3631, 3639, 3645, 3648,
        3663, 3676, 3688, 3691, 3695, 3699, 3702, 3704, 3712, 3716, 3722, 3729, 3737, 3739, 3749,
        3756, 3758, 3763, 3765, 3780, 3795, 3800, 3803, 3807, 3811, 3816, 3822, 3830, 3835, 3844,
        3850, 3855, 3863, 3866, 3874, 3878, 3883, 3888, 3896, 3899, 3904, 3914, 3919, 3924, 3926,
        3928, 3933, 3946, 3948, 3955, 3957, 3965, 3968, 3971, 3974, 3977, 3984, 3987, 3990, 3994,
        3997, 4000, 4003, 4006, 4009, 4017, 4027, 4033, 4038, 4043, 4045, 4063, 4069, 4072, 4076,
        4079, 4084, 4090, 4097, 4101, 4108, 4110, 4113, 4122, 4124, 4134, 4140, 4145, 4147, 4150,
        4157, 4161, 4164, 4166, 4179, 4192, 4195, 4197, 4201, 4207, 4216, 4226, 4228, 4234, 4250,
        4255, 4259, 4263, 4270, 4278, 4283, 4290, 4299, 4302, 4311, 4317, 4321, 4325, 4329, 4342,
        4345, 4351, 4359];
    static __ATN;
    static get _ATN() {
        if (!CypherCmdParser.__ATN) {
            CypherCmdParser.__ATN = new ATNDeserializer().deserialize(CypherCmdParser._serializedATN);
        }
        return CypherCmdParser.__ATN;
    }
    static DecisionsToDFA = CypherCmdParser._ATN.decisionToState.map((ds, index) => new DFA(ds, index));
}
export class StatementsOrCommandsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    statementOrCommand_list() {
        return this.getTypedRuleContexts(StatementOrCommandContext);
    }
    statementOrCommand(i) {
        return this.getTypedRuleContext(StatementOrCommandContext, i);
    }
    EOF() {
        return this.getToken(CypherCmdParser.EOF, 0);
    }
    SEMICOLON_list() {
        return this.getTokens(CypherCmdParser.SEMICOLON);
    }
    SEMICOLON(i) {
        return this.getToken(CypherCmdParser.SEMICOLON, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_statementsOrCommands;
    }
    enterRule(listener) {
        if (listener.enterStatementsOrCommands) {
            listener.enterStatementsOrCommands(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStatementsOrCommands) {
            listener.exitStatementsOrCommands(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStatementsOrCommands) {
            return visitor.visitStatementsOrCommands(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StatementOrCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    preparsedStatement() {
        return this.getTypedRuleContext(PreparsedStatementContext, 0);
    }
    consoleCommand() {
        return this.getTypedRuleContext(ConsoleCommandContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_statementOrCommand;
    }
    enterRule(listener) {
        if (listener.enterStatementOrCommand) {
            listener.enterStatementOrCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStatementOrCommand) {
            listener.exitStatementOrCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStatementOrCommand) {
            return visitor.visitStatementOrCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConsoleCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    clearCmd() {
        return this.getTypedRuleContext(ClearCmdContext, 0);
    }
    historyCmd() {
        return this.getTypedRuleContext(HistoryCmdContext, 0);
    }
    useCmd() {
        return this.getTypedRuleContext(UseCmdContext, 0);
    }
    paramsCmd() {
        return this.getTypedRuleContext(ParamsCmdContext, 0);
    }
    serverCmd() {
        return this.getTypedRuleContext(ServerCmdContext, 0);
    }
    connectCmd() {
        return this.getTypedRuleContext(ConnectCmdContext, 0);
    }
    disconnectCmd() {
        return this.getTypedRuleContext(DisconnectCmdContext, 0);
    }
    welcomeCmd() {
        return this.getTypedRuleContext(WelcomeCmdContext, 0);
    }
    sysInfoCmd() {
        return this.getTypedRuleContext(SysInfoCmdContext, 0);
    }
    styleCmd() {
        return this.getTypedRuleContext(StyleCmdContext, 0);
    }
    playCmd() {
        return this.getTypedRuleContext(PlayCmdContext, 0);
    }
    accessModeCmd() {
        return this.getTypedRuleContext(AccessModeCmdContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_consoleCommand;
    }
    enterRule(listener) {
        if (listener.enterConsoleCommand) {
            listener.enterConsoleCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConsoleCommand) {
            listener.exitConsoleCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConsoleCommand) {
            return visitor.visitConsoleCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParamsCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PARAM() {
        return this.getToken(CypherCmdParser.PARAM, 0);
    }
    paramsArgs() {
        return this.getTypedRuleContext(ParamsArgsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_paramsCmd;
    }
    enterRule(listener) {
        if (listener.enterParamsCmd) {
            listener.enterParamsCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParamsCmd) {
            listener.exitParamsCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParamsCmd) {
            return visitor.visitParamsCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParamsArgsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CLEAR() {
        return this.getToken(CypherCmdParser.CLEAR, 0);
    }
    listCompletionRule() {
        return this.getTypedRuleContext(ListCompletionRuleContext, 0);
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    lambda() {
        return this.getTypedRuleContext(LambdaContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_paramsArgs;
    }
    enterRule(listener) {
        if (listener.enterParamsArgs) {
            listener.enterParamsArgs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParamsArgs) {
            listener.exitParamsArgs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParamsArgs) {
            return visitor.visitParamsArgs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LambdaContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    parameterName() {
        return this.getTypedRuleContext(ParameterNameContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    GT() {
        return this.getToken(CypherCmdParser.GT, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_lambda;
    }
    enterRule(listener) {
        if (listener.enterLambda) {
            listener.enterLambda(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLambda) {
            listener.exitLambda(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLambda) {
            return visitor.visitLambda(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ClearCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CLEAR() {
        return this.getToken(CypherCmdParser.CLEAR, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_clearCmd;
    }
    enterRule(listener) {
        if (listener.enterClearCmd) {
            listener.enterClearCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitClearCmd) {
            listener.exitClearCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitClearCmd) {
            return visitor.visitClearCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class HistoryCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    HISTORY() {
        return this.getToken(CypherCmdParser.HISTORY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_historyCmd;
    }
    enterRule(listener) {
        if (listener.enterHistoryCmd) {
            listener.enterHistoryCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitHistoryCmd) {
            listener.exitHistoryCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitHistoryCmd) {
            return visitor.visitHistoryCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UseCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    useCompletionRule() {
        return this.getTypedRuleContext(UseCompletionRuleContext, 0);
    }
    symbolicAliasName() {
        return this.getTypedRuleContext(SymbolicAliasNameContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_useCmd;
    }
    enterRule(listener) {
        if (listener.enterUseCmd) {
            listener.enterUseCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUseCmd) {
            listener.exitUseCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUseCmd) {
            return visitor.visitUseCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ServerCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    serverCompletionRule() {
        return this.getTypedRuleContext(ServerCompletionRuleContext, 0);
    }
    serverArgs() {
        return this.getTypedRuleContext(ServerArgsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_serverCmd;
    }
    enterRule(listener) {
        if (listener.enterServerCmd) {
            listener.enterServerCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitServerCmd) {
            listener.exitServerCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitServerCmd) {
            return visitor.visitServerCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ServerArgsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CONNECT() {
        return this.getToken(CypherCmdParser.CONNECT, 0);
    }
    DISCONNECT() {
        return this.getToken(CypherCmdParser.DISCONNECT, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_serverArgs;
    }
    enterRule(listener) {
        if (listener.enterServerArgs) {
            listener.enterServerArgs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitServerArgs) {
            listener.exitServerArgs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitServerArgs) {
            return visitor.visitServerArgs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConnectCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CONNECT() {
        return this.getToken(CypherCmdParser.CONNECT, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_connectCmd;
    }
    enterRule(listener) {
        if (listener.enterConnectCmd) {
            listener.enterConnectCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConnectCmd) {
            listener.exitConnectCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConnectCmd) {
            return visitor.visitConnectCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DisconnectCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DISCONNECT() {
        return this.getToken(CypherCmdParser.DISCONNECT, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_disconnectCmd;
    }
    enterRule(listener) {
        if (listener.enterDisconnectCmd) {
            listener.enterDisconnectCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDisconnectCmd) {
            listener.exitDisconnectCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDisconnectCmd) {
            return visitor.visitDisconnectCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SysInfoCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SYSINFO() {
        return this.getToken(CypherCmdParser.SYSINFO, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_sysInfoCmd;
    }
    enterRule(listener) {
        if (listener.enterSysInfoCmd) {
            listener.enterSysInfoCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSysInfoCmd) {
            listener.exitSysInfoCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSysInfoCmd) {
            return visitor.visitSysInfoCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StyleCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STYLE() {
        return this.getToken(CypherCmdParser.STYLE, 0);
    }
    RESET() {
        return this.getToken(CypherCmdParser.RESET, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_styleCmd;
    }
    enterRule(listener) {
        if (listener.enterStyleCmd) {
            listener.enterStyleCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStyleCmd) {
            listener.exitStyleCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStyleCmd) {
            return visitor.visitStyleCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WelcomeCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WELCOME() {
        return this.getToken(CypherCmdParser.WELCOME, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_welcomeCmd;
    }
    enterRule(listener) {
        if (listener.enterWelcomeCmd) {
            listener.enterWelcomeCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWelcomeCmd) {
            listener.exitWelcomeCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWelcomeCmd) {
            return visitor.visitWelcomeCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PlayCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PLAY() {
        return this.getToken(CypherCmdParser.PLAY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_playCmd;
    }
    enterRule(listener) {
        if (listener.enterPlayCmd) {
            listener.enterPlayCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPlayCmd) {
            listener.exitPlayCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPlayCmd) {
            return visitor.visitPlayCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AccessModeArgsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    readCompletionRule() {
        return this.getTypedRuleContext(ReadCompletionRuleContext, 0);
    }
    writeCompletionRule() {
        return this.getTypedRuleContext(WriteCompletionRuleContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_accessModeArgs;
    }
    enterRule(listener) {
        if (listener.enterAccessModeArgs) {
            listener.enterAccessModeArgs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAccessModeArgs) {
            listener.exitAccessModeArgs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAccessModeArgs) {
            return visitor.visitAccessModeArgs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AccessModeCmdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ACCESSMODE() {
        return this.getToken(CypherCmdParser.ACCESSMODE, 0);
    }
    accessModeArgs() {
        return this.getTypedRuleContext(AccessModeArgsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_accessModeCmd;
    }
    enterRule(listener) {
        if (listener.enterAccessModeCmd) {
            listener.enterAccessModeCmd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAccessModeCmd) {
            listener.exitAccessModeCmd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAccessModeCmd) {
            return visitor.visitAccessModeCmd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ListCompletionRuleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LIST() {
        return this.getToken(CypherCmdParser.LIST, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_listCompletionRule;
    }
    enterRule(listener) {
        if (listener.enterListCompletionRule) {
            listener.enterListCompletionRule(this);
        }
    }
    exitRule(listener) {
        if (listener.exitListCompletionRule) {
            listener.exitListCompletionRule(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitListCompletionRule) {
            return visitor.visitListCompletionRule(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UseCompletionRuleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USE() {
        return this.getToken(CypherCmdParser.USE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_useCompletionRule;
    }
    enterRule(listener) {
        if (listener.enterUseCompletionRule) {
            listener.enterUseCompletionRule(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUseCompletionRule) {
            listener.exitUseCompletionRule(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUseCompletionRule) {
            return visitor.visitUseCompletionRule(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ServerCompletionRuleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_serverCompletionRule;
    }
    enterRule(listener) {
        if (listener.enterServerCompletionRule) {
            listener.enterServerCompletionRule(this);
        }
    }
    exitRule(listener) {
        if (listener.exitServerCompletionRule) {
            listener.exitServerCompletionRule(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitServerCompletionRule) {
            return visitor.visitServerCompletionRule(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReadCompletionRuleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    READ() {
        return this.getToken(CypherCmdParser.READ, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_readCompletionRule;
    }
    enterRule(listener) {
        if (listener.enterReadCompletionRule) {
            listener.enterReadCompletionRule(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReadCompletionRule) {
            listener.exitReadCompletionRule(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReadCompletionRule) {
            return visitor.visitReadCompletionRule(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WriteCompletionRuleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WRITE() {
        return this.getToken(CypherCmdParser.WRITE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_writeCompletionRule;
    }
    enterRule(listener) {
        if (listener.enterWriteCompletionRule) {
            listener.enterWriteCompletionRule(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWriteCompletionRule) {
            listener.exitWriteCompletionRule(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWriteCompletionRule) {
            return visitor.visitWriteCompletionRule(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UnescapedSymbolicNameStringContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    preparserKeyword() {
        return this.getTypedRuleContext(PreparserKeywordContext, 0);
    }
    HISTORY() {
        return this.getToken(CypherCmdParser.HISTORY, 0);
    }
    CLEAR() {
        return this.getToken(CypherCmdParser.CLEAR, 0);
    }
    PARAM() {
        return this.getToken(CypherCmdParser.PARAM, 0);
    }
    CONNECT() {
        return this.getToken(CypherCmdParser.CONNECT, 0);
    }
    DISCONNECT() {
        return this.getToken(CypherCmdParser.DISCONNECT, 0);
    }
    WELCOME() {
        return this.getToken(CypherCmdParser.WELCOME, 0);
    }
    SYSINFO() {
        return this.getToken(CypherCmdParser.SYSINFO, 0);
    }
    unescapedSymbolicNameString_() {
        return this.getTypedRuleContext(UnescapedSymbolicNameString_Context, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_unescapedSymbolicNameString;
    }
    enterRule(listener) {
        if (listener.enterUnescapedSymbolicNameString) {
            listener.enterUnescapedSymbolicNameString(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUnescapedSymbolicNameString) {
            listener.exitUnescapedSymbolicNameString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnescapedSymbolicNameString) {
            return visitor.visitUnescapedSymbolicNameString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PreparsedStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    statement() {
        return this.getTypedRuleContext(StatementContext, 0);
    }
    preparserOption_list() {
        return this.getTypedRuleContexts(PreparserOptionContext);
    }
    preparserOption(i) {
        return this.getTypedRuleContext(PreparserOptionContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_preparsedStatement;
    }
    enterRule(listener) {
        if (listener.enterPreparsedStatement) {
            listener.enterPreparsedStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPreparsedStatement) {
            listener.exitPreparsedStatement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPreparsedStatement) {
            return visitor.visitPreparsedStatement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PreparserKeywordContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXPLAIN() {
        return this.getToken(CypherCmdParser.EXPLAIN, 0);
    }
    PROFILE() {
        return this.getToken(CypherCmdParser.PROFILE, 0);
    }
    CYPHER() {
        return this.getToken(CypherCmdParser.CYPHER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_preparserKeyword;
    }
    enterRule(listener) {
        if (listener.enterPreparserKeyword) {
            listener.enterPreparserKeyword(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPreparserKeyword) {
            listener.exitPreparserKeyword(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPreparserKeyword) {
            return visitor.visitPreparserKeyword(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PreparserOptionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXPLAIN() {
        return this.getToken(CypherCmdParser.EXPLAIN, 0);
    }
    PROFILE() {
        return this.getToken(CypherCmdParser.PROFILE, 0);
    }
    cypherOptions() {
        return this.getTypedRuleContext(CypherOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_preparserOption;
    }
    enterRule(listener) {
        if (listener.enterPreparserOption) {
            listener.enterPreparserOption(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPreparserOption) {
            listener.exitPreparserOption(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPreparserOption) {
            return visitor.visitPreparserOption(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CypherContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CYPHER() {
        return this.getToken(CypherCmdParser.CYPHER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_cypher;
    }
    enterRule(listener) {
        if (listener.enterCypher) {
            listener.enterCypher(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCypher) {
            listener.exitCypher(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCypher) {
            return visitor.visitCypher(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CypherOptionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    cypher() {
        return this.getTypedRuleContext(CypherContext, 0);
    }
    cypherVersion() {
        return this.getTypedRuleContext(CypherVersionContext, 0);
    }
    cypherOption_list() {
        return this.getTypedRuleContexts(CypherOptionContext);
    }
    cypherOption(i) {
        return this.getTypedRuleContext(CypherOptionContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_cypherOptions;
    }
    enterRule(listener) {
        if (listener.enterCypherOptions) {
            listener.enterCypherOptions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCypherOptions) {
            listener.exitCypherOptions(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCypherOptions) {
            return visitor.visitCypherOptions(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CypherOptionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    cypherOptionName() {
        return this.getTypedRuleContext(CypherOptionNameContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    cypherOptionValue() {
        return this.getTypedRuleContext(CypherOptionValueContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_cypherOption;
    }
    enterRule(listener) {
        if (listener.enterCypherOption) {
            listener.enterCypherOption(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCypherOption) {
            listener.exitCypherOption(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCypherOption) {
            return visitor.visitCypherOption(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CypherOptionValueContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    unescapedSymbolicNameString() {
        return this.getTypedRuleContext(UnescapedSymbolicNameStringContext, 0);
    }
    numberLiteral() {
        return this.getTypedRuleContext(NumberLiteralContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_cypherOptionValue;
    }
    enterRule(listener) {
        if (listener.enterCypherOptionValue) {
            listener.enterCypherOptionValue(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCypherOptionValue) {
            listener.exitCypherOptionValue(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCypherOptionValue) {
            return visitor.visitCypherOptionValue(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CypherOptionNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    unescapedSymbolicNameString() {
        return this.getTypedRuleContext(UnescapedSymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_cypherOptionName;
    }
    enterRule(listener) {
        if (listener.enterCypherOptionName) {
            listener.enterCypherOptionName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCypherOptionName) {
            listener.exitCypherOptionName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCypherOptionName) {
            return visitor.visitCypherOptionName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CypherVersionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXTENDED_IDENTIFIER_list() {
        return this.getTokens(CypherCmdParser.EXTENDED_IDENTIFIER);
    }
    EXTENDED_IDENTIFIER(i) {
        return this.getToken(CypherCmdParser.EXTENDED_IDENTIFIER, i);
    }
    UNSIGNED_DECIMAL_INTEGER_list() {
        return this.getTokens(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
    }
    UNSIGNED_DECIMAL_INTEGER(i) {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, i);
    }
    DOT_list() {
        return this.getTokens(CypherCmdParser.DOT);
    }
    DOT(i) {
        return this.getToken(CypherCmdParser.DOT, i);
    }
    DECIMAL_DOUBLE_list() {
        return this.getTokens(CypherCmdParser.DECIMAL_DOUBLE);
    }
    DECIMAL_DOUBLE(i) {
        return this.getToken(CypherCmdParser.DECIMAL_DOUBLE, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_cypherVersion;
    }
    enterRule(listener) {
        if (listener.enterCypherVersion) {
            listener.enterCypherVersion(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCypherVersion) {
            listener.exitCypherVersion(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCypherVersion) {
            return visitor.visitCypherVersion(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StatementsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    statement_list() {
        return this.getTypedRuleContexts(StatementContext);
    }
    statement(i) {
        return this.getTypedRuleContext(StatementContext, i);
    }
    EOF() {
        return this.getToken(CypherCmdParser.EOF, 0);
    }
    SEMICOLON_list() {
        return this.getTokens(CypherCmdParser.SEMICOLON);
    }
    SEMICOLON(i) {
        return this.getToken(CypherCmdParser.SEMICOLON, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_statements;
    }
    enterRule(listener) {
        if (listener.enterStatements) {
            listener.enterStatements(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStatements) {
            listener.exitStatements(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStatements) {
            return visitor.visitStatements(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    command() {
        return this.getTypedRuleContext(CommandContext, 0);
    }
    nextStatement() {
        return this.getTypedRuleContext(NextStatementContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_statement;
    }
    enterRule(listener) {
        if (listener.enterStatement) {
            listener.enterStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStatement) {
            listener.exitStatement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStatement) {
            return visitor.visitStatement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NextStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    regularQuery_list() {
        return this.getTypedRuleContexts(RegularQueryContext);
    }
    regularQuery(i) {
        return this.getTypedRuleContext(RegularQueryContext, i);
    }
    NEXT_list() {
        return this.getTokens(CypherCmdParser.NEXT);
    }
    NEXT(i) {
        return this.getToken(CypherCmdParser.NEXT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nextStatement;
    }
    enterRule(listener) {
        if (listener.enterNextStatement) {
            listener.enterNextStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNextStatement) {
            listener.exitNextStatement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNextStatement) {
            return visitor.visitNextStatement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RegularQueryContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    union() {
        return this.getTypedRuleContext(UnionContext, 0);
    }
    when() {
        return this.getTypedRuleContext(WhenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_regularQuery;
    }
    enterRule(listener) {
        if (listener.enterRegularQuery) {
            listener.enterRegularQuery(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRegularQuery) {
            listener.exitRegularQuery(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRegularQuery) {
            return visitor.visitRegularQuery(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UnionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    singleQuery_list() {
        return this.getTypedRuleContexts(SingleQueryContext);
    }
    singleQuery(i) {
        return this.getTypedRuleContext(SingleQueryContext, i);
    }
    UNION_list() {
        return this.getTokens(CypherCmdParser.UNION);
    }
    UNION(i) {
        return this.getToken(CypherCmdParser.UNION, i);
    }
    ALL_list() {
        return this.getTokens(CypherCmdParser.ALL);
    }
    ALL(i) {
        return this.getToken(CypherCmdParser.ALL, i);
    }
    DISTINCT_list() {
        return this.getTokens(CypherCmdParser.DISTINCT);
    }
    DISTINCT(i) {
        return this.getToken(CypherCmdParser.DISTINCT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_union;
    }
    enterRule(listener) {
        if (listener.enterUnion) {
            listener.enterUnion(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUnion) {
            listener.exitUnion(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnion) {
            return visitor.visitUnion(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WhenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    whenBranch_list() {
        return this.getTypedRuleContexts(WhenBranchContext);
    }
    whenBranch(i) {
        return this.getTypedRuleContext(WhenBranchContext, i);
    }
    elseBranch() {
        return this.getTypedRuleContext(ElseBranchContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_when;
    }
    enterRule(listener) {
        if (listener.enterWhen) {
            listener.enterWhen(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhen) {
            listener.exitWhen(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWhen) {
            return visitor.visitWhen(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WhenBranchContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WHEN() {
        return this.getToken(CypherCmdParser.WHEN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    THEN() {
        return this.getToken(CypherCmdParser.THEN, 0);
    }
    singleQuery() {
        return this.getTypedRuleContext(SingleQueryContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_whenBranch;
    }
    enterRule(listener) {
        if (listener.enterWhenBranch) {
            listener.enterWhenBranch(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhenBranch) {
            listener.exitWhenBranch(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWhenBranch) {
            return visitor.visitWhenBranch(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ElseBranchContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ELSE() {
        return this.getToken(CypherCmdParser.ELSE, 0);
    }
    singleQuery() {
        return this.getTypedRuleContext(SingleQueryContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_elseBranch;
    }
    enterRule(listener) {
        if (listener.enterElseBranch) {
            listener.enterElseBranch(this);
        }
    }
    exitRule(listener) {
        if (listener.exitElseBranch) {
            listener.exitElseBranch(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitElseBranch) {
            return visitor.visitElseBranch(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SingleQueryContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    clause_list() {
        return this.getTypedRuleContexts(ClauseContext);
    }
    clause(i) {
        return this.getTypedRuleContext(ClauseContext, i);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    nextStatement() {
        return this.getTypedRuleContext(NextStatementContext, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    useClause() {
        return this.getTypedRuleContext(UseClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_singleQuery;
    }
    enterRule(listener) {
        if (listener.enterSingleQuery) {
            listener.enterSingleQuery(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSingleQuery) {
            listener.exitSingleQuery(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSingleQuery) {
            return visitor.visitSingleQuery(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    useClause() {
        return this.getTypedRuleContext(UseClauseContext, 0);
    }
    finishClause() {
        return this.getTypedRuleContext(FinishClauseContext, 0);
    }
    returnClause() {
        return this.getTypedRuleContext(ReturnClauseContext, 0);
    }
    createClause() {
        return this.getTypedRuleContext(CreateClauseContext, 0);
    }
    insertClause() {
        return this.getTypedRuleContext(InsertClauseContext, 0);
    }
    deleteClause() {
        return this.getTypedRuleContext(DeleteClauseContext, 0);
    }
    setClause() {
        return this.getTypedRuleContext(SetClauseContext, 0);
    }
    removeClause() {
        return this.getTypedRuleContext(RemoveClauseContext, 0);
    }
    matchClause() {
        return this.getTypedRuleContext(MatchClauseContext, 0);
    }
    mergeClause() {
        return this.getTypedRuleContext(MergeClauseContext, 0);
    }
    withClause() {
        return this.getTypedRuleContext(WithClauseContext, 0);
    }
    filterClause() {
        return this.getTypedRuleContext(FilterClauseContext, 0);
    }
    unwindClause() {
        return this.getTypedRuleContext(UnwindClauseContext, 0);
    }
    letClause() {
        return this.getTypedRuleContext(LetClauseContext, 0);
    }
    callClause() {
        return this.getTypedRuleContext(CallClauseContext, 0);
    }
    subqueryClause() {
        return this.getTypedRuleContext(SubqueryClauseContext, 0);
    }
    loadCSVClause() {
        return this.getTypedRuleContext(LoadCSVClauseContext, 0);
    }
    foreachClause() {
        return this.getTypedRuleContext(ForeachClauseContext, 0);
    }
    orderBySkipLimitClause() {
        return this.getTypedRuleContext(OrderBySkipLimitClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_clause;
    }
    enterRule(listener) {
        if (listener.enterClause) {
            listener.enterClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitClause) {
            listener.exitClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitClause) {
            return visitor.visitClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UseClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USE() {
        return this.getToken(CypherCmdParser.USE, 0);
    }
    graphReference() {
        return this.getTypedRuleContext(GraphReferenceContext, 0);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_useClause;
    }
    enterRule(listener) {
        if (listener.enterUseClause) {
            listener.enterUseClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUseClause) {
            listener.exitUseClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUseClause) {
            return visitor.visitUseClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    graphReference() {
        return this.getTypedRuleContext(GraphReferenceContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    functionInvocation() {
        return this.getTypedRuleContext(FunctionInvocationContext, 0);
    }
    symbolicAliasName() {
        return this.getTypedRuleContext(SymbolicAliasNameContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphReference;
    }
    enterRule(listener) {
        if (listener.enterGraphReference) {
            listener.enterGraphReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphReference) {
            listener.exitGraphReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphReference) {
            return visitor.visitGraphReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FinishClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FINISH() {
        return this.getToken(CypherCmdParser.FINISH, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_finishClause;
    }
    enterRule(listener) {
        if (listener.enterFinishClause) {
            listener.enterFinishClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFinishClause) {
            listener.exitFinishClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFinishClause) {
            return visitor.visitFinishClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReturnClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    RETURN() {
        return this.getToken(CypherCmdParser.RETURN, 0);
    }
    returnBody() {
        return this.getTypedRuleContext(ReturnBodyContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_returnClause;
    }
    enterRule(listener) {
        if (listener.enterReturnClause) {
            listener.enterReturnClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReturnClause) {
            listener.exitReturnClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReturnClause) {
            return visitor.visitReturnClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReturnBodyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    returnItems() {
        return this.getTypedRuleContext(ReturnItemsContext, 0);
    }
    orderBy() {
        return this.getTypedRuleContext(OrderByContext, 0);
    }
    skip() {
        return this.getTypedRuleContext(SkipContext, 0);
    }
    limit() {
        return this.getTypedRuleContext(LimitContext, 0);
    }
    DISTINCT() {
        return this.getToken(CypherCmdParser.DISTINCT, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_returnBody;
    }
    enterRule(listener) {
        if (listener.enterReturnBody) {
            listener.enterReturnBody(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReturnBody) {
            listener.exitReturnBody(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReturnBody) {
            return visitor.visitReturnBody(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReturnItemContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_returnItem;
    }
    enterRule(listener) {
        if (listener.enterReturnItem) {
            listener.enterReturnItem(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReturnItem) {
            listener.exitReturnItem(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReturnItem) {
            return visitor.visitReturnItem(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReturnItemsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    returnItem_list() {
        return this.getTypedRuleContexts(ReturnItemContext);
    }
    returnItem(i) {
        return this.getTypedRuleContext(ReturnItemContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_returnItems;
    }
    enterRule(listener) {
        if (listener.enterReturnItems) {
            listener.enterReturnItems(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReturnItems) {
            listener.exitReturnItems(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReturnItems) {
            return visitor.visitReturnItems(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class OrderItemContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    ascToken() {
        return this.getTypedRuleContext(AscTokenContext, 0);
    }
    descToken() {
        return this.getTypedRuleContext(DescTokenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_orderItem;
    }
    enterRule(listener) {
        if (listener.enterOrderItem) {
            listener.enterOrderItem(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderItem) {
            listener.exitOrderItem(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitOrderItem) {
            return visitor.visitOrderItem(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AscTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ASC() {
        return this.getToken(CypherCmdParser.ASC, 0);
    }
    ASCENDING() {
        return this.getToken(CypherCmdParser.ASCENDING, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_ascToken;
    }
    enterRule(listener) {
        if (listener.enterAscToken) {
            listener.enterAscToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAscToken) {
            listener.exitAscToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAscToken) {
            return visitor.visitAscToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DescTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DESC() {
        return this.getToken(CypherCmdParser.DESC, 0);
    }
    DESCENDING() {
        return this.getToken(CypherCmdParser.DESCENDING, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_descToken;
    }
    enterRule(listener) {
        if (listener.enterDescToken) {
            listener.enterDescToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDescToken) {
            listener.exitDescToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDescToken) {
            return visitor.visitDescToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class OrderByContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ORDER() {
        return this.getToken(CypherCmdParser.ORDER, 0);
    }
    BY() {
        return this.getToken(CypherCmdParser.BY, 0);
    }
    orderItem_list() {
        return this.getTypedRuleContexts(OrderItemContext);
    }
    orderItem(i) {
        return this.getTypedRuleContext(OrderItemContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_orderBy;
    }
    enterRule(listener) {
        if (listener.enterOrderBy) {
            listener.enterOrderBy(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderBy) {
            listener.exitOrderBy(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitOrderBy) {
            return visitor.visitOrderBy(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SkipContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    OFFSET() {
        return this.getToken(CypherCmdParser.OFFSET, 0);
    }
    SKIPROWS() {
        return this.getToken(CypherCmdParser.SKIPROWS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_skip;
    }
    enterRule(listener) {
        if (listener.enterSkip) {
            listener.enterSkip(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSkip) {
            listener.exitSkip(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSkip) {
            return visitor.visitSkip(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LimitContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LIMITROWS() {
        return this.getToken(CypherCmdParser.LIMITROWS, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_limit;
    }
    enterRule(listener) {
        if (listener.enterLimit) {
            listener.enterLimit(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLimit) {
            listener.exitLimit(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLimit) {
            return visitor.visitLimit(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WhereClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_whereClause;
    }
    enterRule(listener) {
        if (listener.enterWhereClause) {
            listener.enterWhereClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhereClause) {
            listener.exitWhereClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWhereClause) {
            return visitor.visitWhereClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WithClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    returnBody() {
        return this.getTypedRuleContext(ReturnBodyContext, 0);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_withClause;
    }
    enterRule(listener) {
        if (listener.enterWithClause) {
            listener.enterWithClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWithClause) {
            listener.exitWithClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWithClause) {
            return visitor.visitWithClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CREATE() {
        return this.getToken(CypherCmdParser.CREATE, 0);
    }
    patternList() {
        return this.getTypedRuleContext(PatternListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createClause;
    }
    enterRule(listener) {
        if (listener.enterCreateClause) {
            listener.enterCreateClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateClause) {
            listener.exitCreateClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateClause) {
            return visitor.visitCreateClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    INSERT() {
        return this.getToken(CypherCmdParser.INSERT, 0);
    }
    insertPatternList() {
        return this.getTypedRuleContext(InsertPatternListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertClause;
    }
    enterRule(listener) {
        if (listener.enterInsertClause) {
            listener.enterInsertClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertClause) {
            listener.exitInsertClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertClause) {
            return visitor.visitInsertClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    setItem_list() {
        return this.getTypedRuleContexts(SetItemContext);
    }
    setItem(i) {
        return this.getTypedRuleContext(SetItemContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_setClause;
    }
    enterRule(listener) {
        if (listener.enterSetClause) {
            listener.enterSetClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetClause) {
            listener.exitSetClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetClause) {
            return visitor.visitSetClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetItemContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_setItem;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class SetPropContext extends SetItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    propertyExpression() {
        return this.getTypedRuleContext(PropertyExpressionContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterSetProp) {
            listener.enterSetProp(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetProp) {
            listener.exitSetProp(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetProp) {
            return visitor.visitSetProp(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AddPropContext extends SetItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    PLUSEQUAL() {
        return this.getToken(CypherCmdParser.PLUSEQUAL, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAddProp) {
            listener.enterAddProp(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAddProp) {
            listener.exitAddProp(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAddProp) {
            return visitor.visitAddProp(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetDynamicPropContext extends SetItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    dynamicPropertyExpression() {
        return this.getTypedRuleContext(DynamicPropertyExpressionContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterSetDynamicProp) {
            listener.enterSetDynamicProp(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetDynamicProp) {
            listener.exitSetDynamicProp(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetDynamicProp) {
            return visitor.visitSetDynamicProp(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetPropsContext extends SetItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterSetProps) {
            listener.enterSetProps(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetProps) {
            listener.exitSetProps(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetProps) {
            return visitor.visitSetProps(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetLabelsContext extends SetItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    nodeLabels() {
        return this.getTypedRuleContext(NodeLabelsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterSetLabels) {
            listener.enterSetLabels(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetLabels) {
            listener.exitSetLabels(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetLabels) {
            return visitor.visitSetLabels(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetLabelsIsContext extends SetItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    nodeLabelsIs() {
        return this.getTypedRuleContext(NodeLabelsIsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterSetLabelsIs) {
            listener.enterSetLabelsIs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetLabelsIs) {
            listener.exitSetLabelsIs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetLabelsIs) {
            return visitor.visitSetLabelsIs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemoveClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REMOVE() {
        return this.getToken(CypherCmdParser.REMOVE, 0);
    }
    removeItem_list() {
        return this.getTypedRuleContexts(RemoveItemContext);
    }
    removeItem(i) {
        return this.getTypedRuleContext(RemoveItemContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_removeClause;
    }
    enterRule(listener) {
        if (listener.enterRemoveClause) {
            listener.enterRemoveClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemoveClause) {
            listener.exitRemoveClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemoveClause) {
            return visitor.visitRemoveClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemoveItemContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_removeItem;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class RemoveLabelsIsContext extends RemoveItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    nodeLabelsIs() {
        return this.getTypedRuleContext(NodeLabelsIsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterRemoveLabelsIs) {
            listener.enterRemoveLabelsIs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemoveLabelsIs) {
            listener.exitRemoveLabelsIs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemoveLabelsIs) {
            return visitor.visitRemoveLabelsIs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemoveDynamicPropContext extends RemoveItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    dynamicPropertyExpression() {
        return this.getTypedRuleContext(DynamicPropertyExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterRemoveDynamicProp) {
            listener.enterRemoveDynamicProp(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemoveDynamicProp) {
            listener.exitRemoveDynamicProp(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemoveDynamicProp) {
            return visitor.visitRemoveDynamicProp(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemoveLabelsContext extends RemoveItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    nodeLabels() {
        return this.getTypedRuleContext(NodeLabelsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterRemoveLabels) {
            listener.enterRemoveLabels(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemoveLabels) {
            listener.exitRemoveLabels(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemoveLabels) {
            return visitor.visitRemoveLabels(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemovePropContext extends RemoveItemContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    propertyExpression() {
        return this.getTypedRuleContext(PropertyExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterRemoveProp) {
            listener.enterRemoveProp(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemoveProp) {
            listener.exitRemoveProp(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemoveProp) {
            return visitor.visitRemoveProp(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DeleteClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DELETE() {
        return this.getToken(CypherCmdParser.DELETE, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    DETACH() {
        return this.getToken(CypherCmdParser.DETACH, 0);
    }
    NODETACH() {
        return this.getToken(CypherCmdParser.NODETACH, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_deleteClause;
    }
    enterRule(listener) {
        if (listener.enterDeleteClause) {
            listener.enterDeleteClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDeleteClause) {
            listener.exitDeleteClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDeleteClause) {
            return visitor.visitDeleteClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MatchClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    MATCH() {
        return this.getToken(CypherCmdParser.MATCH, 0);
    }
    patternList() {
        return this.getTypedRuleContext(PatternListContext, 0);
    }
    OPTIONAL() {
        return this.getToken(CypherCmdParser.OPTIONAL, 0);
    }
    matchMode() {
        return this.getTypedRuleContext(MatchModeContext, 0);
    }
    hint_list() {
        return this.getTypedRuleContexts(HintContext);
    }
    hint(i) {
        return this.getTypedRuleContext(HintContext, i);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_matchClause;
    }
    enterRule(listener) {
        if (listener.enterMatchClause) {
            listener.enterMatchClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMatchClause) {
            listener.exitMatchClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMatchClause) {
            return visitor.visitMatchClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MatchModeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REPEATABLE() {
        return this.getToken(CypherCmdParser.REPEATABLE, 0);
    }
    ELEMENT() {
        return this.getToken(CypherCmdParser.ELEMENT, 0);
    }
    ELEMENTS() {
        return this.getToken(CypherCmdParser.ELEMENTS, 0);
    }
    BINDINGS() {
        return this.getToken(CypherCmdParser.BINDINGS, 0);
    }
    DIFFERENT() {
        return this.getToken(CypherCmdParser.DIFFERENT, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    RELATIONSHIPS() {
        return this.getToken(CypherCmdParser.RELATIONSHIPS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_matchMode;
    }
    enterRule(listener) {
        if (listener.enterMatchMode) {
            listener.enterMatchMode(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMatchMode) {
            listener.exitMatchMode(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMatchMode) {
            return visitor.visitMatchMode(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class HintContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USING() {
        return this.getToken(CypherCmdParser.USING, 0);
    }
    JOIN() {
        return this.getToken(CypherCmdParser.JOIN, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    nonEmptyNameList() {
        return this.getTypedRuleContext(NonEmptyNameListContext, 0);
    }
    SCAN() {
        return this.getToken(CypherCmdParser.SCAN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    labelOrRelType() {
        return this.getTypedRuleContext(LabelOrRelTypeContext, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    INDEX() {
        return this.getToken(CypherCmdParser.INDEX, 0);
    }
    TEXT() {
        return this.getToken(CypherCmdParser.TEXT, 0);
    }
    RANGE() {
        return this.getToken(CypherCmdParser.RANGE, 0);
    }
    POINT() {
        return this.getToken(CypherCmdParser.POINT, 0);
    }
    SEEK() {
        return this.getToken(CypherCmdParser.SEEK, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_hint;
    }
    enterRule(listener) {
        if (listener.enterHint) {
            listener.enterHint(this);
        }
    }
    exitRule(listener) {
        if (listener.exitHint) {
            listener.exitHint(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitHint) {
            return visitor.visitHint(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MergeClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    MERGE() {
        return this.getToken(CypherCmdParser.MERGE, 0);
    }
    pattern() {
        return this.getTypedRuleContext(PatternContext, 0);
    }
    mergeAction_list() {
        return this.getTypedRuleContexts(MergeActionContext);
    }
    mergeAction(i) {
        return this.getTypedRuleContext(MergeActionContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_mergeClause;
    }
    enterRule(listener) {
        if (listener.enterMergeClause) {
            listener.enterMergeClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMergeClause) {
            listener.exitMergeClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMergeClause) {
            return visitor.visitMergeClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MergeActionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    setClause() {
        return this.getTypedRuleContext(SetClauseContext, 0);
    }
    MATCH() {
        return this.getToken(CypherCmdParser.MATCH, 0);
    }
    CREATE() {
        return this.getToken(CypherCmdParser.CREATE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_mergeAction;
    }
    enterRule(listener) {
        if (listener.enterMergeAction) {
            listener.enterMergeAction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMergeAction) {
            listener.exitMergeAction(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMergeAction) {
            return visitor.visitMergeAction(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FilterClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FILTER() {
        return this.getToken(CypherCmdParser.FILTER, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_filterClause;
    }
    enterRule(listener) {
        if (listener.enterFilterClause) {
            listener.enterFilterClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFilterClause) {
            listener.exitFilterClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFilterClause) {
            return visitor.visitFilterClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UnwindClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    UNWIND() {
        return this.getToken(CypherCmdParser.UNWIND, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_unwindClause;
    }
    enterRule(listener) {
        if (listener.enterUnwindClause) {
            listener.enterUnwindClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUnwindClause) {
            listener.exitUnwindClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnwindClause) {
            return visitor.visitUnwindClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LetClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LET() {
        return this.getToken(CypherCmdParser.LET, 0);
    }
    letItem_list() {
        return this.getTypedRuleContexts(LetItemContext);
    }
    letItem(i) {
        return this.getTypedRuleContext(LetItemContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_letClause;
    }
    enterRule(listener) {
        if (listener.enterLetClause) {
            listener.enterLetClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLetClause) {
            listener.exitLetClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLetClause) {
            return visitor.visitLetClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LetItemContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_letItem;
    }
    enterRule(listener) {
        if (listener.enterLetItem) {
            listener.enterLetItem(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLetItem) {
            listener.exitLetItem(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLetItem) {
            return visitor.visitLetItem(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CallClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CALL() {
        return this.getToken(CypherCmdParser.CALL, 0);
    }
    procedureName() {
        return this.getTypedRuleContext(ProcedureNameContext, 0);
    }
    OPTIONAL() {
        return this.getToken(CypherCmdParser.OPTIONAL, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    YIELD() {
        return this.getToken(CypherCmdParser.YIELD, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    procedureResultItem_list() {
        return this.getTypedRuleContexts(ProcedureResultItemContext);
    }
    procedureResultItem(i) {
        return this.getTypedRuleContext(ProcedureResultItemContext, i);
    }
    procedureArgument_list() {
        return this.getTypedRuleContexts(ProcedureArgumentContext);
    }
    procedureArgument(i) {
        return this.getTypedRuleContext(ProcedureArgumentContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_callClause;
    }
    enterRule(listener) {
        if (listener.enterCallClause) {
            listener.enterCallClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCallClause) {
            listener.exitCallClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCallClause) {
            return visitor.visitCallClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ProcedureNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    namespace() {
        return this.getTypedRuleContext(NamespaceContext, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_procedureName;
    }
    enterRule(listener) {
        if (listener.enterProcedureName) {
            listener.enterProcedureName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProcedureName) {
            listener.exitProcedureName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProcedureName) {
            return visitor.visitProcedureName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ProcedureArgumentContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_procedureArgument;
    }
    enterRule(listener) {
        if (listener.enterProcedureArgument) {
            listener.enterProcedureArgument(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProcedureArgument) {
            listener.exitProcedureArgument(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProcedureArgument) {
            return visitor.visitProcedureArgument(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ProcedureResultItemContext extends ParserRuleContext {
    _yieldItemName;
    _yieldItemAlias;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    variable_list() {
        return this.getTypedRuleContexts(VariableContext);
    }
    variable(i) {
        return this.getTypedRuleContext(VariableContext, i);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_procedureResultItem;
    }
    enterRule(listener) {
        if (listener.enterProcedureResultItem) {
            listener.enterProcedureResultItem(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProcedureResultItem) {
            listener.exitProcedureResultItem(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProcedureResultItem) {
            return visitor.visitProcedureResultItem(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LoadCSVClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LOAD() {
        return this.getToken(CypherCmdParser.LOAD, 0);
    }
    CSV() {
        return this.getToken(CypherCmdParser.CSV, 0);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    HEADERS() {
        return this.getToken(CypherCmdParser.HEADERS, 0);
    }
    FIELDTERMINATOR() {
        return this.getToken(CypherCmdParser.FIELDTERMINATOR, 0);
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_loadCSVClause;
    }
    enterRule(listener) {
        if (listener.enterLoadCSVClause) {
            listener.enterLoadCSVClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLoadCSVClause) {
            listener.exitLoadCSVClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLoadCSVClause) {
            return visitor.visitLoadCSVClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ForeachClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FOREACH() {
        return this.getToken(CypherCmdParser.FOREACH, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    BAR() {
        return this.getToken(CypherCmdParser.BAR, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    clause_list() {
        return this.getTypedRuleContexts(ClauseContext);
    }
    clause(i) {
        return this.getTypedRuleContext(ClauseContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_foreachClause;
    }
    enterRule(listener) {
        if (listener.enterForeachClause) {
            listener.enterForeachClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitForeachClause) {
            listener.exitForeachClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitForeachClause) {
            return visitor.visitForeachClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CALL() {
        return this.getToken(CypherCmdParser.CALL, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    nextStatement() {
        return this.getTypedRuleContext(NextStatementContext, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    OPTIONAL() {
        return this.getToken(CypherCmdParser.OPTIONAL, 0);
    }
    subqueryScope() {
        return this.getTypedRuleContext(SubqueryScopeContext, 0);
    }
    subqueryInTransactionsParameters() {
        return this.getTypedRuleContext(SubqueryInTransactionsParametersContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryClause;
    }
    enterRule(listener) {
        if (listener.enterSubqueryClause) {
            listener.enterSubqueryClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryClause) {
            listener.exitSubqueryClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryClause) {
            return visitor.visitSubqueryClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryScopeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    variable_list() {
        return this.getTypedRuleContexts(VariableContext);
    }
    variable(i) {
        return this.getTypedRuleContext(VariableContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryScope;
    }
    enterRule(listener) {
        if (listener.enterSubqueryScope) {
            listener.enterSubqueryScope(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryScope) {
            listener.exitSubqueryScope(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryScope) {
            return visitor.visitSubqueryScope(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryInTransactionsParametersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    TRANSACTIONS() {
        return this.getToken(CypherCmdParser.TRANSACTIONS, 0);
    }
    CONCURRENT() {
        return this.getToken(CypherCmdParser.CONCURRENT, 0);
    }
    subqueryInTransactionsBatchParameters_list() {
        return this.getTypedRuleContexts(SubqueryInTransactionsBatchParametersContext);
    }
    subqueryInTransactionsBatchParameters(i) {
        return this.getTypedRuleContext(SubqueryInTransactionsBatchParametersContext, i);
    }
    subqueryInTransactionsErrorParameters_list() {
        return this.getTypedRuleContexts(SubqueryInTransactionsErrorParametersContext);
    }
    subqueryInTransactionsErrorParameters(i) {
        return this.getTypedRuleContext(SubqueryInTransactionsErrorParametersContext, i);
    }
    subqueryInTransactionsReportParameters_list() {
        return this.getTypedRuleContexts(SubqueryInTransactionsReportParametersContext);
    }
    subqueryInTransactionsReportParameters(i) {
        return this.getTypedRuleContext(SubqueryInTransactionsReportParametersContext, i);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryInTransactionsParameters;
    }
    enterRule(listener) {
        if (listener.enterSubqueryInTransactionsParameters) {
            listener.enterSubqueryInTransactionsParameters(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryInTransactionsParameters) {
            listener.exitSubqueryInTransactionsParameters(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryInTransactionsParameters) {
            return visitor.visitSubqueryInTransactionsParameters(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryInTransactionsBatchParametersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    OF() {
        return this.getToken(CypherCmdParser.OF, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    ROW() {
        return this.getToken(CypherCmdParser.ROW, 0);
    }
    ROWS() {
        return this.getToken(CypherCmdParser.ROWS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryInTransactionsBatchParameters;
    }
    enterRule(listener) {
        if (listener.enterSubqueryInTransactionsBatchParameters) {
            listener.enterSubqueryInTransactionsBatchParameters(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryInTransactionsBatchParameters) {
            listener.exitSubqueryInTransactionsBatchParameters(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryInTransactionsBatchParameters) {
            return visitor.visitSubqueryInTransactionsBatchParameters(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryInTransactionsErrorParametersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    ERROR() {
        return this.getToken(CypherCmdParser.ERROR, 0);
    }
    RETRY() {
        return this.getToken(CypherCmdParser.RETRY, 0);
    }
    subqueryInTransactionsRetryParameters() {
        return this.getTypedRuleContext(SubqueryInTransactionsRetryParametersContext, 0);
    }
    THEN() {
        return this.getToken(CypherCmdParser.THEN, 0);
    }
    CONTINUE() {
        return this.getToken(CypherCmdParser.CONTINUE, 0);
    }
    BREAK() {
        return this.getToken(CypherCmdParser.BREAK, 0);
    }
    FAIL() {
        return this.getToken(CypherCmdParser.FAIL, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryInTransactionsErrorParameters;
    }
    enterRule(listener) {
        if (listener.enterSubqueryInTransactionsErrorParameters) {
            listener.enterSubqueryInTransactionsErrorParameters(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryInTransactionsErrorParameters) {
            listener.exitSubqueryInTransactionsErrorParameters(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryInTransactionsErrorParameters) {
            return visitor.visitSubqueryInTransactionsErrorParameters(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryInTransactionsRetryParametersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    secondsToken() {
        return this.getTypedRuleContext(SecondsTokenContext, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryInTransactionsRetryParameters;
    }
    enterRule(listener) {
        if (listener.enterSubqueryInTransactionsRetryParameters) {
            listener.enterSubqueryInTransactionsRetryParameters(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryInTransactionsRetryParameters) {
            listener.exitSubqueryInTransactionsRetryParameters(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryInTransactionsRetryParameters) {
            return visitor.visitSubqueryInTransactionsRetryParameters(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubqueryInTransactionsReportParametersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REPORT() {
        return this.getToken(CypherCmdParser.REPORT, 0);
    }
    STATUS() {
        return this.getToken(CypherCmdParser.STATUS, 0);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_subqueryInTransactionsReportParameters;
    }
    enterRule(listener) {
        if (listener.enterSubqueryInTransactionsReportParameters) {
            listener.enterSubqueryInTransactionsReportParameters(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSubqueryInTransactionsReportParameters) {
            listener.exitSubqueryInTransactionsReportParameters(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubqueryInTransactionsReportParameters) {
            return visitor.visitSubqueryInTransactionsReportParameters(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class OrderBySkipLimitClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    orderBy() {
        return this.getTypedRuleContext(OrderByContext, 0);
    }
    skip() {
        return this.getTypedRuleContext(SkipContext, 0);
    }
    limit() {
        return this.getTypedRuleContext(LimitContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_orderBySkipLimitClause;
    }
    enterRule(listener) {
        if (listener.enterOrderBySkipLimitClause) {
            listener.enterOrderBySkipLimitClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderBySkipLimitClause) {
            listener.exitOrderBySkipLimitClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitOrderBySkipLimitClause) {
            return visitor.visitOrderBySkipLimitClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PatternListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    pattern_list() {
        return this.getTypedRuleContexts(PatternContext);
    }
    pattern(i) {
        return this.getTypedRuleContext(PatternContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_patternList;
    }
    enterRule(listener) {
        if (listener.enterPatternList) {
            listener.enterPatternList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPatternList) {
            listener.exitPatternList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPatternList) {
            return visitor.visitPatternList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertPatternListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    insertPattern_list() {
        return this.getTypedRuleContexts(InsertPatternContext);
    }
    insertPattern(i) {
        return this.getTypedRuleContext(InsertPatternContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertPatternList;
    }
    enterRule(listener) {
        if (listener.enterInsertPatternList) {
            listener.enterInsertPatternList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertPatternList) {
            listener.exitInsertPatternList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertPatternList) {
            return visitor.visitInsertPatternList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    anonymousPattern() {
        return this.getTypedRuleContext(AnonymousPatternContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    selector() {
        return this.getTypedRuleContext(SelectorContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_pattern;
    }
    enterRule(listener) {
        if (listener.enterPattern) {
            listener.enterPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPattern) {
            listener.exitPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPattern) {
            return visitor.visitPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    insertNodePattern_list() {
        return this.getTypedRuleContexts(InsertNodePatternContext);
    }
    insertNodePattern(i) {
        return this.getTypedRuleContext(InsertNodePatternContext, i);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    insertRelationshipPattern_list() {
        return this.getTypedRuleContexts(InsertRelationshipPatternContext);
    }
    insertRelationshipPattern(i) {
        return this.getTypedRuleContext(InsertRelationshipPatternContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertPattern;
    }
    enterRule(listener) {
        if (listener.enterInsertPattern) {
            listener.enterInsertPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertPattern) {
            listener.exitInsertPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertPattern) {
            return visitor.visitInsertPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class QuantifierContext extends ParserRuleContext {
    _from_;
    _to;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    UNSIGNED_DECIMAL_INTEGER_list() {
        return this.getTokens(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
    }
    UNSIGNED_DECIMAL_INTEGER(i) {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, i);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    COMMA() {
        return this.getToken(CypherCmdParser.COMMA, 0);
    }
    PLUS() {
        return this.getToken(CypherCmdParser.PLUS, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_quantifier;
    }
    enterRule(listener) {
        if (listener.enterQuantifier) {
            listener.enterQuantifier(this);
        }
    }
    exitRule(listener) {
        if (listener.exitQuantifier) {
            listener.exitQuantifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitQuantifier) {
            return visitor.visitQuantifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AnonymousPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    shortestPathPattern() {
        return this.getTypedRuleContext(ShortestPathPatternContext, 0);
    }
    patternElement() {
        return this.getTypedRuleContext(PatternElementContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_anonymousPattern;
    }
    enterRule(listener) {
        if (listener.enterAnonymousPattern) {
            listener.enterAnonymousPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAnonymousPattern) {
            listener.exitAnonymousPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAnonymousPattern) {
            return visitor.visitAnonymousPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShortestPathPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    patternElement() {
        return this.getTypedRuleContext(PatternElementContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    SHORTEST_PATH() {
        return this.getToken(CypherCmdParser.SHORTEST_PATH, 0);
    }
    ALL_SHORTEST_PATHS() {
        return this.getToken(CypherCmdParser.ALL_SHORTEST_PATHS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_shortestPathPattern;
    }
    enterRule(listener) {
        if (listener.enterShortestPathPattern) {
            listener.enterShortestPathPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShortestPathPattern) {
            listener.exitShortestPathPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShortestPathPattern) {
            return visitor.visitShortestPathPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PatternElementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    nodePattern_list() {
        return this.getTypedRuleContexts(NodePatternContext);
    }
    nodePattern(i) {
        return this.getTypedRuleContext(NodePatternContext, i);
    }
    parenthesizedPath_list() {
        return this.getTypedRuleContexts(ParenthesizedPathContext);
    }
    parenthesizedPath(i) {
        return this.getTypedRuleContext(ParenthesizedPathContext, i);
    }
    relationshipPattern_list() {
        return this.getTypedRuleContexts(RelationshipPatternContext);
    }
    relationshipPattern(i) {
        return this.getTypedRuleContext(RelationshipPatternContext, i);
    }
    quantifier_list() {
        return this.getTypedRuleContexts(QuantifierContext);
    }
    quantifier(i) {
        return this.getTypedRuleContext(QuantifierContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_patternElement;
    }
    enterRule(listener) {
        if (listener.enterPatternElement) {
            listener.enterPatternElement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPatternElement) {
            listener.exitPatternElement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPatternElement) {
            return visitor.visitPatternElement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SelectorContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_selector;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class AllShortestPathContext extends SelectorContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    SHORTEST() {
        return this.getToken(CypherCmdParser.SHORTEST, 0);
    }
    pathToken() {
        return this.getTypedRuleContext(PathTokenContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAllShortestPath) {
            listener.enterAllShortestPath(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAllShortestPath) {
            listener.exitAllShortestPath(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAllShortestPath) {
            return visitor.visitAllShortestPath(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AnyPathContext extends SelectorContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ANY() {
        return this.getToken(CypherCmdParser.ANY, 0);
    }
    nonNegativeIntegerSpecification() {
        return this.getTypedRuleContext(NonNegativeIntegerSpecificationContext, 0);
    }
    pathToken() {
        return this.getTypedRuleContext(PathTokenContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAnyPath) {
            listener.enterAnyPath(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAnyPath) {
            listener.exitAnyPath(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAnyPath) {
            return visitor.visitAnyPath(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShortestGroupContext extends SelectorContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    SHORTEST() {
        return this.getToken(CypherCmdParser.SHORTEST, 0);
    }
    groupToken() {
        return this.getTypedRuleContext(GroupTokenContext, 0);
    }
    nonNegativeIntegerSpecification() {
        return this.getTypedRuleContext(NonNegativeIntegerSpecificationContext, 0);
    }
    pathToken() {
        return this.getTypedRuleContext(PathTokenContext, 0);
    }
    enterRule(listener) {
        if (listener.enterShortestGroup) {
            listener.enterShortestGroup(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShortestGroup) {
            listener.exitShortestGroup(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShortestGroup) {
            return visitor.visitShortestGroup(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AnyShortestPathContext extends SelectorContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ANY() {
        return this.getToken(CypherCmdParser.ANY, 0);
    }
    SHORTEST() {
        return this.getToken(CypherCmdParser.SHORTEST, 0);
    }
    pathToken() {
        return this.getTypedRuleContext(PathTokenContext, 0);
    }
    nonNegativeIntegerSpecification() {
        return this.getTypedRuleContext(NonNegativeIntegerSpecificationContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAnyShortestPath) {
            listener.enterAnyShortestPath(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAnyShortestPath) {
            listener.exitAnyShortestPath(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAnyShortestPath) {
            return visitor.visitAnyShortestPath(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AllPathContext extends SelectorContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    pathToken() {
        return this.getTypedRuleContext(PathTokenContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAllPath) {
            listener.enterAllPath(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAllPath) {
            listener.exitAllPath(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAllPath) {
            return visitor.visitAllPath(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NonNegativeIntegerSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nonNegativeIntegerSpecification;
    }
    enterRule(listener) {
        if (listener.enterNonNegativeIntegerSpecification) {
            listener.enterNonNegativeIntegerSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNonNegativeIntegerSpecification) {
            listener.exitNonNegativeIntegerSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNonNegativeIntegerSpecification) {
            return visitor.visitNonNegativeIntegerSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GroupTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    GROUP() {
        return this.getToken(CypherCmdParser.GROUP, 0);
    }
    GROUPS() {
        return this.getToken(CypherCmdParser.GROUPS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_groupToken;
    }
    enterRule(listener) {
        if (listener.enterGroupToken) {
            listener.enterGroupToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGroupToken) {
            listener.exitGroupToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGroupToken) {
            return visitor.visitGroupToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PathTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PATH() {
        return this.getToken(CypherCmdParser.PATH, 0);
    }
    PATHS() {
        return this.getToken(CypherCmdParser.PATHS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_pathToken;
    }
    enterRule(listener) {
        if (listener.enterPathToken) {
            listener.enterPathToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPathToken) {
            listener.exitPathToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPathToken) {
            return visitor.visitPathToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PathPatternNonEmptyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    nodePattern_list() {
        return this.getTypedRuleContexts(NodePatternContext);
    }
    nodePattern(i) {
        return this.getTypedRuleContext(NodePatternContext, i);
    }
    relationshipPattern_list() {
        return this.getTypedRuleContexts(RelationshipPatternContext);
    }
    relationshipPattern(i) {
        return this.getTypedRuleContext(RelationshipPatternContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_pathPatternNonEmpty;
    }
    enterRule(listener) {
        if (listener.enterPathPatternNonEmpty) {
            listener.enterPathPatternNonEmpty(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPathPatternNonEmpty) {
            listener.exitPathPatternNonEmpty(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPathPatternNonEmpty) {
            return visitor.visitPathPatternNonEmpty(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodePatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    labelExpression() {
        return this.getTypedRuleContext(LabelExpressionContext, 0);
    }
    properties() {
        return this.getTypedRuleContext(PropertiesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodePattern;
    }
    enterRule(listener) {
        if (listener.enterNodePattern) {
            listener.enterNodePattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodePattern) {
            listener.exitNodePattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodePattern) {
            return visitor.visitNodePattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertNodePatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    insertNodeLabelExpression() {
        return this.getTypedRuleContext(InsertNodeLabelExpressionContext, 0);
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertNodePattern;
    }
    enterRule(listener) {
        if (listener.enterInsertNodePattern) {
            listener.enterInsertNodePattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertNodePattern) {
            listener.exitInsertNodePattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertNodePattern) {
            return visitor.visitInsertNodePattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParenthesizedPathContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    pattern() {
        return this.getTypedRuleContext(PatternContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    quantifier() {
        return this.getTypedRuleContext(QuantifierContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_parenthesizedPath;
    }
    enterRule(listener) {
        if (listener.enterParenthesizedPath) {
            listener.enterParenthesizedPath(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParenthesizedPath) {
            listener.exitParenthesizedPath(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParenthesizedPath) {
            return visitor.visitParenthesizedPath(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeLabelsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelType_list() {
        return this.getTypedRuleContexts(LabelTypeContext);
    }
    labelType(i) {
        return this.getTypedRuleContext(LabelTypeContext, i);
    }
    dynamicLabelType_list() {
        return this.getTypedRuleContexts(DynamicLabelTypeContext);
    }
    dynamicLabelType(i) {
        return this.getTypedRuleContext(DynamicLabelTypeContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeLabels;
    }
    enterRule(listener) {
        if (listener.enterNodeLabels) {
            listener.enterNodeLabels(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeLabels) {
            listener.exitNodeLabels(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeLabels) {
            return visitor.visitNodeLabels(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeLabelsIsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    dynamicExpression() {
        return this.getTypedRuleContext(DynamicExpressionContext, 0);
    }
    labelType_list() {
        return this.getTypedRuleContexts(LabelTypeContext);
    }
    labelType(i) {
        return this.getTypedRuleContext(LabelTypeContext, i);
    }
    dynamicLabelType_list() {
        return this.getTypedRuleContexts(DynamicLabelTypeContext);
    }
    dynamicLabelType(i) {
        return this.getTypedRuleContext(DynamicLabelTypeContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeLabelsIs;
    }
    enterRule(listener) {
        if (listener.enterNodeLabelsIs) {
            listener.enterNodeLabelsIs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeLabelsIs) {
            listener.exitNodeLabelsIs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeLabelsIs) {
            return visitor.visitNodeLabelsIs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DOLLAR() {
        return this.getToken(CypherCmdParser.DOLLAR, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dynamicExpression;
    }
    enterRule(listener) {
        if (listener.enterDynamicExpression) {
            listener.enterDynamicExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDynamicExpression) {
            listener.exitDynamicExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicExpression) {
            return visitor.visitDynamicExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicAnyAllExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DOLLAR() {
        return this.getToken(CypherCmdParser.DOLLAR, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    ANY() {
        return this.getToken(CypherCmdParser.ANY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dynamicAnyAllExpression;
    }
    enterRule(listener) {
        if (listener.enterDynamicAnyAllExpression) {
            listener.enterDynamicAnyAllExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDynamicAnyAllExpression) {
            listener.exitDynamicAnyAllExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicAnyAllExpression) {
            return visitor.visitDynamicAnyAllExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicLabelTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    dynamicExpression() {
        return this.getTypedRuleContext(DynamicExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dynamicLabelType;
    }
    enterRule(listener) {
        if (listener.enterDynamicLabelType) {
            listener.enterDynamicLabelType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDynamicLabelType) {
            listener.exitDynamicLabelType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicLabelType) {
            return visitor.visitDynamicLabelType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelType;
    }
    enterRule(listener) {
        if (listener.enterLabelType) {
            listener.enterLabelType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelType) {
            listener.exitLabelType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelType) {
            return visitor.visitLabelType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RelTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_relType;
    }
    enterRule(listener) {
        if (listener.enterRelType) {
            listener.enterRelType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRelType) {
            listener.exitRelType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRelType) {
            return visitor.visitRelType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelOrRelTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelOrRelType;
    }
    enterRule(listener) {
        if (listener.enterLabelOrRelType) {
            listener.enterLabelOrRelType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelOrRelType) {
            listener.exitLabelOrRelType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelOrRelType) {
            return visitor.visitLabelOrRelType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertiesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_properties;
    }
    enterRule(listener) {
        if (listener.enterProperties) {
            listener.enterProperties(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProperties) {
            listener.exitProperties(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProperties) {
            return visitor.visitProperties(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RelationshipPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    leftArrow() {
        return this.getTypedRuleContext(LeftArrowContext, 0);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    labelExpression() {
        return this.getTypedRuleContext(LabelExpressionContext, 0);
    }
    pathLength() {
        return this.getTypedRuleContext(PathLengthContext, 0);
    }
    properties() {
        return this.getTypedRuleContext(PropertiesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_relationshipPattern;
    }
    enterRule(listener) {
        if (listener.enterRelationshipPattern) {
            listener.enterRelationshipPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRelationshipPattern) {
            listener.exitRelationshipPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRelationshipPattern) {
            return visitor.visitRelationshipPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertRelationshipPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    insertRelationshipLabelExpression() {
        return this.getTypedRuleContext(InsertRelationshipLabelExpressionContext, 0);
    }
    leftArrow() {
        return this.getTypedRuleContext(LeftArrowContext, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertRelationshipPattern;
    }
    enterRule(listener) {
        if (listener.enterInsertRelationshipPattern) {
            listener.enterInsertRelationshipPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertRelationshipPattern) {
            listener.exitInsertRelationshipPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertRelationshipPattern) {
            return visitor.visitInsertRelationshipPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LeftArrowContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LT() {
        return this.getToken(CypherCmdParser.LT, 0);
    }
    ARROW_LEFT_HEAD() {
        return this.getToken(CypherCmdParser.ARROW_LEFT_HEAD, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_leftArrow;
    }
    enterRule(listener) {
        if (listener.enterLeftArrow) {
            listener.enterLeftArrow(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLeftArrow) {
            listener.exitLeftArrow(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLeftArrow) {
            return visitor.visitLeftArrow(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ArrowLineContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ARROW_LINE() {
        return this.getToken(CypherCmdParser.ARROW_LINE, 0);
    }
    MINUS() {
        return this.getToken(CypherCmdParser.MINUS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_arrowLine;
    }
    enterRule(listener) {
        if (listener.enterArrowLine) {
            listener.enterArrowLine(this);
        }
    }
    exitRule(listener) {
        if (listener.exitArrowLine) {
            listener.exitArrowLine(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitArrowLine) {
            return visitor.visitArrowLine(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RightArrowContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    GT() {
        return this.getToken(CypherCmdParser.GT, 0);
    }
    ARROW_RIGHT_HEAD() {
        return this.getToken(CypherCmdParser.ARROW_RIGHT_HEAD, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_rightArrow;
    }
    enterRule(listener) {
        if (listener.enterRightArrow) {
            listener.enterRightArrow(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRightArrow) {
            listener.exitRightArrow(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRightArrow) {
            return visitor.visitRightArrow(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PathLengthContext extends ParserRuleContext {
    _from_;
    _to;
    _single;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    DOTDOT() {
        return this.getToken(CypherCmdParser.DOTDOT, 0);
    }
    UNSIGNED_DECIMAL_INTEGER_list() {
        return this.getTokens(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER);
    }
    UNSIGNED_DECIMAL_INTEGER(i) {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_pathLength;
    }
    enterRule(listener) {
        if (listener.enterPathLength) {
            listener.enterPathLength(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPathLength) {
            listener.exitPathLength(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPathLength) {
            return visitor.visitPathLength(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelExpression4() {
        return this.getTypedRuleContext(LabelExpression4Context, 0);
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelExpression;
    }
    enterRule(listener) {
        if (listener.enterLabelExpression) {
            listener.enterLabelExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelExpression) {
            listener.exitLabelExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelExpression) {
            return visitor.visitLabelExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelExpression4Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelExpression3_list() {
        return this.getTypedRuleContexts(LabelExpression3Context);
    }
    labelExpression3(i) {
        return this.getTypedRuleContext(LabelExpression3Context, i);
    }
    BAR_list() {
        return this.getTokens(CypherCmdParser.BAR);
    }
    BAR(i) {
        return this.getToken(CypherCmdParser.BAR, i);
    }
    COLON_list() {
        return this.getTokens(CypherCmdParser.COLON);
    }
    COLON(i) {
        return this.getToken(CypherCmdParser.COLON, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelExpression4;
    }
    enterRule(listener) {
        if (listener.enterLabelExpression4) {
            listener.enterLabelExpression4(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelExpression4) {
            listener.exitLabelExpression4(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelExpression4) {
            return visitor.visitLabelExpression4(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelExpression3Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelExpression2_list() {
        return this.getTypedRuleContexts(LabelExpression2Context);
    }
    labelExpression2(i) {
        return this.getTypedRuleContext(LabelExpression2Context, i);
    }
    AMPERSAND_list() {
        return this.getTokens(CypherCmdParser.AMPERSAND);
    }
    AMPERSAND(i) {
        return this.getToken(CypherCmdParser.AMPERSAND, i);
    }
    COLON_list() {
        return this.getTokens(CypherCmdParser.COLON);
    }
    COLON(i) {
        return this.getToken(CypherCmdParser.COLON, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelExpression3;
    }
    enterRule(listener) {
        if (listener.enterLabelExpression3) {
            listener.enterLabelExpression3(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelExpression3) {
            listener.exitLabelExpression3(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelExpression3) {
            return visitor.visitLabelExpression3(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelExpression2Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelExpression1() {
        return this.getTypedRuleContext(LabelExpression1Context, 0);
    }
    EXCLAMATION_MARK_list() {
        return this.getTokens(CypherCmdParser.EXCLAMATION_MARK);
    }
    EXCLAMATION_MARK(i) {
        return this.getToken(CypherCmdParser.EXCLAMATION_MARK, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelExpression2;
    }
    enterRule(listener) {
        if (listener.enterLabelExpression2) {
            listener.enterLabelExpression2(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelExpression2) {
            listener.exitLabelExpression2(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelExpression2) {
            return visitor.visitLabelExpression2(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelExpression1Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelExpression1;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class AnyLabelContext extends LabelExpression1Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    PERCENT() {
        return this.getToken(CypherCmdParser.PERCENT, 0);
    }
    enterRule(listener) {
        if (listener.enterAnyLabel) {
            listener.enterAnyLabel(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAnyLabel) {
            listener.exitAnyLabel(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAnyLabel) {
            return visitor.visitAnyLabel(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicLabelContext extends LabelExpression1Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    dynamicAnyAllExpression() {
        return this.getTypedRuleContext(DynamicAnyAllExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterDynamicLabel) {
            listener.enterDynamicLabel(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDynamicLabel) {
            listener.exitDynamicLabel(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicLabel) {
            return visitor.visitDynamicLabel(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelNameContext extends LabelExpression1Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    enterRule(listener) {
        if (listener.enterLabelName) {
            listener.enterLabelName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelName) {
            listener.exitLabelName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelName) {
            return visitor.visitLabelName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParenthesizedLabelExpressionContext extends LabelExpression1Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    labelExpression4() {
        return this.getTypedRuleContext(LabelExpression4Context, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    enterRule(listener) {
        if (listener.enterParenthesizedLabelExpression) {
            listener.enterParenthesizedLabelExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParenthesizedLabelExpression) {
            listener.exitParenthesizedLabelExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParenthesizedLabelExpression) {
            return visitor.visitParenthesizedLabelExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertNodeLabelExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    COLON_list() {
        return this.getTokens(CypherCmdParser.COLON);
    }
    COLON(i) {
        return this.getToken(CypherCmdParser.COLON, i);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    AMPERSAND_list() {
        return this.getTokens(CypherCmdParser.AMPERSAND);
    }
    AMPERSAND(i) {
        return this.getToken(CypherCmdParser.AMPERSAND, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertNodeLabelExpression;
    }
    enterRule(listener) {
        if (listener.enterInsertNodeLabelExpression) {
            listener.enterInsertNodeLabelExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertNodeLabelExpression) {
            listener.exitInsertNodeLabelExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertNodeLabelExpression) {
            return visitor.visitInsertNodeLabelExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class InsertRelationshipLabelExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_insertRelationshipLabelExpression;
    }
    enterRule(listener) {
        if (listener.enterInsertRelationshipLabelExpression) {
            listener.enterInsertRelationshipLabelExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitInsertRelationshipLabelExpression) {
            listener.exitInsertRelationshipLabelExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInsertRelationshipLabelExpression) {
            return visitor.visitInsertRelationshipLabelExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression11_list() {
        return this.getTypedRuleContexts(Expression11Context);
    }
    expression11(i) {
        return this.getTypedRuleContext(Expression11Context, i);
    }
    OR_list() {
        return this.getTokens(CypherCmdParser.OR);
    }
    OR(i) {
        return this.getToken(CypherCmdParser.OR, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression;
    }
    enterRule(listener) {
        if (listener.enterExpression) {
            listener.enterExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression) {
            listener.exitExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression) {
            return visitor.visitExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression11Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression10_list() {
        return this.getTypedRuleContexts(Expression10Context);
    }
    expression10(i) {
        return this.getTypedRuleContext(Expression10Context, i);
    }
    XOR_list() {
        return this.getTokens(CypherCmdParser.XOR);
    }
    XOR(i) {
        return this.getToken(CypherCmdParser.XOR, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression11;
    }
    enterRule(listener) {
        if (listener.enterExpression11) {
            listener.enterExpression11(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression11) {
            listener.exitExpression11(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression11) {
            return visitor.visitExpression11(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression10Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression9_list() {
        return this.getTypedRuleContexts(Expression9Context);
    }
    expression9(i) {
        return this.getTypedRuleContext(Expression9Context, i);
    }
    AND_list() {
        return this.getTokens(CypherCmdParser.AND);
    }
    AND(i) {
        return this.getToken(CypherCmdParser.AND, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression10;
    }
    enterRule(listener) {
        if (listener.enterExpression10) {
            listener.enterExpression10(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression10) {
            listener.exitExpression10(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression10) {
            return visitor.visitExpression10(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression9Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression8() {
        return this.getTypedRuleContext(Expression8Context, 0);
    }
    NOT_list() {
        return this.getTokens(CypherCmdParser.NOT);
    }
    NOT(i) {
        return this.getToken(CypherCmdParser.NOT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression9;
    }
    enterRule(listener) {
        if (listener.enterExpression9) {
            listener.enterExpression9(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression9) {
            listener.exitExpression9(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression9) {
            return visitor.visitExpression9(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression8Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression7_list() {
        return this.getTypedRuleContexts(Expression7Context);
    }
    expression7(i) {
        return this.getTypedRuleContext(Expression7Context, i);
    }
    EQ_list() {
        return this.getTokens(CypherCmdParser.EQ);
    }
    EQ(i) {
        return this.getToken(CypherCmdParser.EQ, i);
    }
    INVALID_NEQ_list() {
        return this.getTokens(CypherCmdParser.INVALID_NEQ);
    }
    INVALID_NEQ(i) {
        return this.getToken(CypherCmdParser.INVALID_NEQ, i);
    }
    NEQ_list() {
        return this.getTokens(CypherCmdParser.NEQ);
    }
    NEQ(i) {
        return this.getToken(CypherCmdParser.NEQ, i);
    }
    LE_list() {
        return this.getTokens(CypherCmdParser.LE);
    }
    LE(i) {
        return this.getToken(CypherCmdParser.LE, i);
    }
    GE_list() {
        return this.getTokens(CypherCmdParser.GE);
    }
    GE(i) {
        return this.getToken(CypherCmdParser.GE, i);
    }
    LT_list() {
        return this.getTokens(CypherCmdParser.LT);
    }
    LT(i) {
        return this.getToken(CypherCmdParser.LT, i);
    }
    GT_list() {
        return this.getTokens(CypherCmdParser.GT);
    }
    GT(i) {
        return this.getToken(CypherCmdParser.GT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression8;
    }
    enterRule(listener) {
        if (listener.enterExpression8) {
            listener.enterExpression8(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression8) {
            listener.exitExpression8(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression8) {
            return visitor.visitExpression8(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression7Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression6() {
        return this.getTypedRuleContext(Expression6Context, 0);
    }
    comparisonExpression6() {
        return this.getTypedRuleContext(ComparisonExpression6Context, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression7;
    }
    enterRule(listener) {
        if (listener.enterExpression7) {
            listener.enterExpression7(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression7) {
            listener.exitExpression7(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression7) {
            return visitor.visitExpression7(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ComparisonExpression6Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_comparisonExpression6;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class TypeComparisonContext extends ComparisonExpression6Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    type_() {
        return this.getTypedRuleContext(TypeContext, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    COLONCOLON() {
        return this.getToken(CypherCmdParser.COLONCOLON, 0);
    }
    TYPED() {
        return this.getToken(CypherCmdParser.TYPED, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    enterRule(listener) {
        if (listener.enterTypeComparison) {
            listener.enterTypeComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTypeComparison) {
            listener.exitTypeComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTypeComparison) {
            return visitor.visitTypeComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringAndListComparisonContext extends ComparisonExpression6Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expression6() {
        return this.getTypedRuleContext(Expression6Context, 0);
    }
    REGEQ() {
        return this.getToken(CypherCmdParser.REGEQ, 0);
    }
    STARTS() {
        return this.getToken(CypherCmdParser.STARTS, 0);
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    ENDS() {
        return this.getToken(CypherCmdParser.ENDS, 0);
    }
    CONTAINS() {
        return this.getToken(CypherCmdParser.CONTAINS, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    enterRule(listener) {
        if (listener.enterStringAndListComparison) {
            listener.enterStringAndListComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringAndListComparison) {
            listener.exitStringAndListComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringAndListComparison) {
            return visitor.visitStringAndListComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NormalFormComparisonContext extends ComparisonExpression6Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    NORMALIZED() {
        return this.getToken(CypherCmdParser.NORMALIZED, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    normalForm() {
        return this.getTypedRuleContext(NormalFormContext, 0);
    }
    enterRule(listener) {
        if (listener.enterNormalFormComparison) {
            listener.enterNormalFormComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNormalFormComparison) {
            listener.exitNormalFormComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNormalFormComparison) {
            return visitor.visitNormalFormComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelComparisonContext extends ComparisonExpression6Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    labelExpression() {
        return this.getTypedRuleContext(LabelExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterLabelComparison) {
            listener.enterLabelComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelComparison) {
            listener.exitLabelComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelComparison) {
            return visitor.visitLabelComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NullComparisonContext extends ComparisonExpression6Context {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    NULL() {
        return this.getToken(CypherCmdParser.NULL, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    enterRule(listener) {
        if (listener.enterNullComparison) {
            listener.enterNullComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNullComparison) {
            listener.exitNullComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNullComparison) {
            return visitor.visitNullComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NormalFormContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NFC() {
        return this.getToken(CypherCmdParser.NFC, 0);
    }
    NFD() {
        return this.getToken(CypherCmdParser.NFD, 0);
    }
    NFKC() {
        return this.getToken(CypherCmdParser.NFKC, 0);
    }
    NFKD() {
        return this.getToken(CypherCmdParser.NFKD, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_normalForm;
    }
    enterRule(listener) {
        if (listener.enterNormalForm) {
            listener.enterNormalForm(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNormalForm) {
            listener.exitNormalForm(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNormalForm) {
            return visitor.visitNormalForm(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression6Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression5_list() {
        return this.getTypedRuleContexts(Expression5Context);
    }
    expression5(i) {
        return this.getTypedRuleContext(Expression5Context, i);
    }
    PLUS_list() {
        return this.getTokens(CypherCmdParser.PLUS);
    }
    PLUS(i) {
        return this.getToken(CypherCmdParser.PLUS, i);
    }
    MINUS_list() {
        return this.getTokens(CypherCmdParser.MINUS);
    }
    MINUS(i) {
        return this.getToken(CypherCmdParser.MINUS, i);
    }
    DOUBLEBAR_list() {
        return this.getTokens(CypherCmdParser.DOUBLEBAR);
    }
    DOUBLEBAR(i) {
        return this.getToken(CypherCmdParser.DOUBLEBAR, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression6;
    }
    enterRule(listener) {
        if (listener.enterExpression6) {
            listener.enterExpression6(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression6) {
            listener.exitExpression6(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression6) {
            return visitor.visitExpression6(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression5Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression4_list() {
        return this.getTypedRuleContexts(Expression4Context);
    }
    expression4(i) {
        return this.getTypedRuleContext(Expression4Context, i);
    }
    TIMES_list() {
        return this.getTokens(CypherCmdParser.TIMES);
    }
    TIMES(i) {
        return this.getToken(CypherCmdParser.TIMES, i);
    }
    DIVIDE_list() {
        return this.getTokens(CypherCmdParser.DIVIDE);
    }
    DIVIDE(i) {
        return this.getToken(CypherCmdParser.DIVIDE, i);
    }
    PERCENT_list() {
        return this.getTokens(CypherCmdParser.PERCENT);
    }
    PERCENT(i) {
        return this.getToken(CypherCmdParser.PERCENT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression5;
    }
    enterRule(listener) {
        if (listener.enterExpression5) {
            listener.enterExpression5(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression5) {
            listener.exitExpression5(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression5) {
            return visitor.visitExpression5(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression4Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression3_list() {
        return this.getTypedRuleContexts(Expression3Context);
    }
    expression3(i) {
        return this.getTypedRuleContext(Expression3Context, i);
    }
    POW_list() {
        return this.getTokens(CypherCmdParser.POW);
    }
    POW(i) {
        return this.getToken(CypherCmdParser.POW, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression4;
    }
    enterRule(listener) {
        if (listener.enterExpression4) {
            listener.enterExpression4(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression4) {
            listener.exitExpression4(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression4) {
            return visitor.visitExpression4(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression3Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression2() {
        return this.getTypedRuleContext(Expression2Context, 0);
    }
    PLUS() {
        return this.getToken(CypherCmdParser.PLUS, 0);
    }
    MINUS() {
        return this.getToken(CypherCmdParser.MINUS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression3;
    }
    enterRule(listener) {
        if (listener.enterExpression3) {
            listener.enterExpression3(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression3) {
            listener.exitExpression3(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression3) {
            return visitor.visitExpression3(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression2Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression1() {
        return this.getTypedRuleContext(Expression1Context, 0);
    }
    postFix_list() {
        return this.getTypedRuleContexts(PostFixContext);
    }
    postFix(i) {
        return this.getTypedRuleContext(PostFixContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression2;
    }
    enterRule(listener) {
        if (listener.enterExpression2) {
            listener.enterExpression2(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression2) {
            listener.exitExpression2(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression2) {
            return visitor.visitExpression2(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PostFixContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_postFix;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class IndexPostfixContext extends PostFixContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    enterRule(listener) {
        if (listener.enterIndexPostfix) {
            listener.enterIndexPostfix(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIndexPostfix) {
            listener.exitIndexPostfix(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitIndexPostfix) {
            return visitor.visitIndexPostfix(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyPostfixContext extends PostFixContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    property() {
        return this.getTypedRuleContext(PropertyContext, 0);
    }
    enterRule(listener) {
        if (listener.enterPropertyPostfix) {
            listener.enterPropertyPostfix(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyPostfix) {
            listener.exitPropertyPostfix(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyPostfix) {
            return visitor.visitPropertyPostfix(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RangePostfixContext extends PostFixContext {
    _fromExp;
    _toExp;
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    DOTDOT() {
        return this.getToken(CypherCmdParser.DOTDOT, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    enterRule(listener) {
        if (listener.enterRangePostfix) {
            listener.enterRangePostfix(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRangePostfix) {
            listener.exitRangePostfix(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRangePostfix) {
            return visitor.visitRangePostfix(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DOT() {
        return this.getToken(CypherCmdParser.DOT, 0);
    }
    propertyKeyName() {
        return this.getTypedRuleContext(PropertyKeyNameContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_property;
    }
    enterRule(listener) {
        if (listener.enterProperty) {
            listener.enterProperty(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProperty) {
            listener.exitProperty(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProperty) {
            return visitor.visitProperty(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicPropertyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dynamicProperty;
    }
    enterRule(listener) {
        if (listener.enterDynamicProperty) {
            listener.enterDynamicProperty(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDynamicProperty) {
            listener.exitDynamicProperty(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicProperty) {
            return visitor.visitDynamicProperty(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression1() {
        return this.getTypedRuleContext(Expression1Context, 0);
    }
    property_list() {
        return this.getTypedRuleContexts(PropertyContext);
    }
    property(i) {
        return this.getTypedRuleContext(PropertyContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyExpression;
    }
    enterRule(listener) {
        if (listener.enterPropertyExpression) {
            listener.enterPropertyExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyExpression) {
            listener.exitPropertyExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyExpression) {
            return visitor.visitPropertyExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicPropertyExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression1() {
        return this.getTypedRuleContext(Expression1Context, 0);
    }
    dynamicProperty() {
        return this.getTypedRuleContext(DynamicPropertyContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dynamicPropertyExpression;
    }
    enterRule(listener) {
        if (listener.enterDynamicPropertyExpression) {
            listener.enterDynamicPropertyExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDynamicPropertyExpression) {
            listener.exitDynamicPropertyExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicPropertyExpression) {
            return visitor.visitDynamicPropertyExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class Expression1Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    literal() {
        return this.getTypedRuleContext(LiteralContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    caseExpression() {
        return this.getTypedRuleContext(CaseExpressionContext, 0);
    }
    extendedCaseExpression() {
        return this.getTypedRuleContext(ExtendedCaseExpressionContext, 0);
    }
    countStar() {
        return this.getTypedRuleContext(CountStarContext, 0);
    }
    existsExpression() {
        return this.getTypedRuleContext(ExistsExpressionContext, 0);
    }
    countExpression() {
        return this.getTypedRuleContext(CountExpressionContext, 0);
    }
    collectExpression() {
        return this.getTypedRuleContext(CollectExpressionContext, 0);
    }
    mapProjection() {
        return this.getTypedRuleContext(MapProjectionContext, 0);
    }
    listComprehension() {
        return this.getTypedRuleContext(ListComprehensionContext, 0);
    }
    listLiteral() {
        return this.getTypedRuleContext(ListLiteralContext, 0);
    }
    patternComprehension() {
        return this.getTypedRuleContext(PatternComprehensionContext, 0);
    }
    reduceExpression() {
        return this.getTypedRuleContext(ReduceExpressionContext, 0);
    }
    allReduceExpression() {
        return this.getTypedRuleContext(AllReduceExpressionContext, 0);
    }
    listItemsPredicate() {
        return this.getTypedRuleContext(ListItemsPredicateContext, 0);
    }
    normalizeFunction() {
        return this.getTypedRuleContext(NormalizeFunctionContext, 0);
    }
    vectorFunction() {
        return this.getTypedRuleContext(VectorFunctionContext, 0);
    }
    trimFunction() {
        return this.getTypedRuleContext(TrimFunctionContext, 0);
    }
    patternExpression() {
        return this.getTypedRuleContext(PatternExpressionContext, 0);
    }
    shortestPathExpression() {
        return this.getTypedRuleContext(ShortestPathExpressionContext, 0);
    }
    parenthesizedExpression() {
        return this.getTypedRuleContext(ParenthesizedExpressionContext, 0);
    }
    functionInvocation() {
        return this.getTypedRuleContext(FunctionInvocationContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_expression1;
    }
    enterRule(listener) {
        if (listener.enterExpression1) {
            listener.enterExpression1(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression1) {
            listener.exitExpression1(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression1) {
            return visitor.visitExpression1(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_literal;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class NummericLiteralContext extends LiteralContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    numberLiteral() {
        return this.getTypedRuleContext(NumberLiteralContext, 0);
    }
    enterRule(listener) {
        if (listener.enterNummericLiteral) {
            listener.enterNummericLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNummericLiteral) {
            listener.exitNummericLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNummericLiteral) {
            return visitor.visitNummericLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class BooleanLiteralContext extends LiteralContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    TRUE() {
        return this.getToken(CypherCmdParser.TRUE, 0);
    }
    FALSE() {
        return this.getToken(CypherCmdParser.FALSE, 0);
    }
    enterRule(listener) {
        if (listener.enterBooleanLiteral) {
            listener.enterBooleanLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitBooleanLiteral) {
            listener.exitBooleanLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBooleanLiteral) {
            return visitor.visitBooleanLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class KeywordLiteralContext extends LiteralContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    INF() {
        return this.getToken(CypherCmdParser.INF, 0);
    }
    INFINITY() {
        return this.getToken(CypherCmdParser.INFINITY, 0);
    }
    NAN() {
        return this.getToken(CypherCmdParser.NAN, 0);
    }
    NULL() {
        return this.getToken(CypherCmdParser.NULL, 0);
    }
    enterRule(listener) {
        if (listener.enterKeywordLiteral) {
            listener.enterKeywordLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitKeywordLiteral) {
            listener.exitKeywordLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitKeywordLiteral) {
            return visitor.visitKeywordLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class OtherLiteralContext extends LiteralContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    enterRule(listener) {
        if (listener.enterOtherLiteral) {
            listener.enterOtherLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOtherLiteral) {
            listener.exitOtherLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitOtherLiteral) {
            return visitor.visitOtherLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringsLiteralContext extends LiteralContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    enterRule(listener) {
        if (listener.enterStringsLiteral) {
            listener.enterStringsLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringsLiteral) {
            listener.exitStringsLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringsLiteral) {
            return visitor.visitStringsLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CaseExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(CypherCmdParser.CASE, 0);
    }
    END() {
        return this.getToken(CypherCmdParser.END, 0);
    }
    caseAlternative_list() {
        return this.getTypedRuleContexts(CaseAlternativeContext);
    }
    caseAlternative(i) {
        return this.getTypedRuleContext(CaseAlternativeContext, i);
    }
    ELSE() {
        return this.getToken(CypherCmdParser.ELSE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_caseExpression;
    }
    enterRule(listener) {
        if (listener.enterCaseExpression) {
            listener.enterCaseExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseExpression) {
            listener.exitCaseExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCaseExpression) {
            return visitor.visitCaseExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CaseAlternativeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WHEN() {
        return this.getToken(CypherCmdParser.WHEN, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    THEN() {
        return this.getToken(CypherCmdParser.THEN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_caseAlternative;
    }
    enterRule(listener) {
        if (listener.enterCaseAlternative) {
            listener.enterCaseAlternative(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseAlternative) {
            listener.exitCaseAlternative(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCaseAlternative) {
            return visitor.visitCaseAlternative(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExtendedCaseExpressionContext extends ParserRuleContext {
    _elseExp;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(CypherCmdParser.CASE, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    END() {
        return this.getToken(CypherCmdParser.END, 0);
    }
    extendedCaseAlternative_list() {
        return this.getTypedRuleContexts(ExtendedCaseAlternativeContext);
    }
    extendedCaseAlternative(i) {
        return this.getTypedRuleContext(ExtendedCaseAlternativeContext, i);
    }
    ELSE() {
        return this.getToken(CypherCmdParser.ELSE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_extendedCaseExpression;
    }
    enterRule(listener) {
        if (listener.enterExtendedCaseExpression) {
            listener.enterExtendedCaseExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExtendedCaseExpression) {
            listener.exitExtendedCaseExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExtendedCaseExpression) {
            return visitor.visitExtendedCaseExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExtendedCaseAlternativeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WHEN() {
        return this.getToken(CypherCmdParser.WHEN, 0);
    }
    extendedWhen_list() {
        return this.getTypedRuleContexts(ExtendedWhenContext);
    }
    extendedWhen(i) {
        return this.getTypedRuleContext(ExtendedWhenContext, i);
    }
    THEN() {
        return this.getToken(CypherCmdParser.THEN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_extendedCaseAlternative;
    }
    enterRule(listener) {
        if (listener.enterExtendedCaseAlternative) {
            listener.enterExtendedCaseAlternative(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExtendedCaseAlternative) {
            listener.exitExtendedCaseAlternative(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExtendedCaseAlternative) {
            return visitor.visitExtendedCaseAlternative(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExtendedWhenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_extendedWhen;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class WhenSimpleComparisonContext extends ExtendedWhenContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expression7() {
        return this.getTypedRuleContext(Expression7Context, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    INVALID_NEQ() {
        return this.getToken(CypherCmdParser.INVALID_NEQ, 0);
    }
    NEQ() {
        return this.getToken(CypherCmdParser.NEQ, 0);
    }
    LE() {
        return this.getToken(CypherCmdParser.LE, 0);
    }
    GE() {
        return this.getToken(CypherCmdParser.GE, 0);
    }
    LT() {
        return this.getToken(CypherCmdParser.LT, 0);
    }
    GT() {
        return this.getToken(CypherCmdParser.GT, 0);
    }
    enterRule(listener) {
        if (listener.enterWhenSimpleComparison) {
            listener.enterWhenSimpleComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhenSimpleComparison) {
            listener.exitWhenSimpleComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWhenSimpleComparison) {
            return visitor.visitWhenSimpleComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WhenEqualsContext extends ExtendedWhenContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterWhenEquals) {
            listener.enterWhenEquals(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhenEquals) {
            listener.exitWhenEquals(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWhenEquals) {
            return visitor.visitWhenEquals(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WhenAdvancedComparisonContext extends ExtendedWhenContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    comparisonExpression6() {
        return this.getTypedRuleContext(ComparisonExpression6Context, 0);
    }
    enterRule(listener) {
        if (listener.enterWhenAdvancedComparison) {
            listener.enterWhenAdvancedComparison(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhenAdvancedComparison) {
            listener.exitWhenAdvancedComparison(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWhenAdvancedComparison) {
            return visitor.visitWhenAdvancedComparison(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ListComprehensionContext extends ParserRuleContext {
    _whereExp;
    _barExp;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    BAR() {
        return this.getToken(CypherCmdParser.BAR, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_listComprehension;
    }
    enterRule(listener) {
        if (listener.enterListComprehension) {
            listener.enterListComprehension(this);
        }
    }
    exitRule(listener) {
        if (listener.exitListComprehension) {
            listener.exitListComprehension(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitListComprehension) {
            return visitor.visitListComprehension(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PatternComprehensionContext extends ParserRuleContext {
    _whereExp;
    _barExp;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    pathPatternNonEmpty() {
        return this.getTypedRuleContext(PathPatternNonEmptyContext, 0);
    }
    BAR() {
        return this.getToken(CypherCmdParser.BAR, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_patternComprehension;
    }
    enterRule(listener) {
        if (listener.enterPatternComprehension) {
            listener.enterPatternComprehension(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPatternComprehension) {
            listener.exitPatternComprehension(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPatternComprehension) {
            return visitor.visitPatternComprehension(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReduceExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REDUCE() {
        return this.getToken(CypherCmdParser.REDUCE, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable_list() {
        return this.getTypedRuleContexts(VariableContext);
    }
    variable(i) {
        return this.getTypedRuleContext(VariableContext, i);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    COMMA() {
        return this.getToken(CypherCmdParser.COMMA, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    BAR() {
        return this.getToken(CypherCmdParser.BAR, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_reduceExpression;
    }
    enterRule(listener) {
        if (listener.enterReduceExpression) {
            listener.enterReduceExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReduceExpression) {
            listener.exitReduceExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReduceExpression) {
            return visitor.visitReduceExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AllReduceExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALLREDUCE() {
        return this.getToken(CypherCmdParser.ALLREDUCE, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_allReduceExpression;
    }
    enterRule(listener) {
        if (listener.enterAllReduceExpression) {
            listener.enterAllReduceExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAllReduceExpression) {
            listener.exitAllReduceExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAllReduceExpression) {
            return visitor.visitAllReduceExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ListItemsPredicateContext extends ParserRuleContext {
    _inExp;
    _whereExp;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    ANY() {
        return this.getToken(CypherCmdParser.ANY, 0);
    }
    NONE() {
        return this.getToken(CypherCmdParser.NONE, 0);
    }
    SINGLE() {
        return this.getToken(CypherCmdParser.SINGLE, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_listItemsPredicate;
    }
    enterRule(listener) {
        if (listener.enterListItemsPredicate) {
            listener.enterListItemsPredicate(this);
        }
    }
    exitRule(listener) {
        if (listener.exitListItemsPredicate) {
            listener.exitListItemsPredicate(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitListItemsPredicate) {
            return visitor.visitListItemsPredicate(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NormalizeFunctionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NORMALIZE() {
        return this.getToken(CypherCmdParser.NORMALIZE, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    COMMA() {
        return this.getToken(CypherCmdParser.COMMA, 0);
    }
    normalForm() {
        return this.getTypedRuleContext(NormalFormContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_normalizeFunction;
    }
    enterRule(listener) {
        if (listener.enterNormalizeFunction) {
            listener.enterNormalizeFunction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNormalizeFunction) {
            listener.exitNormalizeFunction(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNormalizeFunction) {
            return visitor.visitNormalizeFunction(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class VectorFunctionContext extends ParserRuleContext {
    _vectorValue;
    _dimension;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    VECTOR() {
        return this.getToken(CypherCmdParser.VECTOR, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    vectorCoordinateType() {
        return this.getTypedRuleContext(VectorCoordinateTypeContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_vectorFunction;
    }
    enterRule(listener) {
        if (listener.enterVectorFunction) {
            listener.enterVectorFunction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitVectorFunction) {
            listener.exitVectorFunction(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitVectorFunction) {
            return visitor.visitVectorFunction(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TrimFunctionContext extends ParserRuleContext {
    _trimCharacterString;
    _trimSource;
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TRIM() {
        return this.getToken(CypherCmdParser.TRIM, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    BOTH() {
        return this.getToken(CypherCmdParser.BOTH, 0);
    }
    LEADING() {
        return this.getToken(CypherCmdParser.LEADING, 0);
    }
    TRAILING() {
        return this.getToken(CypherCmdParser.TRAILING, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_trimFunction;
    }
    enterRule(listener) {
        if (listener.enterTrimFunction) {
            listener.enterTrimFunction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTrimFunction) {
            listener.exitTrimFunction(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTrimFunction) {
            return visitor.visitTrimFunction(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PatternExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    pathPatternNonEmpty() {
        return this.getTypedRuleContext(PathPatternNonEmptyContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_patternExpression;
    }
    enterRule(listener) {
        if (listener.enterPatternExpression) {
            listener.enterPatternExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPatternExpression) {
            listener.exitPatternExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPatternExpression) {
            return visitor.visitPatternExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShortestPathExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    shortestPathPattern() {
        return this.getTypedRuleContext(ShortestPathPatternContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_shortestPathExpression;
    }
    enterRule(listener) {
        if (listener.enterShortestPathExpression) {
            listener.enterShortestPathExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShortestPathExpression) {
            listener.exitShortestPathExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShortestPathExpression) {
            return visitor.visitShortestPathExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParenthesizedExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_parenthesizedExpression;
    }
    enterRule(listener) {
        if (listener.enterParenthesizedExpression) {
            listener.enterParenthesizedExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParenthesizedExpression) {
            listener.exitParenthesizedExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParenthesizedExpression) {
            return visitor.visitParenthesizedExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MapProjectionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    mapProjectionElement_list() {
        return this.getTypedRuleContexts(MapProjectionElementContext);
    }
    mapProjectionElement(i) {
        return this.getTypedRuleContext(MapProjectionElementContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_mapProjection;
    }
    enterRule(listener) {
        if (listener.enterMapProjection) {
            listener.enterMapProjection(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMapProjection) {
            listener.exitMapProjection(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMapProjection) {
            return visitor.visitMapProjection(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MapProjectionElementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    propertyKeyName() {
        return this.getTypedRuleContext(PropertyKeyNameContext, 0);
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    property() {
        return this.getTypedRuleContext(PropertyContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    DOT() {
        return this.getToken(CypherCmdParser.DOT, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_mapProjectionElement;
    }
    enterRule(listener) {
        if (listener.enterMapProjectionElement) {
            listener.enterMapProjectionElement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMapProjectionElement) {
            listener.exitMapProjectionElement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMapProjectionElement) {
            return visitor.visitMapProjectionElement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CountStarContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COUNT() {
        return this.getToken(CypherCmdParser.COUNT, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_countStar;
    }
    enterRule(listener) {
        if (listener.enterCountStar) {
            listener.enterCountStar(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCountStar) {
            listener.exitCountStar(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCountStar) {
            return visitor.visitCountStar(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExistsExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    nextStatement() {
        return this.getTypedRuleContext(NextStatementContext, 0);
    }
    patternList() {
        return this.getTypedRuleContext(PatternListContext, 0);
    }
    matchMode() {
        return this.getTypedRuleContext(MatchModeContext, 0);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_existsExpression;
    }
    enterRule(listener) {
        if (listener.enterExistsExpression) {
            listener.enterExistsExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExistsExpression) {
            listener.exitExistsExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExistsExpression) {
            return visitor.visitExistsExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CountExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COUNT() {
        return this.getToken(CypherCmdParser.COUNT, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    nextStatement() {
        return this.getTypedRuleContext(NextStatementContext, 0);
    }
    patternList() {
        return this.getTypedRuleContext(PatternListContext, 0);
    }
    matchMode() {
        return this.getTypedRuleContext(MatchModeContext, 0);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_countExpression;
    }
    enterRule(listener) {
        if (listener.enterCountExpression) {
            listener.enterCountExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCountExpression) {
            listener.exitCountExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCountExpression) {
            return visitor.visitCountExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CollectExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLLECT() {
        return this.getToken(CypherCmdParser.COLLECT, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    nextStatement() {
        return this.getTypedRuleContext(NextStatementContext, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_collectExpression;
    }
    enterRule(listener) {
        if (listener.enterCollectExpression) {
            listener.enterCollectExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCollectExpression) {
            listener.exitCollectExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCollectExpression) {
            return visitor.visitCollectExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NumberLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DECIMAL_DOUBLE() {
        return this.getToken(CypherCmdParser.DECIMAL_DOUBLE, 0);
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    UNSIGNED_HEX_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_HEX_INTEGER, 0);
    }
    UNSIGNED_OCTAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_OCTAL_INTEGER, 0);
    }
    MINUS() {
        return this.getToken(CypherCmdParser.MINUS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_numberLiteral;
    }
    enterRule(listener) {
        if (listener.enterNumberLiteral) {
            listener.enterNumberLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNumberLiteral) {
            listener.exitNumberLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNumberLiteral) {
            return visitor.visitNumberLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SignedIntegerLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    MINUS() {
        return this.getToken(CypherCmdParser.MINUS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_signedIntegerLiteral;
    }
    enterRule(listener) {
        if (listener.enterSignedIntegerLiteral) {
            listener.enterSignedIntegerLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSignedIntegerLiteral) {
            listener.exitSignedIntegerLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSignedIntegerLiteral) {
            return visitor.visitSignedIntegerLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ListLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_listLiteral;
    }
    enterRule(listener) {
        if (listener.enterListLiteral) {
            listener.enterListLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitListLiteral) {
            listener.exitListLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitListLiteral) {
            return visitor.visitListLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyKeyNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyKeyName;
    }
    enterRule(listener) {
        if (listener.enterPropertyKeyName) {
            listener.enterPropertyKeyName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyKeyName) {
            listener.exitPropertyKeyName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyKeyName) {
            return visitor.visitPropertyKeyName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParameterContext extends ParserRuleContext {
    paramType;
    constructor(parser, parent, invokingState, paramType) {
        super(parent, invokingState);
        this.parser = parser;
        this.paramType = paramType;
    }
    DOLLAR() {
        return this.getToken(CypherCmdParser.DOLLAR, 0);
    }
    parameterName() {
        return this.getTypedRuleContext(ParameterNameContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_parameter;
    }
    enterRule(listener) {
        if (listener.enterParameter) {
            listener.enterParameter(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParameter) {
            listener.exitParameter(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParameter) {
            return visitor.visitParameter(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParameterNameContext extends ParserRuleContext {
    paramType;
    constructor(parser, parent, invokingState, paramType) {
        super(parent, invokingState);
        this.parser = parser;
        this.paramType = paramType;
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    UNSIGNED_OCTAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_OCTAL_INTEGER, 0);
    }
    EXTENDED_IDENTIFIER() {
        return this.getToken(CypherCmdParser.EXTENDED_IDENTIFIER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_parameterName;
    }
    enterRule(listener) {
        if (listener.enterParameterName) {
            listener.enterParameterName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitParameterName) {
            listener.exitParameterName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParameterName) {
            return visitor.visitParameterName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FunctionInvocationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    functionName() {
        return this.getTypedRuleContext(FunctionNameContext, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    functionArgument_list() {
        return this.getTypedRuleContexts(FunctionArgumentContext);
    }
    functionArgument(i) {
        return this.getTypedRuleContext(FunctionArgumentContext, i);
    }
    DISTINCT() {
        return this.getToken(CypherCmdParser.DISTINCT, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_functionInvocation;
    }
    enterRule(listener) {
        if (listener.enterFunctionInvocation) {
            listener.enterFunctionInvocation(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionInvocation) {
            listener.exitFunctionInvocation(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFunctionInvocation) {
            return visitor.visitFunctionInvocation(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FunctionArgumentContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_functionArgument;
    }
    enterRule(listener) {
        if (listener.enterFunctionArgument) {
            listener.enterFunctionArgument(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionArgument) {
            listener.exitFunctionArgument(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFunctionArgument) {
            return visitor.visitFunctionArgument(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FunctionNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    namespace() {
        return this.getTypedRuleContext(NamespaceContext, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_functionName;
    }
    enterRule(listener) {
        if (listener.enterFunctionName) {
            listener.enterFunctionName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionName) {
            listener.exitFunctionName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFunctionName) {
            return visitor.visitFunctionName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NamespaceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    DOT_list() {
        return this.getTokens(CypherCmdParser.DOT);
    }
    DOT(i) {
        return this.getToken(CypherCmdParser.DOT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_namespace;
    }
    enterRule(listener) {
        if (listener.enterNamespace) {
            listener.enterNamespace(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNamespace) {
            listener.exitNamespace(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNamespace) {
            return visitor.visitNamespace(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class VariableContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicVariableNameString() {
        return this.getTypedRuleContext(SymbolicVariableNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_variable;
    }
    enterRule(listener) {
        if (listener.enterVariable) {
            listener.enterVariable(this);
        }
    }
    exitRule(listener) {
        if (listener.exitVariable) {
            listener.exitVariable(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitVariable) {
            return visitor.visitVariable(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NonEmptyNameListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nonEmptyNameList;
    }
    enterRule(listener) {
        if (listener.enterNonEmptyNameList) {
            listener.enterNonEmptyNameList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNonEmptyNameList) {
            listener.exitNonEmptyNameList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNonEmptyNameList) {
            return visitor.visitNonEmptyNameList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    typePart_list() {
        return this.getTypedRuleContexts(TypePartContext);
    }
    typePart(i) {
        return this.getTypedRuleContext(TypePartContext, i);
    }
    BAR_list() {
        return this.getTokens(CypherCmdParser.BAR);
    }
    BAR(i) {
        return this.getToken(CypherCmdParser.BAR, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_type;
    }
    enterRule(listener) {
        if (listener.enterType) {
            listener.enterType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitType) {
            listener.exitType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitType) {
            return visitor.visitType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TypePartContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    typeName() {
        return this.getTypedRuleContext(TypeNameContext, 0);
    }
    typeNullability() {
        return this.getTypedRuleContext(TypeNullabilityContext, 0);
    }
    typeListSuffix_list() {
        return this.getTypedRuleContexts(TypeListSuffixContext);
    }
    typeListSuffix(i) {
        return this.getTypedRuleContext(TypeListSuffixContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_typePart;
    }
    enterRule(listener) {
        if (listener.enterTypePart) {
            listener.enterTypePart(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTypePart) {
            listener.exitTypePart(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTypePart) {
            return visitor.visitTypePart(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TypeNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NOTHING() {
        return this.getToken(CypherCmdParser.NOTHING, 0);
    }
    NULL() {
        return this.getToken(CypherCmdParser.NULL, 0);
    }
    BOOL() {
        return this.getToken(CypherCmdParser.BOOL, 0);
    }
    BOOLEAN() {
        return this.getToken(CypherCmdParser.BOOLEAN, 0);
    }
    VARCHAR() {
        return this.getToken(CypherCmdParser.VARCHAR, 0);
    }
    STRING() {
        return this.getToken(CypherCmdParser.STRING, 0);
    }
    INT() {
        return this.getToken(CypherCmdParser.INT, 0);
    }
    INTEGER() {
        return this.getToken(CypherCmdParser.INTEGER, 0);
    }
    SIGNED() {
        return this.getToken(CypherCmdParser.SIGNED, 0);
    }
    INTEGER64() {
        return this.getToken(CypherCmdParser.INTEGER64, 0);
    }
    INT64() {
        return this.getToken(CypherCmdParser.INT64, 0);
    }
    FLOAT() {
        return this.getToken(CypherCmdParser.FLOAT, 0);
    }
    FLOAT64() {
        return this.getToken(CypherCmdParser.FLOAT64, 0);
    }
    DATE() {
        return this.getToken(CypherCmdParser.DATE, 0);
    }
    LOCAL() {
        return this.getToken(CypherCmdParser.LOCAL, 0);
    }
    TIME_list() {
        return this.getTokens(CypherCmdParser.TIME);
    }
    TIME(i) {
        return this.getToken(CypherCmdParser.TIME, i);
    }
    DATETIME() {
        return this.getToken(CypherCmdParser.DATETIME, 0);
    }
    ZONED() {
        return this.getToken(CypherCmdParser.ZONED, 0);
    }
    WITHOUT() {
        return this.getToken(CypherCmdParser.WITHOUT, 0);
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    TIMEZONE() {
        return this.getToken(CypherCmdParser.TIMEZONE, 0);
    }
    ZONE() {
        return this.getToken(CypherCmdParser.ZONE, 0);
    }
    TIMESTAMP() {
        return this.getToken(CypherCmdParser.TIMESTAMP, 0);
    }
    DURATION() {
        return this.getToken(CypherCmdParser.DURATION, 0);
    }
    POINT() {
        return this.getToken(CypherCmdParser.POINT, 0);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    VECTOR() {
        return this.getToken(CypherCmdParser.VECTOR, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    signedIntegerLiteral() {
        return this.getTypedRuleContext(SignedIntegerLiteralContext, 0);
    }
    COMMA() {
        return this.getToken(CypherCmdParser.COMMA, 0);
    }
    vectorCoordinateType() {
        return this.getTypedRuleContext(VectorCoordinateTypeContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    LT() {
        return this.getToken(CypherCmdParser.LT, 0);
    }
    GT() {
        return this.getToken(CypherCmdParser.GT, 0);
    }
    VERTEX() {
        return this.getToken(CypherCmdParser.VERTEX, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    EDGE() {
        return this.getToken(CypherCmdParser.EDGE, 0);
    }
    MAP() {
        return this.getToken(CypherCmdParser.MAP, 0);
    }
    type_() {
        return this.getTypedRuleContext(TypeContext, 0);
    }
    LIST() {
        return this.getToken(CypherCmdParser.LIST, 0);
    }
    ARRAY() {
        return this.getToken(CypherCmdParser.ARRAY, 0);
    }
    PATH() {
        return this.getToken(CypherCmdParser.PATH, 0);
    }
    PATHS() {
        return this.getToken(CypherCmdParser.PATHS, 0);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    VALUE() {
        return this.getToken(CypherCmdParser.VALUE, 0);
    }
    ANY() {
        return this.getToken(CypherCmdParser.ANY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_typeName;
    }
    enterRule(listener) {
        if (listener.enterTypeName) {
            listener.enterTypeName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTypeName) {
            listener.exitTypeName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTypeName) {
            return visitor.visitTypeName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TypeNullabilityContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    NULL() {
        return this.getToken(CypherCmdParser.NULL, 0);
    }
    EXCLAMATION_MARK() {
        return this.getToken(CypherCmdParser.EXCLAMATION_MARK, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_typeNullability;
    }
    enterRule(listener) {
        if (listener.enterTypeNullability) {
            listener.enterTypeNullability(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTypeNullability) {
            listener.exitTypeNullability(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTypeNullability) {
            return visitor.visitTypeNullability(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TypeListSuffixContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LIST() {
        return this.getToken(CypherCmdParser.LIST, 0);
    }
    ARRAY() {
        return this.getToken(CypherCmdParser.ARRAY, 0);
    }
    typeNullability() {
        return this.getTypedRuleContext(TypeNullabilityContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_typeListSuffix;
    }
    enterRule(listener) {
        if (listener.enterTypeListSuffix) {
            listener.enterTypeListSuffix(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTypeListSuffix) {
            listener.exitTypeListSuffix(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTypeListSuffix) {
            return visitor.visitTypeListSuffix(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class VectorCoordinateTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    INT() {
        return this.getToken(CypherCmdParser.INT, 0);
    }
    INTEGER() {
        return this.getToken(CypherCmdParser.INTEGER, 0);
    }
    INTEGER64() {
        return this.getToken(CypherCmdParser.INTEGER64, 0);
    }
    INTEGER32() {
        return this.getToken(CypherCmdParser.INTEGER32, 0);
    }
    INTEGER16() {
        return this.getToken(CypherCmdParser.INTEGER16, 0);
    }
    INTEGER8() {
        return this.getToken(CypherCmdParser.INTEGER8, 0);
    }
    INT64() {
        return this.getToken(CypherCmdParser.INT64, 0);
    }
    INT32() {
        return this.getToken(CypherCmdParser.INT32, 0);
    }
    INT16() {
        return this.getToken(CypherCmdParser.INT16, 0);
    }
    INT8() {
        return this.getToken(CypherCmdParser.INT8, 0);
    }
    FLOAT() {
        return this.getToken(CypherCmdParser.FLOAT, 0);
    }
    FLOAT64() {
        return this.getToken(CypherCmdParser.FLOAT64, 0);
    }
    FLOAT32() {
        return this.getToken(CypherCmdParser.FLOAT32, 0);
    }
    typeNullability() {
        return this.getTypedRuleContext(TypeNullabilityContext, 0);
    }
    SIGNED() {
        return this.getToken(CypherCmdParser.SIGNED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_vectorCoordinateType;
    }
    enterRule(listener) {
        if (listener.enterVectorCoordinateType) {
            listener.enterVectorCoordinateType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitVectorCoordinateType) {
            listener.exitVectorCoordinateType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitVectorCoordinateType) {
            return visitor.visitVectorCoordinateType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    createCommand() {
        return this.getTypedRuleContext(CreateCommandContext, 0);
    }
    dropCommand() {
        return this.getTypedRuleContext(DropCommandContext, 0);
    }
    alterCommand() {
        return this.getTypedRuleContext(AlterCommandContext, 0);
    }
    renameCommand() {
        return this.getTypedRuleContext(RenameCommandContext, 0);
    }
    denyCommand() {
        return this.getTypedRuleContext(DenyCommandContext, 0);
    }
    revokeCommand() {
        return this.getTypedRuleContext(RevokeCommandContext, 0);
    }
    grantCommand() {
        return this.getTypedRuleContext(GrantCommandContext, 0);
    }
    startDatabase() {
        return this.getTypedRuleContext(StartDatabaseContext, 0);
    }
    stopDatabase() {
        return this.getTypedRuleContext(StopDatabaseContext, 0);
    }
    enableServerCommand() {
        return this.getTypedRuleContext(EnableServerCommandContext, 0);
    }
    allocationCommand() {
        return this.getTypedRuleContext(AllocationCommandContext, 0);
    }
    showCommand() {
        return this.getTypedRuleContext(ShowCommandContext, 0);
    }
    terminateCommand() {
        return this.getTypedRuleContext(TerminateCommandContext, 0);
    }
    useClause() {
        return this.getTypedRuleContext(UseClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_command;
    }
    enterRule(listener) {
        if (listener.enterCommand) {
            listener.enterCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCommand) {
            listener.exitCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCommand) {
            return visitor.visitCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CREATE() {
        return this.getToken(CypherCmdParser.CREATE, 0);
    }
    createAlias() {
        return this.getTypedRuleContext(CreateAliasContext, 0);
    }
    createCompositeDatabase() {
        return this.getTypedRuleContext(CreateCompositeDatabaseContext, 0);
    }
    createConstraint() {
        return this.getTypedRuleContext(CreateConstraintContext, 0);
    }
    createDatabase() {
        return this.getTypedRuleContext(CreateDatabaseContext, 0);
    }
    createIndex() {
        return this.getTypedRuleContext(CreateIndexContext, 0);
    }
    createRole() {
        return this.getTypedRuleContext(CreateRoleContext, 0);
    }
    createUser() {
        return this.getTypedRuleContext(CreateUserContext, 0);
    }
    OR() {
        return this.getToken(CypherCmdParser.OR, 0);
    }
    REPLACE() {
        return this.getToken(CypherCmdParser.REPLACE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createCommand;
    }
    enterRule(listener) {
        if (listener.enterCreateCommand) {
            listener.enterCreateCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateCommand) {
            listener.exitCreateCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateCommand) {
            return visitor.visitCreateCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALTER() {
        return this.getToken(CypherCmdParser.ALTER, 0);
    }
    alterAlias() {
        return this.getTypedRuleContext(AlterAliasContext, 0);
    }
    alterCurrentUser() {
        return this.getTypedRuleContext(AlterCurrentUserContext, 0);
    }
    alterCurrentGraphType() {
        return this.getTypedRuleContext(AlterCurrentGraphTypeContext, 0);
    }
    alterDatabase() {
        return this.getTypedRuleContext(AlterDatabaseContext, 0);
    }
    alterUser() {
        return this.getTypedRuleContext(AlterUserContext, 0);
    }
    alterServer() {
        return this.getTypedRuleContext(AlterServerContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterCommand;
    }
    enterRule(listener) {
        if (listener.enterAlterCommand) {
            listener.enterAlterCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterCommand) {
            listener.exitAlterCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterCommand) {
            return visitor.visitAlterCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DROP() {
        return this.getToken(CypherCmdParser.DROP, 0);
    }
    dropAlias() {
        return this.getTypedRuleContext(DropAliasContext, 0);
    }
    dropConstraint() {
        return this.getTypedRuleContext(DropConstraintContext, 0);
    }
    dropDatabase() {
        return this.getTypedRuleContext(DropDatabaseContext, 0);
    }
    dropIndex() {
        return this.getTypedRuleContext(DropIndexContext, 0);
    }
    dropRole() {
        return this.getTypedRuleContext(DropRoleContext, 0);
    }
    dropServer() {
        return this.getTypedRuleContext(DropServerContext, 0);
    }
    dropUser() {
        return this.getTypedRuleContext(DropUserContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropCommand;
    }
    enterRule(listener) {
        if (listener.enterDropCommand) {
            listener.enterDropCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropCommand) {
            listener.exitDropCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropCommand) {
            return visitor.visitDropCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SHOW() {
        return this.getToken(CypherCmdParser.SHOW, 0);
    }
    showAliases() {
        return this.getTypedRuleContext(ShowAliasesContext, 0);
    }
    showConstraintCommand() {
        return this.getTypedRuleContext(ShowConstraintCommandContext, 0);
    }
    showCurrentUser() {
        return this.getTypedRuleContext(ShowCurrentUserContext, 0);
    }
    showDatabase() {
        return this.getTypedRuleContext(ShowDatabaseContext, 0);
    }
    showFunctions() {
        return this.getTypedRuleContext(ShowFunctionsContext, 0);
    }
    showIndexCommand() {
        return this.getTypedRuleContext(ShowIndexCommandContext, 0);
    }
    showPrivileges() {
        return this.getTypedRuleContext(ShowPrivilegesContext, 0);
    }
    showProcedures() {
        return this.getTypedRuleContext(ShowProceduresContext, 0);
    }
    showRolePrivileges() {
        return this.getTypedRuleContext(ShowRolePrivilegesContext, 0);
    }
    showRoles() {
        return this.getTypedRuleContext(ShowRolesContext, 0);
    }
    showServers() {
        return this.getTypedRuleContext(ShowServersContext, 0);
    }
    showSettings() {
        return this.getTypedRuleContext(ShowSettingsContext, 0);
    }
    showSupportedPrivileges() {
        return this.getTypedRuleContext(ShowSupportedPrivilegesContext, 0);
    }
    showTransactions() {
        return this.getTypedRuleContext(ShowTransactionsContext, 0);
    }
    showUserPrivileges() {
        return this.getTypedRuleContext(ShowUserPrivilegesContext, 0);
    }
    showUsers() {
        return this.getTypedRuleContext(ShowUsersContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showCommand;
    }
    enterRule(listener) {
        if (listener.enterShowCommand) {
            listener.enterShowCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowCommand) {
            listener.exitShowCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowCommand) {
            return visitor.visitShowCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowCommandYieldContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    yieldClause() {
        return this.getTypedRuleContext(YieldClauseContext, 0);
    }
    returnClause() {
        return this.getTypedRuleContext(ReturnClauseContext, 0);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showCommandYield;
    }
    enterRule(listener) {
        if (listener.enterShowCommandYield) {
            listener.enterShowCommandYield(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowCommandYield) {
            listener.exitShowCommandYield(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowCommandYield) {
            return visitor.visitShowCommandYield(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class YieldItemContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    variable_list() {
        return this.getTypedRuleContexts(VariableContext);
    }
    variable(i) {
        return this.getTypedRuleContext(VariableContext, i);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_yieldItem;
    }
    enterRule(listener) {
        if (listener.enterYieldItem) {
            listener.enterYieldItem(this);
        }
    }
    exitRule(listener) {
        if (listener.exitYieldItem) {
            listener.exitYieldItem(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitYieldItem) {
            return visitor.visitYieldItem(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class YieldSkipContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    signedIntegerLiteral() {
        return this.getTypedRuleContext(SignedIntegerLiteralContext, 0);
    }
    OFFSET() {
        return this.getToken(CypherCmdParser.OFFSET, 0);
    }
    SKIPROWS() {
        return this.getToken(CypherCmdParser.SKIPROWS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_yieldSkip;
    }
    enterRule(listener) {
        if (listener.enterYieldSkip) {
            listener.enterYieldSkip(this);
        }
    }
    exitRule(listener) {
        if (listener.exitYieldSkip) {
            listener.exitYieldSkip(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitYieldSkip) {
            return visitor.visitYieldSkip(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class YieldLimitContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LIMITROWS() {
        return this.getToken(CypherCmdParser.LIMITROWS, 0);
    }
    signedIntegerLiteral() {
        return this.getTypedRuleContext(SignedIntegerLiteralContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_yieldLimit;
    }
    enterRule(listener) {
        if (listener.enterYieldLimit) {
            listener.enterYieldLimit(this);
        }
    }
    exitRule(listener) {
        if (listener.exitYieldLimit) {
            listener.exitYieldLimit(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitYieldLimit) {
            return visitor.visitYieldLimit(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class YieldClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    YIELD() {
        return this.getToken(CypherCmdParser.YIELD, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    yieldItem_list() {
        return this.getTypedRuleContexts(YieldItemContext);
    }
    yieldItem(i) {
        return this.getTypedRuleContext(YieldItemContext, i);
    }
    orderBy() {
        return this.getTypedRuleContext(OrderByContext, 0);
    }
    yieldSkip() {
        return this.getTypedRuleContext(YieldSkipContext, 0);
    }
    yieldLimit() {
        return this.getTypedRuleContext(YieldLimitContext, 0);
    }
    whereClause() {
        return this.getTypedRuleContext(WhereClauseContext, 0);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_yieldClause;
    }
    enterRule(listener) {
        if (listener.enterYieldClause) {
            listener.enterYieldClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitYieldClause) {
            listener.exitYieldClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitYieldClause) {
            return visitor.visitYieldClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CommandOptionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    OPTIONS() {
        return this.getToken(CypherCmdParser.OPTIONS, 0);
    }
    mapOrParameter() {
        return this.getTypedRuleContext(MapOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_commandOptions;
    }
    enterRule(listener) {
        if (listener.enterCommandOptions) {
            listener.enterCommandOptions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCommandOptions) {
            listener.exitCommandOptions(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCommandOptions) {
            return visitor.visitCommandOptions(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TerminateCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TERMINATE() {
        return this.getToken(CypherCmdParser.TERMINATE, 0);
    }
    terminateTransactions() {
        return this.getTypedRuleContext(TerminateTransactionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_terminateCommand;
    }
    enterRule(listener) {
        if (listener.enterTerminateCommand) {
            listener.enterTerminateCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTerminateCommand) {
            listener.exitTerminateCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTerminateCommand) {
            return visitor.visitTerminateCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ComposableCommandClausesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    terminateCommand() {
        return this.getTypedRuleContext(TerminateCommandContext, 0);
    }
    composableShowCommandClauses() {
        return this.getTypedRuleContext(ComposableShowCommandClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_composableCommandClauses;
    }
    enterRule(listener) {
        if (listener.enterComposableCommandClauses) {
            listener.enterComposableCommandClauses(this);
        }
    }
    exitRule(listener) {
        if (listener.exitComposableCommandClauses) {
            listener.exitComposableCommandClauses(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitComposableCommandClauses) {
            return visitor.visitComposableCommandClauses(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ComposableShowCommandClausesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SHOW() {
        return this.getToken(CypherCmdParser.SHOW, 0);
    }
    showIndexCommand() {
        return this.getTypedRuleContext(ShowIndexCommandContext, 0);
    }
    showConstraintCommand() {
        return this.getTypedRuleContext(ShowConstraintCommandContext, 0);
    }
    showFunctions() {
        return this.getTypedRuleContext(ShowFunctionsContext, 0);
    }
    showProcedures() {
        return this.getTypedRuleContext(ShowProceduresContext, 0);
    }
    showSettings() {
        return this.getTypedRuleContext(ShowSettingsContext, 0);
    }
    showTransactions() {
        return this.getTypedRuleContext(ShowTransactionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_composableShowCommandClauses;
    }
    enterRule(listener) {
        if (listener.enterComposableShowCommandClauses) {
            listener.enterComposableShowCommandClauses(this);
        }
    }
    exitRule(listener) {
        if (listener.exitComposableShowCommandClauses) {
            listener.exitComposableShowCommandClauses(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitComposableShowCommandClauses) {
            return visitor.visitComposableShowCommandClauses(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowIndexCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    showIndexesEnd() {
        return this.getTypedRuleContext(ShowIndexesEndContext, 0);
    }
    showIndexType() {
        return this.getTypedRuleContext(ShowIndexTypeContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showIndexCommand;
    }
    enterRule(listener) {
        if (listener.enterShowIndexCommand) {
            listener.enterShowIndexCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowIndexCommand) {
            listener.exitShowIndexCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowIndexCommand) {
            return visitor.visitShowIndexCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowIndexTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    FULLTEXT() {
        return this.getToken(CypherCmdParser.FULLTEXT, 0);
    }
    LOOKUP() {
        return this.getToken(CypherCmdParser.LOOKUP, 0);
    }
    POINT() {
        return this.getToken(CypherCmdParser.POINT, 0);
    }
    RANGE() {
        return this.getToken(CypherCmdParser.RANGE, 0);
    }
    TEXT() {
        return this.getToken(CypherCmdParser.TEXT, 0);
    }
    VECTOR() {
        return this.getToken(CypherCmdParser.VECTOR, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showIndexType;
    }
    enterRule(listener) {
        if (listener.enterShowIndexType) {
            listener.enterShowIndexType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowIndexType) {
            listener.exitShowIndexType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowIndexType) {
            return visitor.visitShowIndexType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowIndexesEndContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    indexToken() {
        return this.getTypedRuleContext(IndexTokenContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    composableCommandClauses() {
        return this.getTypedRuleContext(ComposableCommandClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showIndexesEnd;
    }
    enterRule(listener) {
        if (listener.enterShowIndexesEnd) {
            listener.enterShowIndexesEnd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowIndexesEnd) {
            listener.exitShowIndexesEnd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowIndexesEnd) {
            return visitor.visitShowIndexesEnd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showConstraintCommand;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class ShowConstraintUniqueContext extends ShowConstraintCommandContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    showConstraintsEnd() {
        return this.getTypedRuleContext(ShowConstraintsEndContext, 0);
    }
    UNIQUE() {
        return this.getToken(CypherCmdParser.UNIQUE, 0);
    }
    UNIQUENESS() {
        return this.getToken(CypherCmdParser.UNIQUENESS, 0);
    }
    showConstraintEntity() {
        return this.getTypedRuleContext(ShowConstraintEntityContext, 0);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    enterRule(listener) {
        if (listener.enterShowConstraintUnique) {
            listener.enterShowConstraintUnique(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowConstraintUnique) {
            listener.exitShowConstraintUnique(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowConstraintUnique) {
            return visitor.visitShowConstraintUnique(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintExistContext extends ShowConstraintCommandContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    constraintExistType() {
        return this.getTypedRuleContext(ConstraintExistTypeContext, 0);
    }
    showConstraintsEnd() {
        return this.getTypedRuleContext(ShowConstraintsEndContext, 0);
    }
    showConstraintEntity() {
        return this.getTypedRuleContext(ShowConstraintEntityContext, 0);
    }
    enterRule(listener) {
        if (listener.enterShowConstraintExist) {
            listener.enterShowConstraintExist(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowConstraintExist) {
            listener.exitShowConstraintExist(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowConstraintExist) {
            return visitor.visitShowConstraintExist(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintAllContext extends ShowConstraintCommandContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    showConstraintsEnd() {
        return this.getTypedRuleContext(ShowConstraintsEndContext, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    enterRule(listener) {
        if (listener.enterShowConstraintAll) {
            listener.enterShowConstraintAll(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowConstraintAll) {
            listener.exitShowConstraintAll(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowConstraintAll) {
            return visitor.visitShowConstraintAll(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintKeyContext extends ShowConstraintCommandContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    KEY() {
        return this.getToken(CypherCmdParser.KEY, 0);
    }
    showConstraintsEnd() {
        return this.getTypedRuleContext(ShowConstraintsEndContext, 0);
    }
    showConstraintEntity() {
        return this.getTypedRuleContext(ShowConstraintEntityContext, 0);
    }
    enterRule(listener) {
        if (listener.enterShowConstraintKey) {
            listener.enterShowConstraintKey(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowConstraintKey) {
            listener.exitShowConstraintKey(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowConstraintKey) {
            return visitor.visitShowConstraintKey(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintPropTypeContext extends ShowConstraintCommandContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    TYPE() {
        return this.getToken(CypherCmdParser.TYPE, 0);
    }
    showConstraintsEnd() {
        return this.getTypedRuleContext(ShowConstraintsEndContext, 0);
    }
    showConstraintEntity() {
        return this.getTypedRuleContext(ShowConstraintEntityContext, 0);
    }
    enterRule(listener) {
        if (listener.enterShowConstraintPropType) {
            listener.enterShowConstraintPropType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowConstraintPropType) {
            listener.exitShowConstraintPropType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowConstraintPropType) {
            return visitor.visitShowConstraintPropType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintEntityContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showConstraintEntity;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class NodeEntityContext extends ShowConstraintEntityContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    enterRule(listener) {
        if (listener.enterNodeEntity) {
            listener.enterNodeEntity(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeEntity) {
            listener.exitNodeEntity(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeEntity) {
            return visitor.visitNodeEntity(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RelEntityContext extends ShowConstraintEntityContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    REL() {
        return this.getToken(CypherCmdParser.REL, 0);
    }
    enterRule(listener) {
        if (listener.enterRelEntity) {
            listener.enterRelEntity(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRelEntity) {
            listener.exitRelEntity(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRelEntity) {
            return visitor.visitRelEntity(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintExistTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXISTENCE() {
        return this.getToken(CypherCmdParser.EXISTENCE, 0);
    }
    EXIST() {
        return this.getToken(CypherCmdParser.EXIST, 0);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_constraintExistType;
    }
    enterRule(listener) {
        if (listener.enterConstraintExistType) {
            listener.enterConstraintExistType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintExistType) {
            listener.exitConstraintExistType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintExistType) {
            return visitor.visitConstraintExistType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowConstraintsEndContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    constraintToken() {
        return this.getTypedRuleContext(ConstraintTokenContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    composableCommandClauses() {
        return this.getTypedRuleContext(ComposableCommandClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showConstraintsEnd;
    }
    enterRule(listener) {
        if (listener.enterShowConstraintsEnd) {
            listener.enterShowConstraintsEnd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowConstraintsEnd) {
            listener.exitShowConstraintsEnd(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowConstraintsEnd) {
            return visitor.visitShowConstraintsEnd(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowProceduresContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PROCEDURE() {
        return this.getToken(CypherCmdParser.PROCEDURE, 0);
    }
    PROCEDURES() {
        return this.getToken(CypherCmdParser.PROCEDURES, 0);
    }
    executableBy() {
        return this.getTypedRuleContext(ExecutableByContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    composableCommandClauses() {
        return this.getTypedRuleContext(ComposableCommandClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showProcedures;
    }
    enterRule(listener) {
        if (listener.enterShowProcedures) {
            listener.enterShowProcedures(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowProcedures) {
            listener.exitShowProcedures(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowProcedures) {
            return visitor.visitShowProcedures(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowFunctionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    functionToken() {
        return this.getTypedRuleContext(FunctionTokenContext, 0);
    }
    showFunctionsType() {
        return this.getTypedRuleContext(ShowFunctionsTypeContext, 0);
    }
    executableBy() {
        return this.getTypedRuleContext(ExecutableByContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    composableCommandClauses() {
        return this.getTypedRuleContext(ComposableCommandClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showFunctions;
    }
    enterRule(listener) {
        if (listener.enterShowFunctions) {
            listener.enterShowFunctions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowFunctions) {
            listener.exitShowFunctions(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowFunctions) {
            return visitor.visitShowFunctions(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FunctionTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FUNCTION() {
        return this.getToken(CypherCmdParser.FUNCTION, 0);
    }
    FUNCTIONS() {
        return this.getToken(CypherCmdParser.FUNCTIONS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_functionToken;
    }
    enterRule(listener) {
        if (listener.enterFunctionToken) {
            listener.enterFunctionToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionToken) {
            listener.exitFunctionToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFunctionToken) {
            return visitor.visitFunctionToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExecutableByContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXECUTABLE() {
        return this.getToken(CypherCmdParser.EXECUTABLE, 0);
    }
    BY() {
        return this.getToken(CypherCmdParser.BY, 0);
    }
    CURRENT() {
        return this.getToken(CypherCmdParser.CURRENT, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_executableBy;
    }
    enterRule(listener) {
        if (listener.enterExecutableBy) {
            listener.enterExecutableBy(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExecutableBy) {
            listener.exitExecutableBy(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExecutableBy) {
            return visitor.visitExecutableBy(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowFunctionsTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    BUILT() {
        return this.getToken(CypherCmdParser.BUILT, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    DEFINED() {
        return this.getToken(CypherCmdParser.DEFINED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showFunctionsType;
    }
    enterRule(listener) {
        if (listener.enterShowFunctionsType) {
            listener.enterShowFunctionsType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowFunctionsType) {
            listener.exitShowFunctionsType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowFunctionsType) {
            return visitor.visitShowFunctionsType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowTransactionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    transactionToken() {
        return this.getTypedRuleContext(TransactionTokenContext, 0);
    }
    namesAndClauses() {
        return this.getTypedRuleContext(NamesAndClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showTransactions;
    }
    enterRule(listener) {
        if (listener.enterShowTransactions) {
            listener.enterShowTransactions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowTransactions) {
            listener.exitShowTransactions(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowTransactions) {
            return visitor.visitShowTransactions(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TerminateTransactionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    transactionToken() {
        return this.getTypedRuleContext(TransactionTokenContext, 0);
    }
    stringsOrExpression() {
        return this.getTypedRuleContext(StringsOrExpressionContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    composableCommandClauses() {
        return this.getTypedRuleContext(ComposableCommandClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_terminateTransactions;
    }
    enterRule(listener) {
        if (listener.enterTerminateTransactions) {
            listener.enterTerminateTransactions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTerminateTransactions) {
            listener.exitTerminateTransactions(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTerminateTransactions) {
            return visitor.visitTerminateTransactions(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowSettingsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    settingToken() {
        return this.getTypedRuleContext(SettingTokenContext, 0);
    }
    namesAndClauses() {
        return this.getTypedRuleContext(NamesAndClausesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showSettings;
    }
    enterRule(listener) {
        if (listener.enterShowSettings) {
            listener.enterShowSettings(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowSettings) {
            listener.exitShowSettings(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowSettings) {
            return visitor.visitShowSettings(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SettingTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SETTING() {
        return this.getToken(CypherCmdParser.SETTING, 0);
    }
    SETTINGS() {
        return this.getToken(CypherCmdParser.SETTINGS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_settingToken;
    }
    enterRule(listener) {
        if (listener.enterSettingToken) {
            listener.enterSettingToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSettingToken) {
            listener.exitSettingToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSettingToken) {
            return visitor.visitSettingToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NamesAndClausesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    stringsOrExpression() {
        return this.getTypedRuleContext(StringsOrExpressionContext, 0);
    }
    composableCommandClauses() {
        return this.getTypedRuleContext(ComposableCommandClausesContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_namesAndClauses;
    }
    enterRule(listener) {
        if (listener.enterNamesAndClauses) {
            listener.enterNamesAndClauses(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNamesAndClauses) {
            listener.exitNamesAndClauses(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNamesAndClauses) {
            return visitor.visitNamesAndClauses(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringsOrExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    stringList() {
        return this.getTypedRuleContext(StringListContext, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stringsOrExpression;
    }
    enterRule(listener) {
        if (listener.enterStringsOrExpression) {
            listener.enterStringsOrExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringsOrExpression) {
            listener.exitStringsOrExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringsOrExpression) {
            return visitor.visitStringsOrExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CommandNodePatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    labelType() {
        return this.getTypedRuleContext(LabelTypeContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_commandNodePattern;
    }
    enterRule(listener) {
        if (listener.enterCommandNodePattern) {
            listener.enterCommandNodePattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCommandNodePattern) {
            listener.exitCommandNodePattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCommandNodePattern) {
            return visitor.visitCommandNodePattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CommandRelPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN_list() {
        return this.getTokens(CypherCmdParser.LPAREN);
    }
    LPAREN(i) {
        return this.getToken(CypherCmdParser.LPAREN, i);
    }
    RPAREN_list() {
        return this.getTokens(CypherCmdParser.RPAREN);
    }
    RPAREN(i) {
        return this.getToken(CypherCmdParser.RPAREN, i);
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    relType() {
        return this.getTypedRuleContext(RelTypeContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    leftArrow() {
        return this.getTypedRuleContext(LeftArrowContext, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_commandRelPattern;
    }
    enterRule(listener) {
        if (listener.enterCommandRelPattern) {
            listener.enterCommandRelPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCommandRelPattern) {
            listener.exitCommandRelPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCommandRelPattern) {
            return visitor.visitCommandRelPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateConstraintContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CONSTRAINT() {
        return this.getToken(CypherCmdParser.CONSTRAINT, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    constraintType() {
        return this.getTypedRuleContext(ConstraintTypeContext, 0);
    }
    commandNodePattern() {
        return this.getTypedRuleContext(CommandNodePatternContext, 0);
    }
    commandRelPattern() {
        return this.getTypedRuleContext(CommandRelPatternContext, 0);
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createConstraint;
    }
    enterRule(listener) {
        if (listener.enterCreateConstraint) {
            listener.enterCreateConstraint(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateConstraint) {
            listener.exitCreateConstraint(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateConstraint) {
            return visitor.visitCreateConstraint(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_constraintType;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class ConstraintTypedContext extends ConstraintTypeContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    REQUIRE() {
        return this.getToken(CypherCmdParser.REQUIRE, 0);
    }
    propertyList() {
        return this.getTypedRuleContext(PropertyListContext, 0);
    }
    type_() {
        return this.getTypedRuleContext(TypeContext, 0);
    }
    COLONCOLON() {
        return this.getToken(CypherCmdParser.COLONCOLON, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    TYPED() {
        return this.getToken(CypherCmdParser.TYPED, 0);
    }
    enterRule(listener) {
        if (listener.enterConstraintTyped) {
            listener.enterConstraintTyped(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintTyped) {
            listener.exitConstraintTyped(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintTyped) {
            return visitor.visitConstraintTyped(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintKeyContext extends ConstraintTypeContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    REQUIRE() {
        return this.getToken(CypherCmdParser.REQUIRE, 0);
    }
    propertyList() {
        return this.getTypedRuleContext(PropertyListContext, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    KEY() {
        return this.getToken(CypherCmdParser.KEY, 0);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    REL() {
        return this.getToken(CypherCmdParser.REL, 0);
    }
    enterRule(listener) {
        if (listener.enterConstraintKey) {
            listener.enterConstraintKey(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintKey) {
            listener.exitConstraintKey(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintKey) {
            return visitor.visitConstraintKey(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintIsNotNullContext extends ConstraintTypeContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    REQUIRE() {
        return this.getToken(CypherCmdParser.REQUIRE, 0);
    }
    propertyList() {
        return this.getTypedRuleContext(PropertyListContext, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    NULL() {
        return this.getToken(CypherCmdParser.NULL, 0);
    }
    enterRule(listener) {
        if (listener.enterConstraintIsNotNull) {
            listener.enterConstraintIsNotNull(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintIsNotNull) {
            listener.exitConstraintIsNotNull(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintIsNotNull) {
            return visitor.visitConstraintIsNotNull(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintIsUniqueContext extends ConstraintTypeContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    REQUIRE() {
        return this.getToken(CypherCmdParser.REQUIRE, 0);
    }
    propertyList() {
        return this.getTypedRuleContext(PropertyListContext, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    UNIQUE() {
        return this.getToken(CypherCmdParser.UNIQUE, 0);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    REL() {
        return this.getToken(CypherCmdParser.REL, 0);
    }
    enterRule(listener) {
        if (listener.enterConstraintIsUnique) {
            listener.enterConstraintIsUnique(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintIsUnique) {
            listener.exitConstraintIsUnique(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintIsUnique) {
            return visitor.visitConstraintIsUnique(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropConstraintContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CONSTRAINT() {
        return this.getToken(CypherCmdParser.CONSTRAINT, 0);
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropConstraint;
    }
    enterRule(listener) {
        if (listener.enterDropConstraint) {
            listener.enterDropConstraint(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropConstraint) {
            listener.exitDropConstraint(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropConstraint) {
            return visitor.visitDropConstraint(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateIndexContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    RANGE() {
        return this.getToken(CypherCmdParser.RANGE, 0);
    }
    INDEX() {
        return this.getToken(CypherCmdParser.INDEX, 0);
    }
    createIndex_() {
        return this.getTypedRuleContext(CreateIndex_Context, 0);
    }
    TEXT() {
        return this.getToken(CypherCmdParser.TEXT, 0);
    }
    POINT() {
        return this.getToken(CypherCmdParser.POINT, 0);
    }
    VECTOR() {
        return this.getToken(CypherCmdParser.VECTOR, 0);
    }
    LOOKUP() {
        return this.getToken(CypherCmdParser.LOOKUP, 0);
    }
    createLookupIndex() {
        return this.getTypedRuleContext(CreateLookupIndexContext, 0);
    }
    FULLTEXT() {
        return this.getToken(CypherCmdParser.FULLTEXT, 0);
    }
    createFulltextIndex() {
        return this.getTypedRuleContext(CreateFulltextIndexContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createIndex;
    }
    enterRule(listener) {
        if (listener.enterCreateIndex) {
            listener.enterCreateIndex(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateIndex) {
            listener.exitCreateIndex(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateIndex) {
            return visitor.visitCreateIndex(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateIndex_Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    propertyList() {
        return this.getTypedRuleContext(PropertyListContext, 0);
    }
    commandNodePattern() {
        return this.getTypedRuleContext(CommandNodePatternContext, 0);
    }
    commandRelPattern() {
        return this.getTypedRuleContext(CommandRelPatternContext, 0);
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createIndex_;
    }
    enterRule(listener) {
        if (listener.enterCreateIndex_) {
            listener.enterCreateIndex_(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateIndex_) {
            listener.exitCreateIndex_(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateIndex_) {
            return visitor.visitCreateIndex_(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateFulltextIndexContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    EACH() {
        return this.getToken(CypherCmdParser.EACH, 0);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    enclosedPropertyList() {
        return this.getTypedRuleContext(EnclosedPropertyListContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    fulltextNodePattern() {
        return this.getTypedRuleContext(FulltextNodePatternContext, 0);
    }
    fulltextRelPattern() {
        return this.getTypedRuleContext(FulltextRelPatternContext, 0);
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createFulltextIndex;
    }
    enterRule(listener) {
        if (listener.enterCreateFulltextIndex) {
            listener.enterCreateFulltextIndex(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateFulltextIndex) {
            listener.exitCreateFulltextIndex(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateFulltextIndex) {
            return visitor.visitCreateFulltextIndex(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FulltextNodePatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    BAR_list() {
        return this.getTokens(CypherCmdParser.BAR);
    }
    BAR(i) {
        return this.getToken(CypherCmdParser.BAR, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_fulltextNodePattern;
    }
    enterRule(listener) {
        if (listener.enterFulltextNodePattern) {
            listener.enterFulltextNodePattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFulltextNodePattern) {
            listener.exitFulltextNodePattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFulltextNodePattern) {
            return visitor.visitFulltextNodePattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FulltextRelPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN_list() {
        return this.getTokens(CypherCmdParser.LPAREN);
    }
    LPAREN(i) {
        return this.getToken(CypherCmdParser.LPAREN, i);
    }
    RPAREN_list() {
        return this.getTokens(CypherCmdParser.RPAREN);
    }
    RPAREN(i) {
        return this.getToken(CypherCmdParser.RPAREN, i);
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    leftArrow() {
        return this.getTypedRuleContext(LeftArrowContext, 0);
    }
    BAR_list() {
        return this.getTokens(CypherCmdParser.BAR);
    }
    BAR(i) {
        return this.getToken(CypherCmdParser.BAR, i);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_fulltextRelPattern;
    }
    enterRule(listener) {
        if (listener.enterFulltextRelPattern) {
            listener.enterFulltextRelPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFulltextRelPattern) {
            listener.exitFulltextRelPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFulltextRelPattern) {
            return visitor.visitFulltextRelPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateLookupIndexContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    lookupIndexNodePattern() {
        return this.getTypedRuleContext(LookupIndexNodePatternContext, 0);
    }
    lookupIndexRelPattern() {
        return this.getTypedRuleContext(LookupIndexRelPatternContext, 0);
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createLookupIndex;
    }
    enterRule(listener) {
        if (listener.enterCreateLookupIndex) {
            listener.enterCreateLookupIndex(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateLookupIndex) {
            listener.exitCreateLookupIndex(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateLookupIndex) {
            return visitor.visitCreateLookupIndex(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LookupIndexNodePatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    EACH() {
        return this.getToken(CypherCmdParser.EACH, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_lookupIndexNodePattern;
    }
    enterRule(listener) {
        if (listener.enterLookupIndexNodePattern) {
            listener.enterLookupIndexNodePattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLookupIndexNodePattern) {
            listener.exitLookupIndexNodePattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLookupIndexNodePattern) {
            return visitor.visitLookupIndexNodePattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LookupIndexRelPatternContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN_list() {
        return this.getTokens(CypherCmdParser.LPAREN);
    }
    LPAREN(i) {
        return this.getToken(CypherCmdParser.LPAREN, i);
    }
    RPAREN_list() {
        return this.getTokens(CypherCmdParser.RPAREN);
    }
    RPAREN(i) {
        return this.getToken(CypherCmdParser.RPAREN, i);
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    leftArrow() {
        return this.getTypedRuleContext(LeftArrowContext, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    EACH() {
        return this.getToken(CypherCmdParser.EACH, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_lookupIndexRelPattern;
    }
    enterRule(listener) {
        if (listener.enterLookupIndexRelPattern) {
            listener.enterLookupIndexRelPattern(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLookupIndexRelPattern) {
            listener.exitLookupIndexRelPattern(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLookupIndexRelPattern) {
            return visitor.visitLookupIndexRelPattern(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropIndexContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    INDEX() {
        return this.getToken(CypherCmdParser.INDEX, 0);
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropIndex;
    }
    enterRule(listener) {
        if (listener.enterDropIndex) {
            listener.enterDropIndex(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropIndex) {
            listener.exitDropIndex(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropIndex) {
            return visitor.visitDropIndex(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    property() {
        return this.getTypedRuleContext(PropertyContext, 0);
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    enclosedPropertyList() {
        return this.getTypedRuleContext(EnclosedPropertyListContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyList;
    }
    enterRule(listener) {
        if (listener.enterPropertyList) {
            listener.enterPropertyList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyList) {
            listener.exitPropertyList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyList) {
            return visitor.visitPropertyList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EnclosedPropertyListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    variable_list() {
        return this.getTypedRuleContexts(VariableContext);
    }
    variable(i) {
        return this.getTypedRuleContext(VariableContext, i);
    }
    property_list() {
        return this.getTypedRuleContexts(PropertyContext);
    }
    property(i) {
        return this.getTypedRuleContext(PropertyContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_enclosedPropertyList;
    }
    enterRule(listener) {
        if (listener.enterEnclosedPropertyList) {
            listener.enterEnclosedPropertyList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEnclosedPropertyList) {
            listener.exitEnclosedPropertyList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEnclosedPropertyList) {
            return visitor.visitEnclosedPropertyList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterCurrentGraphTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CURRENT() {
        return this.getToken(CypherCmdParser.CURRENT, 0);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    TYPE() {
        return this.getToken(CypherCmdParser.TYPE, 0);
    }
    graphTypeSpecification() {
        return this.getTypedRuleContext(GraphTypeSpecificationContext, 0);
    }
    DROP() {
        return this.getToken(CypherCmdParser.DROP, 0);
    }
    graphTypeDropSpecification() {
        return this.getTypedRuleContext(GraphTypeDropSpecificationContext, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    ADD() {
        return this.getToken(CypherCmdParser.ADD, 0);
    }
    ALTER() {
        return this.getToken(CypherCmdParser.ALTER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterCurrentGraphType;
    }
    enterRule(listener) {
        if (listener.enterAlterCurrentGraphType) {
            listener.enterAlterCurrentGraphType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterCurrentGraphType) {
            listener.exitAlterCurrentGraphType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterCurrentGraphType) {
            return visitor.visitAlterCurrentGraphType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphTypeSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    graphTypeSpecificationBody() {
        return this.getTypedRuleContext(GraphTypeSpecificationBodyContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphTypeSpecification;
    }
    enterRule(listener) {
        if (listener.enterGraphTypeSpecification) {
            listener.enterGraphTypeSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphTypeSpecification) {
            listener.exitGraphTypeSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphTypeSpecification) {
            return visitor.visitGraphTypeSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphTypeDropSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    graphTypeDropSpecificationBody() {
        return this.getTypedRuleContext(GraphTypeDropSpecificationBodyContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphTypeDropSpecification;
    }
    enterRule(listener) {
        if (listener.enterGraphTypeDropSpecification) {
            listener.enterGraphTypeDropSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphTypeDropSpecification) {
            listener.exitGraphTypeDropSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphTypeDropSpecification) {
            return visitor.visitGraphTypeDropSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphTypeSpecificationBodyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    graphTypeElement_list() {
        return this.getTypedRuleContexts(GraphTypeElementContext);
    }
    graphTypeElement(i) {
        return this.getTypedRuleContext(GraphTypeElementContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphTypeSpecificationBody;
    }
    enterRule(listener) {
        if (listener.enterGraphTypeSpecificationBody) {
            listener.enterGraphTypeSpecificationBody(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphTypeSpecificationBody) {
            listener.exitGraphTypeSpecificationBody(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphTypeSpecificationBody) {
            return visitor.visitGraphTypeSpecificationBody(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphTypeDropSpecificationBodyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    graphTypeDropElement_list() {
        return this.getTypedRuleContexts(GraphTypeDropElementContext);
    }
    graphTypeDropElement(i) {
        return this.getTypedRuleContext(GraphTypeDropElementContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphTypeDropSpecificationBody;
    }
    enterRule(listener) {
        if (listener.enterGraphTypeDropSpecificationBody) {
            listener.enterGraphTypeDropSpecificationBody(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphTypeDropSpecificationBody) {
            listener.exitGraphTypeDropSpecificationBody(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphTypeDropSpecificationBody) {
            return visitor.visitGraphTypeDropSpecificationBody(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphTypeElementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    edgeTypeSpecification() {
        return this.getTypedRuleContext(EdgeTypeSpecificationContext, 0);
    }
    nodeTypeSpecification() {
        return this.getTypedRuleContext(NodeTypeSpecificationContext, 0);
    }
    constraintSpecification() {
        return this.getTypedRuleContext(ConstraintSpecificationContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphTypeElement;
    }
    enterRule(listener) {
        if (listener.enterGraphTypeElement) {
            listener.enterGraphTypeElement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphTypeElement) {
            listener.exitGraphTypeElement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphTypeElement) {
            return visitor.visitGraphTypeElement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphTypeDropElementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    edgeTypeSpecification() {
        return this.getTypedRuleContext(EdgeTypeSpecificationContext, 0);
    }
    nodeTypeSpecification() {
        return this.getTypedRuleContext(NodeTypeSpecificationContext, 0);
    }
    CONSTRAINT() {
        return this.getToken(CypherCmdParser.CONSTRAINT, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphTypeDropElement;
    }
    enterRule(listener) {
        if (listener.enterGraphTypeDropElement) {
            listener.enterGraphTypeDropElement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphTypeDropElement) {
            listener.exitGraphTypeDropElement(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphTypeDropElement) {
            return visitor.visitGraphTypeDropElement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeTypeInlineConstraintListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    constraintType_list() {
        return this.getTypedRuleContexts(ConstraintTypeContext);
    }
    constraintType(i) {
        return this.getTypedRuleContext(ConstraintTypeContext, i);
    }
    commandOptions_list() {
        return this.getTypedRuleContexts(CommandOptionsContext);
    }
    commandOptions(i) {
        return this.getTypedRuleContext(CommandOptionsContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeTypeInlineConstraintList;
    }
    enterRule(listener) {
        if (listener.enterNodeTypeInlineConstraintList) {
            listener.enterNodeTypeInlineConstraintList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeTypeInlineConstraintList) {
            listener.exitNodeTypeInlineConstraintList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeTypeInlineConstraintList) {
            return visitor.visitNodeTypeInlineConstraintList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EdgeTypeInlineConstraintListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    constraintType_list() {
        return this.getTypedRuleContexts(ConstraintTypeContext);
    }
    constraintType(i) {
        return this.getTypedRuleContext(ConstraintTypeContext, i);
    }
    commandOptions_list() {
        return this.getTypedRuleContexts(CommandOptionsContext);
    }
    commandOptions(i) {
        return this.getTypedRuleContext(CommandOptionsContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_edgeTypeInlineConstraintList;
    }
    enterRule(listener) {
        if (listener.enterEdgeTypeInlineConstraintList) {
            listener.enterEdgeTypeInlineConstraintList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEdgeTypeInlineConstraintList) {
            listener.exitEdgeTypeInlineConstraintList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEdgeTypeInlineConstraintList) {
            return visitor.visitEdgeTypeInlineConstraintList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ImpliesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EQ() {
        return this.getToken(CypherCmdParser.EQ, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    IMPLIES() {
        return this.getToken(CypherCmdParser.IMPLIES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_implies;
    }
    enterRule(listener) {
        if (listener.enterImplies) {
            listener.enterImplies(this);
        }
    }
    exitRule(listener) {
        if (listener.exitImplies) {
            listener.exitImplies(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitImplies) {
            return visitor.visitImplies(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeTypeSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    identifyingLabel() {
        return this.getTypedRuleContext(IdentifyingLabelContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    impliedLabelSet() {
        return this.getTypedRuleContext(ImpliedLabelSetContext, 0);
    }
    propertyTypeList() {
        return this.getTypedRuleContext(PropertyTypeListContext, 0);
    }
    nodeTypeInlineConstraintList() {
        return this.getTypedRuleContext(NodeTypeInlineConstraintListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeTypeSpecification;
    }
    enterRule(listener) {
        if (listener.enterNodeTypeSpecification) {
            listener.enterNodeTypeSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeTypeSpecification) {
            listener.exitNodeTypeSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeTypeSpecification) {
            return visitor.visitNodeTypeSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ImpliedLabelSetContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelType() {
        return this.getTypedRuleContext(LabelTypeContext, 0);
    }
    AMPERSAND_list() {
        return this.getTokens(CypherCmdParser.AMPERSAND);
    }
    AMPERSAND(i) {
        return this.getToken(CypherCmdParser.AMPERSAND, i);
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_impliedLabelSet;
    }
    enterRule(listener) {
        if (listener.enterImpliedLabelSet) {
            listener.enterImpliedLabelSet(this);
        }
    }
    exitRule(listener) {
        if (listener.exitImpliedLabelSet) {
            listener.exitImpliedLabelSet(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitImpliedLabelSet) {
            return visitor.visitImpliedLabelSet(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class IdentifyingLabelContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    labelType() {
        return this.getTypedRuleContext(LabelTypeContext, 0);
    }
    implies() {
        return this.getTypedRuleContext(ImpliesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_identifyingLabel;
    }
    enterRule(listener) {
        if (listener.enterIdentifyingLabel) {
            listener.enterIdentifyingLabel(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIdentifyingLabel) {
            listener.exitIdentifyingLabel(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitIdentifyingLabel) {
            return visitor.visitIdentifyingLabel(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeTypeReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    nodeTypeAliasReference() {
        return this.getTypedRuleContext(NodeTypeAliasReferenceContext, 0);
    }
    nodeTypeInSituReference() {
        return this.getTypedRuleContext(NodeTypeInSituReferenceContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeTypeReference;
    }
    enterRule(listener) {
        if (listener.enterNodeTypeReference) {
            listener.enterNodeTypeReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeTypeReference) {
            listener.exitNodeTypeReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeTypeReference) {
            return visitor.visitNodeTypeReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeTypeAliasReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeTypeAliasReference;
    }
    enterRule(listener) {
        if (listener.enterNodeTypeAliasReference) {
            listener.enterNodeTypeAliasReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeTypeAliasReference) {
            listener.exitNodeTypeAliasReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeTypeAliasReference) {
            return visitor.visitNodeTypeAliasReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeTypeInSituReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    labelType() {
        return this.getTypedRuleContext(LabelTypeContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    implies() {
        return this.getTypedRuleContext(ImpliesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeTypeInSituReference;
    }
    enterRule(listener) {
        if (listener.enterNodeTypeInSituReference) {
            listener.enterNodeTypeInSituReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeTypeInSituReference) {
            listener.exitNodeTypeInSituReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeTypeInSituReference) {
            return visitor.visitNodeTypeInSituReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EdgeTypeSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    nodeTypeReference_list() {
        return this.getTypedRuleContexts(NodeTypeReferenceContext);
    }
    nodeTypeReference(i) {
        return this.getTypedRuleContext(NodeTypeReferenceContext, i);
    }
    arcTypePointingRight() {
        return this.getTypedRuleContext(ArcTypePointingRightContext, 0);
    }
    edgeTypeInlineConstraintList() {
        return this.getTypedRuleContext(EdgeTypeInlineConstraintListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_edgeTypeSpecification;
    }
    enterRule(listener) {
        if (listener.enterEdgeTypeSpecification) {
            listener.enterEdgeTypeSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEdgeTypeSpecification) {
            listener.exitEdgeTypeSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEdgeTypeSpecification) {
            return visitor.visitEdgeTypeSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ArcTypePointingRightContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    identifyingRelationship() {
        return this.getTypedRuleContext(IdentifyingRelationshipContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    propertyTypeList() {
        return this.getTypedRuleContext(PropertyTypeListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_arcTypePointingRight;
    }
    enterRule(listener) {
        if (listener.enterArcTypePointingRight) {
            listener.enterArcTypePointingRight(this);
        }
    }
    exitRule(listener) {
        if (listener.exitArcTypePointingRight) {
            listener.exitArcTypePointingRight(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitArcTypePointingRight) {
            return visitor.visitArcTypePointingRight(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class IdentifyingRelationshipContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    relType() {
        return this.getTypedRuleContext(RelTypeContext, 0);
    }
    implies() {
        return this.getTypedRuleContext(ImpliesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_identifyingRelationship;
    }
    enterRule(listener) {
        if (listener.enterIdentifyingRelationship) {
            listener.enterIdentifyingRelationship(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIdentifyingRelationship) {
            listener.exitIdentifyingRelationship(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitIdentifyingRelationship) {
            return visitor.visitIdentifyingRelationship(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EdgeTypeReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    edgeTypeAliasReference() {
        return this.getTypedRuleContext(EdgeTypeAliasReferenceContext, 0);
    }
    edgeTypeInSituReference() {
        return this.getTypedRuleContext(EdgeTypeInSituReferenceContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_edgeTypeReference;
    }
    enterRule(listener) {
        if (listener.enterEdgeTypeReference) {
            listener.enterEdgeTypeReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEdgeTypeReference) {
            listener.exitEdgeTypeReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEdgeTypeReference) {
            return visitor.visitEdgeTypeReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EdgeTypeAliasReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN_list() {
        return this.getTokens(CypherCmdParser.LPAREN);
    }
    LPAREN(i) {
        return this.getToken(CypherCmdParser.LPAREN, i);
    }
    RPAREN_list() {
        return this.getTokens(CypherCmdParser.RPAREN);
    }
    RPAREN(i) {
        return this.getToken(CypherCmdParser.RPAREN, i);
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_edgeTypeAliasReference;
    }
    enterRule(listener) {
        if (listener.enterEdgeTypeAliasReference) {
            listener.enterEdgeTypeAliasReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEdgeTypeAliasReference) {
            listener.exitEdgeTypeAliasReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEdgeTypeAliasReference) {
            return visitor.visitEdgeTypeAliasReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EdgeTypeInSituReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN_list() {
        return this.getTokens(CypherCmdParser.LPAREN);
    }
    LPAREN(i) {
        return this.getToken(CypherCmdParser.LPAREN, i);
    }
    RPAREN_list() {
        return this.getTokens(CypherCmdParser.RPAREN);
    }
    RPAREN(i) {
        return this.getToken(CypherCmdParser.RPAREN, i);
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    relType() {
        return this.getTypedRuleContext(RelTypeContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    implies() {
        return this.getTypedRuleContext(ImpliesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_edgeTypeInSituReference;
    }
    enterRule(listener) {
        if (listener.enterEdgeTypeInSituReference) {
            listener.enterEdgeTypeInSituReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEdgeTypeInSituReference) {
            listener.exitEdgeTypeInSituReference(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEdgeTypeInSituReference) {
            return visitor.visitEdgeTypeInSituReference(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyTypeListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    propertyType_list() {
        return this.getTypedRuleContexts(PropertyTypeContext);
    }
    propertyType(i) {
        return this.getTypedRuleContext(PropertyTypeContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyTypeList;
    }
    enterRule(listener) {
        if (listener.enterPropertyTypeList) {
            listener.enterPropertyTypeList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyTypeList) {
            listener.exitPropertyTypeList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyTypeList) {
            return visitor.visitPropertyTypeList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    propertyKeyName() {
        return this.getTypedRuleContext(PropertyKeyNameContext, 0);
    }
    type_() {
        return this.getTypedRuleContext(TypeContext, 0);
    }
    typed() {
        return this.getTypedRuleContext(TypedContext, 0);
    }
    propertyTypeInlineConstraint() {
        return this.getTypedRuleContext(PropertyTypeInlineConstraintContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyType;
    }
    enterRule(listener) {
        if (listener.enterPropertyType) {
            listener.enterPropertyType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyType) {
            listener.exitPropertyType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyType) {
            return visitor.visitPropertyType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyTypeInlineConstraintContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    KEY() {
        return this.getToken(CypherCmdParser.KEY, 0);
    }
    UNIQUE() {
        return this.getToken(CypherCmdParser.UNIQUE, 0);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    REL() {
        return this.getToken(CypherCmdParser.REL, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyTypeInlineConstraint;
    }
    enterRule(listener) {
        if (listener.enterPropertyTypeInlineConstraint) {
            listener.enterPropertyTypeInlineConstraint(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyTypeInlineConstraint) {
            listener.exitPropertyTypeInlineConstraint(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyTypeInlineConstraint) {
            return visitor.visitPropertyTypeInlineConstraint(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TypedContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COLONCOLON() {
        return this.getToken(CypherCmdParser.COLONCOLON, 0);
    }
    TYPED() {
        return this.getToken(CypherCmdParser.TYPED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_typed;
    }
    enterRule(listener) {
        if (listener.enterTyped) {
            listener.enterTyped(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTyped) {
            listener.exitTyped(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTyped) {
            return visitor.visitTyped(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CONSTRAINT() {
        return this.getToken(CypherCmdParser.CONSTRAINT, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    constraintType() {
        return this.getTypedRuleContext(ConstraintTypeContext, 0);
    }
    nodeTypeReference() {
        return this.getTypedRuleContext(NodeTypeReferenceContext, 0);
    }
    edgeTypeReference() {
        return this.getTypedRuleContext(EdgeTypeReferenceContext, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_constraintSpecification;
    }
    enterRule(listener) {
        if (listener.enterConstraintSpecification) {
            listener.enterConstraintSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintSpecification) {
            listener.exitConstraintSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintSpecification) {
            return visitor.visitConstraintSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RenameCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    RENAME() {
        return this.getToken(CypherCmdParser.RENAME, 0);
    }
    renameRole() {
        return this.getTypedRuleContext(RenameRoleContext, 0);
    }
    renameServer() {
        return this.getTypedRuleContext(RenameServerContext, 0);
    }
    renameUser() {
        return this.getTypedRuleContext(RenameUserContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_renameCommand;
    }
    enterRule(listener) {
        if (listener.enterRenameCommand) {
            listener.enterRenameCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRenameCommand) {
            listener.exitRenameCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRenameCommand) {
            return visitor.visitRenameCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GrantCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    GRANT() {
        return this.getToken(CypherCmdParser.GRANT, 0);
    }
    privilege() {
        return this.getTypedRuleContext(PrivilegeContext, 0);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    roleNames() {
        return this.getTypedRuleContext(RoleNamesContext, 0);
    }
    roleToken() {
        return this.getTypedRuleContext(RoleTokenContext, 0);
    }
    grantRole() {
        return this.getTypedRuleContext(GrantRoleContext, 0);
    }
    IMMUTABLE() {
        return this.getToken(CypherCmdParser.IMMUTABLE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_grantCommand;
    }
    enterRule(listener) {
        if (listener.enterGrantCommand) {
            listener.enterGrantCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGrantCommand) {
            listener.exitGrantCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGrantCommand) {
            return visitor.visitGrantCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DenyCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DENY() {
        return this.getToken(CypherCmdParser.DENY, 0);
    }
    privilege() {
        return this.getTypedRuleContext(PrivilegeContext, 0);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    roleNames() {
        return this.getTypedRuleContext(RoleNamesContext, 0);
    }
    IMMUTABLE() {
        return this.getToken(CypherCmdParser.IMMUTABLE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_denyCommand;
    }
    enterRule(listener) {
        if (listener.enterDenyCommand) {
            listener.enterDenyCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDenyCommand) {
            listener.exitDenyCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDenyCommand) {
            return visitor.visitDenyCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RevokeCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REVOKE() {
        return this.getToken(CypherCmdParser.REVOKE, 0);
    }
    privilege() {
        return this.getTypedRuleContext(PrivilegeContext, 0);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    roleNames() {
        return this.getTypedRuleContext(RoleNamesContext, 0);
    }
    roleToken() {
        return this.getTypedRuleContext(RoleTokenContext, 0);
    }
    revokeRole() {
        return this.getTypedRuleContext(RevokeRoleContext, 0);
    }
    IMMUTABLE() {
        return this.getToken(CypherCmdParser.IMMUTABLE, 0);
    }
    DENY() {
        return this.getToken(CypherCmdParser.DENY, 0);
    }
    GRANT() {
        return this.getToken(CypherCmdParser.GRANT, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_revokeCommand;
    }
    enterRule(listener) {
        if (listener.enterRevokeCommand) {
            listener.enterRevokeCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRevokeCommand) {
            listener.exitRevokeCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRevokeCommand) {
            return visitor.visitRevokeCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UserNamesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameOrStringParameterList() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_userNames;
    }
    enterRule(listener) {
        if (listener.enterUserNames) {
            listener.enterUserNames(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUserNames) {
            listener.exitUserNames(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUserNames) {
            return visitor.visitUserNames(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RoleNamesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameOrStringParameterList() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_roleNames;
    }
    enterRule(listener) {
        if (listener.enterRoleNames) {
            listener.enterRoleNames(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRoleNames) {
            listener.exitRoleNames(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRoleNames) {
            return visitor.visitRoleNames(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RoleTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ROLES() {
        return this.getToken(CypherCmdParser.ROLES, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_roleToken;
    }
    enterRule(listener) {
        if (listener.enterRoleToken) {
            listener.enterRoleToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRoleToken) {
            listener.exitRoleToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRoleToken) {
            return visitor.visitRoleToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EnableServerCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ENABLE() {
        return this.getToken(CypherCmdParser.ENABLE, 0);
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    stringOrParameter() {
        return this.getTypedRuleContext(StringOrParameterContext, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_enableServerCommand;
    }
    enterRule(listener) {
        if (listener.enterEnableServerCommand) {
            listener.enterEnableServerCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEnableServerCommand) {
            listener.exitEnableServerCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEnableServerCommand) {
            return visitor.visitEnableServerCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterServerContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    stringOrParameter() {
        return this.getTypedRuleContext(StringOrParameterContext, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterServer;
    }
    enterRule(listener) {
        if (listener.enterAlterServer) {
            listener.enterAlterServer(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterServer) {
            listener.exitAlterServer(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterServer) {
            return visitor.visitAlterServer(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RenameServerContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    stringOrParameter_list() {
        return this.getTypedRuleContexts(StringOrParameterContext);
    }
    stringOrParameter(i) {
        return this.getTypedRuleContext(StringOrParameterContext, i);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_renameServer;
    }
    enterRule(listener) {
        if (listener.enterRenameServer) {
            listener.enterRenameServer(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRenameServer) {
            listener.exitRenameServer(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRenameServer) {
            return visitor.visitRenameServer(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropServerContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    stringOrParameter() {
        return this.getTypedRuleContext(StringOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropServer;
    }
    enterRule(listener) {
        if (listener.enterDropServer) {
            listener.enterDropServer(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropServer) {
            listener.exitDropServer(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropServer) {
            return visitor.visitDropServer(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowServersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    SERVERS() {
        return this.getToken(CypherCmdParser.SERVERS, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showServers;
    }
    enterRule(listener) {
        if (listener.enterShowServers) {
            listener.enterShowServers(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowServers) {
            listener.exitShowServers(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowServers) {
            return visitor.visitShowServers(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AllocationCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    deallocateDatabaseFromServers() {
        return this.getTypedRuleContext(DeallocateDatabaseFromServersContext, 0);
    }
    reallocateDatabases() {
        return this.getTypedRuleContext(ReallocateDatabasesContext, 0);
    }
    DRYRUN() {
        return this.getToken(CypherCmdParser.DRYRUN, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_allocationCommand;
    }
    enterRule(listener) {
        if (listener.enterAllocationCommand) {
            listener.enterAllocationCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAllocationCommand) {
            listener.exitAllocationCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAllocationCommand) {
            return visitor.visitAllocationCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DeallocateDatabaseFromServersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DEALLOCATE() {
        return this.getToken(CypherCmdParser.DEALLOCATE, 0);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    stringOrParameter_list() {
        return this.getTypedRuleContexts(StringOrParameterContext);
    }
    stringOrParameter(i) {
        return this.getTypedRuleContext(StringOrParameterContext, i);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    SERVERS() {
        return this.getToken(CypherCmdParser.SERVERS, 0);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_deallocateDatabaseFromServers;
    }
    enterRule(listener) {
        if (listener.enterDeallocateDatabaseFromServers) {
            listener.enterDeallocateDatabaseFromServers(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDeallocateDatabaseFromServers) {
            listener.exitDeallocateDatabaseFromServers(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDeallocateDatabaseFromServers) {
            return visitor.visitDeallocateDatabaseFromServers(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ReallocateDatabasesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REALLOCATE() {
        return this.getToken(CypherCmdParser.REALLOCATE, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_reallocateDatabases;
    }
    enterRule(listener) {
        if (listener.enterReallocateDatabases) {
            listener.enterReallocateDatabases(this);
        }
    }
    exitRule(listener) {
        if (listener.exitReallocateDatabases) {
            listener.exitReallocateDatabases(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitReallocateDatabases) {
            return visitor.visitReallocateDatabases(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateRoleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    commandNameExpression_list() {
        return this.getTypedRuleContexts(CommandNameExpressionContext);
    }
    commandNameExpression(i) {
        return this.getTypedRuleContext(CommandNameExpressionContext, i);
    }
    IMMUTABLE() {
        return this.getToken(CypherCmdParser.IMMUTABLE, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    COPY() {
        return this.getToken(CypherCmdParser.COPY, 0);
    }
    OF() {
        return this.getToken(CypherCmdParser.OF, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createRole;
    }
    enterRule(listener) {
        if (listener.enterCreateRole) {
            listener.enterCreateRole(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateRole) {
            listener.exitCreateRole(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateRole) {
            return visitor.visitCreateRole(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropRoleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    commandNameExpression() {
        return this.getTypedRuleContext(CommandNameExpressionContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropRole;
    }
    enterRule(listener) {
        if (listener.enterDropRole) {
            listener.enterDropRole(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropRole) {
            listener.exitDropRole(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropRole) {
            return visitor.visitDropRole(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RenameRoleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    commandNameExpression_list() {
        return this.getTypedRuleContexts(CommandNameExpressionContext);
    }
    commandNameExpression(i) {
        return this.getTypedRuleContext(CommandNameExpressionContext, i);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_renameRole;
    }
    enterRule(listener) {
        if (listener.enterRenameRole) {
            listener.enterRenameRole(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRenameRole) {
            listener.exitRenameRole(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRenameRole) {
            return visitor.visitRenameRole(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowRolesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    roleToken() {
        return this.getTypedRuleContext(RoleTokenContext, 0);
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    POPULATED() {
        return this.getToken(CypherCmdParser.POPULATED, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    USERS() {
        return this.getToken(CypherCmdParser.USERS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showRoles;
    }
    enterRule(listener) {
        if (listener.enterShowRoles) {
            listener.enterShowRoles(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowRoles) {
            listener.exitShowRoles(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowRoles) {
            return visitor.visitShowRoles(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GrantRoleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    roleNames() {
        return this.getTypedRuleContext(RoleNamesContext, 0);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    userNames() {
        return this.getTypedRuleContext(UserNamesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_grantRole;
    }
    enterRule(listener) {
        if (listener.enterGrantRole) {
            listener.enterGrantRole(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGrantRole) {
            listener.exitGrantRole(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGrantRole) {
            return visitor.visitGrantRole(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RevokeRoleContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    roleNames() {
        return this.getTypedRuleContext(RoleNamesContext, 0);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    userNames() {
        return this.getTypedRuleContext(UserNamesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_revokeRole;
    }
    enterRule(listener) {
        if (listener.enterRevokeRole) {
            listener.enterRevokeRole(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRevokeRole) {
            listener.exitRevokeRole(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRevokeRole) {
            return visitor.visitRevokeRole(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    commandNameExpression() {
        return this.getTypedRuleContext(CommandNameExpressionContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    SET_list() {
        return this.getTokens(CypherCmdParser.SET);
    }
    SET(i) {
        return this.getToken(CypherCmdParser.SET, i);
    }
    password_list() {
        return this.getTypedRuleContexts(PasswordContext);
    }
    password(i) {
        return this.getTypedRuleContext(PasswordContext, i);
    }
    PASSWORD_list() {
        return this.getTokens(CypherCmdParser.PASSWORD);
    }
    PASSWORD(i) {
        return this.getToken(CypherCmdParser.PASSWORD, i);
    }
    passwordChangeRequired_list() {
        return this.getTypedRuleContexts(PasswordChangeRequiredContext);
    }
    passwordChangeRequired(i) {
        return this.getTypedRuleContext(PasswordChangeRequiredContext, i);
    }
    userStatus_list() {
        return this.getTypedRuleContexts(UserStatusContext);
    }
    userStatus(i) {
        return this.getTypedRuleContext(UserStatusContext, i);
    }
    homeDatabase_list() {
        return this.getTypedRuleContexts(HomeDatabaseContext);
    }
    homeDatabase(i) {
        return this.getTypedRuleContext(HomeDatabaseContext, i);
    }
    setAuthClause_list() {
        return this.getTypedRuleContexts(SetAuthClauseContext);
    }
    setAuthClause(i) {
        return this.getTypedRuleContext(SetAuthClauseContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createUser;
    }
    enterRule(listener) {
        if (listener.enterCreateUser) {
            listener.enterCreateUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateUser) {
            listener.exitCreateUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateUser) {
            return visitor.visitCreateUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    commandNameExpression() {
        return this.getTypedRuleContext(CommandNameExpressionContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropUser;
    }
    enterRule(listener) {
        if (listener.enterDropUser) {
            listener.enterDropUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropUser) {
            listener.exitDropUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropUser) {
            return visitor.visitDropUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RenameUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    commandNameExpression_list() {
        return this.getTypedRuleContexts(CommandNameExpressionContext);
    }
    commandNameExpression(i) {
        return this.getTypedRuleContext(CommandNameExpressionContext, i);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_renameUser;
    }
    enterRule(listener) {
        if (listener.enterRenameUser) {
            listener.enterRenameUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRenameUser) {
            listener.exitRenameUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRenameUser) {
            return visitor.visitRenameUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterCurrentUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CURRENT() {
        return this.getToken(CypherCmdParser.CURRENT, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    passwordExpression_list() {
        return this.getTypedRuleContexts(PasswordExpressionContext);
    }
    passwordExpression(i) {
        return this.getTypedRuleContext(PasswordExpressionContext, i);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterCurrentUser;
    }
    enterRule(listener) {
        if (listener.enterAlterCurrentUser) {
            listener.enterAlterCurrentUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterCurrentUser) {
            listener.exitAlterCurrentUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterCurrentUser) {
            return visitor.visitAlterCurrentUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    commandNameExpression() {
        return this.getTypedRuleContext(CommandNameExpressionContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    REMOVE_list() {
        return this.getTokens(CypherCmdParser.REMOVE);
    }
    REMOVE(i) {
        return this.getToken(CypherCmdParser.REMOVE, i);
    }
    SET_list() {
        return this.getTokens(CypherCmdParser.SET);
    }
    SET(i) {
        return this.getToken(CypherCmdParser.SET, i);
    }
    HOME_list() {
        return this.getTokens(CypherCmdParser.HOME);
    }
    HOME(i) {
        return this.getToken(CypherCmdParser.HOME, i);
    }
    DATABASE_list() {
        return this.getTokens(CypherCmdParser.DATABASE);
    }
    DATABASE(i) {
        return this.getToken(CypherCmdParser.DATABASE, i);
    }
    ALL_list() {
        return this.getTokens(CypherCmdParser.ALL);
    }
    ALL(i) {
        return this.getToken(CypherCmdParser.ALL, i);
    }
    AUTH_list() {
        return this.getTokens(CypherCmdParser.AUTH);
    }
    AUTH(i) {
        return this.getToken(CypherCmdParser.AUTH, i);
    }
    removeNamedProvider_list() {
        return this.getTypedRuleContexts(RemoveNamedProviderContext);
    }
    removeNamedProvider(i) {
        return this.getTypedRuleContext(RemoveNamedProviderContext, i);
    }
    password_list() {
        return this.getTypedRuleContexts(PasswordContext);
    }
    password(i) {
        return this.getTypedRuleContext(PasswordContext, i);
    }
    PASSWORD_list() {
        return this.getTokens(CypherCmdParser.PASSWORD);
    }
    PASSWORD(i) {
        return this.getToken(CypherCmdParser.PASSWORD, i);
    }
    passwordChangeRequired_list() {
        return this.getTypedRuleContexts(PasswordChangeRequiredContext);
    }
    passwordChangeRequired(i) {
        return this.getTypedRuleContext(PasswordChangeRequiredContext, i);
    }
    userStatus_list() {
        return this.getTypedRuleContexts(UserStatusContext);
    }
    userStatus(i) {
        return this.getTypedRuleContext(UserStatusContext, i);
    }
    homeDatabase_list() {
        return this.getTypedRuleContexts(HomeDatabaseContext);
    }
    homeDatabase(i) {
        return this.getTypedRuleContext(HomeDatabaseContext, i);
    }
    setAuthClause_list() {
        return this.getTypedRuleContexts(SetAuthClauseContext);
    }
    setAuthClause(i) {
        return this.getTypedRuleContext(SetAuthClauseContext, i);
    }
    PROVIDER_list() {
        return this.getTokens(CypherCmdParser.PROVIDER);
    }
    PROVIDER(i) {
        return this.getToken(CypherCmdParser.PROVIDER, i);
    }
    PROVIDERS_list() {
        return this.getTokens(CypherCmdParser.PROVIDERS);
    }
    PROVIDERS(i) {
        return this.getToken(CypherCmdParser.PROVIDERS, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterUser;
    }
    enterRule(listener) {
        if (listener.enterAlterUser) {
            listener.enterAlterUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterUser) {
            listener.exitAlterUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterUser) {
            return visitor.visitAlterUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemoveNamedProviderContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    AUTH() {
        return this.getToken(CypherCmdParser.AUTH, 0);
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    stringListLiteral() {
        return this.getTypedRuleContext(StringListLiteralContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    PROVIDER() {
        return this.getToken(CypherCmdParser.PROVIDER, 0);
    }
    PROVIDERS() {
        return this.getToken(CypherCmdParser.PROVIDERS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_removeNamedProvider;
    }
    enterRule(listener) {
        if (listener.enterRemoveNamedProvider) {
            listener.enterRemoveNamedProvider(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemoveNamedProvider) {
            listener.exitRemoveNamedProvider(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemoveNamedProvider) {
            return visitor.visitRemoveNamedProvider(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PasswordContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    passwordExpression() {
        return this.getTypedRuleContext(PasswordExpressionContext, 0);
    }
    passwordChangeRequired() {
        return this.getTypedRuleContext(PasswordChangeRequiredContext, 0);
    }
    PLAINTEXT() {
        return this.getToken(CypherCmdParser.PLAINTEXT, 0);
    }
    ENCRYPTED() {
        return this.getToken(CypherCmdParser.ENCRYPTED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_password;
    }
    enterRule(listener) {
        if (listener.enterPassword) {
            listener.enterPassword(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPassword) {
            listener.exitPassword(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPassword) {
            return visitor.visitPassword(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PasswordOnlyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    passwordExpression() {
        return this.getTypedRuleContext(PasswordExpressionContext, 0);
    }
    PLAINTEXT() {
        return this.getToken(CypherCmdParser.PLAINTEXT, 0);
    }
    ENCRYPTED() {
        return this.getToken(CypherCmdParser.ENCRYPTED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_passwordOnly;
    }
    enterRule(listener) {
        if (listener.enterPasswordOnly) {
            listener.enterPasswordOnly(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPasswordOnly) {
            listener.exitPasswordOnly(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPasswordOnly) {
            return visitor.visitPasswordOnly(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PasswordExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_passwordExpression;
    }
    enterRule(listener) {
        if (listener.enterPasswordExpression) {
            listener.enterPasswordExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPasswordExpression) {
            listener.exitPasswordExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPasswordExpression) {
            return visitor.visitPasswordExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PasswordChangeRequiredContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CHANGE() {
        return this.getToken(CypherCmdParser.CHANGE, 0);
    }
    REQUIRED() {
        return this.getToken(CypherCmdParser.REQUIRED, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_passwordChangeRequired;
    }
    enterRule(listener) {
        if (listener.enterPasswordChangeRequired) {
            listener.enterPasswordChangeRequired(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPasswordChangeRequired) {
            listener.exitPasswordChangeRequired(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPasswordChangeRequired) {
            return visitor.visitPasswordChangeRequired(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UserStatusContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STATUS() {
        return this.getToken(CypherCmdParser.STATUS, 0);
    }
    SUSPENDED() {
        return this.getToken(CypherCmdParser.SUSPENDED, 0);
    }
    ACTIVE() {
        return this.getToken(CypherCmdParser.ACTIVE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_userStatus;
    }
    enterRule(listener) {
        if (listener.enterUserStatus) {
            listener.enterUserStatus(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUserStatus) {
            listener.exitUserStatus(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUserStatus) {
            return visitor.visitUserStatus(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class HomeDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_homeDatabase;
    }
    enterRule(listener) {
        if (listener.enterHomeDatabase) {
            listener.enterHomeDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitHomeDatabase) {
            listener.exitHomeDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitHomeDatabase) {
            return visitor.visitHomeDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetAuthClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    AUTH() {
        return this.getToken(CypherCmdParser.AUTH, 0);
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    PROVIDER() {
        return this.getToken(CypherCmdParser.PROVIDER, 0);
    }
    SET_list() {
        return this.getTokens(CypherCmdParser.SET);
    }
    SET(i) {
        return this.getToken(CypherCmdParser.SET, i);
    }
    userAuthAttribute_list() {
        return this.getTypedRuleContexts(UserAuthAttributeContext);
    }
    userAuthAttribute(i) {
        return this.getTypedRuleContext(UserAuthAttributeContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_setAuthClause;
    }
    enterRule(listener) {
        if (listener.enterSetAuthClause) {
            listener.enterSetAuthClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetAuthClause) {
            listener.exitSetAuthClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetAuthClause) {
            return visitor.visitSetAuthClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UserAuthAttributeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ID() {
        return this.getToken(CypherCmdParser.ID, 0);
    }
    stringOrParameterExpression() {
        return this.getTypedRuleContext(StringOrParameterExpressionContext, 0);
    }
    passwordOnly() {
        return this.getTypedRuleContext(PasswordOnlyContext, 0);
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    passwordChangeRequired() {
        return this.getTypedRuleContext(PasswordChangeRequiredContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_userAuthAttribute;
    }
    enterRule(listener) {
        if (listener.enterUserAuthAttribute) {
            listener.enterUserAuthAttribute(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUserAuthAttribute) {
            listener.exitUserAuthAttribute(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUserAuthAttribute) {
            return visitor.visitUserAuthAttribute(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowUsersContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    USERS() {
        return this.getToken(CypherCmdParser.USERS, 0);
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    AUTH() {
        return this.getToken(CypherCmdParser.AUTH, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showUsers;
    }
    enterRule(listener) {
        if (listener.enterShowUsers) {
            listener.enterShowUsers(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowUsers) {
            listener.exitShowUsers(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowUsers) {
            return visitor.visitShowUsers(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowCurrentUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CURRENT() {
        return this.getToken(CypherCmdParser.CURRENT, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showCurrentUser;
    }
    enterRule(listener) {
        if (listener.enterShowCurrentUser) {
            listener.enterShowCurrentUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowCurrentUser) {
            listener.exitShowCurrentUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowCurrentUser) {
            return visitor.visitShowCurrentUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowSupportedPrivilegesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SUPPORTED() {
        return this.getToken(CypherCmdParser.SUPPORTED, 0);
    }
    privilegeToken() {
        return this.getTypedRuleContext(PrivilegeTokenContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showSupportedPrivileges;
    }
    enterRule(listener) {
        if (listener.enterShowSupportedPrivileges) {
            listener.enterShowSupportedPrivileges(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowSupportedPrivileges) {
            listener.exitShowSupportedPrivileges(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowSupportedPrivileges) {
            return visitor.visitShowSupportedPrivileges(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowPrivilegesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    privilegeToken() {
        return this.getTypedRuleContext(PrivilegeTokenContext, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    privilegeAsCommand() {
        return this.getTypedRuleContext(PrivilegeAsCommandContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showPrivileges;
    }
    enterRule(listener) {
        if (listener.enterShowPrivileges) {
            listener.enterShowPrivileges(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowPrivileges) {
            listener.exitShowPrivileges(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowPrivileges) {
            return visitor.visitShowPrivileges(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowRolePrivilegesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    roleNames() {
        return this.getTypedRuleContext(RoleNamesContext, 0);
    }
    privilegeToken() {
        return this.getTypedRuleContext(PrivilegeTokenContext, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    ROLES() {
        return this.getToken(CypherCmdParser.ROLES, 0);
    }
    privilegeAsCommand() {
        return this.getTypedRuleContext(PrivilegeAsCommandContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showRolePrivileges;
    }
    enterRule(listener) {
        if (listener.enterShowRolePrivileges) {
            listener.enterShowRolePrivileges(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowRolePrivileges) {
            listener.exitShowRolePrivileges(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowRolePrivileges) {
            return visitor.visitShowRolePrivileges(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowUserPrivilegesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    privilegeToken() {
        return this.getTypedRuleContext(PrivilegeTokenContext, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    USERS() {
        return this.getToken(CypherCmdParser.USERS, 0);
    }
    userNames() {
        return this.getTypedRuleContext(UserNamesContext, 0);
    }
    privilegeAsCommand() {
        return this.getTypedRuleContext(PrivilegeAsCommandContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showUserPrivileges;
    }
    enterRule(listener) {
        if (listener.enterShowUserPrivileges) {
            listener.enterShowUserPrivileges(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowUserPrivileges) {
            listener.exitShowUserPrivileges(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowUserPrivileges) {
            return visitor.visitShowUserPrivileges(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PrivilegeAsCommandContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    COMMAND() {
        return this.getToken(CypherCmdParser.COMMAND, 0);
    }
    COMMANDS() {
        return this.getToken(CypherCmdParser.COMMANDS, 0);
    }
    REVOKE() {
        return this.getToken(CypherCmdParser.REVOKE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_privilegeAsCommand;
    }
    enterRule(listener) {
        if (listener.enterPrivilegeAsCommand) {
            listener.enterPrivilegeAsCommand(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPrivilegeAsCommand) {
            listener.exitPrivilegeAsCommand(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPrivilegeAsCommand) {
            return visitor.visitPrivilegeAsCommand(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PrivilegeTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PRIVILEGE() {
        return this.getToken(CypherCmdParser.PRIVILEGE, 0);
    }
    PRIVILEGES() {
        return this.getToken(CypherCmdParser.PRIVILEGES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_privilegeToken;
    }
    enterRule(listener) {
        if (listener.enterPrivilegeToken) {
            listener.enterPrivilegeToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPrivilegeToken) {
            listener.exitPrivilegeToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPrivilegeToken) {
            return visitor.visitPrivilegeToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    allPrivilege() {
        return this.getTypedRuleContext(AllPrivilegeContext, 0);
    }
    createPrivilege() {
        return this.getTypedRuleContext(CreatePrivilegeContext, 0);
    }
    databasePrivilege() {
        return this.getTypedRuleContext(DatabasePrivilegeContext, 0);
    }
    dbmsPrivilege() {
        return this.getTypedRuleContext(DbmsPrivilegeContext, 0);
    }
    dropPrivilege() {
        return this.getTypedRuleContext(DropPrivilegeContext, 0);
    }
    loadPrivilege() {
        return this.getTypedRuleContext(LoadPrivilegeContext, 0);
    }
    qualifiedGraphPrivileges() {
        return this.getTypedRuleContext(QualifiedGraphPrivilegesContext, 0);
    }
    removePrivilege() {
        return this.getTypedRuleContext(RemovePrivilegeContext, 0);
    }
    setPrivilege() {
        return this.getTypedRuleContext(SetPrivilegeContext, 0);
    }
    showPrivilege() {
        return this.getTypedRuleContext(ShowPrivilegeContext, 0);
    }
    writePrivilege() {
        return this.getTypedRuleContext(WritePrivilegeContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_privilege;
    }
    enterRule(listener) {
        if (listener.enterPrivilege) {
            listener.enterPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPrivilege) {
            listener.exitPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPrivilege) {
            return visitor.visitPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AllPrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    allPrivilegeTarget() {
        return this.getTypedRuleContext(AllPrivilegeTargetContext, 0);
    }
    allPrivilegeType() {
        return this.getTypedRuleContext(AllPrivilegeTypeContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_allPrivilege;
    }
    enterRule(listener) {
        if (listener.enterAllPrivilege) {
            listener.enterAllPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAllPrivilege) {
            listener.exitAllPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAllPrivilege) {
            return visitor.visitAllPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AllPrivilegeTypeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PRIVILEGES() {
        return this.getToken(CypherCmdParser.PRIVILEGES, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_allPrivilegeType;
    }
    enterRule(listener) {
        if (listener.enterAllPrivilegeType) {
            listener.enterAllPrivilegeType(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAllPrivilegeType) {
            listener.exitAllPrivilegeType(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAllPrivilegeType) {
            return visitor.visitAllPrivilegeType(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AllPrivilegeTargetContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_allPrivilegeTarget;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class DefaultTargetContext extends AllPrivilegeTargetContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    enterRule(listener) {
        if (listener.enterDefaultTarget) {
            listener.enterDefaultTarget(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDefaultTarget) {
            listener.exitDefaultTarget(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDefaultTarget) {
            return visitor.visitDefaultTarget(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DatabaseVariableTargetContext extends AllPrivilegeTargetContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    symbolicAliasNameList() {
        return this.getTypedRuleContext(SymbolicAliasNameListContext, 0);
    }
    enterRule(listener) {
        if (listener.enterDatabaseVariableTarget) {
            listener.enterDatabaseVariableTarget(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDatabaseVariableTarget) {
            listener.exitDatabaseVariableTarget(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDatabaseVariableTarget) {
            return visitor.visitDatabaseVariableTarget(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphVariableTargetContext extends AllPrivilegeTargetContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    GRAPHS() {
        return this.getToken(CypherCmdParser.GRAPHS, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    symbolicAliasNameList() {
        return this.getTypedRuleContext(SymbolicAliasNameListContext, 0);
    }
    enterRule(listener) {
        if (listener.enterGraphVariableTarget) {
            listener.enterGraphVariableTarget(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphVariableTarget) {
            listener.exitGraphVariableTarget(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphVariableTarget) {
            return visitor.visitGraphVariableTarget(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DBMSTargetContext extends AllPrivilegeTargetContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    enterRule(listener) {
        if (listener.enterDBMSTarget) {
            listener.enterDBMSTarget(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDBMSTarget) {
            listener.exitDBMSTarget(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDBMSTarget) {
            return visitor.visitDBMSTarget(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreatePrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CREATE() {
        return this.getToken(CypherCmdParser.CREATE, 0);
    }
    createPrivilegeForDatabase() {
        return this.getTypedRuleContext(CreatePrivilegeForDatabaseContext, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    databaseScope() {
        return this.getTypedRuleContext(DatabaseScopeContext, 0);
    }
    actionForDBMS() {
        return this.getTypedRuleContext(ActionForDBMSContext, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    graphScope() {
        return this.getTypedRuleContext(GraphScopeContext, 0);
    }
    graphQualifier() {
        return this.getTypedRuleContext(GraphQualifierContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createPrivilege;
    }
    enterRule(listener) {
        if (listener.enterCreatePrivilege) {
            listener.enterCreatePrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreatePrivilege) {
            listener.exitCreatePrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreatePrivilege) {
            return visitor.visitCreatePrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreatePrivilegeForDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    indexToken() {
        return this.getTypedRuleContext(IndexTokenContext, 0);
    }
    constraintToken() {
        return this.getTypedRuleContext(ConstraintTokenContext, 0);
    }
    createNodePrivilegeToken() {
        return this.getTypedRuleContext(CreateNodePrivilegeTokenContext, 0);
    }
    createRelPrivilegeToken() {
        return this.getTypedRuleContext(CreateRelPrivilegeTokenContext, 0);
    }
    createPropertyPrivilegeToken() {
        return this.getTypedRuleContext(CreatePropertyPrivilegeTokenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createPrivilegeForDatabase;
    }
    enterRule(listener) {
        if (listener.enterCreatePrivilegeForDatabase) {
            listener.enterCreatePrivilegeForDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreatePrivilegeForDatabase) {
            listener.exitCreatePrivilegeForDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreatePrivilegeForDatabase) {
            return visitor.visitCreatePrivilegeForDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateNodePrivilegeTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NEW() {
        return this.getToken(CypherCmdParser.NEW, 0);
    }
    LABEL() {
        return this.getToken(CypherCmdParser.LABEL, 0);
    }
    LABELS() {
        return this.getToken(CypherCmdParser.LABELS, 0);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createNodePrivilegeToken;
    }
    enterRule(listener) {
        if (listener.enterCreateNodePrivilegeToken) {
            listener.enterCreateNodePrivilegeToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateNodePrivilegeToken) {
            listener.exitCreateNodePrivilegeToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateNodePrivilegeToken) {
            return visitor.visitCreateNodePrivilegeToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateRelPrivilegeTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NEW() {
        return this.getToken(CypherCmdParser.NEW, 0);
    }
    TYPE() {
        return this.getToken(CypherCmdParser.TYPE, 0);
    }
    TYPES() {
        return this.getToken(CypherCmdParser.TYPES, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createRelPrivilegeToken;
    }
    enterRule(listener) {
        if (listener.enterCreateRelPrivilegeToken) {
            listener.enterCreateRelPrivilegeToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateRelPrivilegeToken) {
            listener.exitCreateRelPrivilegeToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateRelPrivilegeToken) {
            return visitor.visitCreateRelPrivilegeToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreatePropertyPrivilegeTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NEW() {
        return this.getToken(CypherCmdParser.NEW, 0);
    }
    NAME() {
        return this.getToken(CypherCmdParser.NAME, 0);
    }
    NAMES() {
        return this.getToken(CypherCmdParser.NAMES, 0);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createPropertyPrivilegeToken;
    }
    enterRule(listener) {
        if (listener.enterCreatePropertyPrivilegeToken) {
            listener.enterCreatePropertyPrivilegeToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreatePropertyPrivilegeToken) {
            listener.exitCreatePropertyPrivilegeToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreatePropertyPrivilegeToken) {
            return visitor.visitCreatePropertyPrivilegeToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ActionForDBMSContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    COMPOSITE() {
        return this.getToken(CypherCmdParser.COMPOSITE, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_actionForDBMS;
    }
    enterRule(listener) {
        if (listener.enterActionForDBMS) {
            listener.enterActionForDBMS(this);
        }
    }
    exitRule(listener) {
        if (listener.exitActionForDBMS) {
            listener.exitActionForDBMS(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitActionForDBMS) {
            return visitor.visitActionForDBMS(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropPrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DROP() {
        return this.getToken(CypherCmdParser.DROP, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    databaseScope() {
        return this.getTypedRuleContext(DatabaseScopeContext, 0);
    }
    actionForDBMS() {
        return this.getTypedRuleContext(ActionForDBMSContext, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    indexToken() {
        return this.getTypedRuleContext(IndexTokenContext, 0);
    }
    constraintToken() {
        return this.getTypedRuleContext(ConstraintTokenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropPrivilege;
    }
    enterRule(listener) {
        if (listener.enterDropPrivilege) {
            listener.enterDropPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropPrivilege) {
            listener.exitDropPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropPrivilege) {
            return visitor.visitDropPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LoadPrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LOAD() {
        return this.getToken(CypherCmdParser.LOAD, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    stringOrParameter() {
        return this.getTypedRuleContext(StringOrParameterContext, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    DATA() {
        return this.getToken(CypherCmdParser.DATA, 0);
    }
    URL() {
        return this.getToken(CypherCmdParser.URL, 0);
    }
    CIDR() {
        return this.getToken(CypherCmdParser.CIDR, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_loadPrivilege;
    }
    enterRule(listener) {
        if (listener.enterLoadPrivilege) {
            listener.enterLoadPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLoadPrivilege) {
            listener.exitLoadPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLoadPrivilege) {
            return visitor.visitLoadPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowPrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SHOW() {
        return this.getToken(CypherCmdParser.SHOW, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    databaseScope() {
        return this.getTypedRuleContext(DatabaseScopeContext, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    indexToken() {
        return this.getTypedRuleContext(IndexTokenContext, 0);
    }
    constraintToken() {
        return this.getTypedRuleContext(ConstraintTokenContext, 0);
    }
    transactionToken() {
        return this.getTypedRuleContext(TransactionTokenContext, 0);
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    PRIVILEGE() {
        return this.getToken(CypherCmdParser.PRIVILEGE, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    SERVERS() {
        return this.getToken(CypherCmdParser.SERVERS, 0);
    }
    settingToken() {
        return this.getTypedRuleContext(SettingTokenContext, 0);
    }
    settingQualifier() {
        return this.getTypedRuleContext(SettingQualifierContext, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    userQualifier() {
        return this.getTypedRuleContext(UserQualifierContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showPrivilege;
    }
    enterRule(listener) {
        if (listener.enterShowPrivilege) {
            listener.enterShowPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowPrivilege) {
            listener.exitShowPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowPrivilege) {
            return visitor.visitShowPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SetPrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    LABEL() {
        return this.getToken(CypherCmdParser.LABEL, 0);
    }
    labelsResource() {
        return this.getTypedRuleContext(LabelsResourceContext, 0);
    }
    graphScope() {
        return this.getTypedRuleContext(GraphScopeContext, 0);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    propertiesResource() {
        return this.getTypedRuleContext(PropertiesResourceContext, 0);
    }
    graphQualifier() {
        return this.getTypedRuleContext(GraphQualifierContext, 0);
    }
    passwordToken() {
        return this.getTypedRuleContext(PasswordTokenContext, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    AUTH() {
        return this.getToken(CypherCmdParser.AUTH, 0);
    }
    STATUS() {
        return this.getToken(CypherCmdParser.STATUS, 0);
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    ACCESS() {
        return this.getToken(CypherCmdParser.ACCESS, 0);
    }
    DEFAULT() {
        return this.getToken(CypherCmdParser.DEFAULT, 0);
    }
    LANGUAGE() {
        return this.getToken(CypherCmdParser.LANGUAGE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_setPrivilege;
    }
    enterRule(listener) {
        if (listener.enterSetPrivilege) {
            listener.enterSetPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSetPrivilege) {
            listener.exitSetPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSetPrivilege) {
            return visitor.visitSetPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PasswordTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    PASSWORDS() {
        return this.getToken(CypherCmdParser.PASSWORDS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_passwordToken;
    }
    enterRule(listener) {
        if (listener.enterPasswordToken) {
            listener.enterPasswordToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPasswordToken) {
            listener.exitPasswordToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPasswordToken) {
            return visitor.visitPasswordToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RemovePrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    REMOVE() {
        return this.getToken(CypherCmdParser.REMOVE, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    LABEL() {
        return this.getToken(CypherCmdParser.LABEL, 0);
    }
    labelsResource() {
        return this.getTypedRuleContext(LabelsResourceContext, 0);
    }
    graphScope() {
        return this.getTypedRuleContext(GraphScopeContext, 0);
    }
    PRIVILEGE() {
        return this.getToken(CypherCmdParser.PRIVILEGE, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_removePrivilege;
    }
    enterRule(listener) {
        if (listener.enterRemovePrivilege) {
            listener.enterRemovePrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRemovePrivilege) {
            listener.exitRemovePrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRemovePrivilege) {
            return visitor.visitRemovePrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WritePrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WRITE() {
        return this.getToken(CypherCmdParser.WRITE, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    graphScope() {
        return this.getTypedRuleContext(GraphScopeContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_writePrivilege;
    }
    enterRule(listener) {
        if (listener.enterWritePrivilege) {
            listener.enterWritePrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWritePrivilege) {
            listener.exitWritePrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWritePrivilege) {
            return visitor.visitWritePrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DatabasePrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    databaseScope() {
        return this.getTypedRuleContext(DatabaseScopeContext, 0);
    }
    ACCESS() {
        return this.getToken(CypherCmdParser.ACCESS, 0);
    }
    START() {
        return this.getToken(CypherCmdParser.START, 0);
    }
    STOP() {
        return this.getToken(CypherCmdParser.STOP, 0);
    }
    indexToken() {
        return this.getTypedRuleContext(IndexTokenContext, 0);
    }
    constraintToken() {
        return this.getTypedRuleContext(ConstraintTokenContext, 0);
    }
    NAME() {
        return this.getToken(CypherCmdParser.NAME, 0);
    }
    TRANSACTION() {
        return this.getToken(CypherCmdParser.TRANSACTION, 0);
    }
    TERMINATE() {
        return this.getToken(CypherCmdParser.TERMINATE, 0);
    }
    transactionToken() {
        return this.getTypedRuleContext(TransactionTokenContext, 0);
    }
    MANAGEMENT() {
        return this.getToken(CypherCmdParser.MANAGEMENT, 0);
    }
    userQualifier() {
        return this.getTypedRuleContext(UserQualifierContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_databasePrivilege;
    }
    enterRule(listener) {
        if (listener.enterDatabasePrivilege) {
            listener.enterDatabasePrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDatabasePrivilege) {
            listener.exitDatabasePrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDatabasePrivilege) {
            return visitor.visitDatabasePrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DbmsPrivilegeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    ALTER() {
        return this.getToken(CypherCmdParser.ALTER, 0);
    }
    ASSIGN() {
        return this.getToken(CypherCmdParser.ASSIGN, 0);
    }
    MANAGEMENT() {
        return this.getToken(CypherCmdParser.MANAGEMENT, 0);
    }
    dbmsPrivilegeExecute() {
        return this.getTypedRuleContext(DbmsPrivilegeExecuteContext, 0);
    }
    RENAME() {
        return this.getToken(CypherCmdParser.RENAME, 0);
    }
    IMPERSONATE() {
        return this.getToken(CypherCmdParser.IMPERSONATE, 0);
    }
    PRIVILEGE() {
        return this.getToken(CypherCmdParser.PRIVILEGE, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    userQualifier() {
        return this.getTypedRuleContext(UserQualifierContext, 0);
    }
    COMPOSITE() {
        return this.getToken(CypherCmdParser.COMPOSITE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dbmsPrivilege;
    }
    enterRule(listener) {
        if (listener.enterDbmsPrivilege) {
            listener.enterDbmsPrivilege(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDbmsPrivilege) {
            listener.exitDbmsPrivilege(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDbmsPrivilege) {
            return visitor.visitDbmsPrivilege(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DbmsPrivilegeExecuteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EXECUTE() {
        return this.getToken(CypherCmdParser.EXECUTE, 0);
    }
    adminToken() {
        return this.getTypedRuleContext(AdminTokenContext, 0);
    }
    PROCEDURES() {
        return this.getToken(CypherCmdParser.PROCEDURES, 0);
    }
    procedureToken() {
        return this.getTypedRuleContext(ProcedureTokenContext, 0);
    }
    executeProcedureQualifier() {
        return this.getTypedRuleContext(ExecuteProcedureQualifierContext, 0);
    }
    functionToken() {
        return this.getTypedRuleContext(FunctionTokenContext, 0);
    }
    executeFunctionQualifier() {
        return this.getTypedRuleContext(ExecuteFunctionQualifierContext, 0);
    }
    BOOSTED() {
        return this.getToken(CypherCmdParser.BOOSTED, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    DEFINED() {
        return this.getToken(CypherCmdParser.DEFINED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dbmsPrivilegeExecute;
    }
    enterRule(listener) {
        if (listener.enterDbmsPrivilegeExecute) {
            listener.enterDbmsPrivilegeExecute(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDbmsPrivilegeExecute) {
            listener.exitDbmsPrivilegeExecute(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDbmsPrivilegeExecute) {
            return visitor.visitDbmsPrivilegeExecute(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AdminTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ADMIN() {
        return this.getToken(CypherCmdParser.ADMIN, 0);
    }
    ADMINISTRATOR() {
        return this.getToken(CypherCmdParser.ADMINISTRATOR, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_adminToken;
    }
    enterRule(listener) {
        if (listener.enterAdminToken) {
            listener.enterAdminToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAdminToken) {
            listener.exitAdminToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAdminToken) {
            return visitor.visitAdminToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ProcedureTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PROCEDURE() {
        return this.getToken(CypherCmdParser.PROCEDURE, 0);
    }
    PROCEDURES() {
        return this.getToken(CypherCmdParser.PROCEDURES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_procedureToken;
    }
    enterRule(listener) {
        if (listener.enterProcedureToken) {
            listener.enterProcedureToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitProcedureToken) {
            listener.exitProcedureToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProcedureToken) {
            return visitor.visitProcedureToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class IndexTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    INDEX() {
        return this.getToken(CypherCmdParser.INDEX, 0);
    }
    INDEXES() {
        return this.getToken(CypherCmdParser.INDEXES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_indexToken;
    }
    enterRule(listener) {
        if (listener.enterIndexToken) {
            listener.enterIndexToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIndexToken) {
            listener.exitIndexToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitIndexToken) {
            return visitor.visitIndexToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ConstraintTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CONSTRAINT() {
        return this.getToken(CypherCmdParser.CONSTRAINT, 0);
    }
    CONSTRAINTS() {
        return this.getToken(CypherCmdParser.CONSTRAINTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_constraintToken;
    }
    enterRule(listener) {
        if (listener.enterConstraintToken) {
            listener.enterConstraintToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitConstraintToken) {
            listener.exitConstraintToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitConstraintToken) {
            return visitor.visitConstraintToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TransactionTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TRANSACTION() {
        return this.getToken(CypherCmdParser.TRANSACTION, 0);
    }
    TRANSACTIONS() {
        return this.getToken(CypherCmdParser.TRANSACTIONS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_transactionToken;
    }
    enterRule(listener) {
        if (listener.enterTransactionToken) {
            listener.enterTransactionToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTransactionToken) {
            listener.exitTransactionToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTransactionToken) {
            return visitor.visitTransactionToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UserQualifierContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(CypherCmdParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(CypherCmdParser.RPAREN, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    userNames() {
        return this.getTypedRuleContext(UserNamesContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_userQualifier;
    }
    enterRule(listener) {
        if (listener.enterUserQualifier) {
            listener.enterUserQualifier(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUserQualifier) {
            listener.exitUserQualifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUserQualifier) {
            return visitor.visitUserQualifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExecuteFunctionQualifierContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    globs() {
        return this.getTypedRuleContext(GlobsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_executeFunctionQualifier;
    }
    enterRule(listener) {
        if (listener.enterExecuteFunctionQualifier) {
            listener.enterExecuteFunctionQualifier(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExecuteFunctionQualifier) {
            listener.exitExecuteFunctionQualifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExecuteFunctionQualifier) {
            return visitor.visitExecuteFunctionQualifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExecuteProcedureQualifierContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    globs() {
        return this.getTypedRuleContext(GlobsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_executeProcedureQualifier;
    }
    enterRule(listener) {
        if (listener.enterExecuteProcedureQualifier) {
            listener.enterExecuteProcedureQualifier(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExecuteProcedureQualifier) {
            listener.exitExecuteProcedureQualifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExecuteProcedureQualifier) {
            return visitor.visitExecuteProcedureQualifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SettingQualifierContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    globs() {
        return this.getTypedRuleContext(GlobsContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_settingQualifier;
    }
    enterRule(listener) {
        if (listener.enterSettingQualifier) {
            listener.enterSettingQualifier(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSettingQualifier) {
            listener.exitSettingQualifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSettingQualifier) {
            return visitor.visitSettingQualifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GlobsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    glob_list() {
        return this.getTypedRuleContexts(GlobContext);
    }
    glob(i) {
        return this.getTypedRuleContext(GlobContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_globs;
    }
    enterRule(listener) {
        if (listener.enterGlobs) {
            listener.enterGlobs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGlobs) {
            listener.exitGlobs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGlobs) {
            return visitor.visitGlobs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GlobContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    escapedSymbolicNameString() {
        return this.getTypedRuleContext(EscapedSymbolicNameStringContext, 0);
    }
    globRecursive() {
        return this.getTypedRuleContext(GlobRecursiveContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_glob;
    }
    enterRule(listener) {
        if (listener.enterGlob) {
            listener.enterGlob(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGlob) {
            listener.exitGlob(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGlob) {
            return visitor.visitGlob(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GlobRecursiveContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    globPart() {
        return this.getTypedRuleContext(GlobPartContext, 0);
    }
    globRecursive() {
        return this.getTypedRuleContext(GlobRecursiveContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_globRecursive;
    }
    enterRule(listener) {
        if (listener.enterGlobRecursive) {
            listener.enterGlobRecursive(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGlobRecursive) {
            listener.exitGlobRecursive(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGlobRecursive) {
            return visitor.visitGlobRecursive(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GlobPartContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DOT() {
        return this.getToken(CypherCmdParser.DOT, 0);
    }
    escapedSymbolicNameString() {
        return this.getTypedRuleContext(EscapedSymbolicNameStringContext, 0);
    }
    QUESTION() {
        return this.getToken(CypherCmdParser.QUESTION, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    unescapedSymbolicNameString() {
        return this.getTypedRuleContext(UnescapedSymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_globPart;
    }
    enterRule(listener) {
        if (listener.enterGlobPart) {
            listener.enterGlobPart(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGlobPart) {
            listener.exitGlobPart(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGlobPart) {
            return visitor.visitGlobPart(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class QualifiedGraphPrivilegesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    graphScope() {
        return this.getTypedRuleContext(GraphScopeContext, 0);
    }
    graphQualifier() {
        return this.getTypedRuleContext(GraphQualifierContext, 0);
    }
    TRAVERSE() {
        return this.getToken(CypherCmdParser.TRAVERSE, 0);
    }
    DELETE() {
        return this.getToken(CypherCmdParser.DELETE, 0);
    }
    propertiesResource() {
        return this.getTypedRuleContext(PropertiesResourceContext, 0);
    }
    READ() {
        return this.getToken(CypherCmdParser.READ, 0);
    }
    MATCH() {
        return this.getToken(CypherCmdParser.MATCH, 0);
    }
    MERGE() {
        return this.getToken(CypherCmdParser.MERGE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_qualifiedGraphPrivileges;
    }
    enterRule(listener) {
        if (listener.enterQualifiedGraphPrivileges) {
            listener.enterQualifiedGraphPrivileges(this);
        }
    }
    exitRule(listener) {
        if (listener.exitQualifiedGraphPrivileges) {
            listener.exitQualifiedGraphPrivileges(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitQualifiedGraphPrivileges) {
            return visitor.visitQualifiedGraphPrivileges(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LabelsResourceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    nonEmptyStringList() {
        return this.getTypedRuleContext(NonEmptyStringListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_labelsResource;
    }
    enterRule(listener) {
        if (listener.enterLabelsResource) {
            listener.enterLabelsResource(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLabelsResource) {
            listener.exitLabelsResource(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLabelsResource) {
            return visitor.visitLabelsResource(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertiesResourceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    nonEmptyStringList() {
        return this.getTypedRuleContext(NonEmptyStringListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertiesResource;
    }
    enterRule(listener) {
        if (listener.enterPropertiesResource) {
            listener.enterPropertiesResource(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertiesResource) {
            listener.exitPropertiesResource(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertiesResource) {
            return visitor.visitPropertiesResource(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NonEmptyStringListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nonEmptyStringList;
    }
    enterRule(listener) {
        if (listener.enterNonEmptyStringList) {
            listener.enterNonEmptyStringList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNonEmptyStringList) {
            listener.exitNonEmptyStringList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNonEmptyStringList) {
            return visitor.visitNonEmptyStringList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphQualifierContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    graphQualifierToken() {
        return this.getTypedRuleContext(GraphQualifierTokenContext, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    nonEmptyStringList() {
        return this.getTypedRuleContext(NonEmptyStringListContext, 0);
    }
    LPAREN_list() {
        return this.getTokens(CypherCmdParser.LPAREN);
    }
    LPAREN(i) {
        return this.getToken(CypherCmdParser.LPAREN, i);
    }
    RPAREN_list() {
        return this.getTokens(CypherCmdParser.RPAREN);
    }
    RPAREN(i) {
        return this.getToken(CypherCmdParser.RPAREN, i);
    }
    arrowLine_list() {
        return this.getTypedRuleContexts(ArrowLineContext);
    }
    arrowLine(i) {
        return this.getTypedRuleContext(ArrowLineContext, i);
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    variable() {
        return this.getTypedRuleContext(VariableContext, 0);
    }
    COLON() {
        return this.getToken(CypherCmdParser.COLON, 0);
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    leftArrow() {
        return this.getTypedRuleContext(LeftArrowContext, 0);
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    rightArrow() {
        return this.getTypedRuleContext(RightArrowContext, 0);
    }
    BAR_list() {
        return this.getTokens(CypherCmdParser.BAR);
    }
    BAR(i) {
        return this.getToken(CypherCmdParser.BAR, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphQualifier;
    }
    enterRule(listener) {
        if (listener.enterGraphQualifier) {
            listener.enterGraphQualifier(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphQualifier) {
            listener.exitGraphQualifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphQualifier) {
            return visitor.visitGraphQualifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphQualifierTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    relToken() {
        return this.getTypedRuleContext(RelTokenContext, 0);
    }
    nodeToken() {
        return this.getTypedRuleContext(NodeTokenContext, 0);
    }
    elementToken() {
        return this.getTypedRuleContext(ElementTokenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphQualifierToken;
    }
    enterRule(listener) {
        if (listener.enterGraphQualifierToken) {
            listener.enterGraphQualifierToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphQualifierToken) {
            listener.exitGraphQualifierToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphQualifierToken) {
            return visitor.visitGraphQualifierToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RelTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    RELATIONSHIPS() {
        return this.getToken(CypherCmdParser.RELATIONSHIPS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_relToken;
    }
    enterRule(listener) {
        if (listener.enterRelToken) {
            listener.enterRelToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitRelToken) {
            listener.exitRelToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRelToken) {
            return visitor.visitRelToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ElementTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ELEMENT() {
        return this.getToken(CypherCmdParser.ELEMENT, 0);
    }
    ELEMENTS() {
        return this.getToken(CypherCmdParser.ELEMENTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_elementToken;
    }
    enterRule(listener) {
        if (listener.enterElementToken) {
            listener.enterElementToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitElementToken) {
            listener.exitElementToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitElementToken) {
            return visitor.visitElementToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NodeTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    NODES() {
        return this.getToken(CypherCmdParser.NODES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_nodeToken;
    }
    enterRule(listener) {
        if (listener.enterNodeToken) {
            listener.enterNodeToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNodeToken) {
            listener.exitNodeToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNodeToken) {
            return visitor.visitNodeToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DatabaseScopeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    symbolicAliasNameList() {
        return this.getTypedRuleContext(SymbolicAliasNameListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_databaseScope;
    }
    enterRule(listener) {
        if (listener.enterDatabaseScope) {
            listener.enterDatabaseScope(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDatabaseScope) {
            listener.exitDatabaseScope(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDatabaseScope) {
            return visitor.visitDatabaseScope(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphScopeContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    GRAPHS() {
        return this.getToken(CypherCmdParser.GRAPHS, 0);
    }
    TIMES() {
        return this.getToken(CypherCmdParser.TIMES, 0);
    }
    symbolicAliasNameList() {
        return this.getTypedRuleContext(SymbolicAliasNameListContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphScope;
    }
    enterRule(listener) {
        if (listener.enterGraphScope) {
            listener.enterGraphScope(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphScope) {
            listener.exitGraphScope(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphScope) {
            return visitor.visitGraphScope(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateCompositeDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COMPOSITE() {
        return this.getToken(CypherCmdParser.COMPOSITE, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    databaseName() {
        return this.getTypedRuleContext(DatabaseNameContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    defaultLanguageSpecification() {
        return this.getTypedRuleContext(DefaultLanguageSpecificationContext, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    waitClause() {
        return this.getTypedRuleContext(WaitClauseContext, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createCompositeDatabase;
    }
    enterRule(listener) {
        if (listener.enterCreateCompositeDatabase) {
            listener.enterCreateCompositeDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateCompositeDatabase) {
            listener.exitCreateCompositeDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateCompositeDatabase) {
            return visitor.visitCreateCompositeDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    databaseName() {
        return this.getTypedRuleContext(DatabaseNameContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    defaultLanguageSpecification() {
        return this.getTypedRuleContext(DefaultLanguageSpecificationContext, 0);
    }
    topology() {
        return this.getTypedRuleContext(TopologyContext, 0);
    }
    shards() {
        return this.getTypedRuleContext(ShardsContext, 0);
    }
    commandOptions() {
        return this.getTypedRuleContext(CommandOptionsContext, 0);
    }
    waitClause() {
        return this.getTypedRuleContext(WaitClauseContext, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createDatabase;
    }
    enterRule(listener) {
        if (listener.enterCreateDatabase) {
            listener.enterCreateDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateDatabase) {
            listener.exitCreateDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateDatabase) {
            return visitor.visitCreateDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShardsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    propertyShard() {
        return this.getTypedRuleContext(PropertyShardContext, 0);
    }
    graphShard() {
        return this.getTypedRuleContext(GraphShardContext, 0);
    }
    SET_list() {
        return this.getTokens(CypherCmdParser.SET);
    }
    SET(i) {
        return this.getToken(CypherCmdParser.SET, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_shards;
    }
    enterRule(listener) {
        if (listener.enterShards) {
            listener.enterShards(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShards) {
            listener.exitShards(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShards) {
            return visitor.visitShards(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class GraphShardContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    SHARD() {
        return this.getToken(CypherCmdParser.SHARD, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    topology() {
        return this.getTypedRuleContext(TopologyContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_graphShard;
    }
    enterRule(listener) {
        if (listener.enterGraphShard) {
            listener.enterGraphShard(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGraphShard) {
            listener.exitGraphShard(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitGraphShard) {
            return visitor.visitGraphShard(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PropertyShardContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    COUNT() {
        return this.getToken(CypherCmdParser.COUNT, 0);
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    SHARD() {
        return this.getToken(CypherCmdParser.SHARD, 0);
    }
    SHARDS() {
        return this.getToken(CypherCmdParser.SHARDS, 0);
    }
    TOPOLOGY() {
        return this.getToken(CypherCmdParser.TOPOLOGY, 0);
    }
    uIntOrIntParameter() {
        return this.getTypedRuleContext(UIntOrIntParameterContext, 0);
    }
    REPLICA() {
        return this.getToken(CypherCmdParser.REPLICA, 0);
    }
    REPLICAS() {
        return this.getToken(CypherCmdParser.REPLICAS, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_propertyShard;
    }
    enterRule(listener) {
        if (listener.enterPropertyShard) {
            listener.enterPropertyShard(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPropertyShard) {
            listener.exitPropertyShard(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPropertyShard) {
            return visitor.visitPropertyShard(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TopologyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TOPOLOGY() {
        return this.getToken(CypherCmdParser.TOPOLOGY, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    primaryTopology_list() {
        return this.getTypedRuleContexts(PrimaryTopologyContext);
    }
    primaryTopology(i) {
        return this.getTypedRuleContext(PrimaryTopologyContext, i);
    }
    secondaryTopology_list() {
        return this.getTypedRuleContexts(SecondaryTopologyContext);
    }
    secondaryTopology(i) {
        return this.getTypedRuleContext(SecondaryTopologyContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_topology;
    }
    enterRule(listener) {
        if (listener.enterTopology) {
            listener.enterTopology(this);
        }
    }
    exitRule(listener) {
        if (listener.exitTopology) {
            listener.exitTopology(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTopology) {
            return visitor.visitTopology(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PrimaryTopologyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    uIntOrIntParameter() {
        return this.getTypedRuleContext(UIntOrIntParameterContext, 0);
    }
    primaryToken() {
        return this.getTypedRuleContext(PrimaryTokenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_primaryTopology;
    }
    enterRule(listener) {
        if (listener.enterPrimaryTopology) {
            listener.enterPrimaryTopology(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPrimaryTopology) {
            listener.exitPrimaryTopology(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPrimaryTopology) {
            return visitor.visitPrimaryTopology(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PrimaryTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PRIMARY() {
        return this.getToken(CypherCmdParser.PRIMARY, 0);
    }
    PRIMARIES() {
        return this.getToken(CypherCmdParser.PRIMARIES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_primaryToken;
    }
    enterRule(listener) {
        if (listener.enterPrimaryToken) {
            listener.enterPrimaryToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPrimaryToken) {
            listener.exitPrimaryToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPrimaryToken) {
            return visitor.visitPrimaryToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SecondaryTopologyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    uIntOrIntParameter() {
        return this.getTypedRuleContext(UIntOrIntParameterContext, 0);
    }
    secondaryToken() {
        return this.getTypedRuleContext(SecondaryTokenContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_secondaryTopology;
    }
    enterRule(listener) {
        if (listener.enterSecondaryTopology) {
            listener.enterSecondaryTopology(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSecondaryTopology) {
            listener.exitSecondaryTopology(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSecondaryTopology) {
            return visitor.visitSecondaryTopology(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SecondaryTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SECONDARY() {
        return this.getToken(CypherCmdParser.SECONDARY, 0);
    }
    SECONDARIES() {
        return this.getToken(CypherCmdParser.SECONDARIES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_secondaryToken;
    }
    enterRule(listener) {
        if (listener.enterSecondaryToken) {
            listener.enterSecondaryToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSecondaryToken) {
            listener.exitSecondaryToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSecondaryToken) {
            return visitor.visitSecondaryToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DefaultLanguageSpecificationContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DEFAULT() {
        return this.getToken(CypherCmdParser.DEFAULT, 0);
    }
    LANGUAGE() {
        return this.getToken(CypherCmdParser.LANGUAGE, 0);
    }
    CYPHER() {
        return this.getToken(CypherCmdParser.CYPHER, 0);
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_defaultLanguageSpecification;
    }
    enterRule(listener) {
        if (listener.enterDefaultLanguageSpecification) {
            listener.enterDefaultLanguageSpecification(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDefaultLanguageSpecification) {
            listener.exitDefaultLanguageSpecification(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDefaultLanguageSpecification) {
            return visitor.visitDefaultLanguageSpecification(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    COMPOSITE() {
        return this.getToken(CypherCmdParser.COMPOSITE, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    aliasAction() {
        return this.getTypedRuleContext(AliasActionContext, 0);
    }
    DATA() {
        return this.getToken(CypherCmdParser.DATA, 0);
    }
    waitClause() {
        return this.getTypedRuleContext(WaitClauseContext, 0);
    }
    DUMP() {
        return this.getToken(CypherCmdParser.DUMP, 0);
    }
    DESTROY() {
        return this.getToken(CypherCmdParser.DESTROY, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropDatabase;
    }
    enterRule(listener) {
        if (listener.enterDropDatabase) {
            listener.enterDropDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropDatabase) {
            listener.exitDropDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropDatabase) {
            return visitor.visitDropDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AliasActionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    RESTRICT() {
        return this.getToken(CypherCmdParser.RESTRICT, 0);
    }
    CASCADE() {
        return this.getToken(CypherCmdParser.CASCADE, 0);
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    ALIASES() {
        return this.getToken(CypherCmdParser.ALIASES, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_aliasAction;
    }
    enterRule(listener) {
        if (listener.enterAliasAction) {
            listener.enterAliasAction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAliasAction) {
            listener.exitAliasAction(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAliasAction) {
            return visitor.visitAliasAction(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    waitClause() {
        return this.getTypedRuleContext(WaitClauseContext, 0);
    }
    SET_list() {
        return this.getTokens(CypherCmdParser.SET);
    }
    SET(i) {
        return this.getToken(CypherCmdParser.SET, i);
    }
    REMOVE_list() {
        return this.getTokens(CypherCmdParser.REMOVE);
    }
    REMOVE(i) {
        return this.getToken(CypherCmdParser.REMOVE, i);
    }
    OPTION_list() {
        return this.getTokens(CypherCmdParser.OPTION);
    }
    OPTION(i) {
        return this.getToken(CypherCmdParser.OPTION, i);
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    alterDatabaseAccess_list() {
        return this.getTypedRuleContexts(AlterDatabaseAccessContext);
    }
    alterDatabaseAccess(i) {
        return this.getTypedRuleContext(AlterDatabaseAccessContext, i);
    }
    alterDatabaseTopology_list() {
        return this.getTypedRuleContexts(AlterDatabaseTopologyContext);
    }
    alterDatabaseTopology(i) {
        return this.getTypedRuleContext(AlterDatabaseTopologyContext, i);
    }
    alterDatabaseOption_list() {
        return this.getTypedRuleContexts(AlterDatabaseOptionContext);
    }
    alterDatabaseOption(i) {
        return this.getTypedRuleContext(AlterDatabaseOptionContext, i);
    }
    defaultLanguageSpecification_list() {
        return this.getTypedRuleContexts(DefaultLanguageSpecificationContext);
    }
    defaultLanguageSpecification(i) {
        return this.getTypedRuleContext(DefaultLanguageSpecificationContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterDatabase;
    }
    enterRule(listener) {
        if (listener.enterAlterDatabase) {
            listener.enterAlterDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterDatabase) {
            listener.exitAlterDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterDatabase) {
            return visitor.visitAlterDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterDatabaseAccessContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ACCESS() {
        return this.getToken(CypherCmdParser.ACCESS, 0);
    }
    READ() {
        return this.getToken(CypherCmdParser.READ, 0);
    }
    ONLY() {
        return this.getToken(CypherCmdParser.ONLY, 0);
    }
    WRITE() {
        return this.getToken(CypherCmdParser.WRITE, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterDatabaseAccess;
    }
    enterRule(listener) {
        if (listener.enterAlterDatabaseAccess) {
            listener.enterAlterDatabaseAccess(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterDatabaseAccess) {
            listener.exitAlterDatabaseAccess(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterDatabaseAccess) {
            return visitor.visitAlterDatabaseAccess(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterDatabaseTopologyContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TOPOLOGY() {
        return this.getToken(CypherCmdParser.TOPOLOGY, 0);
    }
    primaryTopology_list() {
        return this.getTypedRuleContexts(PrimaryTopologyContext);
    }
    primaryTopology(i) {
        return this.getTypedRuleContext(PrimaryTopologyContext, i);
    }
    secondaryTopology_list() {
        return this.getTypedRuleContexts(SecondaryTopologyContext);
    }
    secondaryTopology(i) {
        return this.getTypedRuleContext(SecondaryTopologyContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterDatabaseTopology;
    }
    enterRule(listener) {
        if (listener.enterAlterDatabaseTopology) {
            listener.enterAlterDatabaseTopology(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterDatabaseTopology) {
            listener.exitAlterDatabaseTopology(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterDatabaseTopology) {
            return visitor.visitAlterDatabaseTopology(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterDatabaseOptionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    OPTION() {
        return this.getToken(CypherCmdParser.OPTION, 0);
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterDatabaseOption;
    }
    enterRule(listener) {
        if (listener.enterAlterDatabaseOption) {
            listener.enterAlterDatabaseOption(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterDatabaseOption) {
            listener.exitAlterDatabaseOption(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterDatabaseOption) {
            return visitor.visitAlterDatabaseOption(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StartDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    START() {
        return this.getToken(CypherCmdParser.START, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    waitClause() {
        return this.getTypedRuleContext(WaitClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_startDatabase;
    }
    enterRule(listener) {
        if (listener.enterStartDatabase) {
            listener.enterStartDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStartDatabase) {
            listener.exitStartDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStartDatabase) {
            return visitor.visitStartDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StopDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STOP() {
        return this.getToken(CypherCmdParser.STOP, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    waitClause() {
        return this.getTypedRuleContext(WaitClauseContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stopDatabase;
    }
    enterRule(listener) {
        if (listener.enterStopDatabase) {
            listener.enterStopDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStopDatabase) {
            listener.exitStopDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStopDatabase) {
            return visitor.visitStopDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class WaitClauseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WAIT() {
        return this.getToken(CypherCmdParser.WAIT, 0);
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    secondsToken() {
        return this.getTypedRuleContext(SecondsTokenContext, 0);
    }
    NOWAIT() {
        return this.getToken(CypherCmdParser.NOWAIT, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_waitClause;
    }
    enterRule(listener) {
        if (listener.enterWaitClause) {
            listener.enterWaitClause(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWaitClause) {
            listener.exitWaitClause(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitWaitClause) {
            return visitor.visitWaitClause(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SecondsTokenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    SEC() {
        return this.getToken(CypherCmdParser.SEC, 0);
    }
    SECOND() {
        return this.getToken(CypherCmdParser.SECOND, 0);
    }
    SECONDS() {
        return this.getToken(CypherCmdParser.SECONDS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_secondsToken;
    }
    enterRule(listener) {
        if (listener.enterSecondsToken) {
            listener.enterSecondsToken(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSecondsToken) {
            listener.exitSecondsToken(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSecondsToken) {
            return visitor.visitSecondsToken(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowDatabaseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DEFAULT() {
        return this.getToken(CypherCmdParser.DEFAULT, 0);
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showDatabase;
    }
    enterRule(listener) {
        if (listener.enterShowDatabase) {
            listener.enterShowDatabase(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowDatabase) {
            listener.exitShowDatabase(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowDatabase) {
            return visitor.visitShowDatabase(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AliasNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_aliasName;
    }
    enterRule(listener) {
        if (listener.enterAliasName) {
            listener.enterAliasName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAliasName) {
            listener.exitAliasName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAliasName) {
            return visitor.visitAliasName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AliasTargetNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicAliasNameOrParameter() {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_aliasTargetName;
    }
    enterRule(listener) {
        if (listener.enterAliasTargetName) {
            listener.enterAliasTargetName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAliasTargetName) {
            listener.exitAliasTargetName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAliasTargetName) {
            return visitor.visitAliasTargetName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DatabaseNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameOrStringParameter() {
        return this.getTypedRuleContext(SymbolicNameOrStringParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_databaseName;
    }
    enterRule(listener) {
        if (listener.enterDatabaseName) {
            listener.enterDatabaseName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDatabaseName) {
            listener.exitDatabaseName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDatabaseName) {
            return visitor.visitDatabaseName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CreateAliasContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    aliasName() {
        return this.getTypedRuleContext(AliasNameContext, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    aliasTargetName() {
        return this.getTypedRuleContext(AliasTargetNameContext, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    AT() {
        return this.getToken(CypherCmdParser.AT, 0);
    }
    stringOrParameter() {
        return this.getTypedRuleContext(StringOrParameterContext, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    commandNameExpression() {
        return this.getTypedRuleContext(CommandNameExpressionContext, 0);
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    passwordExpression() {
        return this.getTypedRuleContext(PasswordExpressionContext, 0);
    }
    PROPERTIES() {
        return this.getToken(CypherCmdParser.PROPERTIES, 0);
    }
    mapOrParameter_list() {
        return this.getTypedRuleContexts(MapOrParameterContext);
    }
    mapOrParameter(i) {
        return this.getTypedRuleContext(MapOrParameterContext, i);
    }
    DRIVER() {
        return this.getToken(CypherCmdParser.DRIVER, 0);
    }
    defaultLanguageSpecification() {
        return this.getTypedRuleContext(DefaultLanguageSpecificationContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_createAlias;
    }
    enterRule(listener) {
        if (listener.enterCreateAlias) {
            listener.enterCreateAlias(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCreateAlias) {
            listener.exitCreateAlias(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCreateAlias) {
            return visitor.visitCreateAlias(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DropAliasContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    aliasName() {
        return this.getTypedRuleContext(AliasNameContext, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_dropAlias;
    }
    enterRule(listener) {
        if (listener.enterDropAlias) {
            listener.enterDropAlias(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDropAlias) {
            listener.exitDropAlias(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDropAlias) {
            return visitor.visitDropAlias(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterAliasContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    aliasName() {
        return this.getTypedRuleContext(AliasNameContext, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    alterAliasTarget_list() {
        return this.getTypedRuleContexts(AlterAliasTargetContext);
    }
    alterAliasTarget(i) {
        return this.getTypedRuleContext(AlterAliasTargetContext, i);
    }
    alterAliasUser_list() {
        return this.getTypedRuleContexts(AlterAliasUserContext);
    }
    alterAliasUser(i) {
        return this.getTypedRuleContext(AlterAliasUserContext, i);
    }
    alterAliasPassword_list() {
        return this.getTypedRuleContexts(AlterAliasPasswordContext);
    }
    alterAliasPassword(i) {
        return this.getTypedRuleContext(AlterAliasPasswordContext, i);
    }
    alterAliasDriver_list() {
        return this.getTypedRuleContexts(AlterAliasDriverContext);
    }
    alterAliasDriver(i) {
        return this.getTypedRuleContext(AlterAliasDriverContext, i);
    }
    alterAliasProperties_list() {
        return this.getTypedRuleContexts(AlterAliasPropertiesContext);
    }
    alterAliasProperties(i) {
        return this.getTypedRuleContext(AlterAliasPropertiesContext, i);
    }
    defaultLanguageSpecification_list() {
        return this.getTypedRuleContexts(DefaultLanguageSpecificationContext);
    }
    defaultLanguageSpecification(i) {
        return this.getTypedRuleContext(DefaultLanguageSpecificationContext, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterAlias;
    }
    enterRule(listener) {
        if (listener.enterAlterAlias) {
            listener.enterAlterAlias(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterAlias) {
            listener.exitAlterAlias(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterAlias) {
            return visitor.visitAlterAlias(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterAliasTargetContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TARGET() {
        return this.getToken(CypherCmdParser.TARGET, 0);
    }
    aliasTargetName() {
        return this.getTypedRuleContext(AliasTargetNameContext, 0);
    }
    AT() {
        return this.getToken(CypherCmdParser.AT, 0);
    }
    stringOrParameter() {
        return this.getTypedRuleContext(StringOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterAliasTarget;
    }
    enterRule(listener) {
        if (listener.enterAlterAliasTarget) {
            listener.enterAlterAliasTarget(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterAliasTarget) {
            listener.exitAlterAliasTarget(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterAliasTarget) {
            return visitor.visitAlterAliasTarget(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterAliasUserContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    commandNameExpression() {
        return this.getTypedRuleContext(CommandNameExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterAliasUser;
    }
    enterRule(listener) {
        if (listener.enterAlterAliasUser) {
            listener.enterAlterAliasUser(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterAliasUser) {
            listener.exitAlterAliasUser(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterAliasUser) {
            return visitor.visitAlterAliasUser(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterAliasPasswordContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    passwordExpression() {
        return this.getTypedRuleContext(PasswordExpressionContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterAliasPassword;
    }
    enterRule(listener) {
        if (listener.enterAlterAliasPassword) {
            listener.enterAlterAliasPassword(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterAliasPassword) {
            listener.exitAlterAliasPassword(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterAliasPassword) {
            return visitor.visitAlterAliasPassword(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterAliasDriverContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DRIVER() {
        return this.getToken(CypherCmdParser.DRIVER, 0);
    }
    mapOrParameter() {
        return this.getTypedRuleContext(MapOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterAliasDriver;
    }
    enterRule(listener) {
        if (listener.enterAlterAliasDriver) {
            listener.enterAlterAliasDriver(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterAliasDriver) {
            listener.exitAlterAliasDriver(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterAliasDriver) {
            return visitor.visitAlterAliasDriver(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AlterAliasPropertiesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PROPERTIES() {
        return this.getToken(CypherCmdParser.PROPERTIES, 0);
    }
    mapOrParameter() {
        return this.getTypedRuleContext(MapOrParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_alterAliasProperties;
    }
    enterRule(listener) {
        if (listener.enterAlterAliasProperties) {
            listener.enterAlterAliasProperties(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAlterAliasProperties) {
            listener.exitAlterAliasProperties(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAlterAliasProperties) {
            return visitor.visitAlterAliasProperties(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ShowAliasesContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    ALIASES() {
        return this.getToken(CypherCmdParser.ALIASES, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    aliasName() {
        return this.getTypedRuleContext(AliasNameContext, 0);
    }
    showCommandYield() {
        return this.getTypedRuleContext(ShowCommandYieldContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_showAliases;
    }
    enterRule(listener) {
        if (listener.enterShowAliases) {
            listener.enterShowAliases(this);
        }
    }
    exitRule(listener) {
        if (listener.exitShowAliases) {
            listener.exitShowAliases(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitShowAliases) {
            return visitor.visitShowAliases(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicNameOrStringParameterContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicNameOrStringParameter;
    }
    enterRule(listener) {
        if (listener.enterSymbolicNameOrStringParameter) {
            listener.enterSymbolicNameOrStringParameter(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicNameOrStringParameter) {
            listener.exitSymbolicNameOrStringParameter(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicNameOrStringParameter) {
            return visitor.visitSymbolicNameOrStringParameter(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class CommandNameExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString() {
        return this.getTypedRuleContext(SymbolicNameStringContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_commandNameExpression;
    }
    enterRule(listener) {
        if (listener.enterCommandNameExpression) {
            listener.enterCommandNameExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCommandNameExpression) {
            listener.exitCommandNameExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitCommandNameExpression) {
            return visitor.visitCommandNameExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicNameOrStringParameterListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    commandNameExpression_list() {
        return this.getTypedRuleContexts(CommandNameExpressionContext);
    }
    commandNameExpression(i) {
        return this.getTypedRuleContext(CommandNameExpressionContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicNameOrStringParameterList;
    }
    enterRule(listener) {
        if (listener.enterSymbolicNameOrStringParameterList) {
            listener.enterSymbolicNameOrStringParameterList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicNameOrStringParameterList) {
            listener.exitSymbolicNameOrStringParameterList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicNameOrStringParameterList) {
            return visitor.visitSymbolicNameOrStringParameterList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicAliasNameListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicAliasNameOrParameter_list() {
        return this.getTypedRuleContexts(SymbolicAliasNameOrParameterContext);
    }
    symbolicAliasNameOrParameter(i) {
        return this.getTypedRuleContext(SymbolicAliasNameOrParameterContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicAliasNameList;
    }
    enterRule(listener) {
        if (listener.enterSymbolicAliasNameList) {
            listener.enterSymbolicAliasNameList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicAliasNameList) {
            listener.exitSymbolicAliasNameList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicAliasNameList) {
            return visitor.visitSymbolicAliasNameList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicAliasNameOrParameterContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicAliasName() {
        return this.getTypedRuleContext(SymbolicAliasNameContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicAliasNameOrParameter;
    }
    enterRule(listener) {
        if (listener.enterSymbolicAliasNameOrParameter) {
            listener.enterSymbolicAliasNameOrParameter(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicAliasNameOrParameter) {
            listener.exitSymbolicAliasNameOrParameter(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicAliasNameOrParameter) {
            return visitor.visitSymbolicAliasNameOrParameter(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicAliasNameContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    symbolicNameString_list() {
        return this.getTypedRuleContexts(SymbolicNameStringContext);
    }
    symbolicNameString(i) {
        return this.getTypedRuleContext(SymbolicNameStringContext, i);
    }
    DOT_list() {
        return this.getTokens(CypherCmdParser.DOT);
    }
    DOT(i) {
        return this.getToken(CypherCmdParser.DOT, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicAliasName;
    }
    enterRule(listener) {
        if (listener.enterSymbolicAliasName) {
            listener.enterSymbolicAliasName(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicAliasName) {
            listener.exitSymbolicAliasName(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicAliasName) {
            return visitor.visitSymbolicAliasName(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringListLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LBRACKET() {
        return this.getToken(CypherCmdParser.LBRACKET, 0);
    }
    RBRACKET() {
        return this.getToken(CypherCmdParser.RBRACKET, 0);
    }
    stringLiteral_list() {
        return this.getTypedRuleContexts(StringLiteralContext);
    }
    stringLiteral(i) {
        return this.getTypedRuleContext(StringLiteralContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stringListLiteral;
    }
    enterRule(listener) {
        if (listener.enterStringListLiteral) {
            listener.enterStringListLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringListLiteral) {
            listener.exitStringListLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringListLiteral) {
            return visitor.visitStringListLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringListContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    stringLiteral_list() {
        return this.getTypedRuleContexts(StringLiteralContext);
    }
    stringLiteral(i) {
        return this.getTypedRuleContext(StringLiteralContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stringList;
    }
    enterRule(listener) {
        if (listener.enterStringList) {
            listener.enterStringList(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringList) {
            listener.exitStringList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringList) {
            return visitor.visitStringList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STRING_LITERAL1() {
        return this.getToken(CypherCmdParser.STRING_LITERAL1, 0);
    }
    STRING_LITERAL2() {
        return this.getToken(CypherCmdParser.STRING_LITERAL2, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stringLiteral;
    }
    enterRule(listener) {
        if (listener.enterStringLiteral) {
            listener.enterStringLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringLiteral) {
            listener.exitStringLiteral(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringLiteral) {
            return visitor.visitStringLiteral(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringOrParameterExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stringOrParameterExpression;
    }
    enterRule(listener) {
        if (listener.enterStringOrParameterExpression) {
            listener.enterStringOrParameterExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringOrParameterExpression) {
            listener.exitStringOrParameterExpression(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringOrParameterExpression) {
            return visitor.visitStringOrParameterExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringOrParameterContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_stringOrParameter;
    }
    enterRule(listener) {
        if (listener.enterStringOrParameter) {
            listener.enterStringOrParameter(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringOrParameter) {
            listener.exitStringOrParameter(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringOrParameter) {
            return visitor.visitStringOrParameter(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UIntOrIntParameterContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    UNSIGNED_DECIMAL_INTEGER() {
        return this.getToken(CypherCmdParser.UNSIGNED_DECIMAL_INTEGER, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_uIntOrIntParameter;
    }
    enterRule(listener) {
        if (listener.enterUIntOrIntParameter) {
            listener.enterUIntOrIntParameter(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUIntOrIntParameter) {
            listener.exitUIntOrIntParameter(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUIntOrIntParameter) {
            return visitor.visitUIntOrIntParameter(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MapOrParameterContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    map() {
        return this.getTypedRuleContext(MapContext, 0);
    }
    parameter() {
        return this.getTypedRuleContext(ParameterContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_mapOrParameter;
    }
    enterRule(listener) {
        if (listener.enterMapOrParameter) {
            listener.enterMapOrParameter(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMapOrParameter) {
            listener.exitMapOrParameter(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMapOrParameter) {
            return visitor.visitMapOrParameter(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MapContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCURLY() {
        return this.getToken(CypherCmdParser.LCURLY, 0);
    }
    RCURLY() {
        return this.getToken(CypherCmdParser.RCURLY, 0);
    }
    propertyKeyName_list() {
        return this.getTypedRuleContexts(PropertyKeyNameContext);
    }
    propertyKeyName(i) {
        return this.getTypedRuleContext(PropertyKeyNameContext, i);
    }
    COLON_list() {
        return this.getTokens(CypherCmdParser.COLON);
    }
    COLON(i) {
        return this.getToken(CypherCmdParser.COLON, i);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    COMMA_list() {
        return this.getTokens(CypherCmdParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(CypherCmdParser.COMMA, i);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_map;
    }
    enterRule(listener) {
        if (listener.enterMap) {
            listener.enterMap(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMap) {
            listener.exitMap(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMap) {
            return visitor.visitMap(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicVariableNameStringContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    escapedSymbolicVariableNameString() {
        return this.getTypedRuleContext(EscapedSymbolicVariableNameStringContext, 0);
    }
    unescapedSymbolicVariableNameString() {
        return this.getTypedRuleContext(UnescapedSymbolicVariableNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicVariableNameString;
    }
    enterRule(listener) {
        if (listener.enterSymbolicVariableNameString) {
            listener.enterSymbolicVariableNameString(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicVariableNameString) {
            listener.exitSymbolicVariableNameString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicVariableNameString) {
            return visitor.visitSymbolicVariableNameString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EscapedSymbolicVariableNameStringContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    escapedSymbolicNameString() {
        return this.getTypedRuleContext(EscapedSymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_escapedSymbolicVariableNameString;
    }
    enterRule(listener) {
        if (listener.enterEscapedSymbolicVariableNameString) {
            listener.enterEscapedSymbolicVariableNameString(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEscapedSymbolicVariableNameString) {
            listener.exitEscapedSymbolicVariableNameString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEscapedSymbolicVariableNameString) {
            return visitor.visitEscapedSymbolicVariableNameString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UnescapedSymbolicVariableNameStringContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    unescapedSymbolicNameString() {
        return this.getTypedRuleContext(UnescapedSymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_unescapedSymbolicVariableNameString;
    }
    enterRule(listener) {
        if (listener.enterUnescapedSymbolicVariableNameString) {
            listener.enterUnescapedSymbolicVariableNameString(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUnescapedSymbolicVariableNameString) {
            listener.exitUnescapedSymbolicVariableNameString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnescapedSymbolicVariableNameString) {
            return visitor.visitUnescapedSymbolicVariableNameString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SymbolicNameStringContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    escapedSymbolicNameString() {
        return this.getTypedRuleContext(EscapedSymbolicNameStringContext, 0);
    }
    unescapedSymbolicNameString() {
        return this.getTypedRuleContext(UnescapedSymbolicNameStringContext, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_symbolicNameString;
    }
    enterRule(listener) {
        if (listener.enterSymbolicNameString) {
            listener.enterSymbolicNameString(this);
        }
    }
    exitRule(listener) {
        if (listener.exitSymbolicNameString) {
            listener.exitSymbolicNameString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSymbolicNameString) {
            return visitor.visitSymbolicNameString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EscapedSymbolicNameStringContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ESCAPED_SYMBOLIC_NAME() {
        return this.getToken(CypherCmdParser.ESCAPED_SYMBOLIC_NAME, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_escapedSymbolicNameString;
    }
    enterRule(listener) {
        if (listener.enterEscapedSymbolicNameString) {
            listener.enterEscapedSymbolicNameString(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEscapedSymbolicNameString) {
            listener.exitEscapedSymbolicNameString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEscapedSymbolicNameString) {
            return visitor.visitEscapedSymbolicNameString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UnescapedSymbolicNameString_Context extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IDENTIFIER() {
        return this.getToken(CypherCmdParser.IDENTIFIER, 0);
    }
    ACCESS() {
        return this.getToken(CypherCmdParser.ACCESS, 0);
    }
    ACTIVE() {
        return this.getToken(CypherCmdParser.ACTIVE, 0);
    }
    ADD() {
        return this.getToken(CypherCmdParser.ADD, 0);
    }
    ADMIN() {
        return this.getToken(CypherCmdParser.ADMIN, 0);
    }
    ADMINISTRATOR() {
        return this.getToken(CypherCmdParser.ADMINISTRATOR, 0);
    }
    ALIAS() {
        return this.getToken(CypherCmdParser.ALIAS, 0);
    }
    ALIASES() {
        return this.getToken(CypherCmdParser.ALIASES, 0);
    }
    ALL_SHORTEST_PATHS() {
        return this.getToken(CypherCmdParser.ALL_SHORTEST_PATHS, 0);
    }
    ALL() {
        return this.getToken(CypherCmdParser.ALL, 0);
    }
    ALLREDUCE() {
        return this.getToken(CypherCmdParser.ALLREDUCE, 0);
    }
    ALTER() {
        return this.getToken(CypherCmdParser.ALTER, 0);
    }
    AND() {
        return this.getToken(CypherCmdParser.AND, 0);
    }
    ANY() {
        return this.getToken(CypherCmdParser.ANY, 0);
    }
    ARRAY() {
        return this.getToken(CypherCmdParser.ARRAY, 0);
    }
    AS() {
        return this.getToken(CypherCmdParser.AS, 0);
    }
    ASC() {
        return this.getToken(CypherCmdParser.ASC, 0);
    }
    ASCENDING() {
        return this.getToken(CypherCmdParser.ASCENDING, 0);
    }
    ASSIGN() {
        return this.getToken(CypherCmdParser.ASSIGN, 0);
    }
    AT() {
        return this.getToken(CypherCmdParser.AT, 0);
    }
    AUTH() {
        return this.getToken(CypherCmdParser.AUTH, 0);
    }
    BINDINGS() {
        return this.getToken(CypherCmdParser.BINDINGS, 0);
    }
    BOOL() {
        return this.getToken(CypherCmdParser.BOOL, 0);
    }
    BOOLEAN() {
        return this.getToken(CypherCmdParser.BOOLEAN, 0);
    }
    BOOSTED() {
        return this.getToken(CypherCmdParser.BOOSTED, 0);
    }
    BOTH() {
        return this.getToken(CypherCmdParser.BOTH, 0);
    }
    BREAK() {
        return this.getToken(CypherCmdParser.BREAK, 0);
    }
    BUILT() {
        return this.getToken(CypherCmdParser.BUILT, 0);
    }
    BY() {
        return this.getToken(CypherCmdParser.BY, 0);
    }
    CALL() {
        return this.getToken(CypherCmdParser.CALL, 0);
    }
    CASCADE() {
        return this.getToken(CypherCmdParser.CASCADE, 0);
    }
    CASE() {
        return this.getToken(CypherCmdParser.CASE, 0);
    }
    CHANGE() {
        return this.getToken(CypherCmdParser.CHANGE, 0);
    }
    CIDR() {
        return this.getToken(CypherCmdParser.CIDR, 0);
    }
    COLLECT() {
        return this.getToken(CypherCmdParser.COLLECT, 0);
    }
    COMMAND() {
        return this.getToken(CypherCmdParser.COMMAND, 0);
    }
    COMMANDS() {
        return this.getToken(CypherCmdParser.COMMANDS, 0);
    }
    COMPOSITE() {
        return this.getToken(CypherCmdParser.COMPOSITE, 0);
    }
    CONCURRENT() {
        return this.getToken(CypherCmdParser.CONCURRENT, 0);
    }
    CONSTRAINT() {
        return this.getToken(CypherCmdParser.CONSTRAINT, 0);
    }
    CONSTRAINTS() {
        return this.getToken(CypherCmdParser.CONSTRAINTS, 0);
    }
    CONTAINS() {
        return this.getToken(CypherCmdParser.CONTAINS, 0);
    }
    CONTINUE() {
        return this.getToken(CypherCmdParser.CONTINUE, 0);
    }
    COPY() {
        return this.getToken(CypherCmdParser.COPY, 0);
    }
    COUNT() {
        return this.getToken(CypherCmdParser.COUNT, 0);
    }
    CREATE() {
        return this.getToken(CypherCmdParser.CREATE, 0);
    }
    CSV() {
        return this.getToken(CypherCmdParser.CSV, 0);
    }
    CURRENT() {
        return this.getToken(CypherCmdParser.CURRENT, 0);
    }
    CYPHER() {
        return this.getToken(CypherCmdParser.CYPHER, 0);
    }
    DATA() {
        return this.getToken(CypherCmdParser.DATA, 0);
    }
    DATABASE() {
        return this.getToken(CypherCmdParser.DATABASE, 0);
    }
    DATABASES() {
        return this.getToken(CypherCmdParser.DATABASES, 0);
    }
    DATE() {
        return this.getToken(CypherCmdParser.DATE, 0);
    }
    DATETIME() {
        return this.getToken(CypherCmdParser.DATETIME, 0);
    }
    DBMS() {
        return this.getToken(CypherCmdParser.DBMS, 0);
    }
    DEALLOCATE() {
        return this.getToken(CypherCmdParser.DEALLOCATE, 0);
    }
    DEFAULT() {
        return this.getToken(CypherCmdParser.DEFAULT, 0);
    }
    DEFINED() {
        return this.getToken(CypherCmdParser.DEFINED, 0);
    }
    DELETE() {
        return this.getToken(CypherCmdParser.DELETE, 0);
    }
    DENY() {
        return this.getToken(CypherCmdParser.DENY, 0);
    }
    DESC() {
        return this.getToken(CypherCmdParser.DESC, 0);
    }
    DESCENDING() {
        return this.getToken(CypherCmdParser.DESCENDING, 0);
    }
    DESTROY() {
        return this.getToken(CypherCmdParser.DESTROY, 0);
    }
    DETACH() {
        return this.getToken(CypherCmdParser.DETACH, 0);
    }
    DIFFERENT() {
        return this.getToken(CypherCmdParser.DIFFERENT, 0);
    }
    DISTINCT() {
        return this.getToken(CypherCmdParser.DISTINCT, 0);
    }
    DRIVER() {
        return this.getToken(CypherCmdParser.DRIVER, 0);
    }
    DROP() {
        return this.getToken(CypherCmdParser.DROP, 0);
    }
    DRYRUN() {
        return this.getToken(CypherCmdParser.DRYRUN, 0);
    }
    DUMP() {
        return this.getToken(CypherCmdParser.DUMP, 0);
    }
    DURATION() {
        return this.getToken(CypherCmdParser.DURATION, 0);
    }
    EACH() {
        return this.getToken(CypherCmdParser.EACH, 0);
    }
    EDGE() {
        return this.getToken(CypherCmdParser.EDGE, 0);
    }
    ELEMENT() {
        return this.getToken(CypherCmdParser.ELEMENT, 0);
    }
    ELEMENTS() {
        return this.getToken(CypherCmdParser.ELEMENTS, 0);
    }
    ELSE() {
        return this.getToken(CypherCmdParser.ELSE, 0);
    }
    ENABLE() {
        return this.getToken(CypherCmdParser.ENABLE, 0);
    }
    ENCRYPTED() {
        return this.getToken(CypherCmdParser.ENCRYPTED, 0);
    }
    END() {
        return this.getToken(CypherCmdParser.END, 0);
    }
    ENDS() {
        return this.getToken(CypherCmdParser.ENDS, 0);
    }
    ERROR() {
        return this.getToken(CypherCmdParser.ERROR, 0);
    }
    EXECUTABLE() {
        return this.getToken(CypherCmdParser.EXECUTABLE, 0);
    }
    EXECUTE() {
        return this.getToken(CypherCmdParser.EXECUTE, 0);
    }
    EXIST() {
        return this.getToken(CypherCmdParser.EXIST, 0);
    }
    EXISTENCE() {
        return this.getToken(CypherCmdParser.EXISTENCE, 0);
    }
    EXISTS() {
        return this.getToken(CypherCmdParser.EXISTS, 0);
    }
    FAIL() {
        return this.getToken(CypherCmdParser.FAIL, 0);
    }
    FALSE() {
        return this.getToken(CypherCmdParser.FALSE, 0);
    }
    FIELDTERMINATOR() {
        return this.getToken(CypherCmdParser.FIELDTERMINATOR, 0);
    }
    FILTER() {
        return this.getToken(CypherCmdParser.FILTER, 0);
    }
    FINISH() {
        return this.getToken(CypherCmdParser.FINISH, 0);
    }
    FLOAT() {
        return this.getToken(CypherCmdParser.FLOAT, 0);
    }
    FLOAT64() {
        return this.getToken(CypherCmdParser.FLOAT64, 0);
    }
    FLOAT32() {
        return this.getToken(CypherCmdParser.FLOAT32, 0);
    }
    FOREACH() {
        return this.getToken(CypherCmdParser.FOREACH, 0);
    }
    FOR() {
        return this.getToken(CypherCmdParser.FOR, 0);
    }
    FROM() {
        return this.getToken(CypherCmdParser.FROM, 0);
    }
    FULLTEXT() {
        return this.getToken(CypherCmdParser.FULLTEXT, 0);
    }
    FUNCTION() {
        return this.getToken(CypherCmdParser.FUNCTION, 0);
    }
    FUNCTIONS() {
        return this.getToken(CypherCmdParser.FUNCTIONS, 0);
    }
    GRANT() {
        return this.getToken(CypherCmdParser.GRANT, 0);
    }
    GRAPH() {
        return this.getToken(CypherCmdParser.GRAPH, 0);
    }
    GRAPHS() {
        return this.getToken(CypherCmdParser.GRAPHS, 0);
    }
    GROUP() {
        return this.getToken(CypherCmdParser.GROUP, 0);
    }
    GROUPS() {
        return this.getToken(CypherCmdParser.GROUPS, 0);
    }
    HEADERS() {
        return this.getToken(CypherCmdParser.HEADERS, 0);
    }
    HOME() {
        return this.getToken(CypherCmdParser.HOME, 0);
    }
    ID() {
        return this.getToken(CypherCmdParser.ID, 0);
    }
    IF() {
        return this.getToken(CypherCmdParser.IF, 0);
    }
    IMMUTABLE() {
        return this.getToken(CypherCmdParser.IMMUTABLE, 0);
    }
    IMPERSONATE() {
        return this.getToken(CypherCmdParser.IMPERSONATE, 0);
    }
    IMPLIES() {
        return this.getToken(CypherCmdParser.IMPLIES, 0);
    }
    IN() {
        return this.getToken(CypherCmdParser.IN, 0);
    }
    INDEX() {
        return this.getToken(CypherCmdParser.INDEX, 0);
    }
    INDEXES() {
        return this.getToken(CypherCmdParser.INDEXES, 0);
    }
    INF() {
        return this.getToken(CypherCmdParser.INF, 0);
    }
    INFINITY() {
        return this.getToken(CypherCmdParser.INFINITY, 0);
    }
    INSERT() {
        return this.getToken(CypherCmdParser.INSERT, 0);
    }
    INT() {
        return this.getToken(CypherCmdParser.INT, 0);
    }
    INT64() {
        return this.getToken(CypherCmdParser.INT64, 0);
    }
    INT32() {
        return this.getToken(CypherCmdParser.INT32, 0);
    }
    INT16() {
        return this.getToken(CypherCmdParser.INT16, 0);
    }
    INT8() {
        return this.getToken(CypherCmdParser.INT8, 0);
    }
    INTEGER() {
        return this.getToken(CypherCmdParser.INTEGER, 0);
    }
    INTEGER64() {
        return this.getToken(CypherCmdParser.INTEGER64, 0);
    }
    INTEGER32() {
        return this.getToken(CypherCmdParser.INTEGER32, 0);
    }
    INTEGER16() {
        return this.getToken(CypherCmdParser.INTEGER16, 0);
    }
    INTEGER8() {
        return this.getToken(CypherCmdParser.INTEGER8, 0);
    }
    IS() {
        return this.getToken(CypherCmdParser.IS, 0);
    }
    JOIN() {
        return this.getToken(CypherCmdParser.JOIN, 0);
    }
    KEY() {
        return this.getToken(CypherCmdParser.KEY, 0);
    }
    LABEL() {
        return this.getToken(CypherCmdParser.LABEL, 0);
    }
    LABELS() {
        return this.getToken(CypherCmdParser.LABELS, 0);
    }
    LANGUAGE() {
        return this.getToken(CypherCmdParser.LANGUAGE, 0);
    }
    LEADING() {
        return this.getToken(CypherCmdParser.LEADING, 0);
    }
    LET() {
        return this.getToken(CypherCmdParser.LET, 0);
    }
    LIMITROWS() {
        return this.getToken(CypherCmdParser.LIMITROWS, 0);
    }
    LIST() {
        return this.getToken(CypherCmdParser.LIST, 0);
    }
    LOAD() {
        return this.getToken(CypherCmdParser.LOAD, 0);
    }
    LOCAL() {
        return this.getToken(CypherCmdParser.LOCAL, 0);
    }
    LOOKUP() {
        return this.getToken(CypherCmdParser.LOOKUP, 0);
    }
    MATCH() {
        return this.getToken(CypherCmdParser.MATCH, 0);
    }
    MANAGEMENT() {
        return this.getToken(CypherCmdParser.MANAGEMENT, 0);
    }
    MAP() {
        return this.getToken(CypherCmdParser.MAP, 0);
    }
    MERGE() {
        return this.getToken(CypherCmdParser.MERGE, 0);
    }
    NAME() {
        return this.getToken(CypherCmdParser.NAME, 0);
    }
    NAMES() {
        return this.getToken(CypherCmdParser.NAMES, 0);
    }
    NAN() {
        return this.getToken(CypherCmdParser.NAN, 0);
    }
    NEW() {
        return this.getToken(CypherCmdParser.NEW, 0);
    }
    NEXT() {
        return this.getToken(CypherCmdParser.NEXT, 0);
    }
    NFC() {
        return this.getToken(CypherCmdParser.NFC, 0);
    }
    NFD() {
        return this.getToken(CypherCmdParser.NFD, 0);
    }
    NFKC() {
        return this.getToken(CypherCmdParser.NFKC, 0);
    }
    NFKD() {
        return this.getToken(CypherCmdParser.NFKD, 0);
    }
    NODE() {
        return this.getToken(CypherCmdParser.NODE, 0);
    }
    NODETACH() {
        return this.getToken(CypherCmdParser.NODETACH, 0);
    }
    NODES() {
        return this.getToken(CypherCmdParser.NODES, 0);
    }
    NONE() {
        return this.getToken(CypherCmdParser.NONE, 0);
    }
    NORMALIZE() {
        return this.getToken(CypherCmdParser.NORMALIZE, 0);
    }
    NORMALIZED() {
        return this.getToken(CypherCmdParser.NORMALIZED, 0);
    }
    NOT() {
        return this.getToken(CypherCmdParser.NOT, 0);
    }
    NOTHING() {
        return this.getToken(CypherCmdParser.NOTHING, 0);
    }
    NOWAIT() {
        return this.getToken(CypherCmdParser.NOWAIT, 0);
    }
    NULL() {
        return this.getToken(CypherCmdParser.NULL, 0);
    }
    OF() {
        return this.getToken(CypherCmdParser.OF, 0);
    }
    OFFSET() {
        return this.getToken(CypherCmdParser.OFFSET, 0);
    }
    ON() {
        return this.getToken(CypherCmdParser.ON, 0);
    }
    ONLY() {
        return this.getToken(CypherCmdParser.ONLY, 0);
    }
    OPTIONAL() {
        return this.getToken(CypherCmdParser.OPTIONAL, 0);
    }
    OPTIONS() {
        return this.getToken(CypherCmdParser.OPTIONS, 0);
    }
    OPTION() {
        return this.getToken(CypherCmdParser.OPTION, 0);
    }
    OR() {
        return this.getToken(CypherCmdParser.OR, 0);
    }
    ORDER() {
        return this.getToken(CypherCmdParser.ORDER, 0);
    }
    PASSWORD() {
        return this.getToken(CypherCmdParser.PASSWORD, 0);
    }
    PASSWORDS() {
        return this.getToken(CypherCmdParser.PASSWORDS, 0);
    }
    PATH() {
        return this.getToken(CypherCmdParser.PATH, 0);
    }
    PATHS() {
        return this.getToken(CypherCmdParser.PATHS, 0);
    }
    PLAINTEXT() {
        return this.getToken(CypherCmdParser.PLAINTEXT, 0);
    }
    POINT() {
        return this.getToken(CypherCmdParser.POINT, 0);
    }
    POPULATED() {
        return this.getToken(CypherCmdParser.POPULATED, 0);
    }
    PRIMARY() {
        return this.getToken(CypherCmdParser.PRIMARY, 0);
    }
    PRIMARIES() {
        return this.getToken(CypherCmdParser.PRIMARIES, 0);
    }
    PRIVILEGE() {
        return this.getToken(CypherCmdParser.PRIVILEGE, 0);
    }
    PRIVILEGES() {
        return this.getToken(CypherCmdParser.PRIVILEGES, 0);
    }
    PROCEDURE() {
        return this.getToken(CypherCmdParser.PROCEDURE, 0);
    }
    PROCEDURES() {
        return this.getToken(CypherCmdParser.PROCEDURES, 0);
    }
    PROPERTIES() {
        return this.getToken(CypherCmdParser.PROPERTIES, 0);
    }
    PROPERTY() {
        return this.getToken(CypherCmdParser.PROPERTY, 0);
    }
    PROVIDER() {
        return this.getToken(CypherCmdParser.PROVIDER, 0);
    }
    PROVIDERS() {
        return this.getToken(CypherCmdParser.PROVIDERS, 0);
    }
    RANGE() {
        return this.getToken(CypherCmdParser.RANGE, 0);
    }
    READ() {
        return this.getToken(CypherCmdParser.READ, 0);
    }
    REALLOCATE() {
        return this.getToken(CypherCmdParser.REALLOCATE, 0);
    }
    REDUCE() {
        return this.getToken(CypherCmdParser.REDUCE, 0);
    }
    REL() {
        return this.getToken(CypherCmdParser.REL, 0);
    }
    RELATIONSHIP() {
        return this.getToken(CypherCmdParser.RELATIONSHIP, 0);
    }
    RELATIONSHIPS() {
        return this.getToken(CypherCmdParser.RELATIONSHIPS, 0);
    }
    REMOVE() {
        return this.getToken(CypherCmdParser.REMOVE, 0);
    }
    RENAME() {
        return this.getToken(CypherCmdParser.RENAME, 0);
    }
    REPEATABLE() {
        return this.getToken(CypherCmdParser.REPEATABLE, 0);
    }
    REPLACE() {
        return this.getToken(CypherCmdParser.REPLACE, 0);
    }
    REPLICA() {
        return this.getToken(CypherCmdParser.REPLICA, 0);
    }
    REPLICAS() {
        return this.getToken(CypherCmdParser.REPLICAS, 0);
    }
    REPORT() {
        return this.getToken(CypherCmdParser.REPORT, 0);
    }
    REQUIRE() {
        return this.getToken(CypherCmdParser.REQUIRE, 0);
    }
    REQUIRED() {
        return this.getToken(CypherCmdParser.REQUIRED, 0);
    }
    RESTRICT() {
        return this.getToken(CypherCmdParser.RESTRICT, 0);
    }
    RETRY() {
        return this.getToken(CypherCmdParser.RETRY, 0);
    }
    RETURN() {
        return this.getToken(CypherCmdParser.RETURN, 0);
    }
    REVOKE() {
        return this.getToken(CypherCmdParser.REVOKE, 0);
    }
    ROLE() {
        return this.getToken(CypherCmdParser.ROLE, 0);
    }
    ROLES() {
        return this.getToken(CypherCmdParser.ROLES, 0);
    }
    ROW() {
        return this.getToken(CypherCmdParser.ROW, 0);
    }
    ROWS() {
        return this.getToken(CypherCmdParser.ROWS, 0);
    }
    SCAN() {
        return this.getToken(CypherCmdParser.SCAN, 0);
    }
    SECONDARY() {
        return this.getToken(CypherCmdParser.SECONDARY, 0);
    }
    SECONDARIES() {
        return this.getToken(CypherCmdParser.SECONDARIES, 0);
    }
    SEC() {
        return this.getToken(CypherCmdParser.SEC, 0);
    }
    SECOND() {
        return this.getToken(CypherCmdParser.SECOND, 0);
    }
    SECONDS() {
        return this.getToken(CypherCmdParser.SECONDS, 0);
    }
    SEEK() {
        return this.getToken(CypherCmdParser.SEEK, 0);
    }
    SERVER() {
        return this.getToken(CypherCmdParser.SERVER, 0);
    }
    SERVERS() {
        return this.getToken(CypherCmdParser.SERVERS, 0);
    }
    SET() {
        return this.getToken(CypherCmdParser.SET, 0);
    }
    SETTING() {
        return this.getToken(CypherCmdParser.SETTING, 0);
    }
    SETTINGS() {
        return this.getToken(CypherCmdParser.SETTINGS, 0);
    }
    SHARD() {
        return this.getToken(CypherCmdParser.SHARD, 0);
    }
    SHARDS() {
        return this.getToken(CypherCmdParser.SHARDS, 0);
    }
    SHORTEST() {
        return this.getToken(CypherCmdParser.SHORTEST, 0);
    }
    SHORTEST_PATH() {
        return this.getToken(CypherCmdParser.SHORTEST_PATH, 0);
    }
    SHOW() {
        return this.getToken(CypherCmdParser.SHOW, 0);
    }
    SIGNED() {
        return this.getToken(CypherCmdParser.SIGNED, 0);
    }
    SINGLE() {
        return this.getToken(CypherCmdParser.SINGLE, 0);
    }
    SKIPROWS() {
        return this.getToken(CypherCmdParser.SKIPROWS, 0);
    }
    START() {
        return this.getToken(CypherCmdParser.START, 0);
    }
    STARTS() {
        return this.getToken(CypherCmdParser.STARTS, 0);
    }
    STATUS() {
        return this.getToken(CypherCmdParser.STATUS, 0);
    }
    STOP() {
        return this.getToken(CypherCmdParser.STOP, 0);
    }
    VARCHAR() {
        return this.getToken(CypherCmdParser.VARCHAR, 0);
    }
    STRING() {
        return this.getToken(CypherCmdParser.STRING, 0);
    }
    SUPPORTED() {
        return this.getToken(CypherCmdParser.SUPPORTED, 0);
    }
    SUSPENDED() {
        return this.getToken(CypherCmdParser.SUSPENDED, 0);
    }
    TARGET() {
        return this.getToken(CypherCmdParser.TARGET, 0);
    }
    TERMINATE() {
        return this.getToken(CypherCmdParser.TERMINATE, 0);
    }
    TEXT() {
        return this.getToken(CypherCmdParser.TEXT, 0);
    }
    THEN() {
        return this.getToken(CypherCmdParser.THEN, 0);
    }
    TIME() {
        return this.getToken(CypherCmdParser.TIME, 0);
    }
    TIMESTAMP() {
        return this.getToken(CypherCmdParser.TIMESTAMP, 0);
    }
    TIMEZONE() {
        return this.getToken(CypherCmdParser.TIMEZONE, 0);
    }
    TO() {
        return this.getToken(CypherCmdParser.TO, 0);
    }
    TOPOLOGY() {
        return this.getToken(CypherCmdParser.TOPOLOGY, 0);
    }
    TRAILING() {
        return this.getToken(CypherCmdParser.TRAILING, 0);
    }
    TRANSACTION() {
        return this.getToken(CypherCmdParser.TRANSACTION, 0);
    }
    TRANSACTIONS() {
        return this.getToken(CypherCmdParser.TRANSACTIONS, 0);
    }
    TRAVERSE() {
        return this.getToken(CypherCmdParser.TRAVERSE, 0);
    }
    TRIM() {
        return this.getToken(CypherCmdParser.TRIM, 0);
    }
    TRUE() {
        return this.getToken(CypherCmdParser.TRUE, 0);
    }
    TYPE() {
        return this.getToken(CypherCmdParser.TYPE, 0);
    }
    TYPED() {
        return this.getToken(CypherCmdParser.TYPED, 0);
    }
    TYPES() {
        return this.getToken(CypherCmdParser.TYPES, 0);
    }
    UNION() {
        return this.getToken(CypherCmdParser.UNION, 0);
    }
    UNIQUE() {
        return this.getToken(CypherCmdParser.UNIQUE, 0);
    }
    UNIQUENESS() {
        return this.getToken(CypherCmdParser.UNIQUENESS, 0);
    }
    UNWIND() {
        return this.getToken(CypherCmdParser.UNWIND, 0);
    }
    URL() {
        return this.getToken(CypherCmdParser.URL, 0);
    }
    USE() {
        return this.getToken(CypherCmdParser.USE, 0);
    }
    USER() {
        return this.getToken(CypherCmdParser.USER, 0);
    }
    USERS() {
        return this.getToken(CypherCmdParser.USERS, 0);
    }
    USING() {
        return this.getToken(CypherCmdParser.USING, 0);
    }
    VALUE() {
        return this.getToken(CypherCmdParser.VALUE, 0);
    }
    VECTOR() {
        return this.getToken(CypherCmdParser.VECTOR, 0);
    }
    VERTEX() {
        return this.getToken(CypherCmdParser.VERTEX, 0);
    }
    WAIT() {
        return this.getToken(CypherCmdParser.WAIT, 0);
    }
    WHEN() {
        return this.getToken(CypherCmdParser.WHEN, 0);
    }
    WHERE() {
        return this.getToken(CypherCmdParser.WHERE, 0);
    }
    WITH() {
        return this.getToken(CypherCmdParser.WITH, 0);
    }
    WITHOUT() {
        return this.getToken(CypherCmdParser.WITHOUT, 0);
    }
    WRITE() {
        return this.getToken(CypherCmdParser.WRITE, 0);
    }
    XOR() {
        return this.getToken(CypherCmdParser.XOR, 0);
    }
    YIELD() {
        return this.getToken(CypherCmdParser.YIELD, 0);
    }
    ZONE() {
        return this.getToken(CypherCmdParser.ZONE, 0);
    }
    ZONED() {
        return this.getToken(CypherCmdParser.ZONED, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_unescapedSymbolicNameString_;
    }
    enterRule(listener) {
        if (listener.enterUnescapedSymbolicNameString_) {
            listener.enterUnescapedSymbolicNameString_(this);
        }
    }
    exitRule(listener) {
        if (listener.exitUnescapedSymbolicNameString_) {
            listener.exitUnescapedSymbolicNameString_(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnescapedSymbolicNameString_) {
            return visitor.visitUnescapedSymbolicNameString_(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EndOfFileContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EOF() {
        return this.getToken(CypherCmdParser.EOF, 0);
    }
    get ruleIndex() {
        return CypherCmdParser.RULE_endOfFile;
    }
    enterRule(listener) {
        if (listener.enterEndOfFile) {
            listener.enterEndOfFile(this);
        }
    }
    exitRule(listener) {
        if (listener.exitEndOfFile) {
            listener.exitEndOfFile(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEndOfFile) {
            return visitor.visitEndOfFile(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
//# sourceMappingURL=CypherCmdParser.js.map